(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({"C:\\projects\\lightning\\business-objects\\account-limits.js":[function(require,module,exports){
"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = require('underscore');

var AccountLimits = function () {
    function AccountLimits(props) {
        _classCallCheck(this, AccountLimits);

        this.loansLimit = 0;
        this.loansCount = 0;
        this.holdsLimit = 0;
        this.holdsCount = 0;
        this.renewalDayLimit = 3;
        // This is an accepted constant value, but it not provided via the thunder interface at this time - etung:20161123
        this.wishlistLimit = 5000;
        this.wishlistCount = 0;
        this.rtlTitleLimit = 0;
        this.rtlDays = 0;
        this.rtlRemaining = 0;
        this.nextRecommendation = 0;
        this.totalItemsCountedTowardsCheckoutLimit = 0;

        _.extend(this, props);
    }

    _createClass(AccountLimits, [{
        key: "loansRemaining",
        get: function get() {
            return this.loansLimit - this.totalItemsCountedTowardsCheckoutLimit;
        }
    }, {
        key: "holdsRemaining",
        get: function get() {
            return this.holdsLimit - this.holdsCount;
        }
    }, {
        key: "wishlistRemaining",
        get: function get() {
            return this.wishlistLimit - this.wishlistCount;
        }
    }], [{
        key: "parseFromThunder",
        value: function parseFromThunder(card, loans, holds, wishlist) {
            var accountLimits = new AccountLimits();

            accountLimits.holdsCount = holds.totalItems;
            accountLimits.holdsLimit = card.holdLimit;

            accountLimits.loansCount = loans.totalItems;
            accountLimits.totalItemsCountedTowardsCheckoutLimit = loans.totalItemsCountedTowardsCheckoutLimit;

            if (card.checkoutLimitsByMediaType) {
                var c = card.checkoutLimitsByMediaType;
                accountLimits.loansLimit = c.ebook || c.audiobook || c.video || accountLimits.loansLimit;
            }

            accountLimits.wishlistCount = wishlist.totalItems;

            var rtlStats = card.recommendationStatistics;
            if (rtlStats) {
                accountLimits.rtlTitleLimit = rtlStats.limit;
                accountLimits.rtlDays = rtlStats.limitWindowDays;
                accountLimits.rtlRemaining = rtlStats.recommendationsRemaining;
                accountLimits.nextRecommendation = Math.ceil(rtlStats.nextRecommendationSeconds / 86400); //convert seconds to days
            }

            return accountLimits;
        }
    }]);

    return AccountLimits;
}();

module.exports = AccountLimits;

},{"underscore":"C:\\projects\\lightning\\node_modules\\underscore\\underscore.js"}],"C:\\projects\\lightning\\business-objects\\loan-title.js":[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = require('underscore');

// View model for loans page.  I'm not really sure where this belongs in our project structure.  A good name also eludes me.
//
// I tried putting this logic in the swig and ran into some frustrating limitations.


var LoanTitle = function () {
    function LoanTitle(title, limitDisplayFormats, preferKindle, isInODApp, isMac, macOsAudioDownloadsDisabled, macOSAudioDownloadReenabledPreCatalina, isPreCatalinaMac) {
        _classCallCheck(this, LoanTitle);

        this.limitDisplayFormats = limitDisplayFormats;
        this.preferKindle = preferKindle;
        this.isInODApp = isInODApp;
        this.isMac = isMac;
        this.macOsAudioDownloadsDisabled = macOsAudioDownloadsDisabled; // feature flag for LHTNG-3702 'noAudiobooksForMacOS'
        this.macOSAudioDownloadReenabledPreCatalina = macOSAudioDownloadReenabledPreCatalina; // feature flag for LHTNG-3789
        this.isPreCatalinaMac = isPreCatalinaMac;
        _.extend(this, title);
    }

    _createClass(LoanTitle, [{
        key: 'alternativeToKindle',
        get: function get() {
            var alternativeFormat = '';
            if (this.hasOverdriveFormat) {
                alternativeFormat = 'odread';
            } else if (this.hasNonKindleNonReadFormat) {
                alternativeFormat = this.nonKindleFormats[0].id;
            }
            return alternativeFormat;
        }
    }, {
        key: 'showKindleTroubleAccordian',
        get: function get() {
            return !this.showNonKindleFormats && !this.showODFormatButton && !(this.restrictedFormats && this.restrictedFormats.length > 0);
        }
    }, {
        key: 'showNakedKindleProblemLink',
        get: function get() {
            return this.isEbook && this.isLockedOnKindle && !this.showKindleTroubleAccordian;
        }
    }, {
        key: 'isLockedOnKindle',
        get: function get() {
            return this.isFormatLockedIn && this.otherFormats.length > 0 && this.otherFormats[0].id === 'ebook-kindle';
        }
    }, {
        key: 'isEbook',
        get: function get() {
            return this.type.id === 'ebook';
        }
    }, {
        key: 'isAudiobook',
        get: function get() {
            return this.type.id === 'audiobook';
        }
    }, {
        key: 'isVideo',
        get: function get() {
            return this.type.id === 'video';
        }
    }, {
        key: 'isMagazine',
        get: function get() {
            return this.type.id === 'magazine';
        }
    }, {
        key: 'hasReadalong',
        get: function get() {
            return !!(this.overDriveFormat && this.overDriveFormat.hasAudioSynchronizedText);
        }
    }, {
        key: 'hasKindleFormat',
        get: function get() {
            return this.otherFormats.findIndex(function (format) {
                return format.id === 'ebook-kindle';
            }) !== -1;
        }
    }, {
        key: 'hasMp3Format',
        get: function get() {
            return this.otherFormats.findIndex(function (format) {
                return format.id === 'audiobook-mp3';
            }) !== -1;
        }
    }, {
        key: 'hasNonKindleNonReadFormat',
        get: function get() {
            return this.nonKindleFormats.length > 0;
        }
    }, {
        key: 'kindleFormat',
        get: function get() {
            return this.otherFormats.find(function (format) {
                return format.id === 'ebook-kindle';
            });
        }
    }, {
        key: 'showNonKindleButtonAboveDivider',
        get: function get() {
            return this.showNonKindleDownloadButton && !this.hasKindleFormat && this.showODFormatButton && !this.showNoKindleMessage;
        }
    }, {
        key: 'showNonKindleButtonBelowDivider',
        get: function get() {
            return this.showNonKindleDownloadButton && !this.showNonKindleButtonAboveDivider;
        }
    }, {
        key: 'showNonKindleDownloadButton',
        get: function get() {
            return this.showNonKindleFormats && this.nonKindleFormats.length === 1;
        }
    }, {
        key: 'showDownloadDropdown',
        get: function get() {
            return this.isEbook && this.showNonKindleFormats && this.nonKindleFormats.length > 1;
        }
    }, {
        key: 'showNonKindleFormats',
        get: function get() {
            return this.isEbook && !this.isFormatLockedIn && this.nonKindleFormats && this.nonKindleFormats.length > 0 && (!this.preferKindle || !this.limitDisplayFormats || !this.hasKindleFormat);
        }
    }, {
        key: 'showNoKindleMessage',
        get: function get() {
            return !this.isFormatLockedIn && !this.hasKindleFormat && this.preferKindle && this.isEbook;
        }
    }, {
        key: 'nonKindleFormats',
        get: function get() {
            return this.otherFormats.filter(function (format) {
                return format.id !== 'ebook-kindle' && format.id !== 'ebook-kobo';
            });
        }
    }, {
        key: 'hasOverdriveFormat',
        get: function get() {
            return !!(this.overDriveFormat && this.overDriveFormat.id != null);
        }
    }, {
        key: 'showODFormatButton',
        get: function get() {
            return this.hasOverdriveFormat && this.overdriveFormatAllowed && (!this.hasKindleFormat || !this.preferKindle || this.overDriveFormat.hasAudioSynchronizedText);
        }
    }, {
        key: 'suppressAudiobookDownloadButton',
        get: function get() {
            // This is somewhat odd.  In the case where you're on a Mac but there is also a Listen format available, we render the mp3
            // download button server side so that the client-side code to replace it with a format warning will continue to work
            // This is obviously not very maintainable, but we have plans to completely replace this page with client-side
            // rendered backbone components, so I feel a kludge is justified under the circumstances.
            return this.isAudiobook && this.isMac && this.hasMp3Format && this.hasOverdriveFormat && this.overdriveFormatAllowed && this.macOsAudioDownloadsDisabled && (!this.macOSAudioDownloadReenabledPreCatalina || !this.isPreCatalinaMac);
        }
    }, {
        key: 'overdriveFormatAllowed',
        get: function get() {
            // The OD Read format is generally suppressed in the app but there are a few exceptions
            if (this.otherFormats && this.otherFormats.length === 1 && this.isInODApp && (this.otherFormats[0].id === 'ebook-pdf-adobe' || this.otherFormats[0].id === 'ebook-pdf-open' || this.otherFormats[0].id === 'ebook-kindle')) {
                return true;
            } else if (this.overDriveFormat && this.overDriveFormat.hasAudioSynchronizedText) {
                return true;
            } else {
                return !(this.isInODApp && this.otherFormats && this.otherFormats.length > 0);
            }
        }
    }, {
        key: 'firstButtonSlotOccupied',
        get: function get() {
            return this.isEbook && (this.isFormatLockedIn || this.hasKindleFormat || this.showNoKindleMessage || this.showNonKindleButtonAboveDivider) || !this.isEbook && this.hasNonKindleNonReadFormat && !this.suppressAudiobookDownloadButton;
        }
    }, {
        key: 'secondButtonSlotOccupied',
        get: function get() {
            return this.showODFormatButton || this.showNonKindleFormats && !this.showNonKindleButtonAboveDivider;
        }
    }, {
        key: 'showDivider',
        get: function get() {
            return this.firstButtonSlotOccupied && this.secondButtonSlotOccupied;
        }
    }, {
        key: 'useFirstPlayText',
        get: function get() {
            return this.constraints && this.constraints.watchExpirationHours;
        }
    }]);

    return LoanTitle;
}();

module.exports = LoanTitle;

},{"underscore":"C:\\projects\\lightning\\node_modules\\underscore\\underscore.js"}],"C:\\projects\\lightning\\config\\dyslexicBlacklist.json":[function(require,module,exports){
module.exports={
  "ru": {
    "name": "русский"
  },
  "ru-RU": {
    "name": "русский"
  },
  "ar": {
    "name": ""
  },
  "he": {
    "name": ""
  },
  "zh-Hans": {
    "name": "中文(简体)"
  },
  "zh-CN": {
    "name": "中文(简体)"
  },
  "zh-SG": {
    "name": "中文(简体)"
  },
  "zh-Hant": {
    "name": "中文(繁體)"
  },
  "zh-HK": {
    "name": "中文(繁體)"
  },
  "zh-MO": {
    "name": "中文(繁體)"
  },
  "zh-TW": {
    "name": "中文(繁體)"
  },
  "ja": {
    "name": "日本語"
  },
  "ja-JP": {
    "name": "日本語"
  },
  "ta": {
    "name": "மொழி"
  }
}
},{}],"C:\\projects\\lightning\\config\\features.json":[function(require,module,exports){
module.exports={
  "advantage": {"enabled": true, "testable": true},
  "recommend-to-library": {"enabled": true, "testable": true},
  "autocomplete": {"enabled": true, "testable": true},
  "rtl-preview": {"enabled": true, "testable": true},
  "redis-cache": {"enabled": true, "_comment": "this feature cannot be testable, and cannot use the featureManager"},
  "content-holds": {"enabled": true, "testable": true},
  "backToMainCollectionLink": {"enabled": true, "testable": true},
  "libbyTout": {"enabled": true, "testable": true},
  "promoteLibby": {"enabled": true, "testable": true},
  "readingHistory" : {"enabled" : true, "testable": true, "_comment": "LHTNG-1809"},
  "youMayLikeCollection": {"enabled": false, "testable": true},
  "atosLevels": {"enabled": true, "testable": true},
  "lexileScores":{"enabled": true, "testable": true},
  "gradeLevels":{"enabled": true, "testable": true},
  "interestLevels":{"enabled": true, "testable": true},
  "bannerIsSecondaryColor": {"enabled":true, "testable":true, "_comment": "this feature makes the banner the secondary color and the toast darker"},
  "kindleFooter": {"enabled": true, "testable": true, "_comment": "LHTNG-2315 - kindle footer"},
  "kindleNav": {"enabled": true, "testable": true, "_comment": "LHTNG-2315 - kindle nav promotion"},
  "kindleLoanFormatLimit": {"enabled": true, "testable": true, "_comment": "LHTNG-2315 - kindle loans format limit"},
  "kindleSearchOffer": {"enabled": true, "testable": true, "_comment": "LHTNG-2315 - offer to set from search"},
  "kindleLoanOffer": {"enabled": true, "testable": true, "_comment": "LHTNG-2315 - offer to set from fulfill"},
  "getACard": {"enabled": true, "testable": true, "_comment": "LHTNG-2479 - get a card promotion modal"},
  "enhancedLibbyPromo": {"enabled": true, "testable": true},
  "showLibbyIntercept": {"enabled": false, "testable": true},
  "enhancedSeries": {"enabled": false, "testable": true},
  "internationalDemoMode": {"enabled": true, "testable": true},
  "reciprocalLending": {"enabled": true, "testable": true},
  "LHTNG-2863": {"enabled": false, "testable": true},
  "renewTitles" : {"enabled": false, "testable": true}
}

},{}],"C:\\projects\\lightning\\config\\reversePreviewSites.json":[function(require,module,exports){
module.exports={
  "237": {"url": "http://princewilliam-ng.libraryreserve.com/"},
  "100501": {"url": "http://qaintegration-ng.libraryreserve.com/"}
}
},{}],"C:\\projects\\lightning\\config\\supportedLanguages.json":[function(require,module,exports){
module.exports={
    "supportedLanguages": [
        {
        "languageCodes": [
            "en",
            "en-029",
            "en-AU",
            "en-BZ",
            "en-CA",
            "en-GB",
            "en-IE",
            "en-IN",
            "en-JM",
            "en-MY",
            "en-NZ",
            "en-PH",
            "en-SG",
            "en-TT",
            "en-US",
            "en-ZA",
            "en-ZW"
        ],
        "defaultLanguageCode": "en",
        "nativeDisplayName": "English",
        "displayName": "English"
        },
        {
        "languageCodes": [
            "es",
            "es-AR",
            "es-BO",
            "es-CL",
            "es-CO",
            "es-CR",
            "es-DO",
            "es-EC",
            "es-ES",
            "es-GT",
            "es-HN",
            "es-MX",
            "es-NI",
            "es-PA",
            "es-PE",
            "es-PR",
            "es-PY",
            "es-SV",
            "es-US",
            "es-UY",
            "es-VE"
        ],
        "defaultLanguageCode": "es",
        "nativeDisplayName": "Español",
        "displayName": "Spanish"
        },
        {
        "languageCodes": [
            "fr-CA",
            "fr"
        ],
        "defaultLanguageCode": "fr-CA",
        "nativeDisplayName": "Français (Canada)",
        "displayName": "French (Canadian)"
        },
        {
        "languageCodes": [
            "zh-CN",
            "zh-Hans",
            "zh-SG",
            "zh"
        ],
        "defaultLanguageCode": "zh-Hans",
        "nativeDisplayName": "中文(简体)",
        "displayName": "Chinese (Simplified)"
        },
        {
        "languageCodes": [
            "zh-Hant",
            "zh-HK",
            "zh-MO",
            "zh-TW"
        ],
        "defaultLanguageCode": "zh-Hant",
        "nativeDisplayName": "中文(繁體)",
        "displayName": "Chinese (Traditional)"
        },
        {
        "languageCodes": [
            "ja",
            "ja-JP"
        ],
        "defaultLanguageCode": "ja",
        "nativeDisplayName": "日本語",
        "displayName": "Japanese"
        },
        {
        "languageCodes": [
            "ms",
            "ms-BN",
            "ms-MY"
        ],
        "defaultLanguageCode": "ms",
        "nativeDisplayName": "Bahasa Melayu",
        "displayName": "Malay"
        },
        {
        "languageCodes": [
            "ru",
            "ru-RU"
        ],
        "defaultLanguageCode": "ru",
        "nativeDisplayName": "Русский",
        "displayName": "Russian"
        },
        {
        "languageCodes": [
            "sv",
            "sv-FI",
            "sv-SE"
        ],
        "defaultLanguageCode": "sv",
        "nativeDisplayName": "Svenska",
        "displayName": "Swedish"
        },
        {
        "languageCodes": [
            "fi",
            "fi-FI"
        ],
        "defaultLanguageCode": "fi",
        "nativeDisplayName": "Suomi",
        "displayName": "Finnish"
        },
        {
        "languageCodes": [
            "it",
            "it-CH",
            "it-IT"
        ],
        "defaultLanguageCode": "it",
        "nativeDisplayName": "Italiano",
        "displayName": "Italian"
        },
        {
        "languageCodes": [
            "de",
            "de-AT",
            "de-CH",
            "de-DE",
            "de-LI",
            "de-LU"
        ],
        "defaultLanguageCode": "de",
        "nativeDisplayName": "Deutsch",
        "displayName": "German"
        },
        {
        "languageCodes": [
            "da",
            "da-DK"
        ],
        "defaultLanguageCode": "da",
        "nativeDisplayName": "Dansk",
        "displayName": "Danish"
        },
        {
        "languageCodes": [
            "tr",
            "tr-TR"
        ],
        "defaultLanguageCode": "tr",
        "nativeDisplayName": "Türkçe",
        "displayName": "Turkish"
        },
        {
        "languageCodes": [
            "ko",
            "ko-KR"
        ],
        "defaultLanguageCode": "ko",
        "nativeDisplayName": "한국어",
        "displayName": "Korean"
        },
        {
        "languageCodes": [
            "nl",
            "nl-BE",
            "nl-NL"
        ],
        "defaultLanguageCode": "nl",
        "nativeDisplayName": "Nederlands",
        "displayName": "Dutch"
        },
        {
        "languageCodes": [
            "ta",
            "ta-IN"
        ],
        "defaultLanguageCode": "ta",
        "nativeDisplayName": "தமிழ்",
        "displayName": "Tamil"
        },
        {
        "languageCodes": [
            "is",
            "is-IS"
        ],
        "defaultLanguageCode": "is",
        "nativeDisplayName": "Íslenska",
        "displayName": "Icelandic"
        }
    ]
}
},{}],"C:\\projects\\lightning\\lib\\cookieConfig.js":[function(require,module,exports){
'use strict';

var numbers = require('./numbers');

module.exports = {
    hideLibbyIntercept: { name: 'hideLibbyIntercept', durationMS: numbers.dayInMilliSeconds * 56, sliding: true },
    hideLibbyInterceptLong: { name: 'hideLibbyInterceptLong', durationMS: numbers.yearInMilliseconds, sliding: true },
    hideLibbyLoansPromo: { name: 'hideLibbyLoansPromo', durationMS: numbers.dayInMilliSeconds * 14, sliding: true },
    odTrack: { name: 'od_track', durationMS: numbers.yearInMilliseconds * 10, sliding: true, domain: 'overdrive.com', httpOnly: false },
    visitedFeatures: { name: 'visitedFeatures', durationMS: numbers.yearInMilliseconds * 10, sliding: true }
};

},{"./numbers":"C:\\projects\\lightning\\lib\\numbers.js"}],"C:\\projects\\lightning\\lib\\featureManager.js":[function(require,module,exports){
'use strict';

var _ = require('underscore');
var lightClone = require('./utility/clone').lightClone;

/**
 * Private method returning whether libraryConfigurations permits this feature.
 * @param {obj} libraryConfigurations - The library configurations
 * @param {string} feature - The feature in question
 * @returns {boolean}
 */
var _okForLibrary = function _okForLibrary(libraryConfigurations, feature) {
    var libFeat = libraryConfigurations[feature];
    return !libFeat || libFeat.enabled || false;
};

/**
 * Private method returning whether to use the config/features.json
 * `enabled` or `testable` value.
 * @param {number} tenant - The tenant id
 * @param {string} allFeatures - The allFeatures secret cookie value
 * @returns {boolean}
 */
var _shouldUseTestable = function _shouldUseTestable(tenant, allFeatures) {
    return tenant === 100501 || tenant === 800004 || tenant === 800005 || allFeatures === '1';
};

/**
 * Feature manager
 * @constructor
 * @param {obj} libraryConfigurations - The library configurations
 * @param {number} tenant - The tenant id
 * @param {string} allFeatures - The allFeatures secret cookie value
 * @param {array} dynamicConfigurationFunctions - The allFeatures sec
 */
function FeatureManager(feats, libraryConfigurations, tenant, allFeatures, dynamicConfigurationFunctions) {
    this.useTestable = _shouldUseTestable(tenant, allFeatures);
    this.okForLibrary = _.partial(_okForLibrary, libraryConfigurations);
    var features = lightClone(feats);
    dynamicConfigurationFunctions && dynamicConfigurationFunctions.forEach(function (item) {
        features = item.configureDynamicFeature(features, libraryConfigurations, tenant, allFeatures);
    });
    this.features = features;
}

/**
 * Feature manager method for determining whether or not to show a feature.
 * This is the single source of truth for permissions.
 * @method
 * @param {string} feature - The feature in question
 * @returns {boolean}
 */
FeatureManager.prototype.isEnabled = function (feature) {
    return !!(this.okForLibrary(feature) && (this.useTestable ? this.isStrictlyTestable(feature) : this.isStrictlyEnabled(feature)));
};

/**
 * Feature manager method returning the strictly `enabled` value.
 * Note: due to dynamic configurations, this should not be assumed to be
 * the config/features.json `enabled` value, though that is the default.
 * @param {string} feature - The feature to lookup
 * @returns {boolean}
 */
FeatureManager.prototype.isStrictlyEnabled = function (feature) {
    return this.features[feature] && this.features[feature].enabled;
};

/**
 * Feature manager method returning the strictly `testable` value.
 * Note: due to dynamic configurations, this should not be assumed to be
 * the config/features.json `enabled` value, though that is the default.
 * @param {string} feature - The feature to lookup
 * @returns {boolean}
 */
FeatureManager.prototype.isStrictlyTestable = function (feature) {
    return this.features[feature] && this.features[feature].testable;
};

module.exports = FeatureManager;

},{"./utility/clone":"C:\\projects\\lightning\\lib\\utility\\clone.js","underscore":"C:\\projects\\lightning\\node_modules\\underscore\\underscore.js"}],"C:\\projects\\lightning\\lib\\featureManagerBuilder.js":[function(require,module,exports){
'use strict';

var _ = require('underscore');
var reversePreviewSites = require('../config/reversePreviewSites.json');
var features = require('../config/features.json');
var FeatureManager = require('./featureManager');

/**
 * Function for getting configured features for reverse-preview
 * which is a dynamic feature from config/features.json.
 * @param {number} tenant - The tenant id
 * @param {string} allFeatures - The allFeatures secret cookie value
 */
var getFeaturesConfiguredForReversePreview = function getFeaturesConfiguredForReversePreview(feats, libraryConfiguration, tenant) {
    var returnFeatures = _.extend({}, feats);
    var reversePreviewSite = reversePreviewSites && reversePreviewSites[tenant];
    var isReversePreviewEnabled = reversePreviewSite && reversePreviewSite.url;

    returnFeatures['reverse-preview'] = { enabled: isReversePreviewEnabled, testable: isReversePreviewEnabled };
    return returnFeatures;
};

var buildFeatureManager = function buildFeatureManager(libraryConfigurations, tenant, allFeatures, apiFeatures) {
    if (!!apiFeatures) {
        features = apiFeatures;
    }
    return new FeatureManager(features, libraryConfigurations, tenant, allFeatures, [{ configureDynamicFeature: _.partial(getFeaturesConfiguredForReversePreview) }]);
};

module.exports = buildFeatureManager;

},{"../config/features.json":"C:\\projects\\lightning\\config\\features.json","../config/reversePreviewSites.json":"C:\\projects\\lightning\\config\\reversePreviewSites.json","./featureManager":"C:\\projects\\lightning\\lib\\featureManager.js","underscore":"C:\\projects\\lightning\\node_modules\\underscore\\underscore.js"}],"C:\\projects\\lightning\\lib\\i18n\\browser\\index.js":[function(require,module,exports){
'use strict';

/* eslint-env browser */

var Translater = require('../translater');
var utility = require('../utility');

var _logger = function _logger(level, message, args) {
    try {
        var error = level && level.toLowerCase() === 'error';

        if (error && window.NREUM) {
            var errorMessage = message + ' ' + window.JSON.stringify(args);
            window.NREUM.noticeError(errorMessage);
        }

        if (window && window.console) {
            if (error && window.console.error) {
                window.console.error(message, args);
            } else {
                window.console.log(message, args);
            }
        }
    } catch (e) {
        // ¯\_(ツ)_/¯
    }
};

var _getLocale = function _getLocale() {
    if (window.OverDrive && window.OverDrive._locale) {
        return window.OverDrive._locale;
    } else {
        return 'en';
    }
};

var _translaterSingleton = new Translater(window.OverDrive.translations, _logger);

var _text = function _text(expectHtml, key, args) {
    var locale = _getLocale();
    var options = utility.getTranslationOptions(locale, expectHtml);

    return _translaterSingleton.translate(key, locale, args, options);
};

/**
 * @param {string} key - The key to find the translation
 * @param {object} args - The arguments to use for the template
 */
var html = _text.bind(null, true);

/**
 * @param {string} key - The key to find the translation
 * @param {object} args - The arguments to use for the template
 */
var text = _text.bind(null, false);

module.exports = {
    html: html,
    text: text
};

},{"../translater":"C:\\projects\\lightning\\lib\\i18n\\translater.js","../utility":"C:\\projects\\lightning\\lib\\i18n\\utility.js"}],"C:\\projects\\lightning\\lib\\i18n\\messageformat.js":[function(require,module,exports){
'use strict';

var MessageFormat = require('messageformat');

var compileTemplate = function compileTemplate(template, locale) {
    locale = locale || 'en';

    return new MessageFormat(locale).setIntlSupport(true).compile(template);
};

module.exports = {
    compileTemplate: compileTemplate
};

},{"messageformat":"C:\\projects\\lightning\\node_modules\\messageformat\\lib\\index.js"}],"C:\\projects\\lightning\\lib\\i18n\\translater.js":[function(require,module,exports){
'use strict';

var messageformat = require('./messageformat');
var utility = require('./utility');

/**
 * @param {Translations} translations - The translations configuration object
 * @param {Logger} logger - An optional object-logger
 */
function Translater(translations, logger) {
    // template text -> locale -> templateFunction
    // NOTE: We map using the template text to reduce cache key uniqueness errors
    // NOTE: We include the locale in the cache as the same text can be used for multiple locales;
    //       for example the following would cache the first locale to use it: {x, number}.
    this._compiledTemplates = {};

    // key (-> subkey)* -> (english template | locale -> template)
    this._translations = translations;

    // (level: string, message: string, args: string -> object): void
    this._logger = logger;
}

Translater.prototype.translate = function (key, locale, args, options, requestUrl) {
    locale = locale || 'en';
    args = args || {};
    options = options || {};

    // Sould never be valid, but also guard against later code trying keys
    // that append strings onto nothing, which could be false positives.
    if (!key) {
        var keyDescription = key === '' ? '(empty string)' : key === null ? '(null)' : '(undefined)';
        this._log('error', 'Expected a non-empty key', { keyDescription: keyDescription, requestUrl: requestUrl });

        return null;
    }

    var result = null;

    try {
        result = this._translate(key, locale, args, options, requestUrl);
    } catch (e) {
        // already logged; just gotta give them nothing for now
    }

    if (result) {
        // result should already be formatted
        return result;
    } else {
        // still gotta format nothing for all the logic to work out
        return utility.formatLocalizedText(key, result, options);
    }
};

Translater.prototype._translate = function (requestKey, locale, args, options, requestUrl) {
    var keysToTry = this._getKeysToTry(requestKey);

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = keysToTry[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            var translation = this._tryGetTranslation(key);

            if (translation != null) {
                var templateFunction = this._compileTemplate(key, locale, translation, requestUrl);

                if (templateFunction != null) {
                    var translated = templateFunction(args);
                    var result = utility.formatLocalizedText(key, translated, options);

                    return result;
                }
            }
        }

        // no keys could produce a result
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator['return']) {
                _iterator['return']();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    this._log('error', 'Could not find a translation for any of the following keys', { keysToTry: keysToTry, key: requestKey, locale: locale, args: args, requestUrl: requestUrl });

    return null;
};

Translater.prototype._compileTemplate = function (key, rawLocale, translation, requestUrl) {
    var localesToTry = this._getLocalesToTry(rawLocale);

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = localesToTry[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var locale = _step2.value;

            var template = translation[locale];

            if (template != null) {
                if (this._compiledTemplates[template] == null) {
                    this._compiledTemplates[template] = {};
                }

                if (this._compiledTemplates[template][locale] == null) {
                    this._compiledTemplates[template][locale] = messageformat.compileTemplate(template, locale);
                }

                return this._compiledTemplates[template][locale];
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2['return']) {
                _iterator2['return']();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    this._log('error', 'Found a translation but no template for any of the following locales', { translation: translation, localesToTry: localesToTry, rawLocale: rawLocale, key: key, requestUrl: requestUrl });

    return null;
};

Translater.prototype._tryGetTranslation = function (key) {
    var parts = key.split('.');
    var cursor = this._translations;
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
        for (var _iterator3 = parts[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var part = _step3.value;

            cursor = cursor[part];

            if (cursor == null) {
                return null;
            }
        }
    } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion3 && _iterator3['return']) {
                _iterator3['return']();
            }
        } finally {
            if (_didIteratorError3) {
                throw _iteratorError3;
            }
        }
    }

    var translation = cursor;

    // If the translation mapping is just a string, treat it as a mapping
    // of english to that string.
    if (typeof translation === 'string') {
        translation = { en: translation };
    }

    return translation;
};

Translater.prototype._getLocalesToTry = function (locale) {
    if (locale && locale !== 'en') {
        var dashIndex = locale.indexOf('-');

        if (dashIndex === -1) {
            return [locale, 'en'];
        } else {
            var language = locale.substr(0, dashIndex);

            if (language.toLowerCase() === 'en') {
                return [locale, 'en'];
            } else {
                return [locale, language, 'en'];
            }
        }
    } else {
        return ['en'];
    }
};

Translater.prototype._getKeysToTry = function (key) {
    return [key + 'Html', key];
};

Translater.prototype._log = function (level, message, args) {
    if (this._logger) {
        this._logger(level, message, args);
    }
};

module.exports = Translater;

},{"./messageformat":"C:\\projects\\lightning\\lib\\i18n\\messageformat.js","./utility":"C:\\projects\\lightning\\lib\\i18n\\utility.js"}],"C:\\projects\\lightning\\lib\\i18n\\utility.js":[function(require,module,exports){
'use strict';

var escapeHtml = require('escape-html');
var _ = require('underscore');
var locale = require('locale');

var allLocales = require('../../config/supportedLanguages').supportedLanguages;

var _htmlEscape = function _htmlEscape(text, shouldEscapeHtml) {
    if (shouldEscapeHtml && text) {
        return escapeHtml(text);
    } else {
        return text;
    }
};

var _wrap = function _wrap(text, shouldWrap) {
    if (shouldWrap) {
        if (text == null) {
            return 'X (MISSING TEMPLATE) X';
        } else {
            return '✓ ' + text + ' ✓';
        }
    } else {
        return text;
    }
};

var _isHtmlTranslation = function _isHtmlTranslation(key) {
    return key && key.toLowerCase().endsWith('html');
};

var formatLocalizedText = function formatLocalizedText(key, text, options) {
    options = options || {};

    var shouldEscapeHtml = options.expectHtml && !_isHtmlTranslation(key);
    var shouldWrap = !!options.wrap;

    var possiblyHtmlEscaped = _htmlEscape(text, shouldEscapeHtml);
    var possiblyWrapped = _wrap(possiblyHtmlEscaped, shouldWrap);

    return possiblyWrapped || '';
};

var getLanguageHeaderLocale = function getLanguageHeaderLocale(req, libraryPrimaryLocale) {
    // Get all supported languages
    var supportedLanguages = new locale.Locales(_.flatten(_.pluck(allLocales, 'defaultLanguageCode')), libraryPrimaryLocale);
    var locales = new locale.Locales(req.headers['accept-language']);
    var bestLanguage = locales.best(supportedLanguages).toString();
    if (bestLanguage === 'zh-Hans' && req.headers['accept-language'].toLowerCase().includes("zh") && (libraryPrimaryLocale === 'zh-Hans' || libraryPrimaryLocale === 'zh-Hant')) {
        bestLanguage = libraryPrimaryLocale;
    }
    return bestLanguage;
};

var getLocale = function getLocale(req, libraryPrimaryLocale) {
    if (req.query && req.query._locale) {
        return req.query._locale;
    } else if (req.profile && req.profile.settings && req.profile.settings['language-selection']) {
        return req.profile.settings['language-selection'];
    } else if (req.cookies && req.cookies['language-selection']) {
        return req.cookies['language-selection'];
    } else if (req.headers['accept-language']) {
        return getLanguageHeaderLocale(req, libraryPrimaryLocale);
    } else if (libraryPrimaryLocale) {
        return libraryPrimaryLocale;
    } else {
        return 'en';
    }
};

var getTranslationOptions = function getTranslationOptions(locale, expectHtml) {
    // eslint-disable-line no-shadow
    return {
        expectHtml: expectHtml,
        wrap: locale && locale.toLowerCase() === 'en-qa'
    };
};

module.exports = {
    formatLocalizedText: formatLocalizedText,
    getLocale: getLocale,
    getTranslationOptions: getTranslationOptions,
    getLanguageHeaderLocale: getLanguageHeaderLocale
};

},{"../../config/supportedLanguages":"C:\\projects\\lightning\\config\\supportedLanguages.json","escape-html":"C:\\projects\\lightning\\node_modules\\escape-html\\index.js","locale":"C:\\projects\\lightning\\node_modules\\locale\\lib\\index.js","underscore":"C:\\projects\\lightning\\node_modules\\underscore\\underscore.js"}],"C:\\projects\\lightning\\lib\\internal\\routing.js":[function(require,module,exports){
'use strict';

var _ = require('underscore');

var urlJoin = require('url-join');
var routes = require('../../routes/routing-configuration').routes;

// Converts nested route map into flattened route hash table
var mapRoutePaths = function mapRoutePaths(routeMap) {
    var response = {};

    var mapRoutes = function mapRoutes(currentRouteMap, targetObject) {
        _.each(currentRouteMap, function (route) {
            if (_.isObject(route)) {
                mapRoutes(route, targetObject);
            } else {
                targetObject[route] = true;
            }
        });
    };

    mapRoutes(routeMap, response);

    return response;
};

var _unprefixedRoutes = [routes.accountSignIn, routes.accountLinkLibraryCardComplete, routes.assets.css.colors, routes.assets.css.versionedColors];

var _caseInsensitiveLookup = function _caseInsensitiveLookup(obj, keyLookup) {
    if (obj != null && keyLookup != null) {
        for (var prop in obj) {
            if (keyLookup.toLowerCase() == prop.toLowerCase()) {
                return { key: prop, value: obj[prop] };
            }
        }
    }

    return null;
};

var routeReverseLoopkup = mapRoutePaths(routes);

var _generateUrlWithParameters = function _generateUrlWithParameters(pathTemplate, originalParameterDictionary) {
    if (pathTemplate == null) {
        return null;
    }

    // Check to see if the route passed in is in our routing-configuration
    if (!routeReverseLoopkup[pathTemplate]) {
        return null;
    }

    // make a shallow clone of the parameter dictionary
    var parameterDictionary = {};
    for (var originalKey in originalParameterDictionary) {
        if ({}.hasOwnProperty.call(originalParameterDictionary, originalKey)) {
            parameterDictionary[originalKey] = originalParameterDictionary[originalKey];
        }
    }

    var satisfiedAllParameters = true;
    var path = pathTemplate.replace(/:\w+\??/g, function (match) {
        var isOptional = match[match.length - 1] === '?';

        // the length of the key is one less than the match because of the colon prefix
        var keyLength = match.length - 1;
        if (isOptional) {
            // and one less if optional to not include the question mark
            --keyLength;
        }

        // start from 1 to skip the colon prefix
        var key = match.substr(1, keyLength);

        var tuple = _caseInsensitiveLookup(parameterDictionary, key);

        if (tuple == null || tuple.value == null) {
            if (isOptional) {
                delete parameterDictionary[key]; // remove it so it's not in the querystring

                return '';
            } else {
                satisfiedAllParameters = false;

                return null;
            }
        } else {
            delete parameterDictionary[tuple.key]; // remove it so it's not in the querystring

            return tuple.value;
        }
    });

    // TODO: log?  error?
    if (!satisfiedAllParameters) {
        return null;
    }

    // url-join will trim off a trailing slash ONLY when there's a querystring; we'd
    // rather be consistent and just always trim it ourselves to avoid confusion
    // NOTE: the index path is the only case where ending in a slash isn't trailing
    var lastPathChar = path[path.length - 1];
    if (lastPathChar === '/' && path !== '/') {
        path = path.substr(0, path.length - 1);
    }

    // TODO: Support arrays as querystring values
    // TODO: Convert non-strings to strings
    var queryParts = [];
    for (var key in parameterDictionary) {
        if ({}.hasOwnProperty.call(parameterDictionary, key)) {
            queryParts.push(key + '=' + encodeURIComponent(parameterDictionary[key]));
        }
    }
    var query = queryParts.length === 0 ? '' : '?' + queryParts.join('&');

    return path + query;
};

var _prependRoot = function _prependRoot(req, route) {
    var baseUrl = req.baseUrl || '/';
    if (baseUrl === '/') {
        return route;
    } else if (route === '/') {
        return baseUrl;
    } else {
        return urlJoin(baseUrl, route);
    }
};

var getRouteUrl = function getRouteUrl(req, route, parameters) {
    var fullRoute = _generateUrlWithParameters(route, parameters || {});
    if (fullRoute != null) {
        var isPrefixed = _unprefixedRoutes.indexOf(route) === -1;
        if (isPrefixed) {
            return _prependRoot(req, fullRoute);
        } else {
            return fullRoute;
        }
    } else {
        // probably log here
        return null;
    }
};

module.exports = {
    routes: routes,
    getRouteUrl: getRouteUrl,

    _caseInsensitiveLookup: _caseInsensitiveLookup
};

},{"../../routes/routing-configuration":"C:\\projects\\lightning\\routes\\routing-configuration\\index.js","underscore":"C:\\projects\\lightning\\node_modules\\underscore\\underscore.js","url-join":"C:\\projects\\lightning\\node_modules\\url-join\\lib\\url-join.js"}],"C:\\projects\\lightning\\lib\\numbers.js":[function(require,module,exports){
"use strict";

module.exports = {
    yearInSeconds: 365 * 24 * 60 * 60,
    yearInMilliseconds: 365 * 24 * 60 * 60 * 1000,
    minuteInMilliseconds: 60 * 1000,
    dayInMilliSeconds: 24 * 60 * 60 * 1000
};

},{}],"C:\\projects\\lightning\\lib\\simpleHash.js":[function(require,module,exports){
"use strict";

var SimpleHash = {
    hash: function hash(toHash) {
        var hash = 0,
            i,
            chr,
            len = toHash.length;
        if (toHash.length === 0) {
            return hash;
        }
        for (i = 0; i < len; i++) {
            chr = toHash.charCodeAt(i);
            hash = (hash << 5) - hash + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    }
};

module.exports = SimpleHash;

},{}],"C:\\projects\\lightning\\lib\\supportUrl.js":[function(require,module,exports){
'use strict';

var querystring = require('querystring');

var supportUrl = function supportUrl(preferredLang, article, params) {
    var language = preferredLang || 'en';
    var url = 'https://help.overdrive.com';
    if (language === 'fr' || language === 'fr-CA') {
        url += '/customer/fr/portal/articles/';
        if (!!article) {
            url += article;
        }
    } else if (!!article) {
        url += '/customer/portal/articles/' + article;
    }
    if (!!params) {
        var queryString = querystring.stringify(params);
        if (queryString) {
            url += '?' + queryString;
        }
    }
    return url;
};

module.exports = supportUrl;

},{"querystring":"C:\\projects\\lightning\\node_modules\\querystring-es3\\index.js"}],"C:\\projects\\lightning\\lib\\utility\\bitFlag.js":[function(require,module,exports){
'use strict';

/**
* Flips the value of a bit at the index
* @param index - index of bit to flip. 0 is the LSB
* @param flagString - Encoded string, bits are represented by base 10 integer
* @return flagString - the updated and encoded string
*/
var bitFlip = function bitFlip(index, flagString) {
    var pow = Math.pow(2, index);
    return (parseInt(flagString, 10) ^ pow).toString();
};

/**
* Returns the value of a bit at the index specified from the encoded flagString
* @param index - index of bit flag. 0 is the LSB
* @param flagString - Encoded string, bits are represented by base 10 integer
* @return boolean value at index
*/
var bitDecode = function bitDecode(index, flagString) {
    var pow = Math.pow(2, index);
    return (parseInt(flagString, 10) & pow) === pow;
};

/**
* Encodes the bit at the index on/off into a flagString
* @param value - value to be encoded (true/false)
* @param index - index of bit to set. 0 is the LSB
* @param flagString - optional if updating existing flagString
* @return the encoded string of bits
*/
var bitEncode = function bitEncode(value, index) {
    var flagString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';

    return bitDecode(index, flagString) === value ? flagString : bitFlip(index, flagString);
};

module.exports = {
    bitFlip: bitFlip,
    bitDecode: bitDecode,
    bitEncode: bitEncode
};

},{}],"C:\\projects\\lightning\\lib\\utility\\clone.js":[function(require,module,exports){
"use strict";

/**
 * Returns a shallow-ish clone of param.
 * Uses json parse, stringify so no support for
 * es6 structures (symbols, sets, maps, etc), dates, functions, undefined
 * @param {obj|array|string|number|null} obj - The thing to be cloned
 * @return {obj|array|string|number|null} A cloned thing
 */
var JSONClone = function JSONClone(obj) {
    return JSON.parse(JSON.stringify(obj));
};

/**
 * Returns a shallow-ish clone of param
 * Currently no support for es6 structures (symbols, sets, maps, etc),
 * dates, functions
 * @param {obj|array|string|number|null|undefined} obj - The thing to be cloned
 * @return {obj|array|string|number|null|undefined} A cloned thing
 */
var lightClone = function lightClone(obj) {
    return obj === void 0 ? obj : JSONClone(obj);
};

module.exports = {
    JSONClone: JSONClone,
    lightClone: lightClone
};

},{}],"C:\\projects\\lightning\\models\\HighlightedFeatureState.js":[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var bitFlag = require('../lib/utility/bitFlag.js');

module.exports = function () {
    function HighlightedFeatureState(flags, featureManager, hasPartnerLibraries) {
        _classCallCheck(this, HighlightedFeatureState);

        this.featureManager = featureManager;
        this.hasPartnerLibraries = hasPartnerLibraries;

        if (flags) {
            this.flags = flags;
        } else {
            this.flags = 0;
        }
    }

    _createClass(HighlightedFeatureState, [{
        key: 'wasVisited',
        value: function wasVisited(featureName) {
            if (!this.features.hasOwnProperty(featureName)) {
                throw new Error('\'' + featureName + '\' is not a known feature.');
            }

            return bitFlag.bitDecode(this.features[featureName].flagBit, this.flags);
        }
    }, {
        key: 'visit',
        value: function visit(featureName) {
            if (!this.features.hasOwnProperty(featureName)) {
                throw new Error('\'' + featureName + '\' is not a known feature.');
            }
            this.flags = bitFlag.bitEncode(true, this.features[featureName].flagBit, this.flags);
        }
    }, {
        key: 'visitAllActiveFeatures',
        value: function visitAllActiveFeatures() {
            var _this = this;

            var activeFeatureNames = Object.getOwnPropertyNames(this.features).filter(function (featureName) {
                return _this.features[featureName].active;
            });
            activeFeatureNames.forEach(function (featureName) {
                return _this.visit(featureName);
            });
        }
    }, {
        key: 'features',
        get: function get() {
            return {
                partnerLibrariesMenu: { flagBit: 0, active: this.featureManager.isEnabled('reciprocalLending') && this.hasPartnerLibraries }
            };
        }
    }, {
        key: 'unvisitedFeaturePresent',
        get: function get() {
            var _this2 = this;

            var activeFeatureNames = Object.getOwnPropertyNames(this.features).filter(function (featureName) {
                return _this2.features[featureName].active;
            });
            return activeFeatureNames.length !== 0 && activeFeatureNames.some(function (featureName) {
                return !_this2.wasVisited(featureName);
            });
        }
    }]);

    return HighlightedFeatureState;
}();

},{"../lib/utility/bitFlag.js":"C:\\projects\\lightning\\lib\\utility\\bitFlag.js"}],"C:\\projects\\lightning\\models\\OdTrack.js":[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var bitFlag = require('../lib/utility/bitFlag.js');

module.exports = function () {
    function OdTrack(flags, isGdprCoutnry) {
        _classCallCheck(this, OdTrack);

        if (flags) {
            this.flags = flags;
        } else {
            // defaults
            this.flags = 0;
            if (!isGdprCoutnry) {
                this.perfTrackingEnabled = true;
                this.analyticsTrackingEnabled = true;
            } else {
                this.perfTrackingEnabled = false;
                this.analyticsTrackingEnabled = false;
            }
        }
    }

    _createClass(OdTrack, [{
        key: 'perfTrackingEnabled',
        get: function get() {
            return bitFlag.bitDecode(0, this.flags);
        },
        set: function set(enabled) {
            this.flags = bitFlag.bitEncode(enabled, 0, this.flags);
        }
    }, {
        key: 'analyticsTrackingEnabled',
        get: function get() {
            return bitFlag.bitDecode(1, this.flags);
        },
        set: function set(enabled) {
            this.flags = bitFlag.bitEncode(enabled, 1, this.flags);
        }
    }]);

    return OdTrack;
}();

},{"../lib/utility/bitFlag.js":"C:\\projects\\lightning\\lib\\utility\\bitFlag.js"}],"C:\\projects\\lightning\\models\\dao\\MediaParameters.js":[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _ = require('underscore');

/**
 * Defines all the available input parameters for the media endpoint
 * @class MediaParameters
 * ref: https://thunder-api.test.overdrive.com/docs/ui/index#!/Media/V2Media_IndexMedia
 */
module.exports = function () {
    function MediaParameters() {
        _classCallCheck(this, MediaParameters);

        this.query = '';
        this.mediaType = '';
        this.title = '';
        this.series = '';
        this.publisherId = '';
        this.publisherEntityId = null;
        this.imprintId = '';
        this.identifier = '';
        this.creator = '';
        this.creatorId = null;
        this.addedDate = '';
        this.availableFirst = null;
        this.showOnlyAvailable = false;
        this.showOnlyPrerelease = false;
        this.showOnlyLuckyDayAvailable = false;
        this.hasAudioSynchronizedText = null;
        this.collectionId = 0;

        // All of the following arrays are string arrays
        this.format = [];
        this.subject = [];
        this.bisacCode = [];
        this.maturityLevel = [];
        this.language = [];
        this.atosLevel = [];
        this.lexileScore = [];
        this.interestLevel = [];
        this.gradeLevel = [];
        this.includedFacets = [];

        this.sortBy = 'relevance';
        this.show = 'owned';
        this.page = 1;
        this.perPage = 24;
        this.includeFacets = true;
        this.includeNoFormatTitles = false;
        this.filterCpcTitles = false;
        this.maxItems = 0;

        Object.assign.apply(Object, [this].concat(Array.prototype.slice.call(arguments)));
    }

    _createClass(MediaParameters, [{
        key: 'applyRoomFiltersAndUserPrefs',
        value: function applyRoomFiltersAndUserPrefs(roomFilters, userPreferences) {
            if (roomFilters) {
                // Note that the names don't match up so we can't just extend
                if (roomFilters.maturityLevels) {
                    this.maturityLevel = roomFilters.maturityLevels;
                }
                if (roomFilters.subjects) {
                    this.subject = roomFilters.subjects;
                }
                if (roomFilters.language) {
                    this.language = roomFilters.language;
                }
                if (roomFilters.mediaType) {
                    this.mediaType = roomFilters.mediaType;
                }
            }

            if (userPreferences) {
                // There may be more user prefs to apply besides audience-settings but this
                // was the immediate need.  We can add more as they come up.
                if (userPreferences['audience-setting'] && this.maturityLevel.length === 0) {
                    var audience = userPreferences['audience-setting'];
                    var maturityLevels = [];
                    _.each(_.keys(audience), function (key) {
                        if (audience[key] && key !== 'all') {
                            maturityLevels.push(key);
                        }
                    });
                    if (maturityLevels.length > 0) {
                        this.maturityLevel = maturityLevels;
                    }
                }
            }
        }
    }, {
        key: 'serialize',
        value: function serialize() {
            var _this = this;

            var response = _.extend({}, this);

            // Remove all properties that do not have a value set
            Object.keys(response).forEach(function (key) {
                !_this._hasValue(response[key]) && delete response[key];
            });

            return response;
        }
    }, {
        key: '_hasValue',
        value: function _hasValue(value) {
            return !(_(value).isObject() && _(value).isEmpty() || !value) || value === false;
        }
    }]);

    return MediaParameters;
}();


},{"underscore":"C:\\projects\\lightning\\node_modules\\underscore\\underscore.js"}],"C:\\projects\\lightning\\node_modules\\assert\\assert.js":[function(require,module,exports){
(function (global){
'use strict';

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
    return global.Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = require('util/');
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof global.ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"util/":"C:\\projects\\lightning\\node_modules\\assert\\node_modules\\util\\util.js"}],"C:\\projects\\lightning\\node_modules\\assert\\node_modules\\inherits\\inherits_browser.js":[function(require,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}

},{}],"C:\\projects\\lightning\\node_modules\\assert\\node_modules\\util\\support\\isBufferBrowser.js":[function(require,module,exports){
module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}
},{}],"C:\\projects\\lightning\\node_modules\\assert\\node_modules\\util\\util.js":[function(require,module,exports){
(function (process,global){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = require('./support/isBuffer');

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = require('inherits');

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./support/isBuffer":"C:\\projects\\lightning\\node_modules\\assert\\node_modules\\util\\support\\isBufferBrowser.js","_process":"C:\\projects\\lightning\\node_modules\\process\\browser.js","inherits":"C:\\projects\\lightning\\node_modules\\assert\\node_modules\\inherits\\inherits_browser.js"}],"C:\\projects\\lightning\\node_modules\\babel-polyfill\\lib\\index.js":[function(require,module,exports){
(function (global){
"use strict";

require("core-js/shim");

require("regenerator-runtime/runtime");

require("core-js/fn/regexp/escape");

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"core-js/fn/regexp/escape":"C:\\projects\\lightning\\node_modules\\core-js\\fn\\regexp\\escape.js","core-js/shim":"C:\\projects\\lightning\\node_modules\\core-js\\shim.js","regenerator-runtime/runtime":"C:\\projects\\lightning\\node_modules\\regenerator-runtime\\runtime.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\fn\\regexp\\escape.js":[function(require,module,exports){
require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;

},{"../../modules/_core":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_core.js","../../modules/core.regexp.escape":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\core.regexp.escape.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_a-function.js":[function(require,module,exports){
module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_a-number-value.js":[function(require,module,exports){
var cof = require('./_cof');
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};

},{"./_cof":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_cof.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_add-to-unscopables.js":[function(require,module,exports){
// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = require('./_wks')('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) require('./_hide')(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

},{"./_hide":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_hide.js","./_wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-instance.js":[function(require,module,exports){
module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js":[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

},{"./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-copy-within.js":[function(require,module,exports){
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
'use strict';
var toObject = require('./_to-object');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};

},{"./_to-absolute-index":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-absolute-index.js","./_to-length":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-length.js","./_to-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-object.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-fill.js":[function(require,module,exports){
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
'use strict';
var toObject = require('./_to-object');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};

},{"./_to-absolute-index":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-absolute-index.js","./_to-length":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-length.js","./_to-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-object.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-from-iterable.js":[function(require,module,exports){
var forOf = require('./_for-of');

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};

},{"./_for-of":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_for-of.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-includes.js":[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');
var toAbsoluteIndex = require('./_to-absolute-index');
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

},{"./_to-absolute-index":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-absolute-index.js","./_to-iobject":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-iobject.js","./_to-length":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-length.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-methods.js":[function(require,module,exports){
// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = require('./_ctx');
var IObject = require('./_iobject');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var asc = require('./_array-species-create');
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

},{"./_array-species-create":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-species-create.js","./_ctx":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_ctx.js","./_iobject":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iobject.js","./_to-length":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-length.js","./_to-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-object.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-reduce.js":[function(require,module,exports){
var aFunction = require('./_a-function');
var toObject = require('./_to-object');
var IObject = require('./_iobject');
var toLength = require('./_to-length');

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};

},{"./_a-function":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_a-function.js","./_iobject":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iobject.js","./_to-length":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-length.js","./_to-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-object.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-species-constructor.js":[function(require,module,exports){
var isObject = require('./_is-object');
var isArray = require('./_is-array');
var SPECIES = require('./_wks')('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

},{"./_is-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-array.js","./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js","./_wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-species-create.js":[function(require,module,exports){
// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = require('./_array-species-constructor');

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};

},{"./_array-species-constructor":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-species-constructor.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_bind.js":[function(require,module,exports){
'use strict';
var aFunction = require('./_a-function');
var isObject = require('./_is-object');
var invoke = require('./_invoke');
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};

},{"./_a-function":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_a-function.js","./_invoke":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_invoke.js","./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_classof.js":[function(require,module,exports){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require('./_cof');
var TAG = require('./_wks')('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

},{"./_cof":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_cof.js","./_wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_cof.js":[function(require,module,exports){
var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_collection-strong.js":[function(require,module,exports){
'use strict';
var dP = require('./_object-dp').f;
var create = require('./_object-create');
var redefineAll = require('./_redefine-all');
var ctx = require('./_ctx');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var $iterDefine = require('./_iter-define');
var step = require('./_iter-step');
var setSpecies = require('./_set-species');
var DESCRIPTORS = require('./_descriptors');
var fastKey = require('./_meta').fastKey;
var validate = require('./_validate-collection');
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

},{"./_an-instance":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-instance.js","./_ctx":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_ctx.js","./_descriptors":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_descriptors.js","./_for-of":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_for-of.js","./_iter-define":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iter-define.js","./_iter-step":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iter-step.js","./_meta":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_meta.js","./_object-create":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-create.js","./_object-dp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-dp.js","./_redefine-all":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_redefine-all.js","./_set-species":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-species.js","./_validate-collection":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_validate-collection.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_collection-to-json.js":[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = require('./_classof');
var from = require('./_array-from-iterable');
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};

},{"./_array-from-iterable":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-from-iterable.js","./_classof":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_classof.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_collection-weak.js":[function(require,module,exports){
'use strict';
var redefineAll = require('./_redefine-all');
var getWeak = require('./_meta').getWeak;
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var createArrayMethod = require('./_array-methods');
var $has = require('./_has');
var validate = require('./_validate-collection');
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};

},{"./_an-instance":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-instance.js","./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_array-methods":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-methods.js","./_for-of":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_for-of.js","./_has":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_has.js","./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js","./_meta":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_meta.js","./_redefine-all":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_redefine-all.js","./_validate-collection":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_validate-collection.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_collection.js":[function(require,module,exports){
'use strict';
var global = require('./_global');
var $export = require('./_export');
var redefine = require('./_redefine');
var redefineAll = require('./_redefine-all');
var meta = require('./_meta');
var forOf = require('./_for-of');
var anInstance = require('./_an-instance');
var isObject = require('./_is-object');
var fails = require('./_fails');
var $iterDetect = require('./_iter-detect');
var setToStringTag = require('./_set-to-string-tag');
var inheritIfRequired = require('./_inherit-if-required');

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};

},{"./_an-instance":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-instance.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js","./_for-of":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_for-of.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_inherit-if-required":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_inherit-if-required.js","./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js","./_iter-detect":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iter-detect.js","./_meta":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_meta.js","./_redefine":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_redefine.js","./_redefine-all":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_redefine-all.js","./_set-to-string-tag":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-to-string-tag.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_core.js":[function(require,module,exports){
var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_create-property.js":[function(require,module,exports){
'use strict';
var $defineProperty = require('./_object-dp');
var createDesc = require('./_property-desc');

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

},{"./_object-dp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-dp.js","./_property-desc":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_property-desc.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_ctx.js":[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"./_a-function":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_a-function.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_date-to-iso-string.js":[function(require,module,exports){
'use strict';
// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = require('./_fails');
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;

},{"./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_date-to-primitive.js":[function(require,module,exports){
'use strict';
var anObject = require('./_an-object');
var toPrimitive = require('./_to-primitive');
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_to-primitive":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-primitive.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_defined.js":[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_descriptors.js":[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_dom-create.js":[function(require,module,exports){
var isObject = require('./_is-object');
var document = require('./_global').document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

},{"./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_enum-bug-keys.js":[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_enum-keys.js":[function(require,module,exports){
// all enumerable object keys, includes symbols
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

},{"./_object-gops":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gops.js","./_object-keys":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-keys.js","./_object-pie":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-pie.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js":[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var hide = require('./_hide');
var redefine = require('./_redefine');
var ctx = require('./_ctx');
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"./_core":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_core.js","./_ctx":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_ctx.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_hide":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_hide.js","./_redefine":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_redefine.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails-is-regexp.js":[function(require,module,exports){
var MATCH = require('./_wks')('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};

},{"./_wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js":[function(require,module,exports){
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fix-re-wks.js":[function(require,module,exports){
'use strict';
var hide = require('./_hide');
var redefine = require('./_redefine');
var fails = require('./_fails');
var defined = require('./_defined');
var wks = require('./_wks');

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};

},{"./_defined":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_defined.js","./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js","./_hide":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_hide.js","./_redefine":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_redefine.js","./_wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_flags.js":[function(require,module,exports){
'use strict';
// 21.2.5.3 get RegExp.prototype.flags
var anObject = require('./_an-object');
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_flatten-into-array.js":[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = require('./_is-array');
var isObject = require('./_is-object');
var toLength = require('./_to-length');
var ctx = require('./_ctx');
var IS_CONCAT_SPREADABLE = require('./_wks')('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;

},{"./_ctx":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_ctx.js","./_is-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-array.js","./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js","./_to-length":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-length.js","./_wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_for-of.js":[function(require,module,exports){
var ctx = require('./_ctx');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var anObject = require('./_an-object');
var toLength = require('./_to-length');
var getIterFn = require('./core.get-iterator-method');
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_ctx":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_ctx.js","./_is-array-iter":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-array-iter.js","./_iter-call":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iter-call.js","./_to-length":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-length.js","./core.get-iterator-method":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\core.get-iterator-method.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js":[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_has.js":[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_hide.js":[function(require,module,exports){
var dP = require('./_object-dp');
var createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"./_descriptors":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_descriptors.js","./_object-dp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-dp.js","./_property-desc":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_property-desc.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_html.js":[function(require,module,exports){
var document = require('./_global').document;
module.exports = document && document.documentElement;

},{"./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_ie8-dom-define.js":[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_descriptors":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_descriptors.js","./_dom-create":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_dom-create.js","./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_inherit-if-required.js":[function(require,module,exports){
var isObject = require('./_is-object');
var setPrototypeOf = require('./_set-proto').set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};

},{"./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js","./_set-proto":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-proto.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_invoke.js":[function(require,module,exports){
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iobject.js":[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

},{"./_cof":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_cof.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-array-iter.js":[function(require,module,exports){
// check on default Array iterator
var Iterators = require('./_iterators');
var ITERATOR = require('./_wks')('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

},{"./_iterators":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iterators.js","./_wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-array.js":[function(require,module,exports){
// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

},{"./_cof":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_cof.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-integer.js":[function(require,module,exports){
// 20.1.2.3 Number.isInteger(number)
var isObject = require('./_is-object');
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

},{"./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js":[function(require,module,exports){
module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-regexp.js":[function(require,module,exports){
// 7.2.8 IsRegExp(argument)
var isObject = require('./_is-object');
var cof = require('./_cof');
var MATCH = require('./_wks')('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

},{"./_cof":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_cof.js","./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js","./_wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iter-call.js":[function(require,module,exports){
// call something on iterator step with safe closing on error
var anObject = require('./_an-object');
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iter-create.js":[function(require,module,exports){
'use strict';
var create = require('./_object-create');
var descriptor = require('./_property-desc');
var setToStringTag = require('./_set-to-string-tag');
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

},{"./_hide":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_hide.js","./_object-create":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-create.js","./_property-desc":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_property-desc.js","./_set-to-string-tag":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-to-string-tag.js","./_wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iter-define.js":[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var $export = require('./_export');
var redefine = require('./_redefine');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var $iterCreate = require('./_iter-create');
var setToStringTag = require('./_set-to-string-tag');
var getPrototypeOf = require('./_object-gpo');
var ITERATOR = require('./_wks')('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_hide":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_hide.js","./_iter-create":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iter-create.js","./_iterators":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iterators.js","./_library":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_library.js","./_object-gpo":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gpo.js","./_redefine":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_redefine.js","./_set-to-string-tag":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-to-string-tag.js","./_wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iter-detect.js":[function(require,module,exports){
var ITERATOR = require('./_wks')('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

},{"./_wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iter-step.js":[function(require,module,exports){
module.exports = function (done, value) {
  return { value: value, done: !!done };
};

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iterators.js":[function(require,module,exports){
module.exports = {};

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_library.js":[function(require,module,exports){
module.exports = false;

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_math-expm1.js":[function(require,module,exports){
// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_math-fround.js":[function(require,module,exports){
// 20.2.2.16 Math.fround(x)
var sign = require('./_math-sign');
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};

},{"./_math-sign":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_math-sign.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_math-log1p.js":[function(require,module,exports){
// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_math-scale.js":[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_math-sign.js":[function(require,module,exports){
// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_meta.js":[function(require,module,exports){
var META = require('./_uid')('meta');
var isObject = require('./_is-object');
var has = require('./_has');
var setDesc = require('./_object-dp').f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !require('./_fails')(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

},{"./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js","./_has":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_has.js","./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js","./_object-dp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-dp.js","./_uid":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_uid.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_metadata.js":[function(require,module,exports){
var Map = require('./es6.map');
var $export = require('./_export');
var shared = require('./_shared')('metadata');
var store = shared.store || (shared.store = new (require('./es6.weak-map'))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_shared":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_shared.js","./es6.map":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.map.js","./es6.weak-map":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.weak-map.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_microtask.js":[function(require,module,exports){
var global = require('./_global');
var macrotask = require('./_task').set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = require('./_cof')(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};

},{"./_cof":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_cof.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_task":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_task.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_new-promise-capability.js":[function(require,module,exports){
'use strict';
// 25.4.1.5 NewPromiseCapability(C)
var aFunction = require('./_a-function');

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};

},{"./_a-function":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_a-function.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-assign.js":[function(require,module,exports){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
var toObject = require('./_to-object');
var IObject = require('./_iobject');
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require('./_fails')(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;

},{"./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js","./_iobject":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iobject.js","./_object-gops":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gops.js","./_object-keys":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-keys.js","./_object-pie":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-pie.js","./_to-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-object.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-create.js":[function(require,module,exports){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = require('./_an-object');
var dPs = require('./_object-dps');
var enumBugKeys = require('./_enum-bug-keys');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require('./_dom-create')('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  require('./_html').appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_dom-create":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_dom-create.js","./_enum-bug-keys":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_enum-bug-keys.js","./_html":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_html.js","./_object-dps":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-dps.js","./_shared-key":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_shared-key.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-dp.js":[function(require,module,exports){
var anObject = require('./_an-object');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var toPrimitive = require('./_to-primitive');
var dP = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_descriptors":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_descriptors.js","./_ie8-dom-define":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_ie8-dom-define.js","./_to-primitive":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-primitive.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-dps.js":[function(require,module,exports){
var dP = require('./_object-dp');
var anObject = require('./_an-object');
var getKeys = require('./_object-keys');

module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_descriptors":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_descriptors.js","./_object-dp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-dp.js","./_object-keys":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-keys.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-forced-pam.js":[function(require,module,exports){
'use strict';
// Forced replacement prototype accessors methods
module.exports = require('./_library') || !require('./_fails')(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete require('./_global')[K];
});

},{"./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_library":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_library.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gopd.js":[function(require,module,exports){
var pIE = require('./_object-pie');
var createDesc = require('./_property-desc');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var has = require('./_has');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = require('./_descriptors') ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

},{"./_descriptors":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_descriptors.js","./_has":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_has.js","./_ie8-dom-define":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_ie8-dom-define.js","./_object-pie":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-pie.js","./_property-desc":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_property-desc.js","./_to-iobject":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-iobject.js","./_to-primitive":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-primitive.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gopn-ext.js":[function(require,module,exports){
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require('./_to-iobject');
var gOPN = require('./_object-gopn').f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

},{"./_object-gopn":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gopn.js","./_to-iobject":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-iobject.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gopn.js":[function(require,module,exports){
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = require('./_object-keys-internal');
var hiddenKeys = require('./_enum-bug-keys').concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

},{"./_enum-bug-keys":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_enum-bug-keys.js","./_object-keys-internal":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-keys-internal.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gops.js":[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gpo.js":[function(require,module,exports){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = require('./_has');
var toObject = require('./_to-object');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

},{"./_has":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_has.js","./_shared-key":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_shared-key.js","./_to-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-object.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-keys-internal.js":[function(require,module,exports){
var has = require('./_has');
var toIObject = require('./_to-iobject');
var arrayIndexOf = require('./_array-includes')(false);
var IE_PROTO = require('./_shared-key')('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

},{"./_array-includes":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-includes.js","./_has":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_has.js","./_shared-key":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_shared-key.js","./_to-iobject":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-iobject.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-keys.js":[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require('./_object-keys-internal');
var enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

},{"./_enum-bug-keys":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_enum-bug-keys.js","./_object-keys-internal":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-keys-internal.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-pie.js":[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-sap.js":[function(require,module,exports){
// most Object methods by ES6 should accept primitives
var $export = require('./_export');
var core = require('./_core');
var fails = require('./_fails');
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};

},{"./_core":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_core.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-to-array.js":[function(require,module,exports){
var getKeys = require('./_object-keys');
var toIObject = require('./_to-iobject');
var isEnum = require('./_object-pie').f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};

},{"./_object-keys":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-keys.js","./_object-pie":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-pie.js","./_to-iobject":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-iobject.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_own-keys.js":[function(require,module,exports){
// all object keys, includes non-enumerable and symbols
var gOPN = require('./_object-gopn');
var gOPS = require('./_object-gops');
var anObject = require('./_an-object');
var Reflect = require('./_global').Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_object-gopn":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gopn.js","./_object-gops":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gops.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_parse-float.js":[function(require,module,exports){
var $parseFloat = require('./_global').parseFloat;
var $trim = require('./_string-trim').trim;

module.exports = 1 / $parseFloat(require('./_string-ws') + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;

},{"./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_string-trim":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-trim.js","./_string-ws":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-ws.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_parse-int.js":[function(require,module,exports){
var $parseInt = require('./_global').parseInt;
var $trim = require('./_string-trim').trim;
var ws = require('./_string-ws');
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;

},{"./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_string-trim":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-trim.js","./_string-ws":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-ws.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_perform.js":[function(require,module,exports){
module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_promise-resolve.js":[function(require,module,exports){
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var newPromiseCapability = require('./_new-promise-capability');

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js","./_new-promise-capability":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_new-promise-capability.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_property-desc.js":[function(require,module,exports){
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_redefine-all.js":[function(require,module,exports){
var redefine = require('./_redefine');
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};

},{"./_redefine":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_redefine.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_redefine.js":[function(require,module,exports){
var global = require('./_global');
var hide = require('./_hide');
var has = require('./_has');
var SRC = require('./_uid')('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

require('./_core').inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

},{"./_core":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_core.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_has":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_has.js","./_hide":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_hide.js","./_uid":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_uid.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_replacer.js":[function(require,module,exports){
module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_same-value.js":[function(require,module,exports){
// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-collection-from.js":[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-setmap-offrom/
var $export = require('./_export');
var aFunction = require('./_a-function');
var ctx = require('./_ctx');
var forOf = require('./_for-of');

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};

},{"./_a-function":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_a-function.js","./_ctx":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_ctx.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_for-of":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_for-of.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-collection-of.js":[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-setmap-offrom/
var $export = require('./_export');

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-proto.js":[function(require,module,exports){
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = require('./_is-object');
var anObject = require('./_an-object');
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = require('./_ctx')(Function.call, require('./_object-gopd').f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_ctx":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_ctx.js","./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js","./_object-gopd":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gopd.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-species.js":[function(require,module,exports){
'use strict';
var global = require('./_global');
var dP = require('./_object-dp');
var DESCRIPTORS = require('./_descriptors');
var SPECIES = require('./_wks')('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};

},{"./_descriptors":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_descriptors.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_object-dp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-dp.js","./_wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-to-string-tag.js":[function(require,module,exports){
var def = require('./_object-dp').f;
var has = require('./_has');
var TAG = require('./_wks')('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

},{"./_has":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_has.js","./_object-dp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-dp.js","./_wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_shared-key.js":[function(require,module,exports){
var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

},{"./_shared":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_shared.js","./_uid":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_uid.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_shared.js":[function(require,module,exports){
var core = require('./_core');
var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: require('./_library') ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});

},{"./_core":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_core.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_library":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_library.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_species-constructor.js":[function(require,module,exports){
// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = require('./_an-object');
var aFunction = require('./_a-function');
var SPECIES = require('./_wks')('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

},{"./_a-function":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_a-function.js","./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_strict-method.js":[function(require,module,exports){
'use strict';
var fails = require('./_fails');

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};

},{"./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-at.js":[function(require,module,exports){
var toInteger = require('./_to-integer');
var defined = require('./_defined');
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

},{"./_defined":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_defined.js","./_to-integer":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-integer.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-context.js":[function(require,module,exports){
// helper for String#{startsWith, endsWith, includes}
var isRegExp = require('./_is-regexp');
var defined = require('./_defined');

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

},{"./_defined":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_defined.js","./_is-regexp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-regexp.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-html.js":[function(require,module,exports){
var $export = require('./_export');
var fails = require('./_fails');
var defined = require('./_defined');
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};

},{"./_defined":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_defined.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-pad.js":[function(require,module,exports){
// https://github.com/tc39/proposal-string-pad-start-end
var toLength = require('./_to-length');
var repeat = require('./_string-repeat');
var defined = require('./_defined');

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};

},{"./_defined":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_defined.js","./_string-repeat":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-repeat.js","./_to-length":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-length.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-repeat.js":[function(require,module,exports){
'use strict';
var toInteger = require('./_to-integer');
var defined = require('./_defined');

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};

},{"./_defined":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_defined.js","./_to-integer":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-integer.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-trim.js":[function(require,module,exports){
var $export = require('./_export');
var defined = require('./_defined');
var fails = require('./_fails');
var spaces = require('./_string-ws');
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;

},{"./_defined":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_defined.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js","./_string-ws":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-ws.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-ws.js":[function(require,module,exports){
module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_task.js":[function(require,module,exports){
var ctx = require('./_ctx');
var invoke = require('./_invoke');
var html = require('./_html');
var cel = require('./_dom-create');
var global = require('./_global');
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (require('./_cof')(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};

},{"./_cof":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_cof.js","./_ctx":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_ctx.js","./_dom-create":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_dom-create.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_html":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_html.js","./_invoke":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_invoke.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-absolute-index.js":[function(require,module,exports){
var toInteger = require('./_to-integer');
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

},{"./_to-integer":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-integer.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-index.js":[function(require,module,exports){
// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = require('./_to-integer');
var toLength = require('./_to-length');
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};

},{"./_to-integer":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-integer.js","./_to-length":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-length.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-integer.js":[function(require,module,exports){
// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-iobject.js":[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject');
var defined = require('./_defined');
module.exports = function (it) {
  return IObject(defined(it));
};

},{"./_defined":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_defined.js","./_iobject":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iobject.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-length.js":[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer');
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

},{"./_to-integer":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-integer.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-object.js":[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};

},{"./_defined":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_defined.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-primitive.js":[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

},{"./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_typed-array.js":[function(require,module,exports){
'use strict';
if (require('./_descriptors')) {
  var LIBRARY = require('./_library');
  var global = require('./_global');
  var fails = require('./_fails');
  var $export = require('./_export');
  var $typed = require('./_typed');
  var $buffer = require('./_typed-buffer');
  var ctx = require('./_ctx');
  var anInstance = require('./_an-instance');
  var propertyDesc = require('./_property-desc');
  var hide = require('./_hide');
  var redefineAll = require('./_redefine-all');
  var toInteger = require('./_to-integer');
  var toLength = require('./_to-length');
  var toIndex = require('./_to-index');
  var toAbsoluteIndex = require('./_to-absolute-index');
  var toPrimitive = require('./_to-primitive');
  var has = require('./_has');
  var classof = require('./_classof');
  var isObject = require('./_is-object');
  var toObject = require('./_to-object');
  var isArrayIter = require('./_is-array-iter');
  var create = require('./_object-create');
  var getPrototypeOf = require('./_object-gpo');
  var gOPN = require('./_object-gopn').f;
  var getIterFn = require('./core.get-iterator-method');
  var uid = require('./_uid');
  var wks = require('./_wks');
  var createArrayMethod = require('./_array-methods');
  var createArrayIncludes = require('./_array-includes');
  var speciesConstructor = require('./_species-constructor');
  var ArrayIterators = require('./es6.array.iterator');
  var Iterators = require('./_iterators');
  var $iterDetect = require('./_iter-detect');
  var setSpecies = require('./_set-species');
  var arrayFill = require('./_array-fill');
  var arrayCopyWithin = require('./_array-copy-within');
  var $DP = require('./_object-dp');
  var $GOPD = require('./_object-gopd');
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };

},{"./_an-instance":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-instance.js","./_array-copy-within":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-copy-within.js","./_array-fill":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-fill.js","./_array-includes":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-includes.js","./_array-methods":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-methods.js","./_classof":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_classof.js","./_ctx":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_ctx.js","./_descriptors":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_descriptors.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_has":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_has.js","./_hide":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_hide.js","./_is-array-iter":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-array-iter.js","./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js","./_iter-detect":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iter-detect.js","./_iterators":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iterators.js","./_library":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_library.js","./_object-create":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-create.js","./_object-dp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-dp.js","./_object-gopd":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gopd.js","./_object-gopn":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gopn.js","./_object-gpo":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gpo.js","./_property-desc":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_property-desc.js","./_redefine-all":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_redefine-all.js","./_set-species":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-species.js","./_species-constructor":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_species-constructor.js","./_to-absolute-index":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-absolute-index.js","./_to-index":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-index.js","./_to-integer":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-integer.js","./_to-length":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-length.js","./_to-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-object.js","./_to-primitive":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-primitive.js","./_typed":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_typed.js","./_typed-buffer":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_typed-buffer.js","./_uid":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_uid.js","./_wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js","./core.get-iterator-method":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\core.get-iterator-method.js","./es6.array.iterator":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.iterator.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_typed-buffer.js":[function(require,module,exports){
'use strict';
var global = require('./_global');
var DESCRIPTORS = require('./_descriptors');
var LIBRARY = require('./_library');
var $typed = require('./_typed');
var hide = require('./_hide');
var redefineAll = require('./_redefine-all');
var fails = require('./_fails');
var anInstance = require('./_an-instance');
var toInteger = require('./_to-integer');
var toLength = require('./_to-length');
var toIndex = require('./_to-index');
var gOPN = require('./_object-gopn').f;
var dP = require('./_object-dp').f;
var arrayFill = require('./_array-fill');
var setToStringTag = require('./_set-to-string-tag');
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;

},{"./_an-instance":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-instance.js","./_array-fill":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-fill.js","./_descriptors":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_descriptors.js","./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_hide":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_hide.js","./_library":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_library.js","./_object-dp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-dp.js","./_object-gopn":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gopn.js","./_redefine-all":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_redefine-all.js","./_set-to-string-tag":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-to-string-tag.js","./_to-index":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-index.js","./_to-integer":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-integer.js","./_to-length":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-length.js","./_typed":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_typed.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_typed.js":[function(require,module,exports){
var global = require('./_global');
var hide = require('./_hide');
var uid = require('./_uid');
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};

},{"./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_hide":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_hide.js","./_uid":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_uid.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_uid.js":[function(require,module,exports){
var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

},{}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_user-agent.js":[function(require,module,exports){
var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';

},{"./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_validate-collection.js":[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};

},{"./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks-define.js":[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var LIBRARY = require('./_library');
var wksExt = require('./_wks-ext');
var defineProperty = require('./_object-dp').f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

},{"./_core":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_core.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_library":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_library.js","./_object-dp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-dp.js","./_wks-ext":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks-ext.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks-ext.js":[function(require,module,exports){
exports.f = require('./_wks');

},{"./_wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js":[function(require,module,exports){
var store = require('./_shared')('wks');
var uid = require('./_uid');
var Symbol = require('./_global').Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

},{"./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_shared":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_shared.js","./_uid":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_uid.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\core.get-iterator-method.js":[function(require,module,exports){
var classof = require('./_classof');
var ITERATOR = require('./_wks')('iterator');
var Iterators = require('./_iterators');
module.exports = require('./_core').getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

},{"./_classof":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_classof.js","./_core":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_core.js","./_iterators":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iterators.js","./_wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\core.regexp.escape.js":[function(require,module,exports){
// https://github.com/benjamingr/RexExp.escape
var $export = require('./_export');
var $re = require('./_replacer')(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_replacer":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_replacer.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.copy-within.js":[function(require,module,exports){
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = require('./_export');

$export($export.P, 'Array', { copyWithin: require('./_array-copy-within') });

require('./_add-to-unscopables')('copyWithin');

},{"./_add-to-unscopables":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_add-to-unscopables.js","./_array-copy-within":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-copy-within.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.every.js":[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $every = require('./_array-methods')(4);

$export($export.P + $export.F * !require('./_strict-method')([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-methods.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_strict-method":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_strict-method.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.fill.js":[function(require,module,exports){
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = require('./_export');

$export($export.P, 'Array', { fill: require('./_array-fill') });

require('./_add-to-unscopables')('fill');

},{"./_add-to-unscopables":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_add-to-unscopables.js","./_array-fill":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-fill.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.filter.js":[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $filter = require('./_array-methods')(2);

$export($export.P + $export.F * !require('./_strict-method')([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-methods.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_strict-method":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_strict-method.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.find-index.js":[function(require,module,exports){
'use strict';
// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = require('./_export');
var $find = require('./_array-methods')(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
require('./_add-to-unscopables')(KEY);

},{"./_add-to-unscopables":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_add-to-unscopables.js","./_array-methods":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-methods.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.find.js":[function(require,module,exports){
'use strict';
// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = require('./_export');
var $find = require('./_array-methods')(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
require('./_add-to-unscopables')(KEY);

},{"./_add-to-unscopables":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_add-to-unscopables.js","./_array-methods":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-methods.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.for-each.js":[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $forEach = require('./_array-methods')(0);
var STRICT = require('./_strict-method')([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-methods.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_strict-method":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_strict-method.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.from.js":[function(require,module,exports){
'use strict';
var ctx = require('./_ctx');
var $export = require('./_export');
var toObject = require('./_to-object');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var toLength = require('./_to-length');
var createProperty = require('./_create-property');
var getIterFn = require('./core.get-iterator-method');

$export($export.S + $export.F * !require('./_iter-detect')(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

},{"./_create-property":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_create-property.js","./_ctx":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_ctx.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_is-array-iter":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-array-iter.js","./_iter-call":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iter-call.js","./_iter-detect":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iter-detect.js","./_to-length":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-length.js","./_to-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-object.js","./core.get-iterator-method":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\core.get-iterator-method.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.index-of.js":[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $indexOf = require('./_array-includes')(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !require('./_strict-method')($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});

},{"./_array-includes":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-includes.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_strict-method":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_strict-method.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.is-array.js":[function(require,module,exports){
// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = require('./_export');

$export($export.S, 'Array', { isArray: require('./_is-array') });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_is-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-array.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.iterator.js":[function(require,module,exports){
'use strict';
var addToUnscopables = require('./_add-to-unscopables');
var step = require('./_iter-step');
var Iterators = require('./_iterators');
var toIObject = require('./_to-iobject');

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require('./_iter-define')(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

},{"./_add-to-unscopables":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_add-to-unscopables.js","./_iter-define":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iter-define.js","./_iter-step":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iter-step.js","./_iterators":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iterators.js","./_to-iobject":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-iobject.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.join.js":[function(require,module,exports){
'use strict';
// 22.1.3.13 Array.prototype.join(separator)
var $export = require('./_export');
var toIObject = require('./_to-iobject');
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (require('./_iobject') != Object || !require('./_strict-method')(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_iobject":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iobject.js","./_strict-method":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_strict-method.js","./_to-iobject":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-iobject.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.last-index-of.js":[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toIObject = require('./_to-iobject');
var toInteger = require('./_to-integer');
var toLength = require('./_to-length');
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !require('./_strict-method')($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_strict-method":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_strict-method.js","./_to-integer":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-integer.js","./_to-iobject":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-iobject.js","./_to-length":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-length.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.map.js":[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $map = require('./_array-methods')(1);

$export($export.P + $export.F * !require('./_strict-method')([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-methods.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_strict-method":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_strict-method.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.of.js":[function(require,module,exports){
'use strict';
var $export = require('./_export');
var createProperty = require('./_create-property');

// WebKit Array.of isn't generic
$export($export.S + $export.F * require('./_fails')(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});

},{"./_create-property":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_create-property.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.reduce-right.js":[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $reduce = require('./_array-reduce');

$export($export.P + $export.F * !require('./_strict-method')([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});

},{"./_array-reduce":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-reduce.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_strict-method":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_strict-method.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.reduce.js":[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $reduce = require('./_array-reduce');

$export($export.P + $export.F * !require('./_strict-method')([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});

},{"./_array-reduce":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-reduce.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_strict-method":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_strict-method.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.slice.js":[function(require,module,exports){
'use strict';
var $export = require('./_export');
var html = require('./_html');
var cof = require('./_cof');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * require('./_fails')(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});

},{"./_cof":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_cof.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js","./_html":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_html.js","./_to-absolute-index":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-absolute-index.js","./_to-length":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-length.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.some.js":[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $some = require('./_array-methods')(3);

$export($export.P + $export.F * !require('./_strict-method')([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-methods.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_strict-method":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_strict-method.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.sort.js":[function(require,module,exports){
'use strict';
var $export = require('./_export');
var aFunction = require('./_a-function');
var toObject = require('./_to-object');
var fails = require('./_fails');
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !require('./_strict-method')($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});

},{"./_a-function":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_a-function.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js","./_strict-method":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_strict-method.js","./_to-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-object.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.species.js":[function(require,module,exports){
require('./_set-species')('Array');

},{"./_set-species":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-species.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.date.now.js":[function(require,module,exports){
// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = require('./_export');

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.date.to-iso-string.js":[function(require,module,exports){
// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = require('./_export');
var toISOString = require('./_date-to-iso-string');

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});

},{"./_date-to-iso-string":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_date-to-iso-string.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.date.to-json.js":[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var toPrimitive = require('./_to-primitive');

$export($export.P + $export.F * require('./_fails')(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js","./_to-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-object.js","./_to-primitive":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-primitive.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.date.to-primitive.js":[function(require,module,exports){
var TO_PRIMITIVE = require('./_wks')('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) require('./_hide')(proto, TO_PRIMITIVE, require('./_date-to-primitive'));

},{"./_date-to-primitive":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_date-to-primitive.js","./_hide":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_hide.js","./_wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.date.to-string.js":[function(require,module,exports){
var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  require('./_redefine')(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}

},{"./_redefine":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_redefine.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.function.bind.js":[function(require,module,exports){
// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = require('./_export');

$export($export.P, 'Function', { bind: require('./_bind') });

},{"./_bind":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_bind.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.function.has-instance.js":[function(require,module,exports){
'use strict';
var isObject = require('./_is-object');
var getPrototypeOf = require('./_object-gpo');
var HAS_INSTANCE = require('./_wks')('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) require('./_object-dp').f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });

},{"./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js","./_object-dp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-dp.js","./_object-gpo":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gpo.js","./_wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.function.name.js":[function(require,module,exports){
var dP = require('./_object-dp').f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || require('./_descriptors') && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});

},{"./_descriptors":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_descriptors.js","./_object-dp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-dp.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.map.js":[function(require,module,exports){
'use strict';
var strong = require('./_collection-strong');
var validate = require('./_validate-collection');
var MAP = 'Map';

// 23.1 Map Objects
module.exports = require('./_collection')(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);

},{"./_collection":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_collection.js","./_collection-strong":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_collection-strong.js","./_validate-collection":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_validate-collection.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.acosh.js":[function(require,module,exports){
// 20.2.2.3 Math.acosh(x)
var $export = require('./_export');
var log1p = require('./_math-log1p');
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_math-log1p":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_math-log1p.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.asinh.js":[function(require,module,exports){
// 20.2.2.5 Math.asinh(x)
var $export = require('./_export');
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.atanh.js":[function(require,module,exports){
// 20.2.2.7 Math.atanh(x)
var $export = require('./_export');
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.cbrt.js":[function(require,module,exports){
// 20.2.2.9 Math.cbrt(x)
var $export = require('./_export');
var sign = require('./_math-sign');

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_math-sign":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_math-sign.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.clz32.js":[function(require,module,exports){
// 20.2.2.11 Math.clz32(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.cosh.js":[function(require,module,exports){
// 20.2.2.12 Math.cosh(x)
var $export = require('./_export');
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.expm1.js":[function(require,module,exports){
// 20.2.2.14 Math.expm1(x)
var $export = require('./_export');
var $expm1 = require('./_math-expm1');

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_math-expm1":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_math-expm1.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.fround.js":[function(require,module,exports){
// 20.2.2.16 Math.fround(x)
var $export = require('./_export');

$export($export.S, 'Math', { fround: require('./_math-fround') });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_math-fround":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_math-fround.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.hypot.js":[function(require,module,exports){
// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = require('./_export');
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.imul.js":[function(require,module,exports){
// 20.2.2.18 Math.imul(x, y)
var $export = require('./_export');
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * require('./_fails')(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.log10.js":[function(require,module,exports){
// 20.2.2.21 Math.log10(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.log1p.js":[function(require,module,exports){
// 20.2.2.20 Math.log1p(x)
var $export = require('./_export');

$export($export.S, 'Math', { log1p: require('./_math-log1p') });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_math-log1p":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_math-log1p.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.log2.js":[function(require,module,exports){
// 20.2.2.22 Math.log2(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.sign.js":[function(require,module,exports){
// 20.2.2.28 Math.sign(x)
var $export = require('./_export');

$export($export.S, 'Math', { sign: require('./_math-sign') });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_math-sign":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_math-sign.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.sinh.js":[function(require,module,exports){
// 20.2.2.30 Math.sinh(x)
var $export = require('./_export');
var expm1 = require('./_math-expm1');
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * require('./_fails')(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js","./_math-expm1":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_math-expm1.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.tanh.js":[function(require,module,exports){
// 20.2.2.33 Math.tanh(x)
var $export = require('./_export');
var expm1 = require('./_math-expm1');
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_math-expm1":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_math-expm1.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.trunc.js":[function(require,module,exports){
// 20.2.2.34 Math.trunc(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.number.constructor.js":[function(require,module,exports){
'use strict';
var global = require('./_global');
var has = require('./_has');
var cof = require('./_cof');
var inheritIfRequired = require('./_inherit-if-required');
var toPrimitive = require('./_to-primitive');
var fails = require('./_fails');
var gOPN = require('./_object-gopn').f;
var gOPD = require('./_object-gopd').f;
var dP = require('./_object-dp').f;
var $trim = require('./_string-trim').trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(require('./_object-create')(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = require('./_descriptors') ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  require('./_redefine')(global, NUMBER, $Number);
}

},{"./_cof":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_cof.js","./_descriptors":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_descriptors.js","./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_has":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_has.js","./_inherit-if-required":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_inherit-if-required.js","./_object-create":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-create.js","./_object-dp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-dp.js","./_object-gopd":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gopd.js","./_object-gopn":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gopn.js","./_redefine":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_redefine.js","./_string-trim":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-trim.js","./_to-primitive":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-primitive.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.number.epsilon.js":[function(require,module,exports){
// 20.1.2.1 Number.EPSILON
var $export = require('./_export');

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.number.is-finite.js":[function(require,module,exports){
// 20.1.2.2 Number.isFinite(number)
var $export = require('./_export');
var _isFinite = require('./_global').isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.number.is-integer.js":[function(require,module,exports){
// 20.1.2.3 Number.isInteger(number)
var $export = require('./_export');

$export($export.S, 'Number', { isInteger: require('./_is-integer') });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_is-integer":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-integer.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.number.is-nan.js":[function(require,module,exports){
// 20.1.2.4 Number.isNaN(number)
var $export = require('./_export');

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.number.is-safe-integer.js":[function(require,module,exports){
// 20.1.2.5 Number.isSafeInteger(number)
var $export = require('./_export');
var isInteger = require('./_is-integer');
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_is-integer":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-integer.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.number.max-safe-integer.js":[function(require,module,exports){
// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = require('./_export');

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.number.min-safe-integer.js":[function(require,module,exports){
// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = require('./_export');

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.number.parse-float.js":[function(require,module,exports){
var $export = require('./_export');
var $parseFloat = require('./_parse-float');
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_parse-float":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_parse-float.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.number.parse-int.js":[function(require,module,exports){
var $export = require('./_export');
var $parseInt = require('./_parse-int');
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_parse-int":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_parse-int.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.number.to-fixed.js":[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toInteger = require('./_to-integer');
var aNumberValue = require('./_a-number-value');
var repeat = require('./_string-repeat');
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !require('./_fails')(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});

},{"./_a-number-value":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_a-number-value.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js","./_string-repeat":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-repeat.js","./_to-integer":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-integer.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.number.to-precision.js":[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $fails = require('./_fails');
var aNumberValue = require('./_a-number-value');
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});

},{"./_a-number-value":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_a-number-value.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.assign.js":[function(require,module,exports){
// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', { assign: require('./_object-assign') });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_object-assign":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-assign.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.create.js":[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: require('./_object-create') });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_object-create":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-create.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.define-properties.js":[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', { defineProperties: require('./_object-dps') });

},{"./_descriptors":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_descriptors.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_object-dps":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-dps.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.define-property.js":[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', { defineProperty: require('./_object-dp').f });

},{"./_descriptors":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_descriptors.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_object-dp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-dp.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.freeze.js":[function(require,module,exports){
// 19.1.2.5 Object.freeze(O)
var isObject = require('./_is-object');
var meta = require('./_meta').onFreeze;

require('./_object-sap')('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});

},{"./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js","./_meta":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_meta.js","./_object-sap":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-sap.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.get-own-property-descriptor.js":[function(require,module,exports){
// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = require('./_to-iobject');
var $getOwnPropertyDescriptor = require('./_object-gopd').f;

require('./_object-sap')('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

},{"./_object-gopd":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gopd.js","./_object-sap":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-sap.js","./_to-iobject":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-iobject.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.get-own-property-names.js":[function(require,module,exports){
// 19.1.2.7 Object.getOwnPropertyNames(O)
require('./_object-sap')('getOwnPropertyNames', function () {
  return require('./_object-gopn-ext').f;
});

},{"./_object-gopn-ext":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gopn-ext.js","./_object-sap":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-sap.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.get-prototype-of.js":[function(require,module,exports){
// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = require('./_to-object');
var $getPrototypeOf = require('./_object-gpo');

require('./_object-sap')('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});

},{"./_object-gpo":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gpo.js","./_object-sap":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-sap.js","./_to-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-object.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.is-extensible.js":[function(require,module,exports){
// 19.1.2.11 Object.isExtensible(O)
var isObject = require('./_is-object');

require('./_object-sap')('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});

},{"./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js","./_object-sap":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-sap.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.is-frozen.js":[function(require,module,exports){
// 19.1.2.12 Object.isFrozen(O)
var isObject = require('./_is-object');

require('./_object-sap')('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});

},{"./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js","./_object-sap":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-sap.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.is-sealed.js":[function(require,module,exports){
// 19.1.2.13 Object.isSealed(O)
var isObject = require('./_is-object');

require('./_object-sap')('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});

},{"./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js","./_object-sap":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-sap.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.is.js":[function(require,module,exports){
// 19.1.3.10 Object.is(value1, value2)
var $export = require('./_export');
$export($export.S, 'Object', { is: require('./_same-value') });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_same-value":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_same-value.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.keys.js":[function(require,module,exports){
// 19.1.2.14 Object.keys(O)
var toObject = require('./_to-object');
var $keys = require('./_object-keys');

require('./_object-sap')('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});

},{"./_object-keys":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-keys.js","./_object-sap":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-sap.js","./_to-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-object.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.prevent-extensions.js":[function(require,module,exports){
// 19.1.2.15 Object.preventExtensions(O)
var isObject = require('./_is-object');
var meta = require('./_meta').onFreeze;

require('./_object-sap')('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});

},{"./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js","./_meta":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_meta.js","./_object-sap":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-sap.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.seal.js":[function(require,module,exports){
// 19.1.2.17 Object.seal(O)
var isObject = require('./_is-object');
var meta = require('./_meta').onFreeze;

require('./_object-sap')('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});

},{"./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js","./_meta":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_meta.js","./_object-sap":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-sap.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.set-prototype-of.js":[function(require,module,exports){
// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require('./_export');
$export($export.S, 'Object', { setPrototypeOf: require('./_set-proto').set });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_set-proto":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-proto.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.to-string.js":[function(require,module,exports){
'use strict';
// 19.1.3.6 Object.prototype.toString()
var classof = require('./_classof');
var test = {};
test[require('./_wks')('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  require('./_redefine')(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}

},{"./_classof":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_classof.js","./_redefine":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_redefine.js","./_wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.parse-float.js":[function(require,module,exports){
var $export = require('./_export');
var $parseFloat = require('./_parse-float');
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_parse-float":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_parse-float.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.parse-int.js":[function(require,module,exports){
var $export = require('./_export');
var $parseInt = require('./_parse-int');
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_parse-int":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_parse-int.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.promise.js":[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var global = require('./_global');
var ctx = require('./_ctx');
var classof = require('./_classof');
var $export = require('./_export');
var isObject = require('./_is-object');
var aFunction = require('./_a-function');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var speciesConstructor = require('./_species-constructor');
var task = require('./_task').set;
var microtask = require('./_microtask')();
var newPromiseCapabilityModule = require('./_new-promise-capability');
var perform = require('./_perform');
var userAgent = require('./_user-agent');
var promiseResolve = require('./_promise-resolve');
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[require('./_wks')('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = require('./_redefine-all')($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
require('./_set-to-string-tag')($Promise, PROMISE);
require('./_set-species')(PROMISE);
Wrapper = require('./_core')[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && require('./_iter-detect')(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

},{"./_a-function":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_a-function.js","./_an-instance":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-instance.js","./_classof":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_classof.js","./_core":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_core.js","./_ctx":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_ctx.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_for-of":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_for-of.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js","./_iter-detect":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iter-detect.js","./_library":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_library.js","./_microtask":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_microtask.js","./_new-promise-capability":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_new-promise-capability.js","./_perform":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_perform.js","./_promise-resolve":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_promise-resolve.js","./_redefine-all":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_redefine-all.js","./_set-species":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-species.js","./_set-to-string-tag":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-to-string-tag.js","./_species-constructor":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_species-constructor.js","./_task":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_task.js","./_user-agent":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_user-agent.js","./_wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.apply.js":[function(require,module,exports){
// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = require('./_export');
var aFunction = require('./_a-function');
var anObject = require('./_an-object');
var rApply = (require('./_global').Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !require('./_fails')(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});

},{"./_a-function":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_a-function.js","./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.construct.js":[function(require,module,exports){
// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = require('./_export');
var create = require('./_object-create');
var aFunction = require('./_a-function');
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var fails = require('./_fails');
var bind = require('./_bind');
var rConstruct = (require('./_global').Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});

},{"./_a-function":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_a-function.js","./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_bind":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_bind.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js","./_object-create":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-create.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.define-property.js":[function(require,module,exports){
// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = require('./_object-dp');
var $export = require('./_export');
var anObject = require('./_an-object');
var toPrimitive = require('./_to-primitive');

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * require('./_fails')(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js","./_object-dp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-dp.js","./_to-primitive":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-primitive.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.delete-property.js":[function(require,module,exports){
// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = require('./_export');
var gOPD = require('./_object-gopd').f;
var anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_object-gopd":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gopd.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.enumerate.js":[function(require,module,exports){
'use strict';
// 26.1.5 Reflect.enumerate(target)
var $export = require('./_export');
var anObject = require('./_an-object');
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
require('./_iter-create')(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_iter-create":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iter-create.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.get-own-property-descriptor.js":[function(require,module,exports){
// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = require('./_object-gopd');
var $export = require('./_export');
var anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_object-gopd":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gopd.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.get-prototype-of.js":[function(require,module,exports){
// 26.1.8 Reflect.getPrototypeOf(target)
var $export = require('./_export');
var getProto = require('./_object-gpo');
var anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_object-gpo":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gpo.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.get.js":[function(require,module,exports){
// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = require('./_object-gopd');
var getPrototypeOf = require('./_object-gpo');
var has = require('./_has');
var $export = require('./_export');
var isObject = require('./_is-object');
var anObject = require('./_an-object');

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_has":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_has.js","./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js","./_object-gopd":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gopd.js","./_object-gpo":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gpo.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.has.js":[function(require,module,exports){
// 26.1.9 Reflect.has(target, propertyKey)
var $export = require('./_export');

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.is-extensible.js":[function(require,module,exports){
// 26.1.10 Reflect.isExtensible(target)
var $export = require('./_export');
var anObject = require('./_an-object');
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.own-keys.js":[function(require,module,exports){
// 26.1.11 Reflect.ownKeys(target)
var $export = require('./_export');

$export($export.S, 'Reflect', { ownKeys: require('./_own-keys') });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_own-keys":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_own-keys.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.prevent-extensions.js":[function(require,module,exports){
// 26.1.12 Reflect.preventExtensions(target)
var $export = require('./_export');
var anObject = require('./_an-object');
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.set-prototype-of.js":[function(require,module,exports){
// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = require('./_export');
var setProto = require('./_set-proto');

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_set-proto":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-proto.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.set.js":[function(require,module,exports){
// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = require('./_object-dp');
var gOPD = require('./_object-gopd');
var getPrototypeOf = require('./_object-gpo');
var has = require('./_has');
var $export = require('./_export');
var createDesc = require('./_property-desc');
var anObject = require('./_an-object');
var isObject = require('./_is-object');

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_has":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_has.js","./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js","./_object-dp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-dp.js","./_object-gopd":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gopd.js","./_object-gpo":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gpo.js","./_property-desc":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_property-desc.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.regexp.constructor.js":[function(require,module,exports){
var global = require('./_global');
var inheritIfRequired = require('./_inherit-if-required');
var dP = require('./_object-dp').f;
var gOPN = require('./_object-gopn').f;
var isRegExp = require('./_is-regexp');
var $flags = require('./_flags');
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (require('./_descriptors') && (!CORRECT_NEW || require('./_fails')(function () {
  re2[require('./_wks')('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  require('./_redefine')(global, 'RegExp', $RegExp);
}

require('./_set-species')('RegExp');

},{"./_descriptors":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_descriptors.js","./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js","./_flags":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_flags.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_inherit-if-required":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_inherit-if-required.js","./_is-regexp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-regexp.js","./_object-dp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-dp.js","./_object-gopn":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gopn.js","./_redefine":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_redefine.js","./_set-species":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-species.js","./_wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.regexp.flags.js":[function(require,module,exports){
// 21.2.5.3 get RegExp.prototype.flags()
if (require('./_descriptors') && /./g.flags != 'g') require('./_object-dp').f(RegExp.prototype, 'flags', {
  configurable: true,
  get: require('./_flags')
});

},{"./_descriptors":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_descriptors.js","./_flags":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_flags.js","./_object-dp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-dp.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.regexp.match.js":[function(require,module,exports){
// @@match logic
require('./_fix-re-wks')('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});

},{"./_fix-re-wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fix-re-wks.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.regexp.replace.js":[function(require,module,exports){
// @@replace logic
require('./_fix-re-wks')('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});

},{"./_fix-re-wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fix-re-wks.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.regexp.search.js":[function(require,module,exports){
// @@search logic
require('./_fix-re-wks')('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});

},{"./_fix-re-wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fix-re-wks.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.regexp.split.js":[function(require,module,exports){
// @@split logic
require('./_fix-re-wks')('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = require('./_is-regexp');
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});

},{"./_fix-re-wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fix-re-wks.js","./_is-regexp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-regexp.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.regexp.to-string.js":[function(require,module,exports){
'use strict';
require('./es6.regexp.flags');
var anObject = require('./_an-object');
var $flags = require('./_flags');
var DESCRIPTORS = require('./_descriptors');
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  require('./_redefine')(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (require('./_fails')(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_descriptors":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_descriptors.js","./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js","./_flags":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_flags.js","./_redefine":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_redefine.js","./es6.regexp.flags":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.regexp.flags.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.set.js":[function(require,module,exports){
'use strict';
var strong = require('./_collection-strong');
var validate = require('./_validate-collection');
var SET = 'Set';

// 23.2 Set Objects
module.exports = require('./_collection')(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);

},{"./_collection":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_collection.js","./_collection-strong":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_collection-strong.js","./_validate-collection":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_validate-collection.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.anchor.js":[function(require,module,exports){
'use strict';
// B.2.3.2 String.prototype.anchor(name)
require('./_string-html')('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});

},{"./_string-html":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-html.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.big.js":[function(require,module,exports){
'use strict';
// B.2.3.3 String.prototype.big()
require('./_string-html')('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});

},{"./_string-html":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-html.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.blink.js":[function(require,module,exports){
'use strict';
// B.2.3.4 String.prototype.blink()
require('./_string-html')('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});

},{"./_string-html":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-html.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.bold.js":[function(require,module,exports){
'use strict';
// B.2.3.5 String.prototype.bold()
require('./_string-html')('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});

},{"./_string-html":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-html.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.code-point-at.js":[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $at = require('./_string-at')(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_string-at":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-at.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.ends-with.js":[function(require,module,exports){
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
'use strict';
var $export = require('./_export');
var toLength = require('./_to-length');
var context = require('./_string-context');
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * require('./_fails-is-regexp')(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_fails-is-regexp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails-is-regexp.js","./_string-context":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-context.js","./_to-length":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-length.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.fixed.js":[function(require,module,exports){
'use strict';
// B.2.3.6 String.prototype.fixed()
require('./_string-html')('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});

},{"./_string-html":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-html.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.fontcolor.js":[function(require,module,exports){
'use strict';
// B.2.3.7 String.prototype.fontcolor(color)
require('./_string-html')('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});

},{"./_string-html":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-html.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.fontsize.js":[function(require,module,exports){
'use strict';
// B.2.3.8 String.prototype.fontsize(size)
require('./_string-html')('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});

},{"./_string-html":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-html.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.from-code-point.js":[function(require,module,exports){
var $export = require('./_export');
var toAbsoluteIndex = require('./_to-absolute-index');
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_to-absolute-index":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-absolute-index.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.includes.js":[function(require,module,exports){
// 21.1.3.7 String.prototype.includes(searchString, position = 0)
'use strict';
var $export = require('./_export');
var context = require('./_string-context');
var INCLUDES = 'includes';

$export($export.P + $export.F * require('./_fails-is-regexp')(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_fails-is-regexp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails-is-regexp.js","./_string-context":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-context.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.italics.js":[function(require,module,exports){
'use strict';
// B.2.3.9 String.prototype.italics()
require('./_string-html')('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});

},{"./_string-html":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-html.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.iterator.js":[function(require,module,exports){
'use strict';
var $at = require('./_string-at')(true);

// 21.1.3.27 String.prototype[@@iterator]()
require('./_iter-define')(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

},{"./_iter-define":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iter-define.js","./_string-at":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-at.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.link.js":[function(require,module,exports){
'use strict';
// B.2.3.10 String.prototype.link(url)
require('./_string-html')('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});

},{"./_string-html":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-html.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.raw.js":[function(require,module,exports){
var $export = require('./_export');
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_to-iobject":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-iobject.js","./_to-length":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-length.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.repeat.js":[function(require,module,exports){
var $export = require('./_export');

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: require('./_string-repeat')
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_string-repeat":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-repeat.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.small.js":[function(require,module,exports){
'use strict';
// B.2.3.11 String.prototype.small()
require('./_string-html')('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});

},{"./_string-html":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-html.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.starts-with.js":[function(require,module,exports){
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
'use strict';
var $export = require('./_export');
var toLength = require('./_to-length');
var context = require('./_string-context');
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * require('./_fails-is-regexp')(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_fails-is-regexp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails-is-regexp.js","./_string-context":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-context.js","./_to-length":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-length.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.strike.js":[function(require,module,exports){
'use strict';
// B.2.3.12 String.prototype.strike()
require('./_string-html')('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});

},{"./_string-html":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-html.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.sub.js":[function(require,module,exports){
'use strict';
// B.2.3.13 String.prototype.sub()
require('./_string-html')('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});

},{"./_string-html":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-html.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.sup.js":[function(require,module,exports){
'use strict';
// B.2.3.14 String.prototype.sup()
require('./_string-html')('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});

},{"./_string-html":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-html.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.trim.js":[function(require,module,exports){
'use strict';
// 21.1.3.25 String.prototype.trim()
require('./_string-trim')('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});

},{"./_string-trim":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-trim.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.symbol.js":[function(require,module,exports){
'use strict';
// ECMAScript 6 symbols shim
var global = require('./_global');
var has = require('./_has');
var DESCRIPTORS = require('./_descriptors');
var $export = require('./_export');
var redefine = require('./_redefine');
var META = require('./_meta').KEY;
var $fails = require('./_fails');
var shared = require('./_shared');
var setToStringTag = require('./_set-to-string-tag');
var uid = require('./_uid');
var wks = require('./_wks');
var wksExt = require('./_wks-ext');
var wksDefine = require('./_wks-define');
var enumKeys = require('./_enum-keys');
var isArray = require('./_is-array');
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var createDesc = require('./_property-desc');
var _create = require('./_object-create');
var gOPNExt = require('./_object-gopn-ext');
var $GOPD = require('./_object-gopd');
var $DP = require('./_object-dp');
var $keys = require('./_object-keys');
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  require('./_object-gopn').f = gOPNExt.f = $getOwnPropertyNames;
  require('./_object-pie').f = $propertyIsEnumerable;
  require('./_object-gops').f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !require('./_library')) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require('./_hide')($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_descriptors":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_descriptors.js","./_enum-keys":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_enum-keys.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_has":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_has.js","./_hide":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_hide.js","./_is-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-array.js","./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js","./_library":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_library.js","./_meta":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_meta.js","./_object-create":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-create.js","./_object-dp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-dp.js","./_object-gopd":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gopd.js","./_object-gopn":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gopn.js","./_object-gopn-ext":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gopn-ext.js","./_object-gops":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gops.js","./_object-keys":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-keys.js","./_object-pie":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-pie.js","./_property-desc":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_property-desc.js","./_redefine":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_redefine.js","./_set-to-string-tag":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-to-string-tag.js","./_shared":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_shared.js","./_to-iobject":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-iobject.js","./_to-primitive":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-primitive.js","./_uid":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_uid.js","./_wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js","./_wks-define":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks-define.js","./_wks-ext":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks-ext.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.typed.array-buffer.js":[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $typed = require('./_typed');
var buffer = require('./_typed-buffer');
var anObject = require('./_an-object');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');
var isObject = require('./_is-object');
var ArrayBuffer = require('./_global').ArrayBuffer;
var speciesConstructor = require('./_species-constructor');
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * require('./_fails')(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

require('./_set-species')(ARRAY_BUFFER);

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js","./_set-species":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-species.js","./_species-constructor":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_species-constructor.js","./_to-absolute-index":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-absolute-index.js","./_to-length":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-length.js","./_typed":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_typed.js","./_typed-buffer":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_typed-buffer.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.typed.data-view.js":[function(require,module,exports){
var $export = require('./_export');
$export($export.G + $export.W + $export.F * !require('./_typed').ABV, {
  DataView: require('./_typed-buffer').DataView
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_typed":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_typed.js","./_typed-buffer":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_typed-buffer.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.typed.float32-array.js":[function(require,module,exports){
require('./_typed-array')('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_typed-array.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.typed.float64-array.js":[function(require,module,exports){
require('./_typed-array')('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_typed-array.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.typed.int16-array.js":[function(require,module,exports){
require('./_typed-array')('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_typed-array.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.typed.int32-array.js":[function(require,module,exports){
require('./_typed-array')('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_typed-array.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.typed.int8-array.js":[function(require,module,exports){
require('./_typed-array')('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_typed-array.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.typed.uint16-array.js":[function(require,module,exports){
require('./_typed-array')('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_typed-array.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.typed.uint32-array.js":[function(require,module,exports){
require('./_typed-array')('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_typed-array.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.typed.uint8-array.js":[function(require,module,exports){
require('./_typed-array')('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_typed-array.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.typed.uint8-clamped-array.js":[function(require,module,exports){
require('./_typed-array')('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);

},{"./_typed-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_typed-array.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.weak-map.js":[function(require,module,exports){
'use strict';
var each = require('./_array-methods')(0);
var redefine = require('./_redefine');
var meta = require('./_meta');
var assign = require('./_object-assign');
var weak = require('./_collection-weak');
var isObject = require('./_is-object');
var fails = require('./_fails');
var validate = require('./_validate-collection');
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = require('./_collection')(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}

},{"./_array-methods":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-methods.js","./_collection":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_collection.js","./_collection-weak":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_collection-weak.js","./_fails":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_fails.js","./_is-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-object.js","./_meta":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_meta.js","./_object-assign":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-assign.js","./_redefine":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_redefine.js","./_validate-collection":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_validate-collection.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.weak-set.js":[function(require,module,exports){
'use strict';
var weak = require('./_collection-weak');
var validate = require('./_validate-collection');
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
require('./_collection')(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);

},{"./_collection":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_collection.js","./_collection-weak":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_collection-weak.js","./_validate-collection":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_validate-collection.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.array.flat-map.js":[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = require('./_export');
var flattenIntoArray = require('./_flatten-into-array');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var aFunction = require('./_a-function');
var arraySpeciesCreate = require('./_array-species-create');

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

require('./_add-to-unscopables')('flatMap');

},{"./_a-function":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_a-function.js","./_add-to-unscopables":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_add-to-unscopables.js","./_array-species-create":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-species-create.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_flatten-into-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_flatten-into-array.js","./_to-length":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-length.js","./_to-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-object.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.array.flatten.js":[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = require('./_export');
var flattenIntoArray = require('./_flatten-into-array');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var toInteger = require('./_to-integer');
var arraySpeciesCreate = require('./_array-species-create');

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

require('./_add-to-unscopables')('flatten');

},{"./_add-to-unscopables":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_add-to-unscopables.js","./_array-species-create":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-species-create.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_flatten-into-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_flatten-into-array.js","./_to-integer":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-integer.js","./_to-length":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-length.js","./_to-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-object.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.array.includes.js":[function(require,module,exports){
'use strict';
// https://github.com/tc39/Array.prototype.includes
var $export = require('./_export');
var $includes = require('./_array-includes')(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

require('./_add-to-unscopables')('includes');

},{"./_add-to-unscopables":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_add-to-unscopables.js","./_array-includes":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-includes.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.asap.js":[function(require,module,exports){
// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = require('./_export');
var microtask = require('./_microtask')();
var process = require('./_global').process;
var isNode = require('./_cof')(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});

},{"./_cof":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_cof.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_microtask":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_microtask.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.error.is-error.js":[function(require,module,exports){
// https://github.com/ljharb/proposal-is-error
var $export = require('./_export');
var cof = require('./_cof');

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});

},{"./_cof":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_cof.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.global.js":[function(require,module,exports){
// https://github.com/tc39/proposal-global
var $export = require('./_export');

$export($export.G, { global: require('./_global') });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.map.from.js":[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
require('./_set-collection-from')('Map');

},{"./_set-collection-from":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-collection-from.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.map.of.js":[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
require('./_set-collection-of')('Map');

},{"./_set-collection-of":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-collection-of.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.map.to-json.js":[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = require('./_export');

$export($export.P + $export.R, 'Map', { toJSON: require('./_collection-to-json')('Map') });

},{"./_collection-to-json":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_collection-to-json.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.math.clamp.js":[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.math.deg-per-rad.js":[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.math.degrees.js":[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.math.fscale.js":[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');
var scale = require('./_math-scale');
var fround = require('./_math-fround');

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_math-fround":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_math-fround.js","./_math-scale":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_math-scale.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.math.iaddh.js":[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.math.imulh.js":[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.math.isubh.js":[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.math.rad-per-deg.js":[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.math.radians.js":[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.math.scale.js":[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { scale: require('./_math-scale') });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_math-scale":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_math-scale.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.math.signbit.js":[function(require,module,exports){
// http://jfbastien.github.io/papers/Math.signbit.html
var $export = require('./_export');

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.math.umulh.js":[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.object.define-getter.js":[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var aFunction = require('./_a-function');
var $defineProperty = require('./_object-dp');

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});

},{"./_a-function":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_a-function.js","./_descriptors":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_descriptors.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_object-dp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-dp.js","./_object-forced-pam":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-forced-pam.js","./_to-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-object.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.object.define-setter.js":[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var aFunction = require('./_a-function');
var $defineProperty = require('./_object-dp');

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});

},{"./_a-function":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_a-function.js","./_descriptors":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_descriptors.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_object-dp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-dp.js","./_object-forced-pam":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-forced-pam.js","./_to-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-object.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.object.entries.js":[function(require,module,exports){
// https://github.com/tc39/proposal-object-values-entries
var $export = require('./_export');
var $entries = require('./_object-to-array')(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_object-to-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-to-array.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.object.get-own-property-descriptors.js":[function(require,module,exports){
// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = require('./_export');
var ownKeys = require('./_own-keys');
var toIObject = require('./_to-iobject');
var gOPD = require('./_object-gopd');
var createProperty = require('./_create-property');

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});

},{"./_create-property":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_create-property.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_object-gopd":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gopd.js","./_own-keys":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_own-keys.js","./_to-iobject":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-iobject.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.object.lookup-getter.js":[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var toPrimitive = require('./_to-primitive');
var getPrototypeOf = require('./_object-gpo');
var getOwnPropertyDescriptor = require('./_object-gopd').f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});

},{"./_descriptors":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_descriptors.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_object-forced-pam":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-forced-pam.js","./_object-gopd":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gopd.js","./_object-gpo":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gpo.js","./_to-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-object.js","./_to-primitive":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-primitive.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.object.lookup-setter.js":[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var toPrimitive = require('./_to-primitive');
var getPrototypeOf = require('./_object-gpo');
var getOwnPropertyDescriptor = require('./_object-gopd').f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});

},{"./_descriptors":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_descriptors.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_object-forced-pam":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-forced-pam.js","./_object-gopd":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gopd.js","./_object-gpo":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gpo.js","./_to-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-object.js","./_to-primitive":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-primitive.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.object.values.js":[function(require,module,exports){
// https://github.com/tc39/proposal-object-values-entries
var $export = require('./_export');
var $values = require('./_object-to-array')(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_object-to-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-to-array.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.observable.js":[function(require,module,exports){
'use strict';
// https://github.com/zenparsing/es-observable
var $export = require('./_export');
var global = require('./_global');
var core = require('./_core');
var microtask = require('./_microtask')();
var OBSERVABLE = require('./_wks')('observable');
var aFunction = require('./_a-function');
var anObject = require('./_an-object');
var anInstance = require('./_an-instance');
var redefineAll = require('./_redefine-all');
var hide = require('./_hide');
var forOf = require('./_for-of');
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

require('./_set-species')('Observable');

},{"./_a-function":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_a-function.js","./_an-instance":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-instance.js","./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_core":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_core.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_for-of":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_for-of.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_hide":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_hide.js","./_microtask":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_microtask.js","./_redefine-all":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_redefine-all.js","./_set-species":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-species.js","./_wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.promise.finally.js":[function(require,module,exports){
// https://github.com/tc39/proposal-promise-finally
'use strict';
var $export = require('./_export');
var core = require('./_core');
var global = require('./_global');
var speciesConstructor = require('./_species-constructor');
var promiseResolve = require('./_promise-resolve');

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });

},{"./_core":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_core.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_promise-resolve":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_promise-resolve.js","./_species-constructor":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_species-constructor.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.promise.try.js":[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-promise-try
var $export = require('./_export');
var newPromiseCapability = require('./_new-promise-capability');
var perform = require('./_perform');

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_new-promise-capability":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_new-promise-capability.js","./_perform":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_perform.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.reflect.define-metadata.js":[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_metadata":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_metadata.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.reflect.delete-metadata.js":[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_metadata":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_metadata.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.reflect.get-metadata-keys.js":[function(require,module,exports){
var Set = require('./es6.set');
var from = require('./_array-from-iterable');
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var getPrototypeOf = require('./_object-gpo');
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_array-from-iterable":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_array-from-iterable.js","./_metadata":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_metadata.js","./_object-gpo":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gpo.js","./es6.set":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.set.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.reflect.get-metadata.js":[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var getPrototypeOf = require('./_object-gpo');
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_metadata":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_metadata.js","./_object-gpo":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gpo.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.reflect.get-own-metadata-keys.js":[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_metadata":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_metadata.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.reflect.get-own-metadata.js":[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_metadata":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_metadata.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.reflect.has-metadata.js":[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var getPrototypeOf = require('./_object-gpo');
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_metadata":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_metadata.js","./_object-gpo":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-gpo.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.reflect.has-own-metadata.js":[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_metadata":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_metadata.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.reflect.metadata.js":[function(require,module,exports){
var $metadata = require('./_metadata');
var anObject = require('./_an-object');
var aFunction = require('./_a-function');
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });

},{"./_a-function":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_a-function.js","./_an-object":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_an-object.js","./_metadata":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_metadata.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.set.from.js":[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
require('./_set-collection-from')('Set');

},{"./_set-collection-from":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-collection-from.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.set.of.js":[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
require('./_set-collection-of')('Set');

},{"./_set-collection-of":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-collection-of.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.set.to-json.js":[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = require('./_export');

$export($export.P + $export.R, 'Set', { toJSON: require('./_collection-to-json')('Set') });

},{"./_collection-to-json":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_collection-to-json.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.string.at.js":[function(require,module,exports){
'use strict';
// https://github.com/mathiasbynens/String.prototype.at
var $export = require('./_export');
var $at = require('./_string-at')(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_string-at":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-at.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.string.match-all.js":[function(require,module,exports){
'use strict';
// https://tc39.github.io/String.prototype.matchAll/
var $export = require('./_export');
var defined = require('./_defined');
var toLength = require('./_to-length');
var isRegExp = require('./_is-regexp');
var getFlags = require('./_flags');
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

require('./_iter-create')($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});

},{"./_defined":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_defined.js","./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_flags":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_flags.js","./_is-regexp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_is-regexp.js","./_iter-create":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iter-create.js","./_to-length":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_to-length.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.string.pad-end.js":[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = require('./_export');
var $pad = require('./_string-pad');
var userAgent = require('./_user-agent');

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_string-pad":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-pad.js","./_user-agent":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_user-agent.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.string.pad-start.js":[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = require('./_export');
var $pad = require('./_string-pad');
var userAgent = require('./_user-agent');

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_string-pad":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-pad.js","./_user-agent":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_user-agent.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.string.trim-left.js":[function(require,module,exports){
'use strict';
// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
require('./_string-trim')('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');

},{"./_string-trim":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-trim.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.string.trim-right.js":[function(require,module,exports){
'use strict';
// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
require('./_string-trim')('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');

},{"./_string-trim":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_string-trim.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.symbol.async-iterator.js":[function(require,module,exports){
require('./_wks-define')('asyncIterator');

},{"./_wks-define":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks-define.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.symbol.observable.js":[function(require,module,exports){
require('./_wks-define')('observable');

},{"./_wks-define":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks-define.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.system.global.js":[function(require,module,exports){
// https://github.com/tc39/proposal-global
var $export = require('./_export');

$export($export.S, 'System', { global: require('./_global') });

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.weak-map.from.js":[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
require('./_set-collection-from')('WeakMap');

},{"./_set-collection-from":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-collection-from.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.weak-map.of.js":[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
require('./_set-collection-of')('WeakMap');

},{"./_set-collection-of":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-collection-of.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.weak-set.from.js":[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
require('./_set-collection-from')('WeakSet');

},{"./_set-collection-from":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-collection-from.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.weak-set.of.js":[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
require('./_set-collection-of')('WeakSet');

},{"./_set-collection-of":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_set-collection-of.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\web.dom.iterable.js":[function(require,module,exports){
var $iterators = require('./es6.array.iterator');
var getKeys = require('./_object-keys');
var redefine = require('./_redefine');
var global = require('./_global');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var wks = require('./_wks');
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}

},{"./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_hide":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_hide.js","./_iterators":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_iterators.js","./_object-keys":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_object-keys.js","./_redefine":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_redefine.js","./_wks":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_wks.js","./es6.array.iterator":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.iterator.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\web.immediate.js":[function(require,module,exports){
var $export = require('./_export');
var $task = require('./_task');
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_task":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_task.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\modules\\web.timers.js":[function(require,module,exports){
// ie9- setTimeout & setInterval additional parameters fix
var global = require('./_global');
var $export = require('./_export');
var userAgent = require('./_user-agent');
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});

},{"./_export":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_export.js","./_global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_global.js","./_user-agent":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_user-agent.js"}],"C:\\projects\\lightning\\node_modules\\core-js\\shim.js":[function(require,module,exports){
require('./modules/es6.symbol');
require('./modules/es6.object.create');
require('./modules/es6.object.define-property');
require('./modules/es6.object.define-properties');
require('./modules/es6.object.get-own-property-descriptor');
require('./modules/es6.object.get-prototype-of');
require('./modules/es6.object.keys');
require('./modules/es6.object.get-own-property-names');
require('./modules/es6.object.freeze');
require('./modules/es6.object.seal');
require('./modules/es6.object.prevent-extensions');
require('./modules/es6.object.is-frozen');
require('./modules/es6.object.is-sealed');
require('./modules/es6.object.is-extensible');
require('./modules/es6.object.assign');
require('./modules/es6.object.is');
require('./modules/es6.object.set-prototype-of');
require('./modules/es6.object.to-string');
require('./modules/es6.function.bind');
require('./modules/es6.function.name');
require('./modules/es6.function.has-instance');
require('./modules/es6.parse-int');
require('./modules/es6.parse-float');
require('./modules/es6.number.constructor');
require('./modules/es6.number.to-fixed');
require('./modules/es6.number.to-precision');
require('./modules/es6.number.epsilon');
require('./modules/es6.number.is-finite');
require('./modules/es6.number.is-integer');
require('./modules/es6.number.is-nan');
require('./modules/es6.number.is-safe-integer');
require('./modules/es6.number.max-safe-integer');
require('./modules/es6.number.min-safe-integer');
require('./modules/es6.number.parse-float');
require('./modules/es6.number.parse-int');
require('./modules/es6.math.acosh');
require('./modules/es6.math.asinh');
require('./modules/es6.math.atanh');
require('./modules/es6.math.cbrt');
require('./modules/es6.math.clz32');
require('./modules/es6.math.cosh');
require('./modules/es6.math.expm1');
require('./modules/es6.math.fround');
require('./modules/es6.math.hypot');
require('./modules/es6.math.imul');
require('./modules/es6.math.log10');
require('./modules/es6.math.log1p');
require('./modules/es6.math.log2');
require('./modules/es6.math.sign');
require('./modules/es6.math.sinh');
require('./modules/es6.math.tanh');
require('./modules/es6.math.trunc');
require('./modules/es6.string.from-code-point');
require('./modules/es6.string.raw');
require('./modules/es6.string.trim');
require('./modules/es6.string.iterator');
require('./modules/es6.string.code-point-at');
require('./modules/es6.string.ends-with');
require('./modules/es6.string.includes');
require('./modules/es6.string.repeat');
require('./modules/es6.string.starts-with');
require('./modules/es6.string.anchor');
require('./modules/es6.string.big');
require('./modules/es6.string.blink');
require('./modules/es6.string.bold');
require('./modules/es6.string.fixed');
require('./modules/es6.string.fontcolor');
require('./modules/es6.string.fontsize');
require('./modules/es6.string.italics');
require('./modules/es6.string.link');
require('./modules/es6.string.small');
require('./modules/es6.string.strike');
require('./modules/es6.string.sub');
require('./modules/es6.string.sup');
require('./modules/es6.date.now');
require('./modules/es6.date.to-json');
require('./modules/es6.date.to-iso-string');
require('./modules/es6.date.to-string');
require('./modules/es6.date.to-primitive');
require('./modules/es6.array.is-array');
require('./modules/es6.array.from');
require('./modules/es6.array.of');
require('./modules/es6.array.join');
require('./modules/es6.array.slice');
require('./modules/es6.array.sort');
require('./modules/es6.array.for-each');
require('./modules/es6.array.map');
require('./modules/es6.array.filter');
require('./modules/es6.array.some');
require('./modules/es6.array.every');
require('./modules/es6.array.reduce');
require('./modules/es6.array.reduce-right');
require('./modules/es6.array.index-of');
require('./modules/es6.array.last-index-of');
require('./modules/es6.array.copy-within');
require('./modules/es6.array.fill');
require('./modules/es6.array.find');
require('./modules/es6.array.find-index');
require('./modules/es6.array.species');
require('./modules/es6.array.iterator');
require('./modules/es6.regexp.constructor');
require('./modules/es6.regexp.to-string');
require('./modules/es6.regexp.flags');
require('./modules/es6.regexp.match');
require('./modules/es6.regexp.replace');
require('./modules/es6.regexp.search');
require('./modules/es6.regexp.split');
require('./modules/es6.promise');
require('./modules/es6.map');
require('./modules/es6.set');
require('./modules/es6.weak-map');
require('./modules/es6.weak-set');
require('./modules/es6.typed.array-buffer');
require('./modules/es6.typed.data-view');
require('./modules/es6.typed.int8-array');
require('./modules/es6.typed.uint8-array');
require('./modules/es6.typed.uint8-clamped-array');
require('./modules/es6.typed.int16-array');
require('./modules/es6.typed.uint16-array');
require('./modules/es6.typed.int32-array');
require('./modules/es6.typed.uint32-array');
require('./modules/es6.typed.float32-array');
require('./modules/es6.typed.float64-array');
require('./modules/es6.reflect.apply');
require('./modules/es6.reflect.construct');
require('./modules/es6.reflect.define-property');
require('./modules/es6.reflect.delete-property');
require('./modules/es6.reflect.enumerate');
require('./modules/es6.reflect.get');
require('./modules/es6.reflect.get-own-property-descriptor');
require('./modules/es6.reflect.get-prototype-of');
require('./modules/es6.reflect.has');
require('./modules/es6.reflect.is-extensible');
require('./modules/es6.reflect.own-keys');
require('./modules/es6.reflect.prevent-extensions');
require('./modules/es6.reflect.set');
require('./modules/es6.reflect.set-prototype-of');
require('./modules/es7.array.includes');
require('./modules/es7.array.flat-map');
require('./modules/es7.array.flatten');
require('./modules/es7.string.at');
require('./modules/es7.string.pad-start');
require('./modules/es7.string.pad-end');
require('./modules/es7.string.trim-left');
require('./modules/es7.string.trim-right');
require('./modules/es7.string.match-all');
require('./modules/es7.symbol.async-iterator');
require('./modules/es7.symbol.observable');
require('./modules/es7.object.get-own-property-descriptors');
require('./modules/es7.object.values');
require('./modules/es7.object.entries');
require('./modules/es7.object.define-getter');
require('./modules/es7.object.define-setter');
require('./modules/es7.object.lookup-getter');
require('./modules/es7.object.lookup-setter');
require('./modules/es7.map.to-json');
require('./modules/es7.set.to-json');
require('./modules/es7.map.of');
require('./modules/es7.set.of');
require('./modules/es7.weak-map.of');
require('./modules/es7.weak-set.of');
require('./modules/es7.map.from');
require('./modules/es7.set.from');
require('./modules/es7.weak-map.from');
require('./modules/es7.weak-set.from');
require('./modules/es7.global');
require('./modules/es7.system.global');
require('./modules/es7.error.is-error');
require('./modules/es7.math.clamp');
require('./modules/es7.math.deg-per-rad');
require('./modules/es7.math.degrees');
require('./modules/es7.math.fscale');
require('./modules/es7.math.iaddh');
require('./modules/es7.math.isubh');
require('./modules/es7.math.imulh');
require('./modules/es7.math.rad-per-deg');
require('./modules/es7.math.radians');
require('./modules/es7.math.scale');
require('./modules/es7.math.umulh');
require('./modules/es7.math.signbit');
require('./modules/es7.promise.finally');
require('./modules/es7.promise.try');
require('./modules/es7.reflect.define-metadata');
require('./modules/es7.reflect.delete-metadata');
require('./modules/es7.reflect.get-metadata');
require('./modules/es7.reflect.get-metadata-keys');
require('./modules/es7.reflect.get-own-metadata');
require('./modules/es7.reflect.get-own-metadata-keys');
require('./modules/es7.reflect.has-metadata');
require('./modules/es7.reflect.has-own-metadata');
require('./modules/es7.reflect.metadata');
require('./modules/es7.asap');
require('./modules/es7.observable');
require('./modules/web.timers');
require('./modules/web.immediate');
require('./modules/web.dom.iterable');
module.exports = require('./modules/_core');

},{"./modules/_core":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\_core.js","./modules/es6.array.copy-within":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.copy-within.js","./modules/es6.array.every":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.every.js","./modules/es6.array.fill":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.fill.js","./modules/es6.array.filter":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.filter.js","./modules/es6.array.find":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.find.js","./modules/es6.array.find-index":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.find-index.js","./modules/es6.array.for-each":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.for-each.js","./modules/es6.array.from":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.from.js","./modules/es6.array.index-of":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.index-of.js","./modules/es6.array.is-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.is-array.js","./modules/es6.array.iterator":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.iterator.js","./modules/es6.array.join":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.join.js","./modules/es6.array.last-index-of":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.last-index-of.js","./modules/es6.array.map":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.map.js","./modules/es6.array.of":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.of.js","./modules/es6.array.reduce":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.reduce.js","./modules/es6.array.reduce-right":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.reduce-right.js","./modules/es6.array.slice":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.slice.js","./modules/es6.array.some":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.some.js","./modules/es6.array.sort":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.sort.js","./modules/es6.array.species":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.array.species.js","./modules/es6.date.now":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.date.now.js","./modules/es6.date.to-iso-string":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.date.to-iso-string.js","./modules/es6.date.to-json":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.date.to-json.js","./modules/es6.date.to-primitive":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.date.to-primitive.js","./modules/es6.date.to-string":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.date.to-string.js","./modules/es6.function.bind":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.function.bind.js","./modules/es6.function.has-instance":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.function.has-instance.js","./modules/es6.function.name":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.function.name.js","./modules/es6.map":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.map.js","./modules/es6.math.acosh":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.acosh.js","./modules/es6.math.asinh":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.asinh.js","./modules/es6.math.atanh":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.atanh.js","./modules/es6.math.cbrt":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.cbrt.js","./modules/es6.math.clz32":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.clz32.js","./modules/es6.math.cosh":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.cosh.js","./modules/es6.math.expm1":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.expm1.js","./modules/es6.math.fround":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.fround.js","./modules/es6.math.hypot":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.hypot.js","./modules/es6.math.imul":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.imul.js","./modules/es6.math.log10":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.log10.js","./modules/es6.math.log1p":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.log1p.js","./modules/es6.math.log2":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.log2.js","./modules/es6.math.sign":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.sign.js","./modules/es6.math.sinh":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.sinh.js","./modules/es6.math.tanh":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.tanh.js","./modules/es6.math.trunc":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.math.trunc.js","./modules/es6.number.constructor":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.number.constructor.js","./modules/es6.number.epsilon":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.number.epsilon.js","./modules/es6.number.is-finite":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.number.is-finite.js","./modules/es6.number.is-integer":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.number.is-integer.js","./modules/es6.number.is-nan":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.number.is-nan.js","./modules/es6.number.is-safe-integer":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.number.is-safe-integer.js","./modules/es6.number.max-safe-integer":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.number.max-safe-integer.js","./modules/es6.number.min-safe-integer":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.number.min-safe-integer.js","./modules/es6.number.parse-float":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.number.parse-float.js","./modules/es6.number.parse-int":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.number.parse-int.js","./modules/es6.number.to-fixed":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.number.to-fixed.js","./modules/es6.number.to-precision":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.number.to-precision.js","./modules/es6.object.assign":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.assign.js","./modules/es6.object.create":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.create.js","./modules/es6.object.define-properties":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.define-properties.js","./modules/es6.object.define-property":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.define-property.js","./modules/es6.object.freeze":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.freeze.js","./modules/es6.object.get-own-property-descriptor":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.get-own-property-descriptor.js","./modules/es6.object.get-own-property-names":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.get-own-property-names.js","./modules/es6.object.get-prototype-of":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.get-prototype-of.js","./modules/es6.object.is":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.is.js","./modules/es6.object.is-extensible":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.is-extensible.js","./modules/es6.object.is-frozen":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.is-frozen.js","./modules/es6.object.is-sealed":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.is-sealed.js","./modules/es6.object.keys":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.keys.js","./modules/es6.object.prevent-extensions":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.prevent-extensions.js","./modules/es6.object.seal":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.seal.js","./modules/es6.object.set-prototype-of":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.set-prototype-of.js","./modules/es6.object.to-string":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.object.to-string.js","./modules/es6.parse-float":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.parse-float.js","./modules/es6.parse-int":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.parse-int.js","./modules/es6.promise":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.promise.js","./modules/es6.reflect.apply":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.apply.js","./modules/es6.reflect.construct":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.construct.js","./modules/es6.reflect.define-property":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.define-property.js","./modules/es6.reflect.delete-property":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.delete-property.js","./modules/es6.reflect.enumerate":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.enumerate.js","./modules/es6.reflect.get":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.get.js","./modules/es6.reflect.get-own-property-descriptor":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.get-own-property-descriptor.js","./modules/es6.reflect.get-prototype-of":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.get-prototype-of.js","./modules/es6.reflect.has":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.has.js","./modules/es6.reflect.is-extensible":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.is-extensible.js","./modules/es6.reflect.own-keys":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.own-keys.js","./modules/es6.reflect.prevent-extensions":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.prevent-extensions.js","./modules/es6.reflect.set":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.set.js","./modules/es6.reflect.set-prototype-of":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.reflect.set-prototype-of.js","./modules/es6.regexp.constructor":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.regexp.constructor.js","./modules/es6.regexp.flags":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.regexp.flags.js","./modules/es6.regexp.match":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.regexp.match.js","./modules/es6.regexp.replace":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.regexp.replace.js","./modules/es6.regexp.search":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.regexp.search.js","./modules/es6.regexp.split":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.regexp.split.js","./modules/es6.regexp.to-string":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.regexp.to-string.js","./modules/es6.set":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.set.js","./modules/es6.string.anchor":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.anchor.js","./modules/es6.string.big":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.big.js","./modules/es6.string.blink":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.blink.js","./modules/es6.string.bold":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.bold.js","./modules/es6.string.code-point-at":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.code-point-at.js","./modules/es6.string.ends-with":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.ends-with.js","./modules/es6.string.fixed":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.fixed.js","./modules/es6.string.fontcolor":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.fontcolor.js","./modules/es6.string.fontsize":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.fontsize.js","./modules/es6.string.from-code-point":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.from-code-point.js","./modules/es6.string.includes":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.includes.js","./modules/es6.string.italics":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.italics.js","./modules/es6.string.iterator":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.iterator.js","./modules/es6.string.link":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.link.js","./modules/es6.string.raw":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.raw.js","./modules/es6.string.repeat":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.repeat.js","./modules/es6.string.small":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.small.js","./modules/es6.string.starts-with":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.starts-with.js","./modules/es6.string.strike":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.strike.js","./modules/es6.string.sub":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.sub.js","./modules/es6.string.sup":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.sup.js","./modules/es6.string.trim":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.string.trim.js","./modules/es6.symbol":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.symbol.js","./modules/es6.typed.array-buffer":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.typed.array-buffer.js","./modules/es6.typed.data-view":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.typed.data-view.js","./modules/es6.typed.float32-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.typed.float32-array.js","./modules/es6.typed.float64-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.typed.float64-array.js","./modules/es6.typed.int16-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.typed.int16-array.js","./modules/es6.typed.int32-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.typed.int32-array.js","./modules/es6.typed.int8-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.typed.int8-array.js","./modules/es6.typed.uint16-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.typed.uint16-array.js","./modules/es6.typed.uint32-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.typed.uint32-array.js","./modules/es6.typed.uint8-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.typed.uint8-array.js","./modules/es6.typed.uint8-clamped-array":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.typed.uint8-clamped-array.js","./modules/es6.weak-map":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.weak-map.js","./modules/es6.weak-set":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es6.weak-set.js","./modules/es7.array.flat-map":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.array.flat-map.js","./modules/es7.array.flatten":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.array.flatten.js","./modules/es7.array.includes":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.array.includes.js","./modules/es7.asap":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.asap.js","./modules/es7.error.is-error":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.error.is-error.js","./modules/es7.global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.global.js","./modules/es7.map.from":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.map.from.js","./modules/es7.map.of":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.map.of.js","./modules/es7.map.to-json":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.map.to-json.js","./modules/es7.math.clamp":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.math.clamp.js","./modules/es7.math.deg-per-rad":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.math.deg-per-rad.js","./modules/es7.math.degrees":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.math.degrees.js","./modules/es7.math.fscale":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.math.fscale.js","./modules/es7.math.iaddh":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.math.iaddh.js","./modules/es7.math.imulh":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.math.imulh.js","./modules/es7.math.isubh":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.math.isubh.js","./modules/es7.math.rad-per-deg":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.math.rad-per-deg.js","./modules/es7.math.radians":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.math.radians.js","./modules/es7.math.scale":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.math.scale.js","./modules/es7.math.signbit":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.math.signbit.js","./modules/es7.math.umulh":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.math.umulh.js","./modules/es7.object.define-getter":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.object.define-getter.js","./modules/es7.object.define-setter":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.object.define-setter.js","./modules/es7.object.entries":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.object.entries.js","./modules/es7.object.get-own-property-descriptors":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.object.get-own-property-descriptors.js","./modules/es7.object.lookup-getter":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.object.lookup-getter.js","./modules/es7.object.lookup-setter":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.object.lookup-setter.js","./modules/es7.object.values":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.object.values.js","./modules/es7.observable":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.observable.js","./modules/es7.promise.finally":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.promise.finally.js","./modules/es7.promise.try":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.promise.try.js","./modules/es7.reflect.define-metadata":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.reflect.define-metadata.js","./modules/es7.reflect.delete-metadata":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.reflect.delete-metadata.js","./modules/es7.reflect.get-metadata":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.reflect.get-metadata.js","./modules/es7.reflect.get-metadata-keys":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.reflect.get-metadata-keys.js","./modules/es7.reflect.get-own-metadata":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.reflect.get-own-metadata.js","./modules/es7.reflect.get-own-metadata-keys":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.reflect.get-own-metadata-keys.js","./modules/es7.reflect.has-metadata":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.reflect.has-metadata.js","./modules/es7.reflect.has-own-metadata":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.reflect.has-own-metadata.js","./modules/es7.reflect.metadata":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.reflect.metadata.js","./modules/es7.set.from":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.set.from.js","./modules/es7.set.of":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.set.of.js","./modules/es7.set.to-json":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.set.to-json.js","./modules/es7.string.at":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.string.at.js","./modules/es7.string.match-all":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.string.match-all.js","./modules/es7.string.pad-end":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.string.pad-end.js","./modules/es7.string.pad-start":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.string.pad-start.js","./modules/es7.string.trim-left":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.string.trim-left.js","./modules/es7.string.trim-right":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.string.trim-right.js","./modules/es7.symbol.async-iterator":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.symbol.async-iterator.js","./modules/es7.symbol.observable":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.symbol.observable.js","./modules/es7.system.global":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.system.global.js","./modules/es7.weak-map.from":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.weak-map.from.js","./modules/es7.weak-map.of":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.weak-map.of.js","./modules/es7.weak-set.from":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.weak-set.from.js","./modules/es7.weak-set.of":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\es7.weak-set.of.js","./modules/web.dom.iterable":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\web.dom.iterable.js","./modules/web.immediate":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\web.immediate.js","./modules/web.timers":"C:\\projects\\lightning\\node_modules\\core-js\\modules\\web.timers.js"}],"C:\\projects\\lightning\\node_modules\\es5-shim\\es5-shim.js":[function(require,module,exports){
/*!
 * https://github.com/es-shims/es5-shim
 * @license es5-shim Copyright 2009-2015 by contributors, MIT License
 * see https://github.com/es-shims/es5-shim/blob/master/LICENSE
 */

// vim: ts=4 sts=4 sw=4 expandtab

// Add semicolon to prevent IIFE from being passed as argument to concatenated code.
;

// UMD (Universal Module Definition)
// see https://github.com/umdjs/umd/blob/master/templates/returnExports.js
(function (root, factory) {
    'use strict';

    /* global define, exports, module */
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(factory);
    } else if (typeof exports === 'object') {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like enviroments that support module.exports,
        // like Node.
        module.exports = factory();
    } else {
        // Browser globals (root is window)
        root.returnExports = factory();
    }
}(this, function () {
    /**
     * Brings an environment as close to ECMAScript 5 compliance
     * as is possible with the facilities of erstwhile engines.
     *
     * Annotated ES5: http://es5.github.com/ (specific links below)
     * ES5 Spec: http://www.ecma-international.org/publications/files/ECMA-ST/Ecma-262.pdf
     * Required reading: http://javascriptweblog.wordpress.com/2011/12/05/extending-javascript-natives/
     */

    // Shortcut to an often accessed properties, in order to avoid multiple
    // dereference that costs universally. This also holds a reference to known-good
    // functions.
    var $Array = Array;
    var ArrayPrototype = $Array.prototype;
    var $Object = Object;
    var ObjectPrototype = $Object.prototype;
    var $Function = Function;
    var FunctionPrototype = $Function.prototype;
    var $String = String;
    var StringPrototype = $String.prototype;
    var $Number = Number;
    var NumberPrototype = $Number.prototype;
    var array_slice = ArrayPrototype.slice;
    var array_splice = ArrayPrototype.splice;
    var array_push = ArrayPrototype.push;
    var array_unshift = ArrayPrototype.unshift;
    var array_concat = ArrayPrototype.concat;
    var array_join = ArrayPrototype.join;
    var call = FunctionPrototype.call;
    var apply = FunctionPrototype.apply;
    var max = Math.max;
    var min = Math.min;

    // Having a toString local variable name breaks in Opera so use to_string.
    var to_string = ObjectPrototype.toString;

    /* global Symbol */
    /* eslint-disable one-var-declaration-per-line, no-redeclare, max-statements-per-line */
    var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
    var isCallable; /* inlined from https://npmjs.com/is-callable */ var fnToStr = Function.prototype.toString, constructorRegex = /^\s*class /, isES6ClassFn = function isES6ClassFn(value) { try { var fnStr = fnToStr.call(value); var singleStripped = fnStr.replace(/\/\/.*\n/g, ''); var multiStripped = singleStripped.replace(/\/\*[.\s\S]*\*\//g, ''); var spaceStripped = multiStripped.replace(/\n/mg, ' ').replace(/ {2}/g, ' '); return constructorRegex.test(spaceStripped); } catch (e) { return false; /* not a function */ } }, tryFunctionObject = function tryFunctionObject(value) { try { if (isES6ClassFn(value)) { return false; } fnToStr.call(value); return true; } catch (e) { return false; } }, fnClass = '[object Function]', genClass = '[object GeneratorFunction]', isCallable = function isCallable(value) { if (!value) { return false; } if (typeof value !== 'function' && typeof value !== 'object') { return false; } if (hasToStringTag) { return tryFunctionObject(value); } if (isES6ClassFn(value)) { return false; } var strClass = to_string.call(value); return strClass === fnClass || strClass === genClass; };

    var isRegex; /* inlined from https://npmjs.com/is-regex */ var regexExec = RegExp.prototype.exec, tryRegexExec = function tryRegexExec(value) { try { regexExec.call(value); return true; } catch (e) { return false; } }, regexClass = '[object RegExp]'; isRegex = function isRegex(value) { if (typeof value !== 'object') { return false; } return hasToStringTag ? tryRegexExec(value) : to_string.call(value) === regexClass; };
    var isString; /* inlined from https://npmjs.com/is-string */ var strValue = String.prototype.valueOf, tryStringObject = function tryStringObject(value) { try { strValue.call(value); return true; } catch (e) { return false; } }, stringClass = '[object String]'; isString = function isString(value) { if (typeof value === 'string') { return true; } if (typeof value !== 'object') { return false; } return hasToStringTag ? tryStringObject(value) : to_string.call(value) === stringClass; };
    /* eslint-enable one-var-declaration-per-line, no-redeclare, max-statements-per-line */

    /* inlined from http://npmjs.com/define-properties */
    var supportsDescriptors = $Object.defineProperty && (function () {
        try {
            var obj = {};
            $Object.defineProperty(obj, 'x', { enumerable: false, value: obj });
            for (var _ in obj) { // jscs:ignore disallowUnusedVariables
                return false;
            }
            return obj.x === obj;
        } catch (e) { /* this is ES3 */
            return false;
        }
    }());
    var defineProperties = (function (has) {
        // Define configurable, writable, and non-enumerable props
        // if they don't exist.
        var defineProperty;
        if (supportsDescriptors) {
            defineProperty = function (object, name, method, forceAssign) {
                if (!forceAssign && (name in object)) {
                    return;
                }
                $Object.defineProperty(object, name, {
                    configurable: true,
                    enumerable: false,
                    writable: true,
                    value: method
                });
            };
        } else {
            defineProperty = function (object, name, method, forceAssign) {
                if (!forceAssign && (name in object)) {
                    return;
                }
                object[name] = method;
            };
        }
        return function defineProperties(object, map, forceAssign) {
            for (var name in map) {
                if (has.call(map, name)) {
                    defineProperty(object, name, map[name], forceAssign);
                }
            }
        };
    }(ObjectPrototype.hasOwnProperty));

    //
    // Util
    // ======
    //

    /* replaceable with https://npmjs.com/package/es-abstract /helpers/isPrimitive */
    var isPrimitive = function isPrimitive(input) {
        var type = typeof input;
        return input === null || (type !== 'object' && type !== 'function');
    };

    var isActualNaN = $Number.isNaN || function isActualNaN(x) {
        return x !== x;
    };

    var ES = {
        // ES5 9.4
        // http://es5.github.com/#x9.4
        // http://jsperf.com/to-integer
        /* replaceable with https://npmjs.com/package/es-abstract ES5.ToInteger */
        ToInteger: function ToInteger(num) {
            var n = +num;
            if (isActualNaN(n)) {
                n = 0;
            } else if (n !== 0 && n !== (1 / 0) && n !== -(1 / 0)) {
                n = (n > 0 || -1) * Math.floor(Math.abs(n));
            }
            return n;
        },

        /* replaceable with https://npmjs.com/package/es-abstract ES5.ToPrimitive */
        ToPrimitive: function ToPrimitive(input) {
            var val, valueOf, toStr;
            if (isPrimitive(input)) {
                return input;
            }
            valueOf = input.valueOf;
            if (isCallable(valueOf)) {
                val = valueOf.call(input);
                if (isPrimitive(val)) {
                    return val;
                }
            }
            toStr = input.toString;
            if (isCallable(toStr)) {
                val = toStr.call(input);
                if (isPrimitive(val)) {
                    return val;
                }
            }
            throw new TypeError();
        },

        // ES5 9.9
        // http://es5.github.com/#x9.9
        /* replaceable with https://npmjs.com/package/es-abstract ES5.ToObject */
        ToObject: function (o) {
            if (o == null) { // this matches both null and undefined
                throw new TypeError("can't convert " + o + ' to object');
            }
            return $Object(o);
        },

        /* replaceable with https://npmjs.com/package/es-abstract ES5.ToUint32 */
        ToUint32: function ToUint32(x) {
            return x >>> 0;
        }
    };

    //
    // Function
    // ========
    //

    // ES-5 15.3.4.5
    // http://es5.github.com/#x15.3.4.5

    var Empty = function Empty() {};

    defineProperties(FunctionPrototype, {
        bind: function bind(that) { // .length is 1
            // 1. Let Target be the this value.
            var target = this;
            // 2. If IsCallable(Target) is false, throw a TypeError exception.
            if (!isCallable(target)) {
                throw new TypeError('Function.prototype.bind called on incompatible ' + target);
            }
            // 3. Let A be a new (possibly empty) internal list of all of the
            //   argument values provided after thisArg (arg1, arg2 etc), in order.
            // XXX slicedArgs will stand in for "A" if used
            var args = array_slice.call(arguments, 1); // for normal call
            // 4. Let F be a new native ECMAScript object.
            // 11. Set the [[Prototype]] internal property of F to the standard
            //   built-in Function prototype object as specified in 15.3.3.1.
            // 12. Set the [[Call]] internal property of F as described in
            //   15.3.4.5.1.
            // 13. Set the [[Construct]] internal property of F as described in
            //   15.3.4.5.2.
            // 14. Set the [[HasInstance]] internal property of F as described in
            //   15.3.4.5.3.
            var bound;
            var binder = function () {

                if (this instanceof bound) {
                    // 15.3.4.5.2 [[Construct]]
                    // When the [[Construct]] internal method of a function object,
                    // F that was created using the bind function is called with a
                    // list of arguments ExtraArgs, the following steps are taken:
                    // 1. Let target be the value of F's [[TargetFunction]]
                    //   internal property.
                    // 2. If target has no [[Construct]] internal method, a
                    //   TypeError exception is thrown.
                    // 3. Let boundArgs be the value of F's [[BoundArgs]] internal
                    //   property.
                    // 4. Let args be a new list containing the same values as the
                    //   list boundArgs in the same order followed by the same
                    //   values as the list ExtraArgs in the same order.
                    // 5. Return the result of calling the [[Construct]] internal
                    //   method of target providing args as the arguments.

                    var result = apply.call(
                        target,
                        this,
                        array_concat.call(args, array_slice.call(arguments))
                    );
                    if ($Object(result) === result) {
                        return result;
                    }
                    return this;

                } else {
                    // 15.3.4.5.1 [[Call]]
                    // When the [[Call]] internal method of a function object, F,
                    // which was created using the bind function is called with a
                    // this value and a list of arguments ExtraArgs, the following
                    // steps are taken:
                    // 1. Let boundArgs be the value of F's [[BoundArgs]] internal
                    //   property.
                    // 2. Let boundThis be the value of F's [[BoundThis]] internal
                    //   property.
                    // 3. Let target be the value of F's [[TargetFunction]] internal
                    //   property.
                    // 4. Let args be a new list containing the same values as the
                    //   list boundArgs in the same order followed by the same
                    //   values as the list ExtraArgs in the same order.
                    // 5. Return the result of calling the [[Call]] internal method
                    //   of target providing boundThis as the this value and
                    //   providing args as the arguments.

                    // equiv: target.call(this, ...boundArgs, ...args)
                    return apply.call(
                        target,
                        that,
                        array_concat.call(args, array_slice.call(arguments))
                    );

                }

            };

            // 15. If the [[Class]] internal property of Target is "Function", then
            //     a. Let L be the length property of Target minus the length of A.
            //     b. Set the length own property of F to either 0 or L, whichever is
            //       larger.
            // 16. Else set the length own property of F to 0.

            var boundLength = max(0, target.length - args.length);

            // 17. Set the attributes of the length own property of F to the values
            //   specified in 15.3.5.1.
            var boundArgs = [];
            for (var i = 0; i < boundLength; i++) {
                array_push.call(boundArgs, '$' + i);
            }

            // XXX Build a dynamic function with desired amount of arguments is the only
            // way to set the length property of a function.
            // In environments where Content Security Policies enabled (Chrome extensions,
            // for ex.) all use of eval or Function costructor throws an exception.
            // However in all of these environments Function.prototype.bind exists
            // and so this code will never be executed.
            bound = $Function('binder', 'return function (' + array_join.call(boundArgs, ',') + '){ return binder.apply(this, arguments); }')(binder);

            if (target.prototype) {
                Empty.prototype = target.prototype;
                bound.prototype = new Empty();
                // Clean up dangling references.
                Empty.prototype = null;
            }

            // TODO
            // 18. Set the [[Extensible]] internal property of F to true.

            // TODO
            // 19. Let thrower be the [[ThrowTypeError]] function Object (13.2.3).
            // 20. Call the [[DefineOwnProperty]] internal method of F with
            //   arguments "caller", PropertyDescriptor {[[Get]]: thrower, [[Set]]:
            //   thrower, [[Enumerable]]: false, [[Configurable]]: false}, and
            //   false.
            // 21. Call the [[DefineOwnProperty]] internal method of F with
            //   arguments "arguments", PropertyDescriptor {[[Get]]: thrower,
            //   [[Set]]: thrower, [[Enumerable]]: false, [[Configurable]]: false},
            //   and false.

            // TODO
            // NOTE Function objects created using Function.prototype.bind do not
            // have a prototype property or the [[Code]], [[FormalParameters]], and
            // [[Scope]] internal properties.
            // XXX can't delete prototype in pure-js.

            // 22. Return F.
            return bound;
        }
    });

    // _Please note: Shortcuts are defined after `Function.prototype.bind` as we
    // use it in defining shortcuts.
    var owns = call.bind(ObjectPrototype.hasOwnProperty);
    var toStr = call.bind(ObjectPrototype.toString);
    var arraySlice = call.bind(array_slice);
    var arraySliceApply = apply.bind(array_slice);
    /* globals document */
    if (typeof document === 'object' && document && document.documentElement) {
        try {
            arraySlice(document.documentElement.childNodes);
        } catch (e) {
            var origArraySlice = arraySlice;
            var origArraySliceApply = arraySliceApply;
            arraySlice = function arraySliceIE(arr) {
                var r = [];
                var i = arr.length;
                while (i-- > 0) {
                    r[i] = arr[i];
                }
                return origArraySliceApply(r, origArraySlice(arguments, 1));
            };
            arraySliceApply = function arraySliceApplyIE(arr, args) {
                return origArraySliceApply(arraySlice(arr), args);
            };
        }
    }
    var strSlice = call.bind(StringPrototype.slice);
    var strSplit = call.bind(StringPrototype.split);
    var strIndexOf = call.bind(StringPrototype.indexOf);
    var pushCall = call.bind(array_push);
    var isEnum = call.bind(ObjectPrototype.propertyIsEnumerable);
    var arraySort = call.bind(ArrayPrototype.sort);

    //
    // Array
    // =====
    //

    var isArray = $Array.isArray || function isArray(obj) {
        return toStr(obj) === '[object Array]';
    };

    // ES5 15.4.4.12
    // http://es5.github.com/#x15.4.4.13
    // Return len+argCount.
    // [bugfix, ielt8]
    // IE < 8 bug: [].unshift(0) === undefined but should be "1"
    var hasUnshiftReturnValueBug = [].unshift(0) !== 1;
    defineProperties(ArrayPrototype, {
        unshift: function () {
            array_unshift.apply(this, arguments);
            return this.length;
        }
    }, hasUnshiftReturnValueBug);

    // ES5 15.4.3.2
    // http://es5.github.com/#x15.4.3.2
    // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/isArray
    defineProperties($Array, { isArray: isArray });

    // The IsCallable() check in the Array functions
    // has been replaced with a strict check on the
    // internal class of the object to trap cases where
    // the provided function was actually a regular
    // expression literal, which in V8 and
    // JavaScriptCore is a typeof "function".  Only in
    // V8 are regular expression literals permitted as
    // reduce parameters, so it is desirable in the
    // general case for the shim to match the more
    // strict and common behavior of rejecting regular
    // expressions.

    // ES5 15.4.4.18
    // http://es5.github.com/#x15.4.4.18
    // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/array/forEach

    // Check failure of by-index access of string characters (IE < 9)
    // and failure of `0 in boxedString` (Rhino)
    var boxedString = $Object('a');
    var splitString = boxedString[0] !== 'a' || !(0 in boxedString);

    var properlyBoxesContext = function properlyBoxed(method) {
        // Check node 0.6.21 bug where third parameter is not boxed
        var properlyBoxesNonStrict = true;
        var properlyBoxesStrict = true;
        var threwException = false;
        if (method) {
            try {
                method.call('foo', function (_, __, context) {
                    if (typeof context !== 'object') {
                        properlyBoxesNonStrict = false;
                    }
                });

                method.call([1], function () {
                    'use strict';

                    properlyBoxesStrict = typeof this === 'string';
                }, 'x');
            } catch (e) {
                threwException = true;
            }
        }
        return !!method && !threwException && properlyBoxesNonStrict && properlyBoxesStrict;
    };

    defineProperties(ArrayPrototype, {
        forEach: function forEach(callbackfn/*, thisArg*/) {
            var object = ES.ToObject(this);
            var self = splitString && isString(this) ? strSplit(this, '') : object;
            var i = -1;
            var length = ES.ToUint32(self.length);
            var T;
            if (arguments.length > 1) {
                T = arguments[1];
            }

            // If no callback function or if callback is not a callable function
            if (!isCallable(callbackfn)) {
                throw new TypeError('Array.prototype.forEach callback must be a function');
            }

            while (++i < length) {
                if (i in self) {
                    // Invoke the callback function with call, passing arguments:
                    // context, property value, property key, thisArg object
                    if (typeof T === 'undefined') {
                        callbackfn(self[i], i, object);
                    } else {
                        callbackfn.call(T, self[i], i, object);
                    }
                }
            }
        }
    }, !properlyBoxesContext(ArrayPrototype.forEach));

    // ES5 15.4.4.19
    // http://es5.github.com/#x15.4.4.19
    // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/map
    defineProperties(ArrayPrototype, {
        map: function map(callbackfn/*, thisArg*/) {
            var object = ES.ToObject(this);
            var self = splitString && isString(this) ? strSplit(this, '') : object;
            var length = ES.ToUint32(self.length);
            var result = $Array(length);
            var T;
            if (arguments.length > 1) {
                T = arguments[1];
            }

            // If no callback function or if callback is not a callable function
            if (!isCallable(callbackfn)) {
                throw new TypeError('Array.prototype.map callback must be a function');
            }

            for (var i = 0; i < length; i++) {
                if (i in self) {
                    if (typeof T === 'undefined') {
                        result[i] = callbackfn(self[i], i, object);
                    } else {
                        result[i] = callbackfn.call(T, self[i], i, object);
                    }
                }
            }
            return result;
        }
    }, !properlyBoxesContext(ArrayPrototype.map));

    // ES5 15.4.4.20
    // http://es5.github.com/#x15.4.4.20
    // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/filter
    defineProperties(ArrayPrototype, {
        filter: function filter(callbackfn/*, thisArg*/) {
            var object = ES.ToObject(this);
            var self = splitString && isString(this) ? strSplit(this, '') : object;
            var length = ES.ToUint32(self.length);
            var result = [];
            var value;
            var T;
            if (arguments.length > 1) {
                T = arguments[1];
            }

            // If no callback function or if callback is not a callable function
            if (!isCallable(callbackfn)) {
                throw new TypeError('Array.prototype.filter callback must be a function');
            }

            for (var i = 0; i < length; i++) {
                if (i in self) {
                    value = self[i];
                    if (typeof T === 'undefined' ? callbackfn(value, i, object) : callbackfn.call(T, value, i, object)) {
                        pushCall(result, value);
                    }
                }
            }
            return result;
        }
    }, !properlyBoxesContext(ArrayPrototype.filter));

    // ES5 15.4.4.16
    // http://es5.github.com/#x15.4.4.16
    // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/every
    defineProperties(ArrayPrototype, {
        every: function every(callbackfn/*, thisArg*/) {
            var object = ES.ToObject(this);
            var self = splitString && isString(this) ? strSplit(this, '') : object;
            var length = ES.ToUint32(self.length);
            var T;
            if (arguments.length > 1) {
                T = arguments[1];
            }

            // If no callback function or if callback is not a callable function
            if (!isCallable(callbackfn)) {
                throw new TypeError('Array.prototype.every callback must be a function');
            }

            for (var i = 0; i < length; i++) {
                if (i in self && !(typeof T === 'undefined' ? callbackfn(self[i], i, object) : callbackfn.call(T, self[i], i, object))) {
                    return false;
                }
            }
            return true;
        }
    }, !properlyBoxesContext(ArrayPrototype.every));

    // ES5 15.4.4.17
    // http://es5.github.com/#x15.4.4.17
    // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/some
    defineProperties(ArrayPrototype, {
        some: function some(callbackfn/*, thisArg */) {
            var object = ES.ToObject(this);
            var self = splitString && isString(this) ? strSplit(this, '') : object;
            var length = ES.ToUint32(self.length);
            var T;
            if (arguments.length > 1) {
                T = arguments[1];
            }

            // If no callback function or if callback is not a callable function
            if (!isCallable(callbackfn)) {
                throw new TypeError('Array.prototype.some callback must be a function');
            }

            for (var i = 0; i < length; i++) {
                if (i in self && (typeof T === 'undefined' ? callbackfn(self[i], i, object) : callbackfn.call(T, self[i], i, object))) {
                    return true;
                }
            }
            return false;
        }
    }, !properlyBoxesContext(ArrayPrototype.some));

    // ES5 15.4.4.21
    // http://es5.github.com/#x15.4.4.21
    // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/reduce
    var reduceCoercesToObject = false;
    if (ArrayPrototype.reduce) {
        reduceCoercesToObject = typeof ArrayPrototype.reduce.call('es5', function (_, __, ___, list) {
            return list;
        }) === 'object';
    }
    defineProperties(ArrayPrototype, {
        reduce: function reduce(callbackfn/*, initialValue*/) {
            var object = ES.ToObject(this);
            var self = splitString && isString(this) ? strSplit(this, '') : object;
            var length = ES.ToUint32(self.length);

            // If no callback function or if callback is not a callable function
            if (!isCallable(callbackfn)) {
                throw new TypeError('Array.prototype.reduce callback must be a function');
            }

            // no value to return if no initial value and an empty array
            if (length === 0 && arguments.length === 1) {
                throw new TypeError('reduce of empty array with no initial value');
            }

            var i = 0;
            var result;
            if (arguments.length >= 2) {
                result = arguments[1];
            } else {
                do {
                    if (i in self) {
                        result = self[i++];
                        break;
                    }

                    // if array contains no values, no initial value to return
                    if (++i >= length) {
                        throw new TypeError('reduce of empty array with no initial value');
                    }
                } while (true);
            }

            for (; i < length; i++) {
                if (i in self) {
                    result = callbackfn(result, self[i], i, object);
                }
            }

            return result;
        }
    }, !reduceCoercesToObject);

    // ES5 15.4.4.22
    // http://es5.github.com/#x15.4.4.22
    // https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Objects/Array/reduceRight
    var reduceRightCoercesToObject = false;
    if (ArrayPrototype.reduceRight) {
        reduceRightCoercesToObject = typeof ArrayPrototype.reduceRight.call('es5', function (_, __, ___, list) {
            return list;
        }) === 'object';
    }
    defineProperties(ArrayPrototype, {
        reduceRight: function reduceRight(callbackfn/*, initial*/) {
            var object = ES.ToObject(this);
            var self = splitString && isString(this) ? strSplit(this, '') : object;
            var length = ES.ToUint32(self.length);

            // If no callback function or if callback is not a callable function
            if (!isCallable(callbackfn)) {
                throw new TypeError('Array.prototype.reduceRight callback must be a function');
            }

            // no value to return if no initial value, empty array
            if (length === 0 && arguments.length === 1) {
                throw new TypeError('reduceRight of empty array with no initial value');
            }

            var result;
            var i = length - 1;
            if (arguments.length >= 2) {
                result = arguments[1];
            } else {
                do {
                    if (i in self) {
                        result = self[i--];
                        break;
                    }

                    // if array contains no values, no initial value to return
                    if (--i < 0) {
                        throw new TypeError('reduceRight of empty array with no initial value');
                    }
                } while (true);
            }

            if (i < 0) {
                return result;
            }

            do {
                if (i in self) {
                    result = callbackfn(result, self[i], i, object);
                }
            } while (i--);

            return result;
        }
    }, !reduceRightCoercesToObject);

    // ES5 15.4.4.14
    // http://es5.github.com/#x15.4.4.14
    // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/indexOf
    var hasFirefox2IndexOfBug = ArrayPrototype.indexOf && [0, 1].indexOf(1, 2) !== -1;
    defineProperties(ArrayPrototype, {
        indexOf: function indexOf(searchElement/*, fromIndex */) {
            var self = splitString && isString(this) ? strSplit(this, '') : ES.ToObject(this);
            var length = ES.ToUint32(self.length);

            if (length === 0) {
                return -1;
            }

            var i = 0;
            if (arguments.length > 1) {
                i = ES.ToInteger(arguments[1]);
            }

            // handle negative indices
            i = i >= 0 ? i : max(0, length + i);
            for (; i < length; i++) {
                if (i in self && self[i] === searchElement) {
                    return i;
                }
            }
            return -1;
        }
    }, hasFirefox2IndexOfBug);

    // ES5 15.4.4.15
    // http://es5.github.com/#x15.4.4.15
    // https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/lastIndexOf
    var hasFirefox2LastIndexOfBug = ArrayPrototype.lastIndexOf && [0, 1].lastIndexOf(0, -3) !== -1;
    defineProperties(ArrayPrototype, {
        lastIndexOf: function lastIndexOf(searchElement/*, fromIndex */) {
            var self = splitString && isString(this) ? strSplit(this, '') : ES.ToObject(this);
            var length = ES.ToUint32(self.length);

            if (length === 0) {
                return -1;
            }
            var i = length - 1;
            if (arguments.length > 1) {
                i = min(i, ES.ToInteger(arguments[1]));
            }
            // handle negative indices
            i = i >= 0 ? i : length - Math.abs(i);
            for (; i >= 0; i--) {
                if (i in self && searchElement === self[i]) {
                    return i;
                }
            }
            return -1;
        }
    }, hasFirefox2LastIndexOfBug);

    // ES5 15.4.4.12
    // http://es5.github.com/#x15.4.4.12
    var spliceNoopReturnsEmptyArray = (function () {
        var a = [1, 2];
        var result = a.splice();
        return a.length === 2 && isArray(result) && result.length === 0;
    }());
    defineProperties(ArrayPrototype, {
        // Safari 5.0 bug where .splice() returns undefined
        splice: function splice(start, deleteCount) {
            if (arguments.length === 0) {
                return [];
            } else {
                return array_splice.apply(this, arguments);
            }
        }
    }, !spliceNoopReturnsEmptyArray);

    var spliceWorksWithEmptyObject = (function () {
        var obj = {};
        ArrayPrototype.splice.call(obj, 0, 0, 1);
        return obj.length === 1;
    }());
    defineProperties(ArrayPrototype, {
        splice: function splice(start, deleteCount) {
            if (arguments.length === 0) {
                return [];
            }
            var args = arguments;
            this.length = max(ES.ToInteger(this.length), 0);
            if (arguments.length > 0 && typeof deleteCount !== 'number') {
                args = arraySlice(arguments);
                if (args.length < 2) {
                    pushCall(args, this.length - start);
                } else {
                    args[1] = ES.ToInteger(deleteCount);
                }
            }
            return array_splice.apply(this, args);
        }
    }, !spliceWorksWithEmptyObject);
    var spliceWorksWithLargeSparseArrays = (function () {
        // Per https://github.com/es-shims/es5-shim/issues/295
        // Safari 7/8 breaks with sparse arrays of size 1e5 or greater
        var arr = new $Array(1e5);
        // note: the index MUST be 8 or larger or the test will false pass
        arr[8] = 'x';
        arr.splice(1, 1);
        // note: this test must be defined *after* the indexOf shim
        // per https://github.com/es-shims/es5-shim/issues/313
        return arr.indexOf('x') === 7;
    }());
    var spliceWorksWithSmallSparseArrays = (function () {
        // Per https://github.com/es-shims/es5-shim/issues/295
        // Opera 12.15 breaks on this, no idea why.
        var n = 256;
        var arr = [];
        arr[n] = 'a';
        arr.splice(n + 1, 0, 'b');
        return arr[n] === 'a';
    }());
    defineProperties(ArrayPrototype, {
        splice: function splice(start, deleteCount) {
            var O = ES.ToObject(this);
            var A = [];
            var len = ES.ToUint32(O.length);
            var relativeStart = ES.ToInteger(start);
            var actualStart = relativeStart < 0 ? max((len + relativeStart), 0) : min(relativeStart, len);
            var actualDeleteCount = min(max(ES.ToInteger(deleteCount), 0), len - actualStart);

            var k = 0;
            var from;
            while (k < actualDeleteCount) {
                from = $String(actualStart + k);
                if (owns(O, from)) {
                    A[k] = O[from];
                }
                k += 1;
            }

            var items = arraySlice(arguments, 2);
            var itemCount = items.length;
            var to;
            if (itemCount < actualDeleteCount) {
                k = actualStart;
                var maxK = len - actualDeleteCount;
                while (k < maxK) {
                    from = $String(k + actualDeleteCount);
                    to = $String(k + itemCount);
                    if (owns(O, from)) {
                        O[to] = O[from];
                    } else {
                        delete O[to];
                    }
                    k += 1;
                }
                k = len;
                var minK = len - actualDeleteCount + itemCount;
                while (k > minK) {
                    delete O[k - 1];
                    k -= 1;
                }
            } else if (itemCount > actualDeleteCount) {
                k = len - actualDeleteCount;
                while (k > actualStart) {
                    from = $String(k + actualDeleteCount - 1);
                    to = $String(k + itemCount - 1);
                    if (owns(O, from)) {
                        O[to] = O[from];
                    } else {
                        delete O[to];
                    }
                    k -= 1;
                }
            }
            k = actualStart;
            for (var i = 0; i < items.length; ++i) {
                O[k] = items[i];
                k += 1;
            }
            O.length = len - actualDeleteCount + itemCount;

            return A;
        }
    }, !spliceWorksWithLargeSparseArrays || !spliceWorksWithSmallSparseArrays);

    var originalJoin = ArrayPrototype.join;
    var hasStringJoinBug;
    try {
        hasStringJoinBug = Array.prototype.join.call('123', ',') !== '1,2,3';
    } catch (e) {
        hasStringJoinBug = true;
    }
    if (hasStringJoinBug) {
        defineProperties(ArrayPrototype, {
            join: function join(separator) {
                var sep = typeof separator === 'undefined' ? ',' : separator;
                return originalJoin.call(isString(this) ? strSplit(this, '') : this, sep);
            }
        }, hasStringJoinBug);
    }

    var hasJoinUndefinedBug = [1, 2].join(undefined) !== '1,2';
    if (hasJoinUndefinedBug) {
        defineProperties(ArrayPrototype, {
            join: function join(separator) {
                var sep = typeof separator === 'undefined' ? ',' : separator;
                return originalJoin.call(this, sep);
            }
        }, hasJoinUndefinedBug);
    }

    var pushShim = function push(item) {
        var O = ES.ToObject(this);
        var n = ES.ToUint32(O.length);
        var i = 0;
        while (i < arguments.length) {
            O[n + i] = arguments[i];
            i += 1;
        }
        O.length = n + i;
        return n + i;
    };

    var pushIsNotGeneric = (function () {
        var obj = {};
        var result = Array.prototype.push.call(obj, undefined);
        return result !== 1 || obj.length !== 1 || typeof obj[0] !== 'undefined' || !owns(obj, 0);
    }());
    defineProperties(ArrayPrototype, {
        push: function push(item) {
            if (isArray(this)) {
                return array_push.apply(this, arguments);
            }
            return pushShim.apply(this, arguments);
        }
    }, pushIsNotGeneric);

    // This fixes a very weird bug in Opera 10.6 when pushing `undefined
    var pushUndefinedIsWeird = (function () {
        var arr = [];
        var result = arr.push(undefined);
        return result !== 1 || arr.length !== 1 || typeof arr[0] !== 'undefined' || !owns(arr, 0);
    }());
    defineProperties(ArrayPrototype, { push: pushShim }, pushUndefinedIsWeird);

    // ES5 15.2.3.14
    // http://es5.github.io/#x15.4.4.10
    // Fix boxed string bug
    defineProperties(ArrayPrototype, {
        slice: function (start, end) {
            var arr = isString(this) ? strSplit(this, '') : this;
            return arraySliceApply(arr, arguments);
        }
    }, splitString);

    var sortIgnoresNonFunctions = (function () {
        try {
            [1, 2].sort(null);
        } catch (e) {
            try {
                [1, 2].sort({});
            } catch (e2) {
                return false;
            }
        }
        return true;
    }());
    var sortThrowsOnRegex = (function () {
        // this is a problem in Firefox 4, in which `typeof /a/ === 'function'`
        try {
            [1, 2].sort(/a/);
            return false;
        } catch (e) {}
        return true;
    }());
    var sortIgnoresUndefined = (function () {
        // applies in IE 8, for one.
        try {
            [1, 2].sort(undefined);
            return true;
        } catch (e) {}
        return false;
    }());
    defineProperties(ArrayPrototype, {
        sort: function sort(compareFn) {
            if (typeof compareFn === 'undefined') {
                return arraySort(this);
            }
            if (!isCallable(compareFn)) {
                throw new TypeError('Array.prototype.sort callback must be a function');
            }
            return arraySort(this, compareFn);
        }
    }, sortIgnoresNonFunctions || !sortIgnoresUndefined || !sortThrowsOnRegex);

    //
    // Object
    // ======
    //

    // ES5 15.2.3.14
    // http://es5.github.com/#x15.2.3.14

    // http://whattheheadsaid.com/2010/10/a-safer-object-keys-compatibility-implementation
    var hasDontEnumBug = !isEnum({ 'toString': null }, 'toString'); // jscs:ignore disallowQuotedKeysInObjects
    var hasProtoEnumBug = isEnum(function () {}, 'prototype');
    var hasStringEnumBug = !owns('x', '0');
    var equalsConstructorPrototype = function (o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true,

        $width: true,
        $height: true,
        $top: true,
        $localStorage: true
    };
    var hasAutomationEqualityBug = (function () {
        /* globals window */
        if (typeof window === 'undefined') {
            return false;
        }
        for (var k in window) {
            try {
                if (!excludedKeys['$' + k] && owns(window, k) && window[k] !== null && typeof window[k] === 'object') {
                    equalsConstructorPrototype(window[k]);
                }
            } catch (e) {
                return true;
            }
        }
        return false;
    }());
    var equalsConstructorPrototypeIfNotBuggy = function (object) {
        if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
            return equalsConstructorPrototype(object);
        }
        try {
            return equalsConstructorPrototype(object);
        } catch (e) {
            return false;
        }
    };
    var dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var dontEnumsLength = dontEnums.length;

    // taken directly from https://github.com/ljharb/is-arguments/blob/master/index.js
    // can be replaced with require('is-arguments') if we ever use a build process instead
    var isStandardArguments = function isArguments(value) {
        return toStr(value) === '[object Arguments]';
    };
    var isLegacyArguments = function isArguments(value) {
        return value !== null
            && typeof value === 'object'
            && typeof value.length === 'number'
            && value.length >= 0
            && !isArray(value)
            && isCallable(value.callee);
    };
    var isArguments = isStandardArguments(arguments) ? isStandardArguments : isLegacyArguments;

    defineProperties($Object, {
        keys: function keys(object) {
            var isFn = isCallable(object);
            var isArgs = isArguments(object);
            var isObject = object !== null && typeof object === 'object';
            var isStr = isObject && isString(object);

            if (!isObject && !isFn && !isArgs) {
                throw new TypeError('Object.keys called on a non-object');
            }

            var theKeys = [];
            var skipProto = hasProtoEnumBug && isFn;
            if ((isStr && hasStringEnumBug) || isArgs) {
                for (var i = 0; i < object.length; ++i) {
                    pushCall(theKeys, $String(i));
                }
            }

            if (!isArgs) {
                for (var name in object) {
                    if (!(skipProto && name === 'prototype') && owns(object, name)) {
                        pushCall(theKeys, $String(name));
                    }
                }
            }

            if (hasDontEnumBug) {
                var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
                for (var j = 0; j < dontEnumsLength; j++) {
                    var dontEnum = dontEnums[j];
                    if (!(skipConstructor && dontEnum === 'constructor') && owns(object, dontEnum)) {
                        pushCall(theKeys, dontEnum);
                    }
                }
            }
            return theKeys;
        }
    });

    var keysWorksWithArguments = $Object.keys && (function () {
        // Safari 5.0 bug
        return $Object.keys(arguments).length === 2;
    }(1, 2));
    var keysHasArgumentsLengthBug = $Object.keys && (function () {
        var argKeys = $Object.keys(arguments);
        return arguments.length !== 1 || argKeys.length !== 1 || argKeys[0] !== 1;
    }(1));
    var originalKeys = $Object.keys;
    defineProperties($Object, {
        keys: function keys(object) {
            if (isArguments(object)) {
                return originalKeys(arraySlice(object));
            } else {
                return originalKeys(object);
            }
        }
    }, !keysWorksWithArguments || keysHasArgumentsLengthBug);

    //
    // Date
    // ====
    //

    var hasNegativeMonthYearBug = new Date(-3509827329600292).getUTCMonth() !== 0;
    var aNegativeTestDate = new Date(-1509842289600292);
    var aPositiveTestDate = new Date(1449662400000);
    var hasToUTCStringFormatBug = aNegativeTestDate.toUTCString() !== 'Mon, 01 Jan -45875 11:59:59 GMT';
    var hasToDateStringFormatBug;
    var hasToStringFormatBug;
    var timeZoneOffset = aNegativeTestDate.getTimezoneOffset();
    if (timeZoneOffset < -720) {
        hasToDateStringFormatBug = aNegativeTestDate.toDateString() !== 'Tue Jan 02 -45875';
        hasToStringFormatBug = !(/^Thu Dec 10 2015 \d\d:\d\d:\d\d GMT[-+]\d\d\d\d(?: |$)/).test(String(aPositiveTestDate));
    } else {
        hasToDateStringFormatBug = aNegativeTestDate.toDateString() !== 'Mon Jan 01 -45875';
        hasToStringFormatBug = !(/^Wed Dec 09 2015 \d\d:\d\d:\d\d GMT[-+]\d\d\d\d(?: |$)/).test(String(aPositiveTestDate));
    }

    var originalGetFullYear = call.bind(Date.prototype.getFullYear);
    var originalGetMonth = call.bind(Date.prototype.getMonth);
    var originalGetDate = call.bind(Date.prototype.getDate);
    var originalGetUTCFullYear = call.bind(Date.prototype.getUTCFullYear);
    var originalGetUTCMonth = call.bind(Date.prototype.getUTCMonth);
    var originalGetUTCDate = call.bind(Date.prototype.getUTCDate);
    var originalGetUTCDay = call.bind(Date.prototype.getUTCDay);
    var originalGetUTCHours = call.bind(Date.prototype.getUTCHours);
    var originalGetUTCMinutes = call.bind(Date.prototype.getUTCMinutes);
    var originalGetUTCSeconds = call.bind(Date.prototype.getUTCSeconds);
    var originalGetUTCMilliseconds = call.bind(Date.prototype.getUTCMilliseconds);
    var dayName = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var monthName = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var daysInMonth = function daysInMonth(month, year) {
        return originalGetDate(new Date(year, month, 0));
    };

    defineProperties(Date.prototype, {
        getFullYear: function getFullYear() {
            if (!this || !(this instanceof Date)) {
                throw new TypeError('this is not a Date object.');
            }
            var year = originalGetFullYear(this);
            if (year < 0 && originalGetMonth(this) > 11) {
                return year + 1;
            }
            return year;
        },
        getMonth: function getMonth() {
            if (!this || !(this instanceof Date)) {
                throw new TypeError('this is not a Date object.');
            }
            var year = originalGetFullYear(this);
            var month = originalGetMonth(this);
            if (year < 0 && month > 11) {
                return 0;
            }
            return month;
        },
        getDate: function getDate() {
            if (!this || !(this instanceof Date)) {
                throw new TypeError('this is not a Date object.');
            }
            var year = originalGetFullYear(this);
            var month = originalGetMonth(this);
            var date = originalGetDate(this);
            if (year < 0 && month > 11) {
                if (month === 12) {
                    return date;
                }
                var days = daysInMonth(0, year + 1);
                return (days - date) + 1;
            }
            return date;
        },
        getUTCFullYear: function getUTCFullYear() {
            if (!this || !(this instanceof Date)) {
                throw new TypeError('this is not a Date object.');
            }
            var year = originalGetUTCFullYear(this);
            if (year < 0 && originalGetUTCMonth(this) > 11) {
                return year + 1;
            }
            return year;
        },
        getUTCMonth: function getUTCMonth() {
            if (!this || !(this instanceof Date)) {
                throw new TypeError('this is not a Date object.');
            }
            var year = originalGetUTCFullYear(this);
            var month = originalGetUTCMonth(this);
            if (year < 0 && month > 11) {
                return 0;
            }
            return month;
        },
        getUTCDate: function getUTCDate() {
            if (!this || !(this instanceof Date)) {
                throw new TypeError('this is not a Date object.');
            }
            var year = originalGetUTCFullYear(this);
            var month = originalGetUTCMonth(this);
            var date = originalGetUTCDate(this);
            if (year < 0 && month > 11) {
                if (month === 12) {
                    return date;
                }
                var days = daysInMonth(0, year + 1);
                return (days - date) + 1;
            }
            return date;
        }
    }, hasNegativeMonthYearBug);

    defineProperties(Date.prototype, {
        toUTCString: function toUTCString() {
            if (!this || !(this instanceof Date)) {
                throw new TypeError('this is not a Date object.');
            }
            var day = originalGetUTCDay(this);
            var date = originalGetUTCDate(this);
            var month = originalGetUTCMonth(this);
            var year = originalGetUTCFullYear(this);
            var hour = originalGetUTCHours(this);
            var minute = originalGetUTCMinutes(this);
            var second = originalGetUTCSeconds(this);
            return dayName[day] + ', '
                + (date < 10 ? '0' + date : date) + ' '
                + monthName[month] + ' '
                + year + ' '
                + (hour < 10 ? '0' + hour : hour) + ':'
                + (minute < 10 ? '0' + minute : minute) + ':'
                + (second < 10 ? '0' + second : second) + ' GMT';
        }
    }, hasNegativeMonthYearBug || hasToUTCStringFormatBug);

    // Opera 12 has `,`
    defineProperties(Date.prototype, {
        toDateString: function toDateString() {
            if (!this || !(this instanceof Date)) {
                throw new TypeError('this is not a Date object.');
            }
            var day = this.getDay();
            var date = this.getDate();
            var month = this.getMonth();
            var year = this.getFullYear();
            return dayName[day] + ' '
                + monthName[month] + ' '
                + (date < 10 ? '0' + date : date) + ' '
                + year;
        }
    }, hasNegativeMonthYearBug || hasToDateStringFormatBug);

    // can't use defineProperties here because of toString enumeration issue in IE <= 8
    if (hasNegativeMonthYearBug || hasToStringFormatBug) {
        Date.prototype.toString = function toString() {
            if (!this || !(this instanceof Date)) {
                throw new TypeError('this is not a Date object.');
            }
            var day = this.getDay();
            var date = this.getDate();
            var month = this.getMonth();
            var year = this.getFullYear();
            var hour = this.getHours();
            var minute = this.getMinutes();
            var second = this.getSeconds();
            var timezoneOffset = this.getTimezoneOffset();
            var hoursOffset = Math.floor(Math.abs(timezoneOffset) / 60);
            var minutesOffset = Math.floor(Math.abs(timezoneOffset) % 60);
            return dayName[day] + ' '
                + monthName[month] + ' '
                + (date < 10 ? '0' + date : date) + ' '
                + year + ' '
                + (hour < 10 ? '0' + hour : hour) + ':'
                + (minute < 10 ? '0' + minute : minute) + ':'
                + (second < 10 ? '0' + second : second) + ' GMT'
                + (timezoneOffset > 0 ? '-' : '+')
                + (hoursOffset < 10 ? '0' + hoursOffset : hoursOffset)
                + (minutesOffset < 10 ? '0' + minutesOffset : minutesOffset);
        };
        if (supportsDescriptors) {
            $Object.defineProperty(Date.prototype, 'toString', {
                configurable: true,
                enumerable: false,
                writable: true
            });
        }
    }

    // ES5 15.9.5.43
    // http://es5.github.com/#x15.9.5.43
    // This function returns a String value represent the instance in time
    // represented by this Date object. The format of the String is the Date Time
    // string format defined in 15.9.1.15. All fields are present in the String.
    // The time zone is always UTC, denoted by the suffix Z. If the time value of
    // this object is not a finite Number a RangeError exception is thrown.
    var negativeDate = -62198755200000;
    var negativeYearString = '-000001';
    var hasNegativeDateBug = Date.prototype.toISOString && new Date(negativeDate).toISOString().indexOf(negativeYearString) === -1; // eslint-disable-line max-len
    var hasSafari51DateBug = Date.prototype.toISOString && new Date(-1).toISOString() !== '1969-12-31T23:59:59.999Z';

    var getTime = call.bind(Date.prototype.getTime);

    defineProperties(Date.prototype, {
        toISOString: function toISOString() {
            if (!isFinite(this) || !isFinite(getTime(this))) {
                // Adope Photoshop requires the second check.
                throw new RangeError('Date.prototype.toISOString called on non-finite value.');
            }

            var year = originalGetUTCFullYear(this);

            var month = originalGetUTCMonth(this);
            // see https://github.com/es-shims/es5-shim/issues/111
            year += Math.floor(month / 12);
            month = ((month % 12) + 12) % 12;

            // the date time string format is specified in 15.9.1.15.
            var result = [
                month + 1,
                originalGetUTCDate(this),
                originalGetUTCHours(this),
                originalGetUTCMinutes(this),
                originalGetUTCSeconds(this)
            ];
            year = (
                (year < 0 ? '-' : (year > 9999 ? '+' : ''))
                + strSlice('00000' + Math.abs(year), (0 <= year && year <= 9999) ? -4 : -6)
            );

            for (var i = 0; i < result.length; ++i) {
                // pad months, days, hours, minutes, and seconds to have two digits.
                result[i] = strSlice('00' + result[i], -2);
            }
            // pad milliseconds to have three digits.
            return (
                year + '-' + arraySlice(result, 0, 2).join('-')
                + 'T' + arraySlice(result, 2).join(':') + '.'
                + strSlice('000' + originalGetUTCMilliseconds(this), -3) + 'Z'
            );
        }
    }, hasNegativeDateBug || hasSafari51DateBug);

    // ES5 15.9.5.44
    // http://es5.github.com/#x15.9.5.44
    // This function provides a String representation of a Date object for use by
    // JSON.stringify (15.12.3).
    var dateToJSONIsSupported = (function () {
        try {
            return Date.prototype.toJSON
                && new Date(NaN).toJSON() === null
                && new Date(negativeDate).toJSON().indexOf(negativeYearString) !== -1
                && Date.prototype.toJSON.call({ // generic
                    toISOString: function () { return true; }
                });
        } catch (e) {
            return false;
        }
    }());
    if (!dateToJSONIsSupported) {
        Date.prototype.toJSON = function toJSON(key) {
            // When the toJSON method is called with argument key, the following
            // steps are taken:

            // 1.  Let O be the result of calling ToObject, giving it the this
            // value as its argument.
            // 2. Let tv be ES.ToPrimitive(O, hint Number).
            var O = $Object(this);
            var tv = ES.ToPrimitive(O);
            // 3. If tv is a Number and is not finite, return null.
            if (typeof tv === 'number' && !isFinite(tv)) {
                return null;
            }
            // 4. Let toISO be the result of calling the [[Get]] internal method of
            // O with argument "toISOString".
            var toISO = O.toISOString;
            // 5. If IsCallable(toISO) is false, throw a TypeError exception.
            if (!isCallable(toISO)) {
                throw new TypeError('toISOString property is not callable');
            }
            // 6. Return the result of calling the [[Call]] internal method of
            //  toISO with O as the this value and an empty argument list.
            return toISO.call(O);

            // NOTE 1 The argument is ignored.

            // NOTE 2 The toJSON function is intentionally generic; it does not
            // require that its this value be a Date object. Therefore, it can be
            // transferred to other kinds of objects for use as a method. However,
            // it does require that any such object have a toISOString method. An
            // object is free to use the argument key to filter its
            // stringification.
        };
    }

    // ES5 15.9.4.2
    // http://es5.github.com/#x15.9.4.2
    // based on work shared by Daniel Friesen (dantman)
    // http://gist.github.com/303249
    var supportsExtendedYears = Date.parse('+033658-09-27T01:46:40.000Z') === 1e15;
    var acceptsInvalidDates = !isNaN(Date.parse('2012-04-04T24:00:00.500Z')) || !isNaN(Date.parse('2012-11-31T23:59:59.000Z')) || !isNaN(Date.parse('2012-12-31T23:59:60.000Z'));
    var doesNotParseY2KNewYear = isNaN(Date.parse('2000-01-01T00:00:00.000Z'));
    if (doesNotParseY2KNewYear || acceptsInvalidDates || !supportsExtendedYears) {
        // XXX global assignment won't work in embeddings that use
        // an alternate object for the context.
        /* global Date: true */
        var maxSafeUnsigned32Bit = Math.pow(2, 31) - 1;
        var hasSafariSignedIntBug = isActualNaN(new Date(1970, 0, 1, 0, 0, 0, maxSafeUnsigned32Bit + 1).getTime());
        // eslint-disable-next-line no-implicit-globals, no-global-assign
        Date = (function (NativeDate) {
            // Date.length === 7
            var DateShim = function Date(Y, M, D, h, m, s, ms) {
                var length = arguments.length;
                var date;
                if (this instanceof NativeDate) {
                    var seconds = s;
                    var millis = ms;
                    if (hasSafariSignedIntBug && length >= 7 && ms > maxSafeUnsigned32Bit) {
                        // work around a Safari 8/9 bug where it treats the seconds as signed
                        var msToShift = Math.floor(ms / maxSafeUnsigned32Bit) * maxSafeUnsigned32Bit;
                        var sToShift = Math.floor(msToShift / 1e3);
                        seconds += sToShift;
                        millis -= sToShift * 1e3;
                    }
                    date = length === 1 && $String(Y) === Y // isString(Y)
                        // We explicitly pass it through parse:
                        ? new NativeDate(DateShim.parse(Y))
                        // We have to manually make calls depending on argument
                        // length here
                        : length >= 7 ? new NativeDate(Y, M, D, h, m, seconds, millis)
                            : length >= 6 ? new NativeDate(Y, M, D, h, m, seconds)
                                : length >= 5 ? new NativeDate(Y, M, D, h, m)
                                    : length >= 4 ? new NativeDate(Y, M, D, h)
                                        : length >= 3 ? new NativeDate(Y, M, D)
                                            : length >= 2 ? new NativeDate(Y, M)
                                                : length >= 1 ? new NativeDate(Y instanceof NativeDate ? +Y : Y)
                                                    : new NativeDate();
                } else {
                    date = NativeDate.apply(this, arguments);
                }
                if (!isPrimitive(date)) {
                    // Prevent mixups with unfixed Date object
                    defineProperties(date, { constructor: DateShim }, true);
                }
                return date;
            };

            // 15.9.1.15 Date Time String Format.
            var isoDateExpression = new RegExp('^'
                + '(\\d{4}|[+-]\\d{6})' // four-digit year capture or sign + 6-digit extended year
                + '(?:-(\\d{2})' // optional month capture
                + '(?:-(\\d{2})' // optional day capture
                + '(?:' // capture hours:minutes:seconds.milliseconds
                    + 'T(\\d{2})' // hours capture
                    + ':(\\d{2})' // minutes capture
                    + '(?:' // optional :seconds.milliseconds
                        + ':(\\d{2})' // seconds capture
                        + '(?:(\\.\\d{1,}))?' // milliseconds capture
                    + ')?'
                + '(' // capture UTC offset component
                    + 'Z|' // UTC capture
                    + '(?:' // offset specifier +/-hours:minutes
                        + '([-+])' // sign capture
                        + '(\\d{2})' // hours offset capture
                        + ':(\\d{2})' // minutes offset capture
                    + ')'
                + ')?)?)?)?'
            + '$');

            var months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365];

            var dayFromMonth = function dayFromMonth(year, month) {
                var t = month > 1 ? 1 : 0;
                return (
                    months[month]
                    + Math.floor((year - 1969 + t) / 4)
                    - Math.floor((year - 1901 + t) / 100)
                    + Math.floor((year - 1601 + t) / 400)
                    + (365 * (year - 1970))
                );
            };

            var toUTC = function toUTC(t) {
                var s = 0;
                var ms = t;
                if (hasSafariSignedIntBug && ms > maxSafeUnsigned32Bit) {
                    // work around a Safari 8/9 bug where it treats the seconds as signed
                    var msToShift = Math.floor(ms / maxSafeUnsigned32Bit) * maxSafeUnsigned32Bit;
                    var sToShift = Math.floor(msToShift / 1e3);
                    s += sToShift;
                    ms -= sToShift * 1e3;
                }
                return $Number(new NativeDate(1970, 0, 1, 0, 0, s, ms));
            };

            // Copy any custom methods a 3rd party library may have added
            for (var key in NativeDate) {
                if (owns(NativeDate, key)) {
                    DateShim[key] = NativeDate[key];
                }
            }

            // Copy "native" methods explicitly; they may be non-enumerable
            defineProperties(DateShim, {
                now: NativeDate.now,
                UTC: NativeDate.UTC
            }, true);
            DateShim.prototype = NativeDate.prototype;
            defineProperties(DateShim.prototype, { constructor: DateShim }, true);

            // Upgrade Date.parse to handle simplified ISO 8601 strings
            var parseShim = function parse(string) {
                var match = isoDateExpression.exec(string);
                if (match) {
                    // parse months, days, hours, minutes, seconds, and milliseconds
                    // provide default values if necessary
                    // parse the UTC offset component
                    var year = $Number(match[1]),
                        month = $Number(match[2] || 1) - 1,
                        day = $Number(match[3] || 1) - 1,
                        hour = $Number(match[4] || 0),
                        minute = $Number(match[5] || 0),
                        second = $Number(match[6] || 0),
                        millisecond = Math.floor($Number(match[7] || 0) * 1000),
                        // When time zone is missed, local offset should be used
                        // (ES 5.1 bug)
                        // see https://bugs.ecmascript.org/show_bug.cgi?id=112
                        isLocalTime = Boolean(match[4] && !match[8]),
                        signOffset = match[9] === '-' ? 1 : -1,
                        hourOffset = $Number(match[10] || 0),
                        minuteOffset = $Number(match[11] || 0),
                        result;
                    var hasMinutesOrSecondsOrMilliseconds = minute > 0 || second > 0 || millisecond > 0;
                    if (
                        hour < (hasMinutesOrSecondsOrMilliseconds ? 24 : 25)
                        && minute < 60 && second < 60 && millisecond < 1000
                        && month > -1 && month < 12 && hourOffset < 24
                        && minuteOffset < 60 // detect invalid offsets
                        && day > -1
                        && day < (dayFromMonth(year, month + 1) - dayFromMonth(year, month))
                    ) {
                        result = (
                            ((dayFromMonth(year, month) + day) * 24)
                            + hour
                            + (hourOffset * signOffset)
                        ) * 60;
                        result = ((
                            ((result + minute + (minuteOffset * signOffset)) * 60)
                            + second
                        ) * 1000) + millisecond;
                        if (isLocalTime) {
                            result = toUTC(result);
                        }
                        if (-8.64e15 <= result && result <= 8.64e15) {
                            return result;
                        }
                    }
                    return NaN;
                }
                return NativeDate.parse.apply(this, arguments);
            };
            defineProperties(DateShim, { parse: parseShim });

            return DateShim;
        }(Date));
        /* global Date: false */
    }

    // ES5 15.9.4.4
    // http://es5.github.com/#x15.9.4.4
    if (!Date.now) {
        Date.now = function now() {
            return new Date().getTime();
        };
    }

    //
    // Number
    // ======
    //

    // ES5.1 15.7.4.5
    // http://es5.github.com/#x15.7.4.5
    var hasToFixedBugs = NumberPrototype.toFixed && (
        (0.00008).toFixed(3) !== '0.000'
        || (0.9).toFixed(0) !== '1'
        || (1.255).toFixed(2) !== '1.25'
        || (1000000000000000128).toFixed(0) !== '1000000000000000128'
    );

    var toFixedHelpers = {
        base: 1e7,
        size: 6,
        data: [0, 0, 0, 0, 0, 0],
        multiply: function multiply(n, c) {
            var i = -1;
            var c2 = c;
            while (++i < toFixedHelpers.size) {
                c2 += n * toFixedHelpers.data[i];
                toFixedHelpers.data[i] = c2 % toFixedHelpers.base;
                c2 = Math.floor(c2 / toFixedHelpers.base);
            }
        },
        divide: function divide(n) {
            var i = toFixedHelpers.size;
            var c = 0;
            while (--i >= 0) {
                c += toFixedHelpers.data[i];
                toFixedHelpers.data[i] = Math.floor(c / n);
                c = (c % n) * toFixedHelpers.base;
            }
        },
        numToString: function numToString() {
            var i = toFixedHelpers.size;
            var s = '';
            while (--i >= 0) {
                if (s !== '' || i === 0 || toFixedHelpers.data[i] !== 0) {
                    var t = $String(toFixedHelpers.data[i]);
                    if (s === '') {
                        s = t;
                    } else {
                        s += strSlice('0000000', 0, 7 - t.length) + t;
                    }
                }
            }
            return s;
        },
        pow: function pow(x, n, acc) {
            return (n === 0 ? acc : (n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc)));
        },
        log: function log(x) {
            var n = 0;
            var x2 = x;
            while (x2 >= 4096) {
                n += 12;
                x2 /= 4096;
            }
            while (x2 >= 2) {
                n += 1;
                x2 /= 2;
            }
            return n;
        }
    };

    var toFixedShim = function toFixed(fractionDigits) {
        var f, x, s, m, e, z, j, k;

        // Test for NaN and round fractionDigits down
        f = $Number(fractionDigits);
        f = isActualNaN(f) ? 0 : Math.floor(f);

        if (f < 0 || f > 20) {
            throw new RangeError('Number.toFixed called with invalid number of decimals');
        }

        x = $Number(this);

        if (isActualNaN(x)) {
            return 'NaN';
        }

        // If it is too big or small, return the string value of the number
        if (x <= -1e21 || x >= 1e21) {
            return $String(x);
        }

        s = '';

        if (x < 0) {
            s = '-';
            x = -x;
        }

        m = '0';

        if (x > 1e-21) {
            // 1e-21 < x < 1e21
            // -70 < log2(x) < 70
            e = toFixedHelpers.log(x * toFixedHelpers.pow(2, 69, 1)) - 69;
            z = (e < 0 ? x * toFixedHelpers.pow(2, -e, 1) : x / toFixedHelpers.pow(2, e, 1));
            z *= 0x10000000000000; // Math.pow(2, 52);
            e = 52 - e;

            // -18 < e < 122
            // x = z / 2 ^ e
            if (e > 0) {
                toFixedHelpers.multiply(0, z);
                j = f;

                while (j >= 7) {
                    toFixedHelpers.multiply(1e7, 0);
                    j -= 7;
                }

                toFixedHelpers.multiply(toFixedHelpers.pow(10, j, 1), 0);
                j = e - 1;

                while (j >= 23) {
                    toFixedHelpers.divide(1 << 23);
                    j -= 23;
                }

                toFixedHelpers.divide(1 << j);
                toFixedHelpers.multiply(1, 1);
                toFixedHelpers.divide(2);
                m = toFixedHelpers.numToString();
            } else {
                toFixedHelpers.multiply(0, z);
                toFixedHelpers.multiply(1 << (-e), 0);
                m = toFixedHelpers.numToString() + strSlice('0.00000000000000000000', 2, 2 + f);
            }
        }

        if (f > 0) {
            k = m.length;

            if (k <= f) {
                m = s + strSlice('0.0000000000000000000', 0, f - k + 2) + m;
            } else {
                m = s + strSlice(m, 0, k - f) + '.' + strSlice(m, k - f);
            }
        } else {
            m = s + m;
        }

        return m;
    };
    defineProperties(NumberPrototype, { toFixed: toFixedShim }, hasToFixedBugs);

    var hasToPrecisionUndefinedBug = (function () {
        try {
            return 1.0.toPrecision(undefined) === '1';
        } catch (e) {
            return true;
        }
    }());
    var originalToPrecision = NumberPrototype.toPrecision;
    defineProperties(NumberPrototype, {
        toPrecision: function toPrecision(precision) {
            return typeof precision === 'undefined' ? originalToPrecision.call(this) : originalToPrecision.call(this, precision);
        }
    }, hasToPrecisionUndefinedBug);

    //
    // String
    // ======
    //

    // ES5 15.5.4.14
    // http://es5.github.com/#x15.5.4.14

    // [bugfix, IE lt 9, firefox 4, Konqueror, Opera, obscure browsers]
    // Many browsers do not split properly with regular expressions or they
    // do not perform the split correctly under obscure conditions.
    // See http://blog.stevenlevithan.com/archives/cross-browser-split
    // I've tested in many browsers and this seems to cover the deviant ones:
    //    'ab'.split(/(?:ab)*/) should be ["", ""], not [""]
    //    '.'.split(/(.?)(.?)/) should be ["", ".", "", ""], not ["", ""]
    //    'tesst'.split(/(s)*/) should be ["t", undefined, "e", "s", "t"], not
    //       [undefined, "t", undefined, "e", ...]
    //    ''.split(/.?/) should be [], not [""]
    //    '.'.split(/()()/) should be ["."], not ["", "", "."]

    if (
        'ab'.split(/(?:ab)*/).length !== 2
        || '.'.split(/(.?)(.?)/).length !== 4
        || 'tesst'.split(/(s)*/)[1] === 't'
        || 'test'.split(/(?:)/, -1).length !== 4
        || ''.split(/.?/).length
        || '.'.split(/()()/).length > 1
    ) {
        (function () {
            var compliantExecNpcg = typeof (/()??/).exec('')[1] === 'undefined'; // NPCG: nonparticipating capturing group
            var maxSafe32BitInt = Math.pow(2, 32) - 1;

            StringPrototype.split = function (separator, limit) {
                var string = String(this);
                if (typeof separator === 'undefined' && limit === 0) {
                    return [];
                }

                // If `separator` is not a regex, use native split
                if (!isRegex(separator)) {
                    return strSplit(this, separator, limit);
                }

                var output = [];
                var flags = (separator.ignoreCase ? 'i' : '')
                            + (separator.multiline ? 'm' : '')
                            + (separator.unicode ? 'u' : '') // in ES6
                            + (separator.sticky ? 'y' : ''), // Firefox 3+ and ES6
                    lastLastIndex = 0,
                    // Make `global` and avoid `lastIndex` issues by working with a copy
                    separator2, match, lastIndex, lastLength;
                var separatorCopy = new RegExp(separator.source, flags + 'g');
                if (!compliantExecNpcg) {
                    // Doesn't need flags gy, but they don't hurt
                    separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
                }
                /* Values for `limit`, per the spec:
                 * If undefined: 4294967295 // maxSafe32BitInt
                 * If 0, Infinity, or NaN: 0
                 * If positive number: limit = Math.floor(limit); if (limit > 4294967295) limit -= 4294967296;
                 * If negative number: 4294967296 - Math.floor(Math.abs(limit))
                 * If other: Type-convert, then use the above rules
                 */
                var splitLimit = typeof limit === 'undefined' ? maxSafe32BitInt : ES.ToUint32(limit);
                match = separatorCopy.exec(string);
                while (match) {
                    // `separatorCopy.lastIndex` is not reliable cross-browser
                    lastIndex = match.index + match[0].length;
                    if (lastIndex > lastLastIndex) {
                        pushCall(output, strSlice(string, lastLastIndex, match.index));
                        // Fix browsers whose `exec` methods don't consistently return `undefined` for
                        // nonparticipating capturing groups
                        if (!compliantExecNpcg && match.length > 1) {
                            /* eslint-disable no-loop-func */
                            match[0].replace(separator2, function () {
                                for (var i = 1; i < arguments.length - 2; i++) {
                                    if (typeof arguments[i] === 'undefined') {
                                        match[i] = void 0;
                                    }
                                }
                            });
                            /* eslint-enable no-loop-func */
                        }
                        if (match.length > 1 && match.index < string.length) {
                            array_push.apply(output, arraySlice(match, 1));
                        }
                        lastLength = match[0].length;
                        lastLastIndex = lastIndex;
                        if (output.length >= splitLimit) {
                            break;
                        }
                    }
                    if (separatorCopy.lastIndex === match.index) {
                        separatorCopy.lastIndex++; // Avoid an infinite loop
                    }
                    match = separatorCopy.exec(string);
                }
                if (lastLastIndex === string.length) {
                    if (lastLength || !separatorCopy.test('')) {
                        pushCall(output, '');
                    }
                } else {
                    pushCall(output, strSlice(string, lastLastIndex));
                }
                return output.length > splitLimit ? arraySlice(output, 0, splitLimit) : output;
            };
        }());

    // [bugfix, chrome]
    // If separator is undefined, then the result array contains just one String,
    // which is the this value (converted to a String). If limit is not undefined,
    // then the output array is truncated so that it contains no more than limit
    // elements.
    // "0".split(undefined, 0) -> []
    } else if ('0'.split(void 0, 0).length) {
        StringPrototype.split = function split(separator, limit) {
            if (typeof separator === 'undefined' && limit === 0) {
                return [];
            }
            return strSplit(this, separator, limit);
        };
    }

    var str_replace = StringPrototype.replace;
    var replaceReportsGroupsCorrectly = (function () {
        var groups = [];
        'x'.replace(/x(.)?/g, function (match, group) {
            pushCall(groups, group);
        });
        return groups.length === 1 && typeof groups[0] === 'undefined';
    }());

    if (!replaceReportsGroupsCorrectly) {
        StringPrototype.replace = function replace(searchValue, replaceValue) {
            var isFn = isCallable(replaceValue);
            var hasCapturingGroups = isRegex(searchValue) && (/\)[*?]/).test(searchValue.source);
            if (!isFn || !hasCapturingGroups) {
                return str_replace.call(this, searchValue, replaceValue);
            } else {
                var wrappedReplaceValue = function (match) {
                    var length = arguments.length;
                    var originalLastIndex = searchValue.lastIndex;
                    searchValue.lastIndex = 0;
                    var args = searchValue.exec(match) || [];
                    searchValue.lastIndex = originalLastIndex;
                    pushCall(args, arguments[length - 2], arguments[length - 1]);
                    return replaceValue.apply(this, args);
                };
                return str_replace.call(this, searchValue, wrappedReplaceValue);
            }
        };
    }

    // ECMA-262, 3rd B.2.3
    // Not an ECMAScript standard, although ECMAScript 3rd Edition has a
    // non-normative section suggesting uniform semantics and it should be
    // normalized across all browsers
    // [bugfix, IE lt 9] IE < 9 substr() with negative value not working in IE
    var string_substr = StringPrototype.substr;
    var hasNegativeSubstrBug = ''.substr && '0b'.substr(-1) !== 'b';
    defineProperties(StringPrototype, {
        substr: function substr(start, length) {
            var normalizedStart = start;
            if (start < 0) {
                normalizedStart = max(this.length + start, 0);
            }
            return string_substr.call(this, normalizedStart, length);
        }
    }, hasNegativeSubstrBug);

    // ES5 15.5.4.20
    // whitespace from: http://es5.github.io/#x15.5.4.20
    var ws = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003'
        + '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028'
        + '\u2029\uFEFF';
    var zeroWidth = '\u200b';
    var wsRegexChars = '[' + ws + ']';
    var trimBeginRegexp = new RegExp('^' + wsRegexChars + wsRegexChars + '*');
    var trimEndRegexp = new RegExp(wsRegexChars + wsRegexChars + '*$');
    var hasTrimWhitespaceBug = StringPrototype.trim && (ws.trim() || !zeroWidth.trim());
    defineProperties(StringPrototype, {
        // http://blog.stevenlevithan.com/archives/faster-trim-javascript
        // http://perfectionkills.com/whitespace-deviations/
        trim: function trim() {
            if (typeof this === 'undefined' || this === null) {
                throw new TypeError("can't convert " + this + ' to object');
            }
            return $String(this).replace(trimBeginRegexp, '').replace(trimEndRegexp, '');
        }
    }, hasTrimWhitespaceBug);
    var trim = call.bind(String.prototype.trim);

    var hasLastIndexBug = StringPrototype.lastIndexOf && 'abcあい'.lastIndexOf('あい', 2) !== -1;
    defineProperties(StringPrototype, {
        lastIndexOf: function lastIndexOf(searchString) {
            if (typeof this === 'undefined' || this === null) {
                throw new TypeError("can't convert " + this + ' to object');
            }
            var S = $String(this);
            var searchStr = $String(searchString);
            var numPos = arguments.length > 1 ? $Number(arguments[1]) : NaN;
            var pos = isActualNaN(numPos) ? Infinity : ES.ToInteger(numPos);
            var start = min(max(pos, 0), S.length);
            var searchLen = searchStr.length;
            var k = start + searchLen;
            while (k > 0) {
                k = max(0, k - searchLen);
                var index = strIndexOf(strSlice(S, k, start + searchLen), searchStr);
                if (index !== -1) {
                    return k + index;
                }
            }
            return -1;
        }
    }, hasLastIndexBug);

    var originalLastIndexOf = StringPrototype.lastIndexOf;
    defineProperties(StringPrototype, {
        lastIndexOf: function lastIndexOf(searchString) {
            return originalLastIndexOf.apply(this, arguments);
        }
    }, StringPrototype.lastIndexOf.length !== 1);

    // ES-5 15.1.2.2
    // eslint-disable-next-line radix
    if (parseInt(ws + '08') !== 8 || parseInt(ws + '0x16') !== 22) {
        /* global parseInt: true */
        parseInt = (function (origParseInt) {
            var hexRegex = /^[-+]?0[xX]/;
            return function parseInt(str, radix) {
                if (typeof str === 'symbol') {
                    // handle Symbols in node 8.3/8.4
                    // eslint-disable-next-line no-implicit-coercion, no-unused-expressions
                    '' + str; // jscs:ignore disallowImplicitTypeConversion
                }

                var string = trim(String(str));
                var defaultedRadix = $Number(radix) || (hexRegex.test(string) ? 16 : 10);
                return origParseInt(string, defaultedRadix);
            };
        }(parseInt));
    }

    // https://es5.github.io/#x15.1.2.3
    if (1 / parseFloat('-0') !== -Infinity) {
        /* global parseFloat: true */
        parseFloat = (function (origParseFloat) {
            return function parseFloat(string) {
                var inputString = trim(String(string));
                var result = origParseFloat(inputString);
                return result === 0 && strSlice(inputString, 0, 1) === '-' ? -0 : result;
            };
        }(parseFloat));
    }

    if (String(new RangeError('test')) !== 'RangeError: test') {
        var errorToStringShim = function toString() {
            if (typeof this === 'undefined' || this === null) {
                throw new TypeError("can't convert " + this + ' to object');
            }
            var name = this.name;
            if (typeof name === 'undefined') {
                name = 'Error';
            } else if (typeof name !== 'string') {
                name = $String(name);
            }
            var msg = this.message;
            if (typeof msg === 'undefined') {
                msg = '';
            } else if (typeof msg !== 'string') {
                msg = $String(msg);
            }
            if (!name) {
                return msg;
            }
            if (!msg) {
                return name;
            }
            return name + ': ' + msg;
        };
        // can't use defineProperties here because of toString enumeration issue in IE <= 8
        Error.prototype.toString = errorToStringShim;
    }

    if (supportsDescriptors) {
        var ensureNonEnumerable = function (obj, prop) {
            if (isEnum(obj, prop)) {
                var desc = Object.getOwnPropertyDescriptor(obj, prop);
                if (desc.configurable) {
                    desc.enumerable = false;
                    Object.defineProperty(obj, prop, desc);
                }
            }
        };
        ensureNonEnumerable(Error.prototype, 'message');
        if (Error.prototype.message !== '') {
            Error.prototype.message = '';
        }
        ensureNonEnumerable(Error.prototype, 'name');
    }

    if (String(/a/mig) !== '/a/gim') {
        var regexToString = function toString() {
            var str = '/' + this.source + '/';
            if (this.global) {
                str += 'g';
            }
            if (this.ignoreCase) {
                str += 'i';
            }
            if (this.multiline) {
                str += 'm';
            }
            return str;
        };
        // can't use defineProperties here because of toString enumeration issue in IE <= 8
        RegExp.prototype.toString = regexToString;
    }
}));

},{}],"C:\\projects\\lightning\\node_modules\\escape-html\\index.js":[function(require,module,exports){
/*!
 * escape-html
 * Copyright(c) 2012-2013 TJ Holowaychuk
 * Copyright(c) 2015 Andreas Lubbe
 * Copyright(c) 2015 Tiancheng "Timothy" Gu
 * MIT Licensed
 */

'use strict';

/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Module exports.
 * @public
 */

module.exports = escapeHtml;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34: // "
        escape = '&quot;';
        break;
      case 38: // &
        escape = '&amp;';
        break;
      case 39: // '
        escape = '&#39;';
        break;
      case 60: // <
        escape = '&lt;';
        break;
      case 62: // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index
    ? html + str.substring(lastIndex, index)
    : html;
}

},{}],"C:\\projects\\lightning\\node_modules\\he\\he.js":[function(require,module,exports){
(function (global){
/*! https://mths.be/he v1.2.0 by @mathias | MIT license */
;(function(root) {

	// Detect free variables `exports`.
	var freeExports = typeof exports == 'object' && exports;

	// Detect free variable `module`.
	var freeModule = typeof module == 'object' && module &&
		module.exports == freeExports && module;

	// Detect free variable `global`, from Node.js or Browserified code,
	// and use it as `root`.
	var freeGlobal = typeof global == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
		root = freeGlobal;
	}

	/*--------------------------------------------------------------------------*/

	// All astral symbols.
	var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	// All ASCII symbols (not just printable ASCII) except those listed in the
	// first column of the overrides table.
	// https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides
	var regexAsciiWhitelist = /[\x01-\x7F]/g;
	// All BMP symbols that are not ASCII newlines, printable ASCII symbols, or
	// code points listed in the first column of the overrides table on
	// https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides.
	var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;

	var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
	var encodeMap = {'\xAD':'shy','\u200C':'zwnj','\u200D':'zwj','\u200E':'lrm','\u2063':'ic','\u2062':'it','\u2061':'af','\u200F':'rlm','\u200B':'ZeroWidthSpace','\u2060':'NoBreak','\u0311':'DownBreve','\u20DB':'tdot','\u20DC':'DotDot','\t':'Tab','\n':'NewLine','\u2008':'puncsp','\u205F':'MediumSpace','\u2009':'thinsp','\u200A':'hairsp','\u2004':'emsp13','\u2002':'ensp','\u2005':'emsp14','\u2003':'emsp','\u2007':'numsp','\xA0':'nbsp','\u205F\u200A':'ThickSpace','\u203E':'oline','_':'lowbar','\u2010':'dash','\u2013':'ndash','\u2014':'mdash','\u2015':'horbar',',':'comma',';':'semi','\u204F':'bsemi',':':'colon','\u2A74':'Colone','!':'excl','\xA1':'iexcl','?':'quest','\xBF':'iquest','.':'period','\u2025':'nldr','\u2026':'mldr','\xB7':'middot','\'':'apos','\u2018':'lsquo','\u2019':'rsquo','\u201A':'sbquo','\u2039':'lsaquo','\u203A':'rsaquo','"':'quot','\u201C':'ldquo','\u201D':'rdquo','\u201E':'bdquo','\xAB':'laquo','\xBB':'raquo','(':'lpar',')':'rpar','[':'lsqb',']':'rsqb','{':'lcub','}':'rcub','\u2308':'lceil','\u2309':'rceil','\u230A':'lfloor','\u230B':'rfloor','\u2985':'lopar','\u2986':'ropar','\u298B':'lbrke','\u298C':'rbrke','\u298D':'lbrkslu','\u298E':'rbrksld','\u298F':'lbrksld','\u2990':'rbrkslu','\u2991':'langd','\u2992':'rangd','\u2993':'lparlt','\u2994':'rpargt','\u2995':'gtlPar','\u2996':'ltrPar','\u27E6':'lobrk','\u27E7':'robrk','\u27E8':'lang','\u27E9':'rang','\u27EA':'Lang','\u27EB':'Rang','\u27EC':'loang','\u27ED':'roang','\u2772':'lbbrk','\u2773':'rbbrk','\u2016':'Vert','\xA7':'sect','\xB6':'para','@':'commat','*':'ast','/':'sol','undefined':null,'&':'amp','#':'num','%':'percnt','\u2030':'permil','\u2031':'pertenk','\u2020':'dagger','\u2021':'Dagger','\u2022':'bull','\u2043':'hybull','\u2032':'prime','\u2033':'Prime','\u2034':'tprime','\u2057':'qprime','\u2035':'bprime','\u2041':'caret','`':'grave','\xB4':'acute','\u02DC':'tilde','^':'Hat','\xAF':'macr','\u02D8':'breve','\u02D9':'dot','\xA8':'die','\u02DA':'ring','\u02DD':'dblac','\xB8':'cedil','\u02DB':'ogon','\u02C6':'circ','\u02C7':'caron','\xB0':'deg','\xA9':'copy','\xAE':'reg','\u2117':'copysr','\u2118':'wp','\u211E':'rx','\u2127':'mho','\u2129':'iiota','\u2190':'larr','\u219A':'nlarr','\u2192':'rarr','\u219B':'nrarr','\u2191':'uarr','\u2193':'darr','\u2194':'harr','\u21AE':'nharr','\u2195':'varr','\u2196':'nwarr','\u2197':'nearr','\u2198':'searr','\u2199':'swarr','\u219D':'rarrw','\u219D\u0338':'nrarrw','\u219E':'Larr','\u219F':'Uarr','\u21A0':'Rarr','\u21A1':'Darr','\u21A2':'larrtl','\u21A3':'rarrtl','\u21A4':'mapstoleft','\u21A5':'mapstoup','\u21A6':'map','\u21A7':'mapstodown','\u21A9':'larrhk','\u21AA':'rarrhk','\u21AB':'larrlp','\u21AC':'rarrlp','\u21AD':'harrw','\u21B0':'lsh','\u21B1':'rsh','\u21B2':'ldsh','\u21B3':'rdsh','\u21B5':'crarr','\u21B6':'cularr','\u21B7':'curarr','\u21BA':'olarr','\u21BB':'orarr','\u21BC':'lharu','\u21BD':'lhard','\u21BE':'uharr','\u21BF':'uharl','\u21C0':'rharu','\u21C1':'rhard','\u21C2':'dharr','\u21C3':'dharl','\u21C4':'rlarr','\u21C5':'udarr','\u21C6':'lrarr','\u21C7':'llarr','\u21C8':'uuarr','\u21C9':'rrarr','\u21CA':'ddarr','\u21CB':'lrhar','\u21CC':'rlhar','\u21D0':'lArr','\u21CD':'nlArr','\u21D1':'uArr','\u21D2':'rArr','\u21CF':'nrArr','\u21D3':'dArr','\u21D4':'iff','\u21CE':'nhArr','\u21D5':'vArr','\u21D6':'nwArr','\u21D7':'neArr','\u21D8':'seArr','\u21D9':'swArr','\u21DA':'lAarr','\u21DB':'rAarr','\u21DD':'zigrarr','\u21E4':'larrb','\u21E5':'rarrb','\u21F5':'duarr','\u21FD':'loarr','\u21FE':'roarr','\u21FF':'hoarr','\u2200':'forall','\u2201':'comp','\u2202':'part','\u2202\u0338':'npart','\u2203':'exist','\u2204':'nexist','\u2205':'empty','\u2207':'Del','\u2208':'in','\u2209':'notin','\u220B':'ni','\u220C':'notni','\u03F6':'bepsi','\u220F':'prod','\u2210':'coprod','\u2211':'sum','+':'plus','\xB1':'pm','\xF7':'div','\xD7':'times','<':'lt','\u226E':'nlt','<\u20D2':'nvlt','=':'equals','\u2260':'ne','=\u20E5':'bne','\u2A75':'Equal','>':'gt','\u226F':'ngt','>\u20D2':'nvgt','\xAC':'not','|':'vert','\xA6':'brvbar','\u2212':'minus','\u2213':'mp','\u2214':'plusdo','\u2044':'frasl','\u2216':'setmn','\u2217':'lowast','\u2218':'compfn','\u221A':'Sqrt','\u221D':'prop','\u221E':'infin','\u221F':'angrt','\u2220':'ang','\u2220\u20D2':'nang','\u2221':'angmsd','\u2222':'angsph','\u2223':'mid','\u2224':'nmid','\u2225':'par','\u2226':'npar','\u2227':'and','\u2228':'or','\u2229':'cap','\u2229\uFE00':'caps','\u222A':'cup','\u222A\uFE00':'cups','\u222B':'int','\u222C':'Int','\u222D':'tint','\u2A0C':'qint','\u222E':'oint','\u222F':'Conint','\u2230':'Cconint','\u2231':'cwint','\u2232':'cwconint','\u2233':'awconint','\u2234':'there4','\u2235':'becaus','\u2236':'ratio','\u2237':'Colon','\u2238':'minusd','\u223A':'mDDot','\u223B':'homtht','\u223C':'sim','\u2241':'nsim','\u223C\u20D2':'nvsim','\u223D':'bsim','\u223D\u0331':'race','\u223E':'ac','\u223E\u0333':'acE','\u223F':'acd','\u2240':'wr','\u2242':'esim','\u2242\u0338':'nesim','\u2243':'sime','\u2244':'nsime','\u2245':'cong','\u2247':'ncong','\u2246':'simne','\u2248':'ap','\u2249':'nap','\u224A':'ape','\u224B':'apid','\u224B\u0338':'napid','\u224C':'bcong','\u224D':'CupCap','\u226D':'NotCupCap','\u224D\u20D2':'nvap','\u224E':'bump','\u224E\u0338':'nbump','\u224F':'bumpe','\u224F\u0338':'nbumpe','\u2250':'doteq','\u2250\u0338':'nedot','\u2251':'eDot','\u2252':'efDot','\u2253':'erDot','\u2254':'colone','\u2255':'ecolon','\u2256':'ecir','\u2257':'cire','\u2259':'wedgeq','\u225A':'veeeq','\u225C':'trie','\u225F':'equest','\u2261':'equiv','\u2262':'nequiv','\u2261\u20E5':'bnequiv','\u2264':'le','\u2270':'nle','\u2264\u20D2':'nvle','\u2265':'ge','\u2271':'nge','\u2265\u20D2':'nvge','\u2266':'lE','\u2266\u0338':'nlE','\u2267':'gE','\u2267\u0338':'ngE','\u2268\uFE00':'lvnE','\u2268':'lnE','\u2269':'gnE','\u2269\uFE00':'gvnE','\u226A':'ll','\u226A\u0338':'nLtv','\u226A\u20D2':'nLt','\u226B':'gg','\u226B\u0338':'nGtv','\u226B\u20D2':'nGt','\u226C':'twixt','\u2272':'lsim','\u2274':'nlsim','\u2273':'gsim','\u2275':'ngsim','\u2276':'lg','\u2278':'ntlg','\u2277':'gl','\u2279':'ntgl','\u227A':'pr','\u2280':'npr','\u227B':'sc','\u2281':'nsc','\u227C':'prcue','\u22E0':'nprcue','\u227D':'sccue','\u22E1':'nsccue','\u227E':'prsim','\u227F':'scsim','\u227F\u0338':'NotSucceedsTilde','\u2282':'sub','\u2284':'nsub','\u2282\u20D2':'vnsub','\u2283':'sup','\u2285':'nsup','\u2283\u20D2':'vnsup','\u2286':'sube','\u2288':'nsube','\u2287':'supe','\u2289':'nsupe','\u228A\uFE00':'vsubne','\u228A':'subne','\u228B\uFE00':'vsupne','\u228B':'supne','\u228D':'cupdot','\u228E':'uplus','\u228F':'sqsub','\u228F\u0338':'NotSquareSubset','\u2290':'sqsup','\u2290\u0338':'NotSquareSuperset','\u2291':'sqsube','\u22E2':'nsqsube','\u2292':'sqsupe','\u22E3':'nsqsupe','\u2293':'sqcap','\u2293\uFE00':'sqcaps','\u2294':'sqcup','\u2294\uFE00':'sqcups','\u2295':'oplus','\u2296':'ominus','\u2297':'otimes','\u2298':'osol','\u2299':'odot','\u229A':'ocir','\u229B':'oast','\u229D':'odash','\u229E':'plusb','\u229F':'minusb','\u22A0':'timesb','\u22A1':'sdotb','\u22A2':'vdash','\u22AC':'nvdash','\u22A3':'dashv','\u22A4':'top','\u22A5':'bot','\u22A7':'models','\u22A8':'vDash','\u22AD':'nvDash','\u22A9':'Vdash','\u22AE':'nVdash','\u22AA':'Vvdash','\u22AB':'VDash','\u22AF':'nVDash','\u22B0':'prurel','\u22B2':'vltri','\u22EA':'nltri','\u22B3':'vrtri','\u22EB':'nrtri','\u22B4':'ltrie','\u22EC':'nltrie','\u22B4\u20D2':'nvltrie','\u22B5':'rtrie','\u22ED':'nrtrie','\u22B5\u20D2':'nvrtrie','\u22B6':'origof','\u22B7':'imof','\u22B8':'mumap','\u22B9':'hercon','\u22BA':'intcal','\u22BB':'veebar','\u22BD':'barvee','\u22BE':'angrtvb','\u22BF':'lrtri','\u22C0':'Wedge','\u22C1':'Vee','\u22C2':'xcap','\u22C3':'xcup','\u22C4':'diam','\u22C5':'sdot','\u22C6':'Star','\u22C7':'divonx','\u22C8':'bowtie','\u22C9':'ltimes','\u22CA':'rtimes','\u22CB':'lthree','\u22CC':'rthree','\u22CD':'bsime','\u22CE':'cuvee','\u22CF':'cuwed','\u22D0':'Sub','\u22D1':'Sup','\u22D2':'Cap','\u22D3':'Cup','\u22D4':'fork','\u22D5':'epar','\u22D6':'ltdot','\u22D7':'gtdot','\u22D8':'Ll','\u22D8\u0338':'nLl','\u22D9':'Gg','\u22D9\u0338':'nGg','\u22DA\uFE00':'lesg','\u22DA':'leg','\u22DB':'gel','\u22DB\uFE00':'gesl','\u22DE':'cuepr','\u22DF':'cuesc','\u22E6':'lnsim','\u22E7':'gnsim','\u22E8':'prnsim','\u22E9':'scnsim','\u22EE':'vellip','\u22EF':'ctdot','\u22F0':'utdot','\u22F1':'dtdot','\u22F2':'disin','\u22F3':'isinsv','\u22F4':'isins','\u22F5':'isindot','\u22F5\u0338':'notindot','\u22F6':'notinvc','\u22F7':'notinvb','\u22F9':'isinE','\u22F9\u0338':'notinE','\u22FA':'nisd','\u22FB':'xnis','\u22FC':'nis','\u22FD':'notnivc','\u22FE':'notnivb','\u2305':'barwed','\u2306':'Barwed','\u230C':'drcrop','\u230D':'dlcrop','\u230E':'urcrop','\u230F':'ulcrop','\u2310':'bnot','\u2312':'profline','\u2313':'profsurf','\u2315':'telrec','\u2316':'target','\u231C':'ulcorn','\u231D':'urcorn','\u231E':'dlcorn','\u231F':'drcorn','\u2322':'frown','\u2323':'smile','\u232D':'cylcty','\u232E':'profalar','\u2336':'topbot','\u233D':'ovbar','\u233F':'solbar','\u237C':'angzarr','\u23B0':'lmoust','\u23B1':'rmoust','\u23B4':'tbrk','\u23B5':'bbrk','\u23B6':'bbrktbrk','\u23DC':'OverParenthesis','\u23DD':'UnderParenthesis','\u23DE':'OverBrace','\u23DF':'UnderBrace','\u23E2':'trpezium','\u23E7':'elinters','\u2423':'blank','\u2500':'boxh','\u2502':'boxv','\u250C':'boxdr','\u2510':'boxdl','\u2514':'boxur','\u2518':'boxul','\u251C':'boxvr','\u2524':'boxvl','\u252C':'boxhd','\u2534':'boxhu','\u253C':'boxvh','\u2550':'boxH','\u2551':'boxV','\u2552':'boxdR','\u2553':'boxDr','\u2554':'boxDR','\u2555':'boxdL','\u2556':'boxDl','\u2557':'boxDL','\u2558':'boxuR','\u2559':'boxUr','\u255A':'boxUR','\u255B':'boxuL','\u255C':'boxUl','\u255D':'boxUL','\u255E':'boxvR','\u255F':'boxVr','\u2560':'boxVR','\u2561':'boxvL','\u2562':'boxVl','\u2563':'boxVL','\u2564':'boxHd','\u2565':'boxhD','\u2566':'boxHD','\u2567':'boxHu','\u2568':'boxhU','\u2569':'boxHU','\u256A':'boxvH','\u256B':'boxVh','\u256C':'boxVH','\u2580':'uhblk','\u2584':'lhblk','\u2588':'block','\u2591':'blk14','\u2592':'blk12','\u2593':'blk34','\u25A1':'squ','\u25AA':'squf','\u25AB':'EmptyVerySmallSquare','\u25AD':'rect','\u25AE':'marker','\u25B1':'fltns','\u25B3':'xutri','\u25B4':'utrif','\u25B5':'utri','\u25B8':'rtrif','\u25B9':'rtri','\u25BD':'xdtri','\u25BE':'dtrif','\u25BF':'dtri','\u25C2':'ltrif','\u25C3':'ltri','\u25CA':'loz','\u25CB':'cir','\u25EC':'tridot','\u25EF':'xcirc','\u25F8':'ultri','\u25F9':'urtri','\u25FA':'lltri','\u25FB':'EmptySmallSquare','\u25FC':'FilledSmallSquare','\u2605':'starf','\u2606':'star','\u260E':'phone','\u2640':'female','\u2642':'male','\u2660':'spades','\u2663':'clubs','\u2665':'hearts','\u2666':'diams','\u266A':'sung','\u2713':'check','\u2717':'cross','\u2720':'malt','\u2736':'sext','\u2758':'VerticalSeparator','\u27C8':'bsolhsub','\u27C9':'suphsol','\u27F5':'xlarr','\u27F6':'xrarr','\u27F7':'xharr','\u27F8':'xlArr','\u27F9':'xrArr','\u27FA':'xhArr','\u27FC':'xmap','\u27FF':'dzigrarr','\u2902':'nvlArr','\u2903':'nvrArr','\u2904':'nvHarr','\u2905':'Map','\u290C':'lbarr','\u290D':'rbarr','\u290E':'lBarr','\u290F':'rBarr','\u2910':'RBarr','\u2911':'DDotrahd','\u2912':'UpArrowBar','\u2913':'DownArrowBar','\u2916':'Rarrtl','\u2919':'latail','\u291A':'ratail','\u291B':'lAtail','\u291C':'rAtail','\u291D':'larrfs','\u291E':'rarrfs','\u291F':'larrbfs','\u2920':'rarrbfs','\u2923':'nwarhk','\u2924':'nearhk','\u2925':'searhk','\u2926':'swarhk','\u2927':'nwnear','\u2928':'toea','\u2929':'tosa','\u292A':'swnwar','\u2933':'rarrc','\u2933\u0338':'nrarrc','\u2935':'cudarrr','\u2936':'ldca','\u2937':'rdca','\u2938':'cudarrl','\u2939':'larrpl','\u293C':'curarrm','\u293D':'cularrp','\u2945':'rarrpl','\u2948':'harrcir','\u2949':'Uarrocir','\u294A':'lurdshar','\u294B':'ldrushar','\u294E':'LeftRightVector','\u294F':'RightUpDownVector','\u2950':'DownLeftRightVector','\u2951':'LeftUpDownVector','\u2952':'LeftVectorBar','\u2953':'RightVectorBar','\u2954':'RightUpVectorBar','\u2955':'RightDownVectorBar','\u2956':'DownLeftVectorBar','\u2957':'DownRightVectorBar','\u2958':'LeftUpVectorBar','\u2959':'LeftDownVectorBar','\u295A':'LeftTeeVector','\u295B':'RightTeeVector','\u295C':'RightUpTeeVector','\u295D':'RightDownTeeVector','\u295E':'DownLeftTeeVector','\u295F':'DownRightTeeVector','\u2960':'LeftUpTeeVector','\u2961':'LeftDownTeeVector','\u2962':'lHar','\u2963':'uHar','\u2964':'rHar','\u2965':'dHar','\u2966':'luruhar','\u2967':'ldrdhar','\u2968':'ruluhar','\u2969':'rdldhar','\u296A':'lharul','\u296B':'llhard','\u296C':'rharul','\u296D':'lrhard','\u296E':'udhar','\u296F':'duhar','\u2970':'RoundImplies','\u2971':'erarr','\u2972':'simrarr','\u2973':'larrsim','\u2974':'rarrsim','\u2975':'rarrap','\u2976':'ltlarr','\u2978':'gtrarr','\u2979':'subrarr','\u297B':'suplarr','\u297C':'lfisht','\u297D':'rfisht','\u297E':'ufisht','\u297F':'dfisht','\u299A':'vzigzag','\u299C':'vangrt','\u299D':'angrtvbd','\u29A4':'ange','\u29A5':'range','\u29A6':'dwangle','\u29A7':'uwangle','\u29A8':'angmsdaa','\u29A9':'angmsdab','\u29AA':'angmsdac','\u29AB':'angmsdad','\u29AC':'angmsdae','\u29AD':'angmsdaf','\u29AE':'angmsdag','\u29AF':'angmsdah','\u29B0':'bemptyv','\u29B1':'demptyv','\u29B2':'cemptyv','\u29B3':'raemptyv','\u29B4':'laemptyv','\u29B5':'ohbar','\u29B6':'omid','\u29B7':'opar','\u29B9':'operp','\u29BB':'olcross','\u29BC':'odsold','\u29BE':'olcir','\u29BF':'ofcir','\u29C0':'olt','\u29C1':'ogt','\u29C2':'cirscir','\u29C3':'cirE','\u29C4':'solb','\u29C5':'bsolb','\u29C9':'boxbox','\u29CD':'trisb','\u29CE':'rtriltri','\u29CF':'LeftTriangleBar','\u29CF\u0338':'NotLeftTriangleBar','\u29D0':'RightTriangleBar','\u29D0\u0338':'NotRightTriangleBar','\u29DC':'iinfin','\u29DD':'infintie','\u29DE':'nvinfin','\u29E3':'eparsl','\u29E4':'smeparsl','\u29E5':'eqvparsl','\u29EB':'lozf','\u29F4':'RuleDelayed','\u29F6':'dsol','\u2A00':'xodot','\u2A01':'xoplus','\u2A02':'xotime','\u2A04':'xuplus','\u2A06':'xsqcup','\u2A0D':'fpartint','\u2A10':'cirfnint','\u2A11':'awint','\u2A12':'rppolint','\u2A13':'scpolint','\u2A14':'npolint','\u2A15':'pointint','\u2A16':'quatint','\u2A17':'intlarhk','\u2A22':'pluscir','\u2A23':'plusacir','\u2A24':'simplus','\u2A25':'plusdu','\u2A26':'plussim','\u2A27':'plustwo','\u2A29':'mcomma','\u2A2A':'minusdu','\u2A2D':'loplus','\u2A2E':'roplus','\u2A2F':'Cross','\u2A30':'timesd','\u2A31':'timesbar','\u2A33':'smashp','\u2A34':'lotimes','\u2A35':'rotimes','\u2A36':'otimesas','\u2A37':'Otimes','\u2A38':'odiv','\u2A39':'triplus','\u2A3A':'triminus','\u2A3B':'tritime','\u2A3C':'iprod','\u2A3F':'amalg','\u2A40':'capdot','\u2A42':'ncup','\u2A43':'ncap','\u2A44':'capand','\u2A45':'cupor','\u2A46':'cupcap','\u2A47':'capcup','\u2A48':'cupbrcap','\u2A49':'capbrcup','\u2A4A':'cupcup','\u2A4B':'capcap','\u2A4C':'ccups','\u2A4D':'ccaps','\u2A50':'ccupssm','\u2A53':'And','\u2A54':'Or','\u2A55':'andand','\u2A56':'oror','\u2A57':'orslope','\u2A58':'andslope','\u2A5A':'andv','\u2A5B':'orv','\u2A5C':'andd','\u2A5D':'ord','\u2A5F':'wedbar','\u2A66':'sdote','\u2A6A':'simdot','\u2A6D':'congdot','\u2A6D\u0338':'ncongdot','\u2A6E':'easter','\u2A6F':'apacir','\u2A70':'apE','\u2A70\u0338':'napE','\u2A71':'eplus','\u2A72':'pluse','\u2A73':'Esim','\u2A77':'eDDot','\u2A78':'equivDD','\u2A79':'ltcir','\u2A7A':'gtcir','\u2A7B':'ltquest','\u2A7C':'gtquest','\u2A7D':'les','\u2A7D\u0338':'nles','\u2A7E':'ges','\u2A7E\u0338':'nges','\u2A7F':'lesdot','\u2A80':'gesdot','\u2A81':'lesdoto','\u2A82':'gesdoto','\u2A83':'lesdotor','\u2A84':'gesdotol','\u2A85':'lap','\u2A86':'gap','\u2A87':'lne','\u2A88':'gne','\u2A89':'lnap','\u2A8A':'gnap','\u2A8B':'lEg','\u2A8C':'gEl','\u2A8D':'lsime','\u2A8E':'gsime','\u2A8F':'lsimg','\u2A90':'gsiml','\u2A91':'lgE','\u2A92':'glE','\u2A93':'lesges','\u2A94':'gesles','\u2A95':'els','\u2A96':'egs','\u2A97':'elsdot','\u2A98':'egsdot','\u2A99':'el','\u2A9A':'eg','\u2A9D':'siml','\u2A9E':'simg','\u2A9F':'simlE','\u2AA0':'simgE','\u2AA1':'LessLess','\u2AA1\u0338':'NotNestedLessLess','\u2AA2':'GreaterGreater','\u2AA2\u0338':'NotNestedGreaterGreater','\u2AA4':'glj','\u2AA5':'gla','\u2AA6':'ltcc','\u2AA7':'gtcc','\u2AA8':'lescc','\u2AA9':'gescc','\u2AAA':'smt','\u2AAB':'lat','\u2AAC':'smte','\u2AAC\uFE00':'smtes','\u2AAD':'late','\u2AAD\uFE00':'lates','\u2AAE':'bumpE','\u2AAF':'pre','\u2AAF\u0338':'npre','\u2AB0':'sce','\u2AB0\u0338':'nsce','\u2AB3':'prE','\u2AB4':'scE','\u2AB5':'prnE','\u2AB6':'scnE','\u2AB7':'prap','\u2AB8':'scap','\u2AB9':'prnap','\u2ABA':'scnap','\u2ABB':'Pr','\u2ABC':'Sc','\u2ABD':'subdot','\u2ABE':'supdot','\u2ABF':'subplus','\u2AC0':'supplus','\u2AC1':'submult','\u2AC2':'supmult','\u2AC3':'subedot','\u2AC4':'supedot','\u2AC5':'subE','\u2AC5\u0338':'nsubE','\u2AC6':'supE','\u2AC6\u0338':'nsupE','\u2AC7':'subsim','\u2AC8':'supsim','\u2ACB\uFE00':'vsubnE','\u2ACB':'subnE','\u2ACC\uFE00':'vsupnE','\u2ACC':'supnE','\u2ACF':'csub','\u2AD0':'csup','\u2AD1':'csube','\u2AD2':'csupe','\u2AD3':'subsup','\u2AD4':'supsub','\u2AD5':'subsub','\u2AD6':'supsup','\u2AD7':'suphsub','\u2AD8':'supdsub','\u2AD9':'forkv','\u2ADA':'topfork','\u2ADB':'mlcp','\u2AE4':'Dashv','\u2AE6':'Vdashl','\u2AE7':'Barv','\u2AE8':'vBar','\u2AE9':'vBarv','\u2AEB':'Vbar','\u2AEC':'Not','\u2AED':'bNot','\u2AEE':'rnmid','\u2AEF':'cirmid','\u2AF0':'midcir','\u2AF1':'topcir','\u2AF2':'nhpar','\u2AF3':'parsim','\u2AFD':'parsl','\u2AFD\u20E5':'nparsl','\u266D':'flat','\u266E':'natur','\u266F':'sharp','\xA4':'curren','\xA2':'cent','$':'dollar','\xA3':'pound','\xA5':'yen','\u20AC':'euro','\xB9':'sup1','\xBD':'half','\u2153':'frac13','\xBC':'frac14','\u2155':'frac15','\u2159':'frac16','\u215B':'frac18','\xB2':'sup2','\u2154':'frac23','\u2156':'frac25','\xB3':'sup3','\xBE':'frac34','\u2157':'frac35','\u215C':'frac38','\u2158':'frac45','\u215A':'frac56','\u215D':'frac58','\u215E':'frac78','\uD835\uDCB6':'ascr','\uD835\uDD52':'aopf','\uD835\uDD1E':'afr','\uD835\uDD38':'Aopf','\uD835\uDD04':'Afr','\uD835\uDC9C':'Ascr','\xAA':'ordf','\xE1':'aacute','\xC1':'Aacute','\xE0':'agrave','\xC0':'Agrave','\u0103':'abreve','\u0102':'Abreve','\xE2':'acirc','\xC2':'Acirc','\xE5':'aring','\xC5':'angst','\xE4':'auml','\xC4':'Auml','\xE3':'atilde','\xC3':'Atilde','\u0105':'aogon','\u0104':'Aogon','\u0101':'amacr','\u0100':'Amacr','\xE6':'aelig','\xC6':'AElig','\uD835\uDCB7':'bscr','\uD835\uDD53':'bopf','\uD835\uDD1F':'bfr','\uD835\uDD39':'Bopf','\u212C':'Bscr','\uD835\uDD05':'Bfr','\uD835\uDD20':'cfr','\uD835\uDCB8':'cscr','\uD835\uDD54':'copf','\u212D':'Cfr','\uD835\uDC9E':'Cscr','\u2102':'Copf','\u0107':'cacute','\u0106':'Cacute','\u0109':'ccirc','\u0108':'Ccirc','\u010D':'ccaron','\u010C':'Ccaron','\u010B':'cdot','\u010A':'Cdot','\xE7':'ccedil','\xC7':'Ccedil','\u2105':'incare','\uD835\uDD21':'dfr','\u2146':'dd','\uD835\uDD55':'dopf','\uD835\uDCB9':'dscr','\uD835\uDC9F':'Dscr','\uD835\uDD07':'Dfr','\u2145':'DD','\uD835\uDD3B':'Dopf','\u010F':'dcaron','\u010E':'Dcaron','\u0111':'dstrok','\u0110':'Dstrok','\xF0':'eth','\xD0':'ETH','\u2147':'ee','\u212F':'escr','\uD835\uDD22':'efr','\uD835\uDD56':'eopf','\u2130':'Escr','\uD835\uDD08':'Efr','\uD835\uDD3C':'Eopf','\xE9':'eacute','\xC9':'Eacute','\xE8':'egrave','\xC8':'Egrave','\xEA':'ecirc','\xCA':'Ecirc','\u011B':'ecaron','\u011A':'Ecaron','\xEB':'euml','\xCB':'Euml','\u0117':'edot','\u0116':'Edot','\u0119':'eogon','\u0118':'Eogon','\u0113':'emacr','\u0112':'Emacr','\uD835\uDD23':'ffr','\uD835\uDD57':'fopf','\uD835\uDCBB':'fscr','\uD835\uDD09':'Ffr','\uD835\uDD3D':'Fopf','\u2131':'Fscr','\uFB00':'fflig','\uFB03':'ffilig','\uFB04':'ffllig','\uFB01':'filig','fj':'fjlig','\uFB02':'fllig','\u0192':'fnof','\u210A':'gscr','\uD835\uDD58':'gopf','\uD835\uDD24':'gfr','\uD835\uDCA2':'Gscr','\uD835\uDD3E':'Gopf','\uD835\uDD0A':'Gfr','\u01F5':'gacute','\u011F':'gbreve','\u011E':'Gbreve','\u011D':'gcirc','\u011C':'Gcirc','\u0121':'gdot','\u0120':'Gdot','\u0122':'Gcedil','\uD835\uDD25':'hfr','\u210E':'planckh','\uD835\uDCBD':'hscr','\uD835\uDD59':'hopf','\u210B':'Hscr','\u210C':'Hfr','\u210D':'Hopf','\u0125':'hcirc','\u0124':'Hcirc','\u210F':'hbar','\u0127':'hstrok','\u0126':'Hstrok','\uD835\uDD5A':'iopf','\uD835\uDD26':'ifr','\uD835\uDCBE':'iscr','\u2148':'ii','\uD835\uDD40':'Iopf','\u2110':'Iscr','\u2111':'Im','\xED':'iacute','\xCD':'Iacute','\xEC':'igrave','\xCC':'Igrave','\xEE':'icirc','\xCE':'Icirc','\xEF':'iuml','\xCF':'Iuml','\u0129':'itilde','\u0128':'Itilde','\u0130':'Idot','\u012F':'iogon','\u012E':'Iogon','\u012B':'imacr','\u012A':'Imacr','\u0133':'ijlig','\u0132':'IJlig','\u0131':'imath','\uD835\uDCBF':'jscr','\uD835\uDD5B':'jopf','\uD835\uDD27':'jfr','\uD835\uDCA5':'Jscr','\uD835\uDD0D':'Jfr','\uD835\uDD41':'Jopf','\u0135':'jcirc','\u0134':'Jcirc','\u0237':'jmath','\uD835\uDD5C':'kopf','\uD835\uDCC0':'kscr','\uD835\uDD28':'kfr','\uD835\uDCA6':'Kscr','\uD835\uDD42':'Kopf','\uD835\uDD0E':'Kfr','\u0137':'kcedil','\u0136':'Kcedil','\uD835\uDD29':'lfr','\uD835\uDCC1':'lscr','\u2113':'ell','\uD835\uDD5D':'lopf','\u2112':'Lscr','\uD835\uDD0F':'Lfr','\uD835\uDD43':'Lopf','\u013A':'lacute','\u0139':'Lacute','\u013E':'lcaron','\u013D':'Lcaron','\u013C':'lcedil','\u013B':'Lcedil','\u0142':'lstrok','\u0141':'Lstrok','\u0140':'lmidot','\u013F':'Lmidot','\uD835\uDD2A':'mfr','\uD835\uDD5E':'mopf','\uD835\uDCC2':'mscr','\uD835\uDD10':'Mfr','\uD835\uDD44':'Mopf','\u2133':'Mscr','\uD835\uDD2B':'nfr','\uD835\uDD5F':'nopf','\uD835\uDCC3':'nscr','\u2115':'Nopf','\uD835\uDCA9':'Nscr','\uD835\uDD11':'Nfr','\u0144':'nacute','\u0143':'Nacute','\u0148':'ncaron','\u0147':'Ncaron','\xF1':'ntilde','\xD1':'Ntilde','\u0146':'ncedil','\u0145':'Ncedil','\u2116':'numero','\u014B':'eng','\u014A':'ENG','\uD835\uDD60':'oopf','\uD835\uDD2C':'ofr','\u2134':'oscr','\uD835\uDCAA':'Oscr','\uD835\uDD12':'Ofr','\uD835\uDD46':'Oopf','\xBA':'ordm','\xF3':'oacute','\xD3':'Oacute','\xF2':'ograve','\xD2':'Ograve','\xF4':'ocirc','\xD4':'Ocirc','\xF6':'ouml','\xD6':'Ouml','\u0151':'odblac','\u0150':'Odblac','\xF5':'otilde','\xD5':'Otilde','\xF8':'oslash','\xD8':'Oslash','\u014D':'omacr','\u014C':'Omacr','\u0153':'oelig','\u0152':'OElig','\uD835\uDD2D':'pfr','\uD835\uDCC5':'pscr','\uD835\uDD61':'popf','\u2119':'Popf','\uD835\uDD13':'Pfr','\uD835\uDCAB':'Pscr','\uD835\uDD62':'qopf','\uD835\uDD2E':'qfr','\uD835\uDCC6':'qscr','\uD835\uDCAC':'Qscr','\uD835\uDD14':'Qfr','\u211A':'Qopf','\u0138':'kgreen','\uD835\uDD2F':'rfr','\uD835\uDD63':'ropf','\uD835\uDCC7':'rscr','\u211B':'Rscr','\u211C':'Re','\u211D':'Ropf','\u0155':'racute','\u0154':'Racute','\u0159':'rcaron','\u0158':'Rcaron','\u0157':'rcedil','\u0156':'Rcedil','\uD835\uDD64':'sopf','\uD835\uDCC8':'sscr','\uD835\uDD30':'sfr','\uD835\uDD4A':'Sopf','\uD835\uDD16':'Sfr','\uD835\uDCAE':'Sscr','\u24C8':'oS','\u015B':'sacute','\u015A':'Sacute','\u015D':'scirc','\u015C':'Scirc','\u0161':'scaron','\u0160':'Scaron','\u015F':'scedil','\u015E':'Scedil','\xDF':'szlig','\uD835\uDD31':'tfr','\uD835\uDCC9':'tscr','\uD835\uDD65':'topf','\uD835\uDCAF':'Tscr','\uD835\uDD17':'Tfr','\uD835\uDD4B':'Topf','\u0165':'tcaron','\u0164':'Tcaron','\u0163':'tcedil','\u0162':'Tcedil','\u2122':'trade','\u0167':'tstrok','\u0166':'Tstrok','\uD835\uDCCA':'uscr','\uD835\uDD66':'uopf','\uD835\uDD32':'ufr','\uD835\uDD4C':'Uopf','\uD835\uDD18':'Ufr','\uD835\uDCB0':'Uscr','\xFA':'uacute','\xDA':'Uacute','\xF9':'ugrave','\xD9':'Ugrave','\u016D':'ubreve','\u016C':'Ubreve','\xFB':'ucirc','\xDB':'Ucirc','\u016F':'uring','\u016E':'Uring','\xFC':'uuml','\xDC':'Uuml','\u0171':'udblac','\u0170':'Udblac','\u0169':'utilde','\u0168':'Utilde','\u0173':'uogon','\u0172':'Uogon','\u016B':'umacr','\u016A':'Umacr','\uD835\uDD33':'vfr','\uD835\uDD67':'vopf','\uD835\uDCCB':'vscr','\uD835\uDD19':'Vfr','\uD835\uDD4D':'Vopf','\uD835\uDCB1':'Vscr','\uD835\uDD68':'wopf','\uD835\uDCCC':'wscr','\uD835\uDD34':'wfr','\uD835\uDCB2':'Wscr','\uD835\uDD4E':'Wopf','\uD835\uDD1A':'Wfr','\u0175':'wcirc','\u0174':'Wcirc','\uD835\uDD35':'xfr','\uD835\uDCCD':'xscr','\uD835\uDD69':'xopf','\uD835\uDD4F':'Xopf','\uD835\uDD1B':'Xfr','\uD835\uDCB3':'Xscr','\uD835\uDD36':'yfr','\uD835\uDCCE':'yscr','\uD835\uDD6A':'yopf','\uD835\uDCB4':'Yscr','\uD835\uDD1C':'Yfr','\uD835\uDD50':'Yopf','\xFD':'yacute','\xDD':'Yacute','\u0177':'ycirc','\u0176':'Ycirc','\xFF':'yuml','\u0178':'Yuml','\uD835\uDCCF':'zscr','\uD835\uDD37':'zfr','\uD835\uDD6B':'zopf','\u2128':'Zfr','\u2124':'Zopf','\uD835\uDCB5':'Zscr','\u017A':'zacute','\u0179':'Zacute','\u017E':'zcaron','\u017D':'Zcaron','\u017C':'zdot','\u017B':'Zdot','\u01B5':'imped','\xFE':'thorn','\xDE':'THORN','\u0149':'napos','\u03B1':'alpha','\u0391':'Alpha','\u03B2':'beta','\u0392':'Beta','\u03B3':'gamma','\u0393':'Gamma','\u03B4':'delta','\u0394':'Delta','\u03B5':'epsi','\u03F5':'epsiv','\u0395':'Epsilon','\u03DD':'gammad','\u03DC':'Gammad','\u03B6':'zeta','\u0396':'Zeta','\u03B7':'eta','\u0397':'Eta','\u03B8':'theta','\u03D1':'thetav','\u0398':'Theta','\u03B9':'iota','\u0399':'Iota','\u03BA':'kappa','\u03F0':'kappav','\u039A':'Kappa','\u03BB':'lambda','\u039B':'Lambda','\u03BC':'mu','\xB5':'micro','\u039C':'Mu','\u03BD':'nu','\u039D':'Nu','\u03BE':'xi','\u039E':'Xi','\u03BF':'omicron','\u039F':'Omicron','\u03C0':'pi','\u03D6':'piv','\u03A0':'Pi','\u03C1':'rho','\u03F1':'rhov','\u03A1':'Rho','\u03C3':'sigma','\u03A3':'Sigma','\u03C2':'sigmaf','\u03C4':'tau','\u03A4':'Tau','\u03C5':'upsi','\u03A5':'Upsilon','\u03D2':'Upsi','\u03C6':'phi','\u03D5':'phiv','\u03A6':'Phi','\u03C7':'chi','\u03A7':'Chi','\u03C8':'psi','\u03A8':'Psi','\u03C9':'omega','\u03A9':'ohm','\u0430':'acy','\u0410':'Acy','\u0431':'bcy','\u0411':'Bcy','\u0432':'vcy','\u0412':'Vcy','\u0433':'gcy','\u0413':'Gcy','\u0453':'gjcy','\u0403':'GJcy','\u0434':'dcy','\u0414':'Dcy','\u0452':'djcy','\u0402':'DJcy','\u0435':'iecy','\u0415':'IEcy','\u0451':'iocy','\u0401':'IOcy','\u0454':'jukcy','\u0404':'Jukcy','\u0436':'zhcy','\u0416':'ZHcy','\u0437':'zcy','\u0417':'Zcy','\u0455':'dscy','\u0405':'DScy','\u0438':'icy','\u0418':'Icy','\u0456':'iukcy','\u0406':'Iukcy','\u0457':'yicy','\u0407':'YIcy','\u0439':'jcy','\u0419':'Jcy','\u0458':'jsercy','\u0408':'Jsercy','\u043A':'kcy','\u041A':'Kcy','\u045C':'kjcy','\u040C':'KJcy','\u043B':'lcy','\u041B':'Lcy','\u0459':'ljcy','\u0409':'LJcy','\u043C':'mcy','\u041C':'Mcy','\u043D':'ncy','\u041D':'Ncy','\u045A':'njcy','\u040A':'NJcy','\u043E':'ocy','\u041E':'Ocy','\u043F':'pcy','\u041F':'Pcy','\u0440':'rcy','\u0420':'Rcy','\u0441':'scy','\u0421':'Scy','\u0442':'tcy','\u0422':'Tcy','\u045B':'tshcy','\u040B':'TSHcy','\u0443':'ucy','\u0423':'Ucy','\u045E':'ubrcy','\u040E':'Ubrcy','\u0444':'fcy','\u0424':'Fcy','\u0445':'khcy','\u0425':'KHcy','\u0446':'tscy','\u0426':'TScy','\u0447':'chcy','\u0427':'CHcy','\u045F':'dzcy','\u040F':'DZcy','\u0448':'shcy','\u0428':'SHcy','\u0449':'shchcy','\u0429':'SHCHcy','\u044A':'hardcy','\u042A':'HARDcy','\u044B':'ycy','\u042B':'Ycy','\u044C':'softcy','\u042C':'SOFTcy','\u044D':'ecy','\u042D':'Ecy','\u044E':'yucy','\u042E':'YUcy','\u044F':'yacy','\u042F':'YAcy','\u2135':'aleph','\u2136':'beth','\u2137':'gimel','\u2138':'daleth'};

	var regexEscape = /["&'<>`]/g;
	var escapeMap = {
		'"': '&quot;',
		'&': '&amp;',
		'\'': '&#x27;',
		'<': '&lt;',
		// See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
		// following is not strictly necessary unless it’s part of a tag or an
		// unquoted attribute value. We’re only escaping it to support those
		// situations, and for XML support.
		'>': '&gt;',
		// In Internet Explorer ≤ 8, the backtick character can be used
		// to break out of (un)quoted attribute values or HTML comments.
		// See http://html5sec.org/#102, http://html5sec.org/#108, and
		// http://html5sec.org/#133.
		'`': '&#x60;'
	};

	var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
	var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
	var regexDecode = /&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g;
	var decodeMap = {'aacute':'\xE1','Aacute':'\xC1','abreve':'\u0103','Abreve':'\u0102','ac':'\u223E','acd':'\u223F','acE':'\u223E\u0333','acirc':'\xE2','Acirc':'\xC2','acute':'\xB4','acy':'\u0430','Acy':'\u0410','aelig':'\xE6','AElig':'\xC6','af':'\u2061','afr':'\uD835\uDD1E','Afr':'\uD835\uDD04','agrave':'\xE0','Agrave':'\xC0','alefsym':'\u2135','aleph':'\u2135','alpha':'\u03B1','Alpha':'\u0391','amacr':'\u0101','Amacr':'\u0100','amalg':'\u2A3F','amp':'&','AMP':'&','and':'\u2227','And':'\u2A53','andand':'\u2A55','andd':'\u2A5C','andslope':'\u2A58','andv':'\u2A5A','ang':'\u2220','ange':'\u29A4','angle':'\u2220','angmsd':'\u2221','angmsdaa':'\u29A8','angmsdab':'\u29A9','angmsdac':'\u29AA','angmsdad':'\u29AB','angmsdae':'\u29AC','angmsdaf':'\u29AD','angmsdag':'\u29AE','angmsdah':'\u29AF','angrt':'\u221F','angrtvb':'\u22BE','angrtvbd':'\u299D','angsph':'\u2222','angst':'\xC5','angzarr':'\u237C','aogon':'\u0105','Aogon':'\u0104','aopf':'\uD835\uDD52','Aopf':'\uD835\uDD38','ap':'\u2248','apacir':'\u2A6F','ape':'\u224A','apE':'\u2A70','apid':'\u224B','apos':'\'','ApplyFunction':'\u2061','approx':'\u2248','approxeq':'\u224A','aring':'\xE5','Aring':'\xC5','ascr':'\uD835\uDCB6','Ascr':'\uD835\uDC9C','Assign':'\u2254','ast':'*','asymp':'\u2248','asympeq':'\u224D','atilde':'\xE3','Atilde':'\xC3','auml':'\xE4','Auml':'\xC4','awconint':'\u2233','awint':'\u2A11','backcong':'\u224C','backepsilon':'\u03F6','backprime':'\u2035','backsim':'\u223D','backsimeq':'\u22CD','Backslash':'\u2216','Barv':'\u2AE7','barvee':'\u22BD','barwed':'\u2305','Barwed':'\u2306','barwedge':'\u2305','bbrk':'\u23B5','bbrktbrk':'\u23B6','bcong':'\u224C','bcy':'\u0431','Bcy':'\u0411','bdquo':'\u201E','becaus':'\u2235','because':'\u2235','Because':'\u2235','bemptyv':'\u29B0','bepsi':'\u03F6','bernou':'\u212C','Bernoullis':'\u212C','beta':'\u03B2','Beta':'\u0392','beth':'\u2136','between':'\u226C','bfr':'\uD835\uDD1F','Bfr':'\uD835\uDD05','bigcap':'\u22C2','bigcirc':'\u25EF','bigcup':'\u22C3','bigodot':'\u2A00','bigoplus':'\u2A01','bigotimes':'\u2A02','bigsqcup':'\u2A06','bigstar':'\u2605','bigtriangledown':'\u25BD','bigtriangleup':'\u25B3','biguplus':'\u2A04','bigvee':'\u22C1','bigwedge':'\u22C0','bkarow':'\u290D','blacklozenge':'\u29EB','blacksquare':'\u25AA','blacktriangle':'\u25B4','blacktriangledown':'\u25BE','blacktriangleleft':'\u25C2','blacktriangleright':'\u25B8','blank':'\u2423','blk12':'\u2592','blk14':'\u2591','blk34':'\u2593','block':'\u2588','bne':'=\u20E5','bnequiv':'\u2261\u20E5','bnot':'\u2310','bNot':'\u2AED','bopf':'\uD835\uDD53','Bopf':'\uD835\uDD39','bot':'\u22A5','bottom':'\u22A5','bowtie':'\u22C8','boxbox':'\u29C9','boxdl':'\u2510','boxdL':'\u2555','boxDl':'\u2556','boxDL':'\u2557','boxdr':'\u250C','boxdR':'\u2552','boxDr':'\u2553','boxDR':'\u2554','boxh':'\u2500','boxH':'\u2550','boxhd':'\u252C','boxhD':'\u2565','boxHd':'\u2564','boxHD':'\u2566','boxhu':'\u2534','boxhU':'\u2568','boxHu':'\u2567','boxHU':'\u2569','boxminus':'\u229F','boxplus':'\u229E','boxtimes':'\u22A0','boxul':'\u2518','boxuL':'\u255B','boxUl':'\u255C','boxUL':'\u255D','boxur':'\u2514','boxuR':'\u2558','boxUr':'\u2559','boxUR':'\u255A','boxv':'\u2502','boxV':'\u2551','boxvh':'\u253C','boxvH':'\u256A','boxVh':'\u256B','boxVH':'\u256C','boxvl':'\u2524','boxvL':'\u2561','boxVl':'\u2562','boxVL':'\u2563','boxvr':'\u251C','boxvR':'\u255E','boxVr':'\u255F','boxVR':'\u2560','bprime':'\u2035','breve':'\u02D8','Breve':'\u02D8','brvbar':'\xA6','bscr':'\uD835\uDCB7','Bscr':'\u212C','bsemi':'\u204F','bsim':'\u223D','bsime':'\u22CD','bsol':'\\','bsolb':'\u29C5','bsolhsub':'\u27C8','bull':'\u2022','bullet':'\u2022','bump':'\u224E','bumpe':'\u224F','bumpE':'\u2AAE','bumpeq':'\u224F','Bumpeq':'\u224E','cacute':'\u0107','Cacute':'\u0106','cap':'\u2229','Cap':'\u22D2','capand':'\u2A44','capbrcup':'\u2A49','capcap':'\u2A4B','capcup':'\u2A47','capdot':'\u2A40','CapitalDifferentialD':'\u2145','caps':'\u2229\uFE00','caret':'\u2041','caron':'\u02C7','Cayleys':'\u212D','ccaps':'\u2A4D','ccaron':'\u010D','Ccaron':'\u010C','ccedil':'\xE7','Ccedil':'\xC7','ccirc':'\u0109','Ccirc':'\u0108','Cconint':'\u2230','ccups':'\u2A4C','ccupssm':'\u2A50','cdot':'\u010B','Cdot':'\u010A','cedil':'\xB8','Cedilla':'\xB8','cemptyv':'\u29B2','cent':'\xA2','centerdot':'\xB7','CenterDot':'\xB7','cfr':'\uD835\uDD20','Cfr':'\u212D','chcy':'\u0447','CHcy':'\u0427','check':'\u2713','checkmark':'\u2713','chi':'\u03C7','Chi':'\u03A7','cir':'\u25CB','circ':'\u02C6','circeq':'\u2257','circlearrowleft':'\u21BA','circlearrowright':'\u21BB','circledast':'\u229B','circledcirc':'\u229A','circleddash':'\u229D','CircleDot':'\u2299','circledR':'\xAE','circledS':'\u24C8','CircleMinus':'\u2296','CirclePlus':'\u2295','CircleTimes':'\u2297','cire':'\u2257','cirE':'\u29C3','cirfnint':'\u2A10','cirmid':'\u2AEF','cirscir':'\u29C2','ClockwiseContourIntegral':'\u2232','CloseCurlyDoubleQuote':'\u201D','CloseCurlyQuote':'\u2019','clubs':'\u2663','clubsuit':'\u2663','colon':':','Colon':'\u2237','colone':'\u2254','Colone':'\u2A74','coloneq':'\u2254','comma':',','commat':'@','comp':'\u2201','compfn':'\u2218','complement':'\u2201','complexes':'\u2102','cong':'\u2245','congdot':'\u2A6D','Congruent':'\u2261','conint':'\u222E','Conint':'\u222F','ContourIntegral':'\u222E','copf':'\uD835\uDD54','Copf':'\u2102','coprod':'\u2210','Coproduct':'\u2210','copy':'\xA9','COPY':'\xA9','copysr':'\u2117','CounterClockwiseContourIntegral':'\u2233','crarr':'\u21B5','cross':'\u2717','Cross':'\u2A2F','cscr':'\uD835\uDCB8','Cscr':'\uD835\uDC9E','csub':'\u2ACF','csube':'\u2AD1','csup':'\u2AD0','csupe':'\u2AD2','ctdot':'\u22EF','cudarrl':'\u2938','cudarrr':'\u2935','cuepr':'\u22DE','cuesc':'\u22DF','cularr':'\u21B6','cularrp':'\u293D','cup':'\u222A','Cup':'\u22D3','cupbrcap':'\u2A48','cupcap':'\u2A46','CupCap':'\u224D','cupcup':'\u2A4A','cupdot':'\u228D','cupor':'\u2A45','cups':'\u222A\uFE00','curarr':'\u21B7','curarrm':'\u293C','curlyeqprec':'\u22DE','curlyeqsucc':'\u22DF','curlyvee':'\u22CE','curlywedge':'\u22CF','curren':'\xA4','curvearrowleft':'\u21B6','curvearrowright':'\u21B7','cuvee':'\u22CE','cuwed':'\u22CF','cwconint':'\u2232','cwint':'\u2231','cylcty':'\u232D','dagger':'\u2020','Dagger':'\u2021','daleth':'\u2138','darr':'\u2193','dArr':'\u21D3','Darr':'\u21A1','dash':'\u2010','dashv':'\u22A3','Dashv':'\u2AE4','dbkarow':'\u290F','dblac':'\u02DD','dcaron':'\u010F','Dcaron':'\u010E','dcy':'\u0434','Dcy':'\u0414','dd':'\u2146','DD':'\u2145','ddagger':'\u2021','ddarr':'\u21CA','DDotrahd':'\u2911','ddotseq':'\u2A77','deg':'\xB0','Del':'\u2207','delta':'\u03B4','Delta':'\u0394','demptyv':'\u29B1','dfisht':'\u297F','dfr':'\uD835\uDD21','Dfr':'\uD835\uDD07','dHar':'\u2965','dharl':'\u21C3','dharr':'\u21C2','DiacriticalAcute':'\xB4','DiacriticalDot':'\u02D9','DiacriticalDoubleAcute':'\u02DD','DiacriticalGrave':'`','DiacriticalTilde':'\u02DC','diam':'\u22C4','diamond':'\u22C4','Diamond':'\u22C4','diamondsuit':'\u2666','diams':'\u2666','die':'\xA8','DifferentialD':'\u2146','digamma':'\u03DD','disin':'\u22F2','div':'\xF7','divide':'\xF7','divideontimes':'\u22C7','divonx':'\u22C7','djcy':'\u0452','DJcy':'\u0402','dlcorn':'\u231E','dlcrop':'\u230D','dollar':'$','dopf':'\uD835\uDD55','Dopf':'\uD835\uDD3B','dot':'\u02D9','Dot':'\xA8','DotDot':'\u20DC','doteq':'\u2250','doteqdot':'\u2251','DotEqual':'\u2250','dotminus':'\u2238','dotplus':'\u2214','dotsquare':'\u22A1','doublebarwedge':'\u2306','DoubleContourIntegral':'\u222F','DoubleDot':'\xA8','DoubleDownArrow':'\u21D3','DoubleLeftArrow':'\u21D0','DoubleLeftRightArrow':'\u21D4','DoubleLeftTee':'\u2AE4','DoubleLongLeftArrow':'\u27F8','DoubleLongLeftRightArrow':'\u27FA','DoubleLongRightArrow':'\u27F9','DoubleRightArrow':'\u21D2','DoubleRightTee':'\u22A8','DoubleUpArrow':'\u21D1','DoubleUpDownArrow':'\u21D5','DoubleVerticalBar':'\u2225','downarrow':'\u2193','Downarrow':'\u21D3','DownArrow':'\u2193','DownArrowBar':'\u2913','DownArrowUpArrow':'\u21F5','DownBreve':'\u0311','downdownarrows':'\u21CA','downharpoonleft':'\u21C3','downharpoonright':'\u21C2','DownLeftRightVector':'\u2950','DownLeftTeeVector':'\u295E','DownLeftVector':'\u21BD','DownLeftVectorBar':'\u2956','DownRightTeeVector':'\u295F','DownRightVector':'\u21C1','DownRightVectorBar':'\u2957','DownTee':'\u22A4','DownTeeArrow':'\u21A7','drbkarow':'\u2910','drcorn':'\u231F','drcrop':'\u230C','dscr':'\uD835\uDCB9','Dscr':'\uD835\uDC9F','dscy':'\u0455','DScy':'\u0405','dsol':'\u29F6','dstrok':'\u0111','Dstrok':'\u0110','dtdot':'\u22F1','dtri':'\u25BF','dtrif':'\u25BE','duarr':'\u21F5','duhar':'\u296F','dwangle':'\u29A6','dzcy':'\u045F','DZcy':'\u040F','dzigrarr':'\u27FF','eacute':'\xE9','Eacute':'\xC9','easter':'\u2A6E','ecaron':'\u011B','Ecaron':'\u011A','ecir':'\u2256','ecirc':'\xEA','Ecirc':'\xCA','ecolon':'\u2255','ecy':'\u044D','Ecy':'\u042D','eDDot':'\u2A77','edot':'\u0117','eDot':'\u2251','Edot':'\u0116','ee':'\u2147','efDot':'\u2252','efr':'\uD835\uDD22','Efr':'\uD835\uDD08','eg':'\u2A9A','egrave':'\xE8','Egrave':'\xC8','egs':'\u2A96','egsdot':'\u2A98','el':'\u2A99','Element':'\u2208','elinters':'\u23E7','ell':'\u2113','els':'\u2A95','elsdot':'\u2A97','emacr':'\u0113','Emacr':'\u0112','empty':'\u2205','emptyset':'\u2205','EmptySmallSquare':'\u25FB','emptyv':'\u2205','EmptyVerySmallSquare':'\u25AB','emsp':'\u2003','emsp13':'\u2004','emsp14':'\u2005','eng':'\u014B','ENG':'\u014A','ensp':'\u2002','eogon':'\u0119','Eogon':'\u0118','eopf':'\uD835\uDD56','Eopf':'\uD835\uDD3C','epar':'\u22D5','eparsl':'\u29E3','eplus':'\u2A71','epsi':'\u03B5','epsilon':'\u03B5','Epsilon':'\u0395','epsiv':'\u03F5','eqcirc':'\u2256','eqcolon':'\u2255','eqsim':'\u2242','eqslantgtr':'\u2A96','eqslantless':'\u2A95','Equal':'\u2A75','equals':'=','EqualTilde':'\u2242','equest':'\u225F','Equilibrium':'\u21CC','equiv':'\u2261','equivDD':'\u2A78','eqvparsl':'\u29E5','erarr':'\u2971','erDot':'\u2253','escr':'\u212F','Escr':'\u2130','esdot':'\u2250','esim':'\u2242','Esim':'\u2A73','eta':'\u03B7','Eta':'\u0397','eth':'\xF0','ETH':'\xD0','euml':'\xEB','Euml':'\xCB','euro':'\u20AC','excl':'!','exist':'\u2203','Exists':'\u2203','expectation':'\u2130','exponentiale':'\u2147','ExponentialE':'\u2147','fallingdotseq':'\u2252','fcy':'\u0444','Fcy':'\u0424','female':'\u2640','ffilig':'\uFB03','fflig':'\uFB00','ffllig':'\uFB04','ffr':'\uD835\uDD23','Ffr':'\uD835\uDD09','filig':'\uFB01','FilledSmallSquare':'\u25FC','FilledVerySmallSquare':'\u25AA','fjlig':'fj','flat':'\u266D','fllig':'\uFB02','fltns':'\u25B1','fnof':'\u0192','fopf':'\uD835\uDD57','Fopf':'\uD835\uDD3D','forall':'\u2200','ForAll':'\u2200','fork':'\u22D4','forkv':'\u2AD9','Fouriertrf':'\u2131','fpartint':'\u2A0D','frac12':'\xBD','frac13':'\u2153','frac14':'\xBC','frac15':'\u2155','frac16':'\u2159','frac18':'\u215B','frac23':'\u2154','frac25':'\u2156','frac34':'\xBE','frac35':'\u2157','frac38':'\u215C','frac45':'\u2158','frac56':'\u215A','frac58':'\u215D','frac78':'\u215E','frasl':'\u2044','frown':'\u2322','fscr':'\uD835\uDCBB','Fscr':'\u2131','gacute':'\u01F5','gamma':'\u03B3','Gamma':'\u0393','gammad':'\u03DD','Gammad':'\u03DC','gap':'\u2A86','gbreve':'\u011F','Gbreve':'\u011E','Gcedil':'\u0122','gcirc':'\u011D','Gcirc':'\u011C','gcy':'\u0433','Gcy':'\u0413','gdot':'\u0121','Gdot':'\u0120','ge':'\u2265','gE':'\u2267','gel':'\u22DB','gEl':'\u2A8C','geq':'\u2265','geqq':'\u2267','geqslant':'\u2A7E','ges':'\u2A7E','gescc':'\u2AA9','gesdot':'\u2A80','gesdoto':'\u2A82','gesdotol':'\u2A84','gesl':'\u22DB\uFE00','gesles':'\u2A94','gfr':'\uD835\uDD24','Gfr':'\uD835\uDD0A','gg':'\u226B','Gg':'\u22D9','ggg':'\u22D9','gimel':'\u2137','gjcy':'\u0453','GJcy':'\u0403','gl':'\u2277','gla':'\u2AA5','glE':'\u2A92','glj':'\u2AA4','gnap':'\u2A8A','gnapprox':'\u2A8A','gne':'\u2A88','gnE':'\u2269','gneq':'\u2A88','gneqq':'\u2269','gnsim':'\u22E7','gopf':'\uD835\uDD58','Gopf':'\uD835\uDD3E','grave':'`','GreaterEqual':'\u2265','GreaterEqualLess':'\u22DB','GreaterFullEqual':'\u2267','GreaterGreater':'\u2AA2','GreaterLess':'\u2277','GreaterSlantEqual':'\u2A7E','GreaterTilde':'\u2273','gscr':'\u210A','Gscr':'\uD835\uDCA2','gsim':'\u2273','gsime':'\u2A8E','gsiml':'\u2A90','gt':'>','Gt':'\u226B','GT':'>','gtcc':'\u2AA7','gtcir':'\u2A7A','gtdot':'\u22D7','gtlPar':'\u2995','gtquest':'\u2A7C','gtrapprox':'\u2A86','gtrarr':'\u2978','gtrdot':'\u22D7','gtreqless':'\u22DB','gtreqqless':'\u2A8C','gtrless':'\u2277','gtrsim':'\u2273','gvertneqq':'\u2269\uFE00','gvnE':'\u2269\uFE00','Hacek':'\u02C7','hairsp':'\u200A','half':'\xBD','hamilt':'\u210B','hardcy':'\u044A','HARDcy':'\u042A','harr':'\u2194','hArr':'\u21D4','harrcir':'\u2948','harrw':'\u21AD','Hat':'^','hbar':'\u210F','hcirc':'\u0125','Hcirc':'\u0124','hearts':'\u2665','heartsuit':'\u2665','hellip':'\u2026','hercon':'\u22B9','hfr':'\uD835\uDD25','Hfr':'\u210C','HilbertSpace':'\u210B','hksearow':'\u2925','hkswarow':'\u2926','hoarr':'\u21FF','homtht':'\u223B','hookleftarrow':'\u21A9','hookrightarrow':'\u21AA','hopf':'\uD835\uDD59','Hopf':'\u210D','horbar':'\u2015','HorizontalLine':'\u2500','hscr':'\uD835\uDCBD','Hscr':'\u210B','hslash':'\u210F','hstrok':'\u0127','Hstrok':'\u0126','HumpDownHump':'\u224E','HumpEqual':'\u224F','hybull':'\u2043','hyphen':'\u2010','iacute':'\xED','Iacute':'\xCD','ic':'\u2063','icirc':'\xEE','Icirc':'\xCE','icy':'\u0438','Icy':'\u0418','Idot':'\u0130','iecy':'\u0435','IEcy':'\u0415','iexcl':'\xA1','iff':'\u21D4','ifr':'\uD835\uDD26','Ifr':'\u2111','igrave':'\xEC','Igrave':'\xCC','ii':'\u2148','iiiint':'\u2A0C','iiint':'\u222D','iinfin':'\u29DC','iiota':'\u2129','ijlig':'\u0133','IJlig':'\u0132','Im':'\u2111','imacr':'\u012B','Imacr':'\u012A','image':'\u2111','ImaginaryI':'\u2148','imagline':'\u2110','imagpart':'\u2111','imath':'\u0131','imof':'\u22B7','imped':'\u01B5','Implies':'\u21D2','in':'\u2208','incare':'\u2105','infin':'\u221E','infintie':'\u29DD','inodot':'\u0131','int':'\u222B','Int':'\u222C','intcal':'\u22BA','integers':'\u2124','Integral':'\u222B','intercal':'\u22BA','Intersection':'\u22C2','intlarhk':'\u2A17','intprod':'\u2A3C','InvisibleComma':'\u2063','InvisibleTimes':'\u2062','iocy':'\u0451','IOcy':'\u0401','iogon':'\u012F','Iogon':'\u012E','iopf':'\uD835\uDD5A','Iopf':'\uD835\uDD40','iota':'\u03B9','Iota':'\u0399','iprod':'\u2A3C','iquest':'\xBF','iscr':'\uD835\uDCBE','Iscr':'\u2110','isin':'\u2208','isindot':'\u22F5','isinE':'\u22F9','isins':'\u22F4','isinsv':'\u22F3','isinv':'\u2208','it':'\u2062','itilde':'\u0129','Itilde':'\u0128','iukcy':'\u0456','Iukcy':'\u0406','iuml':'\xEF','Iuml':'\xCF','jcirc':'\u0135','Jcirc':'\u0134','jcy':'\u0439','Jcy':'\u0419','jfr':'\uD835\uDD27','Jfr':'\uD835\uDD0D','jmath':'\u0237','jopf':'\uD835\uDD5B','Jopf':'\uD835\uDD41','jscr':'\uD835\uDCBF','Jscr':'\uD835\uDCA5','jsercy':'\u0458','Jsercy':'\u0408','jukcy':'\u0454','Jukcy':'\u0404','kappa':'\u03BA','Kappa':'\u039A','kappav':'\u03F0','kcedil':'\u0137','Kcedil':'\u0136','kcy':'\u043A','Kcy':'\u041A','kfr':'\uD835\uDD28','Kfr':'\uD835\uDD0E','kgreen':'\u0138','khcy':'\u0445','KHcy':'\u0425','kjcy':'\u045C','KJcy':'\u040C','kopf':'\uD835\uDD5C','Kopf':'\uD835\uDD42','kscr':'\uD835\uDCC0','Kscr':'\uD835\uDCA6','lAarr':'\u21DA','lacute':'\u013A','Lacute':'\u0139','laemptyv':'\u29B4','lagran':'\u2112','lambda':'\u03BB','Lambda':'\u039B','lang':'\u27E8','Lang':'\u27EA','langd':'\u2991','langle':'\u27E8','lap':'\u2A85','Laplacetrf':'\u2112','laquo':'\xAB','larr':'\u2190','lArr':'\u21D0','Larr':'\u219E','larrb':'\u21E4','larrbfs':'\u291F','larrfs':'\u291D','larrhk':'\u21A9','larrlp':'\u21AB','larrpl':'\u2939','larrsim':'\u2973','larrtl':'\u21A2','lat':'\u2AAB','latail':'\u2919','lAtail':'\u291B','late':'\u2AAD','lates':'\u2AAD\uFE00','lbarr':'\u290C','lBarr':'\u290E','lbbrk':'\u2772','lbrace':'{','lbrack':'[','lbrke':'\u298B','lbrksld':'\u298F','lbrkslu':'\u298D','lcaron':'\u013E','Lcaron':'\u013D','lcedil':'\u013C','Lcedil':'\u013B','lceil':'\u2308','lcub':'{','lcy':'\u043B','Lcy':'\u041B','ldca':'\u2936','ldquo':'\u201C','ldquor':'\u201E','ldrdhar':'\u2967','ldrushar':'\u294B','ldsh':'\u21B2','le':'\u2264','lE':'\u2266','LeftAngleBracket':'\u27E8','leftarrow':'\u2190','Leftarrow':'\u21D0','LeftArrow':'\u2190','LeftArrowBar':'\u21E4','LeftArrowRightArrow':'\u21C6','leftarrowtail':'\u21A2','LeftCeiling':'\u2308','LeftDoubleBracket':'\u27E6','LeftDownTeeVector':'\u2961','LeftDownVector':'\u21C3','LeftDownVectorBar':'\u2959','LeftFloor':'\u230A','leftharpoondown':'\u21BD','leftharpoonup':'\u21BC','leftleftarrows':'\u21C7','leftrightarrow':'\u2194','Leftrightarrow':'\u21D4','LeftRightArrow':'\u2194','leftrightarrows':'\u21C6','leftrightharpoons':'\u21CB','leftrightsquigarrow':'\u21AD','LeftRightVector':'\u294E','LeftTee':'\u22A3','LeftTeeArrow':'\u21A4','LeftTeeVector':'\u295A','leftthreetimes':'\u22CB','LeftTriangle':'\u22B2','LeftTriangleBar':'\u29CF','LeftTriangleEqual':'\u22B4','LeftUpDownVector':'\u2951','LeftUpTeeVector':'\u2960','LeftUpVector':'\u21BF','LeftUpVectorBar':'\u2958','LeftVector':'\u21BC','LeftVectorBar':'\u2952','leg':'\u22DA','lEg':'\u2A8B','leq':'\u2264','leqq':'\u2266','leqslant':'\u2A7D','les':'\u2A7D','lescc':'\u2AA8','lesdot':'\u2A7F','lesdoto':'\u2A81','lesdotor':'\u2A83','lesg':'\u22DA\uFE00','lesges':'\u2A93','lessapprox':'\u2A85','lessdot':'\u22D6','lesseqgtr':'\u22DA','lesseqqgtr':'\u2A8B','LessEqualGreater':'\u22DA','LessFullEqual':'\u2266','LessGreater':'\u2276','lessgtr':'\u2276','LessLess':'\u2AA1','lesssim':'\u2272','LessSlantEqual':'\u2A7D','LessTilde':'\u2272','lfisht':'\u297C','lfloor':'\u230A','lfr':'\uD835\uDD29','Lfr':'\uD835\uDD0F','lg':'\u2276','lgE':'\u2A91','lHar':'\u2962','lhard':'\u21BD','lharu':'\u21BC','lharul':'\u296A','lhblk':'\u2584','ljcy':'\u0459','LJcy':'\u0409','ll':'\u226A','Ll':'\u22D8','llarr':'\u21C7','llcorner':'\u231E','Lleftarrow':'\u21DA','llhard':'\u296B','lltri':'\u25FA','lmidot':'\u0140','Lmidot':'\u013F','lmoust':'\u23B0','lmoustache':'\u23B0','lnap':'\u2A89','lnapprox':'\u2A89','lne':'\u2A87','lnE':'\u2268','lneq':'\u2A87','lneqq':'\u2268','lnsim':'\u22E6','loang':'\u27EC','loarr':'\u21FD','lobrk':'\u27E6','longleftarrow':'\u27F5','Longleftarrow':'\u27F8','LongLeftArrow':'\u27F5','longleftrightarrow':'\u27F7','Longleftrightarrow':'\u27FA','LongLeftRightArrow':'\u27F7','longmapsto':'\u27FC','longrightarrow':'\u27F6','Longrightarrow':'\u27F9','LongRightArrow':'\u27F6','looparrowleft':'\u21AB','looparrowright':'\u21AC','lopar':'\u2985','lopf':'\uD835\uDD5D','Lopf':'\uD835\uDD43','loplus':'\u2A2D','lotimes':'\u2A34','lowast':'\u2217','lowbar':'_','LowerLeftArrow':'\u2199','LowerRightArrow':'\u2198','loz':'\u25CA','lozenge':'\u25CA','lozf':'\u29EB','lpar':'(','lparlt':'\u2993','lrarr':'\u21C6','lrcorner':'\u231F','lrhar':'\u21CB','lrhard':'\u296D','lrm':'\u200E','lrtri':'\u22BF','lsaquo':'\u2039','lscr':'\uD835\uDCC1','Lscr':'\u2112','lsh':'\u21B0','Lsh':'\u21B0','lsim':'\u2272','lsime':'\u2A8D','lsimg':'\u2A8F','lsqb':'[','lsquo':'\u2018','lsquor':'\u201A','lstrok':'\u0142','Lstrok':'\u0141','lt':'<','Lt':'\u226A','LT':'<','ltcc':'\u2AA6','ltcir':'\u2A79','ltdot':'\u22D6','lthree':'\u22CB','ltimes':'\u22C9','ltlarr':'\u2976','ltquest':'\u2A7B','ltri':'\u25C3','ltrie':'\u22B4','ltrif':'\u25C2','ltrPar':'\u2996','lurdshar':'\u294A','luruhar':'\u2966','lvertneqq':'\u2268\uFE00','lvnE':'\u2268\uFE00','macr':'\xAF','male':'\u2642','malt':'\u2720','maltese':'\u2720','map':'\u21A6','Map':'\u2905','mapsto':'\u21A6','mapstodown':'\u21A7','mapstoleft':'\u21A4','mapstoup':'\u21A5','marker':'\u25AE','mcomma':'\u2A29','mcy':'\u043C','Mcy':'\u041C','mdash':'\u2014','mDDot':'\u223A','measuredangle':'\u2221','MediumSpace':'\u205F','Mellintrf':'\u2133','mfr':'\uD835\uDD2A','Mfr':'\uD835\uDD10','mho':'\u2127','micro':'\xB5','mid':'\u2223','midast':'*','midcir':'\u2AF0','middot':'\xB7','minus':'\u2212','minusb':'\u229F','minusd':'\u2238','minusdu':'\u2A2A','MinusPlus':'\u2213','mlcp':'\u2ADB','mldr':'\u2026','mnplus':'\u2213','models':'\u22A7','mopf':'\uD835\uDD5E','Mopf':'\uD835\uDD44','mp':'\u2213','mscr':'\uD835\uDCC2','Mscr':'\u2133','mstpos':'\u223E','mu':'\u03BC','Mu':'\u039C','multimap':'\u22B8','mumap':'\u22B8','nabla':'\u2207','nacute':'\u0144','Nacute':'\u0143','nang':'\u2220\u20D2','nap':'\u2249','napE':'\u2A70\u0338','napid':'\u224B\u0338','napos':'\u0149','napprox':'\u2249','natur':'\u266E','natural':'\u266E','naturals':'\u2115','nbsp':'\xA0','nbump':'\u224E\u0338','nbumpe':'\u224F\u0338','ncap':'\u2A43','ncaron':'\u0148','Ncaron':'\u0147','ncedil':'\u0146','Ncedil':'\u0145','ncong':'\u2247','ncongdot':'\u2A6D\u0338','ncup':'\u2A42','ncy':'\u043D','Ncy':'\u041D','ndash':'\u2013','ne':'\u2260','nearhk':'\u2924','nearr':'\u2197','neArr':'\u21D7','nearrow':'\u2197','nedot':'\u2250\u0338','NegativeMediumSpace':'\u200B','NegativeThickSpace':'\u200B','NegativeThinSpace':'\u200B','NegativeVeryThinSpace':'\u200B','nequiv':'\u2262','nesear':'\u2928','nesim':'\u2242\u0338','NestedGreaterGreater':'\u226B','NestedLessLess':'\u226A','NewLine':'\n','nexist':'\u2204','nexists':'\u2204','nfr':'\uD835\uDD2B','Nfr':'\uD835\uDD11','nge':'\u2271','ngE':'\u2267\u0338','ngeq':'\u2271','ngeqq':'\u2267\u0338','ngeqslant':'\u2A7E\u0338','nges':'\u2A7E\u0338','nGg':'\u22D9\u0338','ngsim':'\u2275','ngt':'\u226F','nGt':'\u226B\u20D2','ngtr':'\u226F','nGtv':'\u226B\u0338','nharr':'\u21AE','nhArr':'\u21CE','nhpar':'\u2AF2','ni':'\u220B','nis':'\u22FC','nisd':'\u22FA','niv':'\u220B','njcy':'\u045A','NJcy':'\u040A','nlarr':'\u219A','nlArr':'\u21CD','nldr':'\u2025','nle':'\u2270','nlE':'\u2266\u0338','nleftarrow':'\u219A','nLeftarrow':'\u21CD','nleftrightarrow':'\u21AE','nLeftrightarrow':'\u21CE','nleq':'\u2270','nleqq':'\u2266\u0338','nleqslant':'\u2A7D\u0338','nles':'\u2A7D\u0338','nless':'\u226E','nLl':'\u22D8\u0338','nlsim':'\u2274','nlt':'\u226E','nLt':'\u226A\u20D2','nltri':'\u22EA','nltrie':'\u22EC','nLtv':'\u226A\u0338','nmid':'\u2224','NoBreak':'\u2060','NonBreakingSpace':'\xA0','nopf':'\uD835\uDD5F','Nopf':'\u2115','not':'\xAC','Not':'\u2AEC','NotCongruent':'\u2262','NotCupCap':'\u226D','NotDoubleVerticalBar':'\u2226','NotElement':'\u2209','NotEqual':'\u2260','NotEqualTilde':'\u2242\u0338','NotExists':'\u2204','NotGreater':'\u226F','NotGreaterEqual':'\u2271','NotGreaterFullEqual':'\u2267\u0338','NotGreaterGreater':'\u226B\u0338','NotGreaterLess':'\u2279','NotGreaterSlantEqual':'\u2A7E\u0338','NotGreaterTilde':'\u2275','NotHumpDownHump':'\u224E\u0338','NotHumpEqual':'\u224F\u0338','notin':'\u2209','notindot':'\u22F5\u0338','notinE':'\u22F9\u0338','notinva':'\u2209','notinvb':'\u22F7','notinvc':'\u22F6','NotLeftTriangle':'\u22EA','NotLeftTriangleBar':'\u29CF\u0338','NotLeftTriangleEqual':'\u22EC','NotLess':'\u226E','NotLessEqual':'\u2270','NotLessGreater':'\u2278','NotLessLess':'\u226A\u0338','NotLessSlantEqual':'\u2A7D\u0338','NotLessTilde':'\u2274','NotNestedGreaterGreater':'\u2AA2\u0338','NotNestedLessLess':'\u2AA1\u0338','notni':'\u220C','notniva':'\u220C','notnivb':'\u22FE','notnivc':'\u22FD','NotPrecedes':'\u2280','NotPrecedesEqual':'\u2AAF\u0338','NotPrecedesSlantEqual':'\u22E0','NotReverseElement':'\u220C','NotRightTriangle':'\u22EB','NotRightTriangleBar':'\u29D0\u0338','NotRightTriangleEqual':'\u22ED','NotSquareSubset':'\u228F\u0338','NotSquareSubsetEqual':'\u22E2','NotSquareSuperset':'\u2290\u0338','NotSquareSupersetEqual':'\u22E3','NotSubset':'\u2282\u20D2','NotSubsetEqual':'\u2288','NotSucceeds':'\u2281','NotSucceedsEqual':'\u2AB0\u0338','NotSucceedsSlantEqual':'\u22E1','NotSucceedsTilde':'\u227F\u0338','NotSuperset':'\u2283\u20D2','NotSupersetEqual':'\u2289','NotTilde':'\u2241','NotTildeEqual':'\u2244','NotTildeFullEqual':'\u2247','NotTildeTilde':'\u2249','NotVerticalBar':'\u2224','npar':'\u2226','nparallel':'\u2226','nparsl':'\u2AFD\u20E5','npart':'\u2202\u0338','npolint':'\u2A14','npr':'\u2280','nprcue':'\u22E0','npre':'\u2AAF\u0338','nprec':'\u2280','npreceq':'\u2AAF\u0338','nrarr':'\u219B','nrArr':'\u21CF','nrarrc':'\u2933\u0338','nrarrw':'\u219D\u0338','nrightarrow':'\u219B','nRightarrow':'\u21CF','nrtri':'\u22EB','nrtrie':'\u22ED','nsc':'\u2281','nsccue':'\u22E1','nsce':'\u2AB0\u0338','nscr':'\uD835\uDCC3','Nscr':'\uD835\uDCA9','nshortmid':'\u2224','nshortparallel':'\u2226','nsim':'\u2241','nsime':'\u2244','nsimeq':'\u2244','nsmid':'\u2224','nspar':'\u2226','nsqsube':'\u22E2','nsqsupe':'\u22E3','nsub':'\u2284','nsube':'\u2288','nsubE':'\u2AC5\u0338','nsubset':'\u2282\u20D2','nsubseteq':'\u2288','nsubseteqq':'\u2AC5\u0338','nsucc':'\u2281','nsucceq':'\u2AB0\u0338','nsup':'\u2285','nsupe':'\u2289','nsupE':'\u2AC6\u0338','nsupset':'\u2283\u20D2','nsupseteq':'\u2289','nsupseteqq':'\u2AC6\u0338','ntgl':'\u2279','ntilde':'\xF1','Ntilde':'\xD1','ntlg':'\u2278','ntriangleleft':'\u22EA','ntrianglelefteq':'\u22EC','ntriangleright':'\u22EB','ntrianglerighteq':'\u22ED','nu':'\u03BD','Nu':'\u039D','num':'#','numero':'\u2116','numsp':'\u2007','nvap':'\u224D\u20D2','nvdash':'\u22AC','nvDash':'\u22AD','nVdash':'\u22AE','nVDash':'\u22AF','nvge':'\u2265\u20D2','nvgt':'>\u20D2','nvHarr':'\u2904','nvinfin':'\u29DE','nvlArr':'\u2902','nvle':'\u2264\u20D2','nvlt':'<\u20D2','nvltrie':'\u22B4\u20D2','nvrArr':'\u2903','nvrtrie':'\u22B5\u20D2','nvsim':'\u223C\u20D2','nwarhk':'\u2923','nwarr':'\u2196','nwArr':'\u21D6','nwarrow':'\u2196','nwnear':'\u2927','oacute':'\xF3','Oacute':'\xD3','oast':'\u229B','ocir':'\u229A','ocirc':'\xF4','Ocirc':'\xD4','ocy':'\u043E','Ocy':'\u041E','odash':'\u229D','odblac':'\u0151','Odblac':'\u0150','odiv':'\u2A38','odot':'\u2299','odsold':'\u29BC','oelig':'\u0153','OElig':'\u0152','ofcir':'\u29BF','ofr':'\uD835\uDD2C','Ofr':'\uD835\uDD12','ogon':'\u02DB','ograve':'\xF2','Ograve':'\xD2','ogt':'\u29C1','ohbar':'\u29B5','ohm':'\u03A9','oint':'\u222E','olarr':'\u21BA','olcir':'\u29BE','olcross':'\u29BB','oline':'\u203E','olt':'\u29C0','omacr':'\u014D','Omacr':'\u014C','omega':'\u03C9','Omega':'\u03A9','omicron':'\u03BF','Omicron':'\u039F','omid':'\u29B6','ominus':'\u2296','oopf':'\uD835\uDD60','Oopf':'\uD835\uDD46','opar':'\u29B7','OpenCurlyDoubleQuote':'\u201C','OpenCurlyQuote':'\u2018','operp':'\u29B9','oplus':'\u2295','or':'\u2228','Or':'\u2A54','orarr':'\u21BB','ord':'\u2A5D','order':'\u2134','orderof':'\u2134','ordf':'\xAA','ordm':'\xBA','origof':'\u22B6','oror':'\u2A56','orslope':'\u2A57','orv':'\u2A5B','oS':'\u24C8','oscr':'\u2134','Oscr':'\uD835\uDCAA','oslash':'\xF8','Oslash':'\xD8','osol':'\u2298','otilde':'\xF5','Otilde':'\xD5','otimes':'\u2297','Otimes':'\u2A37','otimesas':'\u2A36','ouml':'\xF6','Ouml':'\xD6','ovbar':'\u233D','OverBar':'\u203E','OverBrace':'\u23DE','OverBracket':'\u23B4','OverParenthesis':'\u23DC','par':'\u2225','para':'\xB6','parallel':'\u2225','parsim':'\u2AF3','parsl':'\u2AFD','part':'\u2202','PartialD':'\u2202','pcy':'\u043F','Pcy':'\u041F','percnt':'%','period':'.','permil':'\u2030','perp':'\u22A5','pertenk':'\u2031','pfr':'\uD835\uDD2D','Pfr':'\uD835\uDD13','phi':'\u03C6','Phi':'\u03A6','phiv':'\u03D5','phmmat':'\u2133','phone':'\u260E','pi':'\u03C0','Pi':'\u03A0','pitchfork':'\u22D4','piv':'\u03D6','planck':'\u210F','planckh':'\u210E','plankv':'\u210F','plus':'+','plusacir':'\u2A23','plusb':'\u229E','pluscir':'\u2A22','plusdo':'\u2214','plusdu':'\u2A25','pluse':'\u2A72','PlusMinus':'\xB1','plusmn':'\xB1','plussim':'\u2A26','plustwo':'\u2A27','pm':'\xB1','Poincareplane':'\u210C','pointint':'\u2A15','popf':'\uD835\uDD61','Popf':'\u2119','pound':'\xA3','pr':'\u227A','Pr':'\u2ABB','prap':'\u2AB7','prcue':'\u227C','pre':'\u2AAF','prE':'\u2AB3','prec':'\u227A','precapprox':'\u2AB7','preccurlyeq':'\u227C','Precedes':'\u227A','PrecedesEqual':'\u2AAF','PrecedesSlantEqual':'\u227C','PrecedesTilde':'\u227E','preceq':'\u2AAF','precnapprox':'\u2AB9','precneqq':'\u2AB5','precnsim':'\u22E8','precsim':'\u227E','prime':'\u2032','Prime':'\u2033','primes':'\u2119','prnap':'\u2AB9','prnE':'\u2AB5','prnsim':'\u22E8','prod':'\u220F','Product':'\u220F','profalar':'\u232E','profline':'\u2312','profsurf':'\u2313','prop':'\u221D','Proportion':'\u2237','Proportional':'\u221D','propto':'\u221D','prsim':'\u227E','prurel':'\u22B0','pscr':'\uD835\uDCC5','Pscr':'\uD835\uDCAB','psi':'\u03C8','Psi':'\u03A8','puncsp':'\u2008','qfr':'\uD835\uDD2E','Qfr':'\uD835\uDD14','qint':'\u2A0C','qopf':'\uD835\uDD62','Qopf':'\u211A','qprime':'\u2057','qscr':'\uD835\uDCC6','Qscr':'\uD835\uDCAC','quaternions':'\u210D','quatint':'\u2A16','quest':'?','questeq':'\u225F','quot':'"','QUOT':'"','rAarr':'\u21DB','race':'\u223D\u0331','racute':'\u0155','Racute':'\u0154','radic':'\u221A','raemptyv':'\u29B3','rang':'\u27E9','Rang':'\u27EB','rangd':'\u2992','range':'\u29A5','rangle':'\u27E9','raquo':'\xBB','rarr':'\u2192','rArr':'\u21D2','Rarr':'\u21A0','rarrap':'\u2975','rarrb':'\u21E5','rarrbfs':'\u2920','rarrc':'\u2933','rarrfs':'\u291E','rarrhk':'\u21AA','rarrlp':'\u21AC','rarrpl':'\u2945','rarrsim':'\u2974','rarrtl':'\u21A3','Rarrtl':'\u2916','rarrw':'\u219D','ratail':'\u291A','rAtail':'\u291C','ratio':'\u2236','rationals':'\u211A','rbarr':'\u290D','rBarr':'\u290F','RBarr':'\u2910','rbbrk':'\u2773','rbrace':'}','rbrack':']','rbrke':'\u298C','rbrksld':'\u298E','rbrkslu':'\u2990','rcaron':'\u0159','Rcaron':'\u0158','rcedil':'\u0157','Rcedil':'\u0156','rceil':'\u2309','rcub':'}','rcy':'\u0440','Rcy':'\u0420','rdca':'\u2937','rdldhar':'\u2969','rdquo':'\u201D','rdquor':'\u201D','rdsh':'\u21B3','Re':'\u211C','real':'\u211C','realine':'\u211B','realpart':'\u211C','reals':'\u211D','rect':'\u25AD','reg':'\xAE','REG':'\xAE','ReverseElement':'\u220B','ReverseEquilibrium':'\u21CB','ReverseUpEquilibrium':'\u296F','rfisht':'\u297D','rfloor':'\u230B','rfr':'\uD835\uDD2F','Rfr':'\u211C','rHar':'\u2964','rhard':'\u21C1','rharu':'\u21C0','rharul':'\u296C','rho':'\u03C1','Rho':'\u03A1','rhov':'\u03F1','RightAngleBracket':'\u27E9','rightarrow':'\u2192','Rightarrow':'\u21D2','RightArrow':'\u2192','RightArrowBar':'\u21E5','RightArrowLeftArrow':'\u21C4','rightarrowtail':'\u21A3','RightCeiling':'\u2309','RightDoubleBracket':'\u27E7','RightDownTeeVector':'\u295D','RightDownVector':'\u21C2','RightDownVectorBar':'\u2955','RightFloor':'\u230B','rightharpoondown':'\u21C1','rightharpoonup':'\u21C0','rightleftarrows':'\u21C4','rightleftharpoons':'\u21CC','rightrightarrows':'\u21C9','rightsquigarrow':'\u219D','RightTee':'\u22A2','RightTeeArrow':'\u21A6','RightTeeVector':'\u295B','rightthreetimes':'\u22CC','RightTriangle':'\u22B3','RightTriangleBar':'\u29D0','RightTriangleEqual':'\u22B5','RightUpDownVector':'\u294F','RightUpTeeVector':'\u295C','RightUpVector':'\u21BE','RightUpVectorBar':'\u2954','RightVector':'\u21C0','RightVectorBar':'\u2953','ring':'\u02DA','risingdotseq':'\u2253','rlarr':'\u21C4','rlhar':'\u21CC','rlm':'\u200F','rmoust':'\u23B1','rmoustache':'\u23B1','rnmid':'\u2AEE','roang':'\u27ED','roarr':'\u21FE','robrk':'\u27E7','ropar':'\u2986','ropf':'\uD835\uDD63','Ropf':'\u211D','roplus':'\u2A2E','rotimes':'\u2A35','RoundImplies':'\u2970','rpar':')','rpargt':'\u2994','rppolint':'\u2A12','rrarr':'\u21C9','Rrightarrow':'\u21DB','rsaquo':'\u203A','rscr':'\uD835\uDCC7','Rscr':'\u211B','rsh':'\u21B1','Rsh':'\u21B1','rsqb':']','rsquo':'\u2019','rsquor':'\u2019','rthree':'\u22CC','rtimes':'\u22CA','rtri':'\u25B9','rtrie':'\u22B5','rtrif':'\u25B8','rtriltri':'\u29CE','RuleDelayed':'\u29F4','ruluhar':'\u2968','rx':'\u211E','sacute':'\u015B','Sacute':'\u015A','sbquo':'\u201A','sc':'\u227B','Sc':'\u2ABC','scap':'\u2AB8','scaron':'\u0161','Scaron':'\u0160','sccue':'\u227D','sce':'\u2AB0','scE':'\u2AB4','scedil':'\u015F','Scedil':'\u015E','scirc':'\u015D','Scirc':'\u015C','scnap':'\u2ABA','scnE':'\u2AB6','scnsim':'\u22E9','scpolint':'\u2A13','scsim':'\u227F','scy':'\u0441','Scy':'\u0421','sdot':'\u22C5','sdotb':'\u22A1','sdote':'\u2A66','searhk':'\u2925','searr':'\u2198','seArr':'\u21D8','searrow':'\u2198','sect':'\xA7','semi':';','seswar':'\u2929','setminus':'\u2216','setmn':'\u2216','sext':'\u2736','sfr':'\uD835\uDD30','Sfr':'\uD835\uDD16','sfrown':'\u2322','sharp':'\u266F','shchcy':'\u0449','SHCHcy':'\u0429','shcy':'\u0448','SHcy':'\u0428','ShortDownArrow':'\u2193','ShortLeftArrow':'\u2190','shortmid':'\u2223','shortparallel':'\u2225','ShortRightArrow':'\u2192','ShortUpArrow':'\u2191','shy':'\xAD','sigma':'\u03C3','Sigma':'\u03A3','sigmaf':'\u03C2','sigmav':'\u03C2','sim':'\u223C','simdot':'\u2A6A','sime':'\u2243','simeq':'\u2243','simg':'\u2A9E','simgE':'\u2AA0','siml':'\u2A9D','simlE':'\u2A9F','simne':'\u2246','simplus':'\u2A24','simrarr':'\u2972','slarr':'\u2190','SmallCircle':'\u2218','smallsetminus':'\u2216','smashp':'\u2A33','smeparsl':'\u29E4','smid':'\u2223','smile':'\u2323','smt':'\u2AAA','smte':'\u2AAC','smtes':'\u2AAC\uFE00','softcy':'\u044C','SOFTcy':'\u042C','sol':'/','solb':'\u29C4','solbar':'\u233F','sopf':'\uD835\uDD64','Sopf':'\uD835\uDD4A','spades':'\u2660','spadesuit':'\u2660','spar':'\u2225','sqcap':'\u2293','sqcaps':'\u2293\uFE00','sqcup':'\u2294','sqcups':'\u2294\uFE00','Sqrt':'\u221A','sqsub':'\u228F','sqsube':'\u2291','sqsubset':'\u228F','sqsubseteq':'\u2291','sqsup':'\u2290','sqsupe':'\u2292','sqsupset':'\u2290','sqsupseteq':'\u2292','squ':'\u25A1','square':'\u25A1','Square':'\u25A1','SquareIntersection':'\u2293','SquareSubset':'\u228F','SquareSubsetEqual':'\u2291','SquareSuperset':'\u2290','SquareSupersetEqual':'\u2292','SquareUnion':'\u2294','squarf':'\u25AA','squf':'\u25AA','srarr':'\u2192','sscr':'\uD835\uDCC8','Sscr':'\uD835\uDCAE','ssetmn':'\u2216','ssmile':'\u2323','sstarf':'\u22C6','star':'\u2606','Star':'\u22C6','starf':'\u2605','straightepsilon':'\u03F5','straightphi':'\u03D5','strns':'\xAF','sub':'\u2282','Sub':'\u22D0','subdot':'\u2ABD','sube':'\u2286','subE':'\u2AC5','subedot':'\u2AC3','submult':'\u2AC1','subne':'\u228A','subnE':'\u2ACB','subplus':'\u2ABF','subrarr':'\u2979','subset':'\u2282','Subset':'\u22D0','subseteq':'\u2286','subseteqq':'\u2AC5','SubsetEqual':'\u2286','subsetneq':'\u228A','subsetneqq':'\u2ACB','subsim':'\u2AC7','subsub':'\u2AD5','subsup':'\u2AD3','succ':'\u227B','succapprox':'\u2AB8','succcurlyeq':'\u227D','Succeeds':'\u227B','SucceedsEqual':'\u2AB0','SucceedsSlantEqual':'\u227D','SucceedsTilde':'\u227F','succeq':'\u2AB0','succnapprox':'\u2ABA','succneqq':'\u2AB6','succnsim':'\u22E9','succsim':'\u227F','SuchThat':'\u220B','sum':'\u2211','Sum':'\u2211','sung':'\u266A','sup':'\u2283','Sup':'\u22D1','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','supdot':'\u2ABE','supdsub':'\u2AD8','supe':'\u2287','supE':'\u2AC6','supedot':'\u2AC4','Superset':'\u2283','SupersetEqual':'\u2287','suphsol':'\u27C9','suphsub':'\u2AD7','suplarr':'\u297B','supmult':'\u2AC2','supne':'\u228B','supnE':'\u2ACC','supplus':'\u2AC0','supset':'\u2283','Supset':'\u22D1','supseteq':'\u2287','supseteqq':'\u2AC6','supsetneq':'\u228B','supsetneqq':'\u2ACC','supsim':'\u2AC8','supsub':'\u2AD4','supsup':'\u2AD6','swarhk':'\u2926','swarr':'\u2199','swArr':'\u21D9','swarrow':'\u2199','swnwar':'\u292A','szlig':'\xDF','Tab':'\t','target':'\u2316','tau':'\u03C4','Tau':'\u03A4','tbrk':'\u23B4','tcaron':'\u0165','Tcaron':'\u0164','tcedil':'\u0163','Tcedil':'\u0162','tcy':'\u0442','Tcy':'\u0422','tdot':'\u20DB','telrec':'\u2315','tfr':'\uD835\uDD31','Tfr':'\uD835\uDD17','there4':'\u2234','therefore':'\u2234','Therefore':'\u2234','theta':'\u03B8','Theta':'\u0398','thetasym':'\u03D1','thetav':'\u03D1','thickapprox':'\u2248','thicksim':'\u223C','ThickSpace':'\u205F\u200A','thinsp':'\u2009','ThinSpace':'\u2009','thkap':'\u2248','thksim':'\u223C','thorn':'\xFE','THORN':'\xDE','tilde':'\u02DC','Tilde':'\u223C','TildeEqual':'\u2243','TildeFullEqual':'\u2245','TildeTilde':'\u2248','times':'\xD7','timesb':'\u22A0','timesbar':'\u2A31','timesd':'\u2A30','tint':'\u222D','toea':'\u2928','top':'\u22A4','topbot':'\u2336','topcir':'\u2AF1','topf':'\uD835\uDD65','Topf':'\uD835\uDD4B','topfork':'\u2ADA','tosa':'\u2929','tprime':'\u2034','trade':'\u2122','TRADE':'\u2122','triangle':'\u25B5','triangledown':'\u25BF','triangleleft':'\u25C3','trianglelefteq':'\u22B4','triangleq':'\u225C','triangleright':'\u25B9','trianglerighteq':'\u22B5','tridot':'\u25EC','trie':'\u225C','triminus':'\u2A3A','TripleDot':'\u20DB','triplus':'\u2A39','trisb':'\u29CD','tritime':'\u2A3B','trpezium':'\u23E2','tscr':'\uD835\uDCC9','Tscr':'\uD835\uDCAF','tscy':'\u0446','TScy':'\u0426','tshcy':'\u045B','TSHcy':'\u040B','tstrok':'\u0167','Tstrok':'\u0166','twixt':'\u226C','twoheadleftarrow':'\u219E','twoheadrightarrow':'\u21A0','uacute':'\xFA','Uacute':'\xDA','uarr':'\u2191','uArr':'\u21D1','Uarr':'\u219F','Uarrocir':'\u2949','ubrcy':'\u045E','Ubrcy':'\u040E','ubreve':'\u016D','Ubreve':'\u016C','ucirc':'\xFB','Ucirc':'\xDB','ucy':'\u0443','Ucy':'\u0423','udarr':'\u21C5','udblac':'\u0171','Udblac':'\u0170','udhar':'\u296E','ufisht':'\u297E','ufr':'\uD835\uDD32','Ufr':'\uD835\uDD18','ugrave':'\xF9','Ugrave':'\xD9','uHar':'\u2963','uharl':'\u21BF','uharr':'\u21BE','uhblk':'\u2580','ulcorn':'\u231C','ulcorner':'\u231C','ulcrop':'\u230F','ultri':'\u25F8','umacr':'\u016B','Umacr':'\u016A','uml':'\xA8','UnderBar':'_','UnderBrace':'\u23DF','UnderBracket':'\u23B5','UnderParenthesis':'\u23DD','Union':'\u22C3','UnionPlus':'\u228E','uogon':'\u0173','Uogon':'\u0172','uopf':'\uD835\uDD66','Uopf':'\uD835\uDD4C','uparrow':'\u2191','Uparrow':'\u21D1','UpArrow':'\u2191','UpArrowBar':'\u2912','UpArrowDownArrow':'\u21C5','updownarrow':'\u2195','Updownarrow':'\u21D5','UpDownArrow':'\u2195','UpEquilibrium':'\u296E','upharpoonleft':'\u21BF','upharpoonright':'\u21BE','uplus':'\u228E','UpperLeftArrow':'\u2196','UpperRightArrow':'\u2197','upsi':'\u03C5','Upsi':'\u03D2','upsih':'\u03D2','upsilon':'\u03C5','Upsilon':'\u03A5','UpTee':'\u22A5','UpTeeArrow':'\u21A5','upuparrows':'\u21C8','urcorn':'\u231D','urcorner':'\u231D','urcrop':'\u230E','uring':'\u016F','Uring':'\u016E','urtri':'\u25F9','uscr':'\uD835\uDCCA','Uscr':'\uD835\uDCB0','utdot':'\u22F0','utilde':'\u0169','Utilde':'\u0168','utri':'\u25B5','utrif':'\u25B4','uuarr':'\u21C8','uuml':'\xFC','Uuml':'\xDC','uwangle':'\u29A7','vangrt':'\u299C','varepsilon':'\u03F5','varkappa':'\u03F0','varnothing':'\u2205','varphi':'\u03D5','varpi':'\u03D6','varpropto':'\u221D','varr':'\u2195','vArr':'\u21D5','varrho':'\u03F1','varsigma':'\u03C2','varsubsetneq':'\u228A\uFE00','varsubsetneqq':'\u2ACB\uFE00','varsupsetneq':'\u228B\uFE00','varsupsetneqq':'\u2ACC\uFE00','vartheta':'\u03D1','vartriangleleft':'\u22B2','vartriangleright':'\u22B3','vBar':'\u2AE8','Vbar':'\u2AEB','vBarv':'\u2AE9','vcy':'\u0432','Vcy':'\u0412','vdash':'\u22A2','vDash':'\u22A8','Vdash':'\u22A9','VDash':'\u22AB','Vdashl':'\u2AE6','vee':'\u2228','Vee':'\u22C1','veebar':'\u22BB','veeeq':'\u225A','vellip':'\u22EE','verbar':'|','Verbar':'\u2016','vert':'|','Vert':'\u2016','VerticalBar':'\u2223','VerticalLine':'|','VerticalSeparator':'\u2758','VerticalTilde':'\u2240','VeryThinSpace':'\u200A','vfr':'\uD835\uDD33','Vfr':'\uD835\uDD19','vltri':'\u22B2','vnsub':'\u2282\u20D2','vnsup':'\u2283\u20D2','vopf':'\uD835\uDD67','Vopf':'\uD835\uDD4D','vprop':'\u221D','vrtri':'\u22B3','vscr':'\uD835\uDCCB','Vscr':'\uD835\uDCB1','vsubne':'\u228A\uFE00','vsubnE':'\u2ACB\uFE00','vsupne':'\u228B\uFE00','vsupnE':'\u2ACC\uFE00','Vvdash':'\u22AA','vzigzag':'\u299A','wcirc':'\u0175','Wcirc':'\u0174','wedbar':'\u2A5F','wedge':'\u2227','Wedge':'\u22C0','wedgeq':'\u2259','weierp':'\u2118','wfr':'\uD835\uDD34','Wfr':'\uD835\uDD1A','wopf':'\uD835\uDD68','Wopf':'\uD835\uDD4E','wp':'\u2118','wr':'\u2240','wreath':'\u2240','wscr':'\uD835\uDCCC','Wscr':'\uD835\uDCB2','xcap':'\u22C2','xcirc':'\u25EF','xcup':'\u22C3','xdtri':'\u25BD','xfr':'\uD835\uDD35','Xfr':'\uD835\uDD1B','xharr':'\u27F7','xhArr':'\u27FA','xi':'\u03BE','Xi':'\u039E','xlarr':'\u27F5','xlArr':'\u27F8','xmap':'\u27FC','xnis':'\u22FB','xodot':'\u2A00','xopf':'\uD835\uDD69','Xopf':'\uD835\uDD4F','xoplus':'\u2A01','xotime':'\u2A02','xrarr':'\u27F6','xrArr':'\u27F9','xscr':'\uD835\uDCCD','Xscr':'\uD835\uDCB3','xsqcup':'\u2A06','xuplus':'\u2A04','xutri':'\u25B3','xvee':'\u22C1','xwedge':'\u22C0','yacute':'\xFD','Yacute':'\xDD','yacy':'\u044F','YAcy':'\u042F','ycirc':'\u0177','Ycirc':'\u0176','ycy':'\u044B','Ycy':'\u042B','yen':'\xA5','yfr':'\uD835\uDD36','Yfr':'\uD835\uDD1C','yicy':'\u0457','YIcy':'\u0407','yopf':'\uD835\uDD6A','Yopf':'\uD835\uDD50','yscr':'\uD835\uDCCE','Yscr':'\uD835\uDCB4','yucy':'\u044E','YUcy':'\u042E','yuml':'\xFF','Yuml':'\u0178','zacute':'\u017A','Zacute':'\u0179','zcaron':'\u017E','Zcaron':'\u017D','zcy':'\u0437','Zcy':'\u0417','zdot':'\u017C','Zdot':'\u017B','zeetrf':'\u2128','ZeroWidthSpace':'\u200B','zeta':'\u03B6','Zeta':'\u0396','zfr':'\uD835\uDD37','Zfr':'\u2128','zhcy':'\u0436','ZHcy':'\u0416','zigrarr':'\u21DD','zopf':'\uD835\uDD6B','Zopf':'\u2124','zscr':'\uD835\uDCCF','Zscr':'\uD835\uDCB5','zwj':'\u200D','zwnj':'\u200C'};
	var decodeMapLegacy = {'aacute':'\xE1','Aacute':'\xC1','acirc':'\xE2','Acirc':'\xC2','acute':'\xB4','aelig':'\xE6','AElig':'\xC6','agrave':'\xE0','Agrave':'\xC0','amp':'&','AMP':'&','aring':'\xE5','Aring':'\xC5','atilde':'\xE3','Atilde':'\xC3','auml':'\xE4','Auml':'\xC4','brvbar':'\xA6','ccedil':'\xE7','Ccedil':'\xC7','cedil':'\xB8','cent':'\xA2','copy':'\xA9','COPY':'\xA9','curren':'\xA4','deg':'\xB0','divide':'\xF7','eacute':'\xE9','Eacute':'\xC9','ecirc':'\xEA','Ecirc':'\xCA','egrave':'\xE8','Egrave':'\xC8','eth':'\xF0','ETH':'\xD0','euml':'\xEB','Euml':'\xCB','frac12':'\xBD','frac14':'\xBC','frac34':'\xBE','gt':'>','GT':'>','iacute':'\xED','Iacute':'\xCD','icirc':'\xEE','Icirc':'\xCE','iexcl':'\xA1','igrave':'\xEC','Igrave':'\xCC','iquest':'\xBF','iuml':'\xEF','Iuml':'\xCF','laquo':'\xAB','lt':'<','LT':'<','macr':'\xAF','micro':'\xB5','middot':'\xB7','nbsp':'\xA0','not':'\xAC','ntilde':'\xF1','Ntilde':'\xD1','oacute':'\xF3','Oacute':'\xD3','ocirc':'\xF4','Ocirc':'\xD4','ograve':'\xF2','Ograve':'\xD2','ordf':'\xAA','ordm':'\xBA','oslash':'\xF8','Oslash':'\xD8','otilde':'\xF5','Otilde':'\xD5','ouml':'\xF6','Ouml':'\xD6','para':'\xB6','plusmn':'\xB1','pound':'\xA3','quot':'"','QUOT':'"','raquo':'\xBB','reg':'\xAE','REG':'\xAE','sect':'\xA7','shy':'\xAD','sup1':'\xB9','sup2':'\xB2','sup3':'\xB3','szlig':'\xDF','thorn':'\xFE','THORN':'\xDE','times':'\xD7','uacute':'\xFA','Uacute':'\xDA','ucirc':'\xFB','Ucirc':'\xDB','ugrave':'\xF9','Ugrave':'\xD9','uml':'\xA8','uuml':'\xFC','Uuml':'\xDC','yacute':'\xFD','Yacute':'\xDD','yen':'\xA5','yuml':'\xFF'};
	var decodeMapNumeric = {'0':'\uFFFD','128':'\u20AC','130':'\u201A','131':'\u0192','132':'\u201E','133':'\u2026','134':'\u2020','135':'\u2021','136':'\u02C6','137':'\u2030','138':'\u0160','139':'\u2039','140':'\u0152','142':'\u017D','145':'\u2018','146':'\u2019','147':'\u201C','148':'\u201D','149':'\u2022','150':'\u2013','151':'\u2014','152':'\u02DC','153':'\u2122','154':'\u0161','155':'\u203A','156':'\u0153','158':'\u017E','159':'\u0178'};
	var invalidReferenceCodePoints = [1,2,3,4,5,6,7,8,11,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152,153,154,155,156,157,158,159,64976,64977,64978,64979,64980,64981,64982,64983,64984,64985,64986,64987,64988,64989,64990,64991,64992,64993,64994,64995,64996,64997,64998,64999,65000,65001,65002,65003,65004,65005,65006,65007,65534,65535,131070,131071,196606,196607,262142,262143,327678,327679,393214,393215,458750,458751,524286,524287,589822,589823,655358,655359,720894,720895,786430,786431,851966,851967,917502,917503,983038,983039,1048574,1048575,1114110,1114111];

	/*--------------------------------------------------------------------------*/

	var stringFromCharCode = String.fromCharCode;

	var object = {};
	var hasOwnProperty = object.hasOwnProperty;
	var has = function(object, propertyName) {
		return hasOwnProperty.call(object, propertyName);
	};

	var contains = function(array, value) {
		var index = -1;
		var length = array.length;
		while (++index < length) {
			if (array[index] == value) {
				return true;
			}
		}
		return false;
	};

	var merge = function(options, defaults) {
		if (!options) {
			return defaults;
		}
		var result = {};
		var key;
		for (key in defaults) {
			// A `hasOwnProperty` check is not needed here, since only recognized
			// option names are used anyway. Any others are ignored.
			result[key] = has(options, key) ? options[key] : defaults[key];
		}
		return result;
	};

	// Modified version of `ucs2encode`; see https://mths.be/punycode.
	var codePointToSymbol = function(codePoint, strict) {
		var output = '';
		if ((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF) {
			// See issue #4:
			// “Otherwise, if the number is in the range 0xD800 to 0xDFFF or is
			// greater than 0x10FFFF, then this is a parse error. Return a U+FFFD
			// REPLACEMENT CHARACTER.”
			if (strict) {
				parseError('character reference outside the permissible Unicode range');
			}
			return '\uFFFD';
		}
		if (has(decodeMapNumeric, codePoint)) {
			if (strict) {
				parseError('disallowed character reference');
			}
			return decodeMapNumeric[codePoint];
		}
		if (strict && contains(invalidReferenceCodePoints, codePoint)) {
			parseError('disallowed character reference');
		}
		if (codePoint > 0xFFFF) {
			codePoint -= 0x10000;
			output += stringFromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
			codePoint = 0xDC00 | codePoint & 0x3FF;
		}
		output += stringFromCharCode(codePoint);
		return output;
	};

	var hexEscape = function(codePoint) {
		return '&#x' + codePoint.toString(16).toUpperCase() + ';';
	};

	var decEscape = function(codePoint) {
		return '&#' + codePoint + ';';
	};

	var parseError = function(message) {
		throw Error('Parse error: ' + message);
	};

	/*--------------------------------------------------------------------------*/

	var encode = function(string, options) {
		options = merge(options, encode.options);
		var strict = options.strict;
		if (strict && regexInvalidRawCodePoint.test(string)) {
			parseError('forbidden code point');
		}
		var encodeEverything = options.encodeEverything;
		var useNamedReferences = options.useNamedReferences;
		var allowUnsafeSymbols = options.allowUnsafeSymbols;
		var escapeCodePoint = options.decimal ? decEscape : hexEscape;

		var escapeBmpSymbol = function(symbol) {
			return escapeCodePoint(symbol.charCodeAt(0));
		};

		if (encodeEverything) {
			// Encode ASCII symbols.
			string = string.replace(regexAsciiWhitelist, function(symbol) {
				// Use named references if requested & possible.
				if (useNamedReferences && has(encodeMap, symbol)) {
					return '&' + encodeMap[symbol] + ';';
				}
				return escapeBmpSymbol(symbol);
			});
			// Shorten a few escapes that represent two symbols, of which at least one
			// is within the ASCII range.
			if (useNamedReferences) {
				string = string
					.replace(/&gt;\u20D2/g, '&nvgt;')
					.replace(/&lt;\u20D2/g, '&nvlt;')
					.replace(/&#x66;&#x6A;/g, '&fjlig;');
			}
			// Encode non-ASCII symbols.
			if (useNamedReferences) {
				// Encode non-ASCII symbols that can be replaced with a named reference.
				string = string.replace(regexEncodeNonAscii, function(string) {
					// Note: there is no need to check `has(encodeMap, string)` here.
					return '&' + encodeMap[string] + ';';
				});
			}
			// Note: any remaining non-ASCII symbols are handled outside of the `if`.
		} else if (useNamedReferences) {
			// Apply named character references.
			// Encode `<>"'&` using named character references.
			if (!allowUnsafeSymbols) {
				string = string.replace(regexEscape, function(string) {
					return '&' + encodeMap[string] + ';'; // no need to check `has()` here
				});
			}
			// Shorten escapes that represent two symbols, of which at least one is
			// `<>"'&`.
			string = string
				.replace(/&gt;\u20D2/g, '&nvgt;')
				.replace(/&lt;\u20D2/g, '&nvlt;');
			// Encode non-ASCII symbols that can be replaced with a named reference.
			string = string.replace(regexEncodeNonAscii, function(string) {
				// Note: there is no need to check `has(encodeMap, string)` here.
				return '&' + encodeMap[string] + ';';
			});
		} else if (!allowUnsafeSymbols) {
			// Encode `<>"'&` using hexadecimal escapes, now that they’re not handled
			// using named character references.
			string = string.replace(regexEscape, escapeBmpSymbol);
		}
		return string
			// Encode astral symbols.
			.replace(regexAstralSymbols, function($0) {
				// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
				var high = $0.charCodeAt(0);
				var low = $0.charCodeAt(1);
				var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
				return escapeCodePoint(codePoint);
			})
			// Encode any remaining BMP symbols that are not printable ASCII symbols
			// using a hexadecimal escape.
			.replace(regexBmpWhitelist, escapeBmpSymbol);
	};
	// Expose default options (so they can be overridden globally).
	encode.options = {
		'allowUnsafeSymbols': false,
		'encodeEverything': false,
		'strict': false,
		'useNamedReferences': false,
		'decimal' : false
	};

	var decode = function(html, options) {
		options = merge(options, decode.options);
		var strict = options.strict;
		if (strict && regexInvalidEntity.test(html)) {
			parseError('malformed character reference');
		}
		return html.replace(regexDecode, function($0, $1, $2, $3, $4, $5, $6, $7, $8) {
			var codePoint;
			var semicolon;
			var decDigits;
			var hexDigits;
			var reference;
			var next;

			if ($1) {
				reference = $1;
				// Note: there is no need to check `has(decodeMap, reference)`.
				return decodeMap[reference];
			}

			if ($2) {
				// Decode named character references without trailing `;`, e.g. `&amp`.
				// This is only a parse error if it gets converted to `&`, or if it is
				// followed by `=` in an attribute context.
				reference = $2;
				next = $3;
				if (next && options.isAttributeValue) {
					if (strict && next == '=') {
						parseError('`&` did not start a character reference');
					}
					return $0;
				} else {
					if (strict) {
						parseError(
							'named character reference was not terminated by a semicolon'
						);
					}
					// Note: there is no need to check `has(decodeMapLegacy, reference)`.
					return decodeMapLegacy[reference] + (next || '');
				}
			}

			if ($4) {
				// Decode decimal escapes, e.g. `&#119558;`.
				decDigits = $4;
				semicolon = $5;
				if (strict && !semicolon) {
					parseError('character reference was not terminated by a semicolon');
				}
				codePoint = parseInt(decDigits, 10);
				return codePointToSymbol(codePoint, strict);
			}

			if ($6) {
				// Decode hexadecimal escapes, e.g. `&#x1D306;`.
				hexDigits = $6;
				semicolon = $7;
				if (strict && !semicolon) {
					parseError('character reference was not terminated by a semicolon');
				}
				codePoint = parseInt(hexDigits, 16);
				return codePointToSymbol(codePoint, strict);
			}

			// If we’re still here, `if ($7)` is implied; it’s an ambiguous
			// ampersand for sure. https://mths.be/notes/ambiguous-ampersands
			if (strict) {
				parseError(
					'named character reference was not terminated by a semicolon'
				);
			}
			return $0;
		});
	};
	// Expose default options (so they can be overridden globally).
	decode.options = {
		'isAttributeValue': false,
		'strict': false
	};

	var escape = function(string) {
		return string.replace(regexEscape, function($0) {
			// Note: there is no need to check `has(escapeMap, $0)` here.
			return escapeMap[$0];
		});
	};

	/*--------------------------------------------------------------------------*/

	var he = {
		'version': '1.2.0',
		'encode': encode,
		'decode': decode,
		'escape': escape,
		'unescape': decode
	};

	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		typeof define == 'function' &&
		typeof define.amd == 'object' &&
		define.amd
	) {
		define(function() {
			return he;
		});
	}	else if (freeExports && !freeExports.nodeType) {
		if (freeModule) { // in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = he;
		} else { // in Narwhal or RingoJS v0.7.0-
			for (var key in he) {
				has(he, key) && (freeExports[key] = he[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.he = he;
	}

}(this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],"C:\\projects\\lightning\\node_modules\\locale\\lib\\index.js":[function(require,module,exports){
(function (process){
// Generated by CoffeeScript 1.6.3
(function() {
  var Locale, Locales, app, _ref,
    __slice = [].slice;

  app = function(supported, def) {
    if (!(supported instanceof Locales)) {
      supported = new Locales(supported, def);
      supported.index();
    }
    return function(req, res, next) {
      var bestLocale, locales;
      locales = new Locales(req.headers["accept-language"]);
      bestLocale = locales.best(supported);
      req.locale = String(bestLocale);
      req.rawLocale = bestLocale;
      return next();
    };
  };

  app.Locale = (function() {
    var serialize;

    Locale["default"] = new Locale(process.env.LANG || "en_US");

    function Locale(str) {
      var country, language, match, normalized;
      if (!(match = str != null ? str.match(/[a-z]+/gi) : void 0)) {
        return;
      }
      language = match[0], country = match[1];
      this.code = str;
      this.language = language.toLowerCase();
      if (country) {
        this.country = country.toUpperCase();
      }
      normalized = [this.language];
      if (this.country) {
        normalized.push(this.country);
      }
      this.normalized = normalized.join("_");
    }

    serialize = function() {
      if (this.language) {
        return this.code;
      } else {
        return null;
      }
    };

    Locale.prototype.toString = serialize;

    Locale.prototype.toJSON = serialize;

    return Locale;

  })();

  app.Locales = (function() {
    var serialize;

    Locales.prototype.length = 0;

    Locales.prototype._index = null;

    Locales.prototype.sort = Array.prototype.sort;

    Locales.prototype.push = Array.prototype.push;

    function Locales(str, def) {
      var item, locale, q, _i, _len, _ref, _ref1;
      if (def) {
        this["default"] = new Locale(def);
      }
      if (!str) {
        return;
      }
      _ref = (String(str)).split(",");
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        item = _ref[_i];
        _ref1 = item.split(";"), locale = _ref1[0], q = _ref1[1];
        locale = new Locale(locale.trim());
        locale.score = q ? +q.slice(2) || 0 : 1;
        this.push(locale);
      }
      this.sort(function(a, b) {
        return b.score - a.score;
      });
    }

    Locales.prototype.index = function() {
      var idx, locale, _i, _len;
      if (!this._index) {
        this._index = {};
        for (idx = _i = 0, _len = this.length; _i < _len; idx = ++_i) {
          locale = this[idx];
          this._index[locale.normalized] = idx;
        }
      }
      return this._index;
    };

    Locales.prototype.best = function(locales) {
      var index, item, l, languageIndex, locale, normalizedIndex, setLocale, _i, _j, _len, _len1;
      setLocale = function(l) {
        var r;
        r = l;
        r.defaulted = false;
        return r;
      };
      locale = Locale["default"];
      if (locales && locales["default"]) {
        locale = locales["default"];
      }
      locale.defaulted = true;
      if (!locales) {
        if (this[0]) {
          locale = this[0];
          locale.defaulted = true;
        }
        return locale;
      }
      index = locales.index();
      for (_i = 0, _len = this.length; _i < _len; _i++) {
        item = this[_i];
        normalizedIndex = index[item.normalized];
        languageIndex = index[item.language];
        if (normalizedIndex != null) {
          return setLocale(locales[normalizedIndex]);
        } else if (languageIndex != null) {
          return setLocale(locales[languageIndex]);
        } else {
          for (_j = 0, _len1 = locales.length; _j < _len1; _j++) {
            l = locales[_j];
            if (l.language === item.language) {
              return setLocale(l);
            }
          }
        }
      }
      return locale;
    };

    serialize = function() {
      return __slice.call(this);
    };

    Locales.prototype.toJSON = serialize;

    Locales.prototype.toString = function() {
      return String(this.toJSON());
    };

    return Locales;

  })();

  _ref = module.exports = app, Locale = _ref.Locale, Locales = _ref.Locales;

}).call(this);

}).call(this,require('_process'))

},{"_process":"C:\\projects\\lightning\\node_modules\\process\\browser.js"}],"C:\\projects\\lightning\\node_modules\\make-plural\\umd\\pluralCategories.js":[function(require,module,exports){
var _cc = [
  {cardinal:["other"],ordinal:["other"]},
  {cardinal:["one","other"],ordinal:["other"]},
  {cardinal:["one","other"],ordinal:["one","other"]},
  {cardinal:["one","two","other"],ordinal:["other"]}
];

(function (root, pluralCategories) {
  if (typeof define === 'function' && define.amd) {
    define(pluralCategories);
  } else if (typeof exports === 'object') {
    module.exports = pluralCategories;
  } else {
    root.pluralCategories = pluralCategories;
  }
}(this, {
af: _cc[1],
ak: _cc[1],
am: _cc[1],
ar: {cardinal:["zero","one","two","few","many","other"],ordinal:["other"]},
ars: {cardinal:["zero","one","two","few","many","other"],ordinal:["other"]},
as: {cardinal:["one","other"],ordinal:["one","two","few","many","other"]},
asa: _cc[1],
ast: _cc[1],
az: {cardinal:["one","other"],ordinal:["one","few","many","other"]},
be: {cardinal:["one","few","many","other"],ordinal:["few","other"]},
bem: _cc[1],
bez: _cc[1],
bg: _cc[1],
bh: _cc[1],
bm: _cc[0],
bn: {cardinal:["one","other"],ordinal:["one","two","few","many","other"]},
bo: _cc[0],
br: {cardinal:["one","two","few","many","other"],ordinal:["other"]},
brx: _cc[1],
bs: {cardinal:["one","few","other"],ordinal:["other"]},
ca: {cardinal:["one","other"],ordinal:["one","two","few","other"]},
ce: _cc[1],
cgg: _cc[1],
chr: _cc[1],
ckb: _cc[1],
cs: {cardinal:["one","few","many","other"],ordinal:["other"]},
cy: {cardinal:["zero","one","two","few","many","other"],ordinal:["zero","one","two","few","many","other"]},
da: _cc[1],
de: _cc[1],
dsb: {cardinal:["one","two","few","other"],ordinal:["other"]},
dv: _cc[1],
dz: _cc[0],
ee: _cc[1],
el: _cc[1],
en: {cardinal:["one","other"],ordinal:["one","two","few","other"]},
eo: _cc[1],
es: _cc[1],
et: _cc[1],
eu: _cc[1],
fa: _cc[1],
ff: _cc[1],
fi: _cc[1],
fil: _cc[2],
fo: _cc[1],
fr: _cc[2],
fur: _cc[1],
fy: _cc[1],
ga: {cardinal:["one","two","few","many","other"],ordinal:["one","other"]},
gd: {cardinal:["one","two","few","other"],ordinal:["one","two","few","other"]},
gl: _cc[1],
gsw: _cc[1],
gu: {cardinal:["one","other"],ordinal:["one","two","few","many","other"]},
guw: _cc[1],
gv: {cardinal:["one","two","few","many","other"],ordinal:["other"]},
ha: _cc[1],
haw: _cc[1],
he: {cardinal:["one","two","many","other"],ordinal:["other"]},
hi: {cardinal:["one","other"],ordinal:["one","two","few","many","other"]},
hr: {cardinal:["one","few","other"],ordinal:["other"]},
hsb: {cardinal:["one","two","few","other"],ordinal:["other"]},
hu: _cc[2],
hy: _cc[2],
ia: _cc[1],
id: _cc[0],
ig: _cc[0],
ii: _cc[0],
"in": _cc[0],
io: _cc[1],
is: _cc[1],
it: {cardinal:["one","other"],ordinal:["many","other"]},
iu: _cc[3],
iw: {cardinal:["one","two","many","other"],ordinal:["other"]},
ja: _cc[0],
jbo: _cc[0],
jgo: _cc[1],
ji: _cc[1],
jmc: _cc[1],
jv: _cc[0],
jw: _cc[0],
ka: {cardinal:["one","other"],ordinal:["one","many","other"]},
kab: _cc[1],
kaj: _cc[1],
kcg: _cc[1],
kde: _cc[0],
kea: _cc[0],
kk: {cardinal:["one","other"],ordinal:["many","other"]},
kkj: _cc[1],
kl: _cc[1],
km: _cc[0],
kn: _cc[1],
ko: _cc[0],
ks: _cc[1],
ksb: _cc[1],
ksh: {cardinal:["zero","one","other"],ordinal:["other"]},
ku: _cc[1],
kw: _cc[3],
ky: _cc[1],
lag: {cardinal:["zero","one","other"],ordinal:["other"]},
lb: _cc[1],
lg: _cc[1],
lkt: _cc[0],
ln: _cc[1],
lo: {cardinal:["other"],ordinal:["one","other"]},
lt: {cardinal:["one","few","many","other"],ordinal:["other"]},
lv: {cardinal:["zero","one","other"],ordinal:["other"]},
mas: _cc[1],
mg: _cc[1],
mgo: _cc[1],
mk: {cardinal:["one","other"],ordinal:["one","two","many","other"]},
ml: _cc[1],
mn: _cc[1],
mo: {cardinal:["one","few","other"],ordinal:["one","other"]},
mr: {cardinal:["one","other"],ordinal:["one","two","few","other"]},
ms: {cardinal:["other"],ordinal:["one","other"]},
mt: {cardinal:["one","few","many","other"],ordinal:["other"]},
my: _cc[0],
nah: _cc[1],
naq: _cc[3],
nb: _cc[1],
nd: _cc[1],
ne: _cc[2],
nl: _cc[1],
nn: _cc[1],
nnh: _cc[1],
no: _cc[1],
nqo: _cc[0],
nr: _cc[1],
nso: _cc[1],
ny: _cc[1],
nyn: _cc[1],
om: _cc[1],
or: {cardinal:["one","other"],ordinal:["one","two","few","many","other"]},
os: _cc[1],
pa: _cc[1],
pap: _cc[1],
pl: {cardinal:["one","few","many","other"],ordinal:["other"]},
prg: {cardinal:["zero","one","other"],ordinal:["other"]},
ps: _cc[1],
pt: _cc[1],
"pt-PT": _cc[1],
rm: _cc[1],
ro: {cardinal:["one","few","other"],ordinal:["one","other"]},
rof: _cc[1],
root: _cc[0],
ru: {cardinal:["one","few","many","other"],ordinal:["other"]},
rwk: _cc[1],
sah: _cc[0],
saq: _cc[1],
sc: {cardinal:["one","other"],ordinal:["many","other"]},
scn: {cardinal:["one","other"],ordinal:["many","other"]},
sd: _cc[1],
sdh: _cc[1],
se: _cc[3],
seh: _cc[1],
ses: _cc[0],
sg: _cc[0],
sh: {cardinal:["one","few","other"],ordinal:["other"]},
shi: {cardinal:["one","few","other"],ordinal:["other"]},
si: _cc[1],
sk: {cardinal:["one","few","many","other"],ordinal:["other"]},
sl: {cardinal:["one","two","few","other"],ordinal:["other"]},
sma: _cc[3],
smi: _cc[3],
smj: _cc[3],
smn: _cc[3],
sms: _cc[3],
sn: _cc[1],
so: _cc[1],
sq: {cardinal:["one","other"],ordinal:["one","many","other"]},
sr: {cardinal:["one","few","other"],ordinal:["other"]},
ss: _cc[1],
ssy: _cc[1],
st: _cc[1],
sv: _cc[2],
sw: _cc[1],
syr: _cc[1],
ta: _cc[1],
te: _cc[1],
teo: _cc[1],
th: _cc[0],
ti: _cc[1],
tig: _cc[1],
tk: {cardinal:["one","other"],ordinal:["few","other"]},
tl: _cc[2],
tn: _cc[1],
to: _cc[0],
tr: _cc[1],
ts: _cc[1],
tzm: _cc[1],
ug: _cc[1],
uk: {cardinal:["one","few","many","other"],ordinal:["few","other"]},
ur: _cc[1],
uz: _cc[1],
ve: _cc[1],
vi: {cardinal:["other"],ordinal:["one","other"]},
vo: _cc[1],
vun: _cc[1],
wa: _cc[1],
wae: _cc[1],
wo: _cc[0],
xh: _cc[1],
xog: _cc[1],
yi: _cc[1],
yo: _cc[0],
yue: _cc[0],
zh: _cc[0],
zu: _cc[1]
}));

},{}],"C:\\projects\\lightning\\node_modules\\make-plural\\umd\\plurals.js":[function(require,module,exports){
var _cp = [
function(n, ord) {
  if (ord) return 'other';
  return 'other';
},
function(n, ord) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},
function(n, ord) {
  if (ord) return 'other';
  return ((n == 0
          || n == 1)) ? 'one' : 'other';
},
function(n, ord) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
}
];

(function (root, plurals) {
  if (typeof define === 'function' && define.amd) {
    define(plurals);
  } else if (typeof exports === 'object') {
    module.exports = plurals;
  } else {
    root.plurals = plurals;
  }
}(this, {
af: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ak: function(n, ord
) {
  if (ord) return 'other';
  return ((n == 0
          || n == 1)) ? 'one' : 'other';
},

am: function(n, ord
) {
  if (ord) return 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
},

ar: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n,
      n100 = t0 && s[0].slice(-2);
  if (ord) return 'other';
  return (n == 0) ? 'zero'
      : (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : ((n100 >= 3 && n100 <= 10)) ? 'few'
      : ((n100 >= 11 && n100 <= 99)) ? 'many'
      : 'other';
},

ars: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n,
      n100 = t0 && s[0].slice(-2);
  if (ord) return 'other';
  return (n == 0) ? 'zero'
      : (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : ((n100 >= 3 && n100 <= 10)) ? 'few'
      : ((n100 >= 11 && n100 <= 99)) ? 'many'
      : 'other';
},

as: function(n, ord
) {
  if (ord) return ((n == 1 || n == 5 || n == 7 || n == 8 || n == 9
          || n == 10)) ? 'one'
      : ((n == 2
          || n == 3)) ? 'two'
      : (n == 4) ? 'few'
      : (n == 6) ? 'many'
      : 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
},

asa: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ast: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

az: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], i10 = i.slice(-1),
      i100 = i.slice(-2), i1000 = i.slice(-3);
  if (ord) return ((i10 == 1 || i10 == 2 || i10 == 5 || i10 == 7 || i10 == 8)
          || (i100 == 20 || i100 == 50 || i100 == 70
          || i100 == 80)) ? 'one'
      : ((i10 == 3 || i10 == 4) || (i1000 == 100 || i1000 == 200
          || i1000 == 300 || i1000 == 400 || i1000 == 500 || i1000 == 600 || i1000 == 700
          || i1000 == 800
          || i1000 == 900)) ? 'few'
      : (i == 0 || i10 == 6 || (i100 == 40 || i100 == 60
          || i100 == 90)) ? 'many'
      : 'other';
  return (n == 1) ? 'one' : 'other';
},

be: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return ((n10 == 2
          || n10 == 3) && n100 != 12 && n100 != 13) ? 'few' : 'other';
  return (n10 == 1 && n100 != 11) ? 'one'
      : ((n10 >= 2 && n10 <= 4) && (n100 < 12
          || n100 > 14)) ? 'few'
      : (t0 && n10 == 0 || (n10 >= 5 && n10 <= 9)
          || (n100 >= 11 && n100 <= 14)) ? 'many'
      : 'other';
},

bem: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

bez: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

bg: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

bh: function(n, ord
) {
  if (ord) return 'other';
  return ((n == 0
          || n == 1)) ? 'one' : 'other';
},

bm: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

bn: function(n, ord
) {
  if (ord) return ((n == 1 || n == 5 || n == 7 || n == 8 || n == 9
          || n == 10)) ? 'one'
      : ((n == 2
          || n == 3)) ? 'two'
      : (n == 4) ? 'few'
      : (n == 6) ? 'many'
      : 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
},

bo: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

br: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2),
      n1000000 = t0 && s[0].slice(-6);
  if (ord) return 'other';
  return (n10 == 1 && n100 != 11 && n100 != 71 && n100 != 91) ? 'one'
      : (n10 == 2 && n100 != 12 && n100 != 72 && n100 != 92) ? 'two'
      : (((n10 == 3 || n10 == 4) || n10 == 9) && (n100 < 10
          || n100 > 19) && (n100 < 70 || n100 > 79) && (n100 < 90
          || n100 > 99)) ? 'few'
      : (n != 0 && t0 && n1000000 == 0) ? 'many'
      : 'other';
},

brx: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

bs: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
  if (ord) return 'other';
  return (v0 && i10 == 1 && i100 != 11
          || f10 == 1 && f100 != 11) ? 'one'
      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14)
          || (f10 >= 2 && f10 <= 4) && (f100 < 12
          || f100 > 14)) ? 'few'
      : 'other';
},

ca: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return ((n == 1
          || n == 3)) ? 'one'
      : (n == 2) ? 'two'
      : (n == 4) ? 'few'
      : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

ce: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

cgg: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

chr: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ckb: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

cs: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one'
      : ((i >= 2 && i <= 4) && v0) ? 'few'
      : (!v0) ? 'many'
      : 'other';
},

cy: function(n, ord
) {
  if (ord) return ((n == 0 || n == 7 || n == 8
          || n == 9)) ? 'zero'
      : (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : ((n == 3
          || n == 4)) ? 'few'
      : ((n == 5
          || n == 6)) ? 'many'
      : 'other';
  return (n == 0) ? 'zero'
      : (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : (n == 3) ? 'few'
      : (n == 6) ? 'many'
      : 'other';
},

da: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], t0 = Number(s[0]) == n;
  if (ord) return 'other';
  return (n == 1 || !t0 && (i == 0
          || i == 1)) ? 'one' : 'other';
},

de: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

dsb: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i100 = i.slice(-2), f100 = f.slice(-2);
  if (ord) return 'other';
  return (v0 && i100 == 1
          || f100 == 1) ? 'one'
      : (v0 && i100 == 2
          || f100 == 2) ? 'two'
      : (v0 && (i100 == 3 || i100 == 4) || (f100 == 3
          || f100 == 4)) ? 'few'
      : 'other';
},

dv: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

dz: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

ee: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

el: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

en: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return (n10 == 1 && n100 != 11) ? 'one'
      : (n10 == 2 && n100 != 12) ? 'two'
      : (n10 == 3 && n100 != 13) ? 'few'
      : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

eo: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

es: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

et: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

eu: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

fa: function(n, ord
) {
  if (ord) return 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
},

ff: function(n, ord
) {
  if (ord) return 'other';
  return (n >= 0 && n < 2) ? 'one' : 'other';
},

fi: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

fil: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i10 = i.slice(-1), f10 = f.slice(-1);
  if (ord) return (n == 1) ? 'one' : 'other';
  return (v0 && (i == 1 || i == 2 || i == 3)
          || v0 && i10 != 4 && i10 != 6 && i10 != 9
          || !v0 && f10 != 4 && f10 != 6 && f10 != 9) ? 'one' : 'other';
},

fo: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

fr: function(n, ord
) {
  if (ord) return (n == 1) ? 'one' : 'other';
  return (n >= 0 && n < 2) ? 'one' : 'other';
},

fur: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

fy: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

ga: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n;
  if (ord) return (n == 1) ? 'one' : 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : ((t0 && n >= 3 && n <= 6)) ? 'few'
      : ((t0 && n >= 7 && n <= 10)) ? 'many'
      : 'other';
},

gd: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n;
  if (ord) return ((n == 1
          || n == 11)) ? 'one'
      : ((n == 2
          || n == 12)) ? 'two'
      : ((n == 3
          || n == 13)) ? 'few'
      : 'other';
  return ((n == 1
          || n == 11)) ? 'one'
      : ((n == 2
          || n == 12)) ? 'two'
      : (((t0 && n >= 3 && n <= 10)
          || (t0 && n >= 13 && n <= 19))) ? 'few'
      : 'other';
},

gl: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

gsw: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

gu: function(n, ord
) {
  if (ord) return (n == 1) ? 'one'
      : ((n == 2
          || n == 3)) ? 'two'
      : (n == 4) ? 'few'
      : (n == 6) ? 'many'
      : 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
},

guw: function(n, ord
) {
  if (ord) return 'other';
  return ((n == 0
          || n == 1)) ? 'one' : 'other';
},

gv: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], i10 = i.slice(-1),
      i100 = i.slice(-2);
  if (ord) return 'other';
  return (v0 && i10 == 1) ? 'one'
      : (v0 && i10 == 2) ? 'two'
      : (v0 && (i100 == 0 || i100 == 20 || i100 == 40 || i100 == 60
          || i100 == 80)) ? 'few'
      : (!v0) ? 'many'
      : 'other';
},

ha: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

haw: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

he: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1);
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one'
      : (i == 2 && v0) ? 'two'
      : (v0 && (n < 0
          || n > 10) && t0 && n10 == 0) ? 'many'
      : 'other';
},

hi: function(n, ord
) {
  if (ord) return (n == 1) ? 'one'
      : ((n == 2
          || n == 3)) ? 'two'
      : (n == 4) ? 'few'
      : (n == 6) ? 'many'
      : 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
},

hr: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
  if (ord) return 'other';
  return (v0 && i10 == 1 && i100 != 11
          || f10 == 1 && f100 != 11) ? 'one'
      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14)
          || (f10 >= 2 && f10 <= 4) && (f100 < 12
          || f100 > 14)) ? 'few'
      : 'other';
},

hsb: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i100 = i.slice(-2), f100 = f.slice(-2);
  if (ord) return 'other';
  return (v0 && i100 == 1
          || f100 == 1) ? 'one'
      : (v0 && i100 == 2
          || f100 == 2) ? 'two'
      : (v0 && (i100 == 3 || i100 == 4) || (f100 == 3
          || f100 == 4)) ? 'few'
      : 'other';
},

hu: function(n, ord
) {
  if (ord) return ((n == 1
          || n == 5)) ? 'one' : 'other';
  return (n == 1) ? 'one' : 'other';
},

hy: function(n, ord
) {
  if (ord) return (n == 1) ? 'one' : 'other';
  return (n >= 0 && n < 2) ? 'one' : 'other';
},

ia: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

id: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

ig: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

ii: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

"in": function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

io: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

is: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], t0 = Number(s[0]) == n,
      i10 = i.slice(-1), i100 = i.slice(-2);
  if (ord) return 'other';
  return (t0 && i10 == 1 && i100 != 11
          || !t0) ? 'one' : 'other';
},

it: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return ((n == 11 || n == 8 || n == 80
          || n == 800)) ? 'many' : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

iu: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

iw: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1);
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one'
      : (i == 2 && v0) ? 'two'
      : (v0 && (n < 0
          || n > 10) && t0 && n10 == 0) ? 'many'
      : 'other';
},

ja: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

jbo: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

jgo: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ji: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

jmc: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

jv: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

jw: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

ka: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], i100 = i.slice(-2);
  if (ord) return (i == 1) ? 'one'
      : (i == 0 || ((i100 >= 2 && i100 <= 20) || i100 == 40 || i100 == 60
          || i100 == 80)) ? 'many'
      : 'other';
  return (n == 1) ? 'one' : 'other';
},

kab: function(n, ord
) {
  if (ord) return 'other';
  return (n >= 0 && n < 2) ? 'one' : 'other';
},

kaj: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

kcg: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

kde: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

kea: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

kk: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1);
  if (ord) return (n10 == 6 || n10 == 9
          || t0 && n10 == 0 && n != 0) ? 'many' : 'other';
  return (n == 1) ? 'one' : 'other';
},

kkj: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

kl: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

km: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

kn: function(n, ord
) {
  if (ord) return 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
},

ko: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

ks: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ksb: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ksh: function(n, ord
) {
  if (ord) return 'other';
  return (n == 0) ? 'zero'
      : (n == 1) ? 'one'
      : 'other';
},

ku: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

kw: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

ky: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

lag: function(n, ord
) {
  var s = String(n).split('.'), i = s[0];
  if (ord) return 'other';
  return (n == 0) ? 'zero'
      : ((i == 0
          || i == 1) && n != 0) ? 'one'
      : 'other';
},

lb: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

lg: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

lkt: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

ln: function(n, ord
) {
  if (ord) return 'other';
  return ((n == 0
          || n == 1)) ? 'one' : 'other';
},

lo: function(n, ord
) {
  if (ord) return (n == 1) ? 'one' : 'other';
  return 'other';
},

lt: function(n, ord
) {
  var s = String(n).split('.'), f = s[1] || '', t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return 'other';
  return (n10 == 1 && (n100 < 11
          || n100 > 19)) ? 'one'
      : ((n10 >= 2 && n10 <= 9) && (n100 < 11
          || n100 > 19)) ? 'few'
      : (f != 0) ? 'many'
      : 'other';
},

lv: function(n, ord
) {
  var s = String(n).split('.'), f = s[1] || '', v = f.length,
      t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1),
      n100 = t0 && s[0].slice(-2), f100 = f.slice(-2), f10 = f.slice(-1);
  if (ord) return 'other';
  return (t0 && n10 == 0 || (n100 >= 11 && n100 <= 19)
          || v == 2 && (f100 >= 11 && f100 <= 19)) ? 'zero'
      : (n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11
          || v != 2 && f10 == 1) ? 'one'
      : 'other';
},

mas: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

mg: function(n, ord
) {
  if (ord) return 'other';
  return ((n == 0
          || n == 1)) ? 'one' : 'other';
},

mgo: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

mk: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
  if (ord) return (i10 == 1 && i100 != 11) ? 'one'
      : (i10 == 2 && i100 != 12) ? 'two'
      : ((i10 == 7
          || i10 == 8) && i100 != 17 && i100 != 18) ? 'many'
      : 'other';
  return (v0 && i10 == 1 && i100 != 11
          || f10 == 1 && f100 != 11) ? 'one' : 'other';
},

ml: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

mn: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

mo: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
      n100 = t0 && s[0].slice(-2);
  if (ord) return (n == 1) ? 'one' : 'other';
  return (n == 1 && v0) ? 'one'
      : (!v0 || n == 0
          || n != 1 && (n100 >= 1 && n100 <= 19)) ? 'few'
      : 'other';
},

mr: function(n, ord
) {
  if (ord) return (n == 1) ? 'one'
      : ((n == 2
          || n == 3)) ? 'two'
      : (n == 4) ? 'few'
      : 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
},

ms: function(n, ord
) {
  if (ord) return (n == 1) ? 'one' : 'other';
  return 'other';
},

mt: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n,
      n100 = t0 && s[0].slice(-2);
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 0
          || (n100 >= 2 && n100 <= 10)) ? 'few'
      : ((n100 >= 11 && n100 <= 19)) ? 'many'
      : 'other';
},

my: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

nah: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

naq: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

nb: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

nd: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ne: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n;
  if (ord) return ((t0 && n >= 1 && n <= 4)) ? 'one' : 'other';
  return (n == 1) ? 'one' : 'other';
},

nl: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

nn: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

nnh: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

no: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

nqo: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

nr: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

nso: function(n, ord
) {
  if (ord) return 'other';
  return ((n == 0
          || n == 1)) ? 'one' : 'other';
},

ny: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

nyn: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

om: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

or: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n;
  if (ord) return ((n == 1 || n == 5
          || (t0 && n >= 7 && n <= 9))) ? 'one'
      : ((n == 2
          || n == 3)) ? 'two'
      : (n == 4) ? 'few'
      : (n == 6) ? 'many'
      : 'other';
  return (n == 1) ? 'one' : 'other';
},

os: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

pa: function(n, ord
) {
  if (ord) return 'other';
  return ((n == 0
          || n == 1)) ? 'one' : 'other';
},

pap: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

pl: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], i10 = i.slice(-1),
      i100 = i.slice(-2);
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one'
      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12
          || i100 > 14)) ? 'few'
      : (v0 && i != 1 && (i10 == 0 || i10 == 1)
          || v0 && (i10 >= 5 && i10 <= 9)
          || v0 && (i100 >= 12 && i100 <= 14)) ? 'many'
      : 'other';
},

prg: function(n, ord
) {
  var s = String(n).split('.'), f = s[1] || '', v = f.length,
      t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1),
      n100 = t0 && s[0].slice(-2), f100 = f.slice(-2), f10 = f.slice(-1);
  if (ord) return 'other';
  return (t0 && n10 == 0 || (n100 >= 11 && n100 <= 19)
          || v == 2 && (f100 >= 11 && f100 <= 19)) ? 'zero'
      : (n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11
          || v != 2 && f10 == 1) ? 'one'
      : 'other';
},

ps: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

pt: function(n, ord
) {
  var s = String(n).split('.'), i = s[0];
  if (ord) return 'other';
  return ((i == 0
          || i == 1)) ? 'one' : 'other';
},

"pt-PT": function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

rm: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ro: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
      n100 = t0 && s[0].slice(-2);
  if (ord) return (n == 1) ? 'one' : 'other';
  return (n == 1 && v0) ? 'one'
      : (!v0 || n == 0
          || n != 1 && (n100 >= 1 && n100 <= 19)) ? 'few'
      : 'other';
},

rof: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

root: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

ru: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], i10 = i.slice(-1),
      i100 = i.slice(-2);
  if (ord) return 'other';
  return (v0 && i10 == 1 && i100 != 11) ? 'one'
      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12
          || i100 > 14)) ? 'few'
      : (v0 && i10 == 0 || v0 && (i10 >= 5 && i10 <= 9)
          || v0 && (i100 >= 11 && i100 <= 14)) ? 'many'
      : 'other';
},

rwk: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

sah: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

saq: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

sc: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return ((n == 11 || n == 8 || n == 80
          || n == 800)) ? 'many' : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

scn: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return ((n == 11 || n == 8 || n == 80
          || n == 800)) ? 'many' : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

sd: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

sdh: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

se: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

seh: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ses: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

sg: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

sh: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
  if (ord) return 'other';
  return (v0 && i10 == 1 && i100 != 11
          || f10 == 1 && f100 != 11) ? 'one'
      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14)
          || (f10 >= 2 && f10 <= 4) && (f100 < 12
          || f100 > 14)) ? 'few'
      : 'other';
},

shi: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n;
  if (ord) return 'other';
  return (n >= 0 && n <= 1) ? 'one'
      : ((t0 && n >= 2 && n <= 10)) ? 'few'
      : 'other';
},

si: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '';
  if (ord) return 'other';
  return ((n == 0 || n == 1)
          || i == 0 && f == 1) ? 'one' : 'other';
},

sk: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one'
      : ((i >= 2 && i <= 4) && v0) ? 'few'
      : (!v0) ? 'many'
      : 'other';
},

sl: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], i100 = i.slice(-2);
  if (ord) return 'other';
  return (v0 && i100 == 1) ? 'one'
      : (v0 && i100 == 2) ? 'two'
      : (v0 && (i100 == 3 || i100 == 4)
          || !v0) ? 'few'
      : 'other';
},

sma: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

smi: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

smj: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

smn: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

sms: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

sn: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

so: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

sq: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return (n == 1) ? 'one'
      : (n10 == 4 && n100 != 14) ? 'many'
      : 'other';
  return (n == 1) ? 'one' : 'other';
},

sr: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
  if (ord) return 'other';
  return (v0 && i10 == 1 && i100 != 11
          || f10 == 1 && f100 != 11) ? 'one'
      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14)
          || (f10 >= 2 && f10 <= 4) && (f100 < 12
          || f100 > 14)) ? 'few'
      : 'other';
},

ss: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ssy: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

st: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

sv: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return ((n10 == 1
          || n10 == 2) && n100 != 11 && n100 != 12) ? 'one' : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

sw: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

syr: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ta: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

te: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

teo: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

th: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

ti: function(n, ord
) {
  if (ord) return 'other';
  return ((n == 0
          || n == 1)) ? 'one' : 'other';
},

tig: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

tk: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1);
  if (ord) return ((n10 == 6 || n10 == 9)
          || n == 10) ? 'few' : 'other';
  return (n == 1) ? 'one' : 'other';
},

tl: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i10 = i.slice(-1), f10 = f.slice(-1);
  if (ord) return (n == 1) ? 'one' : 'other';
  return (v0 && (i == 1 || i == 2 || i == 3)
          || v0 && i10 != 4 && i10 != 6 && i10 != 9
          || !v0 && f10 != 4 && f10 != 6 && f10 != 9) ? 'one' : 'other';
},

tn: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

to: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

tr: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ts: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

tzm: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n;
  if (ord) return 'other';
  return ((n == 0 || n == 1)
          || (t0 && n >= 11 && n <= 99)) ? 'one' : 'other';
},

ug: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

uk: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2), i10 = i.slice(-1),
      i100 = i.slice(-2);
  if (ord) return (n10 == 3 && n100 != 13) ? 'few' : 'other';
  return (v0 && i10 == 1 && i100 != 11) ? 'one'
      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12
          || i100 > 14)) ? 'few'
      : (v0 && i10 == 0 || v0 && (i10 >= 5 && i10 <= 9)
          || v0 && (i100 >= 11 && i100 <= 14)) ? 'many'
      : 'other';
},

ur: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

uz: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ve: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

vi: function(n, ord
) {
  if (ord) return (n == 1) ? 'one' : 'other';
  return 'other';
},

vo: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

vun: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

wa: function(n, ord
) {
  if (ord) return 'other';
  return ((n == 0
          || n == 1)) ? 'one' : 'other';
},

wae: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

wo: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

xh: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

xog: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

yi: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

yo: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

yue: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

zh: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

zu: function(n, ord
) {
  if (ord) return 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
}
}));

},{}],"C:\\projects\\lightning\\node_modules\\messageformat-parser\\parser.js":[function(require,module,exports){
/*
 * Generated by PEG.js 0.10.0.
 *
 * http://pegjs.org/
 */

"use strict";

function peg$subclass(child, parent) {
  function ctor() { this.constructor = child; }
  ctor.prototype = parent.prototype;
  child.prototype = new ctor();
}

function peg$SyntaxError(message, expected, found, location) {
  this.message  = message;
  this.expected = expected;
  this.found    = found;
  this.location = location;
  this.name     = "SyntaxError";

  if (typeof Error.captureStackTrace === "function") {
    Error.captureStackTrace(this, peg$SyntaxError);
  }
}

peg$subclass(peg$SyntaxError, Error);

peg$SyntaxError.buildMessage = function(expected, found) {
  var DESCRIBE_EXPECTATION_FNS = {
        literal: function(expectation) {
          return "\"" + literalEscape(expectation.text) + "\"";
        },

        "class": function(expectation) {
          var escapedParts = "",
              i;

          for (i = 0; i < expectation.parts.length; i++) {
            escapedParts += expectation.parts[i] instanceof Array
              ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1])
              : classEscape(expectation.parts[i]);
          }

          return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
        },

        any: function(expectation) {
          return "any character";
        },

        end: function(expectation) {
          return "end of input";
        },

        other: function(expectation) {
          return expectation.description;
        }
      };

  function hex(ch) {
    return ch.charCodeAt(0).toString(16).toUpperCase();
  }

  function literalEscape(s) {
    return s
      .replace(/\\/g, '\\\\')
      .replace(/"/g,  '\\"')
      .replace(/\0/g, '\\0')
      .replace(/\t/g, '\\t')
      .replace(/\n/g, '\\n')
      .replace(/\r/g, '\\r')
      .replace(/[\x00-\x0F]/g,          function(ch) { return '\\x0' + hex(ch); })
      .replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) { return '\\x'  + hex(ch); });
  }

  function classEscape(s) {
    return s
      .replace(/\\/g, '\\\\')
      .replace(/\]/g, '\\]')
      .replace(/\^/g, '\\^')
      .replace(/-/g,  '\\-')
      .replace(/\0/g, '\\0')
      .replace(/\t/g, '\\t')
      .replace(/\n/g, '\\n')
      .replace(/\r/g, '\\r')
      .replace(/[\x00-\x0F]/g,          function(ch) { return '\\x0' + hex(ch); })
      .replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) { return '\\x'  + hex(ch); });
  }

  function describeExpectation(expectation) {
    return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
  }

  function describeExpected(expected) {
    var descriptions = new Array(expected.length),
        i, j;

    for (i = 0; i < expected.length; i++) {
      descriptions[i] = describeExpectation(expected[i]);
    }

    descriptions.sort();

    if (descriptions.length > 0) {
      for (i = 1, j = 1; i < descriptions.length; i++) {
        if (descriptions[i - 1] !== descriptions[i]) {
          descriptions[j] = descriptions[i];
          j++;
        }
      }
      descriptions.length = j;
    }

    switch (descriptions.length) {
      case 1:
        return descriptions[0];

      case 2:
        return descriptions[0] + " or " + descriptions[1];

      default:
        return descriptions.slice(0, -1).join(", ")
          + ", or "
          + descriptions[descriptions.length - 1];
    }
  }

  function describeFound(found) {
    return found ? "\"" + literalEscape(found) + "\"" : "end of input";
  }

  return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
};

function peg$parse(input, options) {
  options = options !== void 0 ? options : {};

  var peg$FAILED = {},

      peg$startRuleFunctions = { start: peg$parsestart },
      peg$startRuleFunction  = peg$parsestart,

      peg$c0 = "#",
      peg$c1 = peg$literalExpectation("#", false),
      peg$c2 = function() { return { type: 'octothorpe' }; },
      peg$c3 = function(str) { return str.join(''); },
      peg$c4 = "{",
      peg$c5 = peg$literalExpectation("{", false),
      peg$c6 = "}",
      peg$c7 = peg$literalExpectation("}", false),
      peg$c8 = function(arg) {
          return {
            type: 'argument',
            arg: arg
          };
        },
      peg$c9 = ",",
      peg$c10 = peg$literalExpectation(",", false),
      peg$c11 = "select",
      peg$c12 = peg$literalExpectation("select", false),
      peg$c13 = function(arg, cases) {
          return {
            type: 'select',
            arg: arg,
            cases: cases
          };
        },
      peg$c14 = "plural",
      peg$c15 = peg$literalExpectation("plural", false),
      peg$c16 = "selectordinal",
      peg$c17 = peg$literalExpectation("selectordinal", false),
      peg$c18 = function(arg, type, offset, cases) {
          var ls = ((type === 'selectordinal') ? options.ordinal : options.cardinal)
                   || ['zero', 'one', 'two', 'few', 'many', 'other'];
          if (ls && ls.length) cases.forEach(function(c) {
            if (isNaN(c.key) && ls.indexOf(c.key) < 0) throw new Error(
              'Invalid key `' + c.key + '` for argument `' + arg + '`.' +
              ' Valid ' + type + ' keys for this locale are `' + ls.join('`, `') +
              '`, and explicit keys like `=0`.');
          });
          return {
            type: type,
            arg: arg,
            offset: offset || 0,
            cases: cases
          };
        },
      peg$c19 = function(arg, key, params) {
          return {
            type: 'function',
            arg: arg,
            key: key,
            params: params
          };
        },
      peg$c20 = /^[0-9a-zA-Z$_]/,
      peg$c21 = peg$classExpectation([["0", "9"], ["a", "z"], ["A", "Z"], "$", "_"], false, false),
      peg$c22 = /^[^ \t\n\r,.+={}]/,
      peg$c23 = peg$classExpectation([" ", "\t", "\n", "\r", ",", ".", "+", "=", "{", "}"], true, false),
      peg$c24 = function(key, tokens) { return { key: key, tokens: tokens }; },
      peg$c25 = function(tokens) { return tokens; },
      peg$c26 = "offset",
      peg$c27 = peg$literalExpectation("offset", false),
      peg$c28 = ":",
      peg$c29 = peg$literalExpectation(":", false),
      peg$c30 = function(d) { return d; },
      peg$c31 = "=",
      peg$c32 = peg$literalExpectation("=", false),
      peg$c33 = function(p) { return options.strictFunctionParams; },
      peg$c34 = function(p) { return p; },
      peg$c35 = function(p) { return p.replace(/^[ \t\n\r]*|[ \t\n\r]*$/g, ''); },
      peg$c36 = "''",
      peg$c37 = peg$literalExpectation("''", false),
      peg$c38 = function() { return "'"; },
      peg$c39 = /^[^']/,
      peg$c40 = peg$classExpectation(["'"], true, false),
      peg$c41 = "'{",
      peg$c42 = peg$literalExpectation("'{", false),
      peg$c43 = "'",
      peg$c44 = peg$literalExpectation("'", false),
      peg$c45 = function(str) { return '\u007B'+str.join(''); },
      peg$c46 = "'}",
      peg$c47 = peg$literalExpectation("'}", false),
      peg$c48 = function(str) { return '\u007D'+str.join(''); },
      peg$c49 = /^[^{}#\\\0-\x08\x0E-\x1F\x7F]/,
      peg$c50 = peg$classExpectation(["{", "}", "#", "\\", ["\0", "\b"], ["\x0E", "\x1F"], "\x7F"], true, false),
      peg$c51 = "\\\\",
      peg$c52 = peg$literalExpectation("\\\\", false),
      peg$c53 = function() { return '\\'; },
      peg$c54 = "\\#",
      peg$c55 = peg$literalExpectation("\\#", false),
      peg$c56 = function() { return '#'; },
      peg$c57 = "\\{",
      peg$c58 = peg$literalExpectation("\\{", false),
      peg$c59 = function() { return '\u007B'; },
      peg$c60 = "\\}",
      peg$c61 = peg$literalExpectation("\\}", false),
      peg$c62 = function() { return '\u007D'; },
      peg$c63 = "\\u",
      peg$c64 = peg$literalExpectation("\\u", false),
      peg$c65 = function(h1, h2, h3, h4) {
            return String.fromCharCode(parseInt('0x' + h1 + h2 + h3 + h4));
          },
      peg$c66 = /^[^',}]/,
      peg$c67 = peg$classExpectation(["'", ",", "}"], true, false),
      peg$c68 = /^[^'}]/,
      peg$c69 = peg$classExpectation(["'", "}"], true, false),
      peg$c70 = /^[0-9]/,
      peg$c71 = peg$classExpectation([["0", "9"]], false, false),
      peg$c72 = /^[0-9a-fA-F]/,
      peg$c73 = peg$classExpectation([["0", "9"], ["a", "f"], ["A", "F"]], false, false),
      peg$c74 = /^[ \t\n\r]/,
      peg$c75 = peg$classExpectation([" ", "\t", "\n", "\r"], false, false),

      peg$currPos          = 0,
      peg$savedPos         = 0,
      peg$posDetailsCache  = [{ line: 1, column: 1 }],
      peg$maxFailPos       = 0,
      peg$maxFailExpected  = [],
      peg$silentFails      = 0,

      peg$result;

  if ("startRule" in options) {
    if (!(options.startRule in peg$startRuleFunctions)) {
      throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
    }

    peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
  }

  function text() {
    return input.substring(peg$savedPos, peg$currPos);
  }

  function location() {
    return peg$computeLocation(peg$savedPos, peg$currPos);
  }

  function expected(description, location) {
    location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos)

    throw peg$buildStructuredError(
      [peg$otherExpectation(description)],
      input.substring(peg$savedPos, peg$currPos),
      location
    );
  }

  function error(message, location) {
    location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos)

    throw peg$buildSimpleError(message, location);
  }

  function peg$literalExpectation(text, ignoreCase) {
    return { type: "literal", text: text, ignoreCase: ignoreCase };
  }

  function peg$classExpectation(parts, inverted, ignoreCase) {
    return { type: "class", parts: parts, inverted: inverted, ignoreCase: ignoreCase };
  }

  function peg$anyExpectation() {
    return { type: "any" };
  }

  function peg$endExpectation() {
    return { type: "end" };
  }

  function peg$otherExpectation(description) {
    return { type: "other", description: description };
  }

  function peg$computePosDetails(pos) {
    var details = peg$posDetailsCache[pos], p;

    if (details) {
      return details;
    } else {
      p = pos - 1;
      while (!peg$posDetailsCache[p]) {
        p--;
      }

      details = peg$posDetailsCache[p];
      details = {
        line:   details.line,
        column: details.column
      };

      while (p < pos) {
        if (input.charCodeAt(p) === 10) {
          details.line++;
          details.column = 1;
        } else {
          details.column++;
        }

        p++;
      }

      peg$posDetailsCache[pos] = details;
      return details;
    }
  }

  function peg$computeLocation(startPos, endPos) {
    var startPosDetails = peg$computePosDetails(startPos),
        endPosDetails   = peg$computePosDetails(endPos);

    return {
      start: {
        offset: startPos,
        line:   startPosDetails.line,
        column: startPosDetails.column
      },
      end: {
        offset: endPos,
        line:   endPosDetails.line,
        column: endPosDetails.column
      }
    };
  }

  function peg$fail(expected) {
    if (peg$currPos < peg$maxFailPos) { return; }

    if (peg$currPos > peg$maxFailPos) {
      peg$maxFailPos = peg$currPos;
      peg$maxFailExpected = [];
    }

    peg$maxFailExpected.push(expected);
  }

  function peg$buildSimpleError(message, location) {
    return new peg$SyntaxError(message, null, null, location);
  }

  function peg$buildStructuredError(expected, found, location) {
    return new peg$SyntaxError(
      peg$SyntaxError.buildMessage(expected, found),
      expected,
      found,
      location
    );
  }

  function peg$parsestart() {
    var s0, s1;

    s0 = [];
    s1 = peg$parsetoken();
    while (s1 !== peg$FAILED) {
      s0.push(s1);
      s1 = peg$parsetoken();
    }

    return s0;
  }

  function peg$parsetoken() {
    var s0, s1, s2;

    s0 = peg$parseargument();
    if (s0 === peg$FAILED) {
      s0 = peg$parseselect();
      if (s0 === peg$FAILED) {
        s0 = peg$parseplural();
        if (s0 === peg$FAILED) {
          s0 = peg$parsefunction();
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 35) {
              s1 = peg$c0;
              peg$currPos++;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c1); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c2();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              s1 = [];
              s2 = peg$parsechar();
              if (s2 !== peg$FAILED) {
                while (s2 !== peg$FAILED) {
                  s1.push(s2);
                  s2 = peg$parsechar();
                }
              } else {
                s1 = peg$FAILED;
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c3(s1);
              }
              s0 = s1;
            }
          }
        }
      }
    }

    return s0;
  }

  function peg$parseargument() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c4;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c5); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      if (s2 !== peg$FAILED) {
        s3 = peg$parseid();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 125) {
              s5 = peg$c6;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c7); }
            }
            if (s5 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c8(s3);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseselect() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c4;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c5); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      if (s2 !== peg$FAILED) {
        s3 = peg$parseid();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 44) {
              s5 = peg$c9;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c10); }
            }
            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();
              if (s6 !== peg$FAILED) {
                if (input.substr(peg$currPos, 6) === peg$c11) {
                  s7 = peg$c11;
                  peg$currPos += 6;
                } else {
                  s7 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c12); }
                }
                if (s7 !== peg$FAILED) {
                  s8 = peg$parse_();
                  if (s8 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 44) {
                      s9 = peg$c9;
                      peg$currPos++;
                    } else {
                      s9 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
                    }
                    if (s9 !== peg$FAILED) {
                      s10 = peg$parse_();
                      if (s10 !== peg$FAILED) {
                        s11 = [];
                        s12 = peg$parseselectCase();
                        if (s12 !== peg$FAILED) {
                          while (s12 !== peg$FAILED) {
                            s11.push(s12);
                            s12 = peg$parseselectCase();
                          }
                        } else {
                          s11 = peg$FAILED;
                        }
                        if (s11 !== peg$FAILED) {
                          s12 = peg$parse_();
                          if (s12 !== peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 125) {
                              s13 = peg$c6;
                              peg$currPos++;
                            } else {
                              s13 = peg$FAILED;
                              if (peg$silentFails === 0) { peg$fail(peg$c7); }
                            }
                            if (s13 !== peg$FAILED) {
                              peg$savedPos = s0;
                              s1 = peg$c13(s3, s11);
                              s0 = s1;
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseplural() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c4;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c5); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      if (s2 !== peg$FAILED) {
        s3 = peg$parseid();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 44) {
              s5 = peg$c9;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c10); }
            }
            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();
              if (s6 !== peg$FAILED) {
                if (input.substr(peg$currPos, 6) === peg$c14) {
                  s7 = peg$c14;
                  peg$currPos += 6;
                } else {
                  s7 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c15); }
                }
                if (s7 === peg$FAILED) {
                  if (input.substr(peg$currPos, 13) === peg$c16) {
                    s7 = peg$c16;
                    peg$currPos += 13;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c17); }
                  }
                }
                if (s7 !== peg$FAILED) {
                  s8 = peg$parse_();
                  if (s8 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 44) {
                      s9 = peg$c9;
                      peg$currPos++;
                    } else {
                      s9 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
                    }
                    if (s9 !== peg$FAILED) {
                      s10 = peg$parse_();
                      if (s10 !== peg$FAILED) {
                        s11 = peg$parseoffset();
                        if (s11 === peg$FAILED) {
                          s11 = null;
                        }
                        if (s11 !== peg$FAILED) {
                          s12 = [];
                          s13 = peg$parsepluralCase();
                          if (s13 !== peg$FAILED) {
                            while (s13 !== peg$FAILED) {
                              s12.push(s13);
                              s13 = peg$parsepluralCase();
                            }
                          } else {
                            s12 = peg$FAILED;
                          }
                          if (s12 !== peg$FAILED) {
                            s13 = peg$parse_();
                            if (s13 !== peg$FAILED) {
                              if (input.charCodeAt(peg$currPos) === 125) {
                                s14 = peg$c6;
                                peg$currPos++;
                              } else {
                                s14 = peg$FAILED;
                                if (peg$silentFails === 0) { peg$fail(peg$c7); }
                              }
                              if (s14 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c18(s3, s7, s11, s12);
                                s0 = s1;
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsefunction() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c4;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c5); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      if (s2 !== peg$FAILED) {
        s3 = peg$parseid();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 44) {
              s5 = peg$c9;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c10); }
            }
            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();
              if (s6 !== peg$FAILED) {
                s7 = peg$parseid();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parse_();
                  if (s8 !== peg$FAILED) {
                    s9 = peg$parsefunctionParams();
                    if (s9 !== peg$FAILED) {
                      if (input.charCodeAt(peg$currPos) === 125) {
                        s10 = peg$c6;
                        peg$currPos++;
                      } else {
                        s10 = peg$FAILED;
                        if (peg$silentFails === 0) { peg$fail(peg$c7); }
                      }
                      if (s10 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c19(s3, s7, s9);
                        s0 = s1;
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseid() {
    var s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$currPos;
    if (peg$c20.test(input.charAt(peg$currPos))) {
      s2 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c21); }
    }
    if (s2 !== peg$FAILED) {
      s3 = [];
      if (peg$c22.test(input.charAt(peg$currPos))) {
        s4 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s4 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      while (s4 !== peg$FAILED) {
        s3.push(s4);
        if (peg$c22.test(input.charAt(peg$currPos))) {
          s4 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s4 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c23); }
        }
      }
      if (s3 !== peg$FAILED) {
        s2 = [s2, s3];
        s1 = s2;
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s0 = input.substring(s0, peg$currPos);
    } else {
      s0 = s1;
    }

    return s0;
  }

  function peg$parseparamDefault() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parseparamcharsDefault();
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parseparamcharsDefault();
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c3(s1);
    }
    s0 = s1;

    return s0;
  }

  function peg$parseparamStrict() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parseparamcharsStrict();
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parseparamcharsStrict();
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c3(s1);
    }
    s0 = s1;

    return s0;
  }

  function peg$parseselectCase() {
    var s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$parse_();
    if (s1 !== peg$FAILED) {
      s2 = peg$parseid();
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_();
        if (s3 !== peg$FAILED) {
          s4 = peg$parsecaseTokens();
          if (s4 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c24(s2, s4);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsepluralCase() {
    var s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$parse_();
    if (s1 !== peg$FAILED) {
      s2 = peg$parsepluralKey();
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_();
        if (s3 !== peg$FAILED) {
          s4 = peg$parsecaseTokens();
          if (s4 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c24(s2, s4);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsecaseTokens() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c4;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c5); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$currPos;
        peg$silentFails++;
        if (input.charCodeAt(peg$currPos) === 123) {
          s5 = peg$c4;
          peg$currPos++;
        } else {
          s5 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c5); }
        }
        peg$silentFails--;
        if (s5 !== peg$FAILED) {
          peg$currPos = s4;
          s4 = void 0;
        } else {
          s4 = peg$FAILED;
        }
        if (s4 !== peg$FAILED) {
          s3 = [s3, s4];
          s2 = s3;
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 === peg$FAILED) {
        s2 = null;
      }
      if (s2 !== peg$FAILED) {
        s3 = [];
        s4 = peg$parsetoken();
        while (s4 !== peg$FAILED) {
          s3.push(s4);
          s4 = peg$parsetoken();
        }
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 125) {
              s5 = peg$c6;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c7); }
            }
            if (s5 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c25(s3);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseoffset() {
    var s0, s1, s2, s3, s4, s5, s6, s7;

    s0 = peg$currPos;
    s1 = peg$parse_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 6) === peg$c26) {
        s2 = peg$c26;
        peg$currPos += 6;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c27); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_();
        if (s3 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 58) {
            s4 = peg$c28;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c29); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsedigits();
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c30(s6);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsepluralKey() {
    var s0, s1, s2;

    s0 = peg$parseid();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s1 = peg$c31;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parsedigits();
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c30(s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parsefunctionParams() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parsefunctionParamsDefault();
    while (s2 !== peg$FAILED) {
      s1.push(s2);
      s2 = peg$parsefunctionParamsDefault();
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = peg$currPos;
      s2 = peg$c33(s1);
      if (s2) {
        s2 = peg$FAILED;
      } else {
        s2 = void 0;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c34(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsefunctionParamsStrict();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsefunctionParamsStrict();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = peg$currPos;
        s2 = peg$c33(s1);
        if (s2) {
          s2 = void 0;
        } else {
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c34(s1);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parsefunctionParamsStrict() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parse_();
    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 44) {
        s2 = peg$c9;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c10); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parseparamStrict();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c34(s3);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsefunctionParamsDefault() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parse_();
    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 44) {
        s2 = peg$c9;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c10); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseparamDefault();
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c35(s4);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsedoubleapos() {
    var s0, s1;

    s0 = peg$currPos;
    if (input.substr(peg$currPos, 2) === peg$c36) {
      s1 = peg$c36;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c37); }
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c38();
    }
    s0 = s1;

    return s0;
  }

  function peg$parseinapos() {
    var s0, s1, s2;

    s0 = peg$parsedoubleapos();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = [];
      if (peg$c39.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          if (peg$c39.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c40); }
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c3(s1);
      }
      s0 = s1;
    }

    return s0;
  }

  function peg$parsequotedCurly() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    if (input.substr(peg$currPos, 2) === peg$c41) {
      s1 = peg$c41;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c42); }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseinapos();
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$parseinapos();
      }
      if (s2 !== peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 39) {
          s3 = peg$c43;
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c44); }
        }
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c45(s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      if (input.substr(peg$currPos, 2) === peg$c46) {
        s1 = peg$c46;
        peg$currPos += 2;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c47); }
      }
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$parseinapos();
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parseinapos();
        }
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 39) {
            s3 = peg$c43;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c44); }
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c48(s2);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parsequotedFunctionParams() {
    var s0;

    s0 = peg$parsequotedCurly();
    if (s0 === peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 39) {
        s0 = peg$c43;
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c44); }
      }
    }

    return s0;
  }

  function peg$parsechar() {
    var s0, s1, s2, s3, s4, s5;

    if (peg$c49.test(input.charAt(peg$currPos))) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c50); }
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      if (input.substr(peg$currPos, 2) === peg$c51) {
        s1 = peg$c51;
        peg$currPos += 2;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c52); }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c53();
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c54) {
          s1 = peg$c54;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c55); }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c56();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c57) {
            s1 = peg$c57;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c58); }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c59();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c60) {
              s1 = peg$c60;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c61); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c62();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c63) {
                s1 = peg$c63;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c64); }
              }
              if (s1 !== peg$FAILED) {
                s2 = peg$parsehexDigit();
                if (s2 !== peg$FAILED) {
                  s3 = peg$parsehexDigit();
                  if (s3 !== peg$FAILED) {
                    s4 = peg$parsehexDigit();
                    if (s4 !== peg$FAILED) {
                      s5 = peg$parsehexDigit();
                      if (s5 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c65(s2, s3, s4, s5);
                        s0 = s1;
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            }
          }
        }
      }
    }

    return s0;
  }

  function peg$parseparamcharsCommon() {
    var s0;

    s0 = peg$parsedoubleapos();
    if (s0 === peg$FAILED) {
      s0 = peg$parsequotedFunctionParams();
    }

    return s0;
  }

  function peg$parseparamcharsDefault() {
    var s0, s1, s2;

    s0 = peg$parseparamcharsCommon();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = [];
      if (peg$c66.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c67); }
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          if (peg$c66.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c67); }
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c3(s1);
      }
      s0 = s1;
    }

    return s0;
  }

  function peg$parseparamcharsStrict() {
    var s0, s1, s2;

    s0 = peg$parseparamcharsCommon();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = [];
      if (peg$c68.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c69); }
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          if (peg$c68.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c69); }
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c3(s1);
      }
      s0 = s1;
    }

    return s0;
  }

  function peg$parsedigits() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    if (peg$c70.test(input.charAt(peg$currPos))) {
      s2 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c71); }
    }
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        if (peg$c70.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c71); }
        }
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s0 = input.substring(s0, peg$currPos);
    } else {
      s0 = s1;
    }

    return s0;
  }

  function peg$parsehexDigit() {
    var s0;

    if (peg$c72.test(input.charAt(peg$currPos))) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c73); }
    }

    return s0;
  }

  function peg$parse_() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    if (peg$c74.test(input.charAt(peg$currPos))) {
      s2 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c75); }
    }
    while (s2 !== peg$FAILED) {
      s1.push(s2);
      if (peg$c74.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c75); }
      }
    }
    if (s1 !== peg$FAILED) {
      s0 = input.substring(s0, peg$currPos);
    } else {
      s0 = s1;
    }

    return s0;
  }

  peg$result = peg$startRuleFunction();

  if (peg$result !== peg$FAILED && peg$currPos === input.length) {
    return peg$result;
  } else {
    if (peg$result !== peg$FAILED && peg$currPos < input.length) {
      peg$fail(peg$endExpectation());
    }

    throw peg$buildStructuredError(
      peg$maxFailExpected,
      peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
      peg$maxFailPos < input.length
        ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
        : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
    );
  }
}

module.exports = {
  SyntaxError: peg$SyntaxError,
  parse:       peg$parse
};

},{}],"C:\\projects\\lightning\\node_modules\\messageformat\\lib\\compiler.js":[function(require,module,exports){
var reserved = require('reserved-words');
var parse = require('messageformat-parser').parse;


/** Creates a new message compiler. Called internally from {@link MessageFormat#compile}.
 *
 * @class
 * @param {MessageFormat} mf - A MessageFormat instance
 * @property {object} locales - The locale identifiers that are used by the compiled functions
 * @property {object} runtime - Names of the core runtime functions that are used by the compiled functions
 * @property {object} formatters - The formatter functions that are used by the compiled functions
 */
function Compiler(mf) {
    this.mf = mf;
    this.lc = null;
    this.locales = {};
    this.runtime = {};
    this.formatters = {};
}

module.exports = Compiler;


/** Utility function for quoting an Object's key value if required
 *
 *  Quotes the key if it contains invalid characters or is an
 *  ECMAScript 3rd Edition reserved word (for IE8).
 */
Compiler.propname = function(key, obj) {
  if (/^[A-Z_$][0-9A-Z_$]*$/i.test(key) &&
     ['break', 'continue', 'delete', 'else', 'for', 'function', 'if', 'in', 'new',
      'return', 'this', 'typeof', 'var', 'void', 'while', 'with', 'case', 'catch',
      'default', 'do', 'finally', 'instanceof', 'switch', 'throw', 'try'].indexOf(key) < 0) {
    return obj ? obj + '.' + key : key;
  } else {
    var jkey = JSON.stringify(key);
    return obj ? obj + '[' + jkey + ']' : jkey;
  }
}


/** Utility function for escaping a function name if required
 */
Compiler.funcname = function(key) {
  var fn = key.trim().replace(/\W+/g, '_');
  return reserved.check(fn, 'es2015', true) || /^\d/.test(fn) ? '_' + fn : fn;
}


/** Utility formatter function for enforcing Bidi Structured Text by using UCC
 *
 *  List inlined from data extracted from CLDR v27 & v28
 *  To verify/recreate, use the following:
 *
 *     git clone https://github.com/unicode-cldr/cldr-misc-full.git
 *     cd cldr-misc-full/main/
 *     grep characterOrder -r . | tr '"/' '\t' | cut -f2,6 | grep -C4 right-to-left
 */
Compiler.bidiMarkText = function(text, locale) {
  function isLocaleRTL(locale) {
    var rtlLanguages = ['ar', 'ckb', 'fa', 'he', 'ks($|[^bfh])', 'lrc', 'mzn',
                        'pa-Arab', 'ps', 'ug', 'ur', 'uz-Arab', 'yi'];
    return new RegExp('^' + rtlLanguages.join('|^')).test(locale);
  }
  var mark = JSON.stringify(isLocaleRTL(locale) ? '\u200F' : '\u200E');
  return mark + ' + ' + text + ' + ' + mark;
}


/** @private */
Compiler.prototype.cases = function(token, plural) {
  var needOther = token.type === 'select' || !this.mf.hasCustomPluralFuncs;
  var r = token.cases.map(function(c) {
    if (c.key === 'other') needOther = false;
    var s = c.tokens.map(function(tok) { return this.token(tok, plural); }, this);
    return Compiler.propname(c.key) + ': ' + (s.join(' + ') || '""');
  }, this);
  if (needOther) throw new Error("No 'other' form found in " + JSON.stringify(token));
  return '{ ' + r.join(', ') + ' }';
}


/** @private */
Compiler.prototype.token = function(token, plural) {
  if (typeof token == 'string') return JSON.stringify(token);

  var fn, args = [ Compiler.propname(token.arg, 'd') ];
  switch (token.type) {
    case 'argument':
      return this.mf.bidiSupport ? Compiler.bidiMarkText(args[0], this.lc) : args[0];

    case 'select':
      fn = 'select';
      args.push(this.cases(token, this.mf.strictNumberSign ? null : plural));
      this.runtime.select = true;
      break;

    case 'selectordinal':
      fn = 'plural';
      args.push(0, Compiler.funcname(this.lc), this.cases(token, token), 1);
      this.locales[this.lc] = true;
      this.runtime.plural = true;
      break;

    case 'plural':
      fn = 'plural';
      args.push(token.offset || 0, Compiler.funcname(this.lc), this.cases(token, token));
      this.locales[this.lc] = true;
      this.runtime.plural = true;
      break;

    case 'function':
      if (this.mf.intlSupport && !(token.key in this.mf.fmt) && (token.key in this.mf.constructor.formatters)) {
        var fmt = this.mf.constructor.formatters[token.key];
        this.mf.fmt[token.key] = (typeof fmt(this.mf) == 'function') ? fmt(this.mf) : fmt;
      }
      if (!this.mf.fmt[token.key]) throw new Error('Formatting function ' + JSON.stringify(token.key) + ' not found!');
      args.push(JSON.stringify(this.lc));
      if (token.params) switch (token.params.length) {
          case 0:   break;
          case 1:   args.push(JSON.stringify(token.params[0])); break;
          default:  args.push(JSON.stringify(token.params)); break;
      }
      fn = Compiler.propname(token.key, 'fmt');
      this.formatters[token.key] = true;
      break;

    case 'octothorpe':
      if (!plural) return '"#"';
      fn = 'number';
      args = [ Compiler.propname(plural.arg, 'd'), JSON.stringify(plural.arg) ];
      if (plural.offset) args.push(plural.offset);
      this.runtime.number = true;
      break;
  }

  if (!fn) throw new Error('Parser error for token ' + JSON.stringify(token));
  return fn + '(' + args.join(', ') + ')';
};


/** Recursively compile a string or a tree of strings to JavaScript function sources
 *
 *  If `src` is an object with a key that is also present in `plurals`, the key
 *  in question will be used as the locale identifier for its value. To disable
 *  the compile-time checks for plural & selectordinal keys while maintaining
 *  multi-locale support, use falsy values in `plurals`.
 *
 * @param {string|object} src - the source for which the JS code should be generated
 * @param {string} lc - the default locale
 * @param {object} plurals - a map of pluralization keys for all available locales
 */
Compiler.prototype.compile = function(src, lc, plurals) {
  if (typeof src != 'object') {
    this.lc = lc;
    var pc = plurals[lc] || { cardinal: [], ordinal: [] };
    var r = parse(src, pc).map(function(token) { return this.token(token); }, this);
    return 'function(d) { return ' + (r.join(' + ') || '""') + '; }';
  } else {
    var result = {};
    for (var key in src) {
      var lcKey = plurals.hasOwnProperty(key) ? key : lc;
      result[key] = this.compile(src[key], lcKey, plurals);
    }
    return result;
  }
}

},{"messageformat-parser":"C:\\projects\\lightning\\node_modules\\messageformat-parser\\parser.js","reserved-words":"C:\\projects\\lightning\\node_modules\\reserved-words\\lib\\index.js"}],"C:\\projects\\lightning\\node_modules\\messageformat\\lib\\index.js":[function(require,module,exports){
/** @file messageformat.js - ICU PluralFormat + SelectFormat for JavaScript
 *
 * @author Alex Sexton - @SlexAxton, Eemeli Aro - @eemeli_aro
 * @copyright 2012-2016 Alex Sexton, Eemeli Aro, and Contributors
 * @license To use or fork, MIT. To contribute back, JS Foundation CLA
 */

var Compiler = require('./compiler');
var Runtime = require('./runtime');


/** Utility getter/wrapper for pluralization functions from
 *  {@link http://github.com/eemeli/make-plural.js make-plural}
 *
 * @private
 */
function getPluralFunc(locale, noPluralKeyChecks) {
  var plurals = require('make-plural/umd/plurals');
  var pluralCategories = require('make-plural/umd/pluralCategories');
  for (var l = locale; l; l = l.replace(/[-_]?[^-_]*$/, '')) {
    var pf = plurals[l];
    if (pf) {
      var pc = noPluralKeyChecks ? { cardinal: [], ordinal: [] } : (pluralCategories[l] || {});
      var fn = function() { return pf.apply(this, arguments); };
      fn.toString = function() { return pf.toString(); };
      fn.cardinal = pc.cardinal;
      fn.ordinal = pc.ordinal;
      return fn;
    }
  }
  throw new Error('Localisation function not found for locale ' + JSON.stringify(locale));
}


/** Create a new message formatter
 *
 *  If `locale` is not set, calls to `compile()` will fetch the default locale
 *  each time. A string `locale` will create a single-locale MessageFormat
 *  instance, with pluralisation rules fetched from the Unicode CLDR using
 *  {@link http://github.com/eemeli/make-plural.js make-plural}.
 *
 *  Using an array of strings as `locale` will create a MessageFormat object
 *  with multi-language support, with pluralisation rules fetched as above. To
 *  select which to use, use the second parameter of `compile()`, or use message
 *  keys corresponding to your locales.
 *
 *  Using an object `locale` with all properties of type `function` allows for
 *  the use of custom/externally defined pluralisation rules.
 *
 * @class
 * @param {string|string[]|Object.<string,function>} [locale] - The locale(s) to use
 */
function MessageFormat(locale) {
  this.pluralFuncs = {};
  if (locale) {
    if (typeof locale == 'string') {
      this.pluralFuncs[locale] = getPluralFunc(locale);
    } else if (Array.isArray(locale)) {
      locale.forEach(function(lc) { this.pluralFuncs[lc] = getPluralFunc(lc); }, this);
    } else if (typeof locale == 'object') {
      for (var lc in locale) if (locale.hasOwnProperty(lc)) {
        if (typeof locale[lc] != 'function') throw new Error('Expected function value for locale ' + JSON.stringify(lc));
        this.pluralFuncs[lc] = locale[lc];
      }
      this.hasCustomPluralFuncs = true;
    }
  }
  this.fmt = {};
  this.runtime = new Runtime(this);
}


/** The default locale
 *
 *  Read by `compile()` when no locale has been previously set
 *
 * @memberof MessageFormat
 * @default 'en'
 */
MessageFormat.defaultLocale = 'en';


/** Escape special characaters
 *
 *  Prefix the characters `#`, `{`, `}` and `\` in the input string with a `\`.
 *  This will allow those characters to not be considered as MessageFormat
 *  control characters.
 *
 * @param {string} str - The input string
 * @returns {string} The escaped string
 */
MessageFormat.escape = function(str) {
  return str.replace(/[#{}\\]/g, '\\$&');
}


/** Default number formatting functions in the style of ICU's
 *  {@link http://icu-project.org/apiref/icu4j/com/ibm/icu/text/MessageFormat.html simpleArg syntax}
 *  implemented using the
 *  {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl Intl}
 *  object defined by ECMA-402.
 *
 *  **Note**: Intl is not defined in default Node until 0.11.15 / 0.12.0, so
 *  earlier versions require a {@link https://www.npmjs.com/package/intl polyfill}.
 *  Therefore {@link MessageFormat.intlSupport} needs to be true for these default
 *  functions to be available for inclusion in the output.
 *
 * @see MessageFormat#setIntlSupport
 *
 * @namespace
 */
MessageFormat.formatters = {


  /** Represent a number as an integer, percent or currency value
   *
   *  Available in MessageFormat strings as `{VAR, number, integer|percent|currency}`.
   *  Internally, calls Intl.NumberFormat with appropriate parameters. `currency` will
   *  default to USD; to change, set `MessageFormat#currency` to the appropriate
   *  three-letter currency code.
   *
   * @param {number} value - The value to operate on
   * @param {string} type - One of `'integer'`, `'percent'` , or `currency`
   *
   * @example
   * var mf = new MessageFormat('en').setIntlSupport(true);
   * mf.currency = 'EUR';  // needs to be set before first compile() call
   *
   * mf.compile('{N} is almost {N, number, integer}')({ N: 3.14 })
   * // '3.14 is almost 3'
   *
   * mf.compile('{P, number, percent} complete')({ P: 0.99 })
   * // '99% complete'
   *
   * mf.compile('The total is {V, number, currency}.')({ V: 5.5 })
   * // 'The total is €5.50.'
   */
  number: function(self) {
    return new Function("v,lc,p",
      "return new Intl.NumberFormat(lc,\n" +
      "    p=='integer' ? {maximumFractionDigits:0}\n" +
      "  : p=='percent' ? {style:'percent'}\n" +
      "  : p=='currency' ? {style:'currency', currency:'" + (self.currency || 'USD') + "', minimumFractionDigits:2, maximumFractionDigits:2}\n" +
      "  : {}).format(v)"
    );
  },


  /** Represent a date as a short/default/long/full string
   *
   * The input value needs to be in a form that the
   * {@link https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Date Date object}
   * can process using its single-argument form, `new Date(value)`.
   *
   * @param {number|string} value - Either a Unix epoch time in milliseconds, or a string value representing a date
   * @param {string} [type='default'] - One of `'short'`, `'default'`, `'long'` , or `full`
   *
   * @example
   * var mf = new MessageFormat(['en', 'fi']).setIntlSupport(true);
   *
   * mf.compile('Today is {T, date}')({ T: Date.now() })
   * // 'Today is Feb 21, 2016'
   *
   * mf.compile('Tänään on {T, date}', 'fi')({ T: Date.now() })
   * // 'Tänään on 21. helmikuuta 2016'
   *
   * mf.compile('Unix time started on {T, date, full}')({ T: 0 })
   * // 'Unix time started on Thursday, January 1, 1970'
   *
   * var cf = mf.compile('{sys} became operational on {d0, date, short}');
   * cf({ sys: 'HAL 9000', d0: '12 January 1999' })
   * // 'HAL 9000 became operational on 1/12/1999'
   */
  date: function(v,lc,p) {
    var o = {day:'numeric', month:'short', year:'numeric'};
    switch (p) {
      case 'full': o.weekday = 'long';
      case 'long': o.month = 'long'; break;
      case 'short': o.month = 'numeric';
    }
    return (new Date(v)).toLocaleDateString(lc, o)
  },


  /** Represent a time as a short/default/long string
   *
   * The input value needs to be in a form that the
   * {@link https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Date Date object}
   * can process using its single-argument form, `new Date(value)`.
   *
   * @param {number|string} value - Either a Unix epoch time in milliseconds, or a string value representing a date
   * @param {string} [type='default'] - One of `'short'`, `'default'`, `'long'` , or `full`
   *
   * @example
   * var mf = new MessageFormat(['en', 'fi']).setIntlSupport(true);
   *
   * mf.compile('The time is now {T, time}')({ T: Date.now() })
   * // 'The time is now 11:26:35 PM'
   *
   * mf.compile('Kello on nyt {T, time}', 'fi')({ T: Date.now() })
   * // 'Kello on nyt 23.26.35'
   *
   * var cf = mf.compile('The Eagle landed at {T, time, full} on {T, date, full}');
   * cf({ T: '1969-07-20 20:17:40 UTC' })
   * // 'The Eagle landed at 10:17:40 PM GMT+2 on Sunday, July 20, 1969'
   */
  time: function(v,lc,p) {
    var o = {second:'numeric', minute:'numeric', hour:'numeric'};
    switch (p) {
      case 'full': case 'long': o.timeZoneName = 'short'; break;
      case 'short': delete o.second;
    }
    return (new Date(v)).toLocaleTimeString(lc, o)
  }
};


/** Add custom formatter functions to this MessageFormat instance
 *
 *  The general syntax for calling a formatting function in MessageFormat is
 *  `{var, fn[, args]*}`, where `var` is the variable that will be set by the
 *  user code, `fn` determines the formatting function, and `args` is an
 *  optional comma-separated list of additional arguments.
 *
 *  In JavaScript, each formatting function is called with three parameters;
 *  the variable value `v`, the current locale `lc`, and (if set) `args` as a
 *  single string, or an array of strings. Formatting functions should not have
 *  side effects.
 *
 * @see MessageFormat.formatters
 *
 * @memberof MessageFormat
 * @param {Object.<string,function>} fmt - A map of formatting functions
 * @returns {MessageFormat} The MessageFormat instance, to allow for chaining
 *
 * @example
 * var mf = new MessageFormat('en-GB');
 * mf.addFormatters({
 *   upcase: function(v) { return v.toUpperCase(); },
 *   locale: function(v, lc) { return lc; },
 *   prop: function(v, lc, p) { return v[p] }
 * });
 *
 * mf.compile('This is {VAR, upcase}.')({ VAR: 'big' })
 * // 'This is BIG.'
 *
 * mf.compile('The current locale is {_, locale}.')({ _: '' })
 * // 'The current locale is en-GB.'
 *
 * mf.compile('Answer: {obj, prop, a}')({ obj: {q: 3, a: 42} })
 * // 'Answer: 42'
 */
MessageFormat.prototype.addFormatters = function(fmt) {
  for (var name in fmt) if (fmt.hasOwnProperty(name)) {
    this.fmt[name] = fmt[name];
  }
  return this;
};


/** Disable the validation of plural & selectordinal keys
 *
 *  Previous versions of messageformat.js allowed the use of plural &
 *  selectordinal statements with any keys; now we throw an error when a
 *  statement uses a non-numerical key that will never be matched as a
 *  pluralization category for the current locale.
 *
 *  Use this method to disable the validation and allow usage as previously.
 *  To re-enable, you'll need to create a new MessageFormat instance.
 *
 * @returns {MessageFormat} The MessageFormat instance, to allow for chaining
 *
 * @example
 * var mf = new MessageFormat('en');
 * var msg = '{X, plural, zero{no answers} one{an answer} other{# answers}}';
 *
 * mf.compile(msg);
 * // Error: Invalid key `zero` for argument `X`. Valid plural keys for this
 * //        locale are `one`, `other`, and explicit keys like `=0`.
 *
 * mf.disablePluralKeyChecks();
 * mf.compile(msg)({ X: 0 });
 * // '0 answers'
 */
MessageFormat.prototype.disablePluralKeyChecks = function() {
  this.noPluralKeyChecks = true;
  for (var lc in this.pluralFuncs) if (this.pluralFuncs.hasOwnProperty(lc)) {
    this.pluralFuncs[lc].cardinal = [];
    this.pluralFuncs[lc].ordinal = [];
  }
  return this;
};


/** Enable or disable the addition of Unicode control characters to all input
 *  to preserve the integrity of the output when mixing LTR and RTL text.
 *
 * @see http://cldr.unicode.org/development/development-process/design-proposals/bidi-handling-of-structured-text
 *
 * @memberof MessageFormat
 * @param {boolean} [enable=true]
 * @returns {MessageFormat} The MessageFormat instance, to allow for chaining
 *
 * @example
 * // upper case stands for RTL characters, output is shown as rendered
 * var mf = new MessageFormat('en');
 *
 * mf.compile('{0} >> {1} >> {2}')(['first', 'SECOND', 'THIRD']);
 * // 'first >> THIRD << SECOND'
 *
 * mf.setBiDiSupport(true);
 * mf.compile('{0} >> {1} >> {2}')(['first', 'SECOND', 'THIRD']);
 * // 'first >> SECOND >> THIRD'
 */
MessageFormat.prototype.setBiDiSupport = function(enable) {
    this.bidiSupport = !!enable || (typeof enable == 'undefined');
    return this;
};


/** Enable or disable support for the default formatters, which require the
 *  `Intl` object. Note that this can't be autodetected, as the environment
 *  in which the formatted text is compiled into Javascript functions is not
 *  necessarily the same environment in which they will get executed.
 *
 * @see MessageFormat.formatters
 *
 * @memberof MessageFormat
 * @param {boolean} [enable=true]
 * @returns {MessageFormat} The MessageFormat instance, to allow for chaining
 */
MessageFormat.prototype.setIntlSupport = function(enable) {
    this.intlSupport = !!enable || (typeof enable == 'undefined');
    return this;
};


/** According to the ICU MessageFormat spec, a `#` character directly inside a
 *  `plural` or `selectordinal` statement should be replaced by the number
 *  matching the surrounding statement. By default, messageformat.js will
 *  replace `#` signs with the value of the nearest surrounding `plural` or
 *  `selectordinal` statement.
 *
 *  Set this to true to follow the stricter ICU MessageFormat spec, and to
 *  throw a runtime error if `#` is used with non-numeric input.
 *
 * @memberof MessageFormat
 * @param {boolean} [enable=true]
 * @returns {MessageFormat} The MessageFormat instance, to allow for chaining
 *
 * @example
 * var mf = new MessageFormat('en');
 *
 * var cookieMsg = '#: {X, plural, =0{no cookies} one{a cookie} other{# cookies}}';
 * mf.compile(cookieMsg)({ X: 3 });
 * // '#: 3 cookies'
 *
 * var pastryMsg = '{X, plural, one{{P, select, cookie{a cookie} other{a pie}}} other{{P, select, cookie{# cookies} other{# pies}}}}';
 * mf.compile(pastryMsg)({ X: 3, P: 'pie' });
 * // '3 pies'
 *
 * mf.setStrictNumberSign(true);
 * mf.compile(pastryMsg)({ X: 3, P: 'pie' });
 * // '# pies'
 */
MessageFormat.prototype.setStrictNumberSign = function(enable) {
    this.strictNumberSign = !!enable || (typeof enable == 'undefined');
    this.runtime.setStrictNumber(this.strictNumberSign);
    return this;
};


/** Compile messages into storable functions
 *
 *  If `messages` is a single string including ICU MessageFormat declarations,
 *  the result of `compile()` is a function taking a single Object parameter
 *  `d` representing each of the input's defined variables.
 *
 *  If `messages` is a hierarchical structure of such strings, the output of
 *  `compile()` will match that structure, with each string replaced by its
 *  corresponding JavaScript function.
 *
 *  If the input `messages` -- and therefore the output -- of `compile()` is an
 *  object, the output object will have a `toString(global)` method that may be
 *  used to store or cache the compiled functions to disk, for later inclusion
 *  in any JS environment, without a local MessageFormat instance required. Its
 *  `global` parameters sets the name (if any) of the resulting global variable,
 *  with special handling for `exports`, `module.exports`, and `export default`.
 *  If `global` does not contain a `.`, the output defaults to an UMD pattern.
 *
 *  If `locale` is not set, the first locale set in the object's constructor
 *  will be used by default; using a key at any depth of `messages` that is a
 *  declared locale will set its child elements to use that locale.
 *
 *  If `locale` is set, it is used for all messages. If the constructor
 *  declared any locales, `locale` needs to be one of them.
 *
 * @memberof MessageFormat
 * @param {string|Object} messages - The input message(s) to be compiled, in ICU MessageFormat
 * @param {string} [locale] - A locale to use for the messages
 * @returns {function|Object} The first match found for the given locale(s)
 *
 * @example
 * var mf = new MessageFormat('en');
 * var cf = mf.compile('A {TYPE} example.');
 *
 * cf({ TYPE: 'simple' })
 * // 'A simple example.'
 *
 * @example
 * var mf = new MessageFormat(['en', 'fi']);
 * var cf = mf.compile({
 *   en: { a: 'A {TYPE} example.',
 *         b: 'This is the {COUNT, selectordinal, one{#st} two{#nd} few{#rd} other{#th}} example.' },
 *   fi: { a: '{TYPE} esimerkki.',
 *         b: 'Tämä on {COUNT, selectordinal, other{#.}} esimerkki.' }
 * });
 *
 * cf.en.b({ COUNT: 2 })
 * // 'This is the 2nd example.'
 *
 * cf.fi.b({ COUNT: 2 })
 * // 'Tämä on 2. esimerkki.'
 *
 * @example
 * var fs = require('fs');
 * var mf = new MessageFormat('en').setIntlSupport();
 * var msgSet = {
 *   a: 'A {TYPE} example.',
 *   b: 'This has {COUNT, plural, one{one member} other{# members}}.',
 *   c: 'We have {P, number, percent} code coverage.'
 * };
 * var cfStr = mf.compile(msgSet).toString('module.exports');
 * fs.writeFileSync('messages.js', cfStr);
 * ...
 * var messages = require('./messages');
 *
 * messages.a({ TYPE: 'more complex' })
 * // 'A more complex example.'
 *
 * messages.b({ COUNT: 3 })
 * // 'This has 3 members.'
 */
MessageFormat.prototype.compile = function(messages, locale) {
  function _stringify(obj, level) {
    if (!level) level = 0;
    if (typeof obj != 'object') return obj;
    var o = [], indent = '';
    for (var i = 0; i < level; ++i) indent += '  ';
    for (var k in obj) o.push('\n' + indent + '  ' + Compiler.propname(k) + ': ' + _stringify(obj[k], level + 1));
    return '{' + o.join(',') + '\n' + indent + '}';
  }

  var pf;
  if (Object.keys(this.pluralFuncs).length == 0) {
    if (!locale) locale = MessageFormat.defaultLocale;
    pf = {};
    pf[locale] = getPluralFunc(locale, this.noPluralKeyChecks);
  } else if (locale) {
    pf = {};
    pf[locale] = this.pluralFuncs[locale];
    if (!pf[locale]) throw new Error('Locale ' + JSON.stringify(locale) + 'not found in ' + JSON.stringify(this.pluralFuncs) + '!');
  } else {
    pf = this.pluralFuncs;
    locale = Object.keys(pf)[0];
  }

  var compiler = new Compiler(this);
  var obj = compiler.compile(messages, locale, pf);

  if (typeof messages != 'object') {
    var fn = new Function(
        'number, plural, select, fmt', Compiler.funcname(locale),
        'return ' + obj);
    var rt = this.runtime;
    return fn(rt.number, rt.plural, rt.select, this.fmt, pf[locale]);
  }

  var rtStr = this.runtime.toString(pf, compiler) + '\n';
  var objStr = _stringify(obj);
  var result = new Function(rtStr + 'return ' + objStr)();
  if (result.hasOwnProperty('toString')) throw new Error('The top-level message key `toString` is reserved');

  result.toString = function(global) {
    switch (global || '') {
      case 'exports':
        var o = [];
        for (var k in obj) o.push(Compiler.propname(k, 'exports') + ' = ' + _stringify(obj[k]));
        return rtStr + o.join(';\n');
      case 'module.exports':
        return rtStr + 'module.exports = ' + objStr;
      case 'export default':
        return rtStr +  'export default ' + objStr;
      case '':
        return rtStr + 'return ' + objStr;
      default:
        if (global.indexOf('.') > -1) return rtStr + global + ' = ' + objStr;
        return rtStr + [
          '(function (root, G) {',
          '  if (typeof define === "function" && define.amd) { define(G); }',
          '  else if (typeof exports === "object") { module.exports = G; }',
          '  else { ' + Compiler.propname(global, 'root') + ' = G; }',
          '})(this, ' + objStr + ');'
        ].join('\n');
    }
  }
  return result;
}


module.exports = MessageFormat;

},{"./compiler":"C:\\projects\\lightning\\node_modules\\messageformat\\lib\\compiler.js","./runtime":"C:\\projects\\lightning\\node_modules\\messageformat\\lib\\runtime.js","make-plural/umd/pluralCategories":"C:\\projects\\lightning\\node_modules\\make-plural\\umd\\pluralCategories.js","make-plural/umd/plurals":"C:\\projects\\lightning\\node_modules\\make-plural\\umd\\plurals.js"}],"C:\\projects\\lightning\\node_modules\\messageformat\\lib\\runtime.js":[function(require,module,exports){
var Compiler = require('./compiler');


/** A set of utility functions that are called by the compiled Javascript
 *  functions, these are included locally in the output of {@link
 *  MessageFormat#compile compile()}.
 *
 * @class
 * @param {MessageFormat} mf - A MessageFormat instance
 */
function Runtime(mf) {
  this.mf = mf;
  this.setStrictNumber(mf.strictNumberSign);
}

module.exports = Runtime;


/** Utility function for `#` in plural rules
 *
 *  Will throw an Error if `value` has a non-numeric value and `offset` is
 *  non-zero or {@link MessageFormat#setStrictNumberSign} is set.
 *
 * @function Runtime#number
 * @param {number} value - The value to operate on
 * @param {string} name - The name of the argument, used for error reporting
 * @param {number} [offset=0] - An optional offset, set by the surrounding context
 * @returns {number|string} The result of applying the offset to the input value
 */
function defaultNumber(value, name, offset) {
  if (!offset) return value;
  if (isNaN(value)) throw new Error('Can\'t apply offset:' + offset + ' to argument `' + name +
                                    '` with non-numerical value ' + JSON.stringify(value) + '.');
  return value - offset;
}


/** @private */
function strictNumber(value, name, offset) {
  if (isNaN(value)) throw new Error('Argument `' + name + '` has non-numerical value ' + JSON.stringify(value) + '.');
  return value - (offset || 0);
}


/** Set how strictly the {@link number} method parses its input.
 *
 *  According to the ICU MessageFormat spec, `#` can only be used to replace a
 *  number input of a `plural` statement. By default, messageformat.js does not
 *  throw a runtime error if you use non-numeric argument with a `plural` rule,
 *  unless rule also includes a non-zero `offset`.
 *
 *  This is called by {@link MessageFormat#setStrictNumberSign} to follow the
 *  stricter ICU MessageFormat spec.
 *
 * @param {boolean} [enable=false]
 */
Runtime.prototype.setStrictNumber = function(enable) {
  this.number = enable ? strictNumber : defaultNumber;
}


/** Utility function for `{N, plural|selectordinal, ...}`
 *
 * @param {number} value - The key to use to find a pluralization rule
 * @param {number} offset - An offset to apply to `value`
 * @param {function} lcfunc - A locale function from `pluralFuncs`
 * @param {Object.<string,string>} data - The object from which results are looked up
 * @param {?boolean} isOrdinal - If true, use ordinal rather than cardinal rules
 * @returns {string} The result of the pluralization
 */
Runtime.prototype.plural = function(value, offset, lcfunc, data, isOrdinal) {
  if ({}.hasOwnProperty.call(data, value)) return data[value];
  if (offset) value -= offset;
  var key = lcfunc(value, isOrdinal);
  if (key in data) return data[key];
  return data.other;
}


/** Utility function for `{N, select, ...}`
 *
 * @param {number} value - The key to use to find a selection
 * @param {Object.<string,string>} data - The object from which results are looked up
 * @returns {string} The result of the select statement
 */
Runtime.prototype.select = function(value, data) {
  if ({}.hasOwnProperty.call(data, value)) return data[value];
  return data.other;
}


/** @private */
Runtime.prototype.toString = function(pluralFuncs, compiler) {
  function _stringify(o, level) {
    if (typeof o != 'object') {
      var funcStr = o.toString().replace(/^(function )\w*/, '$1');
      var indent = /([ \t]*)\S.*$/.exec(funcStr);
      return indent ? funcStr.replace(new RegExp('^' + indent[1], 'mg'), '') : funcStr;
    }
    var s = [];
    for (var i in o) {
      if (level == 0) s.push('var ' + i + ' = ' + _stringify(o[i], level + 1) + ';\n');
      else s.push(Compiler.propname(i) + ': ' + _stringify(o[i], level + 1));
    }
    if (level == 0) return s.join('');
    if (s.length == 0) return '{}';
    var indent = '  '; while (--level) indent += '  ';
    return '{\n' + s.join(',\n').replace(/^/gm, indent) + '\n}';
  }

  var obj = {};
  Object.keys(compiler.locales).forEach(function(lc) { obj[Compiler.funcname(lc)] = pluralFuncs[lc]; });
  Object.keys(compiler.runtime).forEach(function(fn) { obj[fn] = this[fn]; }, this);
  var fmtKeys = Object.keys(compiler.formatters);
  var fmt = this.mf.fmt;
  if (fmtKeys.length) obj.fmt = fmtKeys.reduce(function(o, key) { o[key] = fmt[key]; return o; }, {});
  return _stringify(obj, 0);
}

},{"./compiler":"C:\\projects\\lightning\\node_modules\\messageformat\\lib\\compiler.js"}],"C:\\projects\\lightning\\node_modules\\path-browserify\\index.js":[function(require,module,exports){
(function (process){
// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

}).call(this,require('_process'))

},{"_process":"C:\\projects\\lightning\\node_modules\\process\\browser.js"}],"C:\\projects\\lightning\\node_modules\\process\\browser.js":[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],"C:\\projects\\lightning\\node_modules\\querystring-es3\\decode.js":[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

},{}],"C:\\projects\\lightning\\node_modules\\querystring-es3\\encode.js":[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};

},{}],"C:\\projects\\lightning\\node_modules\\querystring-es3\\index.js":[function(require,module,exports){
'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');

},{"./decode":"C:\\projects\\lightning\\node_modules\\querystring-es3\\decode.js","./encode":"C:\\projects\\lightning\\node_modules\\querystring-es3\\encode.js"}],"C:\\projects\\lightning\\node_modules\\querystring\\decode.js":[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (Array.isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

},{}],"C:\\projects\\lightning\\node_modules\\querystring\\encode.js":[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return Object.keys(obj).map(function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (Array.isArray(obj[k])) {
        return obj[k].map(function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

},{}],"C:\\projects\\lightning\\node_modules\\querystring\\index.js":[function(require,module,exports){
arguments[4]["C:\\projects\\lightning\\node_modules\\querystring-es3\\index.js"][0].apply(exports,arguments)
},{"./decode":"C:\\projects\\lightning\\node_modules\\querystring\\decode.js","./encode":"C:\\projects\\lightning\\node_modules\\querystring\\encode.js"}],"C:\\projects\\lightning\\node_modules\\regenerator-runtime\\runtime.js":[function(require,module,exports){
(function (global){
/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],"C:\\projects\\lightning\\node_modules\\reserved-words\\lib\\index.js":[function(require,module,exports){
module.exports = require('./reserved-words');

},{"./reserved-words":"C:\\projects\\lightning\\node_modules\\reserved-words\\lib\\reserved-words.js"}],"C:\\projects\\lightning\\node_modules\\reserved-words\\lib\\reserved-words.js":[function(require,module,exports){
var assert = require('assert');

/**
 * Structure for storing keywords.
 *
 * @typedef {Object.<String,Boolean>} KeywordsHash
 */

/**
 * ECMAScript dialects.
 *
 * @const
 * @type {Object.<String,Number|String>} - keys as readable names and values as versions
 */
var DIALECTS = {
    es3: 3,
    es5: 5,
    es2015: 6,
    es7: 7,

    // aliases
    es6: 6,
    'default': 5,
    next: 6
};

/**
 * ECMAScript reserved words.
 *
 * @type {Object.<String,KeywordsHash>}
 */
var KEYWORDS = exports.KEYWORDS = {};

/**
 * Check word for being an reserved word.
 *
 * @param {String} word - word to check
 * @param {String|Number} [dialect] - dialect or version
 * @param {Boolean} [strict] - strict mode
 * @returns {?Boolean}
 */
exports.check = function check(word, dialect, strict) {
    dialect = dialect || DIALECTS.default;
    var version = DIALECTS[dialect] || dialect;

    if (strict && version >= 5) {
        version += '-strict';
    }

    assert(KEYWORDS[version], 'Unknown dialect');

    return KEYWORDS[version].hasOwnProperty(word);
};

/**
 * Reserved Words for ES3
 *
 * ECMA-262 3rd: 7.5.1
 * http://www.ecma-international.org/publications/files/ECMA-ST-ARCH/ECMA-262,%203rd%20edition,%20December%201999.pdf
 *
 * @type {KeywordsHash}
 */
KEYWORDS['3'] = _hash(
    // Keyword, ECMA-262 3rd: 7.5.2
    'break    else       new     var',
    'case     finally    return  void',
    'catch    for        switch  while',
    'continue function   this    with',
    'default  if         throw',
    'delete   in         try',
    'do       instanceof typeof',
    // FutureReservedWord, ECMA-262 3rd 7.5.3
    'abstract enum       int        short',
    'boolean  export     interface  static',
    'byte     extends    long       super',
    'char     final      native     synchronized',
    'class    float      package    throws',
    'const    goto       private    transient',
    'debugger implements protected  volatile',
    'double   import     public',
    // NullLiteral & BooleanLiteral
    'null true false'
);

/**
 * Reserved Words for ES5.
 *
 * http://es5.github.io/#x7.6.1
 *
 * @type {KeywordsHash}
 */
KEYWORDS['5'] = _hash(
    // Keyword
    'break    do       instanceof typeof',
    'case     else     new        var',
    'catch    finally  return     void',
    'continue for      switch     while',
    'debugger function this       with',
    'default  if       throw',
    'delete   in       try',
    // FutureReservedWord
    'class enum extends super',
    'const export import',
    // NullLiteral & BooleanLiteral
    'null true false'
);

/**
 * Reserved Words for ES5 in strict mode.
 *
 * @type {KeywordsHash}
 */
KEYWORDS['5-strict'] = _hash(
    KEYWORDS['5'],
    // FutureReservedWord, strict mode. http://es5.github.io/#x7.6.1.2
    'implements let     private   public yield',
    'interface  package protected static'
);

/**
 * Reserved Words for ES6.
 *
 * 11.6.2
 * http://www.ecma-international.org/ecma-262/6.0/index.html#sec-reserved-words
 *
 * @type {KeywordsHash}
 */
KEYWORDS['6'] = _hash(
    // Keywords, ES6 11.6.2.1, http://www.ecma-international.org/ecma-262/6.0/index.html#sec-keywords
    'break    do       in         typeof',
    'case     else     instanceof var',
    'catch    export   new        void',
    'class    extends  return     while',
    'const    finally  super      with',
    'continue for      switch     yield',
    'debugger function this',
    'default  if       throw',
    'delete   import   try',
    // Future Reserved Words, ES6 11.6.2.2
    // http://www.ecma-international.org/ecma-262/6.0/index.html#sec-future-reserved-words
    'enum await',
    // NullLiteral & BooleanLiteral
    'null true false'
);

/**
 * Reserved Words for ES6 in strict mode.
 *
 * @type {KeywordsHash}
 */
KEYWORDS['6-strict'] = _hash(
    KEYWORDS['6'],
    // Keywords, ES6 11.6.2.1
    'let static',
    // Future Reserved Words, ES6 11.6.2.2
    'implements package protected',
    'interface private public'
);

/**
 * Generates hash from strings
 *
 * @private
 * @param {...String|KeywordsHash} keywords - Space-delimited string or previous result of _hash
 * @return {KeywordsHash} - Object with keywords in keys and true in values
 */
function _hash() {
    var set = Array.prototype.map.call(arguments, function(v) {
        return typeof v === 'string' ? v : Object.keys(v).join(' ');
    }).join(' ');

    return set.split(/\s+/)
        .reduce(function(res, keyword) {
            res[keyword] = true;
            return res;
        }, {});
}

},{"assert":"C:\\projects\\lightning\\node_modules\\assert\\assert.js"}],"C:\\projects\\lightning\\node_modules\\underscore\\underscore.js":[function(require,module,exports){
(function (global){
//     Underscore.js 1.9.1
//     http://underscorejs.org
//     (c) 2009-2018 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = typeof self == 'object' && self.self === self && self ||
            typeof global == 'object' && global.global === global && global ||
            this ||
            {};

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

  // Create quick reference variables for speed access to core prototypes.
  var push = ArrayProto.push,
      slice = ArrayProto.slice,
      toString = ObjProto.toString,
      hasOwnProperty = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var nativeIsArray = Array.isArray,
      nativeKeys = Object.keys,
      nativeCreate = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for their old module API. If we're in
  // the browser, add `_` as a global object.
  // (`nodeType` is checked to ensure that `module`
  // and `exports` are not HTML elements.)
  if (typeof exports != 'undefined' && !exports.nodeType) {
    if (typeof module != 'undefined' && !module.nodeType && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.9.1';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-argument case is omitted because we’re not using it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  var builtinIteratee;

  // An internal function to generate callbacks that can be applied to each
  // element in a collection, returning the desired result — either `identity`,
  // an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (_.iteratee !== builtinIteratee) return _.iteratee(value, context);
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value) && !_.isArray(value)) return _.matcher(value);
    return _.property(value);
  };

  // External wrapper for our callback generator. Users may customize
  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
  // This abstraction hides the internal-only argCount argument.
  _.iteratee = builtinIteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // Some functions take a variable number of arguments, or a few expected
  // arguments at the beginning and then a variable number of values to operate
  // on. This helper accumulates all remaining arguments past the function’s
  // argument length (or an explicit `startIndex`), into an array that becomes
  // the last argument. Similar to ES6’s "rest parameter".
  var restArguments = function(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0;
      for (; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var shallowProperty = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  var has = function(obj, path) {
    return obj != null && hasOwnProperty.call(obj, path);
  }

  var deepGet = function(obj, path) {
    var length = path.length;
    for (var i = 0; i < length; i++) {
      if (obj == null) return void 0;
      obj = obj[path[i]];
    }
    return length ? obj : void 0;
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = shallowProperty('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  var createReduce = function(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  };

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var keyFinder = isArrayLike(obj) ? _.findIndex : _.findKey;
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = restArguments(function(obj, path, args) {
    var contextPath, func;
    if (_.isFunction(path)) {
      func = path;
    } else if (_.isArray(path)) {
      contextPath = path.slice(0, -1);
      path = path[path.length - 1];
    }
    return _.map(obj, function(context) {
      var method = func;
      if (!method) {
        if (contextPath && contextPath.length) {
          context = deepGet(context, contextPath);
        }
        if (context == null) return void 0;
        method = context[path];
      }
      return method == null ? method : method.apply(context, args);
    });
  });

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection.
  _.shuffle = function(obj) {
    return _.sample(obj, Infinity);
  };

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    var sample = isArrayLike(obj) ? _.clone(obj) : _.values(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = _.random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (has(result, key)) result[key]++; else result[key] = 1;
  });

  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (_.isString(obj)) {
      // Keep surrogate pair characters together
      return obj.match(reStrSymbol);
    }
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null || array.length < 1) return n == null ? void 0 : [];
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null || array.length < 1) return n == null ? void 0 : [];
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, Boolean);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, output) {
    output = output || [];
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        // Flatten current level of array or arguments object.
        if (shallow) {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        } else {
          flatten(value, shallow, strict, output);
          idx = output.length;
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = restArguments(function(array, otherArrays) {
    return _.difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // The faster algorithm will not work with an iteratee if the iteratee
  // is not a one-to-one function, so providing an iteratee will disable
  // the faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted && !iteratee) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = restArguments(function(arrays) {
    return _.uniq(flatten(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = restArguments(function(array, rest) {
    rest = flatten(rest, true, true);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  });

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices.
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = restArguments(_.unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values. Passing by pairs is the reverse of _.pairs.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions.
  var createPredicateIndexFinder = function(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  };

  // Returns the first index on an array-like that passes a predicate test.
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions.
  var createIndexFinder = function(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  };

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    if (!step) {
      step = stop < start ? -1 : 1;
    }

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Chunk a single array into multiple arrays, each containing `count` or fewer
  // items.
  _.chunk = function(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments.
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = restArguments(function(func, context, args) {
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArguments(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  _.partial = restArguments(function(func, boundArgs) {
    var placeholder = _.partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  _.partial.placeholder = _;

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = restArguments(function(obj, keys) {
    keys = flatten(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = _.bind(obj[key], obj);
    }
  });

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = restArguments(function(func, wait, args) {
    return setTimeout(function() {
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function() {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, result;

    var later = function(context, args) {
      timeout = null;
      if (args) result = func.apply(context, args);
    };

    var debounced = restArguments(function(args) {
      if (timeout) clearTimeout(timeout);
      if (immediate) {
        var callNow = !timeout;
        timeout = setTimeout(later, wait);
        if (callNow) result = func.apply(this, args);
      } else {
        timeout = _.delay(later, wait, this, args);
      }

      return result;
    });

    debounced.cancel = function() {
      clearTimeout(timeout);
      timeout = null;
    };

    return debounced;
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  _.restArguments = restArguments;

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  var collectNonEnumProps = function(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  };

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`.
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object.
  // In contrast to _.map it returns an object.
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = _.keys(obj),
        length = keys.length,
        results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  // The opposite of _.object.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`.
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s).
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test.
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Internal pick helper function to determine if `obj` has key `key`.
  var keyInObj = function(value, key, obj) {
    return key in obj;
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = restArguments(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (_.isFunction(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = _.allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the blacklisted properties.
  _.omit = restArguments(function(obj, keys) {
    var iteratee = keys[0], context;
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = _.map(flatten(keys, false, false), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  });

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq, deepEq;
  eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  };

  // Internal recursive comparison function for `isEqual`.
  deepEq = function(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN.
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
      case '[object Symbol]':
        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError, isMap, isWeakMap, isSet, isWeakSet.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error', 'Symbol', 'Map', 'WeakMap', 'Set', 'WeakSet'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return !_.isSymbol(obj) && isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`?
  _.isNaN = function(obj) {
    return _.isNumber(obj) && isNaN(obj);
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, path) {
    if (!_.isArray(path)) {
      return has(obj, path);
    }
    var length = path.length;
    for (var i = 0; i < length; i++) {
      var key = path[i];
      if (obj == null || !hasOwnProperty.call(obj, key)) {
        return false;
      }
      obj = obj[key];
    }
    return !!length;
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  // Creates a function that, when passed an object, will traverse that object’s
  // properties down the given `path`, specified as an array of keys or indexes.
  _.property = function(path) {
    if (!_.isArray(path)) {
      return shallowProperty(path);
    }
    return function(obj) {
      return deepGet(obj, path);
    };
  };

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    if (obj == null) {
      return function(){};
    }
    return function(path) {
      return !_.isArray(path) ? obj[path] : deepGet(obj, path);
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

  // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // Traverses the children of `obj` along `path`. If a child is a function, it
  // is invoked with its parent as context. Returns the value of the final
  // child, or `fallback` if any child is undefined.
  _.result = function(obj, path, fallback) {
    if (!_.isArray(path)) path = [path];
    var length = path.length;
    if (!length) {
      return _.isFunction(fallback) ? fallback.call(obj) : fallback;
    }
    for (var i = 0; i < length; i++) {
      var prop = obj == null ? void 0 : obj[path[i]];
      if (prop === void 0) {
        prop = fallback;
        i = length; // Ensure we don't continue iterating.
      }
      obj = _.isFunction(prop) ? prop.call(obj) : prop;
    }
    return obj;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var chainResult = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_, args));
      };
    });
    return _;
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return chainResult(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return chainResult(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return String(this._wrapped);
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (typeof define == 'function' && define.amd) {
    define('underscore', [], function() {
      return _;
    });
  }
}());

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],"C:\\projects\\lightning\\node_modules\\url-join\\lib\\url-join.js":[function(require,module,exports){
(function (name, context, definition) {
  if (typeof module !== 'undefined' && module.exports) module.exports = definition();
  else if (typeof define === 'function' && define.amd) define(definition);
  else context[name] = definition();
})('urljoin', this, function () {

  function startsWith(str, searchString) {
    return str.substr(0, searchString.length) === searchString;
  }

  function normalize (strArray, options) {
    var resultArray = [];
    
    // If the first part is a plain protocol, we combine it with the next part.
    if (strArray[0].match(/^[^/:]+:\/*$/) && strArray.length > 1) {
      var first = strArray.shift();
      strArray[0] = first + strArray[0];
    }

    // There must be two or three slashes in the file protocol, two slashes in anything else.
    if (strArray[0].match(/^file:\/\/\//)) {
      strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, '$1:///');
    } else {
      strArray[0] = strArray[0].replace(/^([^/:]+):\/*/, '$1://');
    }
    
    for (var i = 0; i < strArray.length; i++) {
      
      var component = strArray[i];

      if (typeof component !== 'string') {
        component = component && component.toString() || '';
      }

      if (i > 0) {
        // Removing the starting slashes for each component but the first.
        component = component.replace(/^[\/]+/, '');
      }
      if (i < strArray.length - 1) {
        // Removing the ending slashes for each component but the last.
        component = component.replace(/[\/]+$/, '');
      } else {
        // For the last component we will combine multiple slashes to a single one.
        component = component.replace(/[\/]+$/, '/');
      }
      
      resultArray.push(component);
      
    }

    var str = resultArray.join('/');
    // Each input component is now separated by a single slash except the possible first plain protocol part.

    // remove trailing slash before parameters or hash
    str = str.replace(/\/(\?|&|#[^!])/g, '$1');

    // replace ? in parameters with &
    var parts = str.split('?');
    str = parts.shift() + (parts.length > 0 ? '?': '') + parts.join('&');

    return str;
  }

  return function () {
    var input = arguments;
    var options = {};

    if (typeof arguments[0] === 'object') {
      // new syntax with array and options
      input = arguments[0];
      options = arguments[1] || {};
    }
    
    return normalize([].slice.call(input), options);
  };

});

},{}],"C:\\projects\\lightning\\public\\ecmascript\\collections\\base.js":[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// import when we move more to modules
exports["default"] = window.Backbone.Collection;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\TitleFulfillmentModal\\TitleFulfillmentModal.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _modal = require('../common/modal');

var _TitleFormatBadge = require('../media/views/TitleInfo/TitleFormatBadge');

var _TitleFormatBadge2 = _interopRequireDefault(_TitleFormatBadge);

var _Cover = require('../media/Cover');

var _Cover2 = _interopRequireDefault(_Cover);

var _KindlePreference = require('../kindle_preference_modal/KindlePreference');

var _KindlePreference2 = _interopRequireDefault(_KindlePreference);

var _DownloadWarningModal = require('../media/views/DownloadWarningModal');

var _DownloadWarningModal2 = _interopRequireDefault(_DownloadWarningModal);

var _KindleTroubleModal = require('../kindle_trouble_modal/views/KindleTroubleModal');

var _KindleTroubleModal2 = _interopRequireDefault(_KindleTroubleModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Backbone = window.Backbone;
var text = window.text;
var url = window.url;
var acceptableTypes = ['ebook', 'audiobook', 'video', 'magazine'];

var TitleFulfillmentModal = function (_Backbone$View) {
    _inherits(TitleFulfillmentModal, _Backbone$View);

    function TitleFulfillmentModal(_ref) {
        var loan = _ref.loan,
            title = _ref.title,
            bus = _ref.bus,
            featureManager = _ref.featureManager,
            patronSettings = _ref.patronSettings,
            accountLimits = _ref.accountLimits,
            _ref$isRenewal = _ref.isRenewal,
            isRenewal = _ref$isRenewal === undefined ? false : _ref$isRenewal,
            _ref$formatLock = _ref.formatLock,
            formatLock = _ref$formatLock === undefined ? null : _ref$formatLock;

        _classCallCheck(this, TitleFulfillmentModal);

        var _this = _possibleConstructorReturn(this, (TitleFulfillmentModal.__proto__ || Object.getPrototypeOf(TitleFulfillmentModal)).apply(this, arguments));

        _this.loan = loan;
        _this.title = title;
        _this.bus = bus;
        _this.featureManager = featureManager;
        _this.patronSettings = patronSettings;
        _this.accountLimits = accountLimits;
        _this.isRenewal = isRenewal;
        _this.formatLock = formatLock;
        _this._views = [];

        _this._views.push(_this.cover = new _Cover2['default']({ model: _this.title, coverWidths: { mobile: 250, tablet: 250, desktop: 250 } }));
        _this._views.push(_this.formatBadge = new _TitleFormatBadge2['default']({ typeId: _this.title.get('type').id }));
        return _this;
    }

    _createClass(TitleFulfillmentModal, [{
        key: 'render',
        value: function render() {
            if (acceptableTypes.includes(this.loan.type.id)) {
                this.formatBadge.render();

                var _html = this.renderTemplate();

                var modalContents = {
                    title: text('genericSuccess'),
                    autoShow: false,
                    classes: ['large', 'TitleFulfillmentModal'],
                    content: _html
                };

                this.modal = new _modal.Modal(modalContents);

                this.attachEvents(this.modal.$el);
                this.modal.show();
            } else {
                window.Logger.log('error', 'Title has unexpected media type', {
                    source: 'fulfillment modal',
                    title: this.loan.title,
                    id: this.loan.id,
                    type: this.loan.type
                });
                toaster.push(text('genericError'), 'error');
            }
        }
    }, {
        key: 'attachEvents',
        value: function attachEvents(node) {
            var _this2 = this;

            var titleModel = this.title;
            node.find('.kindleFulfillmentButton').click(function (evt) {

                var formatId = $(evt.currentTarget).attr('data-format-id');

                if (_this2.featureManager.isEnabled('kindleLoanOffer') && !(Cookies.get('kindleFulfillmentAppOverride') && Cookies.get('kindleFulfillmentAppOverride') === '1') && window.globalPreferences.get('kindleFulfillment') == null) {
                    // don't follow the href on the kindle button since we need to show a modal sequence first.
                    evt.preventDefault();

                    var fulfillTarget = url(window.routes.mediaDownload, { format: formatId, mediaId: _this2.loan.id });

                    new _KindlePreference2['default']({
                        bus: _this2.bus,
                        globalPreferences: window.globalPreferences,
                        source: 'content_fulfillment',
                        completionTargetUrl: fulfillTarget
                    }).run();
                }
                _this2.bus.trigger('title:download', { titleModel: titleModel, context: { formatId: formatId } });
            });

            node.find('.od-format-button').click(function (evt) {
                var formatId = $(evt.currentTarget).attr('data-format-id');
                _this2.bus.trigger('title:download', { titleModel: titleModel, context: { formatId: formatId } });
            });

            node.find('.loan-button-nonkindle, .Loans-bundledButton').click(function (evt) {
                new _DownloadWarningModal2['default']($(evt.currentTarget));
                var formatId = $(evt.currentTarget).attr('data-format-id');
                _this2.bus.trigger('title:download', { titleModel: titleModel, context: { formatId: formatId } });
            });

            node.find('.kindle-report-trouble-button').on('click', function (event) {
                var titleId = _this2.loan.id;
                var alternativeFormat = _this2.loan.alternativeToKindle;
                var modal = new _KindleTroubleModal2['default']({ titleId: titleId, alternativeFormat: alternativeFormat });
            });
        }
    }, {
        key: 'renderTemplate',
        value: function renderTemplate() {
            this.filterRestrictedFormats();
            var firstButton = this.getFirstButton();

            var kindleOnly = this.isRenewal && this.formatLock === 'ebook-kindle';

            var buttonStack = firstButton + '\n                ' + (!this.suppressAudiobookButton && this.loan.showDivider && !kindleOnly ? this.renderButtonDivider() : '') + '\n                ' + (this.loan.showODFormatButton && !kindleOnly ? this.renderODReadButton() : '') + '\n                ' + (this.loan.showNonKindleButtonBelowDivider ? this.renderDownloadButton() : this.loan.showDownloadDropdown ? this.renderDownloadDropdown() : '') + '\n                ' + (this.loan.restrictedFormats.length > 0 && !this.loan.hasNonKindleNonReadFormat && !this.loan.preferKindle ? this.renderRestrictedFormatWarning(this.loan.restrictedFormats) : '') + '\n                ' + (this.loan.isEbook && !this.loan.showKindleTroubleAccordian && this.loan.hasKindleFormat ? '<div class="kindle-trouble-container">' + this.renderKindleReportLink() + '</div>' : '') + '\n                ';
            if (window.featureManager.isEnabled('macOSAudiobookMessaging') && this.isAudiobookOnMac) {
                buttonStack = buttonStack + '\n            <div class="macOsAudiobookWarning">\n                <div class="supportedVersions">' + html("macOsAudiobookSupression.supoortedVersions") + '</div>\n                <div class="helpLink"><a href="https://help.overdrive.com/en-us/1322.htm" target="_blank">' + html("macOsAudiobookSupression.learnMore") + '</a><div>\n            </div>';
            }

            var titleSpan = '<span class=\'title\'>' + this.title.get('title') + '</span>';
            var loansRemaining = this.accountLimits.loansRemaining;

            var youCanBorrowText = '';
            if (loansRemaining > 0) {
                if (this.loan.isMagazine) {
                    youCanBorrowText = text('accountLoans.magazinesDontCountAgainstCheckout', { loans: loansRemaining });
                } else {
                    youCanBorrowText = text('accountLoans.youCanBorrowMoreTitles', { loans: loansRemaining });
                }
            } else {
                youCanBorrowText = text('accountLoans.youCanBorrowNoMoreTitles');
            }

            return '\n        <div class="content">\n            <div class="row">\n                <div class="small-5 columns">' + this.cover.$el.html() + '</div>\n                <div class="small-7 columns metadata-column">\n                    <div class="borrowed-until">\n                        <div>' + (this.loan.useFirstPlayText ? text('borrowSuccessModal.loanedUntilFirstPlay', { date: this.loan.expires, title: titleSpan, hours: this.loan.constraints.watchExpirationHours }) : this.isRenewal ? text('renewal.titleNowExpires', { title: titleSpan, expirationDate: this.loan.expires }) : text('borrowSuccessModal.loanedUntil', { date: this.loan.expires, title: titleSpan })) + '</div>\n                        ' + (this.isRenewal ? '' : '<div class=\'loans-remaining\'>' + youCanBorrowText + '</div>') + '\n                    </div>\n                    ' + (this.loan.bundledContent.length > 0 ? this.renderBundledContent() : '') + '\n                    <div class="buttons show-for-medium-up">\n                        ' + (this.isRenewal && !!this.formatLock ? kindleOnly ? '<div class="newDueDate kindleSteps bold">' + html('renewal.kindleRenewalInstructions.header') + '</div>\n                                <ol>\n                                    <li class="kindleSteps"><a href=\'https://www.amazon.com/mn/dcw/myx.html#/home/content/booksAll/dateDsc/\' target=\'_blank\'>' + html('renewal.kindleRenewalInstructions.returnLinkText') + '</a></li>\n                                    <li class="kindleSteps">' + html('renewal.kindleRenewalInstructions.sendBook') + '</li>\n                                </ol>' : '<div class="newDueDate bold">' + html('renewal.downloadAgainText') + '</div>' : '') + '\n                        ' + buttonStack + '\n                    </div>\n                </div>\n\n            </div>\n\n            <div class="buttons full-modal-width show-for-small-only">\n                ' + (this.isRenewal && !!this.formatLock ? kindleOnly ? '<div class="newDueDate kindleSteps bold">' + html('renewal.kindleRenewalInstructions.header') + '</div>\n                        <ol>\n                            <li class="kindleSteps"><a href=\'https://www.amazon.com/mn/dcw/myx.html#/home/content/booksAll/dateDsc/\' target=\'_blank\'>' + html('renewal.kindleRenewalInstructions.returnLinkText') + '</a></li>\n                            <li class="kindleSteps">' + html('renewal.kindleRenewalInstructions.sendBook') + '</li>\n                        </ol>' : '<div class="newDueDate bold">' + html('renewal.downloadAgainText') + '</div>' : '') + '\n                ' + buttonStack + '\n            </div>\n        </div>';
        }
    }, {
        key: 'getFirstButton',
        value: function getFirstButton() {
            // get whatever element goes in the first position inside the buttons container.  In some cases not actually a button.
            var content = '';
            if (this.loan.isFormatLockedIn) {
                if (this.loan.otherFormats && this.loan.otherFormats[0].id === 'ebook-epub-adobe') {
                    content = this.renderKindleButton();
                } else {
                    content = this.renderDownloadButton();
                }
            } else if (this.loan.isEbook) {
                if (this.loan.hasKindleFormat) {
                    content = this.renderKindleButton();
                } else if (this.loan.showNoKindleMessage) {
                    content = '<div class=\'no-kindle-warning\'>' + text('accountLoans.kindleFulfillment.noneAvailable') + '</div>';
                } else if (this.loan.showNonKindleButtonAboveDivider) {
                    content = this.renderDownloadButton();
                }
            } else if (!this.loan.isMagazine) {
                if ((this.loan.otherFormats.length === 1 || this.loan.otherFormats.length === 1 && window.OverDrive.inApp) && !this.suppressAudiobookButton) {
                    content = this.renderDownloadButton();
                } else if (this.loan.otherFormats.length > 1) {
                    content = this.renderDownloadDropdown();
                }
            }
            return content;
        }
    }, {
        key: 'renderButtonDivider',
        value: function renderButtonDivider() {
            // If we're showing the divider usually there are two fulfillment options being presented.  The exception is the case
            // where the first slot is filled by the "kindle not available" message.
            return '<div class="button-divider-container">\n                    <div class="button-divider"></div>\n                    ' + (!this.loan.showNoKindleMessage ? '\n                    <span class="divider-text u-allCaps">\n                        ' + html('or') + '\n                    </span>' : '') + '\n                </div>';
        }
    }, {
        key: 'renderKindleButton',
        value: function renderKindleButton() {
            return '<a target="_blank"  href="' + url(window.routes.mediaDownload, { format: this.loan.kindleFormat.id, mediaId: this.loan.id }) + '"\n                    class="button radius kindleFulfillmentButton" data-download tabindex="0" role="button"\n                    data-format-id="' + this.loan.kindleFormat.id + '" data-media-id="' + this.loan.id + '"\n                    data-format-name="' + html('formats.' + this.loan.kindleFormat.id) + '">\n                    <span> ' + text('kindleFulfillment.readNow', { Kindle: '<i class="icon-kindle-logo" aria-label="' + html('kindleFulfillment.kindle') + '"></i>' }) + '</span>\n                </a>\n                <div class=\'kindle-read-on\'>\n                    <span>' + text('accountLoans.kindleFulfillment.kindleReadOn') + '</span>\n                    <span style="display:inline-block">\n                        <i class=\'icon-android\'></i>\n                        <i class=\'icon-apple\'></i>\n                        <i class=\'icon-windows\'></i>\n                    </span>\n                </div>\n                ' + (this.loan.showKindleTroubleAccordian ? this.renderKindleTroubleAccordion() : '') + '\n                ';
        }
    }, {
        key: 'renderKindleTroubleAccordion',
        value: function renderKindleTroubleAccordion() {

            var embeddedButton = '';
            if (this.loan.hasOverdriveFormat) {
                embeddedButton = this.renderODReadButton();
            }

            return '<ul class="accordion kindle-trouble-container" data-accordion>\n                    <li class="accordion-navigation" >\n                        <a class="accordion-title" href="#havingTroublePanel' + this.loan.id + '">\n                            <div class="row">\n                                <div class=\'small-10 columns title-text\'>' + text('accountLoans.havingTrouble') + '</div>\n                                <div class=\'small-2 columns down-arrow-container\'>\n                                    <i class="icon-down-arrow" aria-hidden="true"></i>\n                                </div>\n                            </div>\n                        </a>\n                        <div id="havingTroublePanel' + this.loan.id + '" class="content">\n                            ' + embeddedButton + '\n                            ' + this.renderKindleReportLink() + '\n                        </div>\n                    </li>\n                </ul>';
        }
    }, {
        key: 'renderKindleReportLink',
        value: function renderKindleReportLink() {

            return '<div class="report-kindle-problem">\n                    <button class="link-button kindle-report-trouble-button">\n                        ' + text('kindleFulfillment.reportKindleTrouble') + '\n                    </button>\n                </div>';
        }
    }, {
        key: 'renderDownloadButton',
        value: function renderDownloadButton() {
            var formatId = this.loan.nonKindleFormats[0].id;
            return '<a target="_blank"\n                    class="button loan-button-nonkindle radius primary" tabindex="0" role="button"\n                    data-format-id="' + formatId + '" data-media-id="' + this.loan.id + '"\n                    data-format-name="' + html('formats.' + formatId) + '">\n                    <b>' + (formatId === 'ebook-media-do' ? html('readNow') : this.isRenewal && !!this.formatLock ? html('renewal.downloadAgain') : html('accountLoans.download')) + '</b><br/>\n                    <span class="dl-text">' + html('formats.' + formatId) + '</span>\n                </a>';
        }
    }, {
        key: 'renderODReadButton',
        value: function renderODReadButton() {
            var btnSubText = '';
            var btnActionName = '';

            if (this.loan.isEbook || this.loan.isMagazine) {
                btnActionName = text('readNow');
            } else if (this.loan.isVideo) {
                btnActionName = window.OverDrive.inApp ? text('addToBookshelf') : text('watchNow');
            } else if (this.loan.isAudiobook) {
                btnActionName = text('listenNow');
            }

            if (this.loan.hasReadalong) {
                btnSubText = '<br /><span class="dl-text">' + html('narratedModal.heading') + '</span>';
            }

            return '<a ' + (this.loan.overDriveFormat.id === 'video-streaming' ? 'data-artificial-lock' : '') + '\n                href= "' + url(window.routes.mediaDownload, { format: this.loan.overDriveFormat.id, mediaId: this.loan.id }) + '"\n                target = "_blank"\n                class="button secondary radius od-format-button"\n                role = "button"\n                data-format-id="' + this.loan.overDriveFormat.id + '"\n                data-media-id="' + this.loan.id + '" > <b>' + btnActionName + '</b>' + btnSubText + '\n            </a>';
        }
    }, {
        key: 'renderDownloadDropdown',
        value: function renderDownloadDropdown() {
            var _this3 = this;

            var options = '';

            this.loan.nonKindleFormats.forEach(function (format) {
                options = options + '\n                        <li role="listitem">\n                            <a data-artificial-lock tabindex="-1" data-format="' + html('formats.' + format.id) + '" data-format-id="' + format.id + '"\n                            data-media-id="' + _this3.loan.id + '" aria-label="' + html('accountLoans.downloadAs', { format: html('formats.' + format.id) }) + '"\n                            ' + (_this3.loan.otherFormats[0].id === 'ebook-kindle' ? 'target="_blank"' : '') + '\n                            class="format"\n                            href="' + url(window.routes.mediaDownload, { format: format.id, mediaId: _this3.loan.id }) + '">' + html('formats.' + format.id) + '</a>\n                        </li>';
            });

            var content = '<button role="button" data-dropdown="formats-' + this.loan.id + 'm"\n                                aria-controls="formats-' + this.loan.id + '" aria-expanded="false" id="download-dropdown"\n                                class="button dropdown radius download-dropdown"><b>' + html('accountLoans.download') + '</b><br /></button>\n                        <ul id="formats-' + this.loan.id + 'm" data-dropdown-content class="f-dropdown download-dropdown-formats" aria-hidden="true" role="list" aria-haspopup="true">\n                            ' + options + '\n                        </ul >';
            return content;
        }
    }, {
        key: 'renderBundledContent',
        value: function renderBundledContent() {
            var _this4 = this;

            var bundledButtons = '';
            var restrictedBundle = [];
            this.loan.bundledContent.forEach(function (subcontent) {
                var format = subcontent.otherFormats[0];
                var label = '';
                switch (format.id) {
                    case 'ebook-overdrive':
                    case 'magazine-overdrive':
                        label = html('readNow');
                        break;
                    case 'audiobook-overdrive':
                        label = html('listenNow');
                        break;
                    case 'video-streaming':
                        label = html('watchNow');
                        break;
                    default:
                        label = html('formats.' + format.id) + '<span> ' + html('accountLoans.download') + '</span>';
                }
                if (_this4.isRestricted(format)) {
                    restrictedBundle.push(format);
                } else if (subcontent.id) {
                    bundledButtons += '<li class="Loans-bundleListItem"><a class="Loans-bundledButton button primary radius" data-media-id="' + subcontent.id + '" data-format-id="' + (format.id || subcontent.overDriveFormat.id) + '">\n                               ' + (subcontent.type ? '<i class="icon-' + subcontent.type.id + ' Loans-bundledFormatIcon"></i>' : '') + '\n                               ' + label + '</a></li>';
                }
                // Thunder isn't passing us the bundled content ID's yet, so we have to use a "Go to loans" button for now
                else {
                        bundledButtons = '<li class="Loans-bundleListItem"><a href="/account/loans" class="Loans-bundledButton button primary radius u-allCaps">' + text('goToLoans') + '</a></li>';
                    }
            });

            return '<a class="Loans-bundleIconLink" data-dropdown="bundleDrop-' + this.loan.id + '" aria-controls="bundleDrop-' + this.loan.id + '" aria-expanded="false" aria-label="' + html('accountLoans.bundledLabel') + '">\n                    <i class="icon-attachment Loans-bundledIcon" aria-hidden="true"></i>\n                </a>\n                <ul id="bundleDrop-' + this.loan.id + '" class="f-dropdown Loans-bundledContentList" data-dropdown-content aria-hidden="true" tabindex="-1">\n                    <li class="Loans-bundledLabel">' + html('accountLoans.bundledLabel') + '</li>\n                    ' + bundledButtons + '\n                    ' + (restrictedBundle.length > 0 ? '<li class="Loans-bundleListItem">' + this.renderRestrictedFormatWarning(restrictedBundle) + '</li>' : '') + '\n                </ul>\n        ';
        }
    }, {
        key: 'renderRestrictedFormatWarning',
        value: function renderRestrictedFormatWarning(formats) {
            var pdfLearnMore = '';
            var formatNames = [];
            formats.forEach(function (format) {
                // If one of the formats is pdf, add support page link
                if (format.id === 'ebook-pdf-adobe' || format.id === 'ebook-pdf-open') {
                    pdfLearnMore = '<span><a href=' + window.supportUrl(window.OverDrive._locale, window.OverDrive.supportArticles.ODAppNoPDFEbook) + '" target=\'_blank\' class=\'Loans-learnMoreLink\'>' + window.text('narratedModal.learnMore') + '</a></span>';
                }
                formatNames.push(format.name);
            });
            var formatsText = formatNames.join(' | ');
            return '<div class="text-center no-download">\n                    <span>' + formatsText + '</span>\n                    <strong>' + (window.text('accountLoans.unsupportedFormat', { formats: formats.length }) + pdfLearnMore) + '</strong>\n                </div>';
        }
    }, {
        key: 'remove',
        value: function remove() {
            this._views.forEach(function (view) {
                return view.remove();
            });
            _get(TitleFulfillmentModal.prototype.__proto__ || Object.getPrototypeOf(TitleFulfillmentModal.prototype), 'remove', this).call(this);
        }
    }, {
        key: 'filterRestrictedFormats',
        value: function filterRestrictedFormats() {
            var _this5 = this;

            this.loan.restrictedFormats = [];
            if (this.formatLock) {
                this.loan.otherFormats = this.loan.otherFormats.filter(function (format) {
                    return format.id === _this5.formatLock;
                });
            }
            this.loan.otherFormats = this.loan.otherFormats.filter(function (format) {
                var isRestricted = _this5.isRestricted(format);
                if (isRestricted) {
                    _this5.loan.restrictedFormats.push(format);
                }
                return !isRestricted;
            });
        }
    }, {
        key: 'isRestricted',
        value: function isRestricted(format) {
            var device = window.detectshun.browser();
            var isChromebook = !!window.navigator.userAgent.match(/CrOS/);
            var isWindows = window.navigator.platform.match(/Win/) && !device.bowser.windowsphone;
            var inApp = window.OverDrive.inApp;
            var isMac = window.navigator.userAgent.match(/Mac/) && !device.ios;

            switch (format.id) {
                case 'ebook-pdf-adobe':
                    return device.ios || device.android || device.bowser.windowsphone || device.bowser.blackberry || isChromebook || isWindows && inApp;
                case 'ebook-epub-adobe':
                    return isChromebook && !inApp;
                case 'ebook-pdf-open':
                    return (device.ios || device.android || isWindows || isChromebook) && inApp || device.bowser.windowsphone || device.bowser.blackberry;
                case 'audiobook-mp3':
                    return isChromebook && !inApp || isMac && (this.title.get("formats").length === 1 || inApp && this.title.get("formats").length === 2) && this.featureManager.isEnabled('noAudiobooksForMacOS') && (!this.featureManager.isEnabled('reenableMp3DownloadMacOSPreCatalina') || !window.OverDrive.isPreCatalinaMac);
                default:
                    return false;
            }
        }
    }, {
        key: 'suppressAudiobookButton',
        get: function get() {
            var device = detectshun.browser();
            var isMac = !!(window.navigator.userAgent.match(/Mac/) && !device.ios);
            return this.loan.isAudiobook && this.featureManager.isEnabled('noAudiobooksForMacOS') && isMac && !device.ios && (!this.featureManager.isEnabled('reenableMp3DownloadMacOSPreCatalina') || !window.OverDrive.isPreCatalinaMac);
        }
    }, {
        key: 'isAudiobookOnMac',
        get: function get() {
            var device = detectshun.browser();
            var isMac = !!(window.navigator.userAgent.match(/Mac/) && !device.ios);
            return this.loan.isAudiobook && this.featureManager.isEnabled('noAudiobooksForMacOS') && isMac && !device.ios;
        }
    }]);

    return TitleFulfillmentModal;
}(Backbone.View);

exports['default'] = TitleFulfillmentModal;

},{"../common/modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js","../kindle_preference_modal/KindlePreference":"C:\\projects\\lightning\\public\\ecmascript\\components\\kindle_preference_modal\\KindlePreference.js","../kindle_trouble_modal/views/KindleTroubleModal":"C:\\projects\\lightning\\public\\ecmascript\\components\\kindle_trouble_modal\\views\\KindleTroubleModal.js","../media/Cover":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\Cover.js","../media/views/DownloadWarningModal":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\DownloadWarningModal.js","../media/views/TitleInfo/TitleFormatBadge":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\TitleFormatBadge.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\account_history\\views\\ImportFromRatedCompleteModal.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _modal = require('../../common/modal');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImportFromRatedCompleteModal = function (_Backbone$View) {
    _inherits(ImportFromRatedCompleteModal, _Backbone$View);

    function ImportFromRatedCompleteModal(importedTitleCount, patronHasRatedTitles) {
        _classCallCheck(this, ImportFromRatedCompleteModal);

        var _this = _possibleConstructorReturn(this, (ImportFromRatedCompleteModal.__proto__ || Object.getPrototypeOf(ImportFromRatedCompleteModal)).call(this));

        _initialiseProps.call(_this);

        _this._render(importedTitleCount, patronHasRatedTitles);

        var title = '';
        if (importedTitleCount > 0) {
            title = html('genericSuccess');
        } else {
            title = html('readingHistory.addRatedTitlesFailure');
        }

        var modalContents = {
            autoShow: false,
            title: title,
            classes: ['small'],
            content: _this.$el
        };

        _this.modal = new _modal.Modal(modalContents);
        _this.modal.show();

        return _this;
    }

    _createClass(ImportFromRatedCompleteModal, [{
        key: '_render',
        value: function _render(importedTitleCount, patronHasRatedTitles) {
            if (importedTitleCount > 0) {
                this.$el.append(this.titlesImportedTemplate(importedTitleCount));
            } else if (!!patronHasRatedTitles) {
                this.$el.append(this.noTitlesImportedTemplate(importedTitleCount));
            } else {
                this.$el.append(this.noTitlesRatedTemplate());
            }
        }
    }]);

    return ImportFromRatedCompleteModal;
}(Backbone.View);

var _initialiseProps = function _initialiseProps() {
    this.titlesImportedTemplate = function (importedTitleCount) {
        return '<p><span class="icon-check"/>&nbsp;' + html('readingHistory.addRatedTitlesSuccess', { count: importedTitleCount }) + '</p>';
    };

    this.noTitlesImportedTemplate = function () {
        return '\n        <p>' + html('readingHistory.allRatedTitlesAdded') + '</p>\n        <p>' + window.text('readingHistory.ifYoudLike', { link: '<a target = "_blank" href="https://help.overdrive.com/customer/portal/articles/2833477"> ' + window.text('readingHistory.manuallyAdd') + '</a>' }) + '\n        </p>';
    };

    this.noTitlesRatedTemplate = function () {
        return '\n        <p>' + html('readingHistory.noneRated') + '</p>\n    ';
    };
};

exports['default'] = ImportFromRatedCompleteModal;

},{"../../common/modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\auto_scroll\\autoScroll.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _HistoryEventListener2 = require('../history_event_tracker/HistoryEventListener');

var _HistoryEventListener3 = _interopRequireDefault(_HistoryEventListener2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AutoScroll = function (_HistoryEventListener) {
    _inherits(AutoScroll, _HistoryEventListener);

    function AutoScroll(tracker) {
        _classCallCheck(this, AutoScroll);

        var _this = _possibleConstructorReturn(this, (AutoScroll.__proto__ || Object.getPrototypeOf(AutoScroll)).call(this, tracker));

        _this._cancelLoop = false;
        return _this;
    }

    _createClass(AutoScroll, [{
        key: 'onLoad',
        value: function onLoad(states) {
            this._checkAgain();
            this._startLoopTimer();
        }
    }, {
        key: 'onUnload',
        value: function onUnload() {
            this._setScrollCookie();
        }

        /**
         * Scrolls the user down the page based on the param
         */

    }, {
        key: '_scrollUser',
        value: function _scrollUser() {
            if ($(window) && $(window).scrollTop && this.getTracker().getData(0) && this.getTracker().wasBackButtonHit() && this.getTracker().getData(0).scroll) {
                $(window).scrollTop(this.getTracker().getData(0).scroll);
            }
        }

        /**
         * Checks if the dynamic content has been shown yet
         */

    }, {
        key: '_checkDynamicContentState',
        value: function _checkDynamicContentState() {
            var dynamicContent = $('.js-dynamic-content');
            var dynamicParent = $('.js-dynamic-parent'); // Necessary for dynamically appended content

            if ((dynamicParent.length || dynamicContent.length) && !dynamicContent.is(':visible') && !this._cancelLoop) {
                this._checkAgain();
            } else {
                clearTimeout(this.loopTimer);
                this._scrollUser();
            }
        }

        /**
         * Loop back to check for visible dynamic content
         * If requestAnimationFrame is supported check for visible content on the next frame.
         * Otherwise fallback to setTimeout
         */

    }, {
        key: '_checkAgain',
        value: function _checkAgain() {
            return !!requestAnimationFrame ? requestAnimationFrame(this._checkDynamicContentState.bind(this)) : setTimeout(this._checkDynamicContentState.bind(this), 50);
        }

        /**
         * Exit the loop if content does not appear within 30 seconds
         * Starts the timer to cancel the loop
         */

    }, {
        key: '_startLoopTimer',
        value: function _startLoopTimer() {
            var _this2 = this;

            this.looptimer = setTimeout(function () {
                _this2._cancelLoop = true;
            }, 30000);
        }
    }, {
        key: '_setScrollCookie',
        value: function _setScrollCookie() {
            if ($(window) && $(window).scrollTop) {
                this.getTracker().addDataToLatest('scroll', $(window).scrollTop());
            }
        }
    }]);

    return AutoScroll;
}(_HistoryEventListener3['default']);

exports['default'] = AutoScroll;

},{"../history_event_tracker/HistoryEventListener":"C:\\projects\\lightning\\public\\ecmascript\\components\\history_event_tracker\\HistoryEventListener.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\back_button_redirect\\BackButtonRedirect.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _HistoryEventListener2 = require('../history_event_tracker/HistoryEventListener');

var _HistoryEventListener3 = _interopRequireDefault(_HistoryEventListener2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * class to implement proper behavior to exit sticky rooms when the back button is hit
 * the non-cached logic is in sticky-room.js
 */
var BackButtonRedirect = function (_HistoryEventListener) {
    _inherits(BackButtonRedirect, _HistoryEventListener);

    function BackButtonRedirect(tracker) {
        _classCallCheck(this, BackButtonRedirect);

        var _this = _possibleConstructorReturn(this, (BackButtonRedirect.__proto__ || Object.getPrototypeOf(BackButtonRedirect)).call(this, tracker));

        _this._cacheFallback();
        return _this;
    }

    _createClass(BackButtonRedirect, [{
        key: 'onLoad',
        value: function onLoad(states) {
            if (window.OverDrive.currentRoom) {
                this.getTracker().addDataToLatest('roomKey', window.OverDrive.currentRoom.urlPath);
            } else {
                this.getTracker().addDataToLatest('roomKey', 'site-default');
            }
        }

        /**
         * Delete persistent room cookie if user ends up on main site while having a preferred room
         * Only applicable when the user hits the browser's back button and the page is loaded by browser cache
         */

    }, {
        key: '_cacheFallback',
        value: function _cacheFallback() {
            window.hasPreferredRoom = !!Cookies.get('preferred-room');
            if (!window.OverDrive.currentRoom && window.hasPreferredRoom) {
                Cookies.remove('preferred-room', { path: '/', domain: location.hostname });
                window.hasPreferredRoom = false;
            }
        }
    }]);

    return BackButtonRedirect;
}(_HistoryEventListener3['default']);

exports['default'] = BackButtonRedirect;

},{"../history_event_tracker/HistoryEventListener":"C:\\projects\\lightning\\public\\ecmascript\\components\\history_event_tracker\\HistoryEventListener.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\Checkbox.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Checkbox = function (_Backbone$View) {
    _inherits(Checkbox, _Backbone$View);

    _createClass(Checkbox, [{
        key: 'template',
        value: function template(_ref) {
            var className = _ref.className,
                name = _ref.name,
                label = _ref.label,
                ariaLabel = _ref.ariaLabel;

            return '\n            <label class=\'custom-checkbox\'>\n                <input type=\'checkbox\' name=\'' + name + '\' class=\'' + className + '\' aria-label=\'' + ariaLabel + '\'/>\n                <i class=\'icon icon-checked\'></i>\n                <i class=\'icon icon-unchecked\'></i>\n                <span class=\'checkbox-label\'>' + label + '</span>\n                <span class="js-saved Saved-container"></span>\n            </label>';
        }
    }, {
        key: 'events',
        get: function get() {
            var _this2 = this;

            return {
                'change [type=checkbox]': function changeTypeCheckbox(e) {
                    _this2.trigger('change', e.currentTarget.checked);
                }
            };
        }
    }]);

    function Checkbox(_ref2) {
        var className = _ref2.className,
            name = _ref2.name,
            label = _ref2.label,
            ariaLabel = _ref2.ariaLabel;

        _classCallCheck(this, Checkbox);

        var _this = _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));

        _.extend(_this, arguments[0]);
        return _this;
    }

    _createClass(Checkbox, [{
        key: 'render',
        value: function render() {
            this.$el.empty().append(this.template(this));

            this.$checkbox = this.$el.find('[type=checkbox]:first');

            return this;
        }
    }, {
        key: 'set',
        value: function set(checked) {
            this.$checkbox.prop('checked', checked).change();
        }
    }]);

    return Checkbox;
}(Backbone.View);

exports['default'] = Checkbox;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\HashManager.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _querystring = require('querystring');

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HashManager = function () {
    function HashManager() {
        _classCallCheck(this, HashManager);
    }

    _createClass(HashManager, null, [{
        key: 'parse',
        value: function parse() {
            var hashObject = _querystring2['default'].parse(location.hash.substr(1));

            _.keys(hashObject).forEach(function (key) {
                hashObject[key] = _.flatten([hashObject[key] || []]);
            });

            return hashObject;
        }
    }, {
        key: 'update',
        value: function update(object) {
            var newHash = _querystring2['default'].stringify(object);
            if (newHash !== '&') {
                location.hash = newHash;
            }
        }
    }, {
        key: 'get',
        value: function get(key) {
            var response = this.parse();

            if (_.isString(key)) {
                return response[key];
            }

            return response;
        }
    }, {
        key: 'set',
        value: function set(key, value) {
            var hash = this.parse();

            hash[key] = _.flatten([value]);

            this.update(hash);
        }
    }, {
        key: 'push',
        value: function push(key, value) {
            var hash = this.parse();

            hash[key] = hash[key] || [];
            hash[key].push(value);

            this.update(hash);
        }
    }, {
        key: 'remove',
        value: function remove(key) {
            var hash = this.parse();

            hash[key] && delete hash[key];

            this.update(hash);
        }
    }]);

    return HashManager;
}();

exports['default'] = HashManager;

},{"querystring":"C:\\projects\\lightning\\node_modules\\querystring-es3\\index.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\RadioButton.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RadioButton = function (_Backbone$View) {
    _inherits(RadioButton, _Backbone$View);

    _createClass(RadioButton, [{
        key: 'template',
        value: function template(_ref) {
            var value = _ref.value,
                checked = _ref.checked,
                className = _ref.className,
                name = _ref.name,
                label = _ref.label,
                ariaLabel = _ref.ariaLabel,
                rid = _ref.rid;

            return '\n            <label class=\'custom-radio\'>\n                <span class=\'custom-radio-button\'>\n                    <input type=\'radio\' value=\'' + value + '\' name=\'' + name + '-' + rid + '\' class=\'' + className + '\' aria-label=\'' + ariaLabel + '\' ' + (checked ? 'checked' : '') + ' />\n                    <i class=\'icon icon-radio-unselected\'></i>\n                    <i class=\'icon icon-radio-selected secondary-color\'></i>\n                </span>\n                <span class=\'custom-radio-text\'>\n                    ' + label + '\n                </span>\n            </label>';
        }
    }, {
        key: 'events',
        get: function get() {
            var _this2 = this;

            return {
                'change [type=radio]': function changeTypeRadio(e) {
                    _this2.trigger('change', e.currentTarget.checked);
                }
            };
        }
    }]);

    function RadioButton(_ref2) {
        var className = _ref2.className,
            name = _ref2.name,
            label = _ref2.label,
            ariaLabel = _ref2.ariaLabel,
            rid = _ref2.rid;

        _classCallCheck(this, RadioButton);

        var _this = _possibleConstructorReturn(this, (RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).apply(this, arguments));

        _.extend(_this, arguments[0]);
        return _this;
    }

    _createClass(RadioButton, [{
        key: 'render',
        value: function render() {
            this.$el.empty().append(this.template(this));

            this.$radio = this.$el.find('[type=radio]:first');

            return this;
        }
    }, {
        key: 'set',
        value: function set(checked) {
            this.$radio.prop('checked', checked).change();
        }
    }]);

    return RadioButton;
}(Backbone.View);

exports['default'] = RadioButton;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\confirmDialog.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _modal = require('./modal');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConfirmDialog = function (_Modal) {
    _inherits(ConfirmDialog, _Modal);

    function ConfirmDialog(options) {
        _classCallCheck(this, ConfirmDialog);

        var _this = _possibleConstructorReturn(this, (ConfirmDialog.__proto__ || Object.getPrototypeOf(ConfirmDialog)).call(this, options));

        _this.$el.append($(_this.buttonTemplate));

        _this.$buttonSubmit = _this.$el.find('.button.submit');
        _this.$buttonCancel = _this.$el.find('.button.cancel');

        _this.bindEvents();

        _this._render();
        return _this;
    }

    // We dont actually want to use the Foundation modal events since they get weird fast...
    // lets use our own so consumers dont have to know its foundation


    _createClass(ConfirmDialog, [{
        key: 'bindEvents',
        value: function bindEvents() {
            var _this2 = this;

            this.$buttonSubmit.on('click', function () {
                _this2.trigger('submit', _this2);
                _this2.trigger('close');
            });

            this.$buttonCancel.on('click', function (e) {
                _this2.trigger('cancel', _this2);
                _this2.trigger('close');
            }).on('keydown', function (e) {
                return e.stopPropagation;
            });
        }
    }, {
        key: 'buttonTemplate',
        get: function get() {
            return $('\n            <div class="button-container ' + (this.buttonAlign || 'right') + '">\n                <button type="button" class="button submit radius margin-small u-allCaps secondary">' + this.submitText + '</button>\n                <button type="button" class="button cancel radius margin-small u-allCaps outline gray">' + this.cancelText + '</button>\n            </div>\n        ');
        }
    }]);

    return ConfirmDialog;
}(_modal.Modal);

exports['default'] = ConfirmDialog;

},{"./modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Modal = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _keycodes = require('../../util/keycodes');

var _keycodes2 = _interopRequireDefault(_keycodes);

var _modal = require('./templates/modal.html');

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Modal = function (_Backbone$View) {
    _inherits(Modal, _Backbone$View);

    function Modal() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Modal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.isSelectEvent = function (e) {
            return (e.type === 'click' || e.which === 13 || e.which === 32) && (e.preventDefault() || true);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Modal, [{
        key: 'initialize',
        value: function initialize(options) {
            _.extend(this, this.defaults, options);

            this.tpl = _modal2['default'];
            this.setElement(this.tpl(this));

            if (this.id.length) {
                this.$el.attr('id', this.id);
            }

            this.$content = this.$el.find('.modal-container');

            this.$content.empty().append(this.content);

            this.$el.addClass(this.classes.join(' '));

            this.$title = this.$el.find('.modal-title');

            if (this.hiddenTitle) {
                this.$title.css("opacity", "0");
            }

            if (this.autoRender) {
                this._render();
            }

            this._bindEvents();
        }
    }, {
        key: '_render',
        value: function _render() {
            if (this.attachToDocument) {
                // For Foundation to work as expected we need to have the element attached to the DOM before calling .foundation('reveal', 'open')
                $('body').append(this.el);
            }

            if (this.autoShow) {
                this.show();
            }

            return this;
        }
    }, {
        key: '_bindEvents',


        // We dont actually want to use the Foundation modal events since they get weird fast...
        // lets use our own so consumers dont have to know its foundation
        value: function _bindEvents() {
            var _this2 = this;

            this.$el.on('click keydown', '.js-close', function (e) {
                _this2.isSelectEvent(e) && _this2.trigger('cancel', _this2);
            });

            if (this.defaultButtonBehaviour) {
                this.on('close cancel', function () {
                    _this2.close();
                });
            }

            this.$el.on('keypress', '*', function (e) {
                if (e.which === _keycodes2['default'].TAB) {
                    _this2._keepFocus(e);
                }
            });
        }
    }, {
        key: 'show',
        value: function show() {
            var _this3 = this;

            this._beforeShow();
            this.$el.foundation('reveal', 'open');
            this.trigger('show', this);

            this.$el.on('keydown', function (e) {
                _this3._keepFocus(e);
            });

            // Execute code after the modal is displayed
            this.$el.on('opened.fndtn.reveal', function () {
                return _this3._afterShow();
            });

            // Traps foundation bug that closes modal on dropdown "closed", not an issue in 5.5.3+
            this.$el.off('closed');

            // Handle foundation  close events from ESC and BG clicks
            this.$el.on('close.fndtn.reveal', function () {
                _this3.$el.off('close.fndtn.reveal');
                _this3.trigger('close');
            });
        }
    }, {
        key: '_beforeShow',
        value: function _beforeShow() {
            this.focused = $(document.activeElement);
        }
    }, {
        key: '_afterShow',
        value: function _afterShow() {
            this.$el.attr('aria-hidden', false);
            $('.container').attr('aria-hidden', 'true');
            $('.row.footer').attr('aria-hidden', 'true');
            $('.nav-container').attr('aria-hidden', 'true');

            this.$title.focus();
            this._setScroll();
        }
    }, {
        key: '_setScroll',
        value: function _setScroll() {
            var offset = window.pageYOffset - parseInt(this.$el.css('top').slice(0, -2), 10); // the 'top' styling is baked in by foundation
            if (window.innerHeight < this.el.offsetHeight - offset) {
                // scroll tall modals into view as much as fits
                offset = Math.min(this.el.offsetHeight - window.innerHeight + 10, -5);
            } else if (window.innerWidth < 641) {
                // mobile view padding
                offset -= 5;
            }
            this.el.scrollIntoView(); // sets scroll to top of modal
            window.scrollBy(0, offset); // adjusts scroll according to calculated offset
        }
    }, {
        key: '_keepFocus',
        value: function _keepFocus(e) {
            var activeElem = $(document.activeElement);
            var firstFocusable = this.$title || this.$el.find(':focusable:visible').first();
            var lastFocusable = this.$el.find(':focusable:visible').last();

            if (activeElem.is(firstFocusable) && e.which === _keycodes2['default'].TAB && e.shiftKey) {
                e.preventDefault();
                lastFocusable.focus();
            } else if ($(activeElem).is(lastFocusable) && e.which === _keycodes2['default'].TAB && !e.shiftKey) {
                e.preventDefault();
                firstFocusable.focus();
            }
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.$el.foundation('reveal', 'close');
            this.trigger('hide', this);
            $('.container').attr('aria-hidden', 'false');
            $('.row.footer').attr('aria-hidden', 'false');
            $('.nav-container').attr('aria-hidden', 'false');
            this.focused.focus();
        }
    }, {
        key: 'close',
        value: function close() {
            this.hide();
            this.remove();
        }
    }, {
        key: 'defaults',
        get: function get() {
            return {
                autoShow: true,
                autoRender: true,
                closeOnEsc: true,
                closeOnBlur: true,

                id: '',
                classes: ['small'],
                buttonAlign: 'right',
                title: 'Title',
                hiddenTitle: false,
                content: 'Some Content',
                submitText: html('ok'),
                cancelText: html('cancel'),
                attachToDocument: true,
                defaultButtonBehaviour: true,
                showCloseButton: true
            };
        }
    }]);

    return Modal;
}(Backbone.View);

exports.Modal = Modal;


},{"../../util/keycodes":"C:\\projects\\lightning\\public\\ecmascript\\util\\keycodes.js","./templates/modal.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\templates\\modal.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\templates\\modal.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function (_ref) {
    var title = _ref.title,
        closeOnEsc = _ref.closeOnEsc,
        closeOnBlur = _ref.closeOnBlur,
        showCloseButton = _ref.showCloseButton;
    return '<div class="reveal-modal" aria-hidden="true" role="dialog" data-reveal data-options="close_on_esc:' + closeOnEsc + ';close_on_background_click:' + closeOnBlur + ';">\n    <div class="modal-header">\n        <h2 class="modal-title primary-color" tabindex="0">' + title + '</h2>\n        ' + (showCloseButton ? '<a class="close-reveal-modal js-close" role="button" aria-label="' + window.html('close') + '" tabindex="0">&#215;</a>' : '') + '\n    </div>\n\n    <div class="modal-container"></div>\n</div>';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\cookie_settings_modal\\cookieSettingsModal.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _window = window,
    text = _window.text;
var _window$OverDrive = window.OverDrive,
    highContrast = _window$OverDrive.highContrast,
    dyslexic = _window$OverDrive.dyslexic;

exports['default'] = function () {
    return '\n    <div>' + text('gdpr.settingsPanel.summary') + '</div>\n    <div class="optionContainer">\n        <i class="icon-check"></i>\n        <h3 class="requiredHeading">' + text('gdpr.settingsPanel.requiredHeading') + '</h3>\n        <span class="labelSubtext requiredSubtext">' + text('gdpr.settingsPanel.requiredBody') + '</span>\n    </div>\n    <div class="optionContainer">\n        <span class="perfCookieCheckbox"></span>\n        <span class="labelSubtext">' + text('gdpr.settingsPanel.performanceBody') + '</span>\n    </div>\n    <div class="optionContainer">\n        <span class="analyticsCookieCheckbox"></span>\n        <span class="labelSubtext">' + text('gdpr.settingsPanel.analyticsBody') + '</span>\n    </div>\n    <div class="divider"></div>\n    <div class="addendum">\n        ' + text('gdpr.settingsPanel.addendum', {
        cookiePolicyLink: '<a target="blank" href="https://company.cdn.overdrive.com/policies/cookie-policy.htm?' + (highContrast ? 'high-contrast=1' : '') + (dyslexic ? 'dyslexic=1' : '') + '">' + text('gdpr.cookiePolicy') + '</a>',
        privacyPolicyLink: '<a target="blank" href="https://company.cdn.overdrive.com/policies/privacy-policy.htm?' + (highContrast ? 'high-contrast=1' : '') + (dyslexic ? 'dyslexic=1' : '') + '">' + text('footerPrivacyPolicy') + '</a>'
    }) + '\n    </div>\n\n\n    <button class="confirm button radius margin-small secondary right">' + text('gdpr.settingsPanel.confirm') + '</button>\n\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\cookie_settings_modal\\cookieSettingsModal.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _modal = require('../common/modal');

var _Checkbox = require('../common/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _cookieSettingsModal = require('./cookieSettingsModal.html');

var _cookieSettingsModal2 = _interopRequireDefault(_cookieSettingsModal);

var _OdTrack = require('../../../../models/OdTrack');

var _OdTrack2 = _interopRequireDefault(_OdTrack);

var _cookieConfig = require('../../../../lib/cookieConfig');

var _cookieConfig2 = _interopRequireDefault(_cookieConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _window = window,
    Cookies = _window.Cookies,
    OverDrive = _window.OverDrive;
var _location = location,
    reload = _location.reload;
var odTrack = _cookieConfig2['default'].odTrack;

var CookieSettingsModal = function (_Backbone$View) {
    _inherits(CookieSettingsModal, _Backbone$View);

    function CookieSettingsModal(opts) {
        _classCallCheck(this, CookieSettingsModal);

        var _this = _possibleConstructorReturn(this, (CookieSettingsModal.__proto__ || Object.getPrototypeOf(CookieSettingsModal)).call(this, opts));

        _this.COOKIE_NAME = 'od_track';


        _this.odTrack = new _OdTrack2['default'](Cookies.get(_this.COOKIE_NAME), OverDrive.isGdprCountry);
        _this.isDismissable = opts.isDismissable;
        return _this;
    }

    _createClass(CookieSettingsModal, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            this.$el.empty().append((0, _cookieSettingsModal2['default'])());

            this.perfCookieCheckbox = new _Checkbox2['default']({
                el: this.$el.find('.perfCookieCheckbox'),
                label: html('gdpr.settingsPanel.performanceHeading'),
                ariaLabel: html('gdpr.settingsPanel.performanceHeading')
            }).render();
            this.perfCookieCheckbox.set(this.odTrack.perfTrackingEnabled);
            this.perfCookieCheckbox.on('change', function (val) {
                _this2.odTrack.perfTrackingEnabled = val;
            });

            this.analyticsCookieCheckbox = new _Checkbox2['default']({
                el: this.$el.find('.analyticsCookieCheckbox'),
                label: html('gdpr.settingsPanel.analyticsHeading'),
                ariaLabel: html('gdpr.settingsPanel.analyticsHeading')
            }).render();
            this.analyticsCookieCheckbox.set(this.odTrack.analyticsTrackingEnabled);
            this.analyticsCookieCheckbox.on('change', function (val) {
                _this2.odTrack.analyticsTrackingEnabled = val;
            });

            this.$el.find('.confirm').on('click', function () {
                return _this2.confirm();
            });

            var opts = {
                autoShow: false,
                title: html('gdpr.settingsPanel.title'),
                content: this.$el,
                classes: ['cookieSettingsModal'],
                closeOnEsc: this.isDismissable,
                closeOnBlur: this.isDismissable,
                showCloseButton: this.isDismissable
            };

            this.$el.find('.rainbowText').html(function (i, html) {
                var chars = $.trim(html).split('');
                return '<span>' + chars.join('</span><span>') + '</span>';
            });

            this.modal = new _modal.Modal(opts);
            this.modal.show();
        }
    }, {
        key: 'confirm',
        value: function confirm() {
            Cookies.set(odTrack.name, this.odTrack.flags, {
                domain: window.OverDrive.isLocal ? 'lightning.test' : odTrack.domain,
                expires: new Date(Date.now() + odTrack.durationMS)
            });
            this.modal.hide();

            // We need to send the cookie to the server before it can take effect
            location.reload();
        }
    }]);

    return CookieSettingsModal;
}(Backbone.View);

exports['default'] = CookieSettingsModal;

},{"../../../../lib/cookieConfig":"C:\\projects\\lightning\\lib\\cookieConfig.js","../../../../models/OdTrack":"C:\\projects\\lightning\\models\\OdTrack.js","../common/Checkbox":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\Checkbox.js","../common/modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js","./cookieSettingsModal.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\cookie_settings_modal\\cookieSettingsModal.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\history_event_tracker\\HistoryEventListener.js":[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HistoryCookieListener = function () {
    function HistoryCookieListener(tracker) {
        _classCallCheck(this, HistoryCookieListener);

        this._tracker = tracker;
    }

    _createClass(HistoryCookieListener, [{
        key: "onLoad",
        value: function onLoad(states) {
            return;
        }
    }, {
        key: "onUnload",
        value: function onUnload() {
            return;
        }
    }, {
        key: "getTracker",
        value: function getTracker() {
            return this._tracker;
        }
    }]);

    return HistoryCookieListener;
}();

exports["default"] = HistoryCookieListener;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\history_event_tracker\\HistoryEventTracker.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _autoScroll = require('../auto_scroll/autoScroll');

var _autoScroll2 = _interopRequireDefault(_autoScroll);

var _BackButtonRedirect = require('../back_button_redirect/BackButtonRedirect');

var _BackButtonRedirect2 = _interopRequireDefault(_BackButtonRedirect);

var _simpleHash = require('../../../../lib/simpleHash');

var _simpleHash2 = _interopRequireDefault(_simpleHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HistoryCookieTracker = function () {
    function HistoryCookieTracker() {
        _classCallCheck(this, HistoryCookieTracker);

        this.pageUnloaded = false;
        this.MAX_LENGTH = 3;
        this._initCookieQueue([new _autoScroll2['default'](this), new _BackButtonRedirect2['default'](this)]);
    }

    _createClass(HistoryCookieTracker, [{
        key: '_initCookieQueue',
        value: function _initCookieQueue(listeners) {
            var previousStateString = Cookies.get('urlHistory');
            var states = previousStateString ? JSON.parse(previousStateString) : [];
            while (states.length > this.MAX_LENGTH - 1) {
                states.shift();
            }
            var pathname = window.location.pathname ? window.location.pathname : '/';
            var search = window.location.search ? window.location.search : '';
            var hash = window.location.hash ? window.location.hash : '';
            var route = pathname + search + hash;
            states.push(JSON.stringify({ 'route': _simpleHash2['default'].hash(route) }));
            Cookies.set('urlHistory', states, { path: '/' });
            this._addEventListeners(listeners, states);
        }
    }, {
        key: 'wasBackButtonHit',
        value: function wasBackButtonHit() {
            var states = this.getData();
            if (states.length < 3) {
                return false;
            }
            var antePenultimateRoute = states[states.length - 3].route;
            var penultimateRoute = states[states.length - 2].route;
            var ultimateRoute = states[states.length - 1].route;
            return states.length >= 3 && antePenultimateRoute === ultimateRoute && ultimateRoute !== penultimateRoute;
        }
    }, {
        key: 'addDataToLatest',
        value: function addDataToLatest(name, value) {
            var previousStateString = Cookies.get('urlHistory');
            var states = JSON.parse(previousStateString);
            // sometimes a string sometimes an object but needs to be an object every time
            var state = typeof states[states.length - 1] === 'string' ? JSON.parse(states[states.length - 1]) : states[states.length - 1];
            state[name] = value;
            states[states.length - 1] = state;
            Cookies.set('urlHistory', JSON.stringify(states), { path: '/' });
        }
    }, {
        key: 'getData',
        value: function getData(index) {
            if (Cookies.get('urlHistory')) {
                var previousStateString = Cookies.get('urlHistory');
                var states = JSON.parse(previousStateString);
                for (var i = 0; i < states.length; i++) {
                    states[i] = typeof states[i] === 'string' ? JSON.parse(states[i]) : states[i];
                }
                if (index > -1 && states[index]) {
                    return states[index];
                } else if (!index) {
                    return states;
                }
            }
            return [];
        }
    }, {
        key: '_addEventListeners',
        value: function _addEventListeners(listeners, states) {
            var _this = this;

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                var _loop = function _loop() {
                    var listener = _step.value;

                    listener.onLoad(states);
                    // For browsers that support beforeunload
                    window.addEventListener('beforeunload', function () {
                        if (!_this.pageUnloaded) {
                            listener.onUnload();
                            _this.pageUnloaded = true;
                        }
                    }, false);

                    // For Safari
                    window.addEventListener('pagehide', function () {
                        if (!_this.pageUnloaded) {
                            listener.onUnload();
                            _this.pageUnloaded = true;
                        }
                    }, false);
                };

                for (var _iterator = listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    _loop();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator['return']) {
                        _iterator['return']();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }]);

    return HistoryCookieTracker;
}();

exports['default'] = HistoryCookieTracker;

},{"../../../../lib/simpleHash":"C:\\projects\\lightning\\lib\\simpleHash.js","../auto_scroll/autoScroll":"C:\\projects\\lightning\\public\\ecmascript\\components\\auto_scroll\\autoScroll.js","../back_button_redirect/BackButtonRedirect":"C:\\projects\\lightning\\public\\ecmascript\\components\\back_button_redirect\\BackButtonRedirect.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformationV2\\HoldInformationModalV2.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _modal = require('../common/modal');

var _HoldInformationV = require('./HoldInformationV2');

var _HoldInformationV2 = _interopRequireDefault(_HoldInformationV);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HoldInformationModalV2 = function (_Modal) {
    _inherits(HoldInformationModalV2, _Modal);

    function HoldInformationModalV2(_ref) {
        var model = _ref.model,
            _ref$hideHoldsLink = _ref.hideHoldsLink,
            hideHoldsLink = _ref$hideHoldsLink === undefined ? false : _ref$hideHoldsLink;

        _classCallCheck(this, HoldInformationModalV2);

        var information = new _HoldInformationV2['default']({ model: model, hideHoldsLink: hideHoldsLink, isVisitor: window.OverDrive.isVisitor }).render();
        var modalContents = {
            classes: ['HoldInformationModalV2'],
            title: window.html('holdsRatioHelpModal.heading'),
            content: information.el
        };
        return _possibleConstructorReturn(this, (HoldInformationModalV2.__proto__ || Object.getPrototypeOf(HoldInformationModalV2)).call(this, modalContents));
    }

    return HoldInformationModalV2;
}(_modal.Modal);

exports['default'] = HoldInformationModalV2;

},{"../common/modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js","./HoldInformationV2":"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformationV2\\HoldInformationV2.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformationV2\\HoldInformationV2.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _window = window,
    html = _window.html,
    text = _window.text;

exports['default'] = function (_ref) {
    var description = _ref.description,
        details = _ref.details,
        note = _ref.note;
    return '\n    ' + (description && description.length > 0 ? '<p class=\'description\'>' + description + '</p>' : '') + '\n    ' + (details && details.map(function (detail) {
        return '<p class=\'detail\'><span class=\'holdInfoLabel\'>' + detail.label + ': </span><span>' + detail.value + '</span></p>';
    }).join('')) + '\n    ' + (note && note.length > 0 ? '<p class=\'note\'>' + note + '</p>' : '') + '\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformationV2\\HoldInformationV2.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _HoldInformationV = require('./HoldInformationV2.html');

var _HoldInformationV2 = _interopRequireDefault(_HoldInformationV);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _window = window,
    text = _window.text;

var HoldInformationV2 = function (_Backbone$View) {
    _inherits(HoldInformationV2, _Backbone$View);

    function HoldInformationV2(_ref) {
        var _ref$hideHoldsLink = _ref.hideHoldsLink,
            hideHoldsLink = _ref$hideHoldsLink === undefined ? false : _ref$hideHoldsLink,
            _ref$isVisitor = _ref.isVisitor,
            isVisitor = _ref$isVisitor === undefined ? false : _ref$isVisitor;

        _classCallCheck(this, HoldInformationV2);

        var _this = _possibleConstructorReturn(this, (HoldInformationV2.__proto__ || Object.getPrototypeOf(HoldInformationV2)).apply(this, arguments));

        _this.el = _this.el || document.createElement('div');
        _this.hideHoldsLink = hideHoldsLink;
        _this.isVisitor = isVisitor;
        _this.MAX_WAIT_MONTHS_TO_SHOW = 6;
        _this.MAX_WAIT_WEEKS_TO_SHOW = 26;
        _this.listenTo(_this.model, 'change:titleState', _this.removeWaitTime);
        return _this;
    }

    _createClass(HoldInformationV2, [{
        key: 'render',
        value: function render() {
            var view = (0, _HoldInformationV2['default'])({
                description: this.description,
                details: this.details,
                note: this.note
            });
            this.$el.empty().append(view);

            return this;
        }
    }, {
        key: 'removeWaitTime',
        value: function removeWaitTime() {
            if (window.featureManager.isEnabled('addWaitTimeToWishlist') && this.hideWaitTime) {
                this.$el.hide();
            }
        }
    }, {
        key: 'description',
        get: function get() {
            if (this.isPrereleaseTitle) {
                return text('expectedWaitTime.prereleaseNoWaitTime');
            } else if (this.isExpiredTitle) {
                var theText = '';
                if (this.model.get('titleState') === 'onHold') {
                    theText = text('holdsRatioHelpModal.noCopiesOnPlaceHold');
                } else {
                    theText = text('holdsRatioHelpModal.noCopiesText');
                }
                return this.hideHoldsLink ? theText : '<span>' + theText + '<a class="manageHoldsLink" target="_blank" href="/account/holds">' + text('holdSuccessModal.manageHolds') + '</a></span>';
            } else if (this.model.allCopiesAreLuckyDay && this.model.get('titleState') === 'onHold') {
                var detailsUrl = window.url(window.routes.mediaId, { id: this.model.get('id') });
                var detailsLink = '<a style="text-decoration: underline" href="' + detailsUrl + '">' + text('luckyDay.allLuckyDayHoldsInfoLinkText') + '</a>';
                return text('luckyDay.allLuckyDayHoldsInfo', { link: detailsLink });
            } else if (this.isFastLaneTitle) {
                return text('expectedWaitTime.advantageCaveat');
            } else if (this.isVisitor) {
                return text('expectedWaitTime.rlaCaveat');
            }
            return '';
        }
    }, {
        key: 'details',
        get: function get() {
            var details = [];
            if (!this.showWaitTimeUnavailable && !this.hideWaitTime) {
                details.push({ label: text('expectedWaitTime.waitTime'), value: this.waitTimeText });
            }

            if (this.model.get('holdListPosition')) {
                details.push({ label: text('expectedWaitTime.placeInLine'), value: this.model.get('holdListPosition') });
            }

            var ownedCopies = this.model.get('ownedCopies') || 0;
            var totalHolds = this.model.get('holdsCount') || 0;

            details.push({ label: text('expectedWaitTime.libraryCopies'), value: ownedCopies });

            if (ownedCopies > 1) {
                var holdsRatio = ownedCopies && totalHolds ? totalHolds / ownedCopies : 0;
                var ratioDisplayValue = holdsRatio > 0 && holdsRatio < 1 ? '< 1' : Math.round(holdsRatio);
                details.push({ label: text('expectedWaitTime.peopleWaitingTotal'), value: totalHolds });
                details.push({ label: text('expectedWaitTime.poepleWaitingPerCopy'), value: ratioDisplayValue });
            } else {
                details.push({ label: text('expectedWaitTime.peopleWaiting'), value: totalHolds });
            }
            return details;
        }
    }, {
        key: 'waitTimeHtml',
        get: function get() {
            var html = '';
            if (!this.hideWaitTime) {
                html = '<span class=\'waitingText\'>' + window.text('expectedWaitTime.waitTime') + ': ' + this.waitTimeText + '</span>';
            }
            return html;
        }
    }, {
        key: 'waitTimeText',
        get: function get() {
            var waitTimeText = '';

            if (!this.hideWaitTime) {
                if (this.showWaitTimeUnavailable) {
                    waitTimeText = text('expectedWaitTime.notAvailable');
                } else {
                    var estimatedWaitDays = Number(this.model.get('estimatedWaitDays'));
                    if (estimatedWaitDays <= 7) {
                        waitTimeText = text('expectedWaitTime.availableSoon');
                    } else if (estimatedWaitDays < 7 * this.MAX_WAIT_WEEKS_TO_SHOW) {
                        waitTimeText = text('expectedWaitTime.aboutXWeeks', { weeks: Math.ceil(estimatedWaitDays / 7) });
                    } else {
                        // we intentionally max out at "at least 6 months"
                        waitTimeText = text('expectedWaitTime.atLeastYMonths', { months: Math.min(Math.ceil(estimatedWaitDays / 30), this.MAX_WAIT_MONTHS_TO_SHOW) });
                    }
                }
            }

            return waitTimeText;
        }
    }, {
        key: 'showWaitTimeUnavailable',
        get: function get() {
            return this.model.get('estimatedWaitDays') === undefined || this.model.get('estimatedWaitDays') === null || this.isPrereleaseTitle || this.isVisitor || this.isExpiredTitle;
        }
    }, {
        key: 'hideWaitTime',
        get: function get() {
            return this.isFastLaneTitle || this.model.get('titleState') === 'onHold' || (window.featureManager.isEnabled('betterPatronState') ? this.model.get('isBorrowed') : this.model.get('titleState') === 'borrowed');
        }
    }, {
        key: 'isExpiredTitle',
        get: function get() {
            return this.model.get('isOwned') && !this.model.get('ownedCopies') && !this.model.allCopiesAreLuckyDay;
        }
    }, {
        key: 'isFastLaneTitle',
        get: function get() {
            return this.model.get('isFastlane');
        }
    }, {
        key: 'isPrereleaseTitle',
        get: function get() {
            return this.model.get('isPreReleaseTitle');
        }
    }, {
        key: 'note',
        get: function get() {
            return [];
        }
    }]);

    return HoldInformationV2;
}(Backbone.View);

exports['default'] = HoldInformationV2;

},{"./HoldInformationV2.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformationV2\\HoldInformationV2.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformation\\main.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _HoldInformationModal = require('./views/HoldInformationModal');

var _HoldInformationModal2 = _interopRequireDefault(_HoldInformationModal);

var _HoldInformationModalV = require('../holdInformationV2/HoldInformationModalV2');

var _HoldInformationModalV2 = _interopRequireDefault(_HoldInformationModalV);

var _MediaInterface = require('../media/MediaInterface');

var _MediaInterface2 = _interopRequireDefault(_MediaInterface);

var _Title = require('../media/models/Title');

var _Title2 = _interopRequireDefault(_Title);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var createHoldsRatioModalComponent = function createHoldsRatioModalComponent(_ref) {
    var el = _ref.el;

    // The refactored stuff doesn't use this, but the account page will need to still
    // Kill this with so much fire when that's done.
    $(document).on('click', '.js-holds-ratio-help-icon.js-holds-ratio-account', function (e) {
        var mediaInterface = new _MediaInterface2['default']();

        var $target = $(e.target).closest('.js-holds-ratio-help-icon.js-holds-ratio-account');
        var mediaId = $target.data('media-id');

        mediaInterface.search({ titleId: mediaId }).then(function (response) {
            var model = new _Title2['default'](response);

            // making the assumption that titles on the holds page are on hold
            model.set({ titleState: 'onHold' });

            window.ajax.getHold(model.get('id')).done(function (holdData) {
                // should be confirming that this is on hold
                model.set({
                    holdsRatio: holdData.holdsRatio,
                    holdsCount: holdData.holdsCount,
                    holdListPosition: holdData.holdListPosition
                });

                if (window.featureManager.isEnabled('LHTNG-2863')) {
                    new _HoldInformationModalV2['default']({ model: model, hideHoldsLink: true, el: el });
                } else {
                    new _HoldInformationModal2['default']({ model: model, type: 'basicPosition', el: el });
                }
            });
        });
    });
};

exports['default'] = createHoldsRatioModalComponent;

},{"../holdInformationV2/HoldInformationModalV2":"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformationV2\\HoldInformationModalV2.js","../media/MediaInterface":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\MediaInterface.js","../media/models/Title":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\models\\Title.js","./views/HoldInformationModal":"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformation\\views\\HoldInformationModal.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformation\\templates\\HoldInformation.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function (_ref) {
    var expirationWarning = _ref.expirationWarning,
        description = _ref.description,
        details = _ref.details,
        note = _ref.note;
    return '\n    ' + (expirationWarning.length > 0 ? '<p class=\'expiration-warning\'>' + expirationWarning + '</p>' : '') + '\n    ' + (description.length > 0 ? '<p class=\'description\'>' + description + '</p>' : '') + '\n    ' + details.map(function (detail) {
        return '<p class=\'detail\'>' + detail + '</p>';
    }).join('') + '\n    ' + (note.length > 0 ? '<p class=\'note\'>' + note + '</p>' : '') + '\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformation\\views\\HoldInformation.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _HoldInformation = require('../templates/HoldInformation.html');

var _HoldInformation2 = _interopRequireDefault(_HoldInformation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _window = window,
    html = _window.html,
    url = _window.url,
    routes = _window.routes;

var HoldInformation = function (_Backbone$View) {
    _inherits(HoldInformation, _Backbone$View);

    _createClass(HoldInformation, [{
        key: 'expirationWarning',
        get: function get() {
            var isExpiredContent = this.model.get('isOwned') && !this.model.get('ownedCopies');
            if (isExpiredContent) {
                if (this.type === 'successPosition') {
                    return html('holdsRatioHelpModal.noCopiesOnPlaceHold') + ' <a class=\'HoldSuccessModal-link\' href=\'' + url(routes.accountHolds) + '\'>' + html('holdSuccessModal.manageHolds') + '</a>';
                } else if (window.featureManager.isEnabled('betterPatronState') ? this.model.get('isOnHold') : this.model.get('titleState') === 'onHold') {
                    return html('holdsRatioHelpModal.noCopiesTextHeld');
                }
                return html('holdsRatioHelpModal.noCopiesText');
            }
            return '';
        }
    }, {
        key: 'description',
        get: function get() {
            var holdsRatio = this.model.get('holdsRatio');
            var holdListPosition = this.model.get('holdListPosition') || 0;

            if (this.model.get('isPreReleaseTitle') && holdListPosition === 0) {
                return html('preReleaseModal.borrowUponRelease');
            }

            switch (this.type) {
                case 'ratio':
                    if (holdsRatio) {
                        return holdsRatio >= 1 ? html('holdsRatioHelpModal.listPositionHtml', { holdsRatio: this.model.get('holdsRatio') }) : html('holdsRatioHelpModal.nextAvailable');
                    }
                    return '';
                case 'basicPosition':
                case 'successPosition':
                case 'basic':
                default:
                    return '';
            }
        }
    }, {
        key: 'details',
        get: function get() {
            var holdsCount = this.model.get('holdsCount') || 0;
            var ownedCopies = this.model.get('ownedCopies') || 0;
            var holdListPosition = this.model.get('holdListPosition') || 0;
            switch (this.type) {
                case 'basicPosition':
                case 'successPosition':
                    return [html('holdsRatioHelpModal.yourHoldsPositionHtml', { holdListPosition: holdListPosition, holdsCount: holdsCount }), html('holdsRatioHelpModal.libraryCopies', { ownedCopies: ownedCopies })];
                case 'ratio':
                case 'basic':
                default:
                    return [html('holdsRatioHelpModal.totalHoldsHtml', { holdsCount: holdsCount }), html('holdsRatioHelpModal.libraryCopies', { ownedCopies: ownedCopies })];
            }
        }
    }, {
        key: 'note',
        get: function get() {
            return this.model.get('isFastlane') ? html('advantageFastPassHtml') : '';
        }
    }]);

    function HoldInformation(_ref) {
        var type = _ref.type;

        _classCallCheck(this, HoldInformation);

        var _this = _possibleConstructorReturn(this, (HoldInformation.__proto__ || Object.getPrototypeOf(HoldInformation)).apply(this, arguments));

        _this.el = _this.el || document.createElement('div');
        _this.el.className = _this.el.className + ' HoldInformation';
        _this.type = type || 'basic';
        return _this;
    }

    _createClass(HoldInformation, [{
        key: 'render',
        value: function render() {
            var view = (0, _HoldInformation2['default'])({
                expirationWarning: this.expirationWarning,
                description: this.description,
                details: this.details,
                note: this.note
            });
            this.$el.empty().append(view);

            return this;
        }
    }]);

    return HoldInformation;
}(Backbone.View);

exports['default'] = HoldInformation;

},{"../templates/HoldInformation.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformation\\templates\\HoldInformation.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformation\\views\\HoldInformationModal.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _modal = require('../../common/modal');

var _HoldInformation = require('./HoldInformation');

var _HoldInformation2 = _interopRequireDefault(_HoldInformation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HoldInformationModal = function (_Modal) {
    _inherits(HoldInformationModal, _Modal);

    function HoldInformationModal(_ref) {
        var model = _ref.model,
            type = _ref.type;

        _classCallCheck(this, HoldInformationModal);

        var information = new _HoldInformation2['default']({ model: model, type: type }).render();
        var modalContents = {
            classes: ['HoldInformationModal'],
            title: window.html('holdsRatioHelpModal.heading'),
            content: information.el
        };
        return _possibleConstructorReturn(this, (HoldInformationModal.__proto__ || Object.getPrototypeOf(HoldInformationModal)).call(this, modalContents));
    }

    return HoldInformationModal;
}(_modal.Modal);

exports['default'] = HoldInformationModal;

},{"../../common/modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js","./HoldInformation":"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformation\\views\\HoldInformation.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\kindle_preference_modal\\KindlePreference.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _KindlePreferenceModal = require('./views/KindlePreferenceModal');

var _KindlePreferenceModal2 = _interopRequireDefault(_KindlePreferenceModal);

var _KindlePreferenceResultModal = require('./views/KindlePreferenceResultModal');

var _KindlePreferenceResultModal2 = _interopRequireDefault(_KindlePreferenceResultModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _window = window,
    url = _window.url,
    routes = _window.routes;

var KindlePreference = function () {
    function KindlePreference(_ref) {
        var bus = _ref.bus,
            globalPreferences = _ref.globalPreferences,
            source = _ref.source,
            completionTargetUrl = _ref.completionTargetUrl;

        _classCallCheck(this, KindlePreference);

        this.bus = bus;
        this.source = source;
        this.globalPreferences = globalPreferences;
        this.completionTargetUrl = completionTargetUrl;
    }

    _createClass(KindlePreference, [{
        key: 'run',
        value: function run() {
            var _this = this;

            this.preferenceModal = new _KindlePreferenceModal2['default'](this.completionTargetUrl);

            this.preferenceModal.$el.find('.confirm-button').on('click', function () {
                var resultButtonText = _this.source === 'content_fulfillment' ? html('kindleFulfillment.setPrefModal.continue') : html('ok');
                var showResult = _this._updatePreference(true).then(function () {
                    _this.preferenceModal.close();
                    _this.resultModal = new _KindlePreferenceResultModal2['default']({ kindleSelected: true, wasSuccessful: true, buttonText: resultButtonText, continueTargetUrl: _this.completionTargetUrl });
                })['catch'](function () {
                    _this.preferenceModal.close();
                    _this.resultModal = new _KindlePreferenceResultModal2['default']({ kindleSelected: true, wasSuccessful: false, buttonText: resultButtonText, continueTargetUrl: _this.completionTargetUrl });
                });
            });

            this.preferenceModal.$el.find('.deny-button').on('click', function () {
                _this._updatePreference(false).then(function () {
                    _this.preferenceModal.close();
                })['catch'](function () {
                    _this.preferenceModal.close();
                });
            });
        }
    }, {
        key: '_updatePreference',
        value: function _updatePreference(val) {
            return this.globalPreferences.setKindleFulfillmentPreference(val, this.source);
        }
    }]);

    return KindlePreference;
}();

exports['default'] = KindlePreference;

},{"./views/KindlePreferenceModal":"C:\\projects\\lightning\\public\\ecmascript\\components\\kindle_preference_modal\\views\\KindlePreferenceModal.js","./views/KindlePreferenceResultModal":"C:\\projects\\lightning\\public\\ecmascript\\components\\kindle_preference_modal\\views\\KindlePreferenceResultModal.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\kindle_preference_modal\\templates\\KindlePreferenceModal.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _window = window,
    html = _window.html;

exports['default'] = function (noThanksTargetUrl) {
    return '\n<div class=\'info-container\'>\n    <p>\n        ' + html('kindleFulfillment.setPrefModal.offer') + '\n        ' + html('kindleFulfillment.setPrefModal.adjustInfoHtml', { settingsLink: html('settings') }) + '\n    </p>\n</div>\n<div class=\'button-container\'>\n    ' + (noThanksTargetUrl ? '<a href=' + noThanksTargetUrl + ' target=\'_blank\' class=\'deny-button button margin-small radius outline gray u-allCaps show-desktop\'>' + html('noThanks') + '</a>' : '<button type=\'button\' class=\'deny-button button margin-small radius outline gray u-allCaps show-desktop\'>' + html('noThanks') + '</button>') + '\n\n    <button type=\'button\' class=\'confirm-button button margin-small radius secondary contrast u-allCaps\'>' + html('kindleFulfillment.setPrefModal.setPref') + '</button>\n\n    ' + (noThanksTargetUrl ? '<a href=' + noThanksTargetUrl + ' target=\'_blank\' class=\'deny-button button margin-small radius outline gray u-allCaps show-mobile\'>' + html('noThanks') + '</a>' : '<button type=\'button\' class=\'deny-button button margin-small radius outline gray u-allCaps show-mobile\'>' + html('noThanks') + '</button>') + '\n</div>\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\kindle_preference_modal\\templates\\KindlePreferenceResultModal.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _window = window,
    html = _window.html,
    url = _window.url,
    routes = _window.routes;

exports['default'] = function (_ref) {
    var wasSuccessful = _ref.wasSuccessful,
        buttonText = _ref.buttonText,
        continueTargetUrl = _ref.continueTargetUrl;
    return '\n<div class=\'info-container\'>\n    ' + (wasSuccessful ? '\n        <p>' + html('kindleFulfillment.setPrefSuccessModal.successMsg') + '</p>\n    ' : '\n        <p>' + html('kindleFulfillment.setPrefErrorModal.errorMsg', { accountSettingsLink: '<a href=\'' + url(routes.accountSettings) + '\'>' + html('accountSettings.accountSettings') + '</a>' }) + '</p>\n    ') + '\n</div>\n<div class=\'button-container\'>\n    ' + (continueTargetUrl ? '<a  href=' + continueTargetUrl + ' target=\'_blank\' class=\'continue-button button margin-small radius secondary contrast u-allCaps\'>\n                ' + buttonText + '\n           </a>' : '<button type=\'button\' class=\'continue-button button margin-small radius secondary contrast u-allCaps\'>\n                ' + buttonText + '\n           </button>') + '\n</div>\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\kindle_preference_modal\\views\\KindlePreferenceModal.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _modal = require('../../common/modal');

var _KindlePreferenceModal = require('../templates/KindlePreferenceModal.html');

var _KindlePreferenceModal2 = _interopRequireDefault(_KindlePreferenceModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KindlePreferenceModal = function (_Modal) {
    _inherits(KindlePreferenceModal, _Modal);

    function KindlePreferenceModal(noThanksTargetUrl) {
        _classCallCheck(this, KindlePreferenceModal);

        var modalContents = {
            classes: ['KindlePreferenceModal'],
            title: window.html('kindleFulfillment.setPrefModal.heading'),
            content: (0, _KindlePreferenceModal2['default'])(noThanksTargetUrl),
            closeOnEsc: false,
            closeOnBlur: false
        };

        var _this = _possibleConstructorReturn(this, (KindlePreferenceModal.__proto__ || Object.getPrototypeOf(KindlePreferenceModal)).call(this, modalContents));

        var kindleLogo = '<div class=\'logo-container\'><img src=\'https://images.overdrive.com/misc/kindle/Kindle-icon.png\' alt=\'' + html('kindleFulfillment.kindle') + '\' /></div>';
        _this.$title.before(kindleLogo);

        _this.$el.find('.close-reveal-modal').remove();
        return _this;
    }

    return KindlePreferenceModal;
}(_modal.Modal);

exports['default'] = KindlePreferenceModal;

},{"../../common/modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js","../templates/KindlePreferenceModal.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\kindle_preference_modal\\templates\\KindlePreferenceModal.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\kindle_preference_modal\\views\\KindlePreferenceResultModal.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _modal = require('../../common/modal');

var _KindlePreferenceResultModal = require('../templates/KindlePreferenceResultModal.html');

var _KindlePreferenceResultModal2 = _interopRequireDefault(_KindlePreferenceResultModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KindlePreferenceSuccessModal = function (_Modal) {
    _inherits(KindlePreferenceSuccessModal, _Modal);

    function KindlePreferenceSuccessModal(_ref) {
        var wasSuccessful = _ref.wasSuccessful,
            buttonText = _ref.buttonText,
            continueTargetUrl = _ref.continueTargetUrl;

        _classCallCheck(this, KindlePreferenceSuccessModal);

        var modalContents = {
            classes: ['KindlePreferenceResultModal'],
            title: wasSuccessful ? window.html('genericSuccess') : window.html('genericError'),
            content: (0, _KindlePreferenceResultModal2['default'])({ wasSuccessful: wasSuccessful, buttonText: buttonText, continueTargetUrl: continueTargetUrl })
        };

        var _this = _possibleConstructorReturn(this, (KindlePreferenceSuccessModal.__proto__ || Object.getPrototypeOf(KindlePreferenceSuccessModal)).call(this, modalContents));

        var kindleLogo = '<div class=\'logo-container\'><img src=\'https://images.overdrive.com/misc/kindle/Kindle-icon.png\' alt=\'' + html('kindleFulfillment.kindle') + '\' /></div>';
        _this.$title.before(kindleLogo);

        _this.$el.find('.continue-button').on('click', function () {
            _this.trigger('close');
        });
        return _this;
    }

    return KindlePreferenceSuccessModal;
}(_modal.Modal);

exports['default'] = KindlePreferenceSuccessModal;

},{"../../common/modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js","../templates/KindlePreferenceResultModal.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\kindle_preference_modal\\templates\\KindlePreferenceResultModal.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\kindle_trouble_modal\\templates\\KindleTroubleModal.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _window = window,
    html = _window.html;

exports['default'] = function () {
    return '\n    <p class="message-container">\n        ' + html('kindleFulfillment.kindleTroubleModal.whichIssue') + '\n    </p>\n    <div class="radio-container">\n        <div class=\'badLink-radio\'></div>\n        <div class=\'wrongTitle-radio\'></div>\n        <div class=\'incompatibleDevice-radio\'></div>\n        <div class=\'other-radio\'></div>\n    </div>\n    <div class=\'button-container\'>\n        <button type=\'button\' class=\'submit-button button radius secondary contrast u-allCaps u-center\'>' + html('submit') + '</button>\n    </div>\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\kindle_trouble_modal\\templates\\KindleTroubleResponseModalBroken.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _window = window,
    html = _window.html;

exports['default'] = function (alternativeButtonText) {
    return '\n    <div class=\'message-container\'>\n        <p>' + html('kindleFulfillment.kindleTroubleResponseModal.resolution') + '</p>\n        <p>' + html('kindleFulfillment.kindleTroubleResponseModal.useReadHtml', { option: '\n            <span style=\'font-weight: bold\'>' + alternativeButtonText + '</span>\n        ' }) + '</p>\n        <p>' + html('kindleFulfillment.kindleTroubleResponseModal.sorry') + '</p>\n    </div>\n    <div class=\'button-container\'>\n        <button type=\'button\' class=\'confirm-button button radius secondary contrast u-allCaps u-center\'>' + html('ok') + '</button>\n    </div>\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\kindle_trouble_modal\\templates\\KindleTroubleResponseModalDevice.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _window = window,
    html = _window.html,
    supportUrl = _window.supportUrl;
var _window$OverDrive = window.OverDrive,
    supportArticles = _window$OverDrive.supportArticles,
    _locale = _window$OverDrive._locale;

exports['default'] = function (alternativeButtonText) {
    return '\n    <div class=\'message-container\'>\n        <p>' + html('kindleFulfillment.kindleTroubleResponseModal.sorry') + '</p>\n        <p>' + html('kindleFulfillment.kindleTroubleResponseModal.useReadHtml', { option: '\n            <span style=\'font-weight: bold\'>' + alternativeButtonText + '</span>\n        ' }) + '</p>\n    </div>\n    <div class=\'futureAction-container\'>\n        <p>' + html('kindleFulfillment.kindleTroubleResponseModal.futureActionHtml', { checkRestrictions: '\n            <a target=\'_blank\' href=\'' + supportUrl(_locale, supportArticles.deviceRestrictions) + '\'>' + html('kindleFulfillment.kindleTroubleResponseModal.checkRestrictions') + '</a>\n        ' }) + '</p>\n    </div>\n    <div class=\'button-container\'>\n        <button type=\'button\' class=\'confirm-button button radius secondary contrast u-allCaps u-center\'>' + html('ok') + '</button>\n    </div>\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\kindle_trouble_modal\\templates\\KindleTroubleResponseModalOther.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _window = window,
    html = _window.html,
    url = _window.url,
    routes = _window.routes;

exports['default'] = function (alternativeButtonText) {
    return '\n    <div class=\'message-container\'>\n        <p>' + html('kindleFulfillment.kindleTroubleResponseModal.sorry') + '</p>\n        <p>' + html('kindleFulfillment.kindleTroubleResponseModal.contactSupportHtml', { link: '<a target="_blank" class="u-lowercase" href="' + url(routes.supportMembers) + '">' + html('contactSupport') + '</a>' }) + '\n        </p>\n        <p>' + html('kindleFulfillment.kindleTroubleResponseModal.forNowUseReadHtml', { option: '\n            <span style=\'font-weight: bold\'>' + alternativeButtonText + '</span>\n        ' }) + '</p>\n    </div>\n    <div class=\'button-container\'>\n        <button type=\'button\' class=\'confirm-button button radius secondary contrast u-allCaps u-center\'>' + html('ok') + '</button>\n    </div>\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\kindle_trouble_modal\\views\\KindleTroubleModal.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _modal = require('../../common/modal');

var _KindleTroubleModal = require('../templates/KindleTroubleModal.html');

var _KindleTroubleModal2 = _interopRequireDefault(_KindleTroubleModal);

var _KindleTroubleResponseModal = require('./KindleTroubleResponseModal');

var _KindleTroubleResponseModal2 = _interopRequireDefault(_KindleTroubleResponseModal);

var _RadioButton = require('../../common/RadioButton');

var _RadioButton2 = _interopRequireDefault(_RadioButton);

var _MediaInterface = require('../../media/MediaInterface');

var _MediaInterface2 = _interopRequireDefault(_MediaInterface);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KindleTroubleModal = function (_Modal) {
    _inherits(KindleTroubleModal, _Modal);

    function KindleTroubleModal(_ref) {
        var titleId = _ref.titleId,
            alternativeFormat = _ref.alternativeFormat;

        _classCallCheck(this, KindleTroubleModal);

        var modalContents = {
            classes: ['KindleTroubleModal'],
            title: window.html('kindleFulfillment.reportKindleTrouble'),
            content: (0, _KindleTroubleModal2['default'])()
        };

        var _this = _possibleConstructorReturn(this, (KindleTroubleModal.__proto__ || Object.getPrototypeOf(KindleTroubleModal)).call(this, modalContents));

        _this._buildRadioGroup();

        _this.$el.find('.submit-button').on('click', function () {
            var selectedOption = _this.$el.find('.radio-container input[type="radio"]:checked').val();
            _this._logKindleError(titleId, selectedOption);
            var responseModal = new _KindleTroubleResponseModal2['default'](_this._responseModalOption(selectedOption), alternativeFormat);
            _this.close();
        });
        return _this;
    }

    _createClass(KindleTroubleModal, [{
        key: '_buildRadioGroup',
        value: function _buildRadioGroup() {
            var rid = Math.random().toString(36).substring(7);
            var badLink = new _RadioButton2['default']({
                value: 'badLink',
                checked: true,
                el: '.badLink-radio',
                className: 'troubleRadio',
                name: 'troubleRadio',
                label: window.html('kindleFulfillment.kindleTroubleModal.badLink'),
                rid: rid
            }).render();

            var wrongTitle = new _RadioButton2['default']({
                value: 'wrongTitle',
                el: '.wrongTitle-radio',
                className: 'troubleRadio',
                name: 'troubleRadio',
                label: window.html('kindleFulfillment.kindleTroubleModal.wrongTitle'),
                rid: rid
            }).render();

            var incompatibleDevice = new _RadioButton2['default']({
                value: 'incompatibleDevice',
                el: '.incompatibleDevice-radio',
                className: 'troubleRadio',
                name: 'troubleRadio',
                label: window.html('kindleFulfillment.kindleTroubleModal.incompatibleDevice'),
                rid: rid
            }).render();

            var other = new _RadioButton2['default']({
                value: 'other',
                el: '.other-radio',
                className: 'troubleRadio',
                name: 'troubleRadio',
                label: window.html('titleDetails.other'),
                rid: rid
            }).render();
        }
    }, {
        key: '_logKindleError',
        value: function _logKindleError(titleId, selectedOption) {
            var _this2 = this;

            var mediaInterface = new _MediaInterface2['default']();

            mediaInterface.search({ titleId: titleId }).then(function (title) {
                window.Logger.log('warn', _this2._errorMessage(selectedOption), {
                    message: 'KindleTroubleReport',
                    id: title ? title.id : '',
                    reserveId: title ? title.reserveId : '',
                    isbn: _this2._pluckIdentifier(title, 'ISBN') || '',
                    asin: _this2._pluckIdentifier(title, 'ASIN') || '',
                    title: title ? title.title : '',
                    creator: title ? title.firstCreatorName : ''
                });
            });
        }
    }, {
        key: '_pluckIdentifier',
        value: function _pluckIdentifier(title) {
            var _ref2;

            var identifierType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISBN';

            var formats = title && title.formats;
            var identifiers = formats && formats.length > 0 ? (_ref2 = []).concat.apply(_ref2, _toConsumableArray(formats.map(function (format) {
                return format.identifiers;
            }))) : undefined;
            var ofType = identifiers && identifiers.length > 0 ? identifiers.filter(function (identifier) {
                return identifier.type === identifierType;
            }).map(function (identifier) {
                return identifier.value;
            }) : undefined;
            return ofType && ofType.length > 0 ? ofType[0] : undefined;
        }
    }, {
        key: '_errorMessage',
        value: function _errorMessage(selectedOption) {
            switch (selectedOption) {
                case 'badLink':
                    return 'Link to title broken';
                case 'wrongTitle':
                    return 'Wrong title delivered to device';
                case 'incompatibleDevice':
                    return 'Can\'t send title to device';
                default:
                    return 'Other/unspecified';
            }
        }
    }, {
        key: '_responseModalOption',
        value: function _responseModalOption(selectedOption) {
            switch (selectedOption) {
                case 'badLink':
                    return 'broken';
                case 'wrongTitle':
                    return 'broken';
                case 'incompatibleDevice':
                    return 'device';
                default:
                    return 'other';
            }
        }
    }]);

    return KindleTroubleModal;
}(_modal.Modal);

exports['default'] = KindleTroubleModal;

},{"../../common/RadioButton":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\RadioButton.js","../../common/modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js","../../media/MediaInterface":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\MediaInterface.js","../templates/KindleTroubleModal.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\kindle_trouble_modal\\templates\\KindleTroubleModal.html.js","./KindleTroubleResponseModal":"C:\\projects\\lightning\\public\\ecmascript\\components\\kindle_trouble_modal\\views\\KindleTroubleResponseModal.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\kindle_trouble_modal\\views\\KindleTroubleResponseModal.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _modal = require('../../common/modal');

var _KindleTroubleResponseModalBroken = require('../templates/KindleTroubleResponseModalBroken.html');

var _KindleTroubleResponseModalBroken2 = _interopRequireDefault(_KindleTroubleResponseModalBroken);

var _KindleTroubleResponseModalDevice = require('../templates/KindleTroubleResponseModalDevice.html');

var _KindleTroubleResponseModalDevice2 = _interopRequireDefault(_KindleTroubleResponseModalDevice);

var _KindleTroubleResponseModalOther = require('../templates/KindleTroubleResponseModalOther.html');

var _KindleTroubleResponseModalOther2 = _interopRequireDefault(_KindleTroubleResponseModalOther);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KindleTroubleResponseModal = function (_Modal) {
    _inherits(KindleTroubleResponseModal, _Modal);

    function KindleTroubleResponseModal(option, alternativeFormatId) {
        _classCallCheck(this, KindleTroubleResponseModal);

        var alternativeButtonText = alternativeFormatId === 'odread' ? window.html('readNow') : window.html('accountLoans.download') + ' ' + window.html('formats.' + alternativeFormatId);

        var content = void 0,
            modalContents = void 0;
        switch (option) {
            case 'broken':
                content = (0, _KindleTroubleResponseModalBroken2['default'])(alternativeButtonText);
                modalContents = {
                    classes: ['KindleTroubleResponseModal'],
                    title: window.html('kindleFulfillment.kindleTroubleResponseModal.thanks'),
                    content: content
                };
                break;
            case 'device':
                content = (0, _KindleTroubleResponseModalDevice2['default'])(alternativeButtonText);
                modalContents = {
                    classes: ['KindleTroubleResponseModal'],
                    title: window.html('kindleFulfillment.kindleTroubleResponseModal.otherOptions'),
                    content: content
                };
                break;
            default:
                content = (0, _KindleTroubleResponseModalOther2['default'])(alternativeButtonText);
                modalContents = {
                    classes: ['KindleTroubleResponseModal'],
                    title: window.html('contactSupport'),
                    content: content
                };
                break;
        }

        var _this = _possibleConstructorReturn(this, (KindleTroubleResponseModal.__proto__ || Object.getPrototypeOf(KindleTroubleResponseModal)).call(this, modalContents));

        _this.$el.find('.confirm-button').on('click', function () {
            _this.close();
        });
        return _this;
    }

    return KindleTroubleResponseModal;
}(_modal.Modal);

exports['default'] = KindleTroubleResponseModal;

},{"../../common/modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js","../templates/KindleTroubleResponseModalBroken.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\kindle_trouble_modal\\templates\\KindleTroubleResponseModalBroken.html.js","../templates/KindleTroubleResponseModalDevice.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\kindle_trouble_modal\\templates\\KindleTroubleResponseModalDevice.html.js","../templates/KindleTroubleResponseModalOther.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\kindle_trouble_modal\\templates\\KindleTroubleResponseModalOther.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\language_selection\\main.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _language_selection = require('./views/language_selection');

var _language_selection2 = _interopRequireDefault(_language_selection);

var _preferences = require('../../models/preferences');

var _preferences2 = _interopRequireDefault(_preferences);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var createComponent = function createComponent(_ref) {
    var el = _ref.el,
        footerEl = _ref.footerEl,
        mobileEl = _ref.mobileEl,
        mobileFooterEl = _ref.mobileFooterEl;

    var preferencesModel = new _preferences2['default']();
    preferencesModel.parseBootstrappedData(OverDrive);
    var selectionView = new _language_selection2['default']({ el: el, preferencesModel: preferencesModel }); // eslint-disable-line no-unused-vars
    var footerView = new _language_selection2['default']({ el: footerEl, preferencesModel: preferencesModel }); // eslint-disable-line no-unused-vars
    var mobileView = new _language_selection2['default']({ el: mobileEl, preferencesModel: preferencesModel }); // eslint-disable-line no-unused-vars
    var mobileFooterView = new _language_selection2['default']({ el: mobileFooterEl, preferencesModel: preferencesModel }); // eslint-disable-line no-unused-vars
};

exports['default'] = createComponent;

},{"../../models/preferences":"C:\\projects\\lightning\\public\\ecmascript\\models\\preferences.js","./views/language_selection":"C:\\projects\\lightning\\public\\ecmascript\\components\\language_selection\\views\\language_selection.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\language_selection\\views\\language_selection.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _base = require('../../../views/base');

var _base2 = _interopRequireDefault(_base);

var _keycodes = require('../../../util/keycodes');

var _keycodes2 = _interopRequireDefault(_keycodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var dyslexicBlacklist = require('../../../../../config/dyslexicBlacklist.json');
var numbers = require('../../../../../lib/numbers.js');

var LanguageSelectionView = _base2['default'].extend({
    events: {
        'click .js-languageLink': 'languageLinkClicked',
        'keypress .js-languageLink': 'languageLinkPressed'
    },
    initialize: function initialize(_ref) {
        var preferencesModel = _ref.preferencesModel;

        this.model = preferencesModel;
        this.listenTo(this.model, 'change', this.modelSave);
        var selectedLangLink = this.$el.find('.js-languageLink.selected');
        var selectedLangName = selectedLangLink.text();
        var languageCode = this.model.get('languageSelection');
        if (selectedLangName) {
            this.$el.find('.js-langDisplayText').text(selectedLangName);
        }

        // Update language if Cookie does not match selected language
        if (Cookies.get('language-selection') && languageCode !== Cookies.get('language-selection')) {
            this.updateLanguagePreference(Cookies.get('language-selection'), false);
        }
    },
    languageLinkClicked: function languageLinkClicked(e) {
        this.updateLanguagePreference($(e.currentTarget).data('code'), true);
    },
    languageLinkPressed: function languageLinkPressed(e) {
        if (e.keyCode === _keycodes2['default'].ENTER) {
            this.updateLanguagePreference($(e.currentTarget).data('code'), true);
        }
    },
    updateLanguagePreference: function updateLanguagePreference(code, clicked) {
        var _this = this;

        var updatedPrefs = {
            languageSelection: code
        };

        // If the language does not support dyslexic font, remove the dyslexic cookie
        if (dyslexicBlacklist[code]) {
            if (Cookies.get('dyslexic-setting')) {
                // If on the settings page and the user changed the dyslexic setting,
                // the language selection preferenceModel would not be updated, only the
                // settings page preferencesModel would.  This accounts for that change.
                this.model.attributes.dyslexic = true;
            }

            Cookies.remove('dyslexic-setting', { path: '/' });
            updatedPrefs.dyslexic = false;
        }

        this.model.set(updatedPrefs);

        if (window.OverDrive.isAuthenticated) {
            this.model.save(this.model.getPatchData(), {
                patch: true, success: function success() {
                    _this.setCookieAndRefresh(code, clicked);
                }
            });
        } else {
            this.setCookieAndRefresh(code, clicked);
        }
    },
    setCookieAndRefresh: function setCookieAndRefresh(languageSelectionValue, clicked) {
        // Delete any existing language selection cookie to prevent edge case where multiple cookies are set
        Cookies.remove('language-selection', { path: '/' });

        var domain = window.location.hostname || 'overdrive.com';
        domain = '.' + domain.split('.').splice(-2).join('.'); // grab everything after second-to-last period

        Cookies.set('language-selection', languageSelectionValue, {
            httpOnly: false,
            expires: new Date(Date.now() + numbers.yearInMilliseconds),
            domain: domain,
            overwrite: true
        });

        // Prevents refresh loop when errors occur or cannot retrieve auth
        if (window.OverDrive.authType !== 'error' || clicked) {
            window.location.reload();
        }
    }
});

exports['default'] = LanguageSelectionView;


},{"../../../../../config/dyslexicBlacklist.json":"C:\\projects\\lightning\\config\\dyslexicBlacklist.json","../../../../../lib/numbers.js":"C:\\projects\\lightning\\lib\\numbers.js","../../../util/keycodes":"C:\\projects\\lightning\\public\\ecmascript\\util\\keycodes.js","../../../views/base":"C:\\projects\\lightning\\public\\ecmascript\\views\\base.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\lending_period_modal\\LendingPeriodCollection.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LendingPeriod = require('../media/models/LendingPeriod');

var _LendingPeriod2 = _interopRequireDefault(_LendingPeriod);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LendingPeriodCollection = function (_Backbone$Collection) {
    _inherits(LendingPeriodCollection, _Backbone$Collection);

    function LendingPeriodCollection() {
        _classCallCheck(this, LendingPeriodCollection);

        return _possibleConstructorReturn(this, (LendingPeriodCollection.__proto__ || Object.getPrototypeOf(LendingPeriodCollection)).apply(this, arguments));
    }

    _createClass(LendingPeriodCollection, [{
        key: 'model',
        get: function get() {
            return _LendingPeriod2['default'];
        }
    }]);

    return LendingPeriodCollection;
}(Backbone.Collection);

exports['default'] = LendingPeriodCollection;

},{"../media/models/LendingPeriod":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\models\\LendingPeriod.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\lending_period_modal\\LendingPeriodModal.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function (_ref) {
    var title = _ref.title,
        cover = _ref.cover,
        lendingPeriods = _ref.lendingPeriods,
        isRenewal = _ref.isRenewal,
        showRemoveHoldOption = _ref.showRemoveHoldOption,
        removingHold = _ref.removingHold,
        isLuckyDayRestricted = _ref.isLuckyDayRestricted,
        isLuckyDayHoldable = _ref.isLuckyDayHoldable,
        luckyDayLendingPeriod = _ref.luckyDayLendingPeriod;
    return '\n<div class=\'content\'>\n    <div class=\'row\'>\n        <div class=\'small-5 columns cover\'>\n            ' + cover.$el.html() + '\n        </div>\n        <div class=\'small-7 columns data\'>\n            <div class=\'row\'>\n                <div class=\'small-12 columns title\'>' + title.get('title') + '</div>\n                ' + (title.get('series') && !title.isMagazine ? '<div class=\'small-12 columns\'>' + title.get('series') + '</div>' : '') + '\n                ' + (title.isMagazine && title.get('edition') ? '<div class=\'small-12 columns\'>' + title.get('edition') + '</div>' : '') + '\n                <div class="title-format-badge contrast u-allCaps"><i class="icon-' + title.get('type').id + '"></i>' + window.html(title.get('type').id) + '</div>\n                <div class=\'small-12 columns lending-period\'>\n                    ' + (lendingPeriods.length > 1 ? window.html(isRenewal ? 'renewal.renewForTextHtml' : 'borrowForTextHtml', { text: '\n                        <div class=\'lending-period-dropdown\'><select class=\'lending-period-select\'>\n                            ' + lendingPeriods.map(function (lendingPeriod) {
            return '<option value=\'' + lendingPeriod.cid + '\' ' + (lendingPeriod.get('isPreferredLendingPeriod') ? 'selected' : '') + '>\n                                    ' + window.html('accountLoans.expiresDays', { time: lendingPeriod.period.days }) + '\n                                </option>';
        }) + '\n                        </select><i class=\'icon-down-arrow\'></i></div>' }) : isLuckyDayRestricted ? isLuckyDayHoldable ? window.html('luckyDay.restrictedAllowHolds', { days: luckyDayLendingPeriod }) : title.get('isOnHold') ? window.html('luckyDay.restrictedOnHold', { days: luckyDayLendingPeriod }) : window.html('luckyDay.restricted', { days: luckyDayLendingPeriod }) : lendingPeriods.first().label) + '\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class=\'row buttons\'>\n    ' + (showRemoveHoldOption ? '<div class=\'button-column onHoldRadioContainer\'>\n            <div class=\'holdOption removeHold\'></div>\n            <div class=\'holdOption stayOnHold\'></div>\n        </div>' : '') + '\n    ' + (removingHold ? '<div class="removingHoldWarning">' + window.html('luckyDay.yourHoldRemoved') + '</div>' : '') + '\n    <div class=\'small-12 columns button-column\'>\n        <button type=\'button\' ' + (isLuckyDayRestricted ? '' : 'aria-label=\'' + window.html(isRenewal ? 'renewal.renewTitle' : 'borrowTitle', { title: title.get('title') }) + '\'') + ' class=\'button radius secondary contrast u-allCaps borrow-button\'>\n            ' + (isRenewal ? window.html('renewal.renew') : isLuckyDayRestricted ? window.html('luckyDay.borrowFor', { days: luckyDayLendingPeriod }) : window.html('borrow')) + '\n        </button>\n    </div>\n    ' + (isLuckyDayHoldable ? '<div class=\'small-12 columns button-column\'>\n            <button type=\'button\' class=\'button radius outline u-allCaps hold-button\'>\n                ' + window.html('placeHold') + '\n            </button>\n        </div>' : '') + '\n    <div class=\'small-12 columns button-column\'>\n        <button type=\'button\' aria-label=\'' + window.html('cancel') + '\' class=\'button radius outline gray u-allCaps cancel-button\'>\n            ' + window.html('cancel') + '\n        </button>\n    </div>\n    </div>\n<div>\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\lending_period_modal\\LendingPeriodModal.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _modal = require('../common/modal');

var _PatronTitleLendingPeriods = require('./PatronTitleLendingPeriods');

var _PatronTitleLendingPeriods2 = _interopRequireDefault(_PatronTitleLendingPeriods);

var _Cover = require('../media/Cover');

var _Cover2 = _interopRequireDefault(_Cover);

var _RadioButton = require('../../components/common/RadioButton');

var _RadioButton2 = _interopRequireDefault(_RadioButton);

var _LendingPeriodModal = require('./LendingPeriodModal.html');

var _LendingPeriodModal2 = _interopRequireDefault(_LendingPeriodModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LendingPeriodModal = function (_Backbone$View) {
    _inherits(LendingPeriodModal, _Backbone$View);

    function LendingPeriodModal(_ref) {
        var bus = _ref.bus,
            action = _ref.action,
            onError = _ref.onError,
            _ref$isRenewal = _ref.isRenewal,
            isRenewal = _ref$isRenewal === undefined ? false : _ref$isRenewal;

        _classCallCheck(this, LendingPeriodModal);

        var _this = _possibleConstructorReturn(this, (LendingPeriodModal.__proto__ || Object.getPrototypeOf(LendingPeriodModal)).apply(this, arguments));

        _this.bus = bus;
        _this.action = action || function () {};
        _this.onError = onError || function () {};
        _this.isRenewal = isRenewal;

        _this.cover = new _Cover2['default']({ model: _this.model });
        // Expects a Title object as its model
        _this.patronTitleLendingPeriods = new _PatronTitleLendingPeriods2['default']({ mediaId: _this.model.get('id') });
        _this.patronTitleLendingPeriods.fetchData().then(function () {
            var lendingPeriods = _this.patronTitleLendingPeriods.get('lendingPeriods');
            _this.model.set('titleState', _this.isRenewal ? 'renew' : 'borrow');
            _this._openModal(lendingPeriods);
        })['catch'](function (error) {
            _this.onError(error);
        });
        return _this;
    }

    _createClass(LendingPeriodModal, [{
        key: '_openModal',
        value: function _openModal(lendingPeriods) {
            var _this2 = this;

            var maybeCheckHoldStatus = new Promise(function (resolve) {
                if (_this2.model.get('isOnHold')) {
                    $.ajax({
                        url: window.url(window.routes.getSingleHold, { mediaId: _this2.model.get('id') }),
                        type: 'GET'
                    }).done(function (response) {
                        _this2.model.set('isReleasedHold', response.isAvailable);
                    }).always(function () {
                        resolve();
                    });
                } else {
                    resolve();
                }
            });

            maybeCheckHoldStatus.then(function () {
                var isLuckyDayRestricted = _this2.model.isLuckyDayCheckout && !!window.OverDrive.LuckyDayLendingPeriodsByFormat && !!window.OverDrive.LuckyDayLendingPeriodsByFormat[_this2.model.get('type').id] && !_this2.isRenewal;

                var isLuckyDayHoldable = isLuckyDayRestricted && _this2.model.canPlaceHold && !_this2.model.allCopiesAreLuckyDay;

                var luckyDayLendingPeriod = void 0;
                if (isLuckyDayRestricted) {
                    luckyDayLendingPeriod = window.OverDrive.LuckyDayLendingPeriodsByFormat[_this2.model.get('type').id];
                }

                var autoCancelEnabled = window.featureManager.isEnabled('luckyDayAutoHoldCancel');
                var showRemoveHoldOption = _this2.model.isLuckyDayCheckout && _this2.model.get('isOnHold') && window.featureManager.isEnabled('allowRemoveHoldsOnCheckout') && !_this2.model.get('isReleasedHold') && (isLuckyDayRestricted || !autoCancelEnabled);

                var removeHold = _this2.model.isLuckyDayCheckout && autoCancelEnabled && !showRemoveHoldOption && _this2.model.get('isOnHold');

                var modalTitle = void 0;
                if (_this2.isRenewal) {
                    modalTitle = window.html('renewal.renewHeading');
                } else if (isLuckyDayRestricted) {
                    modalTitle = window.html('luckyDay.xDayLoan', { days: luckyDayLendingPeriod });
                } else {
                    modalTitle = window.html('borrow');
                }
                var modalContents = {
                    classes: ['LendingPeriodModal', 'small'],
                    title: modalTitle,
                    hiddenTitle: !isLuckyDayRestricted,
                    content: (0, _LendingPeriodModal2['default'])({
                        title: _this2.model,
                        cover: _this2.cover,
                        lendingPeriods: isLuckyDayRestricted ? [] : lendingPeriods,
                        isRenewal: _this2.isRenewal,
                        showRemoveHoldOption: showRemoveHoldOption,
                        removingHold: removeHold,
                        isLuckyDayRestricted: isLuckyDayRestricted,
                        isLuckyDayHoldable: isLuckyDayHoldable,
                        luckyDayLendingPeriod: luckyDayLendingPeriod
                    })
                };
                _this2.modal = new _modal.Modal(modalContents);
                var $modalEl = _this2.modal.$el;

                if (showRemoveHoldOption) {
                    new _RadioButton2['default']({
                        value: true,
                        checked: true,
                        el: '.removeHold',
                        className: 'removeHoldOption',
                        name: 'removeHoldOption',
                        label: window.html('accountHolds.removeHoldLabel'),
                        rid: 0
                    }).render();

                    new _RadioButton2['default']({
                        value: false,
                        el: '.stayOnHold',
                        className: 'removeHoldOption',
                        name: 'removeHoldOption',
                        label: window.html('accountHolds.stayOnHold'),
                        rid: 0
                    }).render();
                }

                $modalEl.on('click', '.cancel-button', function () {
                    _this2.modal.close();
                });

                $modalEl.on('click', '.borrow-button', function () {

                    var selectedLendingPeriod = void 0;
                    if (isLuckyDayRestricted) {
                        selectedLendingPeriod = {
                            units: 'days',
                            isPreferredLendingPeriod: false,
                            lendingPeriod: luckyDayLendingPeriod
                        };
                    } else {
                        selectedLendingPeriod = lendingPeriods.length > 1 ? lendingPeriods.get($modalEl.find('.lending-period-select').val()).toJSON() : lendingPeriods.first().toJSON();
                    }

                    _this2.model.set('lendingPeriod', selectedLendingPeriod);

                    $modalEl.find('.borrow-button').addClass('waiting').append('<div class="spinner"></div>');

                    if (removeHold) {
                        _this2.bus.on('title:borrow:success', function () {
                            _this2.bus.trigger('title:hold-cancel', _this2.model);
                        });
                    }

                    _this2.action(_this2.modal);
                });

                $modalEl.on('click', '.hold-button', function () {
                    _this2.model.trigger('title:action', { action: 'hold', model: _this2.model });
                    $modalEl.find('.hold-button').addClass('waiting').append('<div class="spinner"></div>');
                    _this2.bus.on('title:hold:end', function () {
                        _this2.modal.close();
                    });
                });

                $modalEl.on('change', '.removeHoldOption', function (event) {
                    removeHold = event.target.value === 'true';
                });
            });
        }
    }]);

    return LendingPeriodModal;
}(Backbone.View);

exports['default'] = LendingPeriodModal;

},{"../../components/common/RadioButton":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\RadioButton.js","../common/modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js","../media/Cover":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\Cover.js","./LendingPeriodModal.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\lending_period_modal\\LendingPeriodModal.html.js","./PatronTitleLendingPeriods":"C:\\projects\\lightning\\public\\ecmascript\\components\\lending_period_modal\\PatronTitleLendingPeriods.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\lending_period_modal\\PatronTitleLendingPeriods.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('../../util/Promise');

var _LendingPeriodCollection = require('./LendingPeriodCollection');

var _LendingPeriodCollection2 = _interopRequireDefault(_LendingPeriodCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _window = window,
    Logger = _window.Logger,
    url = _window.url,
    routes = _window.routes;

var PatronTitleLendingPeriods = function (_Backbone$Model) {
    _inherits(PatronTitleLendingPeriods, _Backbone$Model);

    function PatronTitleLendingPeriods() {
        _classCallCheck(this, PatronTitleLendingPeriods);

        return _possibleConstructorReturn(this, (PatronTitleLendingPeriods.__proto__ || Object.getPrototypeOf(PatronTitleLendingPeriods)).apply(this, arguments));
    }

    _createClass(PatronTitleLendingPeriods, [{
        key: 'defaults',
        value: function defaults() {
            return {
                mediaId: 0,
                lendingPeriods: new _LendingPeriodCollection2['default']()
            };
        }
    }, {
        key: 'fetchData',
        value: function fetchData() {
            var _this2 = this;

            return Promise.ajax({
                method: 'GET',
                url: url(routes.patronLendingPeriod, { mediaId: this.get('mediaId') }),
                timeout: 10000
            })
            // Set our model but pass the data along in case the caller wants to use it for something else
            .then(function (response) {
                _this2.get('lendingPeriods').set(response);
                return response;
            })
            // Catch errors, log them, and then let the call fail
            ['catch'](function (error) {
                Logger.log('error', 'Failure fetching patron lending periods for title', { mediaId: _this2.get('mediaId'), error: error });
                throw error;
            });
        }
    }]);

    return PatronTitleLendingPeriods;
}(Backbone.Model);

exports['default'] = PatronTitleLendingPeriods;

},{"../../util/Promise":"C:\\projects\\lightning\\public\\ecmascript\\util\\Promise.js","./LendingPeriodCollection":"C:\\projects\\lightning\\public\\ecmascript\\components\\lending_period_modal\\LendingPeriodCollection.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\ContextMenu.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ContextMenu = require('./templates/ContextMenu.html');

var _ContextMenu2 = _interopRequireDefault(_ContextMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _window = window,
    featureManager = _window.featureManager,
    url = _window.url,
    routes = _window.routes,
    OverDrive = _window.OverDrive,
    text = _window.text,
    html = _window.html;

var ContextMenu = function (_Backbone$View) {
    _inherits(ContextMenu, _Backbone$View);

    function ContextMenu() {
        _classCallCheck(this, ContextMenu);

        var _this = _possibleConstructorReturn(this, (ContextMenu.__proto__ || Object.getPrototypeOf(ContextMenu)).apply(this, arguments));

        _this.template = _ContextMenu2['default'];

        _this.isKeyboardSelectEvent = function (e) {
            return (e.which === 13 || e.which === 32) && (e.preventDefault() || true);
        };

        _this.rid = Math.random().toString(36).substring(7);

        _this.listenTo(_this.model, 'change:isInHistory', function () {
            return _this.render();
        });

        _this.render();
        return _this;
    }
    // TODO: Go back and refactor out data tied to the DOM in the template -alance


    _createClass(ContextMenu, [{
        key: 'events',
        value: function events() {
            return {
                'click .js-historyAction': '_handleClick',
                'keydown .js-historyAction': '_handleKey',
                'keydown .js-context-button': 'toggle'
            };
        }
    }, {
        key: '_handleClick',
        value: function _handleClick() {
            this.model.trigger('title:action', { action: 'history', model: this.model });
        }
    }, {
        key: '_handleKey',
        value: function _handleKey(e) {
            e.stopImmediatePropagation();

            if (e.keyCode === 13 || e.keyCode === 32) {
                this.model.trigger('title:action', { action: 'history', model: this.model });
            }
        }
    }, {
        key: '_getSampleText',
        value: function _getSampleText() {
            var type = this.model.get('type').id;

            if (type === 'audiobook' || type === 'music') {
                return text('sampleListen');
            } else if (type === 'video') {
                return text('sampleWatch');
            }

            return text('sampleRead');
        }
    }, {
        key: '_getHistoryActionLabel',
        value: function _getHistoryActionLabel() {
            var title = this.model.get('title');
            if (this.model.get('isInHistory')) {
                return html('readingHistory.removeTitle', { title: title });
            } else {
                return html('readingHistory.addTitle', { title: title });
            }
        }
    }, {
        key: '_getHistoryActionText',
        value: function _getHistoryActionText() {
            if (this.model.get('isInHistory')) {
                return html('readingHistory.remove');
            } else {
                return html('readingHistory.add');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            this.$el.empty().append(this.template(this.viewModel));

            return this;
        }
    }, {
        key: 'toggle',
        value: function toggle(e) {
            if (this.isKeyboardSelectEvent(e)) {
                window.Foundation.libs.dropdown.toggle(this.$el.find('.js-context-button'));
            }
        }
    }, {
        key: 'viewModel',
        get: function get() {
            var seriesSearchUrl = '';
            if (featureManager.isEnabled('enhancedSeries') && this.model.get('detailedSeries')) {
                seriesSearchUrl = url(routes.searchByType, { type: 'seriesId', query: this.model.get('detailedSeries').seriesId, sortBy: 'readingOrder' });
            } else if (this.model.get('series')) {
                seriesSearchUrl = url(routes.searchByType, { type: 'series', query: this.model.get('series'), sortBy: 'newlyadded' });
            }

            return {
                id: this.model.id,
                rid: this.rid,
                title: this.model.get('title'),
                typeId: this.model.get('type').id,
                sampleHref: this.model.get('sample').href || '',
                sampleText: this._getSampleText(),
                alignment: 'bottom',
                historyActionLabel: this._getHistoryActionLabel(),
                historyActionText: this._getHistoryActionText(),
                historyEnabled: OverDrive.showHistoryFeature && !this.model.get('isPreReleaseTitle'),
                gaHistoryAction: this.model.get('isInHistory') ? 'history-remove' : 'history-add',
                seriesSearchUrl: seriesSearchUrl
            };
        }
    }]);

    return ContextMenu;
}(Backbone.View);

exports['default'] = ContextMenu;

},{"./templates/ContextMenu.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\ContextMenu.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\Cover.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Cover = require('./templates/Cover.html');

var _Cover2 = _interopRequireDefault(_Cover);

var _NoCover = require('./templates/NoCover.html');

var _NoCover2 = _interopRequireDefault(_NoCover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _window = window,
    Logger = _window.Logger;

var Cover = function (_Backbone$View) {
    _inherits(Cover, _Backbone$View);

    function Cover(_ref) {
        var coverWidths = _ref.coverWidths,
            isInHero = _ref.isInHero,
            _ref$isTitleHistory = _ref.isTitleHistory,
            isTitleHistory = _ref$isTitleHistory === undefined ? false : _ref$isTitleHistory;

        _classCallCheck(this, Cover);

        var _this = _possibleConstructorReturn(this, (Cover.__proto__ || Object.getPrototypeOf(Cover)).apply(this, arguments));

        _this.coverWidths = _.extend({ mobile: 145, tablet: 160, desktop: 190 }, coverWidths);
        _this.isInHero = isInHero;
        _this.isTitleHistory = isTitleHistory;

        _this.listenTo(_this.model, 'change', _this._render);
        _this._render();
        return _this;
    }

    _createClass(Cover, [{
        key: 'remove',
        value: function remove() {
            $(window).off('resize.' + this.model.id);
        }
    }, {
        key: '_render',
        value: function _render() {
            var _this2 = this;

            var media = this.model.toJSON();

            var device = detectshun.browser();
            var coverWidth = device.mobile ? this.coverWidths.mobile : device.tablet ? this.coverWidths.tablet : this.coverWidths.desktop;
            var cover = this.model.getCover(coverWidth);

            if (this.model.isPlaceholder) {
                var $cover = '<div class="CoverImageContainer"></div>';
                this.$el.empty().append($cover);
            } else if (cover && cover.href) {
                var _$cover = $((0, _Cover2['default'])({
                    media: media,
                    coverColor: cover && cover.primaryColor && cover.primaryColor.hex || 'inherit',
                    src: cover && cover.href,
                    href: this.model.titleDetailsUrl,
                    label: window.text('cover.coverImageLabel', { title: media.title, creator: media.firstCreatorName }),
                    noSampleClass: media.sample.href == null ? 'is-noSample' : ''
                }));

                // LHTNG-2105: In the event that an image fails to load, wipe out the href's and update the model to trigger a render()
                _$cover.find('img').on('error', function () {

                    // LHTNG-2143
                    Logger && Logger.log('error', 'CDN Error', {
                        type: 'image',
                        titleId: media.id,
                        src: cover && cover.href
                    });

                    var imagesRemoved = JSON.parse(JSON.stringify(_this2.model.attributes.covers));

                    _(imagesRemoved).each(function (image) {
                        delete image.href;
                    });

                    _this2.model.set({ covers: imagesRemoved });
                });

                this.$el.empty().append(_$cover);
            } else if (this.isTitleHistory) {
                this.$el.empty().append('<a href="' + this.model.titleDetailsUrl + '">\n                    <img alt="' + window.html('coverImageForTitle', { title: media.title }) + '" class="history-noCover" src="/public/img/no-cover_en_US.jpg">\n                </a>');
            } else {

                var creatorText = this.model.isMagazine ? this.model.get('edition') : this.model.get('firstCreatorName');
                this.$el.empty().append((0, _NoCover2['default'])({
                    media: media,
                    href: this.model.titleDetailsUrl,
                    isInHero: this.isInHero,
                    coverWidth: coverWidth,
                    coverHeight: coverWidth * 293 / 220,
                    creatorText: creatorText
                }));
                $(window).on('resize.' + this.model.id, _.bind(this._manageOverflow, this, '.CoverImageContainer .noCoverAvailable .title', this.model.get('title')));
                $(window).on('resize.' + this.model.id, _.bind(this._manageOverflow, this, '.CoverImageContainer .noCoverAvailable .author', creatorText));
                $(window).on('resize.' + this.model.id, _.bind(this._resizeClearImage, this));

                // timeout gives browser chance to draw and set innerHTML values used
                setTimeout(function () {
                    _this2._manageOverflow('.CoverImageContainer .noCoverAvailable .title', _this2.model.get('title'));
                    _this2._manageOverflow('.CoverImageContainer .noCoverAvailable .author', creatorText);
                    _this2._resizeClearImage();
                }, 1);
            }

            return this;
        }
    }, {
        key: '_resizeClearImage',
        value: function _resizeClearImage() {
            var image = this.el.querySelector('img');
            if (image) {
                $(image).height($(image).parent().width() * 293 / 220);
            }
        }
    }, {
        key: '_manageOverflow',
        value: function _manageOverflow(selector, resetText) {
            var element = this.el.querySelector(selector);
            if (element) {
                element.innerHTML = resetText;
                if (selector.indexOf('.title') !== -1) {
                    if ($(element).width() < 100) {
                        $(element).css('font-size', '14px');
                    } else if ($(element).width() < 125 && $(element).width() >= 100) {
                        $(element).css('font-size', '16px');
                    } else if ($(element).width() < 150 && $(element).width() >= 125) {
                        $(element).css('font-size', '18px');
                    } else if ($(element).width() >= 150) {
                        $(element).css('font-size', '20px');
                    }
                } else if (selector.indexOf('.author') !== -1) {
                    if ($(element).width() < 110) {
                        $(element).css('font-size', '10px');
                    } else if ($(element).width() < 135 && $(element).width() >= 110) {
                        $(element).css('font-size', '12px');
                    } else if ($(element).width() < 160 && $(element).width() >= 135) {
                        $(element).css('font-size', '14px');
                    } else if ($(element).width() >= 160) {
                        $(element).css('font-size', '16px');
                    }
                }
                if (element.scrollHeight > 0 && element.scrollHeight > element.clientHeight) {
                    var text = element.innerHTML;
                    text = text.replace(/\W+$/g, '') + '...'; // remove trailing special characters and add ellipsis
                    while (text !== '...' && element.scrollHeight > element.clientHeight) {
                        text = text.replace(/\W*\w\W*(\.{3})$/g, '$1'); // remove a non-ellipsis character and unwanted characters around itΩ
                        element.innerHTML = text;
                    }
                    // todo: put a min width an height on this! We know what the heights are for particular screen widths
                }
            }
        }
    }]);

    return Cover;
}(Backbone.View);

exports['default'] = Cover;

},{"./templates/Cover.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\Cover.html.js","./templates/NoCover.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\NoCover.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\MediaInterface.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _MediaParameters = require('../../../../models/dao/MediaParameters');

var _MediaParameters2 = _interopRequireDefault(_MediaParameters);

var _TitleCollection = require('./models/TitleCollection');

var _TitleCollection2 = _interopRequireDefault(_TitleCollection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MediaInterface = function () {
    function MediaInterface() {
        _classCallCheck(this, MediaInterface);

        _.extend(this, Backbone.Events);

        this.items = new _TitleCollection2['default']();
        this.facets = {};
        this.sortOptions = [];
    }

    _createClass(MediaInterface, [{
        key: 'quickSearch',
        value: function quickSearch(term, options) {
            return this._fetch(_.extend({}, { query: term }, options));
        }
    }, {
        key: 'search',
        value: function search(parameters, options) {
            return this._fetch(_.extend({}, parameters, options));
        }
    }, {
        key: 'fetchCollectionById',
        value: function fetchCollectionById(id, options) {
            return this._fetch(_.extend({}, { collectionId: id }, options));
        }
    }, {
        key: 'fetchCollectionByParameters',
        value: function fetchCollectionByParameters(collectionFilters, options) {
            return this._fetch(_.extend({}, collectionFilters, options));
        }

        /** Utility function to simulate a data call, but deliberatley return an empty result set */

    }, {
        key: 'fetchEmptyResponse',
        value: function fetchEmptyResponse() {
            this.trigger('sync:start', this, { mediaParameters: null });

            var emptyResponse = {
                items: [],
                facets: {},
                sortOptions: []
            };

            this._fetchDone(emptyResponse, 'synthetic');

            this.trigger('sync:end', this);

            return Promise.resolve(emptyResponse);
        }

        /**
         * @param {MediaParameters} parameters
         * @memberof MediaInterface
         */

    }, {
        key: '_fetch',
        value: function _fetch(parameters) {
            var _this = this;

            if (!parameters) {
                parameters = {};
            }

            // if a title id is specificed then no facets will be calculated regardless of the params sent.
            if (!parameters.includedFacets && !parameters.titleId) {
                parameters.includedFacets = window.OverDrive.supportedFacets;
            }

            if (window.featureManager.isEnabled('LuckyDay') && parameters.shuffle) {
                var sorts = ['mostpopular', 'releasedate', 'title', 'author', 'newlyadded', 'lowcirculating', 'mostpopular-site'];
                parameters.sortBy = sorts[Math.floor(Math.random() * sorts.length)];
            }

            var mediaParameters = new _MediaParameters2['default'](parameters);

            if (!!window.OverDrive.showOnlyAvailable) {
                mediaParameters.showOnlyAvailable = true;
            }

            this.trigger('sync:start', this, { mediaParameters: mediaParameters });

            return new Promise(function (resolve, reject) {
                $.ajax({
                    url: window.url(window.routes.rest.media.index),
                    method: 'POST',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    data: JSON.stringify(mediaParameters.serialize()),
                    timeout: 10000
                }).done(function (data, textStatus, jqXHR) {
                    if (window.featureManager.isEnabled('LuckyDay') && parameters.shuffle) {
                        data.items = data.items && _.shuffle(data.items);
                    }
                    _this._fetchDone(data, textStatus, jqXHR);
                    _this.trigger('sync:end', _this);
                    resolve(data);
                }).fail(function (jqXHR, textStatus, errorThrown) {
                    _this._fetchFail(jqXHR, textStatus, errorThrown);
                    _this.trigger('sync:end', _this);
                    reject(jqXHR);
                });
            });
        }
    }, {
        key: '_fetchDone',
        value: function _fetchDone(data, textStatus, jqXHR) {
            this.items.reset(data.items);
            this.trigger('sync:success', this, { data: data, textStatus: textStatus, jqXHR: jqXHR });
        }
    }, {
        key: '_fetchFail',
        value: function _fetchFail(jqXHR, textStatus, errorThrown) {
            this.trigger('sync:fail', this, { jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown });
        }
    }]);

    return MediaInterface;
}();

exports['default'] = MediaInterface;

},{"../../../../models/dao/MediaParameters":"C:\\projects\\lightning\\models\\dao\\MediaParameters.js","./models/TitleCollection":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\models\\TitleCollection.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleActionButton.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TitleActionButton = function (_Backbone$View) {
    _inherits(TitleActionButton, _Backbone$View);

    function TitleActionButton(_ref) {
        var _ref$type = _ref.type,
            type = _ref$type === undefined ? 'link' : _ref$type,
            action = _ref.action,
            style = _ref.style;

        _classCallCheck(this, TitleActionButton);

        var _this = _possibleConstructorReturn(this, (TitleActionButton.__proto__ || Object.getPrototypeOf(TitleActionButton)).apply(this, arguments));

        _this.isSelectEvent = function (e) {
            return (e.type === 'click' || e.which === 13 || e.which === 32) && (e.preventDefault() || true);
        };

        _this.type = type;

        _this.hasCustomAction = false;
        if (!!action) {
            _this.action = action;
            _this.hasCustomAction = true;
        }

        _this.style = style;

        _this.$button = $('<button />');

        _this.listenTo(_this.model, 'change:titleState', _this.render);

        _this.render();
        return _this;
    }

    _createClass(TitleActionButton, [{
        key: 'render',
        value: function render() {
            this.$button.off();
            this.$el.off();

            var attributes = this.getButtonAttrs();
            if (_(attributes.href).isEmpty()) {
                this.$button = $('<button />', attributes);
            } else {
                this.$button = $('<a />', attributes);
            }

            // Attach event handlers if either is true
            // - Button is not a link
            // - Custom action has been provided
            if (_(attributes.href).isEmpty() || this.hasCustomAction) {
                this._attachEventHandlers(this.$button);
            }

            this.$el.empty().append(this.$button);

            return this;
        }
    }, {
        key: 'waiting',
        value: function waiting() {
            var isWaiting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            if (isWaiting) {
                this.$button.off('.titleActionButton').addClass('waiting').attr('disabled', isWaiting).append('<div class="spinner"></div>');
            } else {
                this.$button.removeClass('waiting').attr('disabled', isWaiting).find('.spinner').remove();

                this._attachEventHandlers(this.$button);
            }

            return this;
        }
    }, {
        key: '_attachEventHandlers',
        value: function _attachEventHandlers($el) {
            var _this2 = this;

            $el.off('.titleActionButton');

            $el.on('click.titleActionButton', function (e) {
                _this2.isSelectEvent(e) && _this2.action(e);
            });
            $el.on('keydown.titleActionButton', function (e) {
                _this2.isSelectEvent(e) && _this2.action(e);
            });
        }
    }, {
        key: 'action',
        value: function action(event) {
            this.isSelectEvent(event) && this._triggerTitleAction();
        }
    }, {
        key: '_triggerTitleAction',
        value: function _triggerTitleAction() {
            this.model.trigger('title:action', { action: this.state, model: this.model });
        }
    }, {
        key: 'getButtonAttrs',
        value: function getButtonAttrs() {
            var buttonAttrs = {
                'data-media-id': this.model.id,
                'data-type': this.model.attributes.type.id,
                'data-type-name': this.model.attributes.type.id && window.html(this.model.attributes.type.id) || '',
                html: this.$button.html && this.$button.html() || '',
                tabindex: 0
            };

            var title = this.model.attributes.title;

            var classes = ['TitleActionButton', 'u-allCaps'];

            if (this.isButton) {
                var _classes;

                (_classes = classes).push.apply(_classes, ['button', 'radius', 'is-button', 'secondary']);
            }

            if (this.style === 'fill') {
                classes.push('fill');
            }

            switch (this.state) {
                case 'recommend':
                    classes.push('is-recommend');
                    if (this.isLink) {
                        classes.push('secondary-color');
                    }
                    buttonAttrs.html = '<span>' + window.html('recommend') + '</span>';
                    buttonAttrs['aria-label'] = window.html('recommendTitle', { title: title });
                    break;
                case 'recommended':
                    if (this.isButton) {
                        classes.push('outline gray');
                        classes = _(classes).without('secondary');
                    }

                    classes.push('is-recommended');
                    buttonAttrs.html = '<span>' + window.html('recommended') + '</span>';
                    buttonAttrs.href = window.url(window.routes.accountRecommendations);
                    break;
                case 'unavailable':
                    classes.push('is-unavailable js-unavailable disabled');
                    buttonAttrs.html = '<span>' + window.html('availabilityUnavailable') + '</span>';
                    break;
                case 'nook':
                    classes.push('is-nook js-nook');
                    buttonAttrs.html = '<span>' + window.html('sendToNook') + '</span>';
                    break;
                case 'preview':
                    if (this.isLink) {
                        classes.push('secondary-color');
                    }

                    classes.push('is-preview js-preview secondary');
                    buttonAttrs.html = '<span>' + window.html('demoMode.preview') + '</span>';
                    buttonAttrs['aria-label'] = window.html('demoMode.previewTitle', { title: title });
                    break;
                case 'borrow':
                    if (this.isLink) {
                        classes.push('secondary-color');
                    }

                    classes.push('is-borrow js-borrow secondary');
                    buttonAttrs.html = '<span>' + window.html('borrow') + '</span>';
                    buttonAttrs['aria-label'] = window.html('borrowTitle', { title: title });
                    break;
                case 'borrowed':
                    classes.push('is-borrowed js-borrowed');
                    buttonAttrs.html = '<span>' + window.html('goToLoans') + '</span>';
                    buttonAttrs.href = window.url(window.routes.accountLoans);
                    break;
                case 'hold':
                    if (this.isLink) {
                        classes.push('secondary-color-hover');
                    }

                    classes.push('is-hold js-hold');
                    buttonAttrs.html = '<span>' + window.html('placeAHold') + '</span>';
                    buttonAttrs['aria-label'] = window.html('placeAHoldOnTitle', { title: title });
                    break;
                case 'onHold':
                    if (this.isButton) {
                        classes.push('primary');
                    }

                    classes.push('is-onHold js-onHold');
                    buttonAttrs.html = '<span>' + window.html('goToHolds') + '</span>';
                    buttonAttrs.href = window.url(window.routes.accountHolds);
                    break;
                case 'renew':
                    classes.push('is-renew renewalButton');
                    classes = classes.filter(function (c) {
                        return c !== 'u-allCaps';
                    });
                    buttonAttrs.html = '<span><i class="icon icon-renew" aria-hidden="true"></i>' + window.html('renewal.renewTitle', { title: '' }) + '</span>';
                    break;
                case 'requestAgain':
                    classes.push('is-requestAgain renewalButton');
                    classes = classes.filter(function (c) {
                        return c !== 'u-allCaps';
                    });
                    buttonAttrs.html = '<span><i class="icon icon-renew" aria-hidden="true"></i>' + window.html('accountLoans.requestAgain') + '</span>';
                    break;
                case 'requested':
                    classes.push('is-requested renewalButton');
                    classes = classes.filter(function (c) {
                        return c !== 'u-allCaps';
                    });
                    buttonAttrs.html = '<span><i class="icon icon-renew" aria-hidden="true"></i>' + window.html('accountLoans.requested') + '</span>';
                    break;
                case 'renewed':
                    classes.push('is-renewed renewalButton');
                    classes = classes.filter(function (c) {
                        return c !== 'u-allCaps';
                    });
                    buttonAttrs.html = '<span><i class="icon icon-renew" aria-hidden="true"></i>' + window.html('accountLoans.renewed') + '</span>';
                    break;
                case 'listenNow':
                    classes.push('is-listenNow');
                    buttonAttrs.html = '<span>' + window.html('listenNow') + '</span>';
                    buttonAttrs.href = window.url(window.routes.mediaDownload, { format: 'audiobook-overdrive', mediaId: this.model.id });
                    buttonAttrs.target = '_blank';
                    break;
                case 'readNow':
                    classes.push('is-readNow');
                    buttonAttrs.html = '<span>' + window.html('readNow') + '</span>';
                    buttonAttrs.href = window.url(window.routes.mediaDownload, { format: 'ebook-overdrive', mediaId: this.model.id });
                    buttonAttrs.target = '_blank';
                    break;
                case 'addToApp':
                    if (this.isLink) {
                        classes.push('secondary-color-hover');
                    }

                    classes.push('is-addToApp');
                    buttonAttrs.html = '<span>' + window.html('addToApp') + '</span>';
                    buttonAttrs.href = window.url(window.routes.mediaDownload, { format: this.model.get('addToAppFormat'), mediaId: this.model.id });
                    break;
                case 'waiting':
                    if (this.isLink) {
                        var dotSpinner = $(window.primaryActionLoadingGif);
                        dotSpinner.css('width', 'inherit');
                        buttonAttrs.html = dotSpinner;
                        break;
                    }

                    classes.push('waiting secondary');
                    buttonAttrs.disabled = true;
                    buttonAttrs.html = '<span>working</span><div class="spinner"></div>';
                    break;
            }

            buttonAttrs['class'] = classes.join(' ');

            return buttonAttrs;
        }
    }, {
        key: 'isButton',
        get: function get() {
            return this.type === 'button';
        }
    }, {
        key: 'isLink',
        get: function get() {
            return this.type === 'link';
        }
    }, {
        key: 'state',
        get: function get() {
            return this.model.get('titleState');
        }
    }]);

    return TitleActionButton;
}(Backbone.View);

exports['default'] = TitleActionButton;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleCard.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TitleCard = require('./templates/TitleCard.html');

var _TitleCard2 = _interopRequireDefault(_TitleCard);

var _TitleInfo = require('./views/TitleInfo');

var _TitleInfo2 = _interopRequireDefault(_TitleInfo);

var _TitleActionButton = require('./TitleActionButton');

var _TitleActionButton2 = _interopRequireDefault(_TitleActionButton);

var _WishListButton = require('./WishListButton');

var _WishListButton2 = _interopRequireDefault(_WishListButton);

var _TitleHeaderBar = require('./TitleHeaderBar');

var _TitleHeaderBar2 = _interopRequireDefault(_TitleHeaderBar);

var _Cover = require('./Cover');

var _Cover2 = _interopRequireDefault(_Cover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TitleCard = function (_Backbone$View) {
    _inherits(TitleCard, _Backbone$View);

    _createClass(TitleCard, [{
        key: 'className',
        get: function get() {
            return 'title-container title';
        }
    }]);

    function TitleCard(_ref) {
        var coverWidths = _ref.coverWidths,
            _ref$isInHero = _ref.isInHero,
            isInHero = _ref$isInHero === undefined ? false : _ref$isInHero;

        _classCallCheck(this, TitleCard);

        var _this = _possibleConstructorReturn(this, (TitleCard.__proto__ || Object.getPrototypeOf(TitleCard)).apply(this, arguments));

        _this.template = _TitleCard2['default'];

        _this._views = [];

        _this.coverWidths = coverWidths;
        _this.isInHero = isInHero;

        _this.render();
        return _this;
    }

    _createClass(TitleCard, [{
        key: 'render',
        value: function render() {
            var model = this.model,
                coverWidths = this.coverWidths,
                isInHero = this.isInHero;


            this.$el.empty();

            this._views.forEach(function (view) {
                return view.remove();
            });
            this._views = [];

            var $tmp = $(this.template());

            // TODO: This will not work  with CSS transition animations
            if (this.model.isPlaceholder) {
                this.$el.addClass('placeholder');
            }

            this._views.push(this.titleHeaderBar = new _TitleHeaderBar2['default']({
                model: model, el: $tmp.find('.TitleHeaderBar')
            }));

            this._views.push(this.cover = new _Cover2['default']({
                model: model, el: $tmp.find('.CoverImage'), coverWidths: coverWidths, isInHero: isInHero
            }));

            this._views.push(this.titleInfo = new _TitleInfo2['default']({
                model: model, el: $tmp.find('.TitleInfo')
            }));

            this._views.push(this.titleActionButton = new _TitleActionButton2['default']({
                model: model, el: $tmp.find('.TitleAction')
            }));

            if (!window.featureManager.isEnabled('internationalDemoMode')) {
                this._views.push(this.wishlistButton = new _WishListButton2['default']({
                    model: model, el: $tmp.find('.TitleWishlist'), type: 'icon-only'
                }).render());
            }

            this.$el.append($tmp);

            return this;
        }
    }, {
        key: 'remove',
        value: function remove() {
            this._views.forEach(function (view) {
                return view.remove();
            });
            _get(TitleCard.prototype.__proto__ || Object.getPrototypeOf(TitleCard.prototype), 'remove', this).call(this);
        }
    }]);

    return TitleCard;
}(Backbone.View);

exports['default'] = TitleCard;

},{"./Cover":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\Cover.js","./TitleActionButton":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleActionButton.js","./TitleHeaderBar":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleHeaderBar.js","./WishListButton":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\WishListButton.js","./templates/TitleCard.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\TitleCard.html.js","./views/TitleInfo":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleCollectionView.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _processForwardedAction = require('../../util/title-actions/processForwardedAction');

var _processForwardedAction2 = _interopRequireDefault(_processForwardedAction);

var _HashManager = require('../../components/common/HashManager');

var _HashManager2 = _interopRequireDefault(_HashManager);

var _TitleCard = require('./TitleCard');

var _TitleCard2 = _interopRequireDefault(_TitleCard);

var _TitleActions = require('../../title-actions/TitleActions');

var _TitleActions2 = _interopRequireDefault(_TitleActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var he = require('he');
// This assumes that the calling code passes a Backbone.Collection with a model type of Title

var TitleCollectionView = function (_Backbone$View) {
    _inherits(TitleCollectionView, _Backbone$View);

    function TitleCollectionView(_ref) {
        var bus = _ref.bus,
            patronMediaItemsModel = _ref.patronMediaItemsModel,
            View = _ref.View,
            attributes = _ref.attributes,
            coverWidths = _ref.coverWidths,
            isInHero = _ref.isInHero,
            context = _ref.context;

        _classCallCheck(this, TitleCollectionView);

        var _this = _possibleConstructorReturn(this, (TitleCollectionView.__proto__ || Object.getPrototypeOf(TitleCollectionView)).apply(this, arguments));

        _this._views = [];

        _this.bus = bus;
        _this.View = View || _TitleCard2['default'];
        _this.attributes = _.extend({}, attributes);
        _this.coverWidths = coverWidths;
        _this.isInHero = isInHero;
        _this.context = context;

        _this.titleActions = new _TitleActions2['default']({ bus: _this.bus, context: context });

        _this.listenTo(_this.collection, 'title:action', _this._handleTitleAction);

        // TODO: >>> Remove this call and _updateMediaStates() logic and update dependant consumers to use PatronTitleStatus
        // Fetch patron data and trigger state updates.
        // Only fetch patron data if authed and has linked cards.
        if (patronMediaItemsModel && window.OverDrive.isAuthenticated && window.OverDrive.hasLinkedCards) {
            patronMediaItemsModel.initialFetch().then(function (patronData) {
                _this._updateMediaStates(patronData);
            });
        }

        _this.render();
        return _this;
    }

    _createClass(TitleCollectionView, [{
        key: '_handleTitleAction',
        value: function _handleTitleAction(_ref2) {
            var action = _ref2.action,
                model = _ref2.model;

            this.titleActions.perform(action, model);
        }
    }, {
        key: '_updateMediaStates',
        value: function _updateMediaStates(patronData) {
            var _this2 = this;

            var ids = [];
            _(_.values(patronData)).each(function (item) {
                if (_.isArray(item)) {
                    var _ids;

                    (_ids = ids).push.apply(_ids, _toConsumableArray(item));
                } else if (_.isObject(item)) {
                    var _ids2;

                    (_ids2 = ids).push.apply(_ids2, _toConsumableArray(_.keys(item).map(Number)));
                } else {
                    ids.push(item);
                }
            });
            ids = _.uniq(ids);

            ids.forEach(function (id) {
                var model = _this2.collection.get(id);

                if (model) {
                    model.updatePatronState(patronData);
                }
            });

            this._performForwardedAction();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var frag = document.createDocumentFragment();

            this._views.forEach(function (view) {
                return view.remove();
            });
            this._views = [];

            this.collection.forEach(function (title) {

                title.set('title', he.decode(title.get('title')));

                title.setContext(_this3.context);

                var view = new _this3.View({
                    model: title,
                    bus: _this3.bus,
                    coverWidths: _this3.coverWidths,
                    isInHero: _this3.isInHero
                });

                frag.appendChild($('<li />', {
                    'class': 'js-titleCard Item'
                }).append(view.$el)[0]);

                _this3._views.push(view);
            });

            // TODO: Figure out a better way to handle the collection title
            var $collectionTitle = $('.collection-title-container');

            this.$el.attr(this.attributes);
            this.$el.empty().append($collectionTitle).append(frag);
        }
    }, {
        key: 'remove',
        value: function remove() {
            this._views.forEach(function (view) {
                return view.remove();
            });
            _get(TitleCollectionView.prototype.__proto__ || Object.getPrototypeOf(TitleCollectionView.prototype), 'remove', this).call(this);
        }
    }, {
        key: '_performForwardedAction',
        value: function _performForwardedAction() {
            if (window.OverDrive.isAuthenticated && window.OverDrive.hasLinkedCards && _HashManager2['default'].get('action')) {
                var forwardedAction = new _processForwardedAction2['default'](this.collection, this.bus);
                forwardedAction.executeAction();
                window.forwardedAction = forwardedAction;
            }
        }
    }, {
        key: 'tagName',
        get: function get() {
            return 'ul';
        }
    }]);

    return TitleCollectionView;
}(Backbone.View);

exports['default'] = TitleCollectionView;

},{"../../components/common/HashManager":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\HashManager.js","../../title-actions/TitleActions":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\TitleActions.js","../../util/title-actions/processForwardedAction":"C:\\projects\\lightning\\public\\ecmascript\\util\\title-actions\\processForwardedAction.js","./TitleCard":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleCard.js","he":"C:\\projects\\lightning\\node_modules\\he\\he.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleHeaderBar.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Backbone = window.Backbone;

var TitleHeaderBar = Backbone.View.extend({
    initialize: function initialize() {
        this.listenTo(this.model, 'change', this.render);

        this.$titleHeaderBar = $('<div />');

        this.render();
    },
    render: function render() {
        var a = this.returnState();

        this.$titleHeaderBar = $('<div />', a.container).append($('<a />', a.link));
        this.$el.html(this.$titleHeaderBar);
        this.$el.attr('aria-hidden', 'true');

        return this;
    },
    returnState: function returnState() {
        var banner = {
            container: {
                classes: ['title-header-bar', 'u-allCaps']
            },
            link: {
                text: '',
                href: this.model.titleDetailsUrl,
                tabindex: -1
            }
        };

        this.action = this.model.get('titleState');

        switch (this.action) {
            case 'recommend':
                banner.container.classes.push('is-recommend not-owned-title');
                banner.link.text = window.html('availabilityNotOwned');
                break;
            case 'recommended':
                banner.container.classes.push('is-recommended not-owned-title');
                banner.link.text = window.html('recommended');
                break;
            case 'unavailable':
                banner.container.classes.push('is-unavailable unavailable-title');
                banner.link.text = window.html('availabilityUnavailable');
                break;
            case 'nook':
                banner.container.classes.push('is-nook available-title secondary-background');
                banner.link.text = window.html('availabilityAvailable');
                break;
            case 'borrow':
                banner.container.classes.push('available-title secondary-background is-borrow');
                banner.link.text = window.html('availabilityAvailable');
                break;
            case 'borrowed':
            case 'addToApp':
            case 'listenNow':
            case 'readNow':
                banner.container.classes.push('is-borrowed available-title secondary-background');
                banner.link.text = window.html('borrowed');
                break;
            case 'hold':
                banner.container.classes.push('is-hold unavailable-title');
                banner.link.text = this.model.get('isPreReleaseTitle') ? window.html('availabilityComingSoon') : window.text('availabilityWaitList');
                break;
            case 'onHold':
                banner.container.classes.push('is-onHold unavailable-title');
                banner.link.text = window.html('onHold');
                break;
            case 'waiting':
                banner.container.classes = this.$titleHeaderBar.attr('class').split(' ');
                banner.link.text = this.$titleHeaderBar.find('a:first').text();
                break;
        }

        banner.container['class'] = banner.container.classes.join(' ');

        return banner;
    }
});

exports['default'] = TitleHeaderBar;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\WishListButton.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _WishListButton = require('./templates/WishListButton.html');

var _WishListButton2 = _interopRequireDefault(_WishListButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WishListButton = function (_Backbone$View) {
    _inherits(WishListButton, _Backbone$View);

    _createClass(WishListButton, [{
        key: 'contrastClass',
        get: function get() {
            return this.contrast === 'default' ? '' : 'contrast-alternate';
        }
    }, {
        key: 'ariaLabel',
        get: function get() {
            var title = this.model.attributes.title;
            return this.model.get('wishlistState') === 'wishlistAdd' ? window.html('addTitleToWishList', { title: title }) : window.html('removeTitleFromWishList', { title: title });
        }
    }, {
        key: 'iconClass',
        get: function get() {
            return this.model.get('wishlistState') === 'wishlistAdd' ? 'icon-wish-list' : 'icon-wish-list-added';
        }
    }, {
        key: 'text',
        get: function get() {
            if (this.type === 'icon-only') {
                return '';
            }
            return this.model.get('wishlistState') === 'wishlistAdd' ? window.html('addToWishList') : window.html('removeFromWishList');
        }
    }, {
        key: 'ga',
        get: function get() {
            var isAdd = this.model.get('wishlistState') === 'wishlistAdd';
            if (isAdd) {
                return {
                    mediaId: this.model.attributes.id,
                    formatType: this.model.attributes.type.id
                };
            }
            return null;
        }
    }]);

    function WishListButton(_ref) {
        var type = _ref.type,
            contrast = _ref.contrast;

        _classCallCheck(this, WishListButton);

        var _this = _possibleConstructorReturn(this, (WishListButton.__proto__ || Object.getPrototypeOf(WishListButton)).apply(this, arguments));

        _this.type = type || 'icon-only';
        _this.contrast = contrast || 'default';

        _this.listenTo(_this.model, 'change:wishlistState', _this.render);
        _this.type = type || 'icon-only';
        return _this;
    }

    _createClass(WishListButton, [{
        key: 'events',
        value: function events() {
            return { 'click': '_handleClick' };
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.el || this.$el.length < 1) {
                return; // we have no target to render anything into
            }

            // retain focus on rerender
            var needsRefocus = this.el.querySelector('.WishListButton') === document.activeElement;

            this.$el.empty();

            // LHTNG-1648 - Dont render wishlist icon on recommend* state titles
            if (_(['recommend', 'recommended']).contains(this.model.get('titleState'))) {
                return this;
            }

            var buttonHtml = (0, _WishListButton2['default'])({
                ga: this.ga,
                contrastClass: this.contrastClass,
                ariaLabel: this.ariaLabel,
                iconClass: this.iconClass,
                text: this.text
            });

            this.$el.append(buttonHtml);

            if (needsRefocus) {
                this.el.querySelector('.WishListButton').focus();
            }

            return this;
        }
    }, {
        key: '_handleClick',
        value: function _handleClick() {
            this.model.trigger('title:action', { action: 'wish', model: this.model });
            this._animate();
        }
    }, {
        key: '_animate',
        value: function _animate() {
            this.$el.find('i').removeClass('animated bounceIn bounceOut').addClass('animated bounceOut');
        }
    }]);

    return WishListButton;
}(Backbone.View);

exports['default'] = WishListButton;

},{"./templates/WishListButton.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\WishListButton.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\models\\LendingPeriod.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LendingPeriod = function (_Backbone$Model) {
    _inherits(LendingPeriod, _Backbone$Model);

    function LendingPeriod() {
        _classCallCheck(this, LendingPeriod);

        return _possibleConstructorReturn(this, (LendingPeriod.__proto__ || Object.getPrototypeOf(LendingPeriod)).apply(this, arguments));
    }

    _createClass(LendingPeriod, [{
        key: 'defaults',
        get: function get() {
            return {
                isPreferredLendingPeriod: false,
                lendingPeriod: 1,
                units: 'days',
                selected: false // Non API property
            };
        }
    }, {
        key: 'period',
        get: function get() {
            var lendingPeriod = this.get('lendingPeriod');
            if (this.get('units') === 'minutes') {

                var dayRemainderMinutes = lendingPeriod % (60 * 24);

                return {
                    days: (lendingPeriod - dayRemainderMinutes) / (60 * 24),
                    hours: Math.ceil(dayRemainderMinutes / 60)
                };
            }
            return {
                days: lendingPeriod
            };
        }

        /** @type {string} - Localized display label for lending period */

    }, {
        key: 'label',
        get: function get() {
            // ref: LHTNG-1789 - `For [{n} days] [{d} hours]`
            var textParts = [];
            !!this.period.days && this.period.days > 0 && textParts.push(window.html('accountLoans.expiresDays', { time: this.period.days }));
            !!this.period.hours && this.period.hours > 0 && textParts.push(window.html('accountLoans.expiresHours', { time: this.period.hours }));

            return window.html('borrowForTextHtml', { text: textParts.join(' ') });
        }
    }]);

    return LendingPeriod;
}(Backbone.Model);

exports['default'] = LendingPeriod;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\models\\Title.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TitleState = require('../../../title-actions/TitleState');

var _TitleState2 = _interopRequireDefault(_TitleState);

var _MediaInterface = require('../MediaInterface');

var _MediaInterface2 = _interopRequireDefault(_MediaInterface);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Title = function (_Backbone$Model) {
    _inherits(Title, _Backbone$Model);

    _createClass(Title, [{
        key: 'defaults',
        value: function defaults() {
            return {
                id: 0,
                firstCreatorName: 'Author',
                title: 'Title',
                firstCreatorId: 0,
                formats: [],
                isOwned: false,
                isHoldable: false,
                isRecommendableToLibrary: false,
                isPreReleaseTitle: false,
                isAvailable: false,
                starRating: 0.0,
                userStarRating: 0,
                starRatingCount: 0,
                holdsRatio: 0,
                holdsCount: 0,
                ownedCopies: 0,
                availableCopies: 0,
                luckyDayOwnedCopies: 0,
                luckyDayAvailableCopies: 0,
                estimatedReleaseDate: '',
                availabilityType: '',
                description: '',
                sample: {}, // Sample
                publisher: {}, // Publisher
                type: { id: 'ebook' }, // Type
                covers: {}, // Covers

                // Custom Lightning Properties
                titleState: 'waiting',
                isRecommended: false,
                wishlistState: 'wishlistAdd',
                isInHistory: false,
                addToAppFormat: null,
                isOnHold: false,
                isReleasedHold: false,
                isBorrowed: false
            };
        }
    }, {
        key: 'setContext',
        value: function setContext(context) {
            this.context = context;
        }
    }, {
        key: 'idAttribute',
        get: function get() {
            return 'id';
        }
    }, {
        key: 'isPlaceholder',
        get: function get() {
            return this.get('placeholder');
        }
    }]);

    function Title(model, options, context) {
        _classCallCheck(this, Title);

        var _ref = options || {},
            patronItems = _ref.patronItems;

        var _this = _possibleConstructorReturn(this, (Title.__proto__ || Object.getPrototypeOf(Title)).call(this, model, options));

        _this.setContext(context);

        _this.set(_.extend({}, model, { titleState: _this._getState(patronItems) }));
        if (!_this.isPlaceholder) {
            _this.link(window.globalEvents);
        }
        return _this;
    }

    _createClass(Title, [{
        key: 'link',
        value: function link(bus) {
            var _this2 = this;

            // Unlink the old bus if there is one
            if (this.bus) {
                this.stopListening(this.bus, 'title:update');
                this.bus = null;
            }

            // Attach new bus if passed
            if (bus) {
                this.bus = bus;
                this.listenTo(this.bus, 'title:update', function (titleModel) {
                    _this2._applyUpdates(titleModel);
                });
            }

            return this;
        }
    }, {
        key: '_applyUpdates',
        value: function _applyUpdates(titleModel) {
            if (titleModel !== this && titleModel.id === this.id) {
                _get(Title.prototype.__proto__ || Object.getPrototypeOf(Title.prototype), 'set', this).call(this, titleModel.changedAttributes());
            }
        }
    }, {
        key: 'set',
        value: function set() {
            _get(Title.prototype.__proto__ || Object.getPrototypeOf(Title.prototype), 'set', this).apply(this, arguments);
            this.bus && this.bus.trigger('title:update', this);
        }

        // An example of this can be seen in CollectionHightlight.js:61 (where TitleCollectionView gets new'ed up)

    }, {
        key: 'updatePatronState',
        value: function updatePatronState(patronItems) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            this.set({
                titleState: this._getState(patronItems),
                wishlistState: _TitleState2['default'].isOnWishlist(this.attributes, patronItems) ? 'wishlistRemove' : 'wishlistAdd',
                userStarRating: _TitleState2['default'].starRating(this.attributes, patronItems) // 0 if not rated
            }, options);
            var readingHistoryState = _TitleState2['default'].isOnReadingHistory(this.attributes, patronItems);
            this.set('isInHistory', readingHistoryState, options || {});

            var userStarRating = _TitleState2['default'].starRating(this.attributes, patronItems);
            this.set('userStarRating', userStarRating, options || {}); // 0 if not rated
        }
    }, {
        key: 'getCover',
        value: function getCover(desiredSize) {
            var covers = _.map(this.get('covers'), function (cover) {
                return cover;
            }); // maps to collection of covers
            var coversBySize = _.sortBy(covers, 'width'); // coversBySize is now an array of covers, from smallest to largest


            // Start with the biggest cover
            // Copy object with Object.assign() so we dont damage reference
            var optimizedCover = Object.assign({}, _.last(covers));

            // if this image opto stuff catches on we'll figure out a way
            // to get cleaner image urls, which will make this all much
            // simpler
            if (optimizedCover && optimizedCover.href) {
                var legacyImageHost = 'https://img1.od-cdn.com/';
                var optimizedImageHost = 'https://ic.od-cdn.com/';
                var optimizedUrl = optimizedCover.href.replace(legacyImageHost, optimizedImageHost);

                // format=auto -> use webp if the device supports it
                var optimizations = 'quality=80&w=' + desiredSize;
                var queryString = (optimizedUrl.indexOf('?') < 0 ? '?' : '&') + optimizations;
                optimizedCover.href = optimizedUrl + queryString;

                return optimizedCover;
            }

            var smallestCoverThatIsBigEnough = _.find(coversBySize, function (cover) {
                return cover.width >= desiredSize;
            }) || _.last(covers); // finds the first cover that is big enough
            return smallestCoverThatIsBigEnough;
        }
    }, {
        key: 'getCoverSrc',
        value: function getCoverSrc(desiredSize) {
            var cover = this.getCover(desiredSize);
            return cover && cover.href || '/public/img/no-cover_en_US.jpg';
        }
    }, {
        key: 'getCurrentAvailability',
        value: function getCurrentAvailability() {
            return $.ajax({
                url: window.url(window.routes.mediaAvailabilityId, { id: this.id }),
                type: 'GET',
                timeout: 0
            });
        }
    }, {
        key: 'getMissingAttribute',
        value: function getMissingAttribute(attribute) {
            var _this3 = this;

            if (!this._mediaInterface) {
                this._mediaInterface = new _MediaInterface2['default']();
            }
            return this._mediaInterface.search({ titleId: this.get('id') }).then(function (response) {
                _this3.set(attribute, response[attribute]);
                return Promise.resolve();
            });
        }
    }, {
        key: 'availabilityText',
        value: function availabilityText() {
            var action = this.get('titleState');
            var availabilityText = '';

            switch (action) {
                case 'recommend':
                    availabilityText = window.html('availabilityNotOwned');
                    break;
                case 'recommended':
                    availabilityText = window.html('recommended');
                    break;
                case 'unavailable':
                    availabilityText = window.html('availabilityUnavailable');
                    break;
                case 'nook':
                    availabilityText = window.html('availabilityAvailable');
                    break;
                case 'borrow' || 'preview':
                    availabilityText = window.html('availabilityAvailable');
                    break;
                case 'borrowed':
                case 'addToApp':
                case 'listenNow':
                case 'readNow':
                    availabilityText = window.html('borrowed');
                    break;
                case 'hold':
                    if (this.get('isPreReleaseTitle')) {
                        availabilityText = window.html('availabilityComingSoon');
                        break;
                    }

                    availabilityText = this.get('isPreReleaseTitle') ? window.html('availabilityComingSoon') : window.html('availabilityWaitList');
                    break;
                case 'onHold':
                    availabilityText = window.html('onHold');
                    break;
                case 'waiting':
                    availabilityText = window.html('loading');
                    break;
            }

            return availabilityText;
        }
    }, {
        key: '_getState',
        value: function _getState(patronItems) {
            this.setPatronState(patronItems);
            return _TitleState2['default'].getState(this.attributes, patronItems);
        }
    }, {
        key: 'setPatronState',
        value: function setPatronState(patronItems) {
            this.set({ isOnHold: patronItems && patronItems.onHolds.indexOf(this.id) > -1 });
            this.set({ isBorrowed: patronItems && patronItems.onCheckouts.indexOf(this.id) > -1 });
            this.set({ isRecommended: patronItems && patronItems.recommendedToLibrary.indexOf(this.id) > -1 });
        }
    }, {
        key: 'sanitizedDesc',
        value: function sanitizedDesc() {
            var desc = this.get('description').replace(/(<br\s*[\/]?>)|(\r?\n|\r)/gim, ' ');
            return $('<div>' + desc + '</div>').text();
        }
    }, {
        key: 'getTitleAsync',
        value: function getTitleAsync(mediaId, resolve, reject) {
            var _this4 = this;

            $.ajax({
                url: window.url(window.routes.mediaInfoId, { id: mediaId }),
                type: 'GET',
                timeout: 10000,
                success: function success(data) {
                    _this4.set(data);
                    _this4.set('titleState', _this4._getState(null));
                    resolve();
                },
                fail: function fail(err) {
                    reject(err);
                }
            });
        }
    }, {
        key: 'contextCollectionId',
        get: function get() {
            return this.context && this.context.collectionDefinition ? this.context.collectionDefinition.id : undefined;
        }
    }, {
        key: 'titleDetailsUrl',
        get: function get() {
            // LHTNG-3018 Reference optional contextCollectionId value when creating a title details link
            var props = { id: this.id };

            if (this.contextCollectionId) {
                props.cid = this.contextCollectionId;
            }

            return window.url(window.routes.mediaId, props);
        }
    }, {
        key: 'hasLuckyDayCopies',
        get: function get() {
            return window.featureManager.isEnabled('LuckyDay') && this.get('luckyDayOwnedCopies') > 0;
        }
    }, {
        key: 'allCopiesAreLuckyDay',
        get: function get() {
            return this.hasLuckyDayCopies && this.get('ownedCopies') === 0;
        }
    }, {
        key: 'isLuckyDayCheckout',
        get: function get() {
            return this.hasAvailableLuckyDayCopies && this.get('availableCopies') === 0 && !this.get('isReleasedHold');
        }
    }, {
        key: 'canPlaceHold',
        get: function get() {
            return this.get('isHoldable') && !this.get('isOnHold') && window.featureManager.isEnabled('content-holds');
        }
    }, {
        key: 'isAvailable',
        get: function get() {
            return this.get('isAvailable') || this.hasAvailableLuckyDayCopies;
        }
    }, {
        key: 'hasAvailableLuckyDayCopies',
        get: function get() {
            return this.hasLuckyDayCopies && this.get('luckyDayAvailableCopies') > 0;
        }
    }, {
        key: 'isMagazine',
        get: function get() {
            return this.get('type').id === 'magazine';
        }
    }]);

    return Title;
}(Backbone.Model);

exports['default'] = Title;

},{"../../../title-actions/TitleState":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\TitleState.js","../MediaInterface":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\MediaInterface.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\models\\TitleCollection.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Title = require('./Title');

var _Title2 = _interopRequireDefault(_Title);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TitleCollection = function (_Backbone$Collection) {
    _inherits(TitleCollection, _Backbone$Collection);

    function TitleCollection() {
        _classCallCheck(this, TitleCollection);

        return _possibleConstructorReturn(this, (TitleCollection.__proto__ || Object.getPrototypeOf(TitleCollection)).apply(this, arguments));
    }

    _createClass(TitleCollection, [{
        key: 'model',
        get: function get() {
            return _Title2['default'];
        }
    }]);

    return TitleCollection;
}(Backbone.Collection);

exports['default'] = TitleCollection;

},{"./Title":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\models\\Title.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\ContextMenu.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _window = window,
    html = _window.html,
    url = _window.url,
    routes = _window.routes;

exports['default'] = function (_ref) {
    var id = _ref.id,
        rid = _ref.rid,
        typeId = _ref.typeId,
        title = _ref.title,
        alignment = _ref.alignment,
        sampleHref = _ref.sampleHref,
        sampleText = _ref.sampleText,
        historyActionLabel = _ref.historyActionLabel,
        historyActionText = _ref.historyActionText,
        historyEnabled = _ref.historyEnabled,
        gaHistoryAction = _ref.gaHistoryAction,
        seriesSearchUrl = _ref.seriesSearchUrl;
    return '\n<div class="ContextMenu">\n    <div tabindex="0" class="ContextMenu-button js-context-button" data-media-id="' + id + '"\n         data-title="' + title + '"\n         data-dropdown="context-menu-' + id + '-' + rid + '"\n         data-options="align:' + alignment + '"\n         aria-controls="more-actions-drop-' + id + '"\n         aria-expanded="false"\n         aria-label="' + html('cover.titleInfo', { title: title }) + '"\n         role="button">\n        <i class="icon icon-more" tabindex="-1"></i>\n    </div>\n\n    <ul id="context-menu-' + id + '-' + rid + '" class="ContextMenu-drop js-context-drop f-dropdown text-left" data-dropdown-content aria-hidden="false" tabindex="-1" role="list" aria-haspopup="true">\n        ' + (sampleHref !== '' ? '\n            <li class="read-sample ContextMenu-item">\n                <a data-href="' + sampleHref + '" data-media-id="' + id + '" data-title="' + title + '"\n                   data-of-dropdown="more-actions-drop-' + id + '" data-type="' + typeId + '"\n                   tabindex="-1" href="javascript:void(0)" aria-label="' + html('cover.sampleLabel', { sample: sampleText, title: title }) + '">\n                    ' + sampleText + '\n                </a>\n            </li>' : '') + '\n        <li class="ContextMenu-item">\n            <a tabindex="-1" href="' + url(routes.mediaId, { id: id }) + '" aria-label="' + html('viewDetailsAboutTitle', { title: title }) + '">' + html('viewDetails') + '</a>\n        </li>\n        ' + (seriesSearchUrl ? '\n            <li class="ContextMenu-item"><a tabindex="-1" href="' + seriesSearchUrl + '">' + html('viewSeries') + '</a></li>' : '') + '\n        ' + (historyEnabled ? '<li class="ContextMenu-item js-historyAction" data-ga-action="' + gaHistoryAction + '" data-media-id="' + id + '"><a tabindex="-1" role="button" aria-label="' + historyActionLabel + '">' + historyActionText + '</a></li>' : '') + '\n        <li class="ContextMenu-item"><a tabindex="-1" href="' + url(routes.mediaRelatedId, { id: id }) + '" aria-label="' + html('viewRelatedToTitle', { title: title }) + '">' + html('youMayAlsoLike') + '</a></li>\n    </ul>\n</div>';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\Cover.html.js":[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports["default"] = function (_ref) {
    var media = _ref.media,
        src = _ref.src,
        href = _ref.href,
        coverColor = _ref.coverColor,
        noSampleClass = _ref.noSampleClass;
    return "\n<div class=\"CoverImageContainer\" style=\"background-color: " + coverColor + "\">\n    <a href=\"" + href + "\"\n           tabindex=\"-1\"\n           data-href    =\"" + href + "\"\n           data-media-id=\"" + media.id + "\"\n           data-title   =\"" + media.title + "\"\n           data-type    =\"" + media.type.id + "\">\n        <img\n            tabindex=\"-1\"\n            aria-label=\"" + media.title + " - " + html(media.type.id) + "\"\n            tabindex=\"0\"\n            class=\"large-title js-details-cover-image " + noSampleClass + "\"\n            src=\"" + src + "\"\n            srcset=\"" + src + "&dpr=2 2x,\n                    " + src + "&dpr=1.5 1.5x,\n                    " + src + " 1x\"\n            alt=\"" + media.title + " - " + html(media.type.id) + "\"\n            style=\"background-color: " + coverColor + "; max-height: none !important;\"/>\n    </a>\n</div>";
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\DownloadWarningModal.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function (_ref) {
    var message = _ref.message,
        downloadUrl = _ref.downloadUrl;
    return '\n    <p data-msg>\n        ' + message + '\n    </p>\n    <div class="button-container">\n        <a data-download-confirm data-cancel href="' + downloadUrl + '" role="button" class="button margin-small radius secondary contrast u-allCaps confirm " aria-label="' + html('confirm') + '">' + html('confirm') + '</a>\n        <button type="button" data-cancel class="button radius margin-small outline gray cancel u-allCaps ">' + html('cancel') + '</button>\n    </div>\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\HoldConflictPanel.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _window = window,
    html = _window.html;

exports['default'] = function (_ref) {
    var heading = _ref.heading,
        src = _ref.src,
        isLuckyDay = _ref.isLuckyDay,
        useNewPopover = _ref.useNewPopover;
    return '\n    <div id="now-unavailable-modal-title" class="title-text">\n        <div class="now-unavailable-text">' + heading + '\n            ' + (isLuckyDay ? useNewPopover ? '<div style="display: inline-block; position: relative">\n                        <div style="display: inline-block; float: right">\n                            <a role="button" id="luckyDayTooltip" class="help-tip secondary-background" style="float: right"></a>\n                        </div>\n                    </div>' : '<div style="display: inline-block; position: relative">\n                        <div style="display: inline-block; float: right">\n                            <a role="button" data-dropdown="luckyDay-help-tip" aria-controls="luckyDay-help-tip" tabindex="0" class="help-tip secondary-background luckyDay-help-tip" style="float: right"></a>\n                        </div>\n                    </div>\n                    <div id="luckyDay-help-tip" data-dropdown-content class="f-dropdown medium content" aria-hidden="true" tabindex="-1">\n                        <p>' + html('nowUnavailableModal.luckyDayInfo') + '</p>\n                    </div>' : '') + '\n        </div>\n    </div>\n\n    <div class="img-container">\n        <img data-id="cover-image" src="' + src + '" alt="' + html('coverImage') + '"/>\n    </div>\n\n    <div class="medium-8 medium-centered columns button-container">\n        <span class="TitleAction" />\n        <button type="button" class="button js-cancel cancel radius u-allCaps outline gray">' + html('cancel') + '</button>\n    </div>\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\HoldSuccessRelatedTitles.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function (_ref) {
    var titleModel = _ref.titleModel;
    return '\n    <div class="HoldSuccessModal-relatedTitlesPrompt" tabindex="0">' + window.html('holdSuccessModal.wantToBorrowSubheading') + '</div>\n\n    <section class="relatedTitles"></section>\n\n    <div class="HoldSuccessModal-callToActionContainer">\n        <a class="button radius HoldSuccessModal-callToAction" href="' + window.url(window.routes.mediaRelatedId, { id: titleModel.id }) + '" tabindex="0">' + window.html('holdSuccessModal.showMore') + '</a>\n    </div>\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\NoCover.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function (_ref) {
    var media = _ref.media,
        href = _ref.href,
        isInHero = _ref.isInHero,
        coverWidth = _ref.coverWidth,
        coverHeight = _ref.coverHeight,
        creatorText = _ref.creatorText;
    return '\n<div class="CoverImageContainer">\n<a class="CoverImageContainer noCoverAvailable ' + (isInHero ? 'secondary-background' : 'primary-background') + '"\n    href="' + href + '"\n    tabindex="-1"\n    data-href    ="' + href + '"\n    data-media-id="' + media.id + '"\n    data-title   ="' + media.title + '"\n    data-type    ="' + media.type.id + '">\n        <div class="title ' + (isInHero ? 'secondary-font-highlight-box' : 'primary-font primary-font-highlight-box') + '">' + media.title + '</div>\n        <div class="author ' + (isInHero ? '' : 'primary-font') + '">' + creatorText + '</div>\n\n        <img\n            tabindex="-1"\n            aria-label="' + media.title + ' - ' + html(media.type.id) + '"\n            tabindex="0"\n            class="large-title js-details-cover-image"\n            src="' + (window.OverDrive.cdn + '/public/img/clear.gif') + '"\n            alt="' + media.title + ' - ' + html(media.type.id) + '"\n            />\n\n</a>\n</div>\n\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\PlaceHoldPanel.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _window = window,
    html = _window.html,
    text = _window.text;

exports['default'] = function (_ref) {
    var title = _ref.title,
        type = _ref.type,
        coverSrc = _ref.coverSrc,
        id = _ref.id,
        isPreReleaseTitle = _ref.isPreReleaseTitle,
        prereleaseDate = _ref.prereleaseDate,
        ownedCopies = _ref.ownedCopies,
        libraryName = _ref.libraryName,
        isRequestAgain = _ref.isRequestAgain;
    return '\n<div class="large-12 columns no-padding-left">\n    <h2>' + title + '</h2>\n    <span class="title-format-badge"><i class="icon-' + type.id + '"></i> <span>' + html(type.id) + '</span></span>\n</div>\n\n<div class="medium-4 columns no-padding-left">\n    <img data-id="cover-image" src="' + coverSrc + '" alt="' + html('coverImage') + '"/>\n</div>\n\n<form id="hold-dynamic-form-' + id + '" data-abide="ajax" data-media-id="' + id + '">\n    <div class="medium-8 columns">\n        ' + (!isPreReleaseTitle ? '' : '<p class="header-xxxsmall prerelease text-red modal">' + text('prereleaseLabel', { prereleaseDate: prereleaseDate }) + '</p>') + '\n        <p id="hold-modal-label" class="js-dialog-label">\n            ' + (ownedCopies === 0 ? html('holdsRatioHelpModal.noCopiesText') : isRequestAgain ? html('requestAgainModal.requestAgainDesc', { libraryName: libraryName }) : html('dynamicHoldModal.placeHoldDesc', { libraryName: libraryName })) + '\n        </p>\n\n        <label>\n            <input data-first-focus type="email" id="email-dynamic-' + id + '" class="patron-hold-email-dynamic js-first-focus" autofocus placeholder="' + html('emailAddress') + '" title="' + html('emailAddress') + '" aria-label="' + html('emailAddress') + '" aria-labelledby="hold-modal-label" required />\n        </label>\n        <small class="error">' + html('emailRequiredError') + '.</small>\n\n        <label>\n            <input type="email" id="email-conf-dynamic-' + id + '" class="patron-hold-email-conf-dynamic js-email-confirm" placeholder="' + html('confirmEmail') + '" title="' + html('confirmEmail') + '" aria-label="' + html('confirmEmail') + '" required data-equalto="email-dynamic-' + id + '" />\n        </label>\n        <small class="error">' + html('emailsMustMatchError') + '</small>\n    </div>\n    <div class="clear" />\n\n    <div class="button-container js-buttons">\n        <span class="TitleAction" />\n        <button type="button" class="button cancel radius margin-small u-allCaps outline gray js-close">' + html('cancel') + '</button>\n    </div>\n    <div class="clear" />\n</form>';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\RemoveHistory.html.js":[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports["default"] = function (_ref) {
    var text = _ref.text,
        ariaLabel = _ref.ariaLabel,
        removeButton = _ref.removeButton,
        cancelButton = _ref.cancelButton;
    return "\n        <p>" + text + "</p>\n    \n        <div class=\"button-container\">\n            <button type=\"button\" data-remove aria-label=\"" + ariaLabel + "\" class=\"js-remove-history button margin-small radius secondary contrast u-allCaps\">\n                <span>" + removeButton + "</span>\n            </button>\n            <button type=\"button\" data-cancel data-reveal-id=\"history-modal\" class=\"button radius margin-small outline gray cancel u-allCaps js-cancel\" tabindex=\"0\">" + cancelButton + "</button>\n        </div>\n";
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\RtlLimitModal.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _window = window,
    html = _window.html;

exports['default'] = function (_ref) {
    var nextRecommendation = _ref.nextRecommendation;
    return '\n        <p>' + html('accountLimitsPanel.rtlNoneRemaining', { time: nextRecommendation }) + '</p>\n    \n        <div class="button-container">\n            <button type=\'button\' class=\'confirm-button button radius secondary contrast u-allCaps\'>' + html('ok') + '</button>\n        </div>\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\RtlPanel.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _window = window,
    html = _window.html;

exports['default'] = function (_ref) {
    var coverSrc = _ref.coverSrc,
        title = _ref.title,
        author = _ref.author,
        type = _ref.type,
        hideEmail = _ref.hideEmail,
        patronEmail = _ref.patronEmail,
        csrfToken = _ref.csrfToken,
        rid = _ref.rid;
    return '\n<div class="row">\n    <div class="small-4 columns no-padding-left no-padding-right">\n        <img src="' + coverSrc + '" alt="' + html('coverImage') + '"/>\n    </div>\n\n    <div class="small-8 columns RecommendModal-titlebox-left-padding no-padding-right">\n        <h2 class="RecommendModal-title">' + title + '</h2>\n        <h3 class="RecommendModal-author js-recommend-modal-author">' + author + '</h3>\n\n        <span class="title-format-badge RecommendModal-formatBadge"><i class="icon-' + type.id + '"></i> <span tabindex="0"></span>' + window.html(type.id) + '</span>\n    </div>\n</div>\n<form id="recommend-dynamic-form" class="js-recommendations-form" data-abide="ajax">\n    <div class="row RecommendModal-inputContainer">\n\n        <p class="RecommendModal-label" tabindex="0">\n            ' + html('recommendToLibraryModal.onHoldIfPurchased') + '\n        </p>\n\n        <div>\n            <input id="email-dynamic-recommend-' + rid + '" class="RecommendModal-emailInput ' + hideEmail + ' js-recommend-email" placeholder="' + html('emailAddress') + '" title="' + html('emailAddress') + '" aria-label="' + html('emailAddress') + '"  value="' + patronEmail + '" type="email" pattern="email" required />\n            <small class="error">' + html('emailRequiredError') + '</small>\n        </div>\n        <div>\n            <input id="email-conf-dynamic-recommended-' + rid + '" class="RecommendModal-emailInput ' + hideEmail + ' js-recommend-email" placeholder="' + html('confirmEmail') + '" title="' + html('confirmEmail') + '" aria-label="' + html('confirmEmail') + '" value="' + patronEmail + '" type="email" pattern="email"  required data-abide-validator="required equalto email" data-validator-equalto="email-dynamic-recommend-' + rid + '" />\n            <small class="error">' + html('emailsMustMatchError') + '</small>\n        </div>\n        <span class="RecommendModal-noGuarantee">' + html('recommendSuccessModal.successMessageNoGuarantee') + '</span>\n    </div>\n    <div class="clear" />\n\n    <div class="button-container">\n        <span class="TitleAction" />\n        <button type="button" class="button cancel radius margin-small u-allCaps outline gray js-close">' + html('cancel') + '</button>\n    </div>\n    <div class="clear" />\n\n    <input type="hidden" class="js-recommend-csrf" id="csrf" name="_csrf" value="' + csrfToken + '">\n</form>\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\TitleCard.html.js":[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports["default"] = function () {
    return "\n<div class=\"title-contents card TitleCard\">\n    <div class=\"TitleHeaderBar\"></div>\n\n    <div class=\"CoverImage\"></div>\n\n    <div class=\"InfoPanel\">\n        <div class=\"TitleInfo\"></div>\n\n        <div class=\"TitleAction is-grid\"></div>\n\n        <div class=\"TitleWishlist is-grid\"></div>\n    </div>\n\n    <div class=\"clear\" />\n</div>";
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\TitleFormatBadge.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function (_ref) {
    var typeId = _ref.typeId;
    return '\n' + (typeId ? '\n    <span class="title-format-badge contrast u-allCaps"><i class="icon-' + typeId + '"></i>' + window.html(typeId) + '</span>\n' : '') + '\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\TitleName.html.js":[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports["default"] = function (_ref) {
    var titleId = _ref.titleId,
        title = _ref.title,
        href = _ref.href,
        ariaLabel = _ref.ariaLabel;
    return "<h3 title=\"" + title + "\" class=\"title-name\" data-media-id=\"" + titleId + "\" tabindex=\"-1\">\n    <a tabindex=\"0\" href=\"" + href + "\" role=\"link\" aria-label=\"" + ariaLabel + "\">\n        " + title + "\n    </a>\n</h3>";
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\WishListButton.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function (_ref) {
    var ga = _ref.ga,
        contrastClass = _ref.contrastClass,
        ariaLabel = _ref.ariaLabel,
        iconClass = _ref.iconClass,
        text = _ref.text;
    return '\n<button ' + (ga ? 'data-ga-track="wishlist" data-ga-mediaID="' + ga.mediaId + '" data-ga-type=' + ga.formatType : '') + '\nclass="WishListButton ' + contrastClass + '" \ntype="button" \naria-label="' + ariaLabel + '">\n    <i class="' + iconClass + ' icon animated bounceIn" aria-hidden="true"></i>\n    ' + (text ? '<span class="u-allCaps WishListButton-text">' + text + '</span>' : '') + '\n</button>';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\DownloadWarningModal.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _modal = require('../../common/modal');

var _DownloadWarningModal = require('../templates/DownloadWarningModal.html');

var _DownloadWarningModal2 = _interopRequireDefault(_DownloadWarningModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var featureManager = window.featureManager;

var _window$OverDrive = window.OverDrive,
    _locale = _window$OverDrive._locale,
    supportArticles = _window$OverDrive.supportArticles;
var _window = window,
    Cookies = _window.Cookies;


var device = detectshun.browser();
var isMac = !!(window.navigator.userAgent.match(/Mac/) && !device.ios);
var isWindows = !!(window.navigator.platform.match(/Win/) && !device.bowser.windowsphone);
var isWindows8AndUp = !!window.navigator.userAgent.match(/(Windows 10.0|Windows NT 10.0|Windows 8.1|Windows NT 6.3|Windows 8|Windows NT 6.2)/);
var inApp = Cookies.get('omcbrowse') !== undefined;
var isWindowsPhone10AndUp = !!(device.bowser.windowsphone && device.bowser.osversion >= 10.0);
var isWindowsPhone8 = !!(device.bowser.windowsphone && device.bowser.osversion < 10.0);

var DownloadWarningModal = function (_Backbone$View) {
    _inherits(DownloadWarningModal, _Backbone$View);

    function DownloadWarningModal() {
        _classCallCheck(this, DownloadWarningModal);

        return _possibleConstructorReturn(this, (DownloadWarningModal.__proto__ || Object.getPrototypeOf(DownloadWarningModal)).apply(this, arguments));
    }

    _createClass(DownloadWarningModal, [{
        key: 'initialize',
        value: function initialize(el) {
            var _this2 = this;

            var format = el.data('format-id');
            var mediaId = el.data('mediaId');

            var warning = this.getWarning(format);
            var downloadUrl = window.url(window.routes.mediaDownload, { format: format, mediaId: mediaId });

            if (warning !== '' && !this.isWarningCookieSet(warning)) {
                var viewData = { message: this.warningText(warning), downloadUrl: downloadUrl };

                var content = $((0, _DownloadWarningModal2['default'])(viewData));

                this.modal = new _modal.Modal({
                    title: html('downloadWarningModal.heading'),
                    content: content
                });

                this.modal.show();

                this.modal.$el.find('.cancel').on('click', function () {
                    _this2.modal.close();
                });
                this.modal.$el.find('.confirm').on('click', function () {
                    _this2.setWarningCookie(warning);
                    _this2.modal.close();
                });
            } else if (format === 'ebook-media-do') {
                window.open(downloadUrl, '_blank');
            } else {
                // if no warning needs displayed, download title
                window.location.href = downloadUrl;
            }
        }
    }, {
        key: 'warningText',
        value: function warningText(warning) {
            switch (warning) {
                case 'ODapp':
                    return html('downloadWarningModal.required', { link: '<a href="http://app.overdrive.com/" target="_blank" class="modal-link" aria-label="' + html('overdriveApp') + '" role="link">' + html('overdriveApp') + '</a>' });
                case 'ADE':
                    return html('downloadWarningModal.required', { link: '<a href="http://www.overdrive.com/partners/redirects.aspx?product=adobede"' + ' target="_blank" class="modal-link" aria-label="Adobe Digital Editions" role="link">Adobe Digital Editions</a>' });
                case 'ADE-ODapp':
                    return html('downloadWarningModal.odAppOrAdobeRequired', { link1: '<a href="https://www.microsoft.com/en-us/store/apps/overdrive-library-ebooks-audiobooks/9wzdncrfj3sr" target="_blank" class="modal-link" aria-label="' + html('overdriveApp') + '" role="link">' + html('overdriveApp') + '</a>',
                        link2: '<a href="http://www.overdrive.com/partners/redirects.aspx?product=adobede" target="_blank" class="modal-link" aria-label="Adobe Digital Editions" role="link">Adobe Digital Editions</a>' });
                case 'ODapp-epub':
                    return html('downloadWarningModal.epubRequired', { link: '<a href="http://app.overdrive.com/" target="_blank" class="modal-link" aria-label="' + html('overdriveApp') + '" role="link">' + html('overdriveApp') + '</a>' });
                case 'video':
                    return html('downloadWarningModal.youMayNeedOdApp', { link: '<a href="http://app.overdrive.com/" target="_blank" class="modal-link" aria-label="' + html('overdriveApp') + '" role="link">' + html('overdriveApp') + '</a>' });
                case 'msedge':
                    return html('downloadWarningModal.mayWorkOnDiffBrowser', { link1: '<a href="https://www.microsoft.com/en-us/download/internet-explorer.aspx" target="_blank" class="modal-link" aria-label="' + html('downloadWarningModal.downloadBrowser', { browser: 'Internet Explorer' }) + '" role="link">Internet Explorer</a>',
                        link2: '<a href="http://www.google.com/chrome/" target="_blank" class="modal-link" aria-label="' + html('downloadWarningModal.downloadBrowser', { browser: 'Chrome' }) + '" role="link">Chrome</a>' });
                case 'ODread':
                    return html('downloadWarningModal.messageForODRead');
                case 'Libby':
                    return html('downloadWarningModal.libbyRequired', { link: '<a href= "https://meet.libbyapp.com/" target="_blank" class="modal-link" aria-label="' + html('libby.libbyApp') + '" role="link">' + html('libby.libbyApp') + '</a>' });
                case 'notSupported':
                    return html('downloadWarningModal.notSupported', { link: '<a href="' + window.supportUrl(_locale, supportArticles.noWindowsPhoneSupport) + '" target="_blank" class="modal-link" aria-label="' + html('narratedModal.learnMore') + '" role="link">' + html('narratedModal.learnMore') + '</a>' });
            }
        }
    }, {
        key: 'getWarning',
        value: function getWarning(format) {
            var warning = '';
            if (format === 'ebook-epub-adobe') {
                if (isMac) {
                    warning = 'ADE';
                } else if (isWindows && !inApp) {
                    if (isWindows8AndUp) {
                        warning = 'ADE-ODapp';
                    } else {
                        warning = 'ADE';
                    }
                } else if ((device.ios || device.android) && !inApp) {
                    warning = 'ODapp';
                } else if (isWindowsPhone10AndUp && !inApp) {
                    warning = 'Libby';
                } else if (isWindowsPhone8 && !inApp) {
                    warning = 'notSupported';
                }
            } else if (format === 'ebook-pdf-adobe' && (isMac || isWindows && !inApp)) {
                warning = 'ADE';
            } else if (format === 'ebook-epub-open') {
                if (isMac) {
                    warning = 'ADE';
                } else if (isWindows && !inApp) {
                    if (isWindows8AndUp) {
                        warning = 'ADE-ODapp';
                    } else {
                        warning = 'ADE';
                    }
                } else if ((device.ios || device.android) && !inApp) {
                    warning = 'ODapp-epub';
                } else if (isWindowsPhone10AndUp && !inApp) {
                    warning = 'Libby';
                } else if (isWindowsPhone8 && !inApp) {
                    warning = 'notSupported';
                }
            } else if (format === 'audiobook-mp3') {
                if ((device.ios || device.android) && !inApp || isMac || isWindows && !inApp) {
                    warning = 'ODapp';
                } else if (isWindowsPhone10AndUp && !inApp) {
                    warning = 'Libby';
                } else if (isWindowsPhone8 && !inApp) {
                    warning = 'notSupported';
                }
            }
            return warning;
        }
    }, {
        key: 'isWarningCookieSet',
        value: function isWarningCookieSet(warning) {
            var cookie = Cookies.get('no-device-warning');
            if (cookie === undefined) {
                return false;
            } else {
                var arr = cookie.split(';');
                return arr.indexOf(warning) > -1;
            }
        }
    }, {
        key: 'setWarningCookie',
        value: function setWarningCookie(warning) {
            var cookie = Cookies.get('no-device-warning');
            if (cookie === undefined) {
                Cookies.set('no-device-warning', warning + ';', { path: '/', expires: 365, overwrite: true });
            } else {
                Cookies.set('no-device-warning', cookie + warning + ';', { path: '/', expires: 365, overwrite: true });
            }
        }
    }]);

    return DownloadWarningModal;
}(Backbone.View);

exports['default'] = DownloadWarningModal;

},{"../../common/modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js","../templates/DownloadWarningModal.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\DownloadWarningModal.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\HoldConflictModal.js":[function(require,module,exports){
'use strict';

var _modal = require('../../common/modal');

var _TitleActionButton = require('../TitleActionButton');

var _TitleActionButton2 = _interopRequireDefault(_TitleActionButton);

var _HoldConflictPanel = require('../templates/HoldConflictPanel.html');

var _HoldConflictPanel2 = _interopRequireDefault(_HoldConflictPanel);

var _popover = require('../../../components/popover/popover');

var _popover2 = _interopRequireDefault(_popover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Backbone = window.Backbone;

var HoldConflictModal = Backbone.View.extend({
    initialize: function initialize(bus, titleModel) {
        var _this = this;

        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        this.bus = bus;

        var useNewPopover = window.featureManager.isEnabled('LHTNG-3592');
        var viewData = {
            heading: window.html(!!options.isLuckyDay ? 'nowUnavailableModal.luckyDayNotAvailableHtml' : 'nowUnavailableModal.isNotCurrentlyAvailableHtml', { span: '<span>' + titleModel.get('title') + '</span>' }),
            src: titleModel.getCoverSrc(510),
            isLuckyDay: !!options.isLuckyDay,
            useNewPopover: useNewPopover
        };

        var modalContents = {
            autoShow: false,
            title: window.html('nowUnavailableModal.heading'),
            classes: ['now-unavailable-modal'],
            content: (0, _HoldConflictPanel2['default'])(viewData),
            id: 'now-unavailable-modal',
            labelledBy: 'now-unavailable-modal-title'
        };
        this.modal = new _modal.Modal(modalContents);

        this.modal.$('.js-cancel').on('click', function () {
            _this.modal.close();
        });

        this.listenTo(this.bus, 'title:hold:fail', function () {
            _this.modal.close();
        });

        this.titleActionButton = new _TitleActionButton2['default']({ model: titleModel, type: 'button', el: this.modal.$('.TitleAction'), style: 'fill' });

        this.modal.show();

        if (options.isLuckyDay && useNewPopover) {
            this.ldtooltip = new _popover2['default']({
                target: this.modal.$el.find('#luckyDayTooltip'),
                contents: '<p>' + html('nonHoldConflictModal.luckyDayInfo') + '</p>'
            });
        }
    }
});

module.exports = HoldConflictModal;

},{"../../../components/popover/popover":"C:\\projects\\lightning\\public\\ecmascript\\components\\popover\\popover.js","../../common/modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js","../TitleActionButton":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleActionButton.js","../templates/HoldConflictPanel.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\HoldConflictPanel.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\HoldModal.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _modal = require('../../common/modal');

var _PlaceHoldPanel = require('./PlaceHoldPanel');

var _PlaceHoldPanel2 = _interopRequireDefault(_PlaceHoldPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HoldModal = function (_Backbone$View) {
    _inherits(HoldModal, _Backbone$View);

    function HoldModal(_ref) {
        var bus = _ref.bus,
            titleModel = _ref.titleModel,
            context = _ref.context;

        _classCallCheck(this, HoldModal);

        var _this = _possibleConstructorReturn(this, (HoldModal.__proto__ || Object.getPrototypeOf(HoldModal)).apply(this, arguments));

        _this.bus = bus;

        _this.placeHoldPanel = new _PlaceHoldPanel2['default']({ bus: bus, titleModel: titleModel, context: context, isRequestAgain: !!context.isRequestAgain });

        _this.modal = new _modal.Modal({
            autoShow: false,
            title: window.html('dynamicHoldModal.placeAHold'),
            classes: ['small', 'HoldModal'],
            content: _this.placeHoldPanel.$el,
            firstFocus: _this.placeHoldPanel.$el.find('.js-first-focus')
        });

        _this.modal.show();

        _this.listenTo(_this.bus, 'title:hold:end', function () {
            _this.modal.close();
        });
        return _this;
    }

    return HoldModal;
}(Backbone.View);

exports['default'] = HoldModal;

},{"../../common/modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js","./PlaceHoldPanel":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\PlaceHoldPanel.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\HoldSuccessModal.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TitleCard = require('../TitleCard');

var _TitleCard2 = _interopRequireDefault(_TitleCard);

var _TitleCollection = require('../models/TitleCollection');

var _TitleCollection2 = _interopRequireDefault(_TitleCollection);

var _TitleCollectionView = require('../TitleCollectionView');

var _TitleCollectionView2 = _interopRequireDefault(_TitleCollectionView);

var _HoldInformation = require('../../holdInformation/views/HoldInformation');

var _HoldInformation2 = _interopRequireDefault(_HoldInformation);

var _modal = require('../../common/modal');

var _HoldSuccessRelatedTitles = require('../templates/HoldSuccessRelatedTitles.html');

var _HoldSuccessRelatedTitles2 = _interopRequireDefault(_HoldSuccessRelatedTitles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _window = window,
    featureManager = _window.featureManager,
    text = _window.text;


var path = require('path');
var containerTemplateHtml = "<h4 class=\"HoldSucessModal-mediaTitle\"> <%- titleModel.title %> </h4>\n<div class=\"HoldSuccessModal-author\" >\n    <%= text('byLine', {creator: '<a class=\"HoldSuccessModal-link\" href=\"' + creatorSearchUrl + '\" aria-label=\"' + html('cover.searchByAuthor', {author: titleModel.firstCreatorName}) +'\" > ' + titleModel.firstCreatorName + '</a>'}) %>\n</div>\n<div class=\"HoldSuccessModal-holdInfo\">\n    <%= holdsInfo %>\n</div>\n<div class=\"HoldSuccessModal-successMessage\">\n    <% if (ownedCopies !== 0) { %>\n        <%= html(successMessageTextKey, {email: email,\n        manageHoldsLink: '<a class=\"HoldSuccessModal-link\" href=\"' + manageHoldsUrl + '\">' + window.html('holdSuccessModal.manageHolds') + '</a>'}) %>\n    <% } %>\n</div>\n<div class=\"relatedTitlesContainer\">\n    <div class=\"loader\">&nbsp; </div>\n</div>\n";

var HoldSuccessModal = function (_Backbone$View) {
    _inherits(HoldSuccessModal, _Backbone$View);

    function HoldSuccessModal(_ref) {
        var bus = _ref.bus,
            titleModel = _ref.titleModel,
            email = _ref.email,
            autoCheckoutEnabled = _ref.autoCheckoutEnabled;

        _classCallCheck(this, HoldSuccessModal);

        var _this = _possibleConstructorReturn(this, (HoldSuccessModal.__proto__ || Object.getPrototypeOf(HoldSuccessModal)).call(this));

        _this.topLevelTemplate = _.template(containerTemplateHtml);

        _this.bus = bus;
        _this.titleModel = titleModel;
        _this.email = email;
        _this.autoCheckoutEnabled = autoCheckoutEnabled;
        _this.collection = new _TitleCollection2['default']();
        _this.collection.url = window.url(window.routes.rest.media.availableRelated, { id: titleModel.id }) + '?max=4';
        _this.ownedCopies = _this.titleModel.get('ownedCopies') || 0;

        _this.renderContainer();
        _this.$titleContainer = _this.$('.relatedTitlesContainer');

        var waypoint = new window.Waypoint.Inview({
            element: _this.$titleContainer,
            enter: function enter() {
                waypoint.destroy();
                _this.fetchRelatedTitles();
            }
        });

        var modalContents = {
            autoShow: false,
            title: html('genericSuccess'),
            classes: ['large, HoldSuccessModal'],
            content: _this.$el
        };

        _this.modal = new _modal.Modal(modalContents);
        _this.modal.show();

        return _this;
    }

    _createClass(HoldSuccessModal, [{
        key: 'fetchRelatedTitles',
        value: function fetchRelatedTitles() {
            var _this2 = this;

            this.collection.fetch().then(function (titles) {
                if (_(titles).isEmpty()) {
                    _this2.$titleContainer.empty();
                    return;
                }
                _this2.renderRelatedTitles();
            }).fail(function () {
                _this2.$titleContainer.empty();
            });
        }
    }, {
        key: 'getHoldInfoHtml',
        value: function getHoldInfoHtml() {
            if (featureManager.isEnabled('LHTNG-2863')) {
                var note = null;
                if (this.titleModel.get('isOwned') && !this.titleModel.get('ownedCopies')) {
                    note = '<span>' + text('holdsRatioHelpModal.noCopiesOnPlaceHold') + '<a class="manageHoldsLink" target="_blank" href="/account/holds">' + text('holdSuccessModal.manageHolds') + '</a></span>';
                } else if (this.titleModel.get('isFastlane')) {
                    note = text('expectedWaitTime.advantageCaveat');
                } else if (window.OverDrive.isVisitor) {
                    note = text('expectedWaitTime.rlaCaveat');
                }

                return '<p class="holdPosition">\n                        <span class="textLabel">' + text('expectedWaitTime.holdPositionLabel') + '</span>\n                        <span>' + text('accountHolds.holdListPosition', { holdListPosition: this.titleModel.get('holdListPosition'), ownedCopies: this.titleModel.get('ownedCopies') }) + '</span>\n                    </p>\n                    ' + (note ? '<p class="note"><span class="textLabel">' + text('note') + '</span><span>' + note + '</span></p>' : '');
            } else {
                var info = new _HoldInformation2['default']({ model: this.titleModel, type: 'successPosition' }).render();
                return info.$el.html();
            }
        }
    }, {
        key: 'renderRelatedTitles',
        value: function renderRelatedTitles() {

            this.$titleContainer.empty();
            this.$titleContainer.append((0, _HoldSuccessRelatedTitles2['default'])({ titleModel: this.titleModel.attributes }));

            this.titleCollectionView = new _TitleCollectionView2['default']({
                el: this.$titleContainer.find('.relatedTitles'),
                bus: this.bus,
                View: _TitleCard2['default'],
                attributes: { 'class': 'titleContainer small-block-grid-2 medium-block-grid-4 large-block-grid-4' },
                collection: this.collection,
                coverWidths: { mobile: 150, tablet: 185, desktop: 220 }
            });
        }
    }, {
        key: 'renderContainer',
        value: function renderContainer() {
            var searchByCreatorUrl = window.url(window.routes.searchByType, { type: 'creatorId', query: this.titleModel.get('firstCreatorId'), sortBy: 'newlyadded' });

            this.$el.append(this.topLevelTemplate({
                successMessageTextKey: this.autoCheckoutEnabled && !featureManager.isEnabled('holdRedelivery') ? 'toasts.holdSuccessAutoCheckoutHtml' : 'toasts.holdSuccessHtml',
                manageHoldsUrl: window.url(window.routes.accountHolds),
                email: this.email,
                titleModel: this.titleModel.attributes,
                creatorSearchUrl: searchByCreatorUrl,
                holdsInfo: this.getHoldInfoHtml(),
                ownedCopies: this.ownedCopies
            }));
        }
    }]);

    return HoldSuccessModal;
}(Backbone.View);

exports['default'] = HoldSuccessModal;


},{"../../common/modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js","../../holdInformation/views/HoldInformation":"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformation\\views\\HoldInformation.js","../TitleCard":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleCard.js","../TitleCollectionView":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleCollectionView.js","../models/TitleCollection":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\models\\TitleCollection.js","../templates/HoldSuccessRelatedTitles.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\HoldSuccessRelatedTitles.html.js","path":"C:\\projects\\lightning\\node_modules\\path-browserify\\index.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\NookEulaModal.js":[function(require,module,exports){
'use strict';

var _confirmDialog = require('../../common/confirmDialog');

var _confirmDialog2 = _interopRequireDefault(_confirmDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Backbone = window.Backbone;


var path = require('path');
var NookEulaTemplate = "<div class=\"row\">\n    <div class=\"large-12 columns\">\n        <img src=\"<%= CDN %>/public/img/bn-logo.jpg\" class=\"barnes-and-noble-logo\">\n    </div>\n</div>\n\n<div class=\"row\">\n    <div class=\"large-12 columns no-padding-left\">\n        <p tabindex=\"0\">\n            <%= html('nookEULAModal.textBody') %><br/><br/>\n\n            <%= html('nookEULAModal.freeNookAppExplanationHtml', {iosLink: '<a href=\"https://itunes.apple.com/us/app/NOOK/id373582546\" target=\"_blank\" class=\"modal-link\">iOS</a>',\n                androidLink: '<a href=\"https://play.google.com/store/apps/details?id=bn.ereader&hl=en\" target=\"_blank\" class=\"modal-link\">Android</a>',\n            windowsLink: '<a href=\"https://www.microsoft.com/en-us/store/apps/nook-books-magazines-newspapers-comics/9wzdncrfj33h\" target=\"_blank\" class=\"modal-link\">Windows 8</a>'}) %>\n        </p>\n    </div>\n</div>\n";

var NookEulaModal = Backbone.View.extend({
    template: _.template(NookEulaTemplate),

    initialize: function initialize(bus, titleModel) {
        var _this = this;

        this.bus = bus;

        var viewData = {
            CDN: window.OverDrive.cdn,
            html: window.html,
            text: window.text
        };

        this.$el.html(this.template(viewData));

        var modalContents = {
            autoShow: false,
            submitText: window.html('nookEULAModal.acceptToContinue'),
            title: window.html('sendToNook'),
            classes: ['small', 'NookEulaModal'],
            content: this.$el
        };

        this.modal = new _confirmDialog2['default'](modalContents);

        this.modal.show();

        this.modal.on('submit', function () {
            return _this.bus.trigger('title:nook:eula-accepted', { title: titleModel });
        });

        this.listenTo(this.bus, 'title:nook:end', function () {
            _this.modal.close();
        });
    }
});

module.exports = NookEulaModal;


},{"../../common/confirmDialog":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\confirmDialog.js","path":"C:\\projects\\lightning\\node_modules\\path-browserify\\index.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\PlaceHoldPanel.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TitleActionButton = require('../TitleActionButton');

var _TitleActionButton2 = _interopRequireDefault(_TitleActionButton);

var _PlaceHoldPanel = require('../templates/PlaceHoldPanel.html');

var _PlaceHoldPanel2 = _interopRequireDefault(_PlaceHoldPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlaceHoldPanel = function (_Backbone$View) {
    _inherits(PlaceHoldPanel, _Backbone$View);

    function PlaceHoldPanel(_ref) {
        var bus = _ref.bus,
            titleModel = _ref.titleModel,
            context = _ref.context,
            _ref$isRequestAgain = _ref.isRequestAgain,
            isRequestAgain = _ref$isRequestAgain === undefined ? false : _ref$isRequestAgain;

        _classCallCheck(this, PlaceHoldPanel);

        var _this = _possibleConstructorReturn(this, (PlaceHoldPanel.__proto__ || Object.getPrototypeOf(PlaceHoldPanel)).apply(this, arguments));

        _this.template = _PlaceHoldPanel2['default'];


        _this.titleModel = titleModel;
        _this.context = context;
        _this.bus = bus;
        _this.card = window.card;
        _this.isRequestAgain = isRequestAgain;

        _this.card._fetch.then(function () {
            _this.render();
            _this._bindEvents();
        });
        return _this;
    }

    _createClass(PlaceHoldPanel, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var viewData = {
                title: this.titleModel.get('title'),
                type: this.titleModel.get('type'),
                coverSrc: this.titleModel.getCoverSrc(510),
                id: this.titleModel.id,
                isPreReleaseTitle: this.titleModel.get('isPreReleaseTitle'),
                prereleaseDate: this.titleModel.get('estimatedReleaseDate'),
                ownedCopies: this.titleModel.get('ownedCopies'),
                libraryName: window.OverDrive.libraryName,
                html: window.html,
                text: window.text,
                isRequestAgain: this.isRequestAgain
            };

            this.$el.html(this.template(viewData));

            this.$form = this.$el.find('form');

            if (this.titleModel.isLuckyDayCheckout) {
                this.titleModel.set('titleState', 'hold');
            }

            this.titleActionButton = new _TitleActionButton2['default']({
                model: this.titleModel,
                type: 'button',
                el: this.$form.find('.TitleAction'),
                action: function action() {
                    return _this2.$form.submit();
                }
            });
        }
    }, {
        key: '_bindEvents',
        value: function _bindEvents() {
            var _this3 = this;

            this.$form.foundation('abide', 'reflow').on('valid.fndtn.abide', function () {
                _this3.card.setHoldEmail(_this3.$el.find('input[type="email"]:first').val().trim());
                _this3.bus.trigger('title:hold', _this3.titleModel, _this3.context);
            });
        }
    }]);

    return PlaceHoldPanel;
}(Backbone.View);

exports['default'] = PlaceHoldPanel;

},{"../TitleActionButton":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleActionButton.js","../templates/PlaceHoldPanel.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\PlaceHoldPanel.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\RemoveHistoryModal.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _modal = require('../../common/modal');

var _RemoveHistory = require('../templates/RemoveHistory.html');

var _RemoveHistory2 = _interopRequireDefault(_RemoveHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RemoveHistoryModal = function (_Backbone$View) {
    _inherits(RemoveHistoryModal, _Backbone$View);

    function RemoveHistoryModal() {
        _classCallCheck(this, RemoveHistoryModal);

        return _possibleConstructorReturn(this, (RemoveHistoryModal.__proto__ || Object.getPrototypeOf(RemoveHistoryModal)).apply(this, arguments));
    }

    _createClass(RemoveHistoryModal, [{
        key: 'initialize',
        value: function initialize(_ref) {
            var _this2 = this;

            var bus = _ref.bus,
                title = _ref.title,
                action = _ref.action;

            this.bus = bus;
            this.action = action || function () {};

            var viewData = {
                text: window.html('readingHistory.removeWarning'),
                ariaLabel: window.html('readingHistory.removeTitle', { title: title.attributes.title }),
                removeButton: window.html('readingHistory.remove'),
                cancelButton: window.html('cancel')
            };

            var content = $((0, _RemoveHistory2['default'])(viewData));

            var modalContents = {
                autoShow: false,
                title: window.html('readingHistory.remove'),
                content: content,
                id: 'removeHistoryModal'
            };

            this.modal = new _modal.Modal(modalContents);

            this.modal.$el.find('.js-cancel').on('click', function () {
                _this2.modal.close();
            });

            this.modal.$el.find('.js-remove-history').on('click', function () {
                _this2.action();
                _this2.modal.close();
            });

            this.modal.show();
        }
    }]);

    return RemoveHistoryModal;
}(Backbone.View);

exports['default'] = RemoveHistoryModal;

},{"../../common/modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js","../templates/RemoveHistory.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\RemoveHistory.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\RtlLimitModal.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _modal = require('../../common/modal');

var _RtlLimitModal = require('../templates/RtlLimitModal.html');

var _RtlLimitModal2 = _interopRequireDefault(_RtlLimitModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RtlNoneRemainingModal = function (_Modal) {
    _inherits(RtlNoneRemainingModal, _Modal);

    function RtlNoneRemainingModal(rtlStats) {
        _classCallCheck(this, RtlNoneRemainingModal);

        var nextRecommendation = Math.ceil(rtlStats.nextRecommendationSeconds / 86400);

        var modalContents = {
            classes: ['RtlLimitModal'],
            title: window.html('recommendLimitModal.heading'),
            content: (0, _RtlLimitModal2['default'])({ nextRecommendation: nextRecommendation })
        };

        var _this = _possibleConstructorReturn(this, (RtlNoneRemainingModal.__proto__ || Object.getPrototypeOf(RtlNoneRemainingModal)).call(this, modalContents));

        _this.$el.find('.confirm-button').on('click', function () {
            _this.close();
        });
        return _this;
    }

    return RtlNoneRemainingModal;
}(_modal.Modal);

exports['default'] = RtlNoneRemainingModal;

},{"../../common/modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js","../templates/RtlLimitModal.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\RtlLimitModal.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\RtlModal.js":[function(require,module,exports){
'use strict';

var _modal = require('../../common/modal');

var _RtlPanel = require('./RtlPanel');

var _RtlPanel2 = _interopRequireDefault(_RtlPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Backbone = window.Backbone;

var RtlModal = Backbone.View.extend({
    initialize: function initialize(bus, titleModel, context) {
        var _this = this;

        this.bus = bus;
        this.context = context;

        this.rtlPanel = new _RtlPanel2['default']({ titleModel: titleModel, bus: bus, context: context });

        var modalContents = {
            autoShow: false,
            title: window.html('recommendToLibraryModal.heading'),
            classes: ['small', 'RecommendModal'],
            content: this.rtlPanel.$el,
            firstFocus: this.rtlPanel.$el.find('.js-first-focus')
        };

        this.modal = new _modal.Modal(modalContents);

        this.modal.show();

        this.listenTo(this.bus, 'title:recommend:end', function () {
            _this.modal.close();
        });
    }
});

module.exports = RtlModal;

},{"../../common/modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js","./RtlPanel":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\RtlPanel.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\RtlPanel.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TitleActionButton = require('../TitleActionButton');

var _TitleActionButton2 = _interopRequireDefault(_TitleActionButton);

var _RtlPanel = require('../templates/RtlPanel.html');

var _RtlPanel2 = _interopRequireDefault(_RtlPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var RtlPanel = Backbone.View.extend({
    initialize: function initialize(_ref) {
        var _this = this;

        var titleModel = _ref.titleModel,
            bus = _ref.bus,
            context = _ref.context;

        this.titleModel = titleModel;
        this.bus = bus;
        this.context = context;
        this.card = window.card;
        this.card._fetch.then(function () {
            _this.render();
            _this._bindEvents();
        });
    },
    render: function render() {
        var _this2 = this;

        var patronEmail = this.card.preferredHoldEmail;

        var viewData = {
            title: this.titleModel.get('title'),
            type: this.titleModel.get('type'),
            author: this.titleModel.get('firstCreatorName'),
            coverSrc: this.titleModel.getCoverSrc(510),
            patronEmail: patronEmail,
            hideEmail: patronEmail === '' ? '' : 'hideMeImportant',
            csrfToken: $('#csrf').val(),
            html: window.html,
            text: window.text,
            rid: Math.random().toString(36).substring(7)
        };

        this.$el.append((0, _RtlPanel2['default'])(viewData));

        this.$form = this.$el.find('form');

        this.titleActionButton = new _TitleActionButton2['default']({
            model: this.titleModel,
            type: 'button',
            el: this.$form.find('.TitleAction'),
            action: function action() {
                return _this2.$form.submit();
            }
        });
    },
    _bindEvents: function _bindEvents() {
        var _this3 = this;

        $(document).foundation({
            abide: {
                validators: {
                    // eslint-disable-next-line object-shorthand
                    'required': function required(el, _required, parent) {
                        var empty = el.value.trim().length === 0;
                        if (_required && empty) {
                            return false;
                        }
                        return true;
                    },
                    // eslint-disable-next-line object-shorthand
                    'equalto': function equalto(el, required, parent) {
                        var from = document.getElementById(el.getAttribute(this.add_namespace('data-validator-equalto'))).value;
                        var to = el.value;
                        return from === to;
                    },
                    // eslint-disable-next-line object-shorthand
                    'email': function email(el, required, parent) {
                        var regex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
                        return regex.test(el.value);
                    }
                }
            }
        });
        this.$form.foundation('abide', 'reflow').on('valid.fndtn.abide', function () {
            if (!_this3.card.preferredHoldEmail) {
                _this3.card.setHoldEmail(_this3.$el.find('input[type="email"]:first').val().trim());
            }

            _this3.bus.trigger('title:recommend:post', {
                titleModel: _this3.titleModel,
                email: _this3.card.preferredHoldEmail,
                context: _this3.context
            });
        });
    }
});

exports['default'] = RtlPanel;

},{"../TitleActionButton":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleActionButton.js","../templates/RtlPanel.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\RtlPanel.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\RtlSuccessModal.js":[function(require,module,exports){
'use strict';

var _modal = require('../../common/modal');

var _TitleCollectionView = require('../TitleCollectionView');

var _TitleCollectionView2 = _interopRequireDefault(_TitleCollectionView);

var _TitleCollection = require('../models/TitleCollection');

var _TitleCollection2 = _interopRequireDefault(_TitleCollection);

var _patron_media_items = require('../../../models/patron_media_items');

var _patron_media_items2 = _interopRequireDefault(_patron_media_items);

var _TitleCard = require('../TitleCard');

var _TitleCard2 = _interopRequireDefault(_TitleCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Backbone = window.Backbone;


var path = require('path');
var RtlSuccessModalTemplate = "<div class=\"modal-container RecommendSuccessModal-container\" role=\"dialog\">\n    <p id=\"availability-label\" class=\"RecommendSuccessModal-label\" tabindex=\"0\">\n        <span class=\"js-recommend-option-text\"><%= window.html(message, {'email':email}) %></span>\n        <span class=\"js-recommend-success-related-text\"><%= window.html('recommendSuccessModal.textBody') %></span>\n    </p>\n\n\n    <div class=\"row\">\n        <div class=\"small-12 small-centered small-collapse columns\">\n            <ul class=\"RecommendSuccessModal-titles js-recommend-success-title-container small-collapse js-relatedTitles row\"></ul>\n        </div>\n    </div>\n\n    <a class=\"button primary RecommendSuccessModal-seeAllButton js-recommendation-modal-see-all-link radius u-allCaps\" href=\"<%= relatedMediaLink %>\"><%= html('recommendSuccessModal.moreYouMayLike') %></a>\n</div>";

var RtlSuccessModal = Backbone.View.extend({
    template: _.template(RtlSuccessModalTemplate),

    initialize: function initialize(bus, data) {
        var _this = this;

        this.titleModel = data.titleModel;
        this.titleCollection = new _TitleCollection2['default']();
        this.bus = bus;

        this.$panel = $(this.template({
            relatedMediaLink: window.url(window.routes.mediaRelatedId, { id: this.titleModel.id }),
            email: data.email,
            message: 'recommendSuccessModal.successMessageAdd'
        }));

        this.$relatedTitles = this.$panel.find('.js-recommend-success-title-container');

        this._renderRelatedTitles().then(function () {
            return _this._renderModal();
        });
    },
    _renderRelatedTitles: function _renderRelatedTitles() {
        var _this2 = this;

        this.titleCollection.url = window.url(window.routes.rest.media.related, { id: this.titleModel.id }) + '?max=2';

        return this.titleCollection.fetch().done(function (titles) {
            var patronMediaItemsModel = new _patron_media_items2['default']({ titles: titles });

            _this2.titleCollectionView = new _TitleCollectionView2['default']({
                el: _this2.$relatedTitles,
                bus: _this2.bus,
                collection: _this2.titleCollection,
                patronMediaItemsModel: patronMediaItemsModel,
                View: _TitleCard2['default'],
                coverWidths: { mobile: 184, tablet: 220, desktop: 220 }
            });

            _this2.titleCollectionView.$el.find('.js-titleCard').addClass('RecommendSuccessModal-item small-6 columns');
        }).fail(function () {
            return 'Failed to retrieve related titles for: ' + _this2.titleModel.id;
        });
    },
    _renderModal: function _renderModal() {
        var modalContents = {
            title: window.html('recommendSuccessModal.heading'),
            classes: ['small', 'RecommendSuccessModal', 'js-recommendation-success-modal'],
            content: this.$panel,
            customButtons: true
        };

        this.modal = new _modal.Modal(modalContents);
    }
});

module.exports = RtlSuccessModal;


},{"../../../models/patron_media_items":"C:\\projects\\lightning\\public\\ecmascript\\models\\patron_media_items.js","../../common/modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js","../TitleCard":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleCard.js","../TitleCollectionView":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleCollectionView.js","../models/TitleCollection":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\models\\TitleCollection.js","path":"C:\\projects\\lightning\\node_modules\\path-browserify\\index.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ContextMenu = require('../ContextMenu');

var _ContextMenu2 = _interopRequireDefault(_ContextMenu);

var _TitleAuthor = require('./TitleInfo/TitleAuthor');

var _TitleAuthor2 = _interopRequireDefault(_TitleAuthor);

var _TitleEdition = require('./TitleInfo/TitleEdition');

var _TitleEdition2 = _interopRequireDefault(_TitleEdition);

var _TitleName = require('./TitleInfo/TitleName');

var _TitleName2 = _interopRequireDefault(_TitleName);

var _TitleFormatBadge = require('./TitleInfo/TitleFormatBadge');

var _TitleFormatBadge2 = _interopRequireDefault(_TitleFormatBadge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TitleInfo = function (_Backbone$View) {
    _inherits(TitleInfo, _Backbone$View);

    _createClass(TitleInfo, [{
        key: 'className',
        get: function get() {
            return 'title-info';
        }
    }]);

    function TitleInfo() {
        _classCallCheck(this, TitleInfo);

        var _this = _possibleConstructorReturn(this, (TitleInfo.__proto__ || Object.getPrototypeOf(TitleInfo)).apply(this, arguments));

        _this._views = [];

        _this.render();
        return _this;
    }

    _createClass(TitleInfo, [{
        key: '_reset',
        value: function _reset() {
            this._views.forEach(function (view) {
                return view.remove();
            });
            this._views = [];
        }
    }, {
        key: 'remove',
        value: function remove() {
            this._reset();
            _get(TitleInfo.prototype.__proto__ || Object.getPrototypeOf(TitleInfo.prototype), 'remove', this).call(this);
        }
    }, {
        key: 'render',
        value: function render() {
            this._reset();

            this._views.push(this.contextMenu = new _ContextMenu2['default']({ model: this.model }));
            if (this.model.isMagazine) {
                this._views.push(this.titleEdition = new _TitleEdition2['default']({ model: this.model }));
            } else {
                this._views.push(this.titleAuthor = new _TitleAuthor2['default']({ model: this.model }));
            }

            this._views.push(this.titleName = new _TitleName2['default']({ model: this.model }));
            this._views.push(this.titleFormatBadge = new _TitleFormatBadge2['default']({ typeId: this.model.get('type').id }));

            this.$el.empty();
            this.$el.append(this.titleName.$el, this.contextMenu.$el.addClass('text-right'), this.model.isMagazine ? this.titleEdition.$el : this.titleAuthor.$el, this.titleFormatBadge.$el);
        }
    }]);

    return TitleInfo;
}(Backbone.View);

exports['default'] = TitleInfo;

},{"../ContextMenu":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\ContextMenu.js","./TitleInfo/TitleAuthor":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\TitleAuthor.js","./TitleInfo/TitleEdition":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\TitleEdition.js","./TitleInfo/TitleFormatBadge":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\TitleFormatBadge.js","./TitleInfo/TitleName":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\TitleName.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\TitleAuthor.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Backbone = window.Backbone;


var path = require('path');
var TitleAuthorTemplate = "<a title=\"<%= text %>\" class=\"secondary-hover-underline\" href=\"<%= href %>\" aria-label=\"<%= label %>\"><%= text %></a>";

var TitleAuthor = Backbone.View.extend({
    template: _.template(TitleAuthorTemplate),

    className: 'title-author',

    tagName: 'p',

    initialize: function initialize() {
        if (this.model.get('type').id !== 'periodicals') {
            this.render();
        }
    },
    render: function render() {
        var title = this.model.toJSON();

        var contents = window.html('cover.noAuthorAvailable');

        if (!_.isEmpty(title.firstCreatorName)) {
            var viewData = {
                href: window.url(window.routes.searchByType, { type: 'creatorId', query: title.firstCreatorId, sortBy: 'newlyadded' }),
                label: window.text('cover.searchByAuthor', { author: _.escape(this.model.get('firstCreatorName')) }),
                text: _.escape(title.firstCreatorName)
            };

            contents = window.text('byLine', { creator: this.template(viewData) });
        }

        this.$el.html(contents);
    }
});

exports['default'] = TitleAuthor;


},{"path":"C:\\projects\\lightning\\node_modules\\path-browserify\\index.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\TitleEdition.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TitleEdition = function (_Backbone$View) {
    _inherits(TitleEdition, _Backbone$View);

    function TitleEdition() {
        _classCallCheck(this, TitleEdition);

        var _this = _possibleConstructorReturn(this, (TitleEdition.__proto__ || Object.getPrototypeOf(TitleEdition)).apply(this, arguments));

        _this.render();
        return _this;
    }

    _createClass(TitleEdition, [{
        key: 'render',
        value: function render() {
            var node = $('<div class="title-edition">' + this.model.get('edition') + '</div>');
            this.setElement(node);
        }
    }]);

    return TitleEdition;
}(Backbone.View);

exports['default'] = TitleEdition;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\TitleFormatBadge.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TitleFormatBadge = require('../../templates/TitleFormatBadge.html');

var _TitleFormatBadge2 = _interopRequireDefault(_TitleFormatBadge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TitleFormatBadge = Backbone.View.extend({
    initialize: function initialize(_ref) {
        var typeId = _ref.typeId;

        this.typeId = typeId;
        this.render();
    },
    render: function render() {
        this.setElement($((0, _TitleFormatBadge2['default'])({ typeId: this.typeId })));
    }
});

exports['default'] = TitleFormatBadge;

},{"../../templates/TitleFormatBadge.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\TitleFormatBadge.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\TitleInfo\\TitleName.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TitleName = require('../../templates/TitleName.html');

var _TitleName2 = _interopRequireDefault(_TitleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TitleName = function (_Backbone$View) {
    _inherits(TitleName, _Backbone$View);

    function TitleName() {
        _classCallCheck(this, TitleName);

        var _this = _possibleConstructorReturn(this, (TitleName.__proto__ || Object.getPrototypeOf(TitleName)).apply(this, arguments));

        _this.template = _TitleName2['default'];
        _this.render();
        return _this;
    }

    _createClass(TitleName, [{
        key: '_assembleLabel',
        value: function _assembleLabel() {
            var labelParts = [];

            labelParts.push(this.model.get('title'));

            if (!!this.model.get('firstCreatorName')) {
                labelParts.push(window.html('byLine', { creator: this.model.isMagazine ? this.model.get('publisher').name : this.model.get('firstCreatorName') }));
            }

            labelParts.push(this.model.availabilityText());

            labelParts.push(this.model.get('type').name);

            return labelParts.join(' ');
        }
    }, {
        key: 'render',
        value: function render() {
            var viewData = {
                titleId: this.model.id,
                href: this.model.titleDetailsUrl,
                ariaLabel: _.escape(this._assembleLabel()),
                title: _.escape(this.model.get('title'))
            };

            this.setElement($(this.template(viewData)));
        }
    }]);

    return TitleName;
}(Backbone.View);

exports['default'] = TitleName;

},{"../../templates/TitleName.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\TitleName.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\mobile_account_menu\\main.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _account_menu_mobile = require('./views/account_menu_mobile');

var _account_menu_mobile2 = _interopRequireDefault(_account_menu_mobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var createComponent = function createComponent(_ref) {
    var el = _ref.el;

    var view = new _account_menu_mobile2['default']({ el: el }); // eslint-disable-line no-unused-vars
    window.AccountMenuMobileView = view;
};

exports['default'] = createComponent;

},{"./views/account_menu_mobile":"C:\\projects\\lightning\\public\\ecmascript\\components\\mobile_account_menu\\views\\account_menu_mobile.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\mobile_account_menu\\views\\account_menu_mobile.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _base = require('../../../views/base');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var AccountMenuMobileView = _base2['default'].extend({
    events: {
        'click .js-account-menu-link': 'toggleAccountDropdown'
    },
    initialize: function initialize(_ref) {
        var el = _ref.el;

        this.el = el;
        this.$accountMenuLink = $('.js-account-menu-link');
        this.$accountMenuContent = $('.js-account-menu-mobile');
    },
    open: function open() {
        $('.icon-account.mobile').addClass('secondary-color');
        this.$accountMenuLink.add(this.$accountMenuContent[0]).addClass('is-open');

        // Close all open foundation dropdowns. hopefully we can kill this eventually.
        $(document).foundation('dropdown', 'close', $('[data-dropdown-content]'));
        toaster._stickToast();
    },
    close: function close() {
        $('.icon-account.mobile').removeClass('secondary-color');
        this.$accountMenuLink.add(this.$accountMenuContent[0]).removeClass('is-open');
        toaster._stickToast();
    },
    toggleAccountDropdown: function toggleAccountDropdown() {
        if (this.$accountMenuLink.hasClass('is-open')) {
            this.close();
        } else {
            this.open();
        }
    }
});

exports['default'] = AccountMenuMobileView;

},{"../../../views/base":"C:\\projects\\lightning\\public\\ecmascript\\views\\base.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\non_hold_conflict_modal\\NonHoldConflictModal.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _modal = require('../common/modal');

var _NonHoldConlictModal = require('./NonHoldConlictModal.html');

var _NonHoldConlictModal2 = _interopRequireDefault(_NonHoldConlictModal);

var _TitleCard = require('../media/TitleCard');

var _TitleCard2 = _interopRequireDefault(_TitleCard);

var _TitleCollection = require('../media/models/TitleCollection');

var _TitleCollection2 = _interopRequireDefault(_TitleCollection);

var _TitleCollectionView = require('../media/TitleCollectionView');

var _TitleCollectionView2 = _interopRequireDefault(_TitleCollectionView);

var _HoldSuccessRelatedTitles = require('../media/templates/HoldSuccessRelatedTitles.html');

var _HoldSuccessRelatedTitles2 = _interopRequireDefault(_HoldSuccessRelatedTitles);

var _popover = require('../../components/popover/popover');

var _popover2 = _interopRequireDefault(_popover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _window = window,
    html = _window.html;

var NonHoldConflictModal = function (_Modal) {
    _inherits(NonHoldConflictModal, _Modal);

    function NonHoldConflictModal(titleModel) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, NonHoldConflictModal);

        var message = html(options.isLuckyDay ? 'nonHoldConflictModal.luckyDayMessageHtml' : 'nonHoldConflictModal.messageHtml', { title: '<span style="font-weight: bold">' + titleModel.get('title') + '</span>' });
        var info = html('nonHoldConflictModal.luckyDayInfo');

        var useNewPopover = window.featureManager.isEnabled('LHTNG-3592');

        var modalContents = {
            classes: ['nonHoldConflictModal'],
            title: html('nonHoldConflictModal.heading'),
            content: (0, _NonHoldConlictModal2['default'])({ titleModel: titleModel, options: options, message: message, info: info, useNewPopover: useNewPopover })
        };

        var _this = _possibleConstructorReturn(this, (NonHoldConflictModal.__proto__ || Object.getPrototypeOf(NonHoldConflictModal)).call(this, modalContents));

        _this.collection = new _TitleCollection2['default']();
        _this.collection.url = window.url(window.routes.rest.media.availableRelated, { id: titleModel.id }) + '?max=4';
        _this.$titleContainer = _this.$('.relatedTitlesContainer');
        _this.titleModel = titleModel;
        _this.fetchRelatedTitles();

        if (options.isLuckyDay && useNewPopover) {
            _this.ldtooltip = new _popover2['default']({
                target: _this.$el.find('#luckyDayTooltip'),
                contents: '<p>' + html('nonHoldConflictModal.luckyDayInfo') + '</p>'
            });
        }
        return _this;
    }

    _createClass(NonHoldConflictModal, [{
        key: 'fetchRelatedTitles',
        value: function fetchRelatedTitles() {
            var _this2 = this;

            this.collection.fetch().then(function (titles) {
                if (_(titles).isEmpty()) {
                    _this2.$titleContainer.empty();
                    return;
                }
                _this2.renderRelatedTitles();
            }).fail(function () {
                _this2.$titleContainer.empty();
            });
        }
    }, {
        key: 'renderRelatedTitles',
        value: function renderRelatedTitles() {

            this.$titleContainer.empty();
            this.$titleContainer.append((0, _HoldSuccessRelatedTitles2['default'])({ titleModel: this.titleModel.attributes }));

            this.titleCollectionView = new _TitleCollectionView2['default']({
                el: this.$titleContainer.find('.relatedTitles'),
                bus: this.bus,
                View: _TitleCard2['default'],
                attributes: { 'class': 'titleContainer small-block-grid-2 medium-block-grid-4 large-block-grid-4' },
                collection: this.collection,
                coverWidths: { mobile: 150, tablet: 185, desktop: 220 }
            });
        }
    }]);

    return NonHoldConflictModal;
}(_modal.Modal);

exports['default'] = NonHoldConflictModal;

},{"../../components/popover/popover":"C:\\projects\\lightning\\public\\ecmascript\\components\\popover\\popover.js","../common/modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js","../media/TitleCard":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleCard.js","../media/TitleCollectionView":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\TitleCollectionView.js","../media/models/TitleCollection":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\models\\TitleCollection.js","../media/templates/HoldSuccessRelatedTitles.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\templates\\HoldSuccessRelatedTitles.html.js","./NonHoldConlictModal.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\non_hold_conflict_modal\\NonHoldConlictModal.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\non_hold_conflict_modal\\NonHoldConlictModal.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function (_ref) {
    var titleModel = _ref.titleModel,
        options = _ref.options,
        message = _ref.message,
        info = _ref.info,
        useNewPopover = _ref.useNewPopover;
    return '\n    <div class="messageContainer">\n        <div class="message">\n            ' + message + '\n            ' + (options.isLuckyDay && !titleModel.get('isOnHold') ? useNewPopover ? '<div style="display: inline-block; position: relative">\n                            <div style="display: inline-block; float: right">\n                                <a role="button" id="luckyDayTooltip" class="help-tip secondary-background" style="float: right"></a>\n                            </div>\n                        </div>\n                    ' : '<div style="display: inline-block; position: relative">\n                        <div style="display: inline-block; float: right">\n                            <a role="button" data-dropdown="luckyDay-help-tip" aria-controls="luckyDay-help-tip" tabindex="0" class="help-tip secondary-background luckyDay-help-tip" style="float: right"></a>\n                        </div>\n                    </div>\n                    <div id="luckyDay-help-tip" data-dropdown-content class="f-dropdown medium content" aria-hidden="true" tabindex="-1">\n                        <p>' + info + '</p>\n                    </div>' : '') + '\n            ' + (titleModel.get('isOnHold') ? '\n                <p class="stillOnHoldMessage">' + window.html('nonHoldConflictModal.stillOnHold', { title: titleModel.title }) + '</p>\n            ' : '') + '\n        </div>\n    </div>\n    <div class="relatedTitlesContainer">\n        <div class="loader"></div>\n    </div>\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\popover\\popover.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Popover = function (_Backbone$View) {
    _inherits(Popover, _Backbone$View);

    function Popover(opts) {
        _classCallCheck(this, Popover);

        var _this = _possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).apply(this, arguments));

        if (!opts.target) {
            throw new Error('you must specify a target');
        }

        _this.contents = opts.contents;
        _this.target = opts.target;
        _this.enabled = false;
        _this.requestedWidth = opts.width || 300;

        _this.target.on('click', function (e) {
            _this.toggle();
            e.stopPropagation();
        });
        return _this;
    }

    _createClass(Popover, [{
        key: 'getParams',
        value: function getParams() {
            var topMargin = 6;
            var sideMargin = 5;
            var caretSpacer = 4;
            var targetOffset = this.target.offset();
            var targetWidth = this.target.width();
            targetOffset.right = targetOffset.left + targetWidth;
            var targetHeight = this.target.height();
            var viewportWidth = $(window).width();
            var viewportHeight = $(window).height();
            var width = Math.min(this.requestedWidth - 2 * sideMargin, viewportWidth);
            var xOverlap = width - targetWidth;
            var spaceToLeft = targetOffset.left;
            var spaceToRight = viewportWidth - targetOffset.right;
            var leftHasRoom = spaceToLeft >= xOverlap / 2;
            var rightHasRoom = spaceToRight >= xOverlap / 2;

            // prefer centering on the target.  This is different than the foundation popovers but much easier to reason about.
            var left = void 0,
                right = void 0,
                top = void 0,
                bottom = void 0,
                caretLeft = void 0,
                caretRight = void 0,
                alignmentClass = void 0;

            if (leftHasRoom && rightHasRoom) {
                // horizontally centered on the target element
                left = targetOffset.left - xOverlap / 2;
                right = viewportWidth - targetOffset.right - xOverlap / 2;
                caretLeft = width / 2;
                alignmentClass = 'popoverCenter';
            } else if (spaceToRight >= xOverlap) {
                // align the left edge to the target's left edge
                left = targetOffset.left;
                right = viewportWidth - targetOffset.right - xOverlap;
                caretLeft = caretSpacer;
                alignmentClass = 'popoverLeft';
            } else if (spaceToLeft >= xOverlap) {
                // align the right edge to the target's right edge
                left = targetOffset.left - xOverlap;
                right = viewportWidth - targetOffset.right;
                caretRight = caretSpacer;
                alignmentClass = 'popoverRight';
            } else {
                // the viewport is narrower than the desired popover width. Fill the available space.
                left = 0;
                right = 0;
                caretLeft = targetOffset.left + targetWidth / 2;
                alignmentClass = 'popoverFit';
            }

            var openUp = (this.target[0].getBoundingClientRect().top + targetHeight / 2) / viewportHeight > 0.666666;
            if (!openUp) {
                top = targetOffset.top + topMargin + targetHeight;
            } else {
                bottom = viewportHeight - targetOffset.top + topMargin;
            }

            return {
                main: {
                    top: top,
                    bottom: bottom,
                    left: left,
                    right: right
                },
                caret: {
                    left: caretLeft,
                    right: caretRight
                },
                directionClass: openUp ? 'popoverUp' : 'popoverDown',
                alignmentClass: alignmentClass
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var params = this.getParams();

            this.$el.empty();
            this.$el = $('\n            <div class="popoverCanvas ' + params.directionClass + ' ' + params.alignmentClass + '">\n                <div class="popover" style="\n                    ' + (params.main.top ? 'top:' + params.main.top + 'px;' : '') + '\n                    ' + (params.main.bottom ? 'bottom:' + params.main.bottom + 'px;' : '') + '\n                    left:' + params.main.left + 'px;\n                    right:' + params.main.right + 'px"\n                    aria-live="polite">\n                        <div class="popoverCaret" style="\n                                ' + (params.caret.right ? 'right:' + params.caret.right + 'px;' : '') + '\n                                ' + (params.caret.left ? 'left:' + params.caret.left + 'px;' : '') + '" >\n                            <div class="popoverCaretTip"></div>\n                        </div>\n                        ' + this.contents + '\n                </div>\n            </div>\n        ');

            $('body').append(this.$el);
            $('body').click(function () {
                return _this2.hide();
            });
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.$el.remove();
            this.enabled = false;
        }
    }, {
        key: 'show',
        value: function show() {
            this.render();
            this.enabled = true;
        }
    }, {
        key: 'toggle',
        value: function toggle() {
            if (this.enabled) {
                this.hide();
            } else {
                this.show();
            }
        }
    }]);

    return Popover;
}(Backbone.View);

exports['default'] = Popover;


},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\quick_search\\collections\\autocompletions.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _base = require('../../../collections/base');

var _base2 = _interopRequireDefault(_base);

var _autocompletion = require('../models/autocompletion');

var _autocompletion2 = _interopRequireDefault(_autocompletion);

var _text = require('../../../util/text');

var _ensureSimpleRequest = require('../../../util/requests/ensureSimpleRequest');

var _ensureSimpleRequest2 = _interopRequireDefault(_ensureSimpleRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var AutocompletionsCollection = _base2['default'].extend({

    model: _autocompletion2['default'],

    url: function url() {
        return OverDrive.autocompleteHost + '/autocomplete';
    },
    initialize: function initialize(models, _ref) {
        var query = _ref.query,
            _ref$count = _ref.count,
            count = _ref$count === undefined ? 15 : _ref$count,
            _ref$sortBy = _ref.sortBy,
            sortBy = _ref$sortBy === undefined ? 'score' : _ref$sortBy;

        this.query = query;
        this.count = count;
        this.sortBy = sortBy;
        this.apiKey = OverDrive.autocompleteApiKey;

        this.mediaType = this._getSupportedMediaTypes();

        this.listenTo(this.query, 'change:text', this.textChangeHandler.bind(this));
        this.on('sync', this.smartSyncTrigger);
    },
    textChangeHandler: function textChangeHandler() {
        if (this.query.isValidForAutocomplete()) {
            // Try to cancel the previous XHR request if it has not already resolved, otherwise noop
            this._lastFetch && this._lastFetch.abort();

            this._lastFetch = this.fetch();
        } else {
            this.reset();
        }
    },
    queryParams: function queryParams() {
        var params = { query: this.query.get('text'), maxSize: this.count, categorySize: this.count, sortBy: this.sortBy, mediaType: this.mediaType };
        if (OverDrive.autocompleteHost !== OverDrive.thunderHost) {
            params['api-key'] = this.apiKey;
        }
        return $.param(params);
    },
    fetch: function fetch() {
        var data = this.queryParams();
        return (0, _ensureSimpleRequest2['default'])(_base2['default'].prototype.fetch.bind(this, { data: data }));
    },
    smartSyncTrigger: function smartSyncTrigger(collection, response, options) {
        if (options.data === this.queryParams()) {
            this.trigger('smartsync');
        }
    },
    parse: function parse(response) {
        var mapped = _.map(response.items, function (item, index) {
            return { text: (0, _text.decodeEntities)(item.text), field: item.field, index: index };
        });
        return _.uniq(mapped, function (item) {
            return item.text.toUpperCase();
        });
    },
    _getSupportedMediaTypes: function _getSupportedMediaTypes() {
        var mediaType = [];

        var supportedFormats = window.OverDrive.supportedFormats;
        if (supportedFormats && _.isArray(supportedFormats)) {
            // Rooms only have the format class, so we're doing something gross and
            // stripping the format class off of each format based on string convention
            mediaType = supportedFormats.map(function (format) {
                var formatClass = format.id;
                var classEndIndex = formatClass.indexOf('-');
                if (classEndIndex !== -1) {
                    formatClass = formatClass.substring(0, classEndIndex);
                }
                return formatClass;
            });
            mediaType = mediaType.filter(function (value, index) {
                return mediaType.indexOf(value) === index;
            });
        }

        var room = window.OverDrive.currentRoom;
        var roomFormats = room && room.filters && room.filters.mediaType;
        if (roomFormats) {
            mediaType = _(mediaType).intersection(roomFormats);
        }

        return mediaType;
    }
});

exports['default'] = AutocompletionsCollection;

},{"../../../collections/base":"C:\\projects\\lightning\\public\\ecmascript\\collections\\base.js","../../../util/requests/ensureSimpleRequest":"C:\\projects\\lightning\\public\\ecmascript\\util\\requests\\ensureSimpleRequest.js","../../../util/text":"C:\\projects\\lightning\\public\\ecmascript\\util\\text.js","../models/autocompletion":"C:\\projects\\lightning\\public\\ecmascript\\components\\quick_search\\models\\autocompletion.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\quick_search\\main.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _quick_search = require('./models/quick_search');

var _quick_search2 = _interopRequireDefault(_quick_search);

var _autocompletions = require('./collections/autocompletions');

var _autocompletions2 = _interopRequireDefault(_autocompletions);

var _search_bar = require('./views/search_bar');

var _search_bar2 = _interopRequireDefault(_search_bar);

var _search_bar_autocomplete = require('./views/search_bar_autocomplete');

var _search_bar_autocomplete2 = _interopRequireDefault(_search_bar_autocomplete);

var _autocompletions3 = require('./views/autocompletions');

var _autocompletions4 = _interopRequireDefault(_autocompletions3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Backbone = window.Backbone;

var createComponent = function createComponent(_ref) {
    var searchEl = _ref.searchEl,
        autocompletionsEl = _ref.autocompletionsEl,
        toggleSearchEl = _ref.toggleSearchEl,
        options = _ref.options;

    var query = new _quick_search2['default']();
    var featureManager = window.featureManager;

    // Disable autocomplete for rooms
    if (featureManager.isEnabled('autocomplete')) {
        var autocompleteBus = _.extend({}, Backbone.Events);
        var searchBarAutocomplete = new _search_bar_autocomplete2['default']({ el: searchEl, toggleSearchEl: toggleSearchEl, query: query, autocompleteBus: autocompleteBus }); // eslint-disable-line no-unused-vars
        var autocompletions = new _autocompletions2['default'](null, { query: query });
        var viewOptions = {
            query: query,
            autocompleteBus: autocompleteBus,
            el: autocompletionsEl,
            collection: autocompletions,
            options: options
        };
        var autocompletionsView = new _autocompletions4['default'](viewOptions); // eslint-disable-line no-unused-vars
    } else {
        var searchBar = new _search_bar2['default']({ el: searchEl, query: query, options: { $toggleSearch: toggleSearchEl } }); // eslint-disable-line no-unused-vars
    }
};

exports['default'] = createComponent;

},{"./collections/autocompletions":"C:\\projects\\lightning\\public\\ecmascript\\components\\quick_search\\collections\\autocompletions.js","./models/quick_search":"C:\\projects\\lightning\\public\\ecmascript\\components\\quick_search\\models\\quick_search.js","./views/autocompletions":"C:\\projects\\lightning\\public\\ecmascript\\components\\quick_search\\views\\autocompletions.js","./views/search_bar":"C:\\projects\\lightning\\public\\ecmascript\\components\\quick_search\\views\\search_bar.js","./views/search_bar_autocomplete":"C:\\projects\\lightning\\public\\ecmascript\\components\\quick_search\\views\\search_bar_autocomplete.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\quick_search\\models\\autocompletion.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _base = require('../../../models/base');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Autocompletion = _base2['default'].extend({
    defaults: function defaults() {
        return {
            text: '',
            active: false
        };
    },
    parse: function parse(result) {
        result.text = this.replaceHtml(result.text);
        return result;
    },
    replaceHtml: function replaceHtml(text) {
        return text.replace('<sup>TM</sup>', '™');
    }
});

exports['default'] = Autocompletion;

},{"../../../models/base":"C:\\projects\\lightning\\public\\ecmascript\\models\\base.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\quick_search\\models\\quick_search.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _base = require('../../../models/base');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var AUTOCOMPLETE_MINIMUM = 1;
var SEARCH_MINIMUM = 1;

var QuickSearchModel = _base2['default'].extend({
    defaults: function defaults() {
        return {
            text: ''
        };
    },
    isValidForAutocomplete: function isValidForAutocomplete() {
        return this.get('text').length >= AUTOCOMPLETE_MINIMUM;
    },
    isValidForSearch: function isValidForSearch() {
        return this.get('text').length >= SEARCH_MINIMUM;
    }
});

exports['default'] = QuickSearchModel;

},{"../../../models/base":"C:\\projects\\lightning\\public\\ecmascript\\models\\base.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\quick_search\\views\\autocompletion.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _base = require('../../../views/base');

var _base2 = _interopRequireDefault(_base);

var _text = require('../../../util/text');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }


var path = require('path');
var template = "<a class=\"Autocompletions-item js-autocompletionItem <% if (data.active){%>is-active<%}%>\" href=\"<%= data.href %>\" data-position=\"<%= data.index %>\">\n    <div class=\"u-allCaps Autocompletions-suggestionSource\"><%= data.field %></div>\n    <div class=\"Autocompletions-suggestion\"><%= data.resultText %></div>\n</a>";

var Autocompletion = _base2['default'].extend({

    template: _.template(template, { variable: 'data' }),

    initialize: function initialize(_ref) {
        var model = _ref.model,
            query = _ref.query;

        this.model = model;
        this.query = query;
        this.listenTo(this.model, 'change:active', this.render);
    },
    deleteViewAndModel: function deleteViewAndModel() {
        this.model.destroy();
        this.deleteView();
    },
    deleteView: function deleteView() {
        this.remove();
        this.unbind();
    },
    getTemplateData: function getTemplateData() {
        var href = window.url(window.routes.search, {
            query: this.model.get('text')
        });

        return _.extend({}, this.model.attributes, {
            href: href,
            resultText: (0, _text.surroundSubtext)({
                text: this.model.get('text'),
                matcher: this.query.get('text'),
                tag: 'b',
                ignoreCase: true
            }),
            field: window.html('autoComplete.' + this.model.get('field'))
        });
    }
});

exports['default'] = Autocompletion;


},{"../../../util/text":"C:\\projects\\lightning\\public\\ecmascript\\util\\text.js","../../../views/base":"C:\\projects\\lightning\\public\\ecmascript\\views\\base.js","path":"C:\\projects\\lightning\\node_modules\\path-browserify\\index.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\quick_search\\views\\autocompletions.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _collection = require('../../../views/collection');

var _collection2 = _interopRequireDefault(_collection);

var _autocompletion = require('./autocompletion');

var _autocompletion2 = _interopRequireDefault(_autocompletion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }


var path = require('path');
var template = "<div aria-hidden=\"true\" role=\"presentation\" tabindex=\"-1\" class=\"Autocompletions\">\n    <div class=\"Autocompletions-list js-autocompletionsList\"></div>\n</div>\n";

var Autocompletions = _collection2['default'].extend({

    template: _.template(template),

    initialize: function initialize(_ref) {
        var el = _ref.el,
            query = _ref.query,
            collection = _ref.collection,
            autocompleteBus = _ref.autocompleteBus,
            _ref$options = _ref.options,
            options = _ref$options === undefined ? {} : _ref$options;

        this.el = el;
        this.collection = collection;
        this.query = query;
        this.autocompleteBus = autocompleteBus;
        this.options = options;
        this.$advancedSearch = $('.js-desktopAdvancedSearch');
        this.$iconClear = $('.icon-clear');
        this.listenTo(this.collection, 'reset', this.emptyElAndClearActive);
        this.listenTo(this.collection, 'smartsync', this.smartRender);
        this.listenTo(autocompleteBus, 'quicksearch:blur', this.emptyElAndClearActive);
        this.listenTo(autocompleteBus, 'quicksearch:focus', this.smartRender);
        this.listenTo(autocompleteBus, 'quicksearch:highlightItem', this.highlightItem);
    },
    emptyElAndClearActive: function emptyElAndClearActive() {
        if (this.options.desktop) {
            this.$advancedSearch.show();
        }
        // Hack until all the logic is moved into views
        if (this.options.mobile) {
            this.resetMobileSearchBar();
        }
        this.collection.invoke('set', { active: false });
        this.emptyEl();
        this.highlightedItemIndex = null;
    },
    resetMobileSearchBar: function resetMobileSearchBar() {
        // Mess of jquery until navbar can be systematically refactored
        $('.account-dropdown-mobile a').removeClass('hideMeImportant');
        $('.toggle-topbar.search').addClass('invisible');
        $('.toggle-topbar.menu-icon').removeClass('invisible');
        $('.toggle-topbar.browse').removeClass('invisible');
    },
    highlightItem: function highlightItem(direction) {
        if (this.collection.models.length === 0) {
            return;
        }
        if (this.highlightedItemIndex == null) {
            this.highlightedItemIndex = direction > 0 ? 0 : direction;
        } else {
            this.highlightedItemIndex += direction;
        }
        if (this.highlightedItemIndex < 0) {
            this.highlightedItemIndex = this.views.length - 1;
        } else if (this.highlightedItemIndex >= this.collection.models.length) {
            this.highlightedItemIndex = 0;
        }
        var model = this.collection.models[this.highlightedItemIndex];
        this.collection.invoke('set', { active: false });
        model.set('active', true);
        this.autocompleteBus.trigger('quicksearch:fill', model.get('text'));
    },
    appendItems: function appendItems() {
        var className = '.js-autocompletionsList';
        this.$(className).append(this.temp);
    },
    smartRender: function smartRender() {
        this.highlightedItemIndex = null;
        if (this.query.get('text').length && this.collection.models.length) {
            this.render();
            this.$advancedSearch.hide();
        } else {
            this.emptyEl();
        }
    },
    createItemView: function createItemView(_ref2) {
        var model = _ref2.model;

        return new _autocompletion2['default']({
            model: model,
            query: this.query
        });
    }
});

exports['default'] = Autocompletions;


},{"../../../views/collection":"C:\\projects\\lightning\\public\\ecmascript\\views\\collection.js","./autocompletion":"C:\\projects\\lightning\\public\\ecmascript\\components\\quick_search\\views\\autocompletion.js","path":"C:\\projects\\lightning\\node_modules\\path-browserify\\index.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\quick_search\\views\\search_bar.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _base = require('../../../views/base');

var _base2 = _interopRequireDefault(_base);

var _keycodes = require('../../../util/keycodes');

var _keycodes2 = _interopRequireDefault(_keycodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _ = window._;

var SearchBar = _base2['default'].extend({

    events: {
        'click .js-doQuickSearch': 'submitForm',
        'keyup .js-quickSearchInput': 'keyup',
        'change .js-quickSearchInput': 'change',
        'input .js-quickSearchInput': 'input',
        'click .js-clearSearch': 'clearSearch'
    },

    initialize: function initialize(_ref) {
        var _this = this;

        var el = _ref.el,
            query = _ref.query,
            options = _ref.options;

        this._injectCustomFunctioanlity();

        this.setElement(el);
        this.delegateEvents();
        this.query = query;

        this.$input = this.$el.find('.js-quickSearchInput');
        this.$form = this.$el.find('.js-quickSearchForm');
        this.$toggleSearch = this.$el.find('.js-toggleSearch');
        this.$clearSearch = this.$el.find('.js-clearSearch');

        // LHTNG-1215 - Sync any input provided staticaly from the form markup
        this.query.set('text', this.$input.val());

        _.extend(this, options || {});

        this.$toggleSearch.on('click keypress', function (ev) {
            _this.toggleSearch(ev);
        });
    },
    _injectCustomFunctioanlity: function _injectCustomFunctioanlity() {
        $.fn.setCursorToTextEnd = function () {
            var $initialVal = this.val();
            this.val('').val($initialVal);
        };
    },
    submitForm: function submitForm(ev) {
        if (this.query.isValidForSearch()) {
            this.$form.submit();
        } else {
            ev.stopPropagation();
            ev.preventDefault();
        }
    },
    keyup: function keyup(ev) {
        this.toggleClearIcon();

        if (this.keyupMap.has(ev.which)) {
            this.keyupMap.get(ev.which)(this);
        } else {
            this.query.set('text', ev.target.value);
            ev.stopPropagation();
            ev.preventDefault();
        }
    },
    input: function input(ev) {
        this.toggleClearIcon();
        this.query.set('text', ev.target.value);
        ev.stopPropagation();
        ev.preventDefault();
    },
    toggleClearIcon: function toggleClearIcon() {
        if (this.$input.val()) {
            this.$clearSearch.show();
        } else {
            this.$clearSearch.hide();
        }
    },
    clearSearch: function clearSearch() {
        this.$input.val('').focus();
        this.$clearSearch.hide();
    },


    keyupMap: new Map([[_keycodes2['default'].ENTER, function (self) {
        return self.submitForm();
    }]]),

    toggleSearch: function toggleSearch(ev) {
        if (ev.which === _keycodes2['default'].SPACE || ev.which === _keycodes2['default'].ENTER || ev.type === 'click') {
            this.$el.toggleClass('hideMe');
            this.$input.focus().setCursorToTextEnd();
        }

        this.toggleClearIcon();

        toaster._stickToast();
    }
});

exports['default'] = SearchBar;

},{"../../../util/keycodes":"C:\\projects\\lightning\\public\\ecmascript\\util\\keycodes.js","../../../views/base":"C:\\projects\\lightning\\public\\ecmascript\\views\\base.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\quick_search\\views\\search_bar_autocomplete.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _search_bar = require('./search_bar');

var _search_bar2 = _interopRequireDefault(_search_bar);

var _keycodes = require('../../../util/keycodes');

var _keycodes2 = _interopRequireDefault(_keycodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var AutocompleteSearchBar = _search_bar2['default'].extend({
    events: function events() {
        return _.extend({}, _.result(_search_bar2['default'].prototype, 'events'), {
            'blur .js-quickSearchInput': 'blur',
            'focus .js-quickSearchInput': 'focus',
            'keydown .js-quickSearchInput': 'keydown'
        });
    },
    initialize: function initialize(_ref) {
        var el = _ref.el,
            toggleSearchEl = _ref.toggleSearchEl,
            query = _ref.query,
            autocompleteBus = _ref.autocompleteBus;

        var options = {};
        if (toggleSearchEl) {
            options.$toggleSearch = toggleSearchEl;
        }

        _search_bar2['default'].prototype.initialize.call(this, { el: el, query: query, options: options });
        this.autocompleteBus = autocompleteBus;
        this.listenTo(this.autocompleteBus, 'quicksearch:fill', this.updateText);
    },
    updateText: function updateText(text) {
        this.$input.val(text);
    },
    shouldTriggerBlur: function shouldTriggerBlur(ev) {
        var classes = ['js-autocompletionItem', 'js-quickSearchIcon', 'js-mobileSearchIcon', 'js-mobileSearch'];
        var targetViaDocument = document.activeElement;
        var targetViaEvent = ev.relatedTarget;
        return classes.every(function (itemClass) {
            return !(targetViaDocument.classList.contains(itemClass) || targetViaEvent && !targetViaEvent.classList.contains(itemClass));
        }) || false;
    },
    keydown: function keydown(ev) {
        if (ev.which === _keycodes2['default'].UP || ev.which === _keycodes2['default'].DOWN) {
            return false;
        }
        if (ev.which === _keycodes2['default'].TAB) {
            this.blurAutocomplete();
        }
        return void 0;
    },
    blurAutocomplete: function blurAutocomplete() {
        this.autocompleteBus.trigger('quicksearch:blur');
    },
    blur: function blur(ev) {
        var _this = this;

        setTimeout(function () {
            if (_this.shouldTriggerBlur(ev)) {
                _this.blurAutocomplete();
            }
        }, 1);
    },
    focus: function focus() {
        this.autocompleteBus.trigger('quicksearch:focus');
    },


    keyupMap: new Map([[_keycodes2['default'].UP, function (self) {
        return self.autocompleteBus.trigger('quicksearch:highlightItem', -1);
    }], [_keycodes2['default'].DOWN, function (self) {
        return self.autocompleteBus.trigger('quicksearch:highlightItem', 1);
    }], [].concat(_toConsumableArray(_search_bar2['default'].prototype.keyupMap))])

});

exports['default'] = AutocompleteSearchBar;

},{"../../../util/keycodes":"C:\\projects\\lightning\\public\\ecmascript\\util\\keycodes.js","./search_bar":"C:\\projects\\lightning\\public\\ecmascript\\components\\quick_search\\views\\search_bar.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\session_expired_modal\\SessionExpiredModal.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function (_ref) {
    var signInUrl = _ref.signInUrl,
        stillTroubleText = _ref.stillTroubleText;
    return '\n<div class="modal-container" >\n    <p > ' + html('reauthenticateModal.textBody') + ' </p>\n\n    <p> ' + stillTroubleText + ' </p>\n\n    <div class="button-container">\n        <a href="' + signInUrl + '" role="button" class="button margin-small radius secondary u-allCaps" aria-label="' + html('signIn') + '">\n            ' + html('signIn') + '\n        </a>\n        <button type="button" class="button radius margin-small outline gray cancel u-allCaps">' + html('cancel') + '</button>\n    </div>\n</div>\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\session_expired_modal\\SessionExpiredModal.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _modal = require('../common/modal');

var _SessionExpiredModal = require('./SessionExpiredModal.html');

var _SessionExpiredModal2 = _interopRequireDefault(_SessionExpiredModal);

var _supportUrl = require('../../../../lib/supportUrl');

var _supportUrl2 = _interopRequireDefault(_supportUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _window = window,
    text = _window.text;

var SessionExpiredModal = function (_Modal) {
    _inherits(SessionExpiredModal, _Modal);

    function SessionExpiredModal(forwardUrl) {
        _classCallCheck(this, SessionExpiredModal);

        var supportUrl = window.routes.supportMembers;
        var signInUrl = '' + window.routes.accountInvalidCard + (forwardUrl ? '?forward=' + encodeURIComponent(forwardUrl) : '');

        var followTheseStepsLink = '<a target="_blank" href="' + supportUrl + '">' + text('pleaseContactSupport') + '</a>';
        var stillTroubleText = text('sessionExpiredModal.stillHavingTrouble', { followTheseSteps: followTheseStepsLink });
        var modalContents = {
            classes: ['SessionExpiredModal'],
            title: text('reauthenticateModal.heading'),
            content: (0, _SessionExpiredModal2['default'])({ signInUrl: signInUrl, stillTroubleText: stillTroubleText })
        };

        var _this = _possibleConstructorReturn(this, (SessionExpiredModal.__proto__ || Object.getPrototypeOf(SessionExpiredModal)).call(this, modalContents));

        _this.$el.find('.cancel').on('click', function () {
            _this.close();
        });
        return _this;
    }

    return SessionExpiredModal;
}(_modal.Modal);

exports['default'] = SessionExpiredModal;

},{"../../../../lib/supportUrl":"C:\\projects\\lightning\\lib\\supportUrl.js","../common/modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js","./SessionExpiredModal.html":"C:\\projects\\lightning\\public\\ecmascript\\components\\session_expired_modal\\SessionExpiredModal.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\site\\EventBridge.js":[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _TitleActionHandler = require('../../title-actions/TitleActionHandler');

var _TitleActionHandler2 = _interopRequireDefault(_TitleActionHandler);

var _SharedActions = require('../../title-actions/shared/SharedActions');

var _SharedActions2 = _interopRequireDefault(_SharedActions);

var _BorrowActions = require('../../title-actions/borrow/BorrowActions');

var _BorrowActions2 = _interopRequireDefault(_BorrowActions);

var _HoldActions = require('../../title-actions/holds/HoldActions');

var _HoldActions2 = _interopRequireDefault(_HoldActions);

var _RecommendActions = require('../../title-actions/recommendations/RecommendActions');

var _RecommendActions2 = _interopRequireDefault(_RecommendActions);

var _NookActions = require('../../title-actions/nook/NookActions');

var _NookActions2 = _interopRequireDefault(_NookActions);

var _StarRatingActions = require('../../title-actions/ratings/StarRatingActions');

var _StarRatingActions2 = _interopRequireDefault(_StarRatingActions);

var _ReadingHistoryActions = require('../../title-actions/history/ReadingHistoryActions');

var _ReadingHistoryActions2 = _interopRequireDefault(_ReadingHistoryActions);

var _TrackingCirculation = require('./ga/TrackingCirculation');

var _TrackingCirculation2 = _interopRequireDefault(_TrackingCirculation);

var _TrackingKindleFulfillment = require('./ga/TrackingKindleFulfillment');

var _TrackingKindleFulfillment2 = _interopRequireDefault(_TrackingKindleFulfillment);

var _TrackingSignInForms = require('./ga/TrackingSignInForms');

var _TrackingSignInForms2 = _interopRequireDefault(_TrackingSignInForms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventBridge = function () {
    function EventBridge(_ref) {
        var bus = _ref.bus,
            card = _ref.card,
            patronSettings = _ref.patronSettings,
            featureManager = _ref.featureManager,
            globalPreferences = _ref.globalPreferences;

        _classCallCheck(this, EventBridge);

        this.bus = bus;
        this.card = card;
        this.patronSettings = patronSettings;
        this.featureManager = featureManager;
        this.globalPreferences = globalPreferences;

        this.registerTitleAction();
        this.registerSharedActionHandlers();
        this.registerAnalyticsIntegrations();
    }

    _createClass(EventBridge, [{
        key: 'registerTitleAction',
        value: function registerTitleAction() {
            void new _TitleActionHandler2['default'](this.bus, this.card, this.patronSettings);
            void new _BorrowActions2['default'](this.bus, this.featureManager, this.globalPreferences);
            void new _HoldActions2['default'](this.bus);
            void new _RecommendActions2['default'](this.bus);
            void new _NookActions2['default'](this.bus);
            void new _StarRatingActions2['default'](this.bus);
            void new _ReadingHistoryActions2['default'](this.bus);
        }
    }, {
        key: 'registerSharedActionHandlers',
        value: function registerSharedActionHandlers() {
            void new _SharedActions2['default'](this.bus);
        }
    }, {
        key: 'registerAnalyticsIntegrations',
        value: function registerAnalyticsIntegrations() {
            void (window.OverDrive.gaEventLogger = new _TrackingCirculation2['default'](this.bus));
            void new _TrackingKindleFulfillment2['default'](this.bus);
            void new _TrackingSignInForms2['default'](this.bus);
        }
    }]);

    return EventBridge;
}();

module.exports = EventBridge;

},{"../../title-actions/TitleActionHandler":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\TitleActionHandler.js","../../title-actions/borrow/BorrowActions":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\borrow\\BorrowActions.js","../../title-actions/history/ReadingHistoryActions":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\history\\ReadingHistoryActions.js","../../title-actions/holds/HoldActions":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\holds\\HoldActions.js","../../title-actions/nook/NookActions":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\nook\\NookActions.js","../../title-actions/ratings/StarRatingActions":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\ratings\\StarRatingActions.js","../../title-actions/recommendations/RecommendActions":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\recommendations\\RecommendActions.js","../../title-actions/shared/SharedActions":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\shared\\SharedActions.js","./ga/TrackingCirculation":"C:\\projects\\lightning\\public\\ecmascript\\components\\site\\ga\\TrackingCirculation.js","./ga/TrackingKindleFulfillment":"C:\\projects\\lightning\\public\\ecmascript\\components\\site\\ga\\TrackingKindleFulfillment.js","./ga/TrackingSignInForms":"C:\\projects\\lightning\\public\\ecmascript\\components\\site\\ga\\TrackingSignInForms.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\site\\ga\\TrackingCirculation.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _window = window,
    url = _window.url,
    routes = _window.routes;

var TrackingCirculation = function () {
    _createClass(TrackingCirculation, [{
        key: 'isDebug',
        get: function get() {
            return _(window.ga).isEmpty();
        }
    }, {
        key: 'debugInstance',
        get: function get() {
            return {
                push: function push(_ref) {
                    var event = _ref.event,
                        content = _ref.content;

                    console.log('ga:log("' + event + '"):', { event: event, content: content }); // eslint-disable-line no-console
                }
            };
        }
    }]);

    function TrackingCirculation(bus) {
        var _this = this;

        _classCallCheck(this, TrackingCirculation);

        this.bus = bus;

        this._dataLayer = window.dataLayer || this.debugInstance;
        this._websiteId = window.OverDrive.tenant;

        this.bus.on('title:borrow:success', function (params) {
            return _this.pushEvent(params, 'titleBorrow');
        }).on('title:hold:success', function (params) {
            return _this.pushEvent(params, 'titleHold');
        }).on('title:wishlist:success', function (params) {
            return _this.pushEvent(params, 'titleWishlist');
        }).on('title:recommend:success', function (params) {
            return _this.pushEvent(params, 'titleRecommend');
        }).on('title:history:add:success', function (params) {
            return _this.pushEvent(params, 'titleHistory');
        }).on('title:download', function (params) {
            return _this.pushEvent(params, 'titleDownload');
        }).on('title:suspend', function (params) {
            return _this.pushEvent(params, 'titleSuspend');
        }).on('title:suspend:cancelled', function (params) {
            return _this.pushEvent(params, 'titleSuspendCancelled');
        });
    }

    _createClass(TrackingCirculation, [{
        key: 'pushEvent',
        value: function pushEvent(_ref2, event) {
            var titleModel = _ref2.titleModel,
                context = _ref2.context;

            var content = _.extend({}, this.getTitleProps(titleModel), this.getCollectionProps(context ? context.collectionDefinition : {}), this.getCampaignProps(titleModel.context ? titleModel.context.campaign : {}), context && context.formatId ? { formatId: context.formatId } : {}, window.featureManager.isEnabled("holdRedelivery") ? this.getSuspendTitleProps(context, titleModel, event) : {});

            if (window.featureManager.isEnabled('gaRenewRequestAgainUpdate')) {
                // Renew and request again aren't distinct events as far as lightning's api are concerned, but we
                // want to report them as distinct events.
                if (event === 'titleBorrow' && context.isRenewal) {
                    event = 'titleRenew';
                } else if (event === 'titleHold' && context.isRequestAgain) {
                    event = 'titleRequestAgain';
                }
            }
            this._dataLayer.push({ event: event, content: content });
        }
    }, {
        key: 'getTitleProps',
        value: function getTitleProps(titleModel) {
            var t = titleModel.attributes;

            return {
                mediaID: t.id,
                titleName: t.title,
                author: t.firstCreatorName,
                formatClass: t.type && t.type.id || 'unknown'
            };
        }
    }, {
        key: 'getCollectionProps',
        value: function getCollectionProps(collectionDefinition) {
            if (_(collectionDefinition).isEmpty()) {
                return {};
            }

            var c = collectionDefinition;
            return {
                listID: c.attributes.id,
                listName: c.attributes.name,
                listUrl: url(routes.collectionById, { collectionId: c.attributes.id }),
                // LHTNG-2199 - This is currently the only place in the code where these are defined as strings,
                // additionnally we have to be consistent with case sensitivity otherwise we will messup Google Analytics
                listType: c.isCurated ? 'Curated' : 'Generated',
                isLuckyDay: c.attributes.showOnlyLuckyDayAvailable
            };
        }
    }, {
        key: 'getCampaignProps',
        value: function getCampaignProps(campaign) {
            if (_(campaign).isEmpty()) {
                return {};
            }

            return {
                campaignId: campaign.id,
                campaignName: campaign.name
            };
        }
    }, {
        key: 'getSuspendTitleProps',
        value: function getSuspendTitleProps(context, titleModel, event) {
            if (event === "titleSuspend" && !_(context).isEmpty() && context.numOfDays) {
                return {
                    suspendDays: context.numOfDays,
                    isRedelivered: context.isRedelivery,
                    autoRedeliveriesCount: titleModel.get("redeliveriesAutomatedCount"),
                    requestedRedeliveryCount: titleModel.get("redeliveriesRequestedCount")
                };
            } else if (event === "titleSuspendCancelled") {
                return {
                    autoRedeliveriesCount: titleModel.get("redeliveriesAutomatedCount"),
                    requestedRedeliveryCount: titleModel.get("redeliveriesRequestedCount")
                };
            } else {
                return {};
            }
        }
    }]);

    return TrackingCirculation;
}();

exports['default'] = TrackingCirculation;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\site\\ga\\TrackingKindleFulfillment.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TrackingKindleFulfillment = function () {
    _createClass(TrackingKindleFulfillment, [{
        key: 'isDebug',
        get: function get() {
            return _(window.ga).isEmpty();
        }
    }, {
        key: 'debugInstance',
        get: function get() {
            return {
                push: function push(_ref) {
                    var event = _ref.event,
                        content = _ref.content;

                    console.log('ga:log("' + event + '"):', content); // eslint-disable-line no-console
                }
            };
        }
    }]);

    function TrackingKindleFulfillment(bus) {
        var _this = this;

        _classCallCheck(this, TrackingKindleFulfillment);

        this.bus = bus;

        this._dataLayer = window.dataLayer || this.debugInstance;

        this.bus.on('preferences:global:update:success', function (_ref2) {
            var context = _ref2.context,
                source = _ref2.source;
            return _this.pushEvent({ context: context, source: source });
        });
    }

    _createClass(TrackingKindleFulfillment, [{
        key: 'pushEvent',
        value: function pushEvent(_ref3) {
            var context = _ref3.context,
                source = _ref3.source;

            if (_(Object.keys(context.changed)).contains('kindleFulfillment')) {
                this._dataLayer.push({
                    event: 'kindleFulfillment',
                    content: {
                        source: source, // settings_page, results_filter, or content_fulfillment
                        value: context.changed.kindleFulfillment
                    }
                });
            }
        }
    }]);

    return TrackingKindleFulfillment;
}();

exports['default'] = TrackingKindleFulfillment;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\site\\ga\\TrackingSignInForms.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TrackingSignInForms = function () {
    function TrackingSignInForms(bus) {
        var _this = this;

        _classCallCheck(this, TrackingSignInForms);

        this.bus = bus;

        this._dataLayer = window.dataLayer || this.debugInstance;

        this.bus.on('signIn:library', function (params) {
            return _this.pushSignInEvent(params, 'Library Card Sign In');
        }).on('signIn:external', function (params) {
            return _this.pushSignInEvent(params, 'External Sign In');
        }).on('signIn.email', function (params) {
            return _this.pushSignInEvent(params, 'Email Sign In');
        }).on('signIn:mobileNum', function (params) {
            return _this.pushSignInEvent(params, 'Mobile Number Sign In');
        }).on('mobile:code:verified', function (params) {
            return _this.pushSignInEvent(params, 'Mobile Number Code Verified');
        }).on('mobile:code:sent', function (params) {
            return _this.pushSignInEvent(params, 'Send Mobile Verification Code');
        }).on('mobile:code:resent', function (params) {
            return _this.pushSignInEvent(params, 'Resend Mobile Verification Code');
        }).on('email:code:sent', function (params) {
            return _this.pushSignInEvent(params, 'Send Email Verification Code');
        }).on('email:code:resent', function (params) {
            return _this.pushSignInEvent(params, 'Resend Email Verification Code');
        }).on('email:code:verified', function (params) {
            return _this.pushSignInEvent(params, 'Email Code Verified');
        }).on('mobile:register:code:sent', function () {
            return _this.pushRegisterEvent("Send Mobile verification code");
        }).on('mobile:register:code:resent', function () {
            return _this.pushRegisterEvent("Resend Mobile verification code");
        }).on('mobile:register:code:verified', function () {
            return _this.pushRegisterEvent("Mobile Number Code Verified");
        }).on('mobile:register:submit', function () {
            return _this.pushRegisterEvent("Form submit");
        });
    }

    _createClass(TrackingSignInForms, [{
        key: 'pushSignInEvent',
        value: function pushSignInEvent(selectedILS, action) {
            var content = {
                event: "auth",
                eventCategory: "Authentication",
                eventAction: action,
                eventLabel: selectedILS
            };

            this._dataLayer.push(content);
        }
    }, {
        key: 'pushRegisterEvent',
        value: function pushRegisterEvent(action) {
            var content = {
                event: "register",
                eventCategory: "Sign up",
                eventAction: "Get a card",
                eventLabel: action
            };

            this._dataLayer.push(content);
        }
    }, {
        key: 'debugInstance',
        get: function get() {
            return {
                push: function push(_ref) {
                    var event = _ref.event,
                        content = _ref.content;

                    console.log('ga:log("' + event + '"):', { event: event, content: content }); // eslint-disable-line no-console
                }
            };
        }
    }]);

    return TrackingSignInForms;
}();

exports['default'] = TrackingSignInForms;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\components\\toaster\\app.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _base = require('../../views/base.js');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var path = require('path');
var template = "\n<div class=\"Toaster-toast <%- hooks.toast.substring(1) %> <%- toasterType %> animated fadeIn\" role=\"alert\">\n    <div class=\"row\">\n        <div class=\"large-10 large-centered medium-10 medium-centered columns\">\n            <div class=\"Toaster-bread\">\n                <span role=\"alert\" class=\"Toaster-message <%- hooks.message.substring(1) %> Toaster-messageContent\" tabindex=\"0\" id=\"<%= id %>\" data-message-id=\"<%= messageId %>\"><%= message %></span>\n                <span class=\"<%- hooks.close.substring(1) %> Toaster-close\" aria-label=\"<%= html('toasts.dismissAria') %>\" tabindex=\"0\" role=\"button\">&times;</span>\n            </div>\n        </div>\n    </div>\n</div>\n";

var Toaster = _base2['default'].extend({

    className: 'Toaster js-toasterContent',

    timeout: null,

    line: null,

    loaf: [],

    staleLoaf: [],

    currentToast: {},

    hooks: {
        timer: '.js-toastTimer',
        message: '.js-toastMessage',
        toast: '.js-toast',
        close: '.js-closeToast'
    },

    toasterTypes: {
        message: '',
        system: 'is-system',
        error: 'is-burnt',
        userAction: 'is-userAction'
    },

    template: _.template(template),

    events: function events() {
        return _defineProperty({}, 'click ' + this.hooks.close, 'closeToast');
    },
    initialize: function initialize(_ref2) {
        var target = _ref2.target;

        this.target = target;
    },
    closeToast: function closeToast() {
        var $element = this.$(this.hooks.message);
        var breadId = $element.attr('id');

        var keys = {
            'auto-checkout-toast': { name: 'auto-checkout-toast', value: '1' }
        };
        var value = keys[breadId];
        if (value) {
            Cookies.remove(value.name, { path: '/' });
            Cookies.set(value.name, value.value, { path: '/', expires: 365 });
        }

        if (breadId === 'system-toast') {
            var messageId = parseInt($element.attr('data-message-id'), 10);
            var cookie = Cookies.get('system-messaging');
            var newCookie = {};

            if (cookie) {
                var cookieJSON = JSON.parse(cookie);

                // If the cookie has an attribute, the cookie is valid JSON
                if (cookieJSON.oldest || cookieJSON.newest) {
                    newCookie = {
                        oldest: cookieJSON.oldest,
                        newest: cookieJSON.newest
                    };

                    if (parseInt(cookieJSON.oldest, 10) > messageId) {
                        newCookie.oldest = messageId;
                    }

                    if (parseInt(cookieJSON.newest, 10) < messageId) {
                        newCookie.newest = messageId;
                    }
                } else {
                    // User has old cookie value that was only an integer
                    // Setting this way to get the form of the proper cookie
                    newCookie = {
                        oldest: messageId,
                        newest: messageId
                    };
                }
            } else {
                // User does not have system-messaging cookie set
                newCookie = {
                    oldest: messageId,
                    newest: messageId
                };
            }

            Cookies.remove('system-messaging', { path: '/' });
            Cookies.set('system-messaging', newCookie, { path: '/', expires: 365 });
        }

        this.pop();
        // If there was a toast displaying already when the just closed toast was pushed, display that toast
        if (this.staleLoaf.length > 0) {
            this.loaf.push(this.staleLoaf.pop());
        }
        this.currentToast = {};
        this.showNextToast();
    },


    /*
     * Ensures newly generated toast is visible.
     */
    ensureVisibility: function ensureVisibility() {
        this.ensureOnTop();
        this.ensureInViewport();
        this.setPlaceholderHeight();
    },


    /*
     * Show newly popped toast on top of modal background
     */
    ensureOnTop: function ensureOnTop() {
        if ($('.reveal-modal.open').hasClass('RecommendSuccessModal') || $('.reveal-modal.open').hasClass('HoldSuccessModal')) {
            this.$el.css({
                'z-index': '99999',
                '-webkit-transform': 'translate3d(0,0,1px)',
                transform: 'translate3d(0,0,1px)',
                position: 'fixed',
                top: '0!important' });
        } else {
            this.$el.css({
                position: 'inherit'
            });
        }
    },


    /*
     * Automatically scroll to top of page on earlier android devices.
     * (They do not support position:fixed well).
     */
    ensureInViewport: function ensureInViewport() {
        var device = detectshun && detectshun.browser();
        if (device && device.bowser.android) {
            var androidVersion = parseInt(device.bowser.osversion, 10);
            if (androidVersion < 3) {
                $(window).scrollTop(0);
            }
        }
    },


    // Set height of toast placeholder so the page doesn't jump
    setPlaceholderHeight: function setPlaceholderHeight() {
        $('.js-toastPlaceholder').css('height', this.$el.height());
    },


    /*
     * Generate a success toast message
     * @param {string} bread The message to place in the toast
     * @param {string} toasterType Type of toast
     * @param {string} id Id of the toast
     * @param {int} messageId Message id of system toasts. Needed only for system toasts
     */
    push: function push(message) {
        var toasterType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'message';
        var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
        var messageId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

        if (message && message !== '') {
            this.loaf.push({ message: message, toasterType: toasterType, id: id, messageId: messageId });
        }
        this.showNextToast();
    },


    /*
     * Push array of system messages to loaf
     * @param msgArr Array of system messages
     */
    bulkSystemMsgPush: function bulkSystemMsgPush(msgArr) {
        this.loaf = this.loaf.concat(msgArr); // Load all messages into array
        this.showNextToast(); // Show latest message
    },


    /*
     * Show next message in loaf
     */
    showNextToast: function showNextToast() {
        if (this.loaf.length > 0) {
            var nextToast = this.loaf.pop();
            nextToast.toasterType = this.toasterTypes[nextToast.toasterType] || nextToast.toasterType;
            // Do not stack user action (borrow, hold, wishlist) toasts
            if (!_.isEmpty(this.currentToast) && this.currentToast.toasterType !== this.toasterTypes.userAction) {
                this.staleLoaf.push(this.currentToast);
            }
            this.generateToast(nextToast);
            this.currentToast = nextToast;
            this.ensureVisibility();
        } else {
            // Stop showing toast placeholder
            $('.js-toastPlaceholder').hide();
            $(window).unbind('scroll.toast');
        }
    },


    /*
     * Generate toast UI
     * @param data Toast object
     */
    generateToast: function generateToast(data) {
        var _this = this;

        var defaultTemplateData = {
            hooks: this.hooks,
            toasterType: this.toasterTypes.message,
            messageId: 0
        };
        var templateData = _.extend({}, defaultTemplateData, data);
        this.pop();
        this.render({ templateData: templateData });
        this._stickToast();
        $(window).on('orientationchange', function () {
            _this._stickToast();
        });
        $(window).on('resize', function () {
            _this._stickToast();
        });
        this.$(this.hooks.message).focus();
    },


    /*
     * Remove the currently displayed toast message
     */
    pop: function pop() {
        var toast = this.$(this.hooks.toast);
        toast.removeClass('animated fadeIn').addClass('animated fadeOut');
        toast.one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', toast.remove());
    },


    /*
     * Make the toast message sticky
     * @private
     */
    _stickToast: function _stickToast() {
        var width = $(window).width();
        var scrollTop = $(window).scrollTop() - $('.js-toaster').outerHeight(true);
        var toast = this.$el;
        var skipHeight = $('div.skip-links').is(':visible') ? $('div.skip-links').outerHeight(true) : 0;
        var mobileNavHeight = $('.js-mobileNav').outerHeight(true);
        var navMenuHeight = $('.js-nav').is(':visible') ? $('.js-nav').outerHeight(true) : 0;
        var expandedSearchHeight = $('.js-nav-search-drop').is(':visible') ? $('.js-nav-search-drop').outerHeight(true) : 0;
        var navHeight = 0;

        // Mobile toaster logic
        if (width <= 870) {
            navHeight = navMenuHeight + mobileNavHeight + skipHeight;
        } else if (width > 870) {
            // Desktop toaster logic
            navHeight = navMenuHeight + expandedSearchHeight + skipHeight;
        }

        // If the recommendation or hold success modal is open, take special action with toast
        // Otherwise, handle toast as normal
        if ($('.reveal-modal.open').hasClass('RecommendSuccessModal') || $('.reveal-modal.open').hasClass('js-holdSuccessModal')) {
            // Sets position to fixed and top to 0
            toast.addClass('sticky');
        } else {
            this.$el.css({
                position: 'inherit',
                'z-index': '998'
            });

            toast.css('top', navHeight);
            if (scrollTop >= navHeight) {
                toast.addClass('sticky');
                $('.js-toastPlaceholder').show();
            } else {
                toast.removeClass('sticky');
                $('.js-toastPlaceholder').hide();
            }

            $(window).on('scroll.toast', function () {
                toast.toggleClass('sticky', $(window).scrollTop() > navHeight);
                if (toast.hasClass('sticky')) {
                    $('.js-toastPlaceholder').show();
                } else {
                    $('.js-toastPlaceholder').hide();
                }
            });
        }
    }
});

exports['default'] = new Toaster({ target: '.js-toaster' });


},{"../../views/base.js":"C:\\projects\\lightning\\public\\ecmascript\\views\\base.js","path":"C:\\projects\\lightning\\node_modules\\path-browserify\\index.js"}],"C:\\projects\\lightning\\public\\ecmascript\\components\\visitor_action_disallowed_modal\\VisitorActionDisallowedModal.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _modal = require('../common/modal');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _window = window,
    text = _window.text;

var VisitorActionDisallowedModal = function (_Modal) {
    _inherits(VisitorActionDisallowedModal, _Modal);

    function VisitorActionDisallowedModal(action) {
        _classCallCheck(this, VisitorActionDisallowedModal);

        var actionText = text('visitorActionDisallowedModal.' + action.trim().toLowerCase());
        if (!actionText) {
            throw new Error('\'' + action + '\' is not a supported action');
        }
        var message = text('visitorActionDisallowedModal.message', { libraryName: window.OverDrive.libraryName, action: actionText });
        var modalContents = {
            classes: ['VisitorActionDisallowedModal'],
            title: text('visitorActionDisallowedModal.heading'),
            content: '<p>' + message + '</p>\n                        <div class=\'button-container\'>\n                            <button type=\'button\' class=\'confirm-button button radius secondary contrast u-allCaps\'>' + html('ok') + '</button>\n                        </div>'
        };

        var _this = _possibleConstructorReturn(this, (VisitorActionDisallowedModal.__proto__ || Object.getPrototypeOf(VisitorActionDisallowedModal)).call(this, modalContents));

        _this.$el.find('.confirm-button').on('click', function () {
            _this.close();
        });
        return _this;
    }

    return VisitorActionDisallowedModal;
}(_modal.Modal);

exports['default'] = VisitorActionDisallowedModal;

},{"../common/modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js"}],"C:\\projects\\lightning\\public\\ecmascript\\document_ready.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _main = require('./components/quick_search/main.js');

var _main2 = _interopRequireDefault(_main);

var _main3 = require('./components/holdInformation/main.js');

var _main4 = _interopRequireDefault(_main3);

var _main5 = require('./components/language_selection/main.js');

var _main6 = _interopRequireDefault(_main5);

var _main7 = require('./components/mobile_account_menu/main.js');

var _main8 = _interopRequireDefault(_main7);

var _expensiveDomTraversalForDyslexicIfCookiePleaseDoNotUse = require('./util/dyslexic/expensiveDomTraversalForDyslexicIfCookiePleaseDoNotUse.js');

var _expensiveDomTraversalForDyslexicIfCookiePleaseDoNotUse2 = _interopRequireDefault(_expensiveDomTraversalForDyslexicIfCookiePleaseDoNotUse);

var _removeCarouselFunctionality = require('./util/compatibility/removeCarouselFunctionality.js');

var _HistoryEventTracker = require('./components/history_event_tracker/HistoryEventTracker');

var _HistoryEventTracker2 = _interopRequireDefault(_HistoryEventTracker);

var _svgLoader = require('./util/svgLoader');

var _svgLoader2 = _interopRequireDefault(_svgLoader);

var _cookieSettingsModal = require('./components/cookie_settings_modal/cookieSettingsModal');

var _cookieSettingsModal2 = _interopRequireDefault(_cookieSettingsModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/*
 * A function full of functions to be run on document ready
 */
var onDocumentReady = function onDocumentReady() {

    var device = detectshun.browser();

    (0, _main6['default'])({
        el: document.querySelector('.js-languageSelection'),
        footerEl: document.querySelector('.js-languageSelectionFooter'),
        mobileEl: document.querySelector('.js-languageMobileSelection'),
        mobileFooterEl: document.querySelector('.js-languageMobileSelectionFooter')
    });

    // Create and attach holds ratio help modal
    (0, _main4['default'])({
        el: document.querySelector('body')
    });

    // Create and attach desktop autocomplete component
    (0, _main2['default'])({
        searchEl: document.querySelector('.js-desktopSearchContainer'),
        autocompletionsEl: document.querySelector('.js-quickSearchAutocompletionsDesktop'),
        toggleSearchEl: $('.desktop .js-toggleSearch'),
        options: { desktop: true }
    });

    // Create and attach mobile autocomplete component
    (0, _main2['default'])({
        searchEl: document.querySelector('.js-mobileSearchContainer'),
        autocompletionsEl: document.querySelector('.js-quickSearchAutocompletionsMobile'),
        toggleSearchEl: $('.desktop .js-toggleSearch'),
        options: { mobile: true }
    });

    (0, _main8['default'])({
        el: document.querySelector('.nav-container')
    });

    // Do expensive traversal for dyslexic if cookie set
    (0, _expensiveDomTraversalForDyslexicIfCookiePleaseDoNotUse2['default'])();

    // Remove carousel functionality on old androids
    (0, _removeCarouselFunctionality.removeCarouselFunctionForOldAndroid)(device);

    // new history tracker using cookies for auto scroll and back button redirect
    new _HistoryEventTracker2['default']();

    (0, _svgLoader2['default'])();

    if (window.OverDrive.showCookieSettingsModal) {
        new _cookieSettingsModal2['default']({ isDismissable: false }).render();
    }

    $('.cookieSettingsButton').on('click', function () {
        new _cookieSettingsModal2['default']({ isDismissable: true }).render();
    });
};

exports['default'] = onDocumentReady;

},{"./components/cookie_settings_modal/cookieSettingsModal":"C:\\projects\\lightning\\public\\ecmascript\\components\\cookie_settings_modal\\cookieSettingsModal.js","./components/history_event_tracker/HistoryEventTracker":"C:\\projects\\lightning\\public\\ecmascript\\components\\history_event_tracker\\HistoryEventTracker.js","./components/holdInformation/main.js":"C:\\projects\\lightning\\public\\ecmascript\\components\\holdInformation\\main.js","./components/language_selection/main.js":"C:\\projects\\lightning\\public\\ecmascript\\components\\language_selection\\main.js","./components/mobile_account_menu/main.js":"C:\\projects\\lightning\\public\\ecmascript\\components\\mobile_account_menu\\main.js","./components/quick_search/main.js":"C:\\projects\\lightning\\public\\ecmascript\\components\\quick_search\\main.js","./util/compatibility/removeCarouselFunctionality.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\compatibility\\removeCarouselFunctionality.js","./util/dyslexic/expensiveDomTraversalForDyslexicIfCookiePleaseDoNotUse.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\dyslexic\\expensiveDomTraversalForDyslexicIfCookiePleaseDoNotUse.js","./util/svgLoader":"C:\\projects\\lightning\\public\\ecmascript\\util\\svgLoader.js"}],"C:\\projects\\lightning\\public\\ecmascript\\global_bindings.js":[function(require,module,exports){
'use strict';

var _document_ready = require('./document_ready');

var _document_ready2 = _interopRequireDefault(_document_ready);

var _window_pageshow = require('./window_pageshow');

var _window_pageshow2 = _interopRequireDefault(_window_pageshow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// ****** Bindings To Native Events On Window ******
$(window).bind('pageshow', _window_pageshow2['default']);

// ****** Bindings To Native Events On Document ******
$(document).ready(_document_ready2['default']);

},{"./document_ready":"C:\\projects\\lightning\\public\\ecmascript\\document_ready.js","./window_pageshow":"C:\\projects\\lightning\\public\\ecmascript\\window_pageshow.js"}],"C:\\projects\\lightning\\public\\ecmascript\\global_bootstrapping.js":[function(require,module,exports){
'use strict';

var _query = require('./util/query.js');

var _routes = require('./util/routes.js');

var _browser = require('../../lib/i18n/browser');

var _stripNoLinkedCardQuery = require('./util/url/stripNoLinkedCardQuery.js');

var _stripNoLinkedCardQuery2 = _interopRequireDefault(_stripNoLinkedCardQuery);

var _getCookieExplanation = require('./util/toast/getCookieExplanation.js');

var _getCookieExplanation2 = _interopRequireDefault(_getCookieExplanation);

var _rfc3986EncodeURIComponent = require('./util/encoding/rfc3986EncodeURIComponent.js');

var _rfc3986EncodeURIComponent2 = _interopRequireDefault(_rfc3986EncodeURIComponent);

var _scrollCarousel = require('./util/carousel/scrollCarousel.js');

var _scrollCarousel2 = _interopRequireDefault(_scrollCarousel);

var _hideCarouselArrows = require('./util/carousel/hideCarouselArrows.js');

var _hideCarouselArrows2 = _interopRequireDefault(_hideCarouselArrows);

var _hideArrowsOnEndOfScroll = require('./util/carousel/hideArrowsOnEndOfScroll.js');

var _hideArrowsOnEndOfScroll2 = _interopRequireDefault(_hideArrowsOnEndOfScroll);

var _arrowTabAccountMenu = require('./util/account/arrowTabAccountMenu.js');

var _arrowTabAccountMenu2 = _interopRequireDefault(_arrowTabAccountMenu);

var _arrowTabMenu = require('./util/compatibility/arrowTabMenu.js');

var _arrowTabMenu2 = _interopRequireDefault(_arrowTabMenu);

var _onunload = require('./util/compatibility/onunload.js');

var _onunload2 = _interopRequireDefault(_onunload);

var _getQueryParams = require('./util/url/getQueryParams.js');

var _getQueryParams2 = _interopRequireDefault(_getQueryParams);

var _addDays = require('./util/dates/addDays.js');

var _addDays2 = _interopRequireDefault(_addDays);

var _replaceQueryParam = require('./util/url/replaceQueryParam.js');

var _replaceQueryParam2 = _interopRequireDefault(_replaceQueryParam);

var _addQueryParam = require('./util/url/addQueryParam.js');

var _addQueryParam2 = _interopRequireDefault(_addQueryParam);

var _componentToHex = require('./util/colors/componentToHex.js');

var _componentToHex2 = _interopRequireDefault(_componentToHex);

var _rgbToHex = require('./util/colors/rgbToHex.js');

var _rgbToHex2 = _interopRequireDefault(_rgbToHex);

var _processInstantForwardActions = require('./util/title-actions/processInstantForwardActions.js');

var _processInstantForwardActions2 = _interopRequireDefault(_processInstantForwardActions);

var _setUserStarRating = require('./util/title-actions/setUserStarRating.js');

var _setUserStarRating2 = _interopRequireDefault(_setUserStarRating);

var _fillStars = require('./util/title-actions/fillStars.js');

var _fillStars2 = _interopRequireDefault(_fillStars);

var _selectStarRating = require('./util/title-actions/selectStarRating.js');

var _selectStarRating2 = _interopRequireDefault(_selectStarRating);

var _openHoldConflictModal = require('./util/title-actions/openHoldConflictModal.js');

var _openHoldConflictModal2 = _interopRequireDefault(_openHoldConflictModal);

var _handleForwardActionHold = require('./util/title-actions/handleForwardActionHold.js');

var _handleForwardActionHold2 = _interopRequireDefault(_handleForwardActionHold);

var _noCard = require('./util/noCard.js');

var _noCard2 = _interopRequireDefault(_noCard);

var _findFormatId = require('./util/findFormatId.js');

var _findFormatId2 = _interopRequireDefault(_findFormatId);

var _app = require('./components/toaster/app.js');

var _app2 = _interopRequireDefault(_app);

var _Title = require('./components/media/models/Title.js');

var _Title2 = _interopRequireDefault(_Title);

var _featureManagerBuilder = require('../../lib/featureManagerBuilder');

var _featureManagerBuilder2 = _interopRequireDefault(_featureManagerBuilder);

var _supportUrl = require('../../lib/supportUrl');

var _supportUrl2 = _interopRequireDefault(_supportUrl);

var _forwardedActions = require('./util/forwardedActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Attaching Functions to Global Namespace
// Remove all of these ASAP
// TODO: The number of accesses to ambient function bits seems to be mounting, trying to decide if there is a better way to reference these
// Idea! - Make a class that is an aggregate of all the .locals functions and expose it such that the front and back end can import it

// Imports for Global Namespace Purposes
window.featureManager = (0, _featureManagerBuilder2['default'])(OverDrive.libraryConfigurations, OverDrive.tenant, OverDrive.allFeatures, OverDrive.features);
window.Title = _Title2['default'];
window.removeQueryParam = _query.removeQueryParam;
window.routes = _routes.routes;
window.url = _routes.url;
window.supportUrl = _supportUrl2['default'];
window.html = _browser.html;
window.text = _browser.text;
window.stripNoLinkedCardQuery = _stripNoLinkedCardQuery2['default'];
window.getCookieExplanation = _getCookieExplanation2['default'];
window.rfc3986EncodeURIComponent = _rfc3986EncodeURIComponent2['default'];
window.scrollCarousel = _scrollCarousel2['default'];
window.hideCarouselArrows = _hideCarouselArrows2['default'];
window.hideArrowsOnEndOfScroll = _hideArrowsOnEndOfScroll2['default'];
window.arrowTabAccountMenu = _arrowTabAccountMenu2['default'];
window.arrowTabMenu = _arrowTabMenu2['default'];
window.onunload = _onunload2['default'];
window.getQueryParams = _getQueryParams2['default'];
window.addDays = _addDays2['default'];
window.replaceQueryParam = _replaceQueryParam2['default'];
window.addQueryParam = _addQueryParam2['default'];
window.componentToHex = _componentToHex2['default'];
window.rgbToHex = _rgbToHex2['default'];
window.processInstantForwardActions = _processInstantForwardActions2['default'];
window.setUserStarRating = _setUserStarRating2['default'];
window.fillStars = _fillStars2['default'];
window.selectStarRating = _selectStarRating2['default'];
window.openHoldConflictModal = _openHoldConflictModal2['default'];
window.handleForwardActionHold = _handleForwardActionHold2['default'];
window.noCard = _noCard2['default'];
window.findFormatId = _findFormatId2['default'];
window.toaster = _app2['default'];

// Moved to allow window.routes to be set first to avoid inclusion order errors

window.recommend = _forwardedActions.recommend;

/**
 * Global event handler
 * Used for consuming component level events that are better
 * handled at the global level
 * Do not go attaching events to this all willy nilly!
 */
window.globalEvents = _.clone(window.Backbone.Events);

},{"../../lib/featureManagerBuilder":"C:\\projects\\lightning\\lib\\featureManagerBuilder.js","../../lib/i18n/browser":"C:\\projects\\lightning\\lib\\i18n\\browser\\index.js","../../lib/supportUrl":"C:\\projects\\lightning\\lib\\supportUrl.js","./components/media/models/Title.js":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\models\\Title.js","./components/toaster/app.js":"C:\\projects\\lightning\\public\\ecmascript\\components\\toaster\\app.js","./util/account/arrowTabAccountMenu.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\account\\arrowTabAccountMenu.js","./util/carousel/hideArrowsOnEndOfScroll.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\carousel\\hideArrowsOnEndOfScroll.js","./util/carousel/hideCarouselArrows.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\carousel\\hideCarouselArrows.js","./util/carousel/scrollCarousel.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\carousel\\scrollCarousel.js","./util/colors/componentToHex.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\colors\\componentToHex.js","./util/colors/rgbToHex.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\colors\\rgbToHex.js","./util/compatibility/arrowTabMenu.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\compatibility\\arrowTabMenu.js","./util/compatibility/onunload.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\compatibility\\onunload.js","./util/dates/addDays.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\dates\\addDays.js","./util/encoding/rfc3986EncodeURIComponent.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\encoding\\rfc3986EncodeURIComponent.js","./util/findFormatId.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\findFormatId.js","./util/forwardedActions":"C:\\projects\\lightning\\public\\ecmascript\\util\\forwardedActions.js","./util/noCard.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\noCard.js","./util/query.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\query.js","./util/routes.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\routes.js","./util/title-actions/fillStars.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\title-actions\\fillStars.js","./util/title-actions/handleForwardActionHold.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\title-actions\\handleForwardActionHold.js","./util/title-actions/openHoldConflictModal.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\title-actions\\openHoldConflictModal.js","./util/title-actions/processInstantForwardActions.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\title-actions\\processInstantForwardActions.js","./util/title-actions/selectStarRating.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\title-actions\\selectStarRating.js","./util/title-actions/setUserStarRating.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\title-actions\\setUserStarRating.js","./util/toast/getCookieExplanation.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\toast\\getCookieExplanation.js","./util/url/addQueryParam.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\url\\addQueryParam.js","./util/url/getQueryParams.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\url\\getQueryParams.js","./util/url/replaceQueryParam.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\url\\replaceQueryParam.js","./util/url/stripNoLinkedCardQuery.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\url\\stripNoLinkedCardQuery.js"}],"C:\\projects\\lightning\\public\\ecmascript\\models\\Card.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var routes = window.routes;
var Cookies = window.Cookies;
var numbers = require('../../../lib/numbers');

var Card = function (_Backbone$Model) {
    _inherits(Card, _Backbone$Model);

    _createClass(Card, [{
        key: 'defaults',
        value: function defaults() {
            return {
                holdLimit: 0,
                accounts: [],
                lastHoldEmail: '',
                bestLibraryKey: '',
                displayName: '',
                email: '',
                canPlaceHolds: true,
                canRecommendTitles: true,
                isVisitingCard: false,

                checkoutLimitsByMediaType: {
                    periodical: 0,
                    video: 0,
                    audiobook: 0,
                    ebook: 0
                }
            };
        }

        // 'Client Account Cookie' - AuthUtility is aware of this cookie and clears is on SignOut

    }]);

    function Card() {
        _classCallCheck(this, Card);

        var _this = _possibleConstructorReturn(this, (Card.__proto__ || Object.getPrototypeOf(Card)).apply(this, arguments));

        _this.url = routes.rest.account.get;
        _this._key = '_cac';


        if (window.OverDrive.isAuthenticated && window.OverDrive.hasLinkedCards) {
            if (_this._hasCachedModel) {
                _this.set(_this._cacheGet());

                // _fetch should only be used for async syncing and not for raw data access
                _this._fetch = Promise.resolve();
            } else {
                _this._fetch = _this.fetch();
                _this._fetch.then(function () {
                    return _this._cacheSet(_this.attributes);
                });
            }
        }
        return _this;
    }

    _createClass(Card, [{
        key: 'setHoldEmail',
        value: function setHoldEmail(email) {
            this.set({ lastHoldEmail: email });

            this._cacheSet(this.attributes);
        }
    }, {
        key: 'setAllowReadingHistory',
        value: function setAllowReadingHistory(allow) {
            this.set('allowReadingHistory', !!allow);
            this._cacheSet(this.attributes);
        }
    }, {
        key: '_cacheGet',
        value: function _cacheGet() {
            return JSON.parse(Cookies.get(this._key) || '{}');
        }
    }, {
        key: 'cacheReset',
        value: function cacheReset() {
            var _this2 = this;

            if (window.OverDrive.isAuthenticated && window.OverDrive.hasLinkedCards) {
                Cookies.remove(this._key);
                this._fetch = this.fetch();
                return this._fetch.then(function () {
                    return _this2._cacheSet(_this2.attributes);
                });
            }
            return Promise.resolve();
        }
    }, {
        key: '_cacheSet',
        value: function _cacheSet(model) {
            Cookies.set(this._key, JSON.stringify(model), {
                expires: new Date(new Date().getTime() + 10 * numbers.minuteInMilliseconds)
            });
        }
    }, {
        key: 'preferredHoldEmail',
        get: function get() {
            return this.get('lastHoldEmail') || this.get('this.email') || '';
        }
    }, {
        key: '_hasCachedModel',
        get: function get() {
            return !_(this._cacheGet()).isEmpty();
        }
    }, {
        key: 'canPlaceHolds',
        get: function get() {
            return this.get('canPlaceHolds');
        }
    }, {
        key: 'canRecommendTitles',
        get: function get() {
            return this.get('canRecommendTitles');
        }
    }, {
        key: 'isVisitingCard',
        get: function get() {
            return this.get('isVisitingCard');
        }
    }]);

    return Card;
}(Backbone.Model);

exports['default'] = Card;

},{"../../../lib/numbers":"C:\\projects\\lightning\\lib\\numbers.js"}],"C:\\projects\\lightning\\public\\ecmascript\\models\\GlobalPreferences.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _numbers = require('../../../lib/numbers');

var _numbers2 = _interopRequireDefault(_numbers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _window = window,
    _url = _window.url,
    routes = _window.routes,
    Cookies = _window.Cookies;

// Fakeing in the path for now ...

routes.rest.preferences = { global: { index: '/rest/preferences/global/' } };

var GlobalPreferences = function (_Backbone$Model) {
    _inherits(GlobalPreferences, _Backbone$Model);

    _createClass(GlobalPreferences, [{
        key: 'url',
        value: function url() {
            return _url(routes.rest.preferences.global.index);
        }

        // Cookie Cache Key: 'Global Account Preferences'

    }, {
        key: 'isNew',
        value: function isNew() {
            return false;
        }
    }, {
        key: 'defaults',
        value: function defaults() {
            return {
                kindleFulfillment: null
            };
        }
    }]);

    function GlobalPreferences(attributes, _ref) {
        var bus = _ref.bus;

        _classCallCheck(this, GlobalPreferences);

        var _this = _possibleConstructorReturn(this, (GlobalPreferences.__proto__ || Object.getPrototypeOf(GlobalPreferences)).apply(this, arguments));

        _this._key = '_gap';

        _this.bus = bus;

        _this._initCache();
        return _this;
    }

    _createClass(GlobalPreferences, [{
        key: 'setKindleFulfillmentPreference',
        value: function setKindleFulfillmentPreference() {
            var _this2 = this;

            var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var source = arguments[1];

            return new Promise(function (resolve, reject) {
                _this2.save({ kindleFulfillment: !!enabled }, {
                    patch: true,
                    wait: true,
                    success: function success(context) {
                        _this2.bus.trigger('preferences:global:update:success', { context: context, source: source });
                        _this2._cacheSet(_this2.attributes);
                        resolve();
                    },
                    error: function error(_error) {
                        reject(_error);
                    }
                });
            });
        }

        // -- Caching Functionality -----------------------------------------------

    }, {
        key: '_initCache',
        value: function _initCache() {
            var _this3 = this;

            if (window.OverDrive.isAuthenticated && window.OverDrive.hasLinkedCards) {
                if (this._hasCachedModel) {
                    this.set(this._cacheGet());

                    // _fetch should only be used for async syncing and not for raw data access
                    this._fetch = Promise.resolve();
                } else {
                    this._fetch = this.fetch();
                    this._fetch.then(function () {
                        _this3._cacheSet(_this3.attributes);
                    });
                }
            }
        }
    }, {
        key: '_cacheGet',
        value: function _cacheGet() {
            return JSON.parse(Cookies.get(this._key) || '{}');
        }
    }, {
        key: '_cacheSet',
        value: function _cacheSet(model) {
            Cookies.set(this._key, JSON.stringify(model), {
                expires: new Date(new Date().getTime() + 10 * _numbers2['default'].minuteInMilliseconds)
            });
        }
    }, {
        key: '_hasCachedModel',
        get: function get() {
            return !_(this._cacheGet()).isEmpty();
        }
    }]);

    return GlobalPreferences;
}(Backbone.Model);

exports['default'] = GlobalPreferences;

},{"../../../lib/numbers":"C:\\projects\\lightning\\lib\\numbers.js"}],"C:\\projects\\lightning\\public\\ecmascript\\models\\base.js":[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// import when we move more to modules
exports["default"] = window.Backbone.Model;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\models\\patron_media_items.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _base = require('../models/base');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PatronMediaItemsModel = _base2['default'].extend({
    url: function url() {
        return window.url(window.routes.mediaInfo);
    },
    initialize: function initialize(_ref) {
        var titles = _ref.titles;

        this.mediaItems = titles || window.OverDrive.titleCollection || {};
        this.itemsOnPage = _.map(_.pluck(this.mediaItems, 'id'), Number);
    },
    initialFetch: function initialFetch() {
        return this.mediaItems.length ? this.fetch({
            data: JSON.stringify({ titleIds: this.itemsOnPage }),
            type: 'POST', contentType: 'application/json',
            headers: { 'csrf-token': $('#csrf').val() || OverDrive._csrf } }) : Promise.resolve({});
    }
});

exports['default'] = PatronMediaItemsModel;

},{"../models/base":"C:\\projects\\lightning\\public\\ecmascript\\models\\base.js"}],"C:\\projects\\lightning\\public\\ecmascript\\models\\preferences.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _base = require('./base');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* node-env browser */

var toJSONMapper = {
    automaticHoldCheckout: 'auto-checkout-setting',
    audience: 'audience-setting',
    highContrast: 'high-contrast',
    dyslexic: 'dyslexic',
    languageSelection: 'language-selection',
    kindleFulfillment: 'kindleFulfillment'
};

var PreferencesModel = _base2['default'].extend({
    initialize: function initialize() {
        this.on('change:automaticHoldCheckout', this.updateHolds.bind(this));
    },
    url: function url() {
        return window.url(window.routes.preferences);
    },
    isNew: function isNew() {
        return false;
    },
    getParsedAudience: function getParsedAudience(audience) {
        return _.filter(_.map(_.pairs(audience), function (item) {
            return item[1] === true && item[0];
        }));
    },
    parseBootstrappedData: function parseBootstrappedData(_ref) {
        var audience = _ref.audience,
            highContrast = _ref.highContrast,
            automaticHoldCheckout = _ref.automaticHoldCheckout,
            dyslexic = _ref.dyslexic,
            languageSelection = _ref.languageSelection,
            kindleFulfillment = _ref.kindleFulfillment;

        this.set(_.extend({ audience: this.getParsedAudience(audience) }, {
            automaticHoldCheckout: !!automaticHoldCheckout,
            highContrast: !!highContrast,
            dyslexic: !!dyslexic,
            languageSelection: languageSelection,
            kindleFulfillment: kindleFulfillment
        }), { silent: true });
    },
    getPatchData: function getPatchData() {
        var changedAttributes = _.keys(this.changedAttributes());
        var toJSON = this.toJSON();
        var data = {};

        changedAttributes.forEach(function (item) {
            data[toJSONMapper[item]] = toJSON[toJSONMapper[item]];
        });

        return _.omit(data, function (value) {
            return value === void 0;
        });
    },
    toJSON: function toJSON() {
        var _toJSON;

        var toJSON = (_toJSON = {}, _defineProperty(_toJSON, toJSONMapper.audience, this.get('audience')), _defineProperty(_toJSON, toJSONMapper.automaticHoldCheckout, this.get('automaticHoldCheckout')), _defineProperty(_toJSON, toJSONMapper.highContrast, this.get('highContrast')), _defineProperty(_toJSON, toJSONMapper.dyslexic, this.get('dyslexic')), _defineProperty(_toJSON, toJSONMapper.languageSelection, this.get('languageSelection')), _defineProperty(_toJSON, toJSONMapper.kindleFulfillment, this.get('kindleFulfillment')), _toJSON);
        return _.omit(toJSON, function (value) {
            return value === void 0;
        });
    },
    updateHolds: function updateHolds() {
        // Updates all previously held items to match new autocheckout setting
        var autoCheckout = this.get('automaticHoldCheckout');
        $.ajax({
            url: window.url(window.routes.updateHoldSettings),
            contentType: 'application/json',
            type: 'POST',
            data: JSON.stringify({ shouldAutoCheckout: autoCheckout })
        });
        // Update all previously held rtl
        $.ajax({
            url: window.url(window.routes.rest.recommended.updateRtlAutoCheckout),
            contentType: 'application/json',
            type: 'PUT',
            data: JSON.stringify({ enableAutocheckout: autoCheckout })
        });
    }
});

exports['default'] = PreferencesModel;

},{"./base":"C:\\projects\\lightning\\public\\ecmascript\\models\\base.js"}],"C:\\projects\\lightning\\public\\ecmascript\\pages\\all.js":[function(require,module,exports){
'use strict';

require('es5-shim');

require('babel-polyfill');

var _global_bootstrapping = require('../global_bootstrapping.js');

var _global_bootstrapping2 = _interopRequireDefault(_global_bootstrapping);

var _global_bindings = require('../global_bindings.js');

var _global_bindings2 = _interopRequireDefault(_global_bindings);

var _logger = require('../util/logging/logger');

var _logger2 = _interopRequireDefault(_logger);

var _EventBridge = require('../components/site/EventBridge');

var _EventBridge2 = _interopRequireDefault(_EventBridge);

var _Card = require('../models/Card');

var _Card2 = _interopRequireDefault(_Card);

var _GlobalPreferences = require('../models/GlobalPreferences');

var _GlobalPreferences2 = _interopRequireDefault(_GlobalPreferences);

var _HighlightedFeatureState = require('../../../models/HighlightedFeatureState');

var _HighlightedFeatureState2 = _interopRequireDefault(_HighlightedFeatureState);

var _FeatureHighlightManager = require('../util/FeatureHighlightManager');

var _FeatureHighlightManager2 = _interopRequireDefault(_FeatureHighlightManager);

var _cookieConfig = require('../../../lib/cookieConfig');

var _cookieConfig2 = _interopRequireDefault(_cookieConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

window.Logger = _logger2['default'];

void (_global_bootstrapping2['default'], _global_bindings2['default']);

window.globalPreferences = new _GlobalPreferences2['default']({}, { bus: window.globalEvents });
window.card = new _Card2['default']();

void new _EventBridge2['default']({
    bus: window.globalEvents,
    card: window.card,
    patronSettings: window.patronSettings,
    featureManager: window.featureManager,
    globalPreferences: window.globalPreferences
});

window.OverDrive.highlightedFeatureState = new _HighlightedFeatureState2['default'](Cookies.get(_cookieConfig2['default'].visitedFeatures.name) || '0', window.featureManager, window.OverDrive.hasPartnerLibraries);
window.OverDrive.featureHighlightManager = new _FeatureHighlightManager2['default'](window.OverDrive.highlightedFeatureState);

},{"../../../lib/cookieConfig":"C:\\projects\\lightning\\lib\\cookieConfig.js","../../../models/HighlightedFeatureState":"C:\\projects\\lightning\\models\\HighlightedFeatureState.js","../components/site/EventBridge":"C:\\projects\\lightning\\public\\ecmascript\\components\\site\\EventBridge.js","../global_bindings.js":"C:\\projects\\lightning\\public\\ecmascript\\global_bindings.js","../global_bootstrapping.js":"C:\\projects\\lightning\\public\\ecmascript\\global_bootstrapping.js","../models/Card":"C:\\projects\\lightning\\public\\ecmascript\\models\\Card.js","../models/GlobalPreferences":"C:\\projects\\lightning\\public\\ecmascript\\models\\GlobalPreferences.js","../util/FeatureHighlightManager":"C:\\projects\\lightning\\public\\ecmascript\\util\\FeatureHighlightManager.js","../util/logging/logger":"C:\\projects\\lightning\\public\\ecmascript\\util\\logging\\logger.js","babel-polyfill":"C:\\projects\\lightning\\node_modules\\babel-polyfill\\lib\\index.js","es5-shim":"C:\\projects\\lightning\\node_modules\\es5-shim\\es5-shim.js"}],"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\Preview.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _modal = require('../components/common/modal');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Preview = function () {
    function Preview(bus) {
        _classCallCheck(this, Preview);

        this.bus = bus;
    }

    _createClass(Preview, [{
        key: 'giveSample',
        value: function giveSample(titleModel) {
            var opts = {
                autoShow: false,
                title: titleModel.get('title'),
                content: '<iframe src="' + titleModel.get('sample').href + '"></iframe>',
                classes: ['sample-modal'],
                closeOnEsc: true,
                closeOnBlur: true,
                showCloseButton: true
            };
            this.modal = new _modal.Modal(opts);
            this.modal.show();
        }
    }]);

    return Preview;
}();

exports['default'] = Preview;

},{"../components/common/modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js"}],"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\TitleActionHandler.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Borrow = require('./borrow/Borrow');

var _Borrow2 = _interopRequireDefault(_Borrow);

var _Wishlist = require('./wishlist/Wishlist');

var _Wishlist2 = _interopRequireDefault(_Wishlist);

var _Hold = require('./holds/Hold');

var _Hold2 = _interopRequireDefault(_Hold);

var _Recommend = require('./recommendations/Recommend');

var _Recommend2 = _interopRequireDefault(_Recommend);

var _Nook = require('./nook/Nook');

var _Nook2 = _interopRequireDefault(_Nook);

var _StarRating = require('./ratings/StarRating');

var _StarRating2 = _interopRequireDefault(_StarRating);

var _ReadingHistory = require('./history/ReadingHistory');

var _ReadingHistory2 = _interopRequireDefault(_ReadingHistory);

var _LanguageMismatch = require('./checks/LanguageMismatch/LanguageMismatch');

var _LanguageMismatch2 = _interopRequireDefault(_LanguageMismatch);

var _LanguageMismatchModal = require('./checks/LanguageMismatch/LanguageMismatchModal');

var _LanguageMismatchModal2 = _interopRequireDefault(_LanguageMismatchModal);

var _Preview = require('./Preview');

var _Preview2 = _interopRequireDefault(_Preview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TitleActionHandler = function () {
    function TitleActionHandler(bus, card, patronSettings) {
        var _this = this;

        _classCallCheck(this, TitleActionHandler);

        this.bus = bus;
        this.card = card;
        this.patronSettings = patronSettings;

        this._borrow = new _Borrow2['default'](this.bus);
        this._hold = new _Hold2['default'](this.bus, this.card);
        this._wishlist = new _Wishlist2['default'](this.bus);
        this._recommend = new _Recommend2['default'](this.bus, this.card, this.patronSettings);
        this._nook = new _Nook2['default'](this.bus);
        this._rating = new _StarRating2['default'](this.bus);
        this._history = new _ReadingHistory2['default'](this.bus);
        this._preview = new _Preview2['default'](this.bus);

        this.bus.on('title:borrow', function (title, context) {
            return _this.perform('borrow', title, context);
        }).on('title:hold', function (title, context) {
            return _this.perform('hold', title, context);
        }).on('title:hold-cancel', function (title, context) {
            return _this.perform('holdCancel', title, context);
        }).on('title:wishlist', function (title, context) {
            return _this.perform('wish', title, context);
        }).on('title:recommend', function (title, context) {
            return _this.perform('recommend', title, context);
        }).on('title:nook', function (title, context) {
            return _this.perform('nook', title, context);
        }).on('title:rating', function (title, context) {
            return _this.perform('rating', title, context);
        }).on('title:history', function (title, context) {
            return _this.perform('history', title, context);
        }).on('title:preview', function (title, context) {
            return _this.perform('preview', title, context);
        }).on('title:renew', function (title, context) {
            return _this.perform('renew', title, context);
        }).on('title:requestAgain', function (title, context) {
            return _this.perform('requestAgain', title, context);
        });
    }

    _createClass(TitleActionHandler, [{
        key: 'perform',
        value: function perform(action, titleModel, context) {
            if (!window.OverDrive.isAuthenticated && action !== 'preview') {
                this._redirectToAuth(action, titleModel.id, titleModel.get('tempStarRating'));
            } else if (!window.OverDrive.hasLinkedCards && !window.featureManager.isEnabled('internationalDemoMode')) {
                var titleAction = titleModel.get('titleState');
                if (action === 'rating') {
                    titleAction = 'rating~' + titleModel.get('tempStarRating');
                }
                this.bus.trigger('user:card:none', { action: titleAction });
            } else if (typeof this._actions['' + action] === 'function') {
                this._executeAction(action, titleModel, context);
            }

            return;
        }
    }, {
        key: '_redirectToAuth',
        value: function _redirectToAuth(action, id, rating) {
            var actionStr = action + '~' + id;
            if (rating) {
                actionStr += '~' + rating;
            }
            window.location = window.url(window.routes.accountSignIn, { forward: window.location.pathname + window.location.search + '#action=' + actionStr });
        }
    }, {
        key: '_executeAction',
        value: function _executeAction(action, title, context) {
            var _this2 = this;

            this._languageCheck(action, title, function () {
                return _this2._actions['' + action](title, context);
            });
        }
    }, {
        key: '_languageCheck',
        value: function _languageCheck(action, title, successCallback) {
            var _this3 = this;

            var shouldCheck = false;
            if (_(['borrow', 'hold', 'recommend', 'preview']).contains(action)) {
                shouldCheck = true;
            } else if (action === 'wish') {
                shouldCheck = title.get('wishlistState') === 'wishlistAdd';
            } else if (action === 'history') {
                shouldCheck = !title.get('isInHistory');
            }

            if (shouldCheck) {
                var fetchLanguageData = !title.get('languages') ? title.getMissingAttribute('languages') : Promise.resolve();
                fetchLanguageData.then(function () {
                    if (_this3._checkLanguageMatch(title) || Cookies.get('language-mismatch-setting') && Cookies.get('language-mismatch-setting') === '1') {
                        successCallback();
                    } else {
                        window.Logger.log('warn', 'launching language mismatch modal', {
                            patronLanguage: window.patronSettings['language-selection'],
                            titleLanguages: title.get('languages') });
                        var mismatchModal = new _LanguageMismatchModal2['default']({
                            model: new _LanguageMismatch2['default']({
                                languages: title.get('languages'),
                                action: action
                            })
                        });
                        mismatchModal.$el.find('.confirm-button').on('click', function () {
                            mismatchModal.close();
                            if (mismatchModal.$el.find('.no-show-checkbox').is(':checked')) {
                                var millisecondsInYear = 1000 * 60 * 60 * 24 * 365;
                                var expireDate = new Date(Date.now() + millisecondsInYear);
                                Cookies.set('language-mismatch-setting', '1', { httpOnly: false, expires: expireDate });
                            }
                            successCallback();
                        });
                        mismatchModal.$el.find('.cancel-button').on('click', function () {
                            mismatchModal.close();
                            title.trigger('change:wishlistState');
                        });
                    }
                });
            } else {
                successCallback();
            }
        }
    }, {
        key: '_checkLanguageMatch',
        value: function _checkLanguageMatch(title) {
            var titleLanguages = title.get('languages');
            var titleLanguageIds = titleLanguages && titleLanguages.map(function (language) {
                return language.id;
            }) || [];
            var patronLanguage = window.patronSettings['language-selection'];
            if (!!patronLanguage) {
                var varietyIndex = patronLanguage.indexOf('-');
                if (varietyIndex !== -1) {
                    patronLanguage = patronLanguage.substring(0, varietyIndex);
                }
                if (!titleLanguageIds.includes(patronLanguage)) {
                    return false;
                }
            }
            return true;
        }
    }, {
        key: '_actions',
        get: function get() {
            var that = this;
            return {
                borrow: function borrow(title, context) {
                    that._borrow.borrowTitle(title, context);
                },
                hold: function hold(title, context) {
                    that._hold.holdTitle(title, context);
                },
                holdCancel: function holdCancel(title, context) {
                    that._hold.holdCancel(title, context);
                },
                wish: function wish(title, context) {
                    that._wishlist.wishlistAction(title, context);
                },
                recommend: function recommend(title, context) {
                    that._recommend.recommendTitle(title, context);
                },
                nook: function nook(title, context) {
                    that._nook.sendToNook(title, context);
                },
                rating: function rating(title, context) {
                    that._rating.handlingRating(title, context);
                },
                history: function history(title, context) {
                    that._history.readingHistoryAction(title, context);
                },
                preview: function preview(title) {
                    that._preview.giveSample(title);
                },
                renew: function renew(title, context) {
                    context.isRenewal = true;
                    context.formatLock = null;
                    if (title.attributes.isFormatLockedIn) {
                        context.formatLock = title.attributes.otherFormats.length && title.attributes.otherFormats[0].id;
                    }
                    that._borrow.borrowTitle(title, context);
                },
                requestAgain: function requestAgain(title, context) {
                    context.isRequestAgain = true;
                    that._hold.holdTitle(title, context);
                }
            };
        }
    }]);

    return TitleActionHandler;
}();

exports['default'] = TitleActionHandler;

},{"./Preview":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\Preview.js","./borrow/Borrow":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\borrow\\Borrow.js","./checks/LanguageMismatch/LanguageMismatch":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\checks\\LanguageMismatch\\LanguageMismatch.js","./checks/LanguageMismatch/LanguageMismatchModal":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\checks\\LanguageMismatch\\LanguageMismatchModal.js","./history/ReadingHistory":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\history\\ReadingHistory.js","./holds/Hold":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\holds\\Hold.js","./nook/Nook":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\nook\\Nook.js","./ratings/StarRating":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\ratings\\StarRating.js","./recommendations/Recommend":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\recommendations\\Recommend.js","./wishlist/Wishlist":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\wishlist\\Wishlist.js"}],"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\TitleActions.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TitleActions = function () {
    function TitleActions(_ref) {
        var bus = _ref.bus,
            context = _ref.context;

        _classCallCheck(this, TitleActions);

        this.bus = bus;

        this.context = {
            room: undefined,
            collectionDefinition: undefined
        };

        _.extend(this.context, context);
    }

    _createClass(TitleActions, [{
        key: 'perform',
        value: function perform(action, titleModel) {
            if (typeof this['_' + action] === 'function') {
                this['_' + action](titleModel);
            }
        }
    }, {
        key: '_borrow',
        value: function _borrow(titleModel) {
            this.bus.trigger('title:borrow', titleModel, this.context);
        }
    }, {
        key: '_hold',
        value: function _hold(titleModel) {
            this.bus.trigger('title:hold', titleModel, this.context);
        }
    }, {
        key: '_wish',
        value: function _wish(titleModel) {
            this.bus.trigger('title:wishlist', titleModel, this.context);
        }
    }, {
        key: '_recommend',
        value: function _recommend(titleModel) {
            this.bus.trigger('title:recommend', titleModel, this.context);
        }
    }, {
        key: '_nook',
        value: function _nook(titleModel) {
            this.bus.trigger('title:nook', titleModel, this.context);
        }
    }, {
        key: '_rating',
        value: function _rating(titleModel) {
            this.bus.trigger('title:rating', titleModel, this.context);
        }
    }, {
        key: '_history',
        value: function _history(titleModel) {
            this.bus.trigger('title:history', titleModel, this.context);
        }
    }, {
        key: '_download',
        value: function _download(titleModel) {
            this.bus.trigger('title:download', titleModel, this.context);
        }
    }, {
        key: '_preview',
        value: function _preview(titleModel) {
            this.bus.trigger('title:preview', titleModel, this.context);
        }
    }, {
        key: '_renew',
        value: function _renew(titleModel) {
            this.bus.trigger('title:renew', titleModel, this.context);
        }
    }, {
        key: '_requestAgain',
        value: function _requestAgain(titleModel) {
            this.bus.trigger('title:requestAgain', titleModel, this.context);
        }
    }, {
        key: 'setContextRoom',
        value: function setContextRoom(room) {
            if (_(room).isEmpty()) {
                delete this.context.room;
            } else {
                this.context.room = room;
            }

            return this;
        }
    }, {
        key: 'setContextCollection',
        value: function setContextCollection(titleCollection) {
            if (_(titleCollection).isEmpty()) {
                delete this.context.titleCollection;
            } else {
                this.context.titleCollection = titleCollection;
            }

            return this;
        }
    }]);

    return TitleActions;
}();

exports['default'] = TitleActions;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\TitleState.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TitleState = function () {
    function TitleState() {
        _classCallCheck(this, TitleState);
    }

    _createClass(TitleState, null, [{
        key: 'getState',
        value: function getState(media, patronItems) {
            var featureManager = window.featureManager;

            if (featureManager.isEnabled('internationalDemoMode')) {
                return 'preview';
            }

            var mediaId = media.id;

            var isOnHold = patronItems && patronItems.onHolds.indexOf(mediaId) > -1;
            var isOnCheckouts = patronItems && patronItems.onCheckouts.indexOf(mediaId) > -1;
            var isOnRecommendations = patronItems && patronItems.recommendedToLibrary.indexOf(mediaId) > -1 || media.isRecommended;
            var isAvailable = media.isAvailable || featureManager.isEnabled('LuckyDay') && media.luckyDayAvailableCopies > 0;

            if (/account\/loans/.test(window.location.href) && media.isRenewable && featureManager.isEnabled('content-holds')) {
                if (isOnHold) {
                    return 'requested';
                } else if (media.holdsCount <= 0 && media.ownedCopies >= 0 && !(featureManager.isEnabled('LuckyDay') && media.isLuckyDayCheckout) && featureManager.isEnabled('renewTitles')) {
                    return 'renew';
                }
                return 'requestAgain';
            }

            if (isOnCheckouts) {
                return 'borrowed';
            }

            if (isOnHold && !isAvailable) {
                return 'onHold';
            }

            if (isOnRecommendations && !isAvailable && !media.isHoldable) {
                return 'recommended';
            }

            if (isAvailable) {
                if (media.type.id === 'periodicals') {
                    return 'nook';
                }

                return 'borrow';
            }

            if (!media.isOwned && media.isRecommendableToLibrary && featureManager.isEnabled('recommend-to-library')) {
                return 'recommend';
            }

            if (media.isHoldable && featureManager.isEnabled('content-holds')) {
                return 'hold';
            }

            return 'unavailable';
        }
    }, {
        key: 'isOnWishlist',
        value: function isOnWishlist(media, patronItems) {
            return patronItems && patronItems.onWishlist.indexOf(media.id) > -1;
        }
    }, {
        key: 'isOnReadingHistory',
        value: function isOnReadingHistory(media, patronItems) {
            return patronItems && patronItems.onReadingHistory.indexOf(media.id) > -1;
        }
    }, {
        key: 'starRating',
        value: function starRating(media, patronItems) {
            // Returns 0 if not rated
            return patronItems && patronItems.starRatings && patronItems.starRatings[media.id] || 0;
        }
    }]);

    return TitleState;
}();

exports['default'] = TitleState;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\borrow\\Borrow.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _LendingPeriodModal = require('../../components/lending_period_modal/LendingPeriodModal');

var _LendingPeriodModal2 = _interopRequireDefault(_LendingPeriodModal);

var _VisitorActionDisallowedModal = require('../../components/visitor_action_disallowed_modal/VisitorActionDisallowedModal');

var _VisitorActionDisallowedModal2 = _interopRequireDefault(_VisitorActionDisallowedModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Borrow = function () {
    function Borrow(bus) {
        _classCallCheck(this, Borrow);

        this.bus = bus;
    }

    _createClass(Borrow, [{
        key: 'borrowTitle',
        value: function borrowTitle(titleModel, context) {
            var _this = this;

            var borrow = function borrow() {
                if (!context.isRenewal) {
                    titleModel.set('titleState', 'waiting');
                }

                void new _LendingPeriodModal2['default']({
                    model: titleModel,
                    bus: _this.bus,
                    isRenewal: !!context.isRenewal,
                    action: function action(modal) {
                        _this._borrowAjax(titleModel, context).always(function () {
                            modal.close();
                        });
                    }, onError: function onError(error) {
                        _this._borrowFailure(titleModel, {}, '', error);
                    }
                });
            };

            if (window.featureManager.isEnabled('LHTNG-3387')) {
                if (titleModel.isAvailable || !!context.isRenewal) {
                    borrow();
                } else if (window.OverDrive.isVisitor) {
                    new _VisitorActionDisallowedModal2['default']('borrow');
                }
            } else {
                borrow();
            }
        }
    }, {
        key: '_borrowAjax',
        value: function _borrowAjax(titleModel, context) {
            var _this2 = this;

            this.bus.trigger('title:borrow:start', { titleModel: titleModel, context: context });

            var _detectshun$browser = detectshun.browser(),
                mobile = _detectshun$browser.mobile,
                tablet = _detectshun$browser.tablet;

            var lendingPeriod = titleModel.get('lendingPeriod');
            return $.post(window.url(window.routes.mediaBorrow, { mediaId: titleModel.id }), {
                lendingPeriod: lendingPeriod.lendingPeriod,
                units: lendingPeriod.units,
                isMobile: detectshun.browser().mobile || detectshun.browser().tablet,
                returnFullLoanObject: true,
                isRenewal: !!context.isRenewal,
                isLuckyDayCheckout: titleModel.isLuckyDayCheckout && !context.isRenewal
            }).done(function (response) {
                return _this2._borrowSuccess(titleModel, response, context);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                return _this2._borrowFailure(titleModel, jqXHR, textStatus, errorThrown);
            }).always(function () {
                _this2.bus.trigger('title:borrow:end', titleModel);
            });
        }
    }, {
        key: '_borrowSuccess',
        value: function _borrowSuccess(titleModel, response, context) {
            if (!!context.isRenewal) {
                titleModel.set('titleState', 'renewed');
            } else {
                titleModel.set('titleState', 'borrowed');
            }

            this.bus.trigger('title:borrow:success', { expires: response.expires, loan: response, titleModel: titleModel, context: context });

            titleModel.set('isInHistory', true);
        }
    }, {
        key: '_borrowFailure',
        value: function _borrowFailure(titleModel, jqXHR, textStatus, errorThrown, context) {
            if (!/account\/loans/.test(window.location.href)) {
                titleModel.set('titleState', 'borrow');
            }

            this.bus.trigger('title:borrow:fail', { jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown, titleModel: titleModel, context: context });
        }
    }]);

    return Borrow;
}();

exports['default'] = Borrow;

},{"../../components/lending_period_modal/LendingPeriodModal":"C:\\projects\\lightning\\public\\ecmascript\\components\\lending_period_modal\\LendingPeriodModal.js","../../components/visitor_action_disallowed_modal/VisitorActionDisallowedModal":"C:\\projects\\lightning\\public\\ecmascript\\components\\visitor_action_disallowed_modal\\VisitorActionDisallowedModal.js"}],"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\borrow\\BorrowActions.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _HoldConflictModal = require('../../components/media/views/HoldConflictModal.js');

var _HoldConflictModal2 = _interopRequireDefault(_HoldConflictModal);

var _TitleFulfillmentModal = require('../../components/TitleFulfillmentModal/TitleFulfillmentModal.js');

var _TitleFulfillmentModal2 = _interopRequireDefault(_TitleFulfillmentModal);

var _loanTitle = require('../../../../business-objects/loan-title');

var _loanTitle2 = _interopRequireDefault(_loanTitle);

var _accountLimits = require('../../../../business-objects/account-limits');

var _accountLimits2 = _interopRequireDefault(_accountLimits);

var _VisitorActionDisallowedModal = require('../../components/visitor_action_disallowed_modal/VisitorActionDisallowedModal');

var _VisitorActionDisallowedModal2 = _interopRequireDefault(_VisitorActionDisallowedModal);

var _NonHoldConflictModal = require('../../components/non_hold_conflict_modal/NonHoldConflictModal');

var _NonHoldConflictModal2 = _interopRequireDefault(_NonHoldConflictModal);

var _modal = require('../../components/common/modal.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BorrowActions = function () {
    function BorrowActions(bus, featureManager, globalPreferences) {
        var _this = this;

        _classCallCheck(this, BorrowActions);

        this.bus = bus;
        this.featureManager = featureManager;
        this.globalPreferences = globalPreferences;

        this.bus.on('title:borrow:success', function (data) {
            return _this.borrowSuccess(data);
        }).on('title:borrow:fail', function (data) {
            return _this.borrowFail(data);
        }).on('title:borrow:conflict', function (data) {
            return _this._openConflictModal(data.titleModel);
        });
    }

    _createClass(BorrowActions, [{
        key: 'borrowSuccess',
        value: function borrowSuccess(data) {
            var _this2 = this;

            var exp = window.html('date-full', { d: data.expires });
            var linkUrl = window.url(window.routes.accountLoans);
            var loans = window.html('loans');
            var limitsUrl = window.url(window.routes.rest.account.limits);

            $.ajax(limitsUrl).then(function (result) {
                var accountLimits = new _accountLimits2['default'](result.data);
                var limitFormats = _this2.featureManager.isEnabled('kindleLoanFormatLimit');
                var preferKindle = Cookies.get('kindleFulfillmentAppOverride') && Cookies.get('kindleFulfillmentAppOverride') === '1' || _this2.globalPreferences && _this2.globalPreferences.get('kindleFulfillment');
                var inApp = Cookies.get('omcbrowse') !== undefined;
                var loan = new _loanTitle2['default'](data.loan, limitFormats, preferKindle, inApp, window.bowser.mac, _this2.featureManager.isEnabled('noAudiobooksForMacOS'), _this2.featureManager.isEnabled('reenableMp3DownloadMacOSPreCatalina'), window.OverDrive.isPreCatalinaMac);

                var modal = new _TitleFulfillmentModal2['default']({
                    loan: loan,
                    title: data.titleModel,
                    bus: _this2.bus,
                    featureManager: _this2.featureManager,
                    globalPreferences: _this2.globalPreferences,
                    accountLimits: accountLimits,
                    isRenewal: !!data.context.isRenewal,
                    formatLock: data.context.formatLock || null
                });
                modal.render();
            });
        }
    }, {
        key: 'borrowFail',
        value: function borrowFail(data) {
            var response = JSON.parse(data.jqXHR.responseText || '{}');
            if (response.errorCode === 'PatronCardFailedAuthentication') {
                this.bus.trigger('user:card:invalid');
            } else if (response.sessionExpired) {
                this.bus.trigger('user:session:expired', { action: 'borrow~' + data.titleModel.id });
            } else if (response.errorCode === 'CostPerCircAvailabilityFastLaneOnly' || response.errorCode === 'TitleNoLongerAvailable') {
                this._openConflictModal(data.titleModel);
            } else if (response.errorCode === 'CostPerCircNoBudget') {
                this._openConflictModal(data.titleModel);
            } else if (response.errorCode === 'RenewalFailed' || response.errorCode === 'HoldsPreventRenewal') {
                this._openConflictModal(data.titleModel);
            } else if (response.errorCode === 'PatronExceededLuckyDayLimit' && this.featureManager.isEnabled('LuckyDay')) {
                this._openConflictModal(data.titleModel, { isLuckyDay: true });
            } else if (response.errorCode === 'PatronExceededCostPerCircCheckoutLimit') {
                if (window.location.href.match('account') !== null) {
                    toaster.push('' + window.text('errorCPCLimit'), 'error');
                } else {
                    this._openConflictModal(data.titleModel);
                }
            } else if (response.errorCode === 'CheckoutNotAllowedForVisitor') {
                new _VisitorActionDisallowedModal2['default']('borrow');
                if (window.featureManager.isEnabled('LHTNG-3387')) {
                    data.titleModel.set({ 'titleState': 'unavailable', 'availableCopies': 0, 'isAvailable': false });
                }
            } else if (response.errorCode === 'LendingPeriodInvalid') {
                new _modal.Modal({
                    title: window.text('genericError'),
                    content: '<p>' + window.html('error.defaultError') + '</p>'
                });
            } else {
                this._defaultError(response.errorCode, data.titleModel);
            }
        }
    }, {
        key: '_defaultError',
        value: function _defaultError(errorCode, titleModel) {
            var href = '';
            var linkText = '';

            if (errorCode === 'PatronExceededCheckoutLimit' || errorCode === 'LoanAlreadyExists') {
                href = window.url(window.routes.accountLoans);
                linkText = window.html('loans');
            } else if (errorCode === 'PatronExceededChurningLimit' || errorCode === 'PatronTypeRestrictedFromTitle') {
                href = window.url(window.routes.supportMembers);
                linkText = window.html('pleaseContactSupport');
            }

            var link = '<a class="bold" href="' + href + '" tabindex="0">' + linkText + '</a>';
            if (errorCode === 'PatronExceededCheckoutLimit' && this.featureManager.isEnabled("holdRedelivery") && titleModel.get('holdListPosition') === 1) {
                toaster.push('' + window.text('holdRedelivery.loansLimit', { link: link }), 'error');
            } else {
                toaster.push('<strong>' + window.html('genericError') + '</strong> ' + window.text('error.' + errorCode, { link: link }), 'error');
            }
        }
    }, {
        key: '_openConflictModal',
        value: function _openConflictModal(titleModel) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            // We make some assumptions about the title state here because at this point
            // the data returned by thunder is not trustworthy. IE: It will return available copies when there are none
            if (!titleModel.canPlaceHold && window.featureManager.isEnabled('nonHoldableConflictModal')) {
                new _NonHoldConflictModal2['default'](titleModel, options);
                titleModel.set({
                    'titleState': titleModel.get('isOnHold') ? 'onHold' : 'unavailable',
                    'availableCopies': 0,
                    'isAvailable': false
                });
            } else {
                var isRequestAgain = /account\/loans/.test(window.location.href);
                titleModel.set({
                    'titleState': isRequestAgain ? 'requestAgain' : 'hold',
                    'availableCopies': 0,
                    'isAvailable': false
                });
                new _HoldConflictModal2['default'](this.bus, titleModel, options);
            }
        }
    }]);

    return BorrowActions;
}();

exports['default'] = BorrowActions;

},{"../../../../business-objects/account-limits":"C:\\projects\\lightning\\business-objects\\account-limits.js","../../../../business-objects/loan-title":"C:\\projects\\lightning\\business-objects\\loan-title.js","../../components/TitleFulfillmentModal/TitleFulfillmentModal.js":"C:\\projects\\lightning\\public\\ecmascript\\components\\TitleFulfillmentModal\\TitleFulfillmentModal.js","../../components/common/modal.js":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js","../../components/media/views/HoldConflictModal.js":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\HoldConflictModal.js","../../components/non_hold_conflict_modal/NonHoldConflictModal":"C:\\projects\\lightning\\public\\ecmascript\\components\\non_hold_conflict_modal\\NonHoldConflictModal.js","../../components/visitor_action_disallowed_modal/VisitorActionDisallowedModal":"C:\\projects\\lightning\\public\\ecmascript\\components\\visitor_action_disallowed_modal\\VisitorActionDisallowedModal.js"}],"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\checks\\LanguageMismatch\\LanguageMismatch.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _window = window,
    html = _window.html;

var LanguageMismatch = function (_Backbone$Model) {
    _inherits(LanguageMismatch, _Backbone$Model);

    function LanguageMismatch() {
        _classCallCheck(this, LanguageMismatch);

        return _possibleConstructorReturn(this, (LanguageMismatch.__proto__ || Object.getPrototypeOf(LanguageMismatch)).apply(this, arguments));
    }

    _createClass(LanguageMismatch, [{
        key: 'languageText',
        get: function get() {
            var languageCodes = this.get('languages').map(function (language) {
                return language.id && language.id.split('-')[0];
            });
            var translations = languageCodes.map(function (code) {
                return code && html('languages.code-' + code);
            });
            return html('languageMismatch.inLanguage', { language: translations.join(', ') });
        }
    }, {
        key: 'areYouSureText',
        get: function get() {
            switch (this.get('action')) {
                case 'borrow':
                    return html('languageMismatch.areYouSure.borrow');
                case 'hold':
                    return html('languageMismatch.areYouSure.hold');
                case 'recommend':
                    return html('languageMismatch.areYouSure.recommend');
                case 'wish':
                    return html('languageMismatch.areYouSure.wish');
                case 'history':
                    return html('languageMismatch.areYouSure.history');
                default:
                    return '';
            }
        }
    }, {
        key: 'actionText',
        get: function get() {
            switch (this.get('action')) {
                case 'borrow':
                    return html('borrow');
                case 'hold':
                    return html('placeHold');
                case 'recommend':
                    return html('recommend');
                case 'wish':
                    return html('addToWishList');
                case 'history':
                    return html('readingHistory.add');
                default:
                    return html('confirm');
            }
        }
    }]);

    return LanguageMismatch;
}(Backbone.Model);

exports['default'] = LanguageMismatch;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\checks\\LanguageMismatch\\LanguageMismatchModal.html.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports['default'] = function (_ref) {
    var languageText = _ref.languageText,
        areYouSureText = _ref.areYouSureText,
        actionText = _ref.actionText;
    return '\n    <div class=\'modal-text\'>\n        ' + languageText + ' ' + areYouSureText + '\n        <div>\n            <input type=\'checkbox\' id=\'no-show-checkbox\' class=\'no-show-checkbox\' /><label class=\'no-show-label\' for=\'no-show-checkbox\'>' + window.html('dontShow') + '</label>\n        </div>\n    </div>\n    <div class=\'button-container\'>\n        <button type=\'button\' class=\'confirm-button button margin-small radius secondary contrast u-allCaps\'>' + actionText + '</button>\n        <button type=\'button\' class=\'cancel-button button margin-small outline gray u-allCaps\'>' + window.html('cancel') + '</button>\n    </div>\n';
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\checks\\LanguageMismatch\\LanguageMismatchModal.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _modal = require('../../../components/common/modal');

var _LanguageMismatchModal = require('./LanguageMismatchModal.html');

var _LanguageMismatchModal2 = _interopRequireDefault(_LanguageMismatchModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LanguageMismatchModal = function (_Modal) {
    _inherits(LanguageMismatchModal, _Modal);

    function LanguageMismatchModal(_ref) {
        var model = _ref.model;

        _classCallCheck(this, LanguageMismatchModal);

        var modalContents = {
            classes: ['LanguageMismatchModal'],
            title: window.html('languageMismatch.languageConfirmation'),
            content: (0, _LanguageMismatchModal2['default'])({
                languageText: model.languageText,
                areYouSureText: model.areYouSureText,
                actionText: model.actionText
            })
        };
        return _possibleConstructorReturn(this, (LanguageMismatchModal.__proto__ || Object.getPrototypeOf(LanguageMismatchModal)).call(this, modalContents));
    }

    return LanguageMismatchModal;
}(_modal.Modal);

exports['default'] = LanguageMismatchModal;

},{"../../../components/common/modal":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\modal.js","./LanguageMismatchModal.html":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\checks\\LanguageMismatch\\LanguageMismatchModal.html.js"}],"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\history\\ReadingHistory.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RemoveHistoryModal = require('../../components/media/views/RemoveHistoryModal.js');

var _RemoveHistoryModal2 = _interopRequireDefault(_RemoveHistoryModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReadingHistory = function () {
    function ReadingHistory(bus) {
        _classCallCheck(this, ReadingHistory);

        this.bus = bus;
    }

    _createClass(ReadingHistory, [{
        key: 'importFromRated',
        value: function importFromRated() {
            var _this = this;

            this.bus.trigger('history:importFromRated:start');

            return $.post(window.url(window.routes.rest.readingHistory.index)).done(function () {
                var _bus;

                for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
                    params[_key] = arguments[_key];
                }

                return (_bus = _this.bus).trigger.apply(_bus, ['history:importFromRated:success'].concat(params));
            }).fail(function () {
                var _bus2;

                for (var _len2 = arguments.length, params = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    params[_key2] = arguments[_key2];
                }

                return (_bus2 = _this.bus).trigger.apply(_bus2, ['history:importFromRated:fail'].concat(params));
            }).always(function () {
                return _this.bus.trigger('history:importFromRated:end');
            });
        }
    }, {
        key: 'readingHistoryAction',
        value: function readingHistoryAction(titleModel, context) {
            var _this2 = this;

            var action = titleModel.get('isInHistory') ? 'remove' : 'add';

            this.bus.trigger('title:history:start', { titleModel: titleModel, action: action });

            var response = new Promise(function (resolve, reject) {
                if (action === 'remove') {
                    new _RemoveHistoryModal2['default']({
                        bus: _this2.bus,
                        title: titleModel,
                        action: function action() {
                            _this2._historyRemoveAjax(titleModel, context).then(resolve).fail(reject);
                        }
                    });
                } else {
                    _this2._historyAddAjax(titleModel, context).then(resolve).fail(reject);
                }
            });

            return response.then(function () {
                var _bus3;

                for (var _len3 = arguments.length, params = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                    params[_key3] = arguments[_key3];
                }

                return (_bus3 = _this2.bus).trigger.apply(_bus3, ['title:history:success', { titleModel: titleModel, action: action, context: context }].concat(params));
            })['catch'](function () {
                var _bus4;

                for (var _len4 = arguments.length, params = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                    params[_key4] = arguments[_key4];
                }

                return (_bus4 = _this2.bus).trigger.apply(_bus4, ['title:history:fail', { titleModel: titleModel, action: action, context: context }].concat(params));
            }).then(function () {
                return _this2.bus.trigger('title:history:end', { titleModel: titleModel, action: action, context: context });
            });
        }
    }, {
        key: '_historyAddAjax',
        value: function _historyAddAjax(titleModel, context) {
            var _this3 = this;

            this.bus.trigger('title:history:add:start', { titleModel: titleModel, context: context });

            var response = $.ajax({
                url: window.url(window.routes.rest.readingHistory.title, { id: titleModel.get('id') }),
                type: 'PUT'
            });

            response.done(function () {
                titleModel.set('isInHistory', !titleModel.get('isInHistory'));
                _this3.bus.trigger('title:history:add:success', { titleModel: titleModel, context: context });
            }).fail(function () {
                var _bus5;

                for (var _len5 = arguments.length, params = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                    params[_key5] = arguments[_key5];
                }

                return (_bus5 = _this3.bus).trigger.apply(_bus5, ['title:history:add:fail', { titleModel: titleModel, context: context }].concat(params));
            }).always(function () {
                return _this3.bus.trigger('title:history:add:end', { titleModel: titleModel, context: context });
            });

            return response;
        }
    }, {
        key: '_historyRemoveAjax',
        value: function _historyRemoveAjax(titleModel, context) {
            var _this4 = this;

            this.bus.trigger('title:history:remove:start', { titleModel: titleModel, context: context });

            var response = $.ajax({
                url: window.url(window.routes.rest.readingHistory.title, { id: titleModel.get('id') }),
                type: 'DELETE'
            });

            response.done(function () {
                titleModel.set('isInHistory', !titleModel.get('isInHistory'));
                _this4.bus.trigger('title:history:remove:success', { titleModel: titleModel, context: context });
            }).fail(function () {
                var _bus6;

                for (var _len6 = arguments.length, params = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
                    params[_key6] = arguments[_key6];
                }

                return (_bus6 = _this4.bus).trigger.apply(_bus6, ['title:history:remove:fail', { titleModel: titleModel, context: context }].concat(params));
            }).always(function () {
                return _this4.bus.trigger('title:history:remove:end', { titleModel: titleModel, context: context });
            });

            return response;
        }
    }]);

    return ReadingHistory;
}();

exports['default'] = ReadingHistory;

},{"../../components/media/views/RemoveHistoryModal.js":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\RemoveHistoryModal.js"}],"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\history\\ReadingHistoryActions.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ImportFromRatedCompleteModal = require('../../components/account_history/views/ImportFromRatedCompleteModal');

var _ImportFromRatedCompleteModal2 = _interopRequireDefault(_ImportFromRatedCompleteModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReadingHistoryActions = function () {
    function ReadingHistoryActions(bus) {
        var _this = this;

        _classCallCheck(this, ReadingHistoryActions);

        this.bus = bus;

        this.bus.on('history:importFromRated:success', function () {
            return _this.importFromRatingsSuccess.apply(_this, arguments);
        }).on('title:history:fail', function () {
            return _this.historyFailure.apply(_this, arguments);
        });
    }

    _createClass(ReadingHistoryActions, [{
        key: 'importFromRatingsSuccess',
        value: function importFromRatingsSuccess(data) {
            new _ImportFromRatedCompleteModal2['default'](data.importedTitleCount, data.patronHasRatedTitles);
        }
    }, {
        key: 'historyFailure',
        value: function historyFailure(_ref, jqXHR, textStatus, errorThrown) {
            var titleModel = _ref.titleModel;

            var response = JSON.parse(jqXHR.responseText || '{}');

            if (response.sessionExpired) {
                this.bus.trigger('user:session:expired');
            } else {
                toaster.push(window.html('error.defaultErrorHtml'), 'error');
            }
        }
    }]);

    return ReadingHistoryActions;
}();

exports['default'] = ReadingHistoryActions;

},{"../../components/account_history/views/ImportFromRatedCompleteModal":"C:\\projects\\lightning\\public\\ecmascript\\components\\account_history\\views\\ImportFromRatedCompleteModal.js"}],"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\holds\\Hold.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _VisitorActionDisallowedModal = require('../../components/visitor_action_disallowed_modal/VisitorActionDisallowedModal');

var _VisitorActionDisallowedModal2 = _interopRequireDefault(_VisitorActionDisallowedModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Hold = function () {
    function Hold(bus, card) {
        _classCallCheck(this, Hold);

        this.bus = bus;
        this.card = card;
    }

    _createClass(Hold, [{
        key: 'holdTitle',
        value: function holdTitle(titleModel, context) {
            var _this = this;

            if (window.featureManager.isEnabled('LHTNG-3387') && window.OverDrive.isVisitor && (!window.featureManager.isEnabled("content-holds") || !titleModel.get('isHoldable'))) {
                new _VisitorActionDisallowedModal2['default']('hold');
            } else if (this.card.preferredHoldEmail.length) {
                // LHTNG-1584 - Dont re-check availability, causes UI loops
                this._holdAjax(titleModel, context);
            } else {
                this.card._fetch.then(function () {
                    if (_this.card.preferredHoldEmail.length) {
                        _this._holdAjax(titleModel, context);
                    } else {
                        _this.bus.trigger('title:hold:request-email', { titleModel: titleModel, context: context });
                    }
                });
            }
        }
    }, {
        key: 'holdCancel',
        value: function holdCancel(titleModel, context) {
            var _this2 = this;

            return $.ajax({
                type: 'DELETE', url: window.url(window.routes.mediaRemoveHold, { mediaId: titleModel.id })
            }).done(function (response) {
                titleModel.set('titleState', 'hold');
                _this2.bus.trigger('title:hold-cancel:success', { titleModel: titleModel, context: context });
            }).fail(function (jqXHR, textStatus, errorThrown) {
                titleModel.set('titleState', 'onHold');
                _this2.bus.trigger('title:hold-cancel:fail', { jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown, titleModel: titleModel, context: context });
            }).complete(function () {
                _this2.bus.trigger('title:hold-cancel:end', { titleModel: titleModel, context: context });
            });
        }
    }, {
        key: '_holdAjax',
        value: function _holdAjax(titleModel, context) {
            var _this3 = this;

            this.bus.trigger('title:hold:start', { titleModel: titleModel, email: this.card.preferredHoldEmail, context: context });

            if (!context.isRequestAgain) {
                titleModel.set('titleState', 'waiting');
            }

            var _detectshun$browser = detectshun.browser(),
                mobile = _detectshun$browser.mobile,
                tablet = _detectshun$browser.tablet;

            return $.ajax({
                url: window.url(window.routes.mediaPlaceHold),
                type: 'POST',
                data: {
                    mediaId: titleModel.id,
                    email: this.card.preferredHoldEmail,
                    isMobile: mobile || tablet,
                    languageCode: window.patronSettings['language-selection'] || window.Cookies.get('language-selection') || $('html').attr('lang') || 'en'
                }
            }).done(function (response) {
                var isRequestAgain = !!context.isRequestAgain || /account\/loans/.test(window.location.href);
                titleModel.set('titleState', isRequestAgain ? 'requested' : 'onHold');
                _this3.bus.trigger('title:hold:success', { titleModel: titleModel, context: context });
            }).fail(function (jqXHR, textStatus, errorThrown) {
                if (!context.isRequestAgain) {
                    titleModel.set('titleState', 'hold');
                }
                _this3.bus.trigger('title:hold:fail', { jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown, titleModel: titleModel, context: context });
            }).complete(function () {
                _this3.bus.trigger('title:hold:end', { titleModel: titleModel, context: context });
            });
        }
    }]);

    return Hold;
}();

exports['default'] = Hold;

},{"../../components/visitor_action_disallowed_modal/VisitorActionDisallowedModal":"C:\\projects\\lightning\\public\\ecmascript\\components\\visitor_action_disallowed_modal\\VisitorActionDisallowedModal.js"}],"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\holds\\HoldActions.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _HoldModal = require('../../components/media/views/HoldModal');

var _HoldModal2 = _interopRequireDefault(_HoldModal);

var _HoldSuccessModal = require('../../components/media/views/HoldSuccessModal');

var _HoldSuccessModal2 = _interopRequireDefault(_HoldSuccessModal);

var _VisitorActionDisallowedModal = require('../../components/visitor_action_disallowed_modal/VisitorActionDisallowedModal');

var _VisitorActionDisallowedModal2 = _interopRequireDefault(_VisitorActionDisallowedModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HoldActions = function () {
    function HoldActions(bus) {
        var _this = this;

        _classCallCheck(this, HoldActions);

        this.bus = bus;

        this.bus.on('title:hold:success', function (data) {
            return _this.holdSuccess(data);
        }).on('title:hold:fail', function (data) {
            return _this.holdFail(data);
        }).on('title:hold:request-email', function (data) {
            return _this._openHoldModal(data);
        }).on('title:hold:conflict', function (data) {
            return _this._openConflictModal(data.titleModel);
        }).on('title:hold-cancel:fail', function (data) {
            return _this.holdCancelFail(data);
        });

        this.featureManager = window.featureManager;
    }

    _createClass(HoldActions, [{
        key: 'holdSuccess',
        value: function holdSuccess(data) {
            var _this2 = this;

            window.ajax.getHold(data.titleModel.get('id')).done(function (holdData) {
                data.titleModel.set({
                    holdsRatio: holdData.holdsRatio,
                    holdsCount: holdData.holdsCount,
                    holdListPosition: holdData.holdListPosition
                });
                new _HoldSuccessModal2['default']({ bus: _this2.bus,
                    titleModel: data.titleModel,
                    email: window.card.preferredHoldEmail,
                    autoCheckoutEnabled: window.patronSettings['auto-checkout-setting'] === 1 });
            });
        }
    }, {
        key: 'holdFail',
        value: function holdFail(_ref) {
            var jqXHR = _ref.jqXHR,
                titleModel = _ref.titleModel;

            var response = JSON.parse(jqXHR.responseText);

            if (response.errorCode === 'PatronCardFailedAuthentication') {
                this.bus.trigger('user:card:invalid');
            } else if (response.sessionExpired) {
                this.bus.trigger('user:session:expired', { action: 'hold~' + titleModel.id });
            } else if (response.errorCode === 'HoldAlreadyExists' || response.errorCode === 'PatronExceededHoldLimit') {
                var link = '<a class="bold" href="' + window.url(window.routes.accountHolds) + '" tabindex="0">' + window.html('holds') + '</a>';
                this._errorToast(link, response.errorCode);
            } else if (response.errorCode === 'PatronTypeRestrictedFromTitle' || response.errorCode === 'PatronHasHoldsDisabled') {
                var _link = '<a class="bold" href="' + window.url(window.routes.supportMembers) + '" tabindex="0">' + window.html('pleaseContactSupport') + '</a>';
                this._errorToast(_link, response.errorCode);
            } else if (response.errorCode === 'HoldNotAllowedForVisitor') {
                new _VisitorActionDisallowedModal2['default']('hold');
            } else if (response.errorCode) {
                this._errorToast('', response.errorCode);
            } else {
                toaster.push('<strong>' + window.html('genericError') + '</strong>', 'error');
            }
        }
    }, {
        key: 'holdCancelFail',
        value: function holdCancelFail(_ref2) {
            var jqXHR = _ref2.jqXHR,
                textStatus = _ref2.textStatus,
                errorThrown = _ref2.errorThrown,
                titleModel = _ref2.titleModel,
                context = _ref2.context;

            var response = JSON.parse(jqXHR.responseText);
            if (response.sessionExpired) {
                this.bus.trigger('user:session:expired');
            } else {
                toaster.push('<strong>' + window.html('genericError') + '</strong> ' + window.html('error.' + response.errorCode), 'error');
            }
        }
    }, {
        key: '_errorToast',
        value: function _errorToast(pageLink, errorCode) {
            toaster.push('<strong>' + window.html('genericError') + '</strong> ' + window.text('error.' + errorCode, { link: pageLink }), 'error');
        }
    }, {
        key: '_openHoldModal',
        value: function _openHoldModal(_ref3) {
            var titleModel = _ref3.titleModel,
                context = _ref3.context;

            if (window.featureManager.isEnabled('LHTNG-3387')) {
                if (window.OverDrive.isVisitor && !this.featureManager.isEnabled("content-holds")) {
                    new _VisitorActionDisallowedModal2['default']('hold');
                } else {
                    new _HoldModal2['default']({
                        bus: this.bus,
                        titleModel: titleModel,
                        context: context
                    });
                }
            } else {
                new _HoldModal2['default']({ bus: this.bus, titleModel: titleModel, context: context });
            }
        }
    }]);

    return HoldActions;
}();

exports['default'] = HoldActions;

},{"../../components/media/views/HoldModal":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\HoldModal.js","../../components/media/views/HoldSuccessModal":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\HoldSuccessModal.js","../../components/visitor_action_disallowed_modal/VisitorActionDisallowedModal":"C:\\projects\\lightning\\public\\ecmascript\\components\\visitor_action_disallowed_modal\\VisitorActionDisallowedModal.js"}],"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\nook\\Nook.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Nook = function () {
    function Nook(bus) {
        var _this = this;

        _classCallCheck(this, Nook);

        this.bus = bus;

        this.bus.on('title:nook:eula-accepted', function (data) {
            return _this._setEulaCookie(data.title);
        });
    }

    _createClass(Nook, [{
        key: 'sendToNook',
        value: function sendToNook(title) {
            if (Cookies.get('nook-eula-setting') === '1') {
                this._nookAjax(title);
            } else {
                this.bus.trigger('title:nook:request-eula', { titleModel: title });
            }
        }
    }, {
        key: '_nookAjax',
        value: function _nookAjax(title) {
            var _this2 = this;

            title.set('titleState', 'waiting');
            this.bus.trigger('title:nook:start', title);

            return $.ajax({
                url: window.url(window.routes.mediaBorrow, {
                    mediaId: title.id
                }),
                type: 'POST'
            }).done(function (response) {
                return _this2._nookSuccess(title, response);
            }).fail(function (jqXHR, textStatus, errorThrown) {
                return _this2._nookFailure(title, jqXHR, textStatus, errorThrown);
            }).complete(function () {
                _this2.bus.trigger('title:nook:end', title);
            });
        }
    }, {
        key: '_nookSuccess',
        value: function _nookSuccess(title) {
            title.set('titleState', 'borrowed');
            this.bus.trigger('title:nook:success', { titleModel: title });
        }
    }, {
        key: '_nookFailure',
        value: function _nookFailure(title, jqXHR, textStatus, errorThrown) {
            title.set('titleState', 'nook');

            this.bus.trigger('title:nook:fail', { jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown, titleModel: title });
        }
    }, {
        key: '_setEulaCookie',
        value: function _setEulaCookie(titleModel) {
            Cookies.set('nook-eula-setting', '1');
            this._nookAjax(titleModel);
        }
    }]);

    return Nook;
}();

exports['default'] = Nook;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\nook\\NookActions.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _NookEulaModal = require('../../components/media/views/NookEulaModal');

var _NookEulaModal2 = _interopRequireDefault(_NookEulaModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NookActions = function () {
    function NookActions(bus) {
        var _this = this;

        _classCallCheck(this, NookActions);

        this.bus = bus;

        this.bus.on('title:nook:success', function (data) {
            return _this.nookSuccess(data);
        }).on('title:nook:fail', function (data) {
            return _this.nookFail(data);
        }).on('title:nook:request-eula', function (data) {
            return _this._openNookEulaModal(data.titleModel);
        });
    }

    _createClass(NookActions, [{
        key: 'nookSuccess',
        value: function nookSuccess(data) {
            window.location.href = window.url(window.routes.mediaDownload, { format: 'periodicals-nook', mediaId: data.titleModel.id });
        }
    }, {
        key: 'nookFail',
        value: function nookFail(data) {
            var response = JSON.parse(data.jqXHR.responseText);

            if (response.errorCode === 'PatronCardFailedAuthentication') {
                this.bus.trigger('user:card:invalid');
            } else if (response.errorCode === 'PatronExceededPeriodicalsCheckoutLimit') {
                var href = window.url(window.routes.accountLoans);
                var linkText = window.html('loans');
                var link = '<a class="bold" href="' + href + '" tabindex="0">' + linkText + '</a>';
                toaster.push('<strong>' + window.html('genericError') + '</strong> ' + window.text('error.' + response.errorCode, { link: link }), 'error');
            } else if (response.sessionExpired) {
                this.bus.trigger('user:session:expired');
            }
        }
    }, {
        key: '_openNookEulaModal',
        value: function _openNookEulaModal(titleModel) {
            new _NookEulaModal2['default'](this.bus, titleModel);
        }
    }]);

    return NookActions;
}();

exports['default'] = NookActions;

},{"../../components/media/views/NookEulaModal":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\NookEulaModal.js"}],"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\ratings\\StarRating.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StarRating = function () {
    function StarRating(bus) {
        _classCallCheck(this, StarRating);

        this.bus = bus;
    }

    _createClass(StarRating, [{
        key: 'handlingRating',
        value: function handlingRating(model) {
            if (model.get('userStarRating') > 0) {
                // User is adding rating
                this._rateTitleAjax(model);
            } else {
                // User is removing rating
                this._deleteRatingAjax(model);
            }
        }
    }, {
        key: '_rateTitleAjax',
        value: function _rateTitleAjax(model) {
            var _this = this;

            return $.ajax({
                url: window.url(window.routes.patronMediaStarRatings, { titleId: model.get('id') }),
                type: 'PUT',
                data: { rating: model.get('userStarRating') },
                timeout: 0
            }).fail(function (jqXHR, textStatus, errorThrown) {
                return _this.ratingFailure(model, jqXHR, textStatus, errorThrown);
            });
        }
    }, {
        key: '_deleteRatingAjax',
        value: function _deleteRatingAjax(model) {
            var _this2 = this;

            return $.ajax({
                url: window.url(window.routes.patronMediaStarRatings, { titleId: model.get('id') }),
                type: 'DELETE',
                timeout: 0
            }).fail(function (jqXHR, textStatus, errorThrown) {
                return _this2.ratingFailure(model, jqXHR, textStatus, errorThrown);
            });
        }
    }, {
        key: 'ratingFailure',
        value: function ratingFailure(model, jqXHR, textStatus, errorThrown) {
            this.bus.trigger('title:rating:fail', { model: model, jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown });
        }
    }]);

    return StarRating;
}();

exports['default'] = StarRating;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\ratings\\StarRatingActions.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StarRatingActions = function () {
    function StarRatingActions(bus) {
        var _this = this;

        _classCallCheck(this, StarRatingActions);

        this.bus = bus;

        this.bus.on('title:rating:fail', function (data) {
            return _this.ratingFail(data);
        });
    }

    _createClass(StarRatingActions, [{
        key: 'ratingFail',
        value: function ratingFail(data) {
            var response = void 0;
            try {
                response = JSON.parse(data.jqXHR.responseText);
            } catch (ex) {
                response = {};
            }

            if (response.sessionExpired) {
                this.bus.trigger('user:session:expired');
            } else {
                var link = '<a class="bold" href="' + window.url(window.routes.supportMembers) + '" tabindex="0">' + window.html('pleaseContactSupport') + '</a>';
                toaster.push('<strong>' + window.html('genericError') + '</strong> ' + window.text('error.errorContactSupport', { link: link }), 'error');
            }
        }
    }]);

    return StarRatingActions;
}();

exports['default'] = StarRatingActions;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\recommendations\\Recommend.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RtlModal = require('../../components/media/views/RtlModal');

var _RtlModal2 = _interopRequireDefault(_RtlModal);

var _RtlLimitModal = require('../../components/media/views/RtlLimitModal');

var _RtlLimitModal2 = _interopRequireDefault(_RtlLimitModal);

var _VisitorActionDisallowedModal = require('../../components/visitor_action_disallowed_modal/VisitorActionDisallowedModal');

var _VisitorActionDisallowedModal2 = _interopRequireDefault(_VisitorActionDisallowedModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Recommend = function () {
    function Recommend(bus, card, patronSettings) {
        var _this = this;

        _classCallCheck(this, Recommend);

        this.bus = bus;
        this.card = card;
        this.patronSettings = patronSettings;

        this.bus.on('title:recommend:post', function (data) {
            return _this._recommendAjax(data);
        });
    }

    _createClass(Recommend, [{
        key: 'recommendTitle',
        value: function recommendTitle(titleModel, context) {
            var _this2 = this;

            this.card._fetch.then(function () {

                var lhtng3387enabled = window.featureManager.isEnabled('LHTNG-3387');
                if (lhtng3387enabled && window.OverDrive.isVisitor && !window.featureManager.isEnabled('recommend-to-library')) {
                    new _VisitorActionDisallowedModal2['default']('recommend');
                } else {
                    var rtlStats = _this2.card.attributes.recommendationStatistics;

                    if (rtlStats.recommendationsRemaining > 0) {
                        if (_this2.card.preferredHoldEmail.length) {
                            _this2.bus.trigger('title:recommend:post', {
                                titleModel: titleModel,
                                email: _this2.card.preferredHoldEmail,
                                context: _this2.context
                            });
                        } else if (!lhtng3387enabled && window.OverDrive.isVisitor && !window.featureManager.isEnabled("recommend-to-library")) {
                            new _VisitorActionDisallowedModal2['default']('recommend');
                        } else {
                            // LHTNG-2868 - Only show the RTL modal now if we need to collect the user's email for placing a hold on the recommended title
                            void new _RtlModal2['default'](_this2.bus, titleModel, context);
                        }
                    } else {
                        void new _RtlLimitModal2['default'](rtlStats);
                    }
                }
            });
        }
    }, {
        key: '_recommendAjax',
        value: function _recommendAjax(_ref) {
            var _this3 = this;

            var titleModel = _ref.titleModel,
                email = _ref.email,
                context = _ref.context;

            this.bus.trigger('title:recommend:start', { titleModel: titleModel, email: email, context: context });

            titleModel.set('titleState', 'waiting');

            var autoCheckoutSetting = this.patronSettings['auto-checkout-setting'];

            return $.ajax({
                url: window.url(window.routes.patronRecommendations),
                type: 'POST',
                data: {
                    id: titleModel.id,
                    addHold: true, // LHTNG-2868 - Always add hold when recommending
                    notifyIfPurchased: true,
                    email: email,
                    autoCheckout: autoCheckoutSetting && autoCheckoutSetting === 1
                }
            }).done(function () {
                return _this3.bus.trigger('title:recommend:success', { titleModel: titleModel, email: email, context: context });
            }).fail(function (jqXHR) {

                // The response is sometimes json and sometimes not.  Fun.
                var response = void 0;
                try {
                    response = JSON.parse(jqXHR.responseText);
                } catch (ex) {
                    response = jqXHR.responseText;
                }
                titleModel.set('titleState', 'recommend');
                _this3.bus.trigger('title:recommend:fail', { titleModel: titleModel, email: email, context: context, response: response });
            }).complete(function () {
                _this3.bus.trigger('title:recommend:end', { titleModel: titleModel, email: email, context: context });
            });
        }
    }]);

    return Recommend;
}();

exports['default'] = Recommend;

},{"../../components/media/views/RtlLimitModal":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\RtlLimitModal.js","../../components/media/views/RtlModal":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\RtlModal.js","../../components/visitor_action_disallowed_modal/VisitorActionDisallowedModal":"C:\\projects\\lightning\\public\\ecmascript\\components\\visitor_action_disallowed_modal\\VisitorActionDisallowedModal.js"}],"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\recommendations\\RecommendActions.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RtlLimitModal = require('../../components/media/views/RtlLimitModal');

var _RtlLimitModal2 = _interopRequireDefault(_RtlLimitModal);

var _RtlSuccessModal = require('../../components/media/views/RtlSuccessModal');

var _RtlSuccessModal2 = _interopRequireDefault(_RtlSuccessModal);

var _VisitorActionDisallowedModal = require('../../components/visitor_action_disallowed_modal/VisitorActionDisallowedModal');

var _VisitorActionDisallowedModal2 = _interopRequireDefault(_VisitorActionDisallowedModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RecommendActions = function () {
    function RecommendActions(bus) {
        var _this = this;

        _classCallCheck(this, RecommendActions);

        this.bus = bus;

        this.bus.on('title:recommend:success', function (data) {
            return _this.recommendSuccess(data);
        }).on('title:recommend:fail', function (data) {
            return _this.recommendFail(data);
        });
    }

    _createClass(RecommendActions, [{
        key: 'recommendSuccess',
        value: function recommendSuccess(data) {
            // Open RTL success modal
            void new _RtlSuccessModal2['default'](this.bus, data);
            data.titleModel.set('titleState', 'recommended');
            window.card.cacheReset();
        }
    }, {
        key: 'recommendFail',
        value: function recommendFail(data) {

            if (data.response === 'PatronCardFailedAuthentication') {
                this.bus.trigger('user:card:invalid');
            } else if (data.response.sessionExpired) {
                this.bus.trigger('user:session:expired', { action: 'recommend~' + data.titleModel.id });
            } else if (data.response === 'PatronExceededRecommendationsLimit') {
                void new _RtlLimitModal2['default'](this.rtlStats); // this should never happen now LHTNG-2828
            } else if (data.response === 'TitleAlreadyRecommended') {
                // TODO: Lightning does not yet have a user friendly way to alert the user of an already recommended title
                toaster.push(window.text('errorOccurred'), 'error');
                $(document).foundation('reveal', 'close');
            } else if (data.response === 'TitleRecommendationNotAllowedForVisitor') {
                new _VisitorActionDisallowedModal2['default']('recommend');
            } else {
                toaster.push(window.text('errorOccurred'), 'error');
                $(document).foundation('reveal', 'close');
            }
        }
    }]);

    return RecommendActions;
}();

exports['default'] = RecommendActions;

},{"../../components/media/views/RtlLimitModal":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\RtlLimitModal.js","../../components/media/views/RtlSuccessModal":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\views\\RtlSuccessModal.js","../../components/visitor_action_disallowed_modal/VisitorActionDisallowedModal":"C:\\projects\\lightning\\public\\ecmascript\\components\\visitor_action_disallowed_modal\\VisitorActionDisallowedModal.js"}],"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\shared\\SharedActions.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _SessionExpiredModal = require('../../components/session_expired_modal/SessionExpiredModal');

var _SessionExpiredModal2 = _interopRequireDefault(_SessionExpiredModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SharedActions = function () {
    function SharedActions(bus) {
        var _this = this;

        _classCallCheck(this, SharedActions);

        this.bus = bus;

        this.bus.on('user:session:expired', function (data) {
            return _this._sessionExpired(data);
        }).on('user:card:invalid', function () {
            return _this._patronCardFailedAuthentication();
        }).on('user:card:none', function (data) {
            return _this._noLinkedCards(data.action);
        });
    }

    _createClass(SharedActions, [{
        key: '_sessionExpired',
        value: function _sessionExpired(data) {
            var forwardUrl = window.location.pathname + window.location.search;
            if (data && data.action) {
                forwardUrl += '#action=' + encodeURIComponent(data.action);
            }
            new _SessionExpiredModal2['default'](forwardUrl);
        }
    }, {
        key: '_noLinkedCards',
        value: function _noLinkedCards(action) {
            if (!window.featureManager.isEnabled('internationalDemoMode')) {
                var forwardUrl = window.location.pathname + window.location.search.replace(/(&|\?)no-linked-card(=true|\=false)/, '');
                var initiateCardLinkUrl = window.url(window.routes.accountStartCardLink, { forward: forwardUrl, action: action });
                $('#add-card-button').attr('href', initiateCardLinkUrl);
                $('#link-card-modal').foundation('reveal', 'open');
            }
        }
    }, {
        key: '_patronCardFailedAuthentication',
        value: function _patronCardFailedAuthentication() {
            if (window.OverDrive.authType === 'library') {
                new _SessionExpiredModal2['default']();
            } else {
                // the user's card is no longer valid. Direct them to the link a card flow so that they may resolve any issues.
                $('.js-card-error-modal').foundation('reveal', 'open');
            }
        }
    }]);

    return SharedActions;
}();

exports['default'] = SharedActions;

},{"../../components/session_expired_modal/SessionExpiredModal":"C:\\projects\\lightning\\public\\ecmascript\\components\\session_expired_modal\\SessionExpiredModal.js"}],"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\wishlist\\Wishlist.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Wishlist = function () {
    function Wishlist(bus) {
        _classCallCheck(this, Wishlist);

        this.bus = bus;
    }

    _createClass(Wishlist, [{
        key: 'wishlistAction',
        value: function wishlistAction(titleModel, context) {
            var _this = this;

            var action = titleModel.get('wishlistState') === 'wishlistAdd' ? 'add' : 'remove';

            this.bus.trigger('title:wishlist:start', { titleModel: titleModel, action: action });

            var request = new Promise(function (resolve, reject) {
                if (titleModel.get('wishlistState') === 'wishlistAdd') {
                    _this._wishlistAddAjax(titleModel).then(resolve).fail(function (jqXHR) {
                        return reject({ jqXHR: jqXHR, titleModel: titleModel });
                    });
                } else {
                    _this._wishlistRemoveAjax(titleModel).then(resolve).fail(function (jqXHR) {
                        return reject({ jqXHR: jqXHR, titleModel: titleModel });
                    });
                }
            });

            request.then(function () {
                var _bus;

                for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
                    params[_key] = arguments[_key];
                }

                return (_bus = _this.bus).trigger.apply(_bus, ['title:wishlist:success', { titleModel: titleModel, action: action, context: context }].concat(params));
            })['catch'](function () {
                var _bus2;

                for (var _len2 = arguments.length, params = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    params[_key2] = arguments[_key2];
                }

                var jqXHR = (params.length && params || [{}])[0].jqXHR;


                _this._wishlistFailure(titleModel, jqXHR);
                (_bus2 = _this.bus).trigger.apply(_bus2, ['title:wishlist:fail', { titleModel: titleModel, action: action, context: context }].concat(params));
            }).then(function () {
                return _this.bus.trigger('title:wishlist:end', { titleModel: titleModel, action: action, context: context });
            });

            return request;
        }
    }, {
        key: '_wishlistAddAjax',
        value: function _wishlistAddAjax(titleModel, context) {
            var _this2 = this;

            this.bus.trigger('title:wishlist:add:start', { titleModel: titleModel, context: context });

            var response = $.ajax({
                url: window.url(window.routes.accountWishlistAdd, { mediaId: titleModel.id }),
                type: 'PUT'
            });

            response.done(function () {
                titleModel.set('wishlistState', 'wishlistRemove');
                _this2.bus.trigger('title:wishlist:add:success', { titleModel: titleModel, context: context });
            }).fail(function () {
                var _bus3;

                for (var _len3 = arguments.length, params = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                    params[_key3] = arguments[_key3];
                }

                return (_bus3 = _this2.bus).trigger.apply(_bus3, ['title:wishlist:add:fail', { titleModel: titleModel, context: context }].concat(params));
            }).always(function () {
                return _this2.bus.trigger('title:wishlist:add:end', { titleModel: titleModel, context: context });
            });

            return response;
        }
    }, {
        key: '_wishlistRemoveAjax',
        value: function _wishlistRemoveAjax(titleModel, context) {
            var _this3 = this;

            this.bus.trigger('title:wishlist:remove:start', { titleModel: titleModel, context: context });

            var response = $.ajax({
                url: window.url(window.routes.accountWishlistRemove, { mediaId: titleModel.id }),
                type: 'DELETE'
            });

            response.done(function () {
                titleModel.set('wishlistState', 'wishlistAdd');
                _this3.bus.trigger('title:wishlist:remove:success', { titleModel: titleModel, context: context });
            }).fail(function () {
                var _bus4;

                for (var _len4 = arguments.length, params = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                    params[_key4] = arguments[_key4];
                }

                return (_bus4 = _this3.bus).trigger.apply(_bus4, ['title:wishlist:remove:fail', { titleModel: titleModel, context: context }].concat(params));
            }).always(function () {
                return _this3.bus.trigger('title:wishlist:remove:end', { titleModel: titleModel, context: context });
            });

            return response;
        }
    }, {
        key: '_wishlistFailure',
        value: function _wishlistFailure(titleModel, jqXHR) {
            if (jqXHR.responseText && JSON.parse(jqXHR.responseText).sessionExpired) {
                this.bus.trigger('user:session:expired');
            } else {
                toaster.push(window.html('error.defaultErrorHtml'), 'error');
            }
        }
    }]);

    return Wishlist;
}();

exports['default'] = Wishlist;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\FeatureHighlightManager.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cookieConfig = require('../../../lib/cookieConfig');

var _cookieConfig2 = _interopRequireDefault(_cookieConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FeatureHighlightManager = function () {
    function FeatureHighlightManager(highlightedFeatureState) {
        var _this = this;

        _classCallCheck(this, FeatureHighlightManager);

        this.highlightedFeatureState = highlightedFeatureState;

        $('.highlightedFeature.notVisited .highlightedFeatureTriggerElement').on('click', function (e) {
            return _this.highlightedFeatureClicked(e);
        });
        $('.visitAllFeaturesTriggerElement').on('click', function () {
            return _this.allFeaturesVisited();
        });
    }

    _createClass(FeatureHighlightManager, [{
        key: 'allFeaturesVisited',
        value: function allFeaturesVisited() {
            this.highlightedFeatureState.visitAllActiveFeatures();
            this.save();
        }
    }, {
        key: 'highlightedFeatureClicked',
        value: function highlightedFeatureClicked(e) {
            var featureName = this.getFeatureName(e.currentTarget);

            if (!this.highlightedFeatureState.wasVisited(featureName)) {
                this.highlightedFeatureState.visit(featureName);
                this.save();
            }

            this.clearFeatureHighlight(featureName);
            this.updatedHamburgerDot(); // yummy
        }
    }, {
        key: 'getFeatureName',
        value: function getFeatureName(element) {
            var parent = this.getFeatureRootElement(element);
            return parent.attributes['data-feature-name'].value;
        }
    }, {
        key: 'clearFeatureHighlight',
        value: function clearFeatureHighlight(featureName) {
            $('[data-feature-name="' + featureName + '"]').removeClass('notVisited');
        }
    }, {
        key: 'getFeatureRootElement',
        value: function getFeatureRootElement(currentElement) {
            if ($(currentElement).hasClass('highlightedFeature')) {
                return currentElement;
            } else {
                var featureParent = $(currentElement).closest('.highlightedFeature').first();
                if (!featureParent || featureParent.length === 0) {
                    throw new Error('Found no ancestor with class "highlightedFeature"');
                }
                return featureParent[0];
            }
        }
    }, {
        key: 'updatedHamburgerDot',
        value: function updatedHamburgerDot() {
            if (!this.highlightedFeatureState.unvisitedFeaturePresent) {
                $('.MobileNav-accountMenu').removeClass('highlightedFeaturePresent');
            }
        }
    }, {
        key: 'save',
        value: function save() {
            var cookieInfo = _cookieConfig2['default'].visitedFeatures;
            Cookies.set(cookieInfo.name, this.highlightedFeatureState.flags, { expires: new Date(Date.now() + cookieInfo.durationMS) });

            if (window.OverDrive.isAuthenticated) {
                $.ajax({
                    url: window.url(window.routes.preferences),
                    type: 'PATCH',
                    contentType: 'application/json',
                    data: JSON.stringify({ visitedFeatures: this.highlightedFeatureState.flags }),
                    error: function error(jqXHR, textStatus, errorThrown) {
                        window.Logger.log('error', 'failed to save visitedFeatures flags to user preferences', { status: textStatus, error: errorThrown });
                    }
                });
            }
        }
    }]);

    return FeatureHighlightManager;
}();

exports['default'] = FeatureHighlightManager;

},{"../../../lib/cookieConfig":"C:\\projects\\lightning\\lib\\cookieConfig.js"}],"C:\\projects\\lightning\\public\\ecmascript\\util\\Promise.js":[function(require,module,exports){
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// ES6 version of settle
Promise.settle = function (promises) {
    var PromiseInspection = function PromiseInspection(fulfilled, value) {
        _classCallCheck(this, PromiseInspection);

        this.fulfilled = fulfilled;
        this.value = value;
    };

    return Promise.all(promises.map(function (p) {
        return (
            // make sure any values are wrapped in a promise
            Promise.resolve(p).then(function (val) {
                return new PromiseInspection(true, val);
            })["catch"](function (err) {
                return new PromiseInspection(false, err);
            })
        );
    }));
};

// wrapping Promise notation around an ajax call
Promise.ajax = function (options) {
    return new Promise(function (resolve, reject) {
        return $.ajax(options).done(function (response) {
            return resolve(response);
        }).fail(function (xhr, status, err) {
            return reject(err);
        });
    });
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\account\\arrowTabAccountMenu.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keycodes = require('../keycodes.js');

var _keycodes2 = _interopRequireDefault(_keycodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/*
 * Force account menu to be navigable with arrow keys
 * @param {object} e event object
 */
var arrowTabAccountMenu = function arrowTabAccountMenu(e) {
    if (e.which === _keycodes2['default'].DOWN) {
        e.preventDefault();
        if ($(e.target).is('ul')) {
            $('ul#dropAccount li:first-child a').focus();
        } else {
            $(e.target).emulateTab();
        }
    }
    if (e.which === _keycodes2['default'].UP) {
        e.preventDefault();
        $(e.target).emulateTab(-1);
    }

    e.stopPropagation();
};

exports['default'] = arrowTabAccountMenu;

},{"../keycodes.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\keycodes.js"}],"C:\\projects\\lightning\\public\\ecmascript\\util\\carousel\\hideArrowsOnEndOfScroll.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var hideArrowsOnEndOfScroll = function hideArrowsOnEndOfScroll(e, el) {
    var media = $(el).children('.js-carouselItem');
    var elemWidth = $(el)[0].getBoundingClientRect().width;
    var mediaWidth = media[0].getBoundingClientRect().width;
    var mediaAmount = media.length;

    if ($(el).scrollLeft() === 0) {
        $(el).parent().siblings('.js-carouselArrowLeft').css('visibility', 'hidden');
    } else {
        $(el).parent().siblings('.js-carouselArrowLeft').css('visibility', 'visible');
    }

    if ($(el).scrollLeft() + elemWidth >= mediaWidth * mediaAmount + mediaAmount * 3.3) {
        $(el).parent().siblings('.js-carouselArrowRight').css('visibility', 'hidden');

        // Stop scrolling past content in Firefox
        if (window.scrollAmt === 0) {
            window.scrollAmt = $(el).scrollLeft();
        } else {
            $(el).scrollLeft(window.scrollAmt);
            window.scrollAmt = 0;
        }
    } else {
        $(el).parent().siblings('.js-carouselArrowRight').css('visibility', 'visible');
    }
};

exports['default'] = hideArrowsOnEndOfScroll;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\carousel\\hideCarouselArrows.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var hideCarouselArrowsForEl = function hideCarouselArrowsForEl(el) {
    var media = $(el).children('.js-carouselItem');
    var mediaAmount = media.length;
    var mediaWidth = media[0].getBoundingClientRect().width;
    var elemWidth = $(el)[0].getBoundingClientRect().width;

    $(el).parent().siblings('.js-carouselArrowRight').css('visibility', 'visible');

    if (mediaAmount * mediaWidth <= elemWidth) {
        $(el).parent().siblings('.js-carouselArrowLeft').css('visibility', 'hidden');
        $(el).parent().siblings('.js-carouselArrowRight').css('visibility', 'hidden');
    }
};

exports['default'] = hideCarouselArrowsForEl;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\carousel\\roundScroll.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/*
 * Snap to nearest cover
 */
var roundScroll = function roundScroll(n, direction, width) {
    if (direction === 'left') {
        return Math.ceil(n / width) * width;
    }
    return Math.floor(n / width) * width;
};

exports['default'] = roundScroll;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\carousel\\scrollCarousel.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _roundScroll = require('./roundScroll.js');

var _roundScroll2 = _interopRequireDefault(_roundScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/*
 * Scroll a media carousel to the right or left
 * @param {string} direction The direction the carousel should scroll
 * @param {string} elem Selector to indicate the carousel element to be scrolled
 */
var scrollCarousel = function scrollCarousel(direction, elem) {
    var media = $(elem).children('.js-carouselItem');
    var elemWidth = elem[0].getBoundingClientRect().width;
    var mediaWidth = media[0].getBoundingClientRect().width;
    var mediaAmount = media.length;

    // Calculate # of titles to left
    var totalLeft = Math.ceil(elem.scrollLeft() / mediaWidth);

    // Calculate number of 4px gaps between titles to compensate
    var gapTotalLeft = (totalLeft + 4) * 4;

    if (direction === 'right') {
        if (elem.scrollLeft() + elemWidth < mediaWidth * mediaAmount) {
            var a = (0, _roundScroll2['default'])(elem.scrollLeft(), 'right', mediaWidth);
            var b = (0, _roundScroll2['default'])(elemWidth, 'right', mediaWidth);
            var scrollLeft = a + b + gapTotalLeft;
            elem.animate({ scrollLeft: scrollLeft });
        }
    } else {
        // Check for obscured cover and if greater or less than 50% shown
        var modifier = 0;
        if ((0, _roundScroll2['default'])(elem.scrollLeft(), 'left', mediaWidth) - elem.scrollLeft() > 100) {
            modifier += mediaWidth;
        }
        var _a = (0, _roundScroll2['default'])(elem.scrollLeft(), 'left', mediaWidth);
        var _b = -elemWidth;
        var c = gapTotalLeft;
        var d = -24;
        var e = -modifier;
        var _scrollLeft = _a + _b + c + d + e;
        elem.animate({ scrollLeft: _scrollLeft });
    }
};

exports['default'] = scrollCarousel;

},{"./roundScroll.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\carousel\\roundScroll.js"}],"C:\\projects\\lightning\\public\\ecmascript\\util\\colors\\componentToHex.js":[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var componentToHex = function componentToHex(c) {
    var hex = c.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
};

exports["default"] = componentToHex;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\colors\\rgbToHex.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _componentToHex = require('./componentToHex.js');

var _componentToHex2 = _interopRequireDefault(_componentToHex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var rgbToHex = function rgbToHex(r, g, b) {
    return '#' + (0, _componentToHex2['default'])(r) + (0, _componentToHex2['default'])(g) + (0, _componentToHex2['default'])(b);
};

exports['default'] = rgbToHex;

},{"./componentToHex.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\colors\\componentToHex.js"}],"C:\\projects\\lightning\\public\\ecmascript\\util\\compatibility\\arrowTabMenu.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keycodes = require('../keycodes.js');

var _keycodes2 = _interopRequireDefault(_keycodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/*
 * Some all expression
 */
var someLongThing = function someLongThing($target) {
    return !$target.is('h2') && $target.closest('li').is(':first-child') && ($target.closest('ul').hasClass('popular-links') && $target.closest('ul').closest('li').is(':first-child') || $target.closest('ul').hasClass('featured-links'));
};

/*
 * Force nav menu to be navigable with arrow keys in all browsers
 * @param {object} e Event object
 */
var arrowTabMenu = function arrowTabMenu(e) {
    var id = '';
    var $target = $(e.target);
    if (e.which === _keycodes2['default'].DOWN) {
        e.preventDefault();
        // focus on next available element
        if ($target.hasClass('f-dropdown')) {
            $target.children('div.featured').find('h2:first').focus();
        } else if ($target.is('h2')) {
            $target.next('ul').find('a:first').focus();
        } else if ($target.hasClass('browse-all')) {
            if ($target.parents('div').hasClass('featured')) {
                if ($target.parents('.featured').next('div').hasClass('popular')) {
                    $target.parents('.featured').next('div.popular').find('h2:first').focus();
                } else {
                    id = $target.closest('ul').attr('id');
                    $('li[data-dropdown="' + id + '"] a').focus();
                }
            } else {
                id = $target.closest('ul').attr('id');
                $('li[data-dropdown="' + id + '"]').focus();
            }
        } else {
            $target.emulateTab();
        }
    } else if (e.which === _keycodes2['default'].UP) {
        e.preventDefault();
        if (someLongThing($target)) {
            $target.closest('div').find('h2').focus();
        } else if ($target.hasClass('browse-all')) {
            $target.prev('ul').find('li:last-child a').focus();
        } else if ($target.is('h2')) {
            if ($target.closest('div').hasClass('popular')) {
                $target.closest('div.popular').prev('div.featured').find('a.browse-all').focus();
            } else {
                id = $target.closest('ul').attr('id');
                $('li[data-dropdown="' + id + '"] a').focus();
            }
        } else {
            $target.emulateTab(-1);
        }
    }
    e.stopPropagation();
};

exports['default'] = arrowTabMenu;

},{"../keycodes.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\keycodes.js"}],"C:\\projects\\lightning\\public\\ecmascript\\util\\compatibility\\force_real_page_reload.js":[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
// Force a full page reload for devices that try
// to draw from a back/forward cache.
var forceRealPageReload = function forceRealPageReload(event) {
    if (event.originalEvent.persisted) {
        window.location.reload();
    }
};

exports["default"] = forceRealPageReload;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\compatibility\\onunload.js":[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Force firefox to reload page when hitting back button.
// Allows document ready event to fire.
var onunload = function onunload() {}; // eslint-disable-line no-empty-function
exports["default"] = onunload;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\compatibility\\removeCarouselFunctionality.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/*
 * Remove carousel functionality
 */
var removeCarouselFunctionality = function removeCarouselFunctionality() {
    var vertOrientation = Math.abs(window.orientation) !== 90;
    // Delete all but 3 in carousels
    $('.carousel.loaded').each(function (index, el) {
        var children = $(el).children();
        for (var x = 3; x < children.length; x++) {
            $(children[x]).remove();
        }

        children = children.slice(0, 3);
        children.addClass('text-left');
        $(el).addClass('text-center').css('overflow-x', 'hidden');

        if (vertOrientation) {
            children.last().hide();
        }
    });
    $('.js-carouselArrow').remove(); // Remove arrows
};

/*
 * On orientation change, ensure carousel has no functionality
 */
var persistRemovalOfCarouselFunctionality = function persistRemovalOfCarouselFunctionality() {
    window.onorientationchange = function () {
        $('.carousel.loaded').each(function (index, el) {
            return $(el).children().last().hide();
        });
    };
};

/*
 * Display titles without a carousel n old Android (< v. 3.0) devices
 * @param device - detectshun object
 */
var removeCarouselFunctionForOldAndroid = function removeCarouselFunctionForOldAndroid(device) {
    var is2genKindle = device.bowser.android && device.bowser.osversion >= '4.0.3' && !!window.navigator.userAgent.match(/KFTT/);
    var isOldAndroid = device.bowser.android && device.bowser.osversion < '3';

    if (is2genKindle || isOldAndroid) {
        removeCarouselFunctionality();
        persistRemovalOfCarouselFunctionality();
    }
};

exports.removeCarouselFunctionForOldAndroid = removeCarouselFunctionForOldAndroid;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\dates\\addDays.js":[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var addDays = function addDays(days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    return d.toISOString();
};

exports["default"] = addDays;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\dyslexic\\expensiveDomTraversalForDyslexicIfCookiePleaseDoNotUse.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _expensiveDomTraversalForDyslexicPleaseDoNotUse = require('./expensiveDomTraversalForDyslexicPleaseDoNotUse.js');

var _expensiveDomTraversalForDyslexicPleaseDoNotUse2 = _interopRequireDefault(_expensiveDomTraversalForDyslexicPleaseDoNotUse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/*
 * Do the expensive DOM traversal if cookie set.
 */
var expensiveDomTraversalForDyslexicIfCookiePleaseDoNotUse = function expensiveDomTraversalForDyslexicIfCookiePleaseDoNotUse() {
    if (window.Cookies && window.Cookies.get('dyslexic-setting') === '1') {
        (0, _expensiveDomTraversalForDyslexicPleaseDoNotUse2['default'])('open-dyslexic', -1);
    }
};

exports['default'] = expensiveDomTraversalForDyslexicIfCookiePleaseDoNotUse;

},{"./expensiveDomTraversalForDyslexicPleaseDoNotUse.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\dyslexic\\expensiveDomTraversalForDyslexicPleaseDoNotUse.js"}],"C:\\projects\\lightning\\public\\ecmascript\\util\\dyslexic\\expensiveDomTraversalForDyslexicPleaseDoNotUse.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var expensiveDomTraversalForDyslexicPleaseDoNotUse = function expensiveDomTraversalForDyslexicPleaseDoNotUse(font, fontsizeOffset) {
    $(':not("i"):not(".menu-icon"):not("style"):not("script"):not(.icon-search-nav)').each(function (index, el) {
        el.style.setProperty('font-family', font, 'important');
        var $el = $(el);
        if ($el.children().length === 0 || $el.children().length === 1 && $el.children('i').length >= 1) {
            var fontsize = parseInt($el.css('font-size'), 10);
            $el.css('font-size', fontsize + fontsizeOffset + 'px');
        }
    });
};

exports['default'] = expensiveDomTraversalForDyslexicPleaseDoNotUse;


},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\encoding\\rfc3986EncodeURIComponent.js":[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Encode a string
 * @param {string} str String to be encoded
 * @returns {string}
 */
var rfc3986EncodeURIComponent = function rfc3986EncodeURIComponent(str) {
  return encodeURIComponent(str).replace(/[&!'()*]/g, escape);
};

exports["default"] = rfc3986EncodeURIComponent;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\findFormatId.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/*
 * @param formats
 * @returns {string} The format ID or null
 */
var findFormatId = function findFormatId(formats) {
    if (formats != null) {
        for (var x = 0; x < formats.length; x++) {
            var val = formats[x];
            if (val.id === 'ebook-epub-adobe' || val.id === 'ebook-epub-open' || val.id === 'audiobook-mp3' || val.id === 'video-streaming') {
                return val.id;
            }
        }
    }
    return null;
};

exports['default'] = findFormatId;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\forwardedActions.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.recommend = undefined;

var _Title = require('../components/media/models/Title');

var _Title2 = _interopRequireDefault(_Title);

var _TitleActions = require('../title-actions/TitleActions');

var _TitleActions2 = _interopRequireDefault(_TitleActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// process instant forward actions (refactored)
var recommend = function recommend(qs, action, bus) {
    if (action) {
        var mediaId = action.split('~')[1];
        var $actionLink = $('.js-recommend[data-media-id="' + mediaId + '"]');
        if ($actionLink.length > 0) {
            // remove the fragment
            history.replaceState(null, null, window.location.pathname + qs);

            // have to do a js click instead of jQuery on <a href>?
            $actionLink[0].click();
        } else {
            // Remove action from url
            history.replaceState(null, null, window.location.pathname + qs);
            var title = new _Title2['default']();
            var promise = new Promise(function (resolve, reject) {
                title.getTitleAsync(mediaId, resolve, reject);
            });

            promise.then(function () {
                var titleAction = new _TitleActions2['default']({ bus: bus });
                titleAction.perform('recommend', title);
            });
        }
    }
};

exports.recommend = recommend;

},{"../components/media/models/Title":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\models\\Title.js","../title-actions/TitleActions":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\TitleActions.js"}],"C:\\projects\\lightning\\public\\ecmascript\\util\\keycodes.js":[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var keys = Object.freeze({
    TAB: 9,
    ENTER: 13,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    SPACE: 32
});
exports["default"] = keys;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\logging\\logger.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _window = window,
    _ = _window._;


var logger = {
    log: function log(level, message, fields) {
        var body = {
            level: level || 'info',
            message: message || 'No message specified',
            fields: {
                path: window.location.pathname
            }
        };

        if (level === 'error') {
            body.fields.stackTrace = new Error().stack;
        }

        if (!_(fields).isEmpty()) {
            Object.assign(body.fields, fields);
        }

        // TODO: remove LHTNG-2598 test code
        console.log(body);

        var requestData = JSON.stringify(body);

        var request = new XMLHttpRequest();
        request.open('POST', '/log', true);
        request.setRequestHeader('Content-Type', 'application/json');
        request.send(requestData);
    }
};

exports['default'] = Object.freeze(logger);

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\noCard.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var noCard = function noCard(action, mediaId, stub) {
    // TODO: This logic is completely buggy and wrong
    var forwardUrl = stub.replace(encodeURIComponent('?no-linked-card=true'), '').replace(/(&|\?)no-linked-card(=true|\=false)/, '');
    var cardLinkUrl = window.url(window.routes.accountStartCardLink, { forward: forwardUrl, action: [action, mediaId].join('~') });
    $('#add-card-button').attr('href', cardLinkUrl);
};

exports['default'] = noCard;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\parameters.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var mandatory = function mandatory() {
    throw new Error('Missing parameter');
};

exports.mandatory = mandatory;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\query.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.removeQueryParam = undefined;

var _querystring = require('../../../node_modules/querystring');

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var removeQueryParam = function removeQueryParam(qs, param) {
    var newqs = qs.toLowerCase();
    if (qs[0] === '?') {
        newqs = qs.substr(1); // Remove starting '?'
    }
    var queryObj = _querystring2['default'].parse(newqs);
    delete queryObj[param];
    return '?' + _querystring2['default'].stringify(queryObj); // Reappend '?'
};

exports.removeQueryParam = removeQueryParam;

},{"../../../node_modules/querystring":"C:\\projects\\lightning\\node_modules\\querystring\\index.js"}],"C:\\projects\\lightning\\public\\ecmascript\\util\\requests\\ensureSimpleRequest.js":[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports["default"] = function (requestFn) {
    var headers = $.ajaxSettings.headers;
    delete $.ajaxSettings.headers;
    var promise = requestFn();
    $.ajaxSettings.headers = headers;
    return promise;
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\routes.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.routes = exports.url = undefined;

var _routing = require('../../../lib/internal/routing.js');

var _routing2 = _interopRequireDefault(_routing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var routes = _routing2['default'].routes;

var url = function url(route, parameters) {
    var result = _routing2['default'].getRouteUrl({ baseUrl: window.OverDrive._baseUrl }, route, parameters);

    if (!result) {
        try {
            var message = 'Failed to route ' + route;
            if (parameters != null) {
                var parametersJSON = JSON.stringify(parameters);
                message += ' with parameters ' + parametersJSON;
            }

            var error = new Error(message);

            if (window.NREUM && window.NREUM.noticeError) {
                window.NREUM.noticeError(error);
            } else if (window.console && window.console.error) {
                window.console.error(error);
            }
        } catch (e) {
            // ¯\_(ツ)_/¯
        }
    }
    return result;
};

exports.url = url;
exports.routes = routes;

},{"../../../lib/internal/routing.js":"C:\\projects\\lightning\\lib\\internal\\routing.js"}],"C:\\projects\\lightning\\public\\ecmascript\\util\\svgLoader.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

// LHTNG-1817 - Dynamic SVG Loader
exports['default'] = function () {
    $(function () {
        try {
            delete $.ajaxSettings.headers['csrf-token'];

            $('.svg.dynamic-loader').each(function (i, el) {
                var $elm = $(el);
                var src = $elm.attr('data-src');

                if (!_(src).isEmpty() && !$elm.html()) {
                    $.get(window.OverDrive.cdn + '/public/img/' + src).then(function (response) {
                        if (!$elm.html()) {
                            $elm.append($('svg', response));
                        }
                    });
                }
            });
        } finally {
            $.ajaxSetup({
                headers: { 'csrf-token': $('#csrf').val() || OverDrive._csrf }
            });
        }
    });
};

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\text.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createRegex = exports.surroundSubtext = exports.decodeEntities = exports.createClosingTag = exports.createOpeningTag = undefined;

var _parameters = require('./parameters');

var createOpeningTag = function createOpeningTag(tag) {
    return '<' + tag + '>';
};

var createClosingTag = function createClosingTag(tag) {
    return '</' + tag + '>';
};

var decodeEntities = function decodeEntities(encodedString) {
    var textArea = document.createElement('textarea');
    textArea.innerHTML = encodedString;
    return textArea.value;
};

var surroundSubtext = function surroundSubtext(_ref) {
    var _ref$text = _ref.text,
        text = _ref$text === undefined ? (0, _parameters.mandatory)() : _ref$text,
        _ref$matcher = _ref.matcher,
        matcher = _ref$matcher === undefined ? (0, _parameters.mandatory)() : _ref$matcher,
        _ref$tag = _ref.tag,
        tag = _ref$tag === undefined ? (0, _parameters.mandatory)() : _ref$tag,
        _ref$ignoreCase = _ref.ignoreCase,
        ignoreCase = _ref$ignoreCase === undefined ? false : _ref$ignoreCase,
        _ref$global = _ref.global,
        global = _ref$global === undefined ? false : _ref$global;

    // Makes users input of special characters be disregard
    var cleanMatcher = matcher.replace(/\s/g, '').replace(/\,/g, '').replace(/\./g, '');
    // Makes users input match those with special characters
    var pattern = '(' + cleanMatcher.split('').join('(\\s|\\,|\\.)*') + ')';
    var flags = '' + (ignoreCase ? 'i' : '') + (global ? 'g' : '');
    var regexp = new RegExp(pattern, flags);
    var newSubstring = createOpeningTag(tag) + '$1' + createClosingTag(tag);
    return text.replace(regexp, newSubstring);
};

var createRegex = function createRegex(_ref2) {
    var _ref2$text = _ref2.text,
        text = _ref2$text === undefined ? (0, _parameters.mandatory)() : _ref2$text,
        _ref2$ignoreCase = _ref2.ignoreCase,
        ignoreCase = _ref2$ignoreCase === undefined ? false : _ref2$ignoreCase,
        _ref2$global = _ref2.global,
        global = _ref2$global === undefined ? false : _ref2$global,
        _ref2$ignoreWhitespac = _ref2.ignoreWhitespace,
        ignoreWhitespace = _ref2$ignoreWhitespac === undefined ? false : _ref2$ignoreWhitespac;

    var pattern = ignoreWhitespace ? '(' + text.split('').join('(\\s|\\n)*') + ')' : text;
    var flags = '' + (ignoreCase ? 'i' : '') + (global ? 'g' : '');
    var regexp = new RegExp(pattern, flags);
    return regexp;
};

exports.createOpeningTag = createOpeningTag;
exports.createClosingTag = createClosingTag;
exports.decodeEntities = decodeEntities;
exports.surroundSubtext = surroundSubtext;
exports.createRegex = createRegex;

},{"./parameters":"C:\\projects\\lightning\\public\\ecmascript\\util\\parameters.js"}],"C:\\projects\\lightning\\public\\ecmascript\\util\\title-actions\\fillStars.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var fillStars = function fillStars($container, stars, options) {
    stars = stars || 0;
    options = options || {};
    var children = $container.children('.icon-star');

    children.removeClass('filled');
    if (!options.isHover) {
        // If the user is actually setting the rating
        children.each(function (i, el) {
            var ratingCopy = window.html('starRating.unratedLabel', { number: i + 1, currentRating: stars });
            if (options.setRating) {
                ratingCopy = window.html('starRating.ratedLabelLong', { number: i + 1, currentRating: stars });
            }
            $(el).attr('aria-label', ratingCopy);
        });
    }

    children = children.filter(function (i) {
        return i + 1 <= Math.round(stars);
    }).addClass('filled');

    if (options.setRating) {
        children.last().attr('aria-label', window.html('starRating.removeRating', { stars: stars }));
    }
};

exports['default'] = fillStars;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\title-actions\\handleForwardActionHold.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _browser = require('../../../../lib/i18n/browser');

var handleForwardActionHold = function handleForwardActionHold(data, titleId) {
    $.when(ajax.getPatronEmail()).done(function (emailResp) {
        if (emailResp === '') {
            var title = data.title;
            var typeId = data.type.id;
            var typeName = data.type.name;
            // TODO: confirm that this reference to window.OverDrive.cdn actually works
            var artwork = data.covers.cover300Wide.href == null ? window.OverDrive.cdn + '/public/img/no-cover_en_US.jpg' : data.covers.cover300Wide.href;
            var prereleaseDate = (0, _browser.html)('date-full', { d: data.estimatedReleaseDate });
            var isPrerelease = data.isPreReleaseTitle;
            var mediaId = titleId;

            var modal = $('#hold-dynamic-modal');
            $('[data-id="title"]').html(title);
            $('[data-id="format-icon"]').removeClass().addClass('icon-' + typeId);
            $('[data-id="format-name"]').html(typeName);
            $('[data-id="cover-image"]').attr('src', artwork);
            if (prereleaseDate != null && isPrerelease) {
                $('[data-id="pre-release-label"]').text(window.text('accountHolds.prereleaseExpected', { date: prereleaseDate })).removeClass('hideMe');
            } else {
                $('[data-id="pre-release-label"]').text('').addClass('hideMe');
            }

            $('form#hold-dynamic-form').attr({ 'data-media-id': mediaId, 'data-from-ajax': 'true' });

            // Disney publisher ids are 98146 - 98155
            if (data.publisher.id >= 98146 && data.publisher.id <= 98155 && Cookies.get('disney-eula-setting') !== '1') {
                $('#disney-eula-modal').foundation('reveal', 'open');
            } else {
                modal.foundation('reveal', 'open');
            }
        } else {
            ajax.placeHold(titleId, emailResp, $('body'));
        }
    });
};

exports['default'] = handleForwardActionHold;

},{"../../../../lib/i18n/browser":"C:\\projects\\lightning\\lib\\i18n\\browser\\index.js"}],"C:\\projects\\lightning\\public\\ecmascript\\util\\title-actions\\openHoldConflictModal.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/*
 * Handle opening the hold conflict modal
 */
var openHoldConflictModal = function openHoldConflictModal(mediaData) {
    var originalHTMLContents = $('.primary-action[data-media-id="' + mediaData.id + '"]').html();

    $('.modal').foundation('reveal', 'close');

    var dataType = mediaData.typeId;
    var holdButton = $('.now-unavailable-button-container a:not([data-cancel])');

    $('.primary-action[data-id="' + mediaData.id + '"]').html(originalHTMLContents);
    $('[data-id="title"]').html(mediaData.title);
    $('[data-id="cover-image"]').attr('src', mediaData.cover);

    holdButton.attr('data-title', mediaData.title).attr('data-artwork', mediaData.cover).attr('data-type', dataType).attr('data-type-name', dataType.toUpperCase()).attr('data-pre-release', mediaData.prerelease);

    loading.changeButtonState(holdButton, 'hold');

    holdButton.attr('data-media-id', mediaData.id).attr('href', 'javascript:void(0)').attr('data-action', 'hold');
    $('#now-unavailable-modal').foundation('reveal', 'open');
};

exports['default'] = openHoldConflictModal;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\title-actions\\processForwardedAction.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _HashManager = require('../../components/common/HashManager');

var _HashManager2 = _interopRequireDefault(_HashManager);

var _Title = require('../../components/media/models/Title');

var _Title2 = _interopRequireDefault(_Title);

var _TitleActions = require('../../title-actions/TitleActions');

var _TitleActions2 = _interopRequireDefault(_TitleActions);

var _forwardedActions = require('../forwardedActions.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProcessForwardedAction = function () {
    function ProcessForwardedAction(collection, bus, model) {
        _classCallCheck(this, ProcessForwardedAction);

        var hash = _HashManager2['default'].get('action')[0];
        this.actionArr = hash ? hash.split('~') : [];
        this.action = this.actionArr[0] || null;
        this.mediaId = this.actionArr[1] || null;
        this.rating = this.actionArr[2] || 0;
        this.model = model || null;
        this.collection = collection.models;
        this.bus = bus;
    }

    // Execute user forwarded action


    _createClass(ProcessForwardedAction, [{
        key: 'executeAction',
        value: function executeAction() {
            var _this = this;

            if (!this.action || !this.mediaId) {
                return;
            }

            if (!this.model || this.model && this.model.get('id') !== this.mediaId) {
                this.model = _.find(this.collection, function (model) {
                    return model.id === _this.mediaId;
                });
            }

            var titleActions = new _TitleActions2['default']({ bus: this.bus });

            if (this.model) {
                // Title model is on page
                _HashManager2['default'].remove('action');

                // LHTNG-1685 - Throw conflict modal if title is isOwned on a 'recommend' forwarded action
                if (this.action === 'recommend' && this.model.get('isOwned')) {
                    if (this.model.get('titleState') === 'borrow') {
                        this.bus.trigger('title:hold:conflict', { titleModel: this.model });
                    } else {
                        this.bus.trigger('title:borrow:conflict', { titleModel: this.model });
                    }

                    return;
                }

                this.model.set('userStarRating', this.rating);
                titleActions.perform(this.action, this.model);
            } else if (this.action === 'recommend' && $('a.primary-action[data-media-id="' + this.mediaId + '"]').length > 0) {
                // Recommended from the preview row
                // Remove after RTL preview row is refactored
                (0, _forwardedActions.recommend)('', this.action, this.bus);
                _HashManager2['default'].remove('action');
            } else {
                // Title model is not on page, fetch async
                var title = new _Title2['default']();
                var promise = new Promise(function (resolve, reject) {
                    title.getTitleAsync(_this.mediaId, resolve, reject);
                });

                promise.then(function () {
                    _this.model && _this.model.set('userStarRating', _this.rating);
                    titleActions.perform(_this.action, title);
                    _HashManager2['default'].remove('action');
                });
            }
        }
    }]);

    return ProcessForwardedAction;
}();

exports['default'] = ProcessForwardedAction;

},{"../../components/common/HashManager":"C:\\projects\\lightning\\public\\ecmascript\\components\\common\\HashManager.js","../../components/media/models/Title":"C:\\projects\\lightning\\public\\ecmascript\\components\\media\\models\\Title.js","../../title-actions/TitleActions":"C:\\projects\\lightning\\public\\ecmascript\\title-actions\\TitleActions.js","../forwardedActions.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\forwardedActions.js"}],"C:\\projects\\lightning\\public\\ecmascript\\util\\title-actions\\processInstantForwardActions.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getQueryParams = require('../url/getQueryParams.js');

var _getQueryParams2 = _interopRequireDefault(_getQueryParams);

var _query = require('../query.js');

var _forwardedActions = require('../forwardedActions.js');

var _selectStarRating = require('./selectStarRating');

var _selectStarRating2 = _interopRequireDefault(_selectStarRating);

var _browser = require('../../../../lib/i18n/browser');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var openHoldConflictModal = './openHoldConflictModal.js';
var handleForwardActionHold = './handleForwardActionHold.js';

var processInstantForwardActions = function processInstantForwardActions(stub) {
    var theStub = stub || window.location.pathname + (window.location.search ? window.location.search : '');
    var action = (0, _getQueryParams2['default'])(window.location.search).action;
    var once = $('body').attr('data-action-processed');
    var qs = (0, _query.removeQueryParam)(window.location.search, 'action');

    if (action && action.indexOf('recommend~') === 0) {
        (0, _forwardedActions.recommend)(qs, action, window.globalEvents);
        return;
    }

    if (action && !once && action.indexOf('~') > -1 && $('body').attr('no-linked-cards') === 'false') {
        history.replaceState(null, null, window.location.pathname + qs);

        action = action.split('~');
        var titleId = action[1];
        var actionElem = $('[data-action="wishlist-add"][data-media-id="' + titleId + '"]');
        var titleElem = $('div.wishlist[data-id="' + titleId + '"] a');
        var rating = parseInt(action[2], 10);
        var actionButton = $('[data-action][data-media-id="' + titleId + '"]').first(); // Action button
        var titleCardLink = $('a.primary-action[data-media-id="' + titleId + '"], .TitleAction-button[data-media-id="' + titleId + '"]').first(); // Link on bottom of title card
        var elem = null;
        var possibleAction = ''; // the action currently attached to the button

        switch (action[0]) {
            case 'wish':
            case 'wishlist-add':
            case 'wishlist-remove':

                // If already added ot the wishlist break.
                if ($('[data-action="wishlist-remove"][data-media-id="' + titleId + '"]').length || $('div.wishlist[data-id="' + titleId + '"] i.icon-wish-list-added').length) {
                    break;
                }

                // Check if item exists on page if it does: click element else: take action manually.
                if (actionElem.length) {
                    // Action button exists
                    actionElem.click();
                } else if (titleElem.length) {
                    // Grid / carousel item exists
                    titleElem.click();
                } else {
                    // Fallback: get media info
                    ajax.wishListAdd(titleId, $('body'));
                    $.ajax({
                        url: window.url(window.routes.mediaInfoId, { id: titleId }),
                        type: 'GET'
                    });
                }
                break;
            case 'star':
                // Needs to happen last in the queue after media status
                $('body').on('userStarRatingSet', function () {
                    (0, _selectStarRating2['default'])($('.star-ratings-container[data-media-id="' + titleId + '"]'), rating);
                });
                break;
            default:
                // borrow, hold, recommend to library

                if (actionButton.length && (actionButton.is(':visible') || Cookies.get('media-view-preference') === 'list')) {
                    elem = actionButton;
                    possibleAction = elem.attr('data-action');
                    if (possibleAction === 'borrow-simple') {
                        possibleAction = 'borrow';
                    }
                } else if (titleCardLink.length) {
                    elem = titleCardLink;
                    if (elem.attr('onclick') && elem.attr('onclick').toLowerCase().indexOf('borrow') > -1 || elem.hasClass('js-borrow')) {
                        possibleAction = 'borrow';
                    } else if (elem.attr('onclick') && elem.attr('onclick').toLowerCase().indexOf('hold') > -1 || elem.hasClass('js-hold')) {
                        possibleAction = 'hold';
                    }
                }

                if (elem) {
                    if (action[0] === possibleAction || action[0] === 'nook') {
                        // the desired action button is visible, click it
                        elem.click();
                    } else if (possibleAction === 'hold') {
                        openHoldConflictModal(titleId, elem);
                    }
                } else {
                    // Fallback: Get media details
                    $.ajax({
                        url: window.url(window.routes.mediaInfoId, { id: titleId }),
                        type: 'GET',
                        success: function success(data) {
                            if (action[0] === 'borrow' || action[0] === 'borrow-simple') {
                                ajax.borrow(titleId, false, $('body'));
                                $(document).on('borrowSuccess', function (e, eventElem, expDate) {
                                    // eBook should be properly capitalized, but other types should be lowercase
                                    var type = data.type.id === 'ebook' ? data.type.name : data.type.id;
                                    ajax.borrowSuccessToast(expDate, type);
                                }).on('borrowFailure', function (e, innerElem, response) {
                                    var parsedResponse = JSON.parse(response.jqXHR.responseText);

                                    // Only execute if the title can be placed on hold and the target was the body
                                    if (parsedResponse.errorCode === 'TitleNoLongerAvailable' && innerElem.context.tagName === 'BODY') {
                                        var fakeElem = $('<a>', {
                                            'data-title': data.title,
                                            'data-type': data.type.id,
                                            'data-artwork': data.covers.cover300Wide.href == null ? 'img/no-cover_en_US.jpg' : data.covers.cover300Wide.href,
                                            'data-prerelease': (0, _browser.html)('date-full', { d: data.estimatedReleaseDate })
                                        });
                                        openHoldConflictModal(titleId, fakeElem);
                                    } else if (parsedResponse.errorCode) {
                                        var href = '';
                                        var linkText = '';
                                        if (parsedResponse.errorCode === 'PatronExceededCheckoutLimit' || parsedResponse.errorCode === 'LoanAlreadyExists') {
                                            href = window.url(window.routes.accountLoans);
                                            linkText = window.html('loans');
                                        } else if (parsedResponse.errorCode === 'PatronExceededChurningLimit' || parsedResponse.errorCode === 'PatronTypeRestrictedFromTitle') {
                                            href = window.url(window.routes.supportMembers);
                                            linkText = window.html('pleaseContactSupport');
                                        }
                                        var link = '<a class="bold" href="' + href + '" tabindex="0">' + linkText + '</a>';
                                        toaster.push('<strong>' + window.html('genericError') + '</strong> ' + window.text('error.' + parsedResponse.errorCode, { link: link }), 'error');
                                    }
                                });
                            } else if (action[0] === 'hold') {
                                $.when(ajax.getAvailability(titleId)).done(function (innerData) {
                                    if (innerData.availableCopies > 0) {
                                        var fakeElem = $('<a>', {
                                            'data-title': innerData.title,
                                            'data-type': innerData.type.id,
                                            'data-artwork': innerData.covers.cover300Wide.href == null ? 'img/no-cover_en_US.jpg' : innerData.covers.cover300Wide.href,
                                            'data-prerelease': (0, _browser.html)('date-full', { d: innerData.estimatedReleaseDate })
                                        });
                                    } else {
                                        handleForwardActionHold(innerData, titleId);
                                    }
                                }).fail(function () {
                                    handleForwardActionHold(data, titleId);
                                });
                            }
                        }
                    });
                }
                break;
        }

        $('body').attr('data-action-processed', true);
    } else if (action && !once && $('body').attr('no-linked-cards') === 'true') {
        action = action.split('~');
        var _titleId = action[1];

        // TODO: This logic is completely buggy and wrong
        var forwardUrl = theStub.replace(encodeURIComponent('?no-linked-card=true'), '').replace(/(&|\?)no-linked-card(=true|\=false)/, '');
        var cardLinkUrl = window.url(window.routes.accountStartCardLink, { forward: forwardUrl, action: [action[0], _titleId].join('~') });

        $('#add-card-button').attr('data-fwd-action', cardLinkUrl);
    }
};

exports['default'] = processInstantForwardActions;

},{"../../../../lib/i18n/browser":"C:\\projects\\lightning\\lib\\i18n\\browser\\index.js","../forwardedActions.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\forwardedActions.js","../query.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\query.js","../url/getQueryParams.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\url\\getQueryParams.js","./selectStarRating":"C:\\projects\\lightning\\public\\ecmascript\\util\\title-actions\\selectStarRating.js"}],"C:\\projects\\lightning\\public\\ecmascript\\util\\title-actions\\selectStarRating.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _fillStars = require('./fillStars.js');

var _fillStars2 = _interopRequireDefault(_fillStars);

var _setUserStarRating = require('./setUserStarRating.js');

var _setUserStarRating2 = _interopRequireDefault(_setUserStarRating);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/*
 * Handles a user selecting a rating
 * */
var selectStarRating = function selectStarRating($container, selectedRating, isHover) {
    var mediaId = $container.data('media-id');
    var existingRating = $container.data('user-rating');

    var isReset = false;
    if (existingRating != null && existingRating === selectedRating) {
        isReset = true;
    }
    var rating = isReset ? 0 : selectedRating;
    if (isReset) {
        $container.data('user-rating', null);
        $container.removeClass('user-rating');
        (0, _fillStars2['default'])($container, $container.data('global-rating'), { setRating: false, isHover: isHover });
    } else {
        (0, _setUserStarRating2['default'])($container, rating, { setRating: true, isHover: isHover });
    }

    if ($container.hasClass('js-no-auth')) {
        // TODO: This will break on pages that need their querystring?
        var forwardUrl = window.location.pathname;
        var action = ['star', mediaId, rating].join('~');
        window.location = window.url(window.routes.accountSignIn, { forward: forwardUrl, action: action });
    } else if (isReset) {
        ajax.deleteStarRating(mediaId);
    } else {
        ajax.setStarRating(mediaId, rating);
    }
};

exports['default'] = selectStarRating;

},{"./fillStars.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\title-actions\\fillStars.js","./setUserStarRating.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\title-actions\\setUserStarRating.js"}],"C:\\projects\\lightning\\public\\ecmascript\\util\\title-actions\\setUserStarRating.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _fillStars = require('./fillStars.js');

var _fillStars2 = _interopRequireDefault(_fillStars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/*
 * Forces a user star rating to be displayed; doesn't persist
 */
var setUserStarRating = function setUserStarRating($container, rating, options) {
    $container.data('user-rating', rating);
    $container.removeClass('user-rating').addClass('user-rating');
    (0, _fillStars2['default'])($container, rating, options);
};

exports['default'] = setUserStarRating;

},{"./fillStars.js":"C:\\projects\\lightning\\public\\ecmascript\\util\\title-actions\\fillStars.js"}],"C:\\projects\\lightning\\public\\ecmascript\\util\\toast\\getCookieExplanation.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/*
 * Append copy to toast explaining cookies to the user
 */
var getCookieExplanation = function getCookieExplanation() {
    var privacyPolicy = window.html('privacyPolicyClickHere');
    var exitSite = window.html('exitSite');
    var cookieToast = window.html('cookieToast', { link: '<a href="http://company.overdrive.com/privacy-policy/" target="_blank">' + privacyPolicy + '</a>' });
    var cookieToastExit = window.html('cookieToastExit', { link: '<a href="https://www.overdrive.com/">' + exitSite + '</a>' });
    $('#eu-notify-toast').html( // eslint-disable-line prefer-template
    cookieToast + '\n         <br/><br/>\n         <strong>\n            ' + cookieToastExit + '\n         </strong>');
};

exports['default'] = getCookieExplanation;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\url\\addQueryParam.js":[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
/*
 * Add the provided query parameter and navigate to the new URL
 * @param {string} name Name of the query parameter to add
 * @param {string} value The new value of the query parameter to add
 */
var addQueryParam = function addQueryParam(name, value) {
    var path = window.location.pathname;
    var queryString = window.location.search;

    if (queryString) {
        queryString += "&" + name + "=" + value;
    } else {
        queryString += "?" + name + "=" + value;
    }

    window.location.href = path + queryString;
};

exports["default"] = addQueryParam;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\url\\getQueryParams.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Get all query parameters
 * @param {string} qs The current query string provided by window.location.search
 * @returns {object} A JSON object containing the query string name and values
 */
var getQueryParams = function getQueryParams(qs) {
    var qsReplaced = qs.split('+').join(' ');

    var params = {};
    var re = /[?&]?([^=]+)=([^&]*)/g;
    var tokens = re.exec(qsReplaced);

    while (tokens) {
        params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
        tokens = re.exec(qsReplaced);
    }

    return params;
};

exports['default'] = getQueryParams;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\util\\url\\replaceQueryParam.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getQueryParams = require('./getQueryParams');

var _getQueryParams2 = _interopRequireDefault(_getQueryParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/*
 * Replace the provided query parameter with a different one and navigate to the new URL
 * @param {string} name Name of the query parameter to replace
 * @param {string} value The new value of the query parameter to replace
 */
var replaceQueryParam = function replaceQueryParam(name, value) {
    var path = window.location.pathname;
    var queryString = window.location.search.replace(/&page=\d+/g, '&page=1').replace(/\?page=\d+/g, '?page=1');
    var query = (0, _getQueryParams2['default'])(queryString);

    if (queryString) {
        if (query[name]) {
            queryString = queryString.replace(name + '=' + query[name], name + '=' + value);
        } else {
            queryString += '&' + name + '=' + value;
        }
    } else {
        queryString = '?' + name + '=' + value;
    }

    window.location.href = path + queryString;
};

exports['default'] = replaceQueryParam;

},{"./getQueryParams":"C:\\projects\\lightning\\public\\ecmascript\\util\\url\\getQueryParams.js"}],"C:\\projects\\lightning\\public\\ecmascript\\util\\url\\stripNoLinkedCardQuery.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/*
 * Strip the noLinkedCard parameter from the url if the user has linked cards
 * @param {array} qs
 * @returns {*}
 */
var stripNoLinkedCardQuery = function stripNoLinkedCardQuery(qs) {
    var arr = qs.split('&');

    if (arr.length === 1 && arr[0].indexOf('no-linked-card') < 0) {
        return qs;
    }

    var newQS = '';
    for (var x = 0; x < arr.length; x++) {
        if (arr[x].indexOf('no-linked-card') > -1) {
            arr[x] = '';
        } else if (x > 0 && x < arr.length) {
            newQS += '&';
        }
        newQS += arr[x];
    }

    return newQS;
};

exports['default'] = stripNoLinkedCardQuery;

},{}],"C:\\projects\\lightning\\public\\ecmascript\\views\\base.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// import when we move more to modules
var Backbone = window.Backbone;

var path = require('path');
var loaderTemplate = _.template("<div class=\"Loader js-es6loader\">\n    <div class=\"Loader-display\"></div><br>\n    <span class=\"Loader-text\"><%= html('loading') %></span>\n</div>\n");

var BaseView = Backbone.View.extend({
    close: function close() {
        this.trigger('close');
        this.remove();
        this.unbind();
        this.stopListening();
        // Views should define this in their extend declaration
        this.onClose && this.onClose();
        return this;
    },
    getHtml: function getHtml() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            templateData = _ref.templateData;

        var globals = {
            html: window.html,
            text: window.text
        };
        var data = templateData || this.getTemplateData();
        return this.template(_.extend({}, data, globals));
    },
    buildElement: function buildElement(options) {
        return this.$el.html(this.getHtml(options));
    },
    doRender: function doRender(options) {
        this.buildElement(options);
        if (this.target && !this.attached) {
            this.beforeAttach && this.beforeAttach();
            this.attach();
            this.attached = true;
        }
    },
    attach: function attach() {
        if (!(this.$target instanceof Backbone.$)) {
            this.$target = Backbone.$(this.target);
        }
        this.$target.append(this.$el);
    },
    render: function render(options) {
        this.clearLoader();

        if (this.beforeRender) {
            this.beforeRender();
        }
        this.doRender(options);
        if (this.afterRender) {
            this.afterRender();
        }
        return this;
    },
    getTemplateData: function getTemplateData() {
        return this.model && this.model.toJSON() || {};
    },
    renderLoader: function renderLoader() {
        var elem = $(this.target).length ? $(this.target) : this.$el;
        elem.empty().append(loaderTemplate({ html: window.html }));
    },
    clearLoader: function clearLoader() {
        // Clear loader if it exists
        var $loader = $('.js-es6loader');
        if ($loader.length) {
            $loader.remove();
        }
    }
});

exports['default'] = BaseView;


},{"path":"C:\\projects\\lightning\\node_modules\\path-browserify\\index.js"}],"C:\\projects\\lightning\\public\\ecmascript\\views\\collection.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _base = require('./base');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var CollectionView = _base2['default'].extend({

    views: [],

    temp: document.createElement('div'),

    destroyItems: function destroyItems() {
        while (this.views.length > 0) {
            this.views[0].deleteView();
            delete this.views[0];
            this.views.shift();
        }
    },
    emptyEl: function emptyEl() {
        this.destroyItems();
        this.$el.empty();
        this.temp.innerHtml = '';
    },
    beforeRender: function beforeRender() {
        this.emptyEl();
    },
    doRender: function doRender() {
        this.template && _base2['default'].prototype.doRender.call(this);
        this.buildAndAppendItems();
    },
    buildAndAppendItems: function buildAndAppendItems() {
        this.buildItems();
        this.appendItems();
    },
    buildItems: function buildItems() {
        this.collection.each(this.assignOne, this);
    },
    appendItems: function appendItems() {
        this.$el.append(this.temp);
    },
    assignOne: function assignOne(model, index) {
        var view = this.createItemView({ model: model });
        this.beforeAppend && this.beforeAppend({ view: view, model: model, index: index });
        var html = view.render().el;
        this.appendItem({ html: html, view: view, model: model, index: index });
        this.views.push(view);
    },
    appendItem: function appendItem(_ref) {
        var html = _ref.html;

        this.temp.appendChild(html);
    },
    getTemplateData: function getTemplateData() {
        return this.collection && this.collection.models || [];
    }
});

exports['default'] = CollectionView;

},{"./base":"C:\\projects\\lightning\\public\\ecmascript\\views\\base.js"}],"C:\\projects\\lightning\\public\\ecmascript\\window_pageshow.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _force_real_page_reload = require('./util/compatibility/force_real_page_reload');

var _force_real_page_reload2 = _interopRequireDefault(_force_real_page_reload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var onWindowPageshow = function onWindowPageshow(event) {

    (0, _force_real_page_reload2['default'])(event);
};

exports['default'] = onWindowPageshow;

},{"./util/compatibility/force_real_page_reload":"C:\\projects\\lightning\\public\\ecmascript\\util\\compatibility\\force_real_page_reload.js"}],"C:\\projects\\lightning\\public\\js\\app.js":[function(require,module,exports){
"use strict";

/**
 * @fileOverview
 * app.js
 * Global JS file that applies to all views.
 * @type {NodeList}
 */

$(document).ready(function () {
    $("form").on("valid invalid", function (e) {
        if (e.type != "valid.fndtn.abide") {
            e.preventDefault();
        }
    });

    //Prevent form submit when errors are showing
    $("form").submit(function (e) {
        if ($(this).find('small.error').is(':visible')) {
            e.preventDefault();
        }
    });

    if (typeof lazyload === 'function') {
        var lzld = lazyload({ src: 'data-aload' });

        $('img[data-aload]')
        // add dimensions
        .addClass('broken')
        // add blank image so it doesn't look broken (this is smaller than clear.gif)
        .attr('src', 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==')
        // remove the placeholder stuff when the image is load for real
        .on('load', function () {
            if (this.getAttribute('data-lzled')) {
                $(this).removeAttr('broken data-aload').removeClass('broken');
            }
        })
        // register the lazy loader watcher
        .each(function () {
            lzld(this);
        });
    } else {
        $('img[data-aload]').attr('src', function () {
            return $(this).attr('data-aload');
        });
    }

    $("[data-forward]").attr("href", $("[data-forward]").attr("href") + "?forward=" + window.location.pathname + stripNoLinkedCardQuery(location.search) + location.hash.replace('#', '&action='));

    var device = detectshun.browser();
    var isWindows = window.navigator.platform.match(/Win/) && !device.bowser.windowsphone ? true : false;
    var isWindows8AndUp = window.navigator.userAgent.match(/(Windows 10.0|Windows NT 10.0|Windows 8.1|Windows NT 6.3|Windows 8|Windows NT 6.2)/) ? true : false;
    var inApp = Cookies.get('omcbrowse') != undefined;

    if (isWindows && isWindows8AndUp && inApp) {
        var elems = $('li.read-sample a, a.sample, a.sample-circle-icon, a.sample-button');
        elems.each(function () {
            if ($(this).attr('data-href')) {
                $(this).attr('data-metro', 'true').attr('href', $(this).attr('data-href')).attr('target', '_blank').removeAttr('data-reveal-id');
            }
        });
    }

    if ($('.more-actions-drop:not(.list-view)').first().find('.js-contextLink').text().length > 105) {
        $('.more-actions-drop').addClass('is-wide');
    }

    // LHTNG-1431,1432,1804 - adding sort options to holds, wishlist, and rated titles
    // I thought about creating a separate script file account-related stuff rather
    // then shoving this in here, but etung encouraged me to use this catch-all file since
    // the account area is going to be redone in the near future.
    var sortByElem = $('.js-accountSortByOptions');
    sortByElem.on('change', function () {
        window.replaceQueryParam('sortBy', $(this).val());
    });
});

/**
 * Close a modal when the cancel button is clicked
 */
$('[data-cancel]').on('click', function () {
    $(this).foundation('reveal', 'close');
});

window.scrollAmt = 0;

/**
 * Hide carousel arrows when reaching the end of a carousel
 */
$('.carousel.loaded').on('scroll', function (e) {
    hideArrowsOnEndOfScroll(e, this);
});

/**
 * Reset scrollAmt to detect end of new carousel
 */
$('.carousel.loaded').on({
    mouseleave: function mouseleave() {
        window.scrollAmt = 0;
    }
});

$('.carousel.loaded').each(function () {
    hideCarouselArrows(this);
});

if (!detectshun.browser().mobile && !detectshun.browser().tablet) {
    $('.carousel.loaded').each(function () {
        Ps.initialize($(this)[0], { suppressScrollY: true });
    });
}

$('i[data-scroll="right"]').on('click', function () {
    var elem = $(this).siblings('.js-carousel').children('div[data-scroll-container]');
    scrollCarousel('right', elem);
});

$('i[data-scroll="left"]').on('click', function () {
    var elem = $(this).siblings('.js-carousel').children('div[data-scroll-container]');
    scrollCarousel('left', elem);
});

/**
 * Actions to perform when a dropdown is closed
 */
$('.drop').on("closed.fndtn.dropdown", function () {
    $(this).find('a').attr('tabindex', '-1');
    $(this).find('h2').attr('tabindex', '-1');
    var elem = $('li[data-dropdown="' + $(this).attr('id') + '"] > a');
    elem.attr('aria-expanded', 'false');
});

$('[data-last-link]').on('focusout', function () {
    var nextItem = $(this).parents('.content.f-dropdown').next('li');
    nextItem.children('a').focus();
});

$('ul.drop.content.f-dropdown').on('keydown', function (e) {
    arrowTabMenu(e);
}).on('keydown', '*', function (e) {
    arrowTabMenu(e);
});

$('ul#dropAccount').on('keydown', function (e) {
    arrowTabAccountMenu(e);
}).on('keydown', '*', function (e) {
    arrowTabAccountMenu(e);
});

// Fix for select elements in IOS app view
$(document).ready(function () {
    $(document).on('popupbeforeposition', function () {
        $.mobile.hashListeningEnabled = false;
    });
    $(document).on('popupafterclose', function () {
        $.mobile.hashListeningEnabled = true;
    });
});

$('#link-card-modal').on('opened.fndtn.reveal', function () {
    var button = $('#add-card-button');
    if (button.attr('data-fwd-action')) {
        button.attr('href', button.attr('data-fwd-action'));
        button.removeAttr('data-fwd-action');
    }
});

$(window).resize(function () {
    clearTimeout(this.id);
    this.id = setTimeout(function () {}, 500); // Do not run constantly on resize
});

// Detect if user is scrolling or not
var scrolling = false;
$('body').on('touchmove', function () {
    scrolling = true;
}).on('touchend', function () {
    scrolling = false;
});

/**
 * Used to automatically redirect links in collections menu on iOS
 * Sometimes they just like to hover instead of click. Because Apple.
 */
$('.js-link').on('click touchend', function (e) {
    if (scrolling) {
        scrolling = false;
        return;
    }
    window.location = $(this).attr('href');
});

// Custom jquery filter to select focusable elements
// Wasn't sure where else to put this for the time being
$.extend($.expr[':'], {
    focusable: function focusable(el, index, selector) {
        return $(el).is('a, button, :input, [tabindex]');
    }
});

try {
    window.console && window.console.log && window.console.log("Hi there! This site is powered by OverDrive and our vision is a world enlightened by reading. Maybe a curious cat like you can help https://company.overdrive.com/company/careers/open-positions/");
} catch (e) {}

},{}],"C:\\projects\\lightning\\public\\js\\app\\actions.js":[function(require,module,exports){
'use strict';

/* eslint-disable no-invalid-this */
window.ajax = {
    bus: window.globalEvents,

    // Ajax request to borrow a title
    borrow: function borrow(mediaId, lendingPeriod, elements, units) {
        elements.each(function () {
            $(this).trigger('borrowRequest');
        });

        return $.post(window.url(window.routes.mediaBorrow, { mediaId: mediaId }), {
            lendingPeriod: lendingPeriod,
            units: units,
            isMobile: detectshun.browser().mobile || detectshun.browser().tablet
        }).done(function (data) {
            elements.each(function (i, el) {
                var $elm = $(el);

                if ($elm.attr('data-type') === 'periodicals') {
                    $(document).trigger('nookSuccess', [$elm, data]);

                    if ($elm.context.tagName === 'BODY') {
                        $elm.removeAttr('data-type').remove('data-media-id'); // Remove temporary data type attribute
                    }
                } else {
                    $(document).trigger('borrowSuccess', [$elm, data]);
                }
            });
        }).fail(function (jqXHR, textStatus, errorThrown) {
            elements.each(function (i, el) {
                var $elm = $(el);
                $elm.trigger('borrowFailure', [$elm, { 'jqXHR': jqXHR, 'textStatus': textStatus, 'errorThrown': errorThrown }]);
            });
        });
    },

    returnTitle: function returnTitle(elem, mediaId) {
        var self = this;
        $.ajax({
            url: window.url(window.routes.mediaReturn, { mediaId: parseInt(mediaId, 10) }),
            type: 'DELETE',
            success: function success() {
                window.location = window.location.pathname;
            },
            error: function error(jqXHR, textStatus, errorThrown) {
                var response = JSON.parse(jqXHR.responseText);
                var link = '';
                if (response.errorCode === 'TitleCannotBeEarlyReturned') {
                    link = '<a href="' + window.supportUrl(window.OverDrive._locale, window.OverDrive.supportArticles.howToReturn) + '" class="bold" aria-label="' + window.html('learnAboutReturning') + '">' + window.html('learnAboutReturning') + '</a>';
                } else if (response.sessionExpired) {
                    self.bus.trigger('user:session:expired');
                } else {
                    toaster.push('<strong>' + window.html('genericError') + '</strong> ' + window.text('error.' + response.errorCode, { link: link }), 'error');
                }

                $('.modal').foundation('reveal', 'close');
            }
        });
    },

    //Ajax request for placing a hold
    placeHold: function placeHold(mediaId, email, elements) {
        elements.each(function () {
            if (!$(this).hasClass('primary-action')) {
                $(this).trigger('holdRequest', $(this));
            }
        });

        $.ajax({
            url: window.url(window.routes.mediaPlaceHold),
            type: 'POST',
            data: {
                email: email,
                mediaId: mediaId,
                isMobile: detectshun.browser().mobile || detectshun.browser().tablet,
                languageCode: window.patronSettings['language-selection'] || window.Cookies.get('language-selection') || $('html').attr('lang') || 'en'
            },
            success: function success(data, textStatus, xhr) {
                elements.each(function () {
                    // If status is 303: hold failed because title has already been placed on hold.
                    if (xhr.status == 303) {
                        var message = { responseText: data };
                        $(this).trigger('holdFailure', [$(this), message]);
                    } else {
                        $(this).trigger('holdSuccess', [$(this), data]);
                    }
                });
            },
            error: function error(response) {
                elements.each(function () {
                    $(this).trigger('holdFailure', [$(this), response]);
                });
            }
        });
    },

    //Ajax request for retrieving a single hold
    getHold: function getHold(mediaId) {
        return $.ajax({
            url: window.url(window.routes.getSingleHold, { mediaId: parseInt(mediaId) }),
            type: 'GET'
        });
    },

    //Ajax request for retrieving a single media item
    getMediaItem: function getMediaItem(mediaId) {
        return $.ajax({
            url: window.url(window.routes.mediaInfoId, { mediaId: parseInt(mediaId) }),
            type: 'GET'
        });
    },

    removeHold: function removeHold(elem, mediaId) {
        $.ajax({
            url: window.url(window.routes.mediaRemoveHold, { mediaId: mediaId, forward: 'account' }),
            type: 'DELETE',
            success: function success() {
                window.location.reload();
            },
            error: function error(jqXHR, textStatus, errorThrown) {
                var response = JSON.parse(jqXHR.responseText);
                toaster.push('<strong>' + window.html('genericError') + '</strong> ' + window.html('error.' + response.errorCode), 'error');
                $('.modal').foundation('reveal', 'close');
            }
        });
    },

    //Ajax request for adding to wish list
    wishListAdd: function wishListAdd(mediaId, elements) {
        $(elements).each(function () {
            $(this).trigger('wishListAddRequest');
        });

        $.ajax({
            url: window.url(window.routes.accountWishlistAdd, { mediaId: mediaId }),
            type: 'PUT',
            success: function success(data) {
                $(elements).each(function () {
                    $(this).trigger('wishListAddSuccess', data);
                });
            },
            error: function error(jqXHR, textStatus, errorThrown) {
                $(elements).each(function () {
                    $(this).trigger('wishListAddFailure', jqXHR, textStatus, errorThrown);
                });
            }
        });
    },

    //Ajax request for removing from wish list
    wishListRemove: function wishListRemove(mediaId, elements, reload) {
        $(elements).each(function () {
            $(this).trigger('wishListRemoveRequest', elements);
        });

        var self = this;

        $.ajax({
            url: window.url(window.routes.accountWishlistRemove, { mediaId: mediaId }),
            type: 'DELETE',
            success: function success(data) {
                if (reload) {
                    // Reload wishlist account page
                    window.location.reload();
                } else {
                    $(elements).each(function () {
                        $(this).trigger('wishListRemoveSuccess', data);
                    });
                }
            },
            error: function error(jqXHR, textStatus, errorThrown) {

                var response = JSON.parse(jqXHR.responseText);
                if (response.sessionExpired) {
                    self.bus.trigger('user:session:expired');
                } else {
                    $(elements).each(function () {
                        $(this).trigger('wishListRemoveFailure', jqXHR, textStatus, errorThrown);
                    });
                }
            }
        });
    },

    getMediaStatus: function getMediaStatus(items) {
        if (items && items.length && window.OverDrive.isAuthenticated && window.OverDrive.hasLinkedCards) {
            $('body').trigger('mediaStatusRequest');

            $.ajax({
                url: window.url(window.routes.mediaInfo),
                type: 'POST',
                contentType: 'application/json',
                timeout: 10000,
                data: JSON.stringify({ titleIds: items }),
                success: function success(data) {
                    $('body').trigger('mediaStatusSuccess', data);
                },
                error: function error(jqXHR, textStatus, errorThrown) {
                    $('body').trigger('mediaStatusFailure', jqXHR, textStatus, errorThrown, items);
                }
            });
        }
    },

    getLendingPeriods: function getLendingPeriods(mediaId, elements, callback) {
        if (mediaId == "" || mediaId == null) {
            return;
        }

        $(elements).each(function () {
            $(this).trigger('lendingPeriodsRequest');
        });

        var self = this;
        $.ajax({
            url: window.url(window.routes.patronLendingPeriod, { mediaId: mediaId }),
            type: 'GET',
            timeout: 0,
            success: function success(data) {
                $(elements).each(function () {
                    $(this).trigger('lendingPeriodsRetrieved', { items: data });
                });

                if (callback != null) {
                    callback(data);
                }
            },

            error: function error(data) {
                // Using new event bus for future-proofing
                self.bus.trigger('lendingPeriods:fetch:fail');
            }
        });
    },

    getAvailability: function getAvailability(mediaId) {
        return $.ajax({
            url: window.url(window.routes.mediaAvailabilityId, { id: mediaId }),
            type: 'GET',
            timeout: 0
        });
    },

    getStarRating: function getStarRating(mediaId, elements) {
        $.ajax({
            url: window.url(window.routes.patronMediaStarRatings, { titleId: mediaId }),
            type: 'GET',
            timeout: 0,
            success: function success(data) {
                $(elements).each(function () {
                    $(this).trigger('starRatingsRetrieved', data);
                });
            },

            error: function error(data) {
                $(this).trigger('starRatingsGetError', data);
            }
        });
    },

    setStarRating: function setStarRating(mediaId, rating) {
        var self = this;
        $.ajax({
            url: window.url(window.routes.patronMediaStarRatings, { titleId: mediaId }),
            type: 'PUT',
            data: { rating: rating },
            timeout: 0,

            error: function error(data) {
                $(this).trigger('starRatingsSetError', data);

                // Using new event bus for future-proofing
                self.bus.trigger('rating:set:fail');
            }
        });
    },

    deleteStarRating: function deleteStarRating(mediaId) {
        var self = this;
        $.ajax({
            url: window.url(window.routes.patronMediaStarRatings, { titleId: mediaId }),
            type: 'delete',
            timeout: 0,

            error: function error(data) {
                $(this).trigger('starRatingsSetError', data);

                // Using new event bus for future-proofing
                self.bus.trigger('rating:delete:fail');
            }
        });
    },

    addRecommendation: function addRecommendation(id, addHold, notifyIfPurchased, email) {
        $.ajax({
            url: window.url(window.routes.patronRecommendations),
            type: 'POST',
            data: { id: id, addHold: addHold, notifyIfPurchased: notifyIfPurchased, email: email },
            timeout: 0,

            success: function success(status) {
                //Recommendation received
                $(document).trigger('recommendationSuccess', { id: id, email: email });
            },

            error: function error(data) {
                //Recommendation failed
                data.mediaId = id;
                $(document).trigger('recommendationFailure', data);
            }
        });
    },

    getPatronEmail: function getPatronEmail(callback) {
        return $.ajax({
            url: window.url(window.routes.patronEmail),
            type: 'GET',
            timeout: 0
        });
    },

    borrowSuccessToast: function borrowSuccessToast(expires, mediaTypeName) {
        var exp = window.html('date-full', { d: expires });
        var toastCopyKey = 'toasts.borrowSuccessHtml';
        if (exp.match(/invalid/i)) {
            toastCopyKey = 'toasts.borrowSuccessNoExpHtml';
        }
        var linkUrl = window.url(window.routes.accountLoans);
        var loans = window.html('loans');
        toaster.push(window.html(toastCopyKey, { mediaTypeName: mediaTypeName, exp: exp,
            link: '<a class="bold" href="' + linkUrl + '" tabindex="0">' + loans + '</a>' }), 'userAction');
    }
};

},{}],"C:\\projects\\lightning\\public\\js\\app\\modal.js":[function(require,module,exports){
'use strict';

var focused = $(':focus');

/**
 * Actions to take when opening modals
 */
$('.reveal-modal').each(function () {
    /* Capture element that opened the modal, so it can be re-focused when the modal closes */
    $(this).on('open.fndtn.reveal', function () {
        focused = document.activeElement;
    });

    $(this).on('opened.fndtn.reveal', function () {
        var modal = this;

        $(modal).attr('aria-hidden', false);
        $('.container').attr('aria-hidden', 'true');
        $('.row.footer').attr('aria-hidden', 'true');
        $('.nav-container').attr('aria-hidden', 'true');

        //Place initial focus inside of modal
        $(modal).find('.js-first-focus').focus();
    }).on('closed.fndtn.reveal', function () {
        $(this).attr('aria-hidden', true);
        $('.container').attr('aria-hidden', 'false');
        $('.row.footer').attr('aria-hidden', 'false');
        $('.nav-container').attr('aria-hidden', 'false');
        //Restore focus to last focused element outside of modal
        focused.focus();
    });
});

/**
 * Keep focus inside the modal. If the user tabs past the last element, re-focus
 * on the first element (js-first-focus). If the user shift-tabs on the first
 * element, focus on the last element (js-last-focus).
 */
$(document).on('keydown', '.reveal-modal', function (e) {
    var activeElem = document.activeElement;

    if ($(activeElem).hasClass('js-first-focus') && e.which === 9 && e.shiftKey) {
        e.preventDefault();
        e.stopPropagation();
        $(this).find('.js-last-focus').focus();
    } else if ($(activeElem).hasClass('js-last-focus') && e.which === 9 && !e.shiftKey) {
        e.preventDefault();
        e.stopPropagation();
        $(this).find('.js-first-focus').focus();
    }
});

//Close modal when enter pressed on close button
$('a.close-reveal-modal').keydown(function (e) {
    if (e.which == 13) {
        $(this).click();
    }
});

//Stop spinners when borrow or holds related modal is closed
$('#hold-dynamic-modal, #now-available-modal, #now-unavailable-modal').on('closed.fndtn.reveal', function () {

    //Put title elements back to original state.
    $('a.primary-action img:visible').each(function () {
        var container = $(this).closest('a.primary-action');
        container.html(container.attr('data-original-text'));
    });
});

},{}],"C:\\projects\\lightning\\public\\js\\app\\nav.js":[function(require,module,exports){
'use strict';

/* eslint no-invalid-this: "off" */
/* eslint func-style: "off" */
var openMenu = 'main';

var trimOutsideForwardSlashes = function trimOutsideForwardSlashes(s) {
    if (s) {
        return s.replace(/^\/?(.*?)\/?$/, '$1');
    } else {
        return s;
    }
};

var getFormWidth = function getFormWidth($elem) {
    return $('.js-mobileSearchContainer').width() - $('.js-mobileNavSearchIcon').width() - $elem.width() - 30;
};

$(document).ready(function () {
    // Don't submit a blank search
    $(document).on('keyup', 'input[data-search]', function (e) {
        if (e.which == 13) {
            if ($(this).val() != '') {
                $(this).parents('form').submit();
            } else {
                e.preventDefault();
                return false;
            }
        }
    });

    // if the user is not on the home page...
    var currentPath = trimOutsideForwardSlashes(location.pathname);
    var homePath = trimOutsideForwardSlashes(window.url(window.routes.home));
    if (currentPath !== homePath) {
        // ...then underline the nav link of the current page if it exists
        // TODO: Refactor away these general selectors and do it more cleanly
        $('a[href*="' + currentPath + '"]').addClass('selected');
        $('a[href*="' + currentPath + '"] li span').addClass('selected');
    }

    if ($(document).width() > 870) {
        $('.js-toggleRow').removeClass('row');
    }

    // Fit mobile search to container
    $('.js-mobileSearchForm').css('width', getFormWidth($('.js-mobileNavIconContainer')) + 'px');
});

$('.js-mobileSearchInput').on('touchstart click', function () {
    setTimeout(function () {
        if (!$('.js-advancedSearchContainer').is(':visible')) {
            $('.js-advancedSearchContainer').toggle();
            window.toaster._stickToast();
        }

        if ($('.js-account-menu-mobile').hasClass('is-open')) {
            window.AccountMenuMobileView.close();
            window.toaster._stickToast();
        }
    }, 1);
}).on('focusout', function () {
    setTimeout(function () {
        var focused = $(document.activeElement);
        if (!focused.hasClass('js-advancedSearchLink') && $('.js-advancedSearchContainer').css('display') == 'block' && !focused.hasClass('js-mobileSearchInput')) {
            $('.js-advancedSearchContainer').hide();
            window.toaster._stickToast();
        }
    }, 1);
});

// Handle mobile nav menu
$('.js-mobileMenu').on('tap click', _.debounce(function (e) {
    e.preventDefault();
    e.stopPropagation();

    if (featureManager.isEnabled('LHTNG-3604')) {
        setTimeout(function () {
            window.toaster._stickToast();
        }, 0);
    } else {
        if ($('.mobile-nav-wrapper').hasClass('unexpanded')) {
            $('.mobile-nav-wrapper').removeClass('unexpanded').addClass('expanded');
            $('.top-bar').removeClass('unexpanded').addClass('expanded');
            setTimeout(function () {
                window.toaster._stickToast();
            }, 0);
        } else {
            $('.mobile-nav-wrapper').removeClass('expanded').addClass('unexpanded');
            $('.top-bar').removeClass('expanded').addClass('unexpanded');
            $('.accordion-navigation.top-nav').removeClass('active');
            $('.accordion-navigation.top-nav > .content').removeClass('active').css('display', 'none');
            setTimeout(function () {
                window.toaster._stickToast();
            }, 0);
        }
    }

    if ($('.icon-search-nav').hasClass('expanded')) {
        $('.icon-search-nav').removeClass('expanded').addClass('unexpanded');
    }

    $('.mobile-nav-menu[data-menu="' + openMenu + '"]').toggle();

    if ($('.js-account-menu-mobile').hasClass('is-open')) {
        window.AccountMenuMobileView.close();
    }

    if ($(this).attr('id') == 'hamburger') {
        if ($(this).attr('aria-expanded') == 'false') {
            $(this).attr('aria-expanded', 'true');
        } else {
            $(this).attr('aria-expanded', 'false');
        }
    }
    return false;
}, 350));

// Advantage tout
$('div#dropAccount.large').on('opened.fndtn.dropdown', function () {
    $('.top-bar').css('overflow', 'visible');
    var link = $(this).find('a');
    $(this).find('p').attr('tabindex', link.attr('data-tab'));
    link.attr('tabindex', link.attr('data-tab'));
}).on('closed.fndtn.dropdown', function () {
    $(this).find('p').attr('tabindex', -1);
    $(this).find('a').attr('tabindex', -1);
});

$(window).resize(function () {
    var width = $(document).width();
    if (width <= 855) {
        $('.js-toggleRow').addClass('row');

        var searchForm = $('.js-mobileSearchForm');
        if (searchForm.hasClass('is-expanded')) {
            searchForm.css('width', getFormWidth($('.js-searchControlContainer')) + 'px');
        } else {
            searchForm.css('width', getFormWidth($('.js-mobileNavIconContainer')) + 'px');
        }
    } else {
        $('.js-toggleRow').removeClass('row');
    }
});

function exitSearchMode() {
    $('.js-searchControlContainer').addClass('u-hideMe');
    var iconContainer = $('.js-mobileNavIconContainer');
    iconContainer.removeClass('u-hideMe');
    $('.js-mobileSearchForm').removeClass('is-expanded').addClass('is-unexpanded').css('width', getFormWidth(iconContainer) + 'px');
}

function enterSearchMode() {
    var searchContainer = $('.js-searchControlContainer');
    searchContainer.removeClass('u-hideMe');
    $('.js-mobileNavIconContainer').addClass('u-hideMe');
    $('.js-mobileSearchForm').addClass('is-expanded').removeClass('is-unexpanded').css('width', getFormWidth(searchContainer) + 'px');
}

// Close mobile search bar
$('.js-clearMobileSearch').on('tap click', function () {
    $('.js-mobileSearchInput').val('').trigger('keyup').focus();
    exitSearchMode();
    $('.js-advancedSearchContainer').show();

    //Hacks until I move all this logic to backbone views
    $('.js-quickSearchInput', '.js-quickSearchMobile').trigger('keyup');
    $('.js-quickSearchInput', '.js-quickSearchMobile').trigger('focusout');
});

$('.js-mobileSearchInput').on('keyup', function () {
    enterSearchMode();

    if ($(this).val().length === 0) {
        exitSearchMode();
        $('.js-advancedSearchContainer').show();
    }
}).on('click focus', function () {
    if ($(this).val().length > 0) {
        enterSearchMode();
    }
    $('.js-advancedSearchContainer').show();
}).on('blur', function () {
    // When mobile search input loses focus, unhide mobile account menu
    $('.js-account-menu-link, .js-account-menu-mobile').removeClass('hideMeImportant');
});

$(document).click(function (e) {
    if (!$(e.target).parent().parent().hasClass('js-mobileSearchContainer')) {
        exitSearchMode();
    }
});

$('.js-doQuickSearch').on('touchstart click', function (e) {
    if ($('.js-mobileSearchInput').val() !== '') {
        $('#search-form-mobile').submit();
    }
});

//Toggle foundation accordion
$(".accordion.top-nav li, span.nav-panel-icon").on("tap click", "a:eq(0), a:eq(1), span", function (e) {
    e.stopPropagation();

    var li_parent = $(this).parent();

    if (li_parent.hasClass('active') && li_parent.hasClass('top-nav')) {
        li_parent.removeClass('active');
        $(".accordion.top-nav li div.content:visible").toggle();
    } else if (li_parent.hasClass('top-nav')) {
        $('.accordion-navigation.top-nav').removeClass('active');
        li_parent.addClass('active');
        $(".accordion.top-nav li div.content:visible").toggle();
        $(this).parent().find(".content").toggle();
    }

    window.toaster._stickToast();
});

// Remove desktop view searchbar autofocus on mobile devices
var mobile = detectshun.browser().mobile;
var tablet = detectshun.browser().tablet;

if (mobile || tablet) {
    $('.search-input').removeAttr('autofocus');
} else {
    $('.search-input').focus();
}

// TODO: Evaluate if this is still needed - MD
window.onorientationchange = function () {
    if ($('.search-input-mobile').css('display') != 'none' && $('.search-input').css('display') == 'none' && $('input:focus').length > 0 && Math.abs(window.orientation) != 90) {
        $('.js-mobileSearchInput').trigger('click');
    } else if (Math.abs(window.orientation) === 90 && $('input:focus').length > 0) {
        $('.search-input').trigger('click');
    } else if ($('input:focus').length > 0) {
        $('.js-mobileSearchInput').trigger('click');
    }
};

$('input[data-search]').click(function (e) {
    if (!$('input[data-search]').is(':focus')) {
        document.activeElement.blur();
        $(this).blur();
        var temp = $(this).val();
        $('input[data-search]').val(temp);
        $(this).focus();
        e.preventDefault();
    }
});

if ($('.js-mobileLibraryLogo').attr('src') == '') {
    showAltLogoMobile();
}

if ($('h1#logo-desktop a img').attr('src') == '') {
    showAltLogoDesktop();
}

/**
 * Set tab indices for nav menu
 */

var resized = false;
$('ul#drop-collections').on('opened.fndtn.dropdown', function (event) {
    $(this).find('a, h2').attr('tabindex', 0);
    // $(this).find('h2:first').focus();
    if (!resized) {
        // Determine size of navigation based on # of columns
        var nav = $('ul#drop-collections');
        var columns = nav.find('ul:first-child').children('li');
        var columnCount = columns.length;
        var columnWidth = 1 / columnCount * 100 + '%';

        columns.css('width', columnWidth);

        if (columnCount === 3) {
            columns.last().css('width', '200px');
        }

        nav.addClass('nav-' + columnCount + '-columns');
        resized = true;
    }
}).on('closed.fndtn.dropdown', function () {
    $(this).find('a, h2').attr('tabindex', -1);
});

$('.Nav-collectionsLink').on('click', function (event) {
    event.stopPropagation();
    event.preventDefault();
    window.Foundation.libs.dropdown.toggle($(this));
});

$('.Nav-collectionsLink').on('keyup', function (event) {
    event.stopPropagation();
    event.preventDefault();
    if (event.which === 13) {
        window.Foundation.libs.dropdown.toggle($(this));
    }
});

$('ul#language-dropdown').on('opened.fndtn.dropdown', function () {
    $(this).find('a').attr('tabindex', 0);
    $(this).find('a:first');
    $(this).attr('tabindex', 0).focus();
}).on('closed.fndtn.dropdown', function () {
    $(this).find('a').attr('tabindex', -1);
    $(this).attr('tabindex', -1);
});

// Close nav when account dropdown is opened
$("#dropAccount").on('opened.fndtn.dropdown', function (e) {
    window.Foundation.libs.dropdown.close($('#drop-collections'));
});

$('.js-closeAdvantageTout').on('click tap', function () {
    Cookies.set('advantage-dismissed', '1', { path: '/', expires: 1 });

    var accountSignInUrl = window.url(window.routes.accountSignIn);

    $('.js-advantageTout').hide();
    window.toaster._stickToast();
    $('a#account-holder-name, [data-dropdown="dropAccountMobile"]').removeAttr('aria-haspopup data-options aria-controls').attr({ 'href': accountSignInUrl, 'data-forward': '' });
    $('#account-holder-name, li.account-dropdown-mobile a i.icon-account, [data-dropdown="dropAccountMobile"]').on('click', function (e) {
        e.stopPropagation();
    });
});

},{}],"C:\\projects\\lightning\\public\\js\\app\\sample.js":[function(require,module,exports){
'use strict';

$('.sample-modal').on('closed.fndtn.reveal', function (e) {
    $('iframe#sample-dynamic-iframe').attr('src', 'about:blank');
});

$('body').on('click keyup', '.js-context-button', function (e) {
    e.stopImmediatePropagation();

    if (e.type == 'click' || e.which == 32 || e.which == 13) {
        //If menu is already open close it
        var dropdown = $(this).attr('data-dropdown');

        if ($('ul#' + dropdown).offset().left > 0) {
            Foundation.libs.dropdown.close($('#' + dropdown), $('.js-context-button[data-dropdown="' + $('#' + dropdown).attr('id') + '"]'));
            $('ul#' + dropdown + ' li a').attr('tabindex', -1);
        } else {
            $(document).foundation('dropdown', 'closeall');
            $('ul#' + dropdown + ' li a').attr('tabindex', 0);
            Foundation.libs.dropdown.open($('#' + dropdown), $('.js-context-button[data-dropdown="' + $('#' + dropdown).attr('id') + '"]'));
            $(this).focus();
        }
    }
});

$('.js-context-drop').blur(function () {
    //Foundation.libs.dropdown.close($('.js-context-drop'));
});

$('body').on('closed.fndtn.dropdown', '.js-context-drop', function (e) {
    $(e.target).find('a').attr('tabindex', '-1');
});

$('body').on('opened.fndtn.dropdown', '.js-context-drop', function (e) {
    $(e.target).find('a').attr('tabindex', '0');
});

$('body').on('click', 'li.read-sample a, .button.sample, .js-details-cover-sample', function (e) {
    // If in mobile or in-app open sample link in new window. Else open in modal.
    var inApp = Cookies.get('omcbrowse') !== undefined;
    var target = $(e.target).closest('a');
    if ($(document).width() <= 640 || target.attr('data-type') === 'video' || target.attr('data-metro') || inApp) {
        target.attr({ target: '_blank', href: target.attr('data-href') }).removeAttr('data-reveal-id');
    } else {
        target.attr('data-reveal-id', 'sample-dynamic-modal');

        if (target.attr('data-href')) {
            $('iframe#sample-dynamic-iframe').attr('src', target.attr('data-href'));
            $('.modal-title[data-sample-title]').html(target.attr('data-title'));
            $(document).foundation('reveal', 'reflow');
        }
    }
});


},{}],"C:\\projects\\lightning\\public\\js\\app\\title-actions.js":[function(require,module,exports){
'use strict';

/**
 * Holds functions
 * @type {{holdPlaced: holds.holdPlaced, revealHoldModal: holds.revealHoldModal}}
 */
window.holds = {
    holdPlaced: function holdPlaced(elements) {
        window.ajax.placeHold(elements.attr('data-media-id'), $('.patron-hold-email-dynamic').val(), elements);
    },

    /**
     * Reveal the place a hold modal
     */
    revealHoldModal: function revealHoldModal(elem) {
        if (!elem.hasClass("disabled")) {
            var title, typeId, typeName, artwork, prereleaseDate, isPrerelease, mediaId;

            title = elem.attr('data-title');
            typeId = elem.attr('data-type');
            typeName = elem.attr('data-type-name');
            artwork = elem.attr('data-artwork');
            prereleaseDate = elem.attr('data-prerelease-date');
            isPrerelease = elem.attr('data-prerelease-date') != '';
            mediaId = elem.attr('data-media-id');

            var modal = $('#hold-dynamic-modal');
            $('[data-id="title"]').html(title);
            $('[data-id="format-icon"]').removeClass().addClass('icon-' + typeId);
            $('[data-id="format-name"]').html(typeName);
            $('[data-id="cover-image"]').attr('src', artwork);

            var labelCopy = window.html('dynamicHoldModal.placeHoldDesc', { libraryName: window.OverDrive.libraryName });
            if (window.OverDrive.mediaItems[mediaId].ownedCopies === 0) {
                labelCopy = window.html('holdsRatioHelpModal.noCopiesText');
            }
            $('.js-hold-modal-label').html(labelCopy);

            if (prereleaseDate != undefined && isPrerelease) {
                $('[data-id="pre-release-label"]').text(window.text('prereleaseLabel', { prereleaseDate: prereleaseDate })).removeClass('hideMe');
            } else {
                $('[data-id="pre-release-label"]').text("").addClass('hideMe');
            }

            $('form#hold-dynamic-form').attr('data-media-id', mediaId);

            if (elem.attr('data-publisher') >= '98146' && elem.attr('data-publisher') <= '98155' && Cookies.get('disney-eula-setting') != '1') {
                // Disney publisher ids are 98146 - 98155
                $('#disney-eula-modal').foundation('reveal', 'open');
            } else {
                modal.foundation('reveal', 'open');
            }
        }
    }
};

/**
 *  Functions for managing action button states
 */
window.loading = {
    spinners: {},

    animateIcon: function animateIcon(elem, animation) {
        elem.removeClass('animated bounceIn bounceOut pulse infinite').addClass('animated ' + animation);
    },

    changeButtonState: function changeButtonState(elem, action, onStatusReq) {
        elem = elem.attr('data-action') ? elem : elem.closest('[data-action]:not([data-action="main-navigation"])');
        var inner = '';
        var type = elem.data('type');
        var mediaId = elem.data('media-id');
        var formats = elem.data('formats');
        var buttonText = '';
        var inApp = Cookies.get('omcbrowse') != undefined;
        var formatId = findFormatId(formats);
        var device = detectshun.browser();
        var isChromebook = window.navigator.userAgent.match(/CrOS/) ? true : false;
        var overdriveFormat = '';

        var isAndroid41AndUp = device.bowser.android && device.bowser.osversion >= '4.1' ? true : false;
        var isAndroidStock = window.navigator.userAgent.match(/Version\/\d\.\d/) && device.bowser.android ? true : false;
        var isDolphin = window.navigator.userAgent.match(/Dolfin/) ? true : false;
        var isNook = window.navigator.userAgent.match(/(BNTV|BNRV)/g) && !device.bowser.chrome ? true : false;
        var isSilk = /\bSilk\/([0-9._-]+)\b/.exec(navigator.userAgent) ? true : false;
        var isListenIncompatible = !isAndroid41AndUp && (isAndroidStock || isDolphin || isSilk) || isNook ? true : false;

        var removeClassList = 'secondary primary place-a-hold radius radius-left lending-options';

        var banner = $('div.title-header-bar[data-media-id="' + elem.attr('data-media-id') + '"] a');

        if (formats) {
            for (var i = 0; i < formats.length; i++) {
                if (formats[i]['id'] == 'video-streaming' || formats[i]['id'] == 'ebook-overdrive' || formats[i]['id'] == 'audiobook-overdrive') {
                    overdriveFormat = formats[i]['id'];
                }
            }
        }

        switch (action) {
            case 'borrow':
                //User has not yet borrowed a title Show borrow button
                var lendingPeriod = $('input#lending-period-' + mediaId).val();
                if (type == 'periodicals') {
                    inner = window.html('day');
                    elem.addClass('secondary radius').removeClass('lending-options radius-left');

                    //$('button.lending-period-dropdown').hide();

                    if (Cookies.get('nook-eula-setting') == '1') {
                        elem.removeAttr('data-reveal-id');
                    }
                } else if (lendingPeriod > 0) {
                    inner = '<span class="borrow-main-text u-allCaps">' + window.html('borrow') + '</span><br/><span class="borrow-sub-text u-allCaps">' + window.html('forXDays', { lendingPeriod: lendingPeriod }) + '</span>';
                } else {
                    inner = '<span>' + window.html('borrow') + '</span>';
                    elem.css('line-height', '21px'); // Align text with other buttons
                }
                elem.removeClass(removeClassList).addClass('secondary radius-left lending-options js-statusUpdated').attr('href', 'javascript:void(0)');

                $('.lending-period-dropdown').addClass('secondary').removeClass('disabled');
                break;

            case 'borrow-simple':
                //User has not yet borrowed a title Show borrow button
                if (type == 'periodicals') {
                    inner = '<span>' + window.html('sendToNook') + '</span>';
                    elem.addClass('secondary radius').removeClass('lending-options radius-left');

                    //$('button.lending-period-dropdown').hide();

                    if (Cookies.get('nook-eula-setting') == '1') {
                        elem.removeAttr('data-reveal-id');
                    }
                } else {
                    inner = '<span class="borrow-main-text u-allCaps">' + window.html('borrow') + '</span>';
                }
                elem.removeClass(removeClassList).addClass('secondary radius js-statusUpdated').attr('href', 'javascript:void(0)');

                elem.removeClass('place-a-hold');
                break;

            case 'hold':
                //User has not yet placed this title on hold show hold button
                inner = '<span>' + window.html('placeAHold') + '</span>';
                elem.removeClass(removeClassList).addClass('place-a-hold radius js-statusUpdated').attr('href', 'javascript:void(0)');
                break;

            case 'borrowed':
                var isios6Incompatible = device.ios && device.bowser.osversion[0] === '6';

                //User has already borrowed this title. Show GO TO LOANS

                // This is temporary to disable the add to app copy. This will be refactored out soon..
                var showAddToApp = false;

                var plainText = window.html('goToLoans');
                buttonText = '<span>' + plainText + '</span>';

                elem.attr('href', window.url(window.routes.accountLoans)).attr('tabindex', '0').html(window.html('goToLoans')).addClass('u-allCaps');

                inner = buttonText ? buttonText : '<span>' + window.html('goToLoans') + '</span>';
                elem.addClass('secondary radius').removeClass('lending-options radius-left');
                elem.removeClass('place-a-hold');

                if (elem.attr('data-type') == 'periodicals') {
                    elem.removeAttr('data-reveal-id');
                }

                elem.attr('data-action', 'borrowed').removeClass(removeClassList).addClass('secondary radius js-statusUpdated');
                if (!elem.parent().hasClass('list-view')) {
                    elem.addClass('wider-button');
                    if (plainText.length > 21) {
                        elem.addClass('decreased-padding');
                    }
                } else {
                    if (plainText.length > 22) {
                        elem.addClass('decreased-padding-listview-small');
                    }

                    if (plainText.length > 19) {
                        elem.addClass('decreased-padding-listview');
                    }
                }

                banner.text(window.html('availabilityBorrowed'));
                banner.closest('.title-header-bar').addClass('available-title secondary-background').removeClass('unavailable-title');

                break;

            case 'held':
                //User has already placed this title on hold. Show GO TO HOLDS
                inner = '<span>' + window.html('goToHolds') + '</span>';

                elem.attr('href', window.url(window.routes.accountHolds)).removeAttr('onclick');
                elem.removeClass(removeClassList).addClass('primary radius');
                if (!elem.parent().hasClass('list-view')) {
                    elem.addClass('wider-button');
                    // Account for Tamil
                    if (inner.length > 30) {
                        elem.addClass('increased-height');
                    }

                    if (inner.length > 24) {
                        elem.addClass('decreased-padding');
                    }
                } else {
                    // Account for Tamil
                    if (inner.length > 30) {
                        elem.addClass('increased-height-listview');
                    }

                    if (inner.length > 25) {
                        elem.addClass('decreased-padding-listview-small');
                    }

                    if (inner.length > 22) {
                        elem.addClass('decreased-padding-listview');
                    }
                }
                elem.attr('data-action', 'held').addClass('.js-statusUpdated');
                banner.text(window.html('onHold'));
                banner.closest('.title-header-bar').removeClass('available-title secondary-background').addClass('unavailable-title').addClass('u-allCaps');
                // Account for Tamil
                if (banner.text().length > 16) {
                    elem.parent().siblings('.title-description').addClass('is-top-padded');
                }
                break;

            case 'wishlist-add':
                inner = '<span class="u-allCaps">' + window.html('addToWishList') + '</span>';
                elem.addClass('add js-statusUpdated').removeClass('remove').attr('data-action', 'wishlist-add');
                elem.closest('.js-wishlist-button').addClass('is-add').removeClass('is-remove');
                elem.removeClass('place-a-hold');
                break;

            case 'wishlist-remove':
                inner = '<span class="u-allCaps">' + window.html('removeFromWishList') + '</span>';
                elem.addClass('remove js-statusUpdated').removeClass('add').attr('data-action', 'wishlist-remove');
                elem.closest('.js-wishlist-button').addClass('is-remove').removeClass('is-add');
                elem.removeClass('place-a-hold');

                elem.attr('data-action', 'wishlist-remove');
                break;

            case 'special':
                inner = '<span class="u-allCaps">' + window.html('removeFromWishList') + '</span>';
                elem.addClass('remove js-statusUpdated').removeClass('add').attr('data-action', 'wishlist-remove');
                elem.removeClass('place-a-hold');
                break;

            case null:
            case false:
                elem.children('div').remove();
                inner = elem.html();
                action = 'default';
                break;

            default:
                elem.children('div').remove();
                inner = elem.html();
                action = 'default';
                break;
        }

        elem.attr('aria-busy', 'false').removeClass('disabled').removeAttr('disabled');
        elem.next('button.lending-period-dropdown').removeClass('disabled');

        if (action != 'default') {
            elem.attr('data-action', action);
        }

        if (action != 'borrow' && elem.attr('data-type') != 'periodicals') {
            elem.addClass('radius').removeClass('lending-options').css('position', 'relative');
            elem.next('button.lending-period-dropdown').hide();
        }

        elem.html(inner).addClass('u-allCaps');

        processInstantForwardActions(window.location.pathname + (window.location.search ? window.location.search : ''));
    },

    updateCoverAlt: function updateCoverAlt(mediaId, text) {
        var coverImage = $('.title-header-bar[data-media-id="' + mediaId + '"]').next('a').children('img');
        if (coverImage.length) {
            var re = new RegExp('(' + window.html('availabilityBorrowed') + ')|(' + window.html('held') + ')|(' + window.html('onHold') + ')|(' + window.html('availabilityAvailable') + ')|(' + window.html('availabilityWaitList') + ')|(' + window.html('availabilityComingSoon') + ')', 'gi');
            coverImage.attr('alt', coverImage.attr('alt').replace(re, text));
        }
    },

    updateRecommendationState: function updateRecommendationState(mediaId) {
        var $recommendButton = $('.js-recommend[data-media-id="' + mediaId + '"]');
        $('div.title-header-bar[data-media-id="' + mediaId + '"]').children('a, span').text(window.text('recommended')).addClass('u-allCaps');
        $recommendButton.html(window.html('recommended')).addClass('js-recommended u-allCaps outline gray js-statusUpdated').attr('href', window.url(window.routes.accountRecommendations)).removeClass('Button-recommend');
        $('.js-recommend[data-media-id="' + mediaId + '"].primary-action').css('visibility', 'hidden').addClass('js-statusUpdated');
    }
};

/**
 * For redirecting when a user's card becomes invalid
 */
window.handleInvalidCard = function () {
    window.globalEvents.trigger('user:card:invalid');
};

/**
 * BORROW EVENT LISTENERS
 */
$(function () {
    var selector = '[data-action="borrow"]:not([data-no-linked-cards]), [data-action="borrow-simple"]:not([data-no-linked-cards])';
    $(document).on('click', selector, function (e) {
        var elem = $(e.target).is('[data-action="borrow"]') || $(e.target).is('[data-action="borrow-simple"]') ? $(e.target) : $(e.target).closest('[data-action="borrow"]').length ? $(e.target).closest('[data-action="borrow"]') : $(e.target).closest('[data-action="borrow-simple"]');
        var mediaId = elem.attr('data-media-id');

        if (elem.attr('data-type') != 'periodicals') {
            var lendingPeriodInput = $('#lending-period-modal-' + mediaId).length ? $('#lending-period-modal-' + mediaId) : $('#lending-period-' + mediaId);
            window.ajax.borrow(mediaId, lendingPeriodInput.val(), elem);

            //Remove event handler to prevent re-triggering event
            elem.off('click');
        } else if (elem.attr('data-type') == 'periodicals' && Cookies.get('nook-eula-setting') != '1') {
            $('a#accept-nook-dynamic').attr('data-media-id', mediaId);
        } else {
            // Periodical and Nook EULA accepted
            elem.attr('data-action', 'nook').click();
        }
    });

    //For borrow and nook buttons
    $(document).on('borrowSuccess nookSuccess', function (e, elem, data) {
        var mediaId = elem.attr('data-media-id');
        var actionButton = $('[data-action="borrow-simple"][data-media-id="' + mediaId + '"], [data-action="nook"][data-media-id="' + mediaId + '"]');

        //Remove loading gif and action button from title elements
        $('.primary-action[data-media-id="' + mediaId + '"]').css('visibility', 'hidden');
    });

    //For borrow buttons only
    $(document).on('borrowSuccess', function (e, elem, data) {
        var mediaId = elem.attr('data-media-id');
        var actionButton = $('[data-action="borrow-simple"][data-media-id="' + mediaId + '"]');

        //Update banners
        var copy = window.html('availabilityBorrowed').toUpperCase();
        $('.title-header-bar[data-media-id="' + mediaId + '"] a').html(copy + ' <i class="icon icon-icon-checked title-label" aria-hidden="true"></i>').attr('href', window.url(window.routes.accountLoans));

        //Update action buttons
        window.loading.changeButtonState(actionButton, 'borrowed');

        //Show toast
        if (actionButton.attr('data-type') !== 'periodicals' && !data.sessionExpired) {
            window.ajax.borrowSuccessToast(data, elem.attr('data-type-name'));
        }

        // Hide modal
        $('.modal').foundation('reveal', 'close');
    }).on('borrowRequest', function (e) {
        // Show spinner
        if ($(e.target).context.tagName !== 'BODY') {}
    }).on('borrowFailure', function (e, elem, response) {
        response = JSON.parse(response.jqXHR.responseText);
        var target = elem;
        var mediaId = target.attr('data-media-id');

        // If the user's card is invalid prompt them to link a card
        // If there's an error besides the title is out of copies, pop a toast
        // If the borrowFailure is on the body, this means an forwarded action happened and the title wasn't on the page
        //  -- Do nothing in this handler; check borrowFailure in utility handler
        if (response.errorCode === 'PatronCardFailedAuthentication') {
            if (window.OverDrive.authType === 'library') {
                window.handleInvalidCard();
            } else {
                // the user's card is no longer valid. Direct them to the link a card flow so that they may resolve any issues.
                $('.js-card-error-modal').foundation('reveal', 'open');
                $('.primary-action[data-media-id="' + mediaId + '"]').html($('.primary-action[data-media-id="' + mediaId + '"]').attr('data-original-text'));
            }
        } else if (response.sessionExpired) {
            var forwardUrl = window.location.pathname;
            if (window.location.search) {
                forwardUrl += window.location.search + '&borrow~' + mediaId;
            } else {
                forwardUrl += '?borrow~' + mediaId;
            }
            $('.js-reauthenticate').attr('href', window.url(window.routes.accountSignIn, { forward: forwardUrl }));
            $('#authenticate-modal').foundation('reveal', 'open');
            $('.primary-action[data-media-id="' + mediaId + '"]').html($('.primary-action[data-media-id="' + mediaId + '"]').attr('data-original-text'));
        } else if (response.errorCode !== 'TitleNoLongerAvailable') {
            var href = '';
            var linkText = '';
            if (response.errorCode === 'PatronExceededCheckoutLimit' || response.errorCode === 'LoanAlreadyExists') {
                href = window.url(window.routes.accountLoans);
                linkText = window.html('loans');
            } else if (response.errorCode === 'PatronExceededChurningLimit' || response.errorCode === 'PatronTypeRestrictedFromTitle') {
                href = window.url(window.routes.supportMembers);
                linkText = window.html('pleaseContactSupport');
            }
            var link = '<a class="bold" href="' + href + '" tabindex="0">' + linkText + '</a>';
            window.toaster.push('<strong>' + window.html('genericError') + '</strong> ' + window.text('error.' + response.errorCode, { link: link }), 'error');
            $('.primary-action[data-media-id="' + mediaId + '"]').html($('.primary-action[data-media-id="' + mediaId + '"]').attr('data-original-text'));
        } else if (elem.context.tagName !== 'BODY') {
            var mediaData = {
                id: mediaId,
                title: target.attr('data-title'),
                cover: target.attr('artwork'),
                typeId: target.attr('data-type'),
                prerelease: target.attr('data-pre-release')
            };

            openHoldConflictModal(mediaData);
        }
    });

    //For Nook buttons only
    //After accepting nook modal
    $(document).on('click tap', '[data-action="nook"]:not([data-no-linked-cards])', function (e) {
        var elem = $(e.target).is('[data-action="nook"]') ? $(e.target) : $(e.target).closest('[data-action="nook"]');
        var id = elem.attr('id') == 'accept-nook-dynamic' || Cookies.get('nook-eula-setting') == '1';

        if (id) {
            elem = $('a[data-action="nook"][data-media-id="' + elem.attr('data-media-id') + '"]'); // Find original element
            window.ajax.borrow(elem.attr('data-media-id'), null, elem);
        } else {
            $('a#accept-nook-dynamic').attr('data-media-id', elem.attr('data-media-id'));
        }
    });

    //Update dynamic nook modal mediaID
    $('.primary-action[data-type="periodicals"]').on('click', function () {
        $('#accept-nook-dynamic').attr({ 'data-media-id': $(this).attr('data-media-id'), 'data-type': $(this).attr('data-type') });
    });
});

window.borrowFromTitleElem = function (mediaId) {
    var elem = $('.primary-action[data-media-id="' + mediaId + '"]:first');
    elem.attr('data-original-text', elem.html());
    elem.html(primaryActionLoadingGif);
    ajax.borrow(mediaId, null, elem);
};

/**
 * HOLD EVENT LISTENERS -- from the big ol' buttons
 */
$(function () {
    var selector = '[data-action="hold"]:not([data-no-linked-cards])';
    $(document).on('click', selector, function (e) {
        var target = $(e.target).closest(selector);
        var mediaId = target.attr('data-media-id');

        // LHTNG-1584
        window.handleHold(target, mediaId);

        $('form#hold-dynamic-form').removeAttr('data-from-title');

        //Remove event handler to prevent re-triggering event
        $($(e.target)).off('click');
    }).on('holdSuccess', function (e, elem, data) {
        var mediaId = elem.attr('data-media-id');
        var holdsUrl = window.url(window.routes.accountHolds);

        // Get the user's new wait list position in order to update holds ratio modals.
        window.ajax.getHold(mediaId).done(function (media) {
            window.setDynamicHoldsRatioModals(media);
        });

        var email = $('.patron-hold-email-dynamic').val();

        // Open Success modal
        var title = new window.Title(window.OverDrive.mediaItems[mediaId]);
        window.globalEvents.trigger('title:hold:success', { titleModel: title });

        $('.primary-action[data-media-id="' + mediaId + '"]').css('visibility', 'hidden');

        var link = '<a href="' + holdsUrl + '">' + window.html('holds') + '</a>';
        $('p.pre-release-explanation').html(window.html('prereleaseExplanation', { link: link }));

        if ($(this).parents('.now-unavailable-button-container').length < 0) {
            $(this).attr('data-action', 'held');
        }
        window.loading.changeButtonState($('a[data-action="hold"][data-media-id="' + mediaId + '"], a[data-action="borrow"][data-media-id="' + mediaId + '"], a[data-action="borrow-simple"][data-media-id="' + mediaId + '"], a[data-action="held"][data-media-id="' + mediaId + '"]'), 'held');

        //Change grid items to match
        $('.title-header-bar[data-media-id="' + mediaId + '"] a').html(window.html('onHold') + ' <i class="icon icon-icon-checked title-label" aria-hidden="true"></i>').attr('href', holdsUrl).addClass('u-allCaps');
        window.loading.updateCoverAlt(mediaId, window.text('onHold'));

        // Update holds ratio help tip class
        $('.js-holds-ratio-not-held[data-media-id="' + mediaId + '"]').addClass('js-holds-ratio-held').removeClass('js-holds-ratio-not-held');

        // Update prerelease tip
        $('.js-prerelease[data-media-id="' + mediaId + '"]').addClass('is-held');
    }).on('holdFailure', function (e, elem, response) {
        window.loading.changeButtonState(elem, 'hold');

        response = JSON.parse(response.responseText);
        var link = '';
        var mediaId = elem.attr('data-media-id');

        function errorToast(pageLink) {
            window.toaster.push('<strong>' + window.html('genericError') + '</strong> ' + window.text('error.' + response.errorCode, { link: pageLink }), 'error');
        }

        if (response.sessionExpired) {
            window.gloablEvents.trigger('user:session:expired', { action: 'hold~' + mediaId });
        } else if (response.errorCode === 'PatronCardFailedAuthentication') {
            $('#hold-dynamic-modal').foundation('reveal', 'close');
            window.handleInvalidCard();
        } else if (response.errorCode === 'HoldAlreadyExists' || response.errorCode === 'PatronExceededHoldLimit') {
            $('#hold-dynamic-modal').foundation('reveal', 'close');
            link = '<a class="bold" href="' + window.url(window.routes.accountHolds) + '" tabindex="0">' + window.html('holds') + '</a>';
            errorToast(link);
        } else if (response.errorCode === 'PatronTypeRestrictedFromTitle' || response.errorCode === 'PatronHasHoldsDisabled') {
            $('#hold-dynamic-modal').foundation('reveal', 'close');
            link = '<a class="bold" href="' + window.url(window.routes.supportMembers) + '" tabindex="0">' + window.html('pleaseContactSupport') + '</a>';
            errorToast(link);
        } else {
            $('#hold-dynamic-modal').foundation('reveal', 'close');
            errorToast('');
        }

        $('.primary-action[data-media-id="' + elem.attr('data-media-id') + '"]').html(elem.attr('data-original-text'));
    });

    /**
     * Place a hold on a title when form validates
     */
    $('form#hold-dynamic-form').on('valid.fndtn.abide', function (e) {
        var elem = $('[data-action="hold"][data-media-id="' + $(this).attr('data-media-id') + '"]').first();

        //Check if hold was placed from title elem or action button
        if ($('form#hold-dynamic-form').attr('data-from-title')) {
            window.holdFromTitleElem($('form#hold-dynamic-form').attr('data-media-id'), $('form#hold-dynamic-form [data-id="title"]').text());
        } else if ($('form#hold-dynamic-form').attr('data-from-ajax')) {
            window.ajax.placeHold($('form#hold-dynamic-form').attr('data-media-id'), $('.patron-hold-email-dynamic').val(), $('body'));
        } else {
            window.holds.holdPlaced(elem);
        }
    });
});

window.handleHold = function (target, mediaId) {
    function revealHoldModal() {
        $('#hold-dynamic-modal h2[data-id="title"]').html($('[data-id="title"]').attr('data-title'));
        if (target.attr('data-artwork')) {
            $('[data-id="cover-image"]').attr('src', target.attr('data-artwork'));
        } else {
            var art = $('div.title[data-title-id="' + mediaId + '"] img').attr('src');
            if (typeof art == 'undefined') {
                art = $('div.modal-container img[data-id="cover-image"]').attr('src');
            }
            $('[data-id="cover-image"]').attr('src', art);
        }
        window.holds.revealHoldModal(target);
    }

    window.ajax.getPatronEmail().done(function (email) {
        if (email != '') {
            $('input#email-dynamic, input#email-conf-dynamic, .js-recommend-email').val(email);
            $('.primary-action, [data-action]:not([data-action="main-navigation"])').addClass('valid-email');
            window.holds.holdPlaced(target);
        } else {
            revealHoldModal();
        }
    }).fail(function () {
        revealHoldModal();
    });
};

/**
 * HOLD FROM TITLE ELEMENT -- e.g. that little link under the cover in a carousel or grid view
 */
function openHoldFromTitleElem(title, typeId, typeName, artwork, mediaId, prereleaseDate, isPrerelease) {
    var modal = $('#hold-dynamic-modal');
    $('form#hold-dynamic-form').attr('data-from-title', true);
    var button = $('.primary-action[data-media-id="' + mediaId + '"]:first');

    button.attr('data-original-text', button.text());
    button.html(primaryActionLoadingGif);

    $.when(window.ajax.getAvailability(mediaId), window.ajax.getPatronEmail()).done(function (availabilityResp, emailResp) {
        var availabilityData = availabilityResp[0];
        var email = emailResp[0];

        if (email != '' || availabilityData.availableCopies > 0) {
            $('input#email-dynamic, input#email-conf-dynamic, .js-recommend-email').val(email);
            $('.primary-action, [data-action]:not([data-action="main-navigation"])').addClass('valid-email');
            $('form#hold-dynamic-form').attr('data-media-id', mediaId);
            window.holdFromTitleElem(mediaId, availabilityData.availableCopies > 0);
        } else {
            $('[data-id="title"]').html(title);
            $('[data-id="format-icon"]').removeClass().addClass('icon-' + typeId);
            $('[data-id="format-name"]').html(typeName);
            $('[data-id="cover-image"]').attr('src', artwork);
            if (prereleaseDate != undefined && isPrerelease) {
                $('[data-id="pre-release-label"]').text("Pre-release: Expected " + prereleaseDate).removeClass('hideMe');
            } else {
                $('[data-id="pre-release-label"]').text("").addClass('hideMe');
            }

            var labelCopy = window.html('dynamicHoldModal.placeHoldDesc', { libraryName: window.OverDrive.libraryName });
            if (window.OverDrive.mediaItems[mediaId].ownedCopies === 0) {
                labelCopy = window.html('holdsRatioHelpModal.noCopiesText');
            }
            $('.js-hold-modal-label').html(labelCopy);

            $('form#hold-dynamic-form').attr('data-media-id', mediaId);

            if (button.attr('data-publisher') >= '98146' && button.attr('data-publisher') <= '98155' && Cookies.get('disney-eula-setting') != '1') {
                // Disney publisher ids are 98146 - 98155
                $('#disney-eula-modal').foundation('reveal', 'open');
            } else {
                modal.foundation('reveal', 'open');
            }
        }
    }).fail(function () {
        window.handleHold(button, mediaId);
    });
}

window.holdFromTitleElem = function (mediaId, availableCopies) {
    var elem = $('.primary-action[data-media-id="' + mediaId + '"]');

    var originalHTMLContents = $('.primary-action[data-media-id="' + mediaId + '"]').html();
    elem.html(window.primaryActionLoadingGif);
    $('.primary-action, [data-action]:not([data-action="main-navigation"])').addClass('valid-email');

    window.ajax.placeHold(mediaId, encodeURIComponent($('.patron-hold-email-dynamic').val()), elem);
};

window.openHoldSuccessModal = function (params) {
    var modal = $('#js-HoldSuccessModal');
    var linkUrl = window.url(window.routes.accountHolds);
    var manageHolds = '<a class="HoldSuccessModal-link" href="' + linkUrl + '" tabindex="0">' + window.html('holdSuccessModal.manageHolds') + '</a>';
    var successCopy;
    if (params.autoCheckoutSetting == 1) {
        successCopy = window.html('toasts.holdSuccessAutoCheckoutHtml', { email: params.email, manageHoldsLink: manageHolds });
    } else {
        successCopy = window.html('toasts.holdSuccessHtml', { email: params.email, manageHoldsLink: manageHolds });
    }
    modal.find('[data-id="loading-container"]').html(primaryActionLoadingGif);
    $.get(window.url(window.routes.mediaRelatedForHoldSuccess, { mediaId: params.mediaId }), function (res) {
        $('.js-holdSuccessContent').html(res);
        modal.find('[data-id="success-message"]').html(successCopy);
        var lzld = lazyload({ src: 'data-aload' });
        $('img[data-aload]')
        // add dimensions
        .addClass('broken')
        // add blank image so it doesn't look broken (this is smaller than clear.gif)
        .attr('src', 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==')
        // remove the placeholder stuff when the image is load for real
        .on('load', function () {
            if (this.getAttribute('data-lzled')) {
                $(this).removeAttr('broken data-aload').removeClass('broken');
            }
        })
        // register the lazy loader watcher
        .each(function () {
            lzld(this);
        });
        modal.find('[data-id="loading-container"]').html('');
        modal.foundation('reveal', 'open');
        if (typeof params.onLoad == 'function') params.onLoad();
    });
};

// Hold success modal events
$('#js-HoldSuccessModal').on('closed.fndtn.reveal', function (e) {
    // Don't clear content if the modal needs to be reopened or the dropdown is closed
    if ($('.js-holds-ratio-help-modal').attr('data-holdSuccess') !== 'true' && !$(e.target).hasClass('js-context-drop')) {
        $('.js-holdSuccessContent').html('');
    }
    window.toaster._stickToast();
});

$('.js-holdSuccessContent').on('click tap', function (e) {
    if ($(e.target).hasClass('js-holds-ratio-help-icon')) {
        $('.js-holds-ratio-help-modal').attr('data-holdSuccess', true);
    }
});

$('.js-holds-ratio-help-modal').on('closed.fndtn.reveal', function () {
    if ($(this).attr('data-holdSuccess') === 'true') {
        $('#js-HoldSuccessModal').foundation('reveal', 'open');
        $(this).attr('data-holdSuccess', false);
    }
});

/**
 * Edit a holds email address
 */
$(document).on('valid.fndtn.abide', '#hold-email-form', function () {
    var mediaId = $('#mediaId').val();

    $.ajax({
        url: window.url(window.routes.mediaEditHold, { mediaId: mediaId }),
        type: 'PUT',
        data: {
            email: $('.patron-hold-email').val(),
            autoCheckout: window.patronSettings['auto-checkout-setting'] == 1
        },
        success: function success(data) {
            var email = $('.patron-hold-email').val();

            // Update the email on the Card manager instance
            window.card && window.card.setHoldEmail(email);
            $('#edit-hold-email-modal').foundation('reveal', 'close');
        },
        error: function error(jqXHR, textStatus, errorThrown) {
            var response = JSON.parse(jqXHR.responseText);
            $('#edit-hold-email-modal').foundation('reveal', 'close');
            window.toaster.push('<strong>' + window.html('genericError') + '</strong> ' + response.responseText, 'error');
        }
    });
});

/**
 * WISH LIST EVENT LISTENERS
 */
$(function () {
    var elemAdd = '[data-action="wishlist-add"]:not([data-no-linked-cards])';

    $('body').on('click', elemAdd, function (e) {
        window.ajax.wishListAdd($(e.target).closest('a').attr('data-media-id'), $(e.target).closest('a'));
    }).on('wishListAddRequest', elemAdd, function (e) {
        var icon = $(e.target).closest('div').children('i');
        window.loading.animateIcon(icon, 'bounceOut');
    }).on('wishListAddSuccess', elemAdd, function (e, data) {
        var icon = $(e.target).closest('div').children('i');
        icon.removeClass('icon-wish-list').addClass('icon-wish-list-added');
        var mediaId = $(e.target).closest('a').attr('data-media-id');
        window.loading.changeButtonState($(e.target).closest('a'), 'wishlist-remove');
        window.loading.animateIcon(icon, 'bounceIn');

        //Change state of any grid view items with same media id
        var gridIcon = $('div.wishlist[data-media-id="' + mediaId + '"]').find('i');
        gridIcon.hasClass('icon-wish-list') ? gridIcon.removeClass('icon-wish-list').addClass('icon-wish-list-added') : gridIcon.removeClass('icon-wish-list-added').addClass('icon-wish-list');
    });

    var elemRemove = '[data-action="wishlist-remove"]';
    $('body').on('click', elemRemove, function (e) {
        window.ajax.wishListRemove($(e.target).closest('a').attr('data-media-id'), $(e.target).closest('a'), false);
    }).on('wishListRemoveRequest', elemRemove, function (e) {
        var icon = $(e.target).closest('div').children('i');
        window.loading.animateIcon(icon, 'bounceOut');
    }).on('wishListRemoveSuccess', elemRemove, function (e, data) {
        var icon = $(e.target).closest('div').children('i');
        icon.removeClass('icon-wish-list-added').addClass('icon-wish-list');
        var mediaId = $(e.target).closest('a').attr('data-media-id');
        $(e.target).closest('a').attr('data-action', 'wishlist-add');
        window.loading.changeButtonState($(e.target).closest('a'), 'wishlist-add');
        window.loading.animateIcon(icon, 'bounceIn');

        //Change state of any grid view items with same media id
        var gridIcon = $('div.wishlist[data-id="' + mediaId + '"]').find('i');
        gridIcon.hasClass('icon-wish-list') ? gridIcon.removeClass('icon-wish-list').addClass('icon-wish-list-added') : gridIcon.removeClass('icon-wish-list-added').addClass('icon-wish-list');
    });
});

/**
 * WISH LIST FROM TITLE ELEMENT
 */
window.wishlistOnTitleElem = function (mediaId, elem) {
    var wishlistUrl = window.url(window.routes.accountWishlist);
    var icon = $(elem).children(':first');
    var titleName = $('.title-name[data-media-id="' + mediaId + '"] a:first').text();
    $(icon).addClass('bounceOut');

    if ($(icon).hasClass("icon-wish-list")) {
        // Add to wish list
        window.ajax.wishListAdd(mediaId, elem);

        $(document).on('wishListAddSuccess', elem, function () {
            $(icon).removeClass('icon-wish-list').addClass('icon-wish-list-added').removeClass('bounceOut').addClass('bounceIn');
            $(elem).attr('aria-label', window.html('removeTitleFromWishList', { title: titleName }));

            //Update any list view items to match
            var mediaId = $(elem).closest('div.wishlist').attr('data-media-id');
            var listElem = $('a[data-action="wishlist-add"][data-media-id="' + mediaId + '"]');
            var listIcon = listElem.prev('i');
            listElem.attr('data-action', 'wishlist-remove');
            listIcon.removeClass('icon-wish-list').addClass('icon-wish-list-added');
            window.loading.animateIcon(listIcon, 'bounceIn');
            window.loading.changeButtonState(listElem, 'wishlist-remove');

            $(document).off('wishListAddSuccess');
        }).on('wishListAddFailure', elem, function (e, jqXHR, textStatus, errorThrown) {
            console.log(errorThrown);
            var mediaId = $(elem).closest('div.wishlist').attr('data-media-id');

            if (jqXHR.responseText && JSON.parse(jqXHR.responseText)['sessionExpired']) {
                var forwardUrl = window.location.pathname;
                if (window.location.search) {
                    forwardUrl += window.location.search + '&wish~' + mediaId;
                } else {
                    forwardUrl += '?wish~' + mediaId;
                }
                $('.js-reauthenticate').attr('href', window.url(window.routes.accountSignIn, { forward: forwardUrl }));
                $('#authenticate-modal').foundation('reveal', 'open');
            } else {
                window.toaster.push(window.html('error.defaultErrorHtml'), 'error');
            }

            var icon = $(elem).children('i');
            window.loading.animateIcon(icon, 'bounceIn');

            $(document).off('wishListAddFailure');
        });
    } else if ($(icon).hasClass("icon-wish-list-added")) {
        // Remove from wish list
        window.ajax.wishListRemove(mediaId, elem, false);

        $(document).on('wishListRemoveSuccess', elem, function () {
            $(icon).removeClass('icon-wish-list-added').addClass('icon-wish-list').removeClass('bounceOut').addClass('bounceIn');
            $(elem).attr('aria-label', window.html('addTitleToWishList', { title: titleName }));

            //Update any list view items to match
            var mediaId = $(elem).closest('div.wishlist').attr('data-id');
            var listElem = $('a[data-action="wishlist-remove"][data-media-id="' + mediaId + '"]');
            var listIcon = listElem.prev('i');
            listElem.attr('data-action', 'wishlist-add');
            listIcon.removeClass('icon-wish-list-added').addClass('icon-wish-list');
            window.loading.animateIcon(listIcon, 'bounceIn');
            window.loading.changeButtonState(listElem, 'wishlist-add');

            $(document).off('wishListRemoveSuccess');
        }).on('wishListRemoveFailure', elem, function (e, jqXHR, textStatus, errorThrown) {
            var mediaId = $(elem).closest('div.wishlist').attr('data-id');
            console.log(errorThrown);

            if (jqXHR.responseText && JSON.parse(jqXHR.responseText)['sessionExpired']) {
                var forwardUrl = window.location.pathname + window.location.search;
                $('.js-reauthenticate').attr('href', window.url(window.routes.accountSignIn, { forward: forwardUrl }));
                $('#authenticate-modal').foundation('reveal', 'open');
            } else {
                window.toaster.push(window.html('error.defaultErrorHtml'), 'error');
            }

            var icon = $(elem).children('i');
            window.loading.animateIcon(icon, 'bounceIn');

            $(document).off('wishListRemoveFailure');
        });
    }
};

/**
 * PATRON MEDIA STATUS EVENT LISTENERS
 */
$(function () {
    var items = [];
    var wishListItems = [];

    $('body').on('mediaStatusRequest', function () {
        $('[data-action]:not([data-no-linked-cards]):not(.js-statusUpdated)').each(function () {
            var action = $(this).attr('data-action');
            if (action == 'wishlist-add' || action == 'wishlist-remove') {
                var icon = $(this).closest('div').children('i');
                window.loading.animateIcon(icon, 'bounceOut');
            }
        });
    }).on('mediaStatusSuccess', function (e, data) {
        var elem;

        // TODO: Remove
        // $('.media-container.loading').css('display', 'none');
        // if (typeof toggleListViewFeature == 'function') {
        //     toggleListViewFeature();
        // }

        async.parallel([function (callback) {
            //LOOP ALL BORROWED TITLES
            if (data.onCheckouts != null) {
                for (var x = 0; x < data.onCheckouts.length; x++) {
                    var titleId = data.onCheckouts[x];
                    items.splice(items.indexOf(+titleId), 1);

                    //Handle grid view items
                    $('.title-header-bar[data-media-id="' + titleId + '"] a').html(window.html('borrowed') + ' <i class="icon icon-icon-checked title-label" aria-hidden="true"></i>').attr('href', window.url(window.routes.accountLoans)).addClass('u-allCaps');
                    window.loading.updateCoverAlt(titleId, window.text('borrowed'));
                    $('.primary-action[data-media-id="' + titleId + '"]').addClass('invisible js-statusUpdated');

                    //Handle list view items
                    elem = $('[data-action="borrow"][data-media-id="' + titleId + '"], [data-action="borrow-simple"][data-media-id="' + titleId + '"], [data-action="hold"][data-media-id="' + titleId + '"], [data-action="nook"][data-media-id="' + titleId + '"]');
                    window.loading.changeButtonState(elem, 'borrowed', true);
                    //Change banner text
                    $('[data-banner][data-media-id="' + titleId + '"]').text(window.html('availabilityBorrowed').toUpperCase());
                }
            }

            callback();
        }, function (callback) {
            //LOOP ALL HELD TITLES
            if (data.onHolds != null) {
                for (var y = 0; y < data.onHolds.length; y++) {
                    //If title is already borrowed do not take action
                    if (data.onCheckouts.indexOf(data.onHolds[y]) == -1) {
                        var titleId = data.onHolds[y];
                        items.splice(items.indexOf(+titleId), 1);

                        $('.title-header-bar[data-media-id="' + titleId + '"] a').html(window.html('onHold') + ' <i class="icon icon-icon-checked title-label" aria-hidden="true"></i>').attr('href', window.url(window.routes.accountHolds)).addClass('u-allCaps');
                        window.loading.updateCoverAlt(titleId, window.text('onHold'));

                        $('.primary-action[data-media-id="' + titleId + '"]').addClass('invisible js-statusUpdated');

                        //Handle list view items
                        elem = $('[data-action="hold"][data-media-id="' + titleId + '"], [data-action="borrow"][data-media-id="' + titleId + '"]');
                        window.loading.changeButtonState(elem, 'held');

                        //Change banner text
                        $('[data-banner][data-media-id="' + titleId + '"]').text(window.text('onHold'));

                        // Update holds ratio help tip class
                        $('.js-holds-ratio-not-held[data-media-id="' + titleId + '"]').addClass('js-holds-ratio-held').removeClass('js-holds-ratio-not-held');

                        // Update prerelease tip
                        $('.js-prerelease[data-media-id="' + titleId + '"]').addClass('is-held');
                    }
                }
            }

            callback();
        }, function (callback) {
            //LOOP ALL RECOMMENDED TITLES
            if (data.recommendedToLibrary != null) {
                for (var z = 0; z < data.recommendedToLibrary.length; z++) {
                    var titleId = data.recommendedToLibrary[z];

                    if (window.OverDrive.mediaItems[titleId] && !window.OverDrive.mediaItems[titleId].isAvailable && !window.OverDrive.mediaItems[titleId].isHoldable) {
                        window.loading.updateRecommendationState(titleId);
                    }
                }
            }

            callback();
        }, function (callback) {
            //LOOP ALL TITLES ON WISH LIST
            if (data.onWishlist != null) {
                for (var z = 0; z < data.onWishlist.length; z++) {
                    var titleId = data.onWishlist[z];
                    var titleName = $('.title-name[data-media-id="' + titleId + '"] a:first').text();

                    $('.wishlist[data-media-id="' + titleId + '"] i').removeClass('icon-wish-list').addClass('icon-wish-list-added js-statusUpdated');
                    $('.wishlist[data-media-id="' + titleId + '"] a').attr('aria-label', window.html("removeTitleFromWishList", { title: titleName }));

                    //Handle list view items
                    elem = $('[data-action="wishlist-add"][data-media-id="' + titleId + '"]');
                    var icon = elem.closest('div').children('i');
                    window.loading.animateIcon(icon, 'bounceIn');
                    window.loading.changeButtonState(elem, 'wishlist-remove');
                    icon.removeClass('icon-wish-list').addClass('icon-wish-list-added');
                }
            }

            callback();
        }], function (err, results) {
            //Stop spinner and change state on remaining items
            for (var i = 0; i < items.length; i++) {
                var elem = $('[data-action][data-media-id="' + items[i] + '"]:not(.lending-options)');

                elem.each(function () {
                    window.loading.changeButtonState($(this), $(this).attr('data-action'), true);
                });
            }

            //Get remaining wish list items
            for (var j = 0; j < wishListItems.length; j++) {
                var elem = $('[data-action="wishlist-add"][data-media-id="' + wishListItems[j] + '"]');

                var icon = elem.closest('div').children('i');
                window.loading.animateIcon(icon, 'bounceIn');
                window.loading.changeButtonState($(this), $(this).attr('data-action'), true);
            }
        });

        var location = window.location.toString();

        //Only process here if not on the details page
        if (location.indexOf('/media/') == -1) {
            processInstantForwardActions(window.location.pathname + (window.location.search ? window.location.search : ''));
        }

        $('.carousel.loaded').each(function () {
            if (!detectshun.browser().mobile && !detectshun.browser().tablet) {
                Ps.update(this);
                hideCarouselArrows(this);
            }
        });

        $('.media-container.loading').css('display', 'none');
        $('.media-container.loaded').css('display', 'block').promise().done(function () {
            $(document).trigger('mediaItemsLoaded');
        });
        $('.js-rtlLoader').removeClass('u-hideMe');

        $('[data-action]:not([data-action="main-navigation"])').removeClass('disabled');
    }).on('mediaStatusFailure', function (e, jqXHR) {
        $('[data-action]:not([data-action="main-navigation"])').each(function () {
            if ($(this).attr('data-action') == 'wishlist-add' || $(this).attr('data-action') == 'wishlist-remove') {
                window.loading.animateIcon($(this).closest('div').children('i'), 'bounceIn');
            }
            window.loading.changeButtonState($(this), $(this).attr('data-action'), true);
        });

        $('.js-rtlLoader').removeClass('u-hideMe');

        $('.carousel.loaded').each(function () {
            if (!detectshun.browser().mobile && !detectshun.browser().tablet) {
                Ps.update(this);
                hideCarouselArrows(this);
            }
        });
    });

    var location = window.location.toString();
    if ($('body').attr('authenticated') != 'false' && location.indexOf('/holds') == -1) {
        $('[data-action]:not([data-action="main-navigation"]), .primary-action, .js-banner-link[data-banner], [data-media-id]').each(function () {
            var mediaId = typeof $(this).attr('data-media-id') === 'undefined' ? $(this).attr('data-id') : $(this).attr('data-media-id');
            if (items.indexOf(+mediaId) < 0 && mediaId) {
                items.push(+mediaId);
                wishListItems.push(+mediaId);
            }
        });
        //hack to get rid of extra call on media details page since the button was refactored to not use title-actions
        if (items.length === 1 && location.indexOf('media/' + items[0]) < 0 || items.length > 1) {
            window.ajax.getMediaStatus(items);
        }
    } else {
        $('[data-action]:not([data-action="main-navigation"])').each(function () {
            window.loading.changeButtonState($(this), $(this).attr('data-action'), true);
        });

        $('.media-container.loading').css('display', 'none');
        $('.media-container.loaded').css('display', 'block');
        $('.media-container.loaded.grid-view').css('display', 'block');
        $('.js-rtlLoader').removeClass('u-hideMe');

        if ($('body').attr('no-linked-cards') === 'true') {
            $(document).ready(function () {
                setTimeout(function () {
                    $(document).trigger('mediaStatusNoCard');
                }, 200);
            });
        }

        $('.carousel.loaded').each(function () {
            if (!detectshun.browser().mobile && !detectshun.browser().tablet) {
                Ps.update(this);
                hideCarouselArrows(this);
            }
        });
    }
});

/**
 * LENDING PERIOD OPTIONS EVENT LISTENERS
 */
$(function () {
    $('[data-lending-period-dropdown]').on('lendingPeriodsRetrieved', function (e, data) {
        var lendingPeriodList = $('.js-lending-period-list');
        lendingPeriodList.empty(); // Clear any remaining options
        for (var i = 0; i < data.items.length; i++) {
            var days;
            if (data.items[i].units == 'days') {
                days = data.items[i].lendingPeriod;
            } else {
                // minutes
                days = data.items[i].lendingPeriod / 1440;
            }
            var selectedClass = data.items[i].isPreferredLendingPeriod ? 'is-checked default' : '';
            var selectedAria = data.items[i].isPreferredLendingPeriod ? 'aria-selected="true"' : 'aria-selected="false"';
            var selectedLabel = data.items[i].isPreferredLendingPeriod ? window.html('selected') : '';

            var content = '<li role="menuitem" tabindex="-1" class="LendingPeriods-lendingPeriodListItem"><a tabindex="-1" href="" role="button"' + selectedAria + ' aria-label="' + window.html('borrowButtonLabel', { days: days }) + selectedLabel + '" class="' + selectedClass + ' lending-option LendingPeriods-lendingPeriodListItemLink js-lending-period-option" data-text="' + window.html('forXDays', { lendingPeriod: days }) + '" data-days="' + days + '" id="lending-' + days + '-days">' + window.html('xDays', { lendingPeriod: days }) + '</a></li>';

            lendingPeriodList.append(content);

            if (data.items[i].isPreferredLendingPeriod) {
                var that = this;
                setTimeout(function (that, days) {
                    $(that).prev('a[data-media-id="' + $(that).attr('data-media-id') + '"]').children('.borrow-sub-text').text(window.text('forXDays', { lendingPeriod: days }));
                }, 0, that, days);
                $('input#lending-period-' + $(this).attr('data-media-id')).val(days);
            }
        }

        window.loading.changeButtonState($(this).prev('[data-action="borrow"]'), 'borrow');

        //If on the details page: execute forwarded action after lending periods retrieved
        var location = window.location.toString();
        if (location.indexOf('/media/') > -1) {
            processInstantForwardActions(window.location.pathname + (window.location.search ? window.location.search : ''));
        }
    }).each(function () {
        //Only check media status if button has display other than none
        if ($(this).parents('.now-available-button-container').length == 0 && !$(this).closest('.action-buttons').length || $(this).closest('.action-buttons').length && getComputedStyle($(this).closest('.action-buttons')[0], null).display != 'none' || $('.media-container.grid-view').length) {
            if ($('body').attr('authenticated') == 'false' && $('body').attr('no-linked-cards') == 'false') {
                var mediaId = $(this).attr('data-media-id');
                var forwardUrl = window.url(window.routes.mediaId, { id: mediaId });
                var signInUrl = window.url(window.routes.accountSignIn, { forward: forwardUrl });
                var signInLink = '<a class="lending-option-link js-lending-period-link" tabindex="-1" aria-label="' + window.html('lendingPeriodTextLabelNoAuth') + '" href="' + signInUrl + '">' + window.html('signIn') + '</a>';
                var content = window.html('lendingPeriodTextNoAuthWithLinkHtml', { link: signInLink });
                $('ul#lending-period-options-' + $(this).attr('data-media-id')).append(content);
            } else {
                //If no linked cards populate lending period dropdown
                var attr = $(this).attr('data-no-linked-cards');
                if (typeof attr !== 'undefined' && attr !== false) {
                    var addCardLink = '<a class="lending-option-link js-lending-period-link" tabindex="-1" aria-label="' + window.html('lendingPeriodTextLabelNoCard') + '" data-reveal-id="link-card-modal" href="javascript:void(0)">' + window.html('addACard') + '</a>';
                    var content = window.html('lendingPeriodTextNoCardWithLinkHtml', { link: addCardLink });
                    $('ul#lending-period-options-' + $(this).attr('data-media-id')).append(content);
                } else {
                    window.ajax.getLendingPeriods($(this).attr('data-media-id'), $(this));
                }
            }
        }
    });

    window.globalEvents.on('lendingPeriods:fetch:fail', function () {
        $('.js-lending-period-list').html('<span>' + window.html('error.errorTryAgain') + '</span>');
    });

    /*
     * Change lending period options and control focus with keyboard
     */
    $('body').on('click keydown', '[data-lending-ul] li a', function (e) {
        if (e.type == 'click' || e.which == 13 || e.which == 32) {
            e.preventDefault();

            var dropdownButton = $(e.target).closest('ul').prev('[data-lending-period-dropdown]');
            var mediaId = dropdownButton.attr('data-media-id');

            var lendingDropdown = $('ul#lending-period-options-modal-' + mediaId).length ? 'ul#lending-period-options-modal-' + mediaId : 'ul#lending-period-options-' + mediaId;
            $(lendingDropdown + ' li a').each(function () {
                $(this).removeClass('checked is-checked').attr({ 'aria-selected': 'false', 'aria-label': $(this).attr('aria-label') ? $(this).attr('aria-label').replace(window.html('selected'), '') : '' });
            });

            $(lendingDropdown + ' li a[data-days="' + $(this).data('days') + '"]').addClass('checked is-checked').attr({ 'aria-selected': 'true', 'aria-label': window.html('borrowButtonLabel', { days: $(this).data('days') }) });

            dropdownButton.prev('[data-action="borrow"]').find('span.borrow-sub-text').text($(this).data('text'));

            var lendingPeriodInput = $('#lending-period-modal-' + mediaId).length ? $('#lending-period-modal-' + mediaId) : $('#lending-period-' + mediaId);

            lendingPeriodInput.val($(this).data('days'));

            if (!$(this).hasClass('default')) {
                dropdownButton.prev('[data-action="borrow"]').addClass('changed');
            } else {
                dropdownButton.prev('[data-action="borrow"]').removeClass('changed');
            }

            //$('.js-lending-period-option').attr('tabindex', -1);
            $('.js-lending-period-list').hide();
            $('.js-lending-period-dropdown-button').focus();
        } else if (e.which == 40) {
            //Down arrow pressed move focus forward
            e.preventDefault();
            $(this).closest('li').next('li').children('a').focus();
        } else if (e.which == 38) {
            //Up arrow pressed move focus back
            e.preventDefault();

            //If first item in list go back to dropdown button
            if ($(this).closest('li').is(':first-child')) {
                $(this).closest('ul').prev('button.dropdown').focus();
            } else {
                $(this).closest('li').prev('li').children('a').focus();
            }
        }
    });

    $('.lending-period-dropdown').on('keydown', function (e) {
        if (e.which == 40) {
            //Down arrow pressed move focus to first item
            e.preventDefault();
            var dropDown = $(this).data('dropdown');
            $('ul#' + dropDown).children('li').first().children('a').focus();
        }
    });

    //Control lending period dropdown tabindex
    $('[data-lending-ul], ul.signin-dropdown').on("opened.fndtn.dropdown", function () {
        $(this).find('a').attr('tabindex', '0');
    }).on("closed.fndtn.dropdown", function () {
        var mediaId = $(this).attr('data-media-id');
        $(this).find('a').attr('tabindex', '-1');
        $('input#lending-period-' + mediaId).trigger('change');
    });

    //Focus on borrow button after selecting new lending period
    $('[data-lending-period-input]').on('change', function () {
        $(this).prev('[data-action="borrow"]').focus();
    });
});

/**
 * Handle star ratings. Star ratings event listeners
 */
$(function () {
    //Action on star click (Set rating)
    $('.star-ratings-container.editable.is-old').on('click', '.icon-star', function (e) {
        var $target = $(e.target);
        var $container = $target.closest('.star-ratings-container');
        var rating = $target.data('index');

        selectStarRating($container, rating, false);
    });

    //Retrieve all star ratings
    $('body').on('mediaStatusSuccess', function (e, data) {
        for (var mediaId in data.starRatings) {
            var $container = $('.star-ratings-container.is-old[data-media-id="' + mediaId + '"]');
            var rating = data.starRatings[mediaId];

            setUserStarRating($container, rating, { setRating: true, isHover: false });
        }
        $(this).trigger('userStarRatingSet'); // Allow forwarded star action to be processed
    });

    //Control hover state
    $('.star-ratings-container.editable.is-old .icon-star').hover(function (e) {
        var $this = $(this);
        var $container = $this.closest('.star-ratings-container');
        var userRating = $container.data('user-rating');

        $container.addClass('user-rating');

        var hypotheticalRating = $this.data('index');
        fillStars($container, hypotheticalRating, { setRating: false, isHover: true });
    });

    $('.star-ratings-container.editable.is-old').on('mouseleave', function () {
        var $this = $(this);
        var $container = $this.closest('.star-ratings-container');
        var userRating = $container.data('user-rating');
        var hasUserRating = userRating > 0;

        if (!hasUserRating) {
            $container.removeClass('user-rating');

            fillStars($container, $container.data('global-rating'), { setRating: false, isHover: true });
        } else {
            fillStars($container, userRating, { setRating: false, isHover: true });
        }
    });

    window.globalEvents.on('rating:set:fail', function () {
        var link = '<a class="bold" href="' + window.url(window.routes.supportMembers) + '" tabindex="0">' + window.html('pleaseContactSupport') + '</a>';
        window.toaster.push('<strong>' + window.html('genericError') + '</strong> ' + window.text('error.errorContactSupport', { link: link }), 'error');
    });

    window.globalEvents.on('rating:delete:fail', function () {
        var link = '<a class="bold" href="' + window.url(window.routes.supportMembers) + '" tabindex="0">' + window.html('pleaseContactSupport') + '</a>';
        window.toaster.push('<strong>' + window.html('genericError') + '</strong> ' + window.text('error.errorContactSupport', { link: link }), 'error');
    });
});

/**
 * Handle recommend to library
 */
$(function () {

    $(document).on('click', '.js-recommend:not([data-no-auth]):not([data-no-linked-cards]):not(.js-recommended)', function (e) {
        // This check will be refactored out soon..
        if (window.OverDrive.isAuthenticated && window.OverDrive.hasLinkedCards) {
            var $genericElem = $('.js-recommend[data-media-id="' + $(this).attr('data-media-id') + '"]');
            var $gridElem = $('.primary-action[data-media-id="' + $(this).attr('data-media-id') + '"]:first');
            var $listElem = $('.js-recommend[data-media-id="' + $(this).attr('data-media-id') + '"]:not(.primary-action)');

            $gridElem.attr('data-original-text', $gridElem.html());
            $gridElem.html(primaryActionLoadingGif);

            var title = $(this).data('title');
            var author = $(this).data('author');
            var typeId = $(this).data('type');
            var typeName = $(this).data('type-name');
            var artwork = $(this).data('artwork');
            var mediaId = $(this).data('media-id');

            $('[data-id="title"]').html(title);
            $('[data-id="author"]').html(author);
            $('[data-id="format-icon"]').removeClass().addClass('icon-' + typeId);
            $('[data-id="format-name"]').html(typeName);
            $('[data-id="cover-image"]').attr('src', artwork);

            $('form#recommend-dynamic-form').attr('data-media-id', mediaId);

            if (!$genericElem.hasClass('js-recommended')) {

                window.ajax.getPatronEmail().done(function (email) {
                    if (email != '') {
                        $('.js-recommend').addClass('valid-email');
                        $('.js-recommend-email').val(email).hide();
                    }

                    $('.js-recommend-modal').foundation('reveal', 'open');
                }).fail(function () {
                    $('.js-recommend-modal').foundation('reveal', 'open');
                });
            }
        }
    });

    $('.js-recommendations-form').on('valid.fndtn.abide', function (e) {

        var id = $('.js-recommendations-form').attr('data-media-id');
        var addHold = $('.js-recommend-checkbox:checked').val();
        var notifyIfPurchased = true;
        var email = $('.js-recommend-email').val();

        window.ajax.addRecommendation(id, addHold, notifyIfPurchased, email);
    });

    $(document).on('recommendationFailure', function (e, data) {
        var $gridElem = $('.primary-action[data-media-id="' + data.mediaId + '"]');
        $gridElem.html($gridElem.attr('data-original-text'));

        var errorMsg = data.responseText || window.text('errorOccurred');

        if (errorMsg === 'PatronExceededRecommendationsLimit') {
            $('.js-recommendation-limit-modal').foundation('reveal', 'open');
        } else if (data.statusText === 'Unauthorized') {
            var forwardUrl = window.location.pathname;
            if (window.location.search) {
                forwardUrl += window.location.search + '&recommend~' + data.mediaId;
            } else {
                forwardUrl += '?recommend~' + data.mediaId;
            }
            $('.js-reauthenticate').attr('href', window.url(window.routes.accountSignIn, { forward: forwardUrl }));
            $('#authenticate-modal').foundation('reveal', 'open');
            //  Consider for following if: data.errorCode === 'PatronCardFailedAuthentication'
        } else if (data.statusText === 'Unauthorized' || data.responseJSON && data.responseJSON.sessionExpired === true) {
            if (window.OverDrive.authType === 'library') {
                window.handleInvalidCard();
            } else {
                // the user's card is no longer valid. Direct them to the link a card flow so that they may resolve any issues.
                $('.js-card-error-modal').foundation('reveal', 'open');
            }
        } else {
            window.toaster.push(errorMsg, 'error');
            $('.js-recommend-modal').foundation('reveal', 'close');
        }
    });

    $('.js-recommend-modal').on('closed.fndtn.reveal', function () {
        //Remove spinners
        var mediaId = $(this).find('form').attr('data-media-id');
        var $gridElem = $('.primary-action[data-media-id="' + mediaId + '"]');
        var $listElem = $('.js-recommend[data-media-id="' + mediaId + '"]:not(.primary-action)');

        $gridElem.html($gridElem.attr('data-original-text'));
    });
});

$(document).on('click', 'a[data-reveal-id]', function (e) {
    e.preventDefault();
});

$(document).ready(function () {

    $(document).on('click', '[data-action][data-no-linked-cards], .icon-star[data-no-linked-cards]', function () {
        var strippedQuerystring = window.location.search.replace(/([?&]no-linked-card=(?:true|false)&?)/i, function (match) {
            var lastChar = match[match.length - 1];
            if (lastChar === '&') {
                // there's more after us; when we're removed we need to use our beginning seperator to replace the ampersand
                return match[0];
            } else {
                // nothing after us; can just replace with nothing
                return '';
            }
        });

        var forwardUrl = window.location.pathname + window.location.search.replace(/(&|\?)no-linked-card(=true|\=false)/, '');
        var action = '';
        if ($(this).hasClass('icon-star')) {
            action = 'star~' + $(this).parent().attr('data-media-id') + '~' + $(this).data('index'); // Add star rating
        } else {
            action = $(this).attr('data-action') + '~' + $(this).attr('data-media-id');
        }
        var initiateCardLinkUrl = window.url(window.routes.accountStartCardLink, { forward: forwardUrl, action: action });
        $('#add-card-button').attr('href', initiateCardLinkUrl);
        $('#link-card-modal').foundation('reveal', 'open');
    });

    /* Reset star rating when user has no linked card and close link a car modal */
    $('.link-card-modal').on('close.fndtn.reveal', function () {
        var container = $('.star-ratings-container');
        container.data('user-rating', null).removeClass('user-rating');
        fillStars(container, Math.round(container.data('global-rating')));
    });
});

//Click on link when clicking wishlist icon
$(document).on('click', '.wishlist-container i', function () {
    $(this).next('a').click();
});

window.setDynamicHoldsRatioModals = function (media) {
    media = media || {};
    $('a#holds-explanation').each(function () {
        if ($(this).attr('data-holdListPosition') != '') {
            $(this).attr('onclick', 'dynamicHoldsRatioModal(' + $(this).attr('data-holdsCount') + ', ' + $(this).attr('data-ownedCopies') + ', ' + $(this).attr('data-holdsRatio') + ', ' + $(this).attr('data-holdListPosition') + ');');
        }

        if ($(this).attr('data-ownedCopies') == '' || $(this).attr('data-ownedCopies') == 0) {
            $('#help-hold-label').addClass('hideMe');
            $('#close-ratio-help').attr('aria-labelledby', 'hold-help-label-noCopies');
        }
    });

    $('a#holds-explanation-details').attr('onclick', 'dynamicHoldsRatioModal(' + media.holdsCount + ', ' + media.ownedCopies + ', ' + media.holdsRatio + ', ' + media.holdListPosition + ');');
};

},{}],"C:\\projects\\lightning\\public\\js\\placeholder.js":[function(require,module,exports){
'use strict';

// Released under MIT license: http://www.opensource.org/licenses/mit-license.php

var device = detectshun.browser();

if (device.bowser.msie) {
    (function ($) {
        'use strict';

        $(function () {
            $('[placeholder]').focus(function () {
                var input = $(this);
                if (input.val() === input.attr('placeholder')) {
                    input.val('').removeClass('placeholder');
                }
            }).blur(function () {
                var input = $(this);
                if (input.val() === '' || input.val() === input.attr('placeholder')) {
                    input.addClass('placeholder').val(input.attr('placeholder'));
                }
            }).blur().parents('form').submit(function () {
                $(this).find('[placeholder]').each(function () {
                    var input = $(this);
                    if (input.val() === input.attr('placeholder')) {
                        input.val('');
                    }
                });
            });
        });
    })(jQuery);
}

},{}],"C:\\projects\\lightning\\routes\\routing-configuration\\index.js":[function(require,module,exports){
'use strict';

var routes = {
    home: '/',
    browse: '/browse',
    search: '/search',
    searchByType: '/search/:type',
    advancedSearch: '/advanced-search',
    titleRecommendations: '/media/:mediaId/recommendations',
    collectionById: '/collection/:collectionId',
    featuredCollection: '/collections/featured/:viewId',
    youMayLikeCollection: '/collections/youmaylike',
    mediaId: '/media/:id',
    mediaInfoId: '/media/info/:id',
    mediaRelatedId: '/media/related/:id',
    mediaRelatedForHoldSuccess: '/media/relatedforholdsuccess/:mediaId',
    mediaInfo: '/media/info',
    mediaAvailabilityId: '/media/availability/:id',
    mediaDownload: '/media/download/:format/:mediaId',
    mediaBorrow: '/media/borrow/:mediaId',
    mediaBorrowStatus: '/media/loans/:mediaId/:libraryKey',
    mediaReturn: '/media/return/:mediaId',
    patronRecommendations: '/patron/recommendations',
    patronRecommendationsDelete: '/patron/recommendations/:mediaId',
    patronMediaStarRatings: '/patron/media/star-rating/:titleId',
    mediaHoldStatus: '/media/holds/status/:mediaId',
    getSingleHold: '/media/hold/:mediaId',
    mediaPlaceHold: '/media/hold',
    mediaEditHold: '/media/holds/edit/:mediaId',
    mediaSuspendHold: '/media/holds/suspend/:mediaId',
    mediaRemoveHoldSuspension: '/media/holds/suspend/remove/:mediaId',
    mediaRemoveHold: '/media/holds/remove/:mediaId',
    accountSettings: '/account/settings',
    accountWishlist: '/account/lists/wishlist',
    accountWishlistStatus: '/account/lists/wishlist/status/:mediaId/:libraryKey',
    accountWishlistRemove: '/account/lists/wishlist/remove/:mediaId',
    accountWishlistAdd: '/account/lists/wishlist/add/:mediaId',
    supportMembers: '/support/members',
    supportCard: '/support/card',
    accountHolds: '/account/holds',
    accountInvalidCard: '/account/card/invalid',
    accountLoans: '/account/loans',
    accountRecommendations: '/account/lists/recommendations',
    accountLinkCard: '/account/linkcard',
    accountGetACard: '/account/sign-in?intent=gac',
    accountRatings: '/account/ratings',
    accountStartCardLink: '/account/initiate-card-link',
    accountSignIn: '/account/sign-in',
    accountSignInComplete: '/account/sign-in/complete',
    accountSignout: '/account/sign-out',
    appAuthenticate: '/account/app-authenticate',
    ozone: {
        signIn: '/account/ozone/sign-in',
        authenticate: '/account/signInOzone',
        accountSignoutComplete: '/account/sign-out/complete',
        external: '/account/ozone/external'
    },
    accountVerifyLinkedCards: '/account/verify-linked-card',
    accountLinkLibraryCardComplete: '/account/link-library-card/complete',
    patronEmail: '/patron/email',
    patronLendingPeriod: '/patron/media/lendingPeriods/:mediaId',
    rtlModalSuccess: '/rtl/modal-success/:id',
    goBack: '/goback',
    dlrRoom: '/dlr-room',
    dlrAuthenticate: '/BANGAuthenticate.dll',
    dlrMediaId: '/ContentDetails.htm',
    seriesbyTitle: '/series-by-title/:mediaId',
    updateHoldSettings: '/media/holds/settings',
    getBranches: '/branches',
    preferences: '/preferences',
    lendingSettings: '/lending-settings',
    reviews: '/media/reviews/:mediaId',
    relatedCarousel: '/media/relatedTitlesCarousel/:id',
    accountHistory: '/account/history',
    rest: {
        account: {
            get: '/rest/account/',
            limits: '/rest/account/limits',
            authLocal: '/rest/account/authenticate/local'
        },
        collections: {
            getById: '/rest/collections/:id'
        },
        media: {
            index: '/rest/media',
            related: '/rest/media/:id/relatedTitles',
            recommended: '/rest/media/:id/recommended',
            availableRelated: '/rest/media/:id/availableRelatedTitles'
        },
        subjects: {
            getGroupedByParent: '/rest/subjects/byparent',
            getCountByMediaType: '/rest/subjects/countby/mediatype'
        },
        search: {
            rtlPreview: '/rest/search/rtlPreview'
        },
        readingHistory: {
            index: '/rest/readingHistory',
            title: '/rest/readingHistory/title/:id',
            settings: '/rest/readingHistory/settings'
        },
        recommended: {
            index: '/rest/recommended',
            updateRtlAutoCheckout: '/rest/recommended/updateRtlAutoCheckout'
        },
        rooms: {
            get: '/rest/rooms/:roomId'
        },
        campaigns: {
            get: '/rest/campaigns/:campaignId'
        },
        preferences: {
            global: {
                index: '/rest/preferences/global/'
            }
        },
        idc: {
            phone: {
                sendCode: '/rest/idc/phone/send-code',
                verifyCode: '/rest/idc/phone/verify-code'
            },
            email: {
                sendCode: '/rest/idc/email/send-code',
                verifyCode: '/rest/idc/email/verify-code'
            },
            signUp: '/rest/idc/sign-up'
        }
    },
    // FYI: assets served at /assets should be considered immutable because
    // they are cached by browsers and intermediate load balancers. If you need
    // to change the asset, increment the version parameter to bust the cache
    assets: {
        css: {
            versionedColors: '/assets/v2/css/:version/colors.css',
            colors: '/assets/v1/css/colors.css'
        }
    },
    fulfillmentError: '/fulfillmentError',
    libbyIntercept: '/libbyPromo'
};

module.exports = {
    routes: Object.freeze(routes)
};

},{}]},{},["C:\\projects\\lightning\\public\\js\\app\\actions.js","C:\\projects\\lightning\\public\\js\\app\\title-actions.js","C:\\projects\\lightning\\public\\js\\app.js","C:\\projects\\lightning\\public\\js\\placeholder.js","C:\\projects\\lightning\\public\\js\\app\\modal.js","C:\\projects\\lightning\\public\\js\\app\\nav.js","C:\\projects\\lightning\\public\\js\\app\\sample.js","C:\\projects\\lightning\\public\\ecmascript\\pages\\all.js"])

